/* eslint-disable no-undef, no-unreachable, react/no-unescaped-entities */
                              import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
                              import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
                              import { Button } from './ui/button';
                              import { Input } from './ui/input';
                              import { Label } from './ui/label';
                              import { Textarea } from './ui/textarea';
                              import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
                              import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription, DialogFooter } from './ui/dialog';
import { ScrollArea } from './ui/scroll-area';
import { confirmDialog } from './ui/confirm-dialog';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from './ui/table';
import html2pdf from 'html2pdf.js';
import { Calendar as CalendarComponent } from './ui/calendar';
                              import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
                              import { 
                                ArrowRightLeft,
                                ArrowUpDown,
                                Archive,
                                Droplet,
                                Wrench,
                                Truck,
                                Package,
                                Home,
                                Building2,
                                Building,
                                Cog,
                                ChevronDown,
                                ChevronRight,
                                ChevronLeft,
                                BarChart3,
                                CalendarCheck,
                                Users, 
                                FileText, 
                                Calendar, 
                                Clock,
                                LogOut, 
                                Plus, 
                                Edit, 
                                Trash,
                                Trash2,
                                UserCheck,
                                Download,
                                Printer,
                                Filter,
                                CalendarIcon,
                                FileDown,
                                Settings,
                                Save,
                                Search,
                                CheckCircle,
                                Upload,
                                DollarSign,
                                HelpCircle,
                                Car,
                                Smartphone,
                                Menu,
                                Lock,
                                Check,
                                Pencil,
                                FileSpreadsheet,
                                Moon,
                                Sun
                              } from 'lucide-react';
                              import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from './ui/tooltip';
import { ClipboardList, Box, Loader2 } from 'lucide-react';
                              import { computePresentBreakdown } from '../utils/attendanceCalc';
import { aggregateFirstLastMinutes } from '../utils/payrollAttendanceAggregation';
                              import { 
                                computeDailyRateFromBasis, 
                                calculateSSSDeduction, 
                                calculateTaxDeduction, 
                                calculateAttendanceDeductions, 
                                isEndDateInFirstHalf, 
                                isEndDateInSSSWindow,
                                computeDateRangeMonthCount,
                                normalizeDateRangeOrder,
                                isInactivePayslipExceptionEmail,
                                zeroAttendanceDeductionFields
                              } from '../utils/payrollUtils';
import {
  buildEmployeeIdCandidates,
  computeMonthWindowFromEndISO,
  computePrevGrossAndGovFromMonthlyPayrollRecords,
  createMonthlyGrossDebugger,
  fetchPayrollRecordsByEmployeeIdCandidates,
  normalizeEmployeeIdForQuery
} from './payroll/utils/monthlyGross';
                              import { toast } from 'sonner';
                              import PhotoModal from './PhotoModal';
                              import CalendarViewModal from './CalendarViewModal';
                              import jsPDF from 'jspdf';
                              import autoTable from 'jspdf-autotable';
                              import html2canvas from 'html2canvas';
                              import { format, parseISO, startOfWeek, endOfWeek, startOfMonth, endOfMonth, isWeekend as dfIsWeekend } from 'date-fns';
                              import { countBusinessDays } from '../utils/dateUtils';
                              import { computeAttendanceStatus, computeDailyAttendanceSummary } from '../utils/attendanceRules';
                              import { validateDateRangeTaipei, normalizeToISODateTaipei, toTaipeiMDYDate } from '../utils/dateParse';
import { hasPositiveDayCredit, resolveSaturdayCredit } from '../utils/payrollSaturdayStatus';
import { getApplicableLoansForRecord, getLoanDeductionAmountForRecord } from '../utils/payrollLoanSchedule';
                              import { validateReportTransferInputs, mapReportRecordsToPayrollRecords } from '../utils/transferUtils';
                              import { cn } from '../lib/utils';
                              import { Switch } from './ui/switch';
import PayslipSummaryCard from './payroll/Generate/components/PayslipSummaryCard';
import MfPayslipSummaryCard from './payroll/Generate/components/MfPayslipSummaryCard';
import MarketingDashboard from './MarketingDashboard';
import MarketingAnnouncements from './MarketingAnnouncements';
import HRISDashboard from './HRIS/Dashboard';
import Candidates from './HRIS/Candidates';
import Employees201Files from './HRIS/Employees201Files';
import { SalesDepartmentToolsContent, SalesDepartmentToolsMenu, getSalesDepartmentToolsMeta, isSalesDepartmentToolsRoute } from './SalesDepartmentTools';
import IMSDashboard from './IMS/Dashboard';
import Machines from './IMS/Machines';
import Consumables from './IMS/Consumables';
import SpareParts from './IMS/SpareParts';
import MachineInField from './IMS/MachineInField';
import Records from './IMS/Records';
import AcquiredAssets from './IMS/AcquiredAssets';
import StockIn from './IMS/StockIn';
import StockOut from './IMS/StockOut';
import StockTransfer from './IMS/StockTransfer';
import Inventory from './IMS/Inventory';
import ProjectDetails from './PCC/ProjectDetails';
import ServiceLifecycleDashboard from './ServiceLifecycleManagement/Dashboard';
import ServiceLifecycleFSR from './ServiceLifecycleManagement/FSR';
import ServiceLifecycleQuotationRequest from './ServiceLifecycleManagement/QuotationRequest';
import ProjectComputation from './PCC/ProjectComputation';
                              import { formatTaipeiDate as formatTaipeiDateHelper, formatTaipeiDateTime as formatTaipeiDateTimeHelper, toTaipeiISODate as toTaipeiISODateHelper, formatTaipeiTime24, normalizeTs } from '../lib/time';
import PayrollGeneratePage from './payroll/Generate/GeneratePage';
import PayrollDashboardPage from './payroll/Dashboard/DashboardPage';
import PayrollDatabasePage from './payroll/Database/DatabasePage';
import PayrollLoansPage from './payroll/Loans/LoansPage';
import SavedPayrollPayslipView from './payroll/Shared/SavedPayrollPayslipView';
import SavedMfPayslipView from './payroll/Shared/SavedMfPayslipView';
import { NumoraSidebarSection, SalesBook, CashReceiptBook, AccountsPayableJournal, CashDisbursementBook, JournalBook } from './Numora';
const AdminDashboard = ({ user = {}, onLogout, axiosInstance }) => {
  const navigate = useNavigate();
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [pendingApprovalsCount, setPendingApprovalsCount] = useState(0);
  const [exportReadyCount, setExportReadyCount] = useState(0); // New state for Green badge

  const isDgmUser = (user?.email?.trim().toLowerCase() === 'dgm@isourceasia.com') || (user?.full_name?.toUpperCase() === 'DONALD G. MADINO');
  const isCadfUser = user?.email?.trim().toLowerCase() === 'cadf@isourceasiaworkplace.com';
  const isOamUser = user?.email?.trim().toLowerCase() === 'oam@isourceasiaworkplace.com';
  const isJcpUser = user?.email?.trim().toLowerCase() === 'jcp@isourceasia.com';
  const isMspUser = user?.email?.trim().toLowerCase() === 'msp@isourceasia.com.ph';
  const isTargetUser = isDgmUser || isCadfUser || isOamUser || isJcpUser || isMspUser;

  useEffect(() => {
    if (isTargetUser) {
      const fetchPendingApprovals = async () => {
        try {
          const response = await axiosInstance.get('/ccp/project-details');
          if (Array.isArray(response.data)) {
             // Count projects based on user role
             const count = response.data.filter(p => {
               const isPlaceholder = p.project_type === 'Account_Placeholder';
               if (isPlaceholder) return false;

               if (isDgmUser) {
                   const isApproved = p.is_approved === true || p.is_approved === 'true' || p.is_approved === 1;
                   return !isApproved;
               }
               
               if (isCadfUser) {
                   const isApproved = p.is_approved === true || p.is_approved === 'true' || p.is_approved === 1;
                   const isApprovedPricing = p.is_approved_pricing === true || p.is_approved_pricing === 'true' || p.is_approved_pricing === 1;
                   return isApproved && !isApprovedPricing;
               }

               if (isOamUser) {
                   const isApprovedPricing = p.is_approved_pricing === true || p.is_approved_pricing === 'true' || p.is_approved_pricing === 1;
                   const isApprovedCosts = p.is_approved_costs === true || p.is_approved_costs === 'true' || p.is_approved_costs === 1;
                   return isApprovedPricing && !isApprovedCosts;
               }

               if (isJcpUser) {
                   const isApprovedCosts = p.is_approved_costs === true || p.is_approved_costs === 'true' || p.is_approved_costs === 1;
                   const isApprovedJoygie = p.is_approved_joygie === true || p.is_approved_joygie === 'true' || p.is_approved_joygie === 1;
                   return isApprovedCosts && !isApprovedJoygie;
               }

               if (isMspUser) {
                   const isApprovedJoygie = p.is_approved_joygie === true || p.is_approved_joygie === 'true' || p.is_approved_joygie === 1;
                   const isApprovedOverall = p.is_approved_overall === true || p.is_approved_overall === 'true' || p.is_approved_overall === 1;
                   return isApprovedJoygie && !isApprovedOverall;
               }

               return false;
             }).length;
             setPendingApprovalsCount(count);

             // Calculate Export Ready Count for OAM
             if (isOamUser) {
                 const exportCount = response.data.filter(p => {
                     const isPlaceholder = p.project_type === 'Account_Placeholder';
                     if (isPlaceholder) return false;
                     
                     const isApprovedOverall = p.is_approved_overall === true || p.is_approved_overall === 'true' || p.is_approved_overall === 1;
                     const isExported = p.is_exported_by_oam === true || p.is_exported_by_oam === 'true' || p.is_exported_by_oam === 1;
                     
                     return isApprovedOverall && !isExported;
                 }).length;
                 setExportReadyCount(exportCount);
             } else {
                 setExportReadyCount(0);
             }
          }
        } catch (error) {
          console.error('Error fetching pending approvals:', error);
        }
      };

      fetchPendingApprovals();
      // Poll every 30 seconds to keep it updated
      const interval = setInterval(fetchPendingApprovals, 30000);

      // Listen for project updates to refresh immediately
      const handleProjectUpdate = () => {
        fetchPendingApprovals();
      };
      window.addEventListener('projectUpdated', handleProjectUpdate);

      return () => {
        clearInterval(interval);
        window.removeEventListener('projectUpdated', handleProjectUpdate);
      };
    }
  }, [user, axiosInstance, isTargetUser]);

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDarkMode]);

                                const [employees, setEmployees] = useState([]);
                                const [admins, setAdmins] = useState([]);
                                const [attendance, setAttendance] = useState([]);
                                const [filteredAttendance, setFilteredAttendance] = useState([]);
                                const [employeeSearchTerm, setEmployeeSearchTerm] = useState('');
                                const [schedules, setSchedules] = useState([]);
                                const [activeReportTab, setActiveReportTab] = useState('daily');
                                const [isTabLoading, setIsTabLoading] = useState(false);
                                const [isLoadingMoreAttendance, setIsLoadingMoreAttendance] = useState(false);

                                const handleReportTabChange = async (value) => {
                                  if (value === activeReportTab) return;
                                  setIsTabLoading(true);
                                  setActiveReportTab(value);
                                  
                                  if (value === 'employee' && !isAllAttendanceLoaded) {
                                    await fetchAttendance(true);
                                  }
                                  
                                  setTimeout(() => setIsTabLoading(false), 400);
                                };

  // Inventory Management System State
  const [inventoryItems, setInventoryItems] = useState([
    { id: 1, name: 'Drill Press', type: 'Machine', quantity: 5, status: 'Active' },
    { id: 2, name: 'CNC Lathe', type: 'Machine', quantity: 2, status: 'Active' },
    { id: 3, name: 'Milling Machine', type: 'Machine', quantity: 3, status: 'Maintenance' },
    { id: 4, name: 'Screw M4x10', type: 'Parts', quantity: 1000, status: 'In Stock' },
    { id: 5, name: 'Bolt M6x20', type: 'Parts', quantity: 500, status: 'In Stock' },
    { id: 6, name: 'Bearing 6204', type: 'Parts', quantity: 50, status: 'Low Stock' },
    { id: 7, name: 'Coolant', type: 'Consumable', quantity: 20, status: 'In Stock' },
    { id: 8, name: 'Lubricant Oil', type: 'Consumable', quantity: 15, status: 'In Stock' },
    { id: 9, name: 'Sandpaper', type: 'Consumable', quantity: 100, status: 'In Stock' },
    { id: 10, name: 'Safety Gloves', type: 'Others', quantity: 50, status: 'In Stock' },
    { id: 11, name: 'Safety Goggles', type: 'Others', quantity: 30, status: 'In Stock' },
    { id: 12, name: 'Excavator Model X', type: 'MIF', quantity: 1, status: 'Deployed' },
    { id: 13, name: 'Generator Set A', type: 'MIF', quantity: 1, status: 'Deployed' },
    { id: 14, name: 'Welding Machine Portable', type: 'MIF', quantity: 2, status: 'Deployed' },
  ]);
  const [inventoryFilterType, setInventoryFilterType] = useState('All');
  const [inventorySearchTerm, setInventorySearchTerm] = useState('');
  const [isAddInventoryDialogOpen, setIsAddInventoryDialogOpen] = useState(false);
  
  // Attendance Records State
  const [isAllAttendanceLoaded, setIsAllAttendanceLoaded] = useState(false);

  // Blue Print Export Filtering State
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [exportFilters, setExportFilters] = useState(['']);
  const [isMachineSelectionModalOpen, setIsMachineSelectionModalOpen] = useState(false);
  const [currentFilterIndex, setCurrentFilterIndex] = useState(null);
  const [newInventoryItem, setNewInventoryItem] = useState({
    name: '',
    type: 'Machine',
    quantity: 0,
    status: 'In Stock'
  });
  
  // CSV Import Ref
  const csvInputRef = useRef(null);
  
  // Spare Parts State
  const [spareParts, setSpareParts] = useState([]);
  const [newSparePart, setNewSparePart] = useState({
    description: '',
    partNumber: '',
    brand: '',
    machineModel: '',
    quantity: 0,
    status: 'In Stock'
  });

  // Map Accounts State
  const [mapAccounts, setMapAccounts] = useState([]);
  const [showMapAccountModal, setShowMapAccountModal] = useState(false);
  const [mapAccountData, setMapAccountData] = useState({
    account_name: '',
    end_user: '',
    address: '',
    province_area: '',
    industry: '',
    present_setup: '',
    decision_maker: '',
    position: '',
    tel_no: '',
    mobile_no: '',
    email_address: '',
    current_products: '',
    price_offered: '',
    justification: '',
    stage_of_sale: '',
    account_status: '',
    result_of_call: '',
    product_final_offering: '',
    quantity: '',
    unit_cost: '',
    total_cost: '',
    target_delivery_date: ''
  });
  
  // Edit State
  const [editingAccountId, setEditingAccountId] = useState(null);
  const [editFormData, setEditFormData] = useState({});

  // MAP Search State
  const [mapSearchTerm, setMapSearchTerm] = useState('');
  const [mapMonthFilter, setMapMonthFilter] = useState('All');
  const [mapStatusFilter, setMapStatusFilter] = useState('All');

  // Sales Performance Report State
  const [salesAccounts, setSalesAccounts] = useState([]);
  const [bluePrints, setBluePrints] = useState([]);
  const [selectedBluePrintAccount, setSelectedBluePrintAccount] = useState(null);
  const [bluePrintRows, setBluePrintRows] = useState([]);
  const [bluePrintSortMode, setBluePrintSortMode] = useState(0);

  const sortBluePrintRows = (rows, mode) => {
    const sortedRows = [...rows];
    
    // Helper to parse "dd-MMM-yyyy"
    const parseDate = (dateStr) => {
      if (!dateStr) return new Date(0);
      const parts = dateStr.split('-');
      if (parts.length === 3) {
        const day = parseInt(parts[0], 10);
        const monthStr = parts[1];
        const year = parseInt(parts[2], 10);
        
        const monthMap = {
          'Jan': 0, 'Feb': 1, 'Mar': 2, 'Apr': 3, 'May': 4, 'Jun': 5,
          'Jul': 6, 'Aug': 7, 'Sep': 8, 'Oct': 9, 'Nov': 10, 'Dec': 11
        };
        
        const month = monthMap[monthStr];
        if (month !== undefined && !isNaN(day) && !isNaN(year)) {
          return new Date(year, month, day);
        }
      }
      return new Date(0);
    };

    switch (mode) {
      case 0: // Recent Date (Descending)
        sortedRows.sort((a, b) => parseDate(b.target_delivery_date) - parseDate(a.target_delivery_date));
        break;
      case 1: // Account Name (A-Z)
        sortedRows.sort((a, b) => (a.account_name || '').localeCompare(b.account_name || ''));
        break;
      case 2: // Machine (A-Z)
        sortedRows.sort((a, b) => (a.machines || '').localeCompare(b.machines || ''));
        break;
      case 3: // Quantity (Descending)
        sortedRows.sort((a, b) => (parseFloat(b.quantity) || 0) - (parseFloat(a.quantity) || 0));
        break;
      case 4: // Total Amount (Descending)
        sortedRows.sort((a, b) => (parseFloat(b.total_amount) || 0) - (parseFloat(a.total_amount) || 0));
        break;
      default:
        break;
    }
    return sortedRows;
  };

  // Fetch Blue Prints
  const fetchBluePrints = async () => {
    try {
      const response = await axiosInstance.get('/blue-prints');
      setBluePrints(response.data);
    } catch (error) {
      console.error('Error fetching blue prints:', error);
      // toast.error('Failed to fetch blue prints'); // Optional: suppress error on initial load if not critical
    }
  };
  const [showAddSalesDropdown, setShowAddSalesDropdown] = useState(false);
  const [selectedSalesAccount, setSelectedSalesAccount] = useState(null);
  const [isSetTargetDialogOpen, setIsSetTargetDialogOpen] = useState(false);
  const [targetAccount, setTargetAccount] = useState(null);
  const [targetAmount, setTargetAmount] = useState('');

  // HRIS Side Menu State
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [activeMenuItem, setActiveMenuItem] = useState('org-chart');
  const numoraMenuItems = new Set([
    'numora-sales-book',
    'numora-cash-receipt-book',
    'numora-accounts-payable-journal',
    'numora-cash-disbursement-book',
    'numora-journal-book',
  ]);
  const canAccessNumora = user?.permissions?.numora_access === true;
  
  // Auto-hide Sidebar Logic
  const hoverTimeoutRef = useRef(null);

  useEffect(() => {
    if (activeMenuItem !== 'org-chart') {
      setIsSidebarOpen(false);
    } else {
      setIsSidebarOpen(true);
    }
  }, [activeMenuItem]);

  useEffect(() => {
    if (!canAccessNumora && numoraMenuItems.has(activeMenuItem)) {
      setActiveMenuItem('org-chart');
    }
  }, [activeMenuItem, canAccessNumora]);

  const handleSidebarMouseEnter = () => {
    if (activeMenuItem === 'org-chart') return;
    if (isSidebarOpen) return;
    
    hoverTimeoutRef.current = setTimeout(() => {
      setIsSidebarOpen(true);
    }, 2000);
  };

  const handleSidebarMouseLeave = () => {
    if (activeMenuItem === 'org-chart') return;
    
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current = null;
    }
    
    setIsSidebarOpen(false);
  };

  const handleTransactionChange = (index, field, value) => {
    if (index === null || index === undefined || index < 0) return;
    const transactions = selectedSalesAccount?.transactions || [];
    if (index >= transactions.length) return;

    const updatedTransactions = [...transactions];
    updatedTransactions[index] = { ...updatedTransactions[index], [field]: value };
    
    // Auto-calculate Total Amount = Quantity * Amount
    if (field === 'quantity' || field === 'amount') {
        const qty = parseFloat(updatedTransactions[index].quantity) || 0;
        const amt = parseFloat(updatedTransactions[index].amount) || 0;
        updatedTransactions[index].total_amount = qty * amt;
    }
    
    // Auto-calculate Net Sales (Actual Sales) = Total Amount - Marketing Funds
    const totalAmount = parseFloat(updatedTransactions[index].total_amount) || 0;
    const marketingFunds = parseFloat(updatedTransactions[index].marketing_funds) || 0;
    updatedTransactions[index].net_sales = totalAmount - marketingFunds;

    // Auto-calculate Total = Amount Collected + 1% WHT + 5% WHT + Retention + Others
    const amountCollected = parseFloat(updatedTransactions[index].amount_collected) || 0;
    const wht1 = parseFloat(updatedTransactions[index].wht_1_percent) || 0;
    const wht5 = parseFloat(updatedTransactions[index].wht_5_percent) || 0;
    const retention = parseFloat(updatedTransactions[index].retention) || 0;
    const others = parseFloat(updatedTransactions[index].others) || 0;
    updatedTransactions[index].total = amountCollected + wht1 + wht5 + retention + others;

    const updatedAccount = { ...selectedSalesAccount, transactions: updatedTransactions };
    setSelectedSalesAccount(updatedAccount);
  };

  const [isSaveConfirmationOpen, setIsSaveConfirmationOpen] = useState(false);

  const saveTransaction = async () => {
    try {
        await axiosInstance.put(`/sales-accounts/${selectedSalesAccount.admin_id}`, {
            transactions: selectedSalesAccount.transactions
        });
        // toast.success('Saved'); // Optional: too many toasts might be annoying on blur
    } catch (error) {
        console.error('Error saving transaction:', error);
        toast.error('Failed to save changes');
    }
  };

  const handleManualSave = async () => {
    await saveTransaction();
    toast.success('Saved successfully');
  };

  const handleAddTransaction = () => {
      const newTransaction = {
          id: crypto.randomUUID(),
          sales_invoice_date: '',
          sales_invoice_number: '',
          account_name: '',
          item_description: '',
          quantity: 0,
          amount: 0,
          total_amount: 0,
          marketing_funds: 0,
          net_sales: 0,
          collection_receipt_date: '',
          collection_receipt_no: '',
          amount_collected: 0,
          wht_1_percent: 0,
          wht_5_percent: 0,
          retention: 0,
          others: 0,
          total: 0,
          remarks: ''
      };
      const updatedTransactions = [...(selectedSalesAccount?.transactions || []), newTransaction];
      const updatedAccount = { ...selectedSalesAccount, transactions: updatedTransactions };
      setSelectedSalesAccount(updatedAccount);
      
      // Save immediately to persist the new row
      axiosInstance.put(`/sales-accounts/${selectedSalesAccount.admin_id}`, {
            transactions: updatedTransactions
      }).catch(err => toast.error('Failed to add row'));
  };

  const handleDeleteTransaction = async (index) => {
      const confirmed = await confirmDialog({
          title: "Delete Row",
          description: "Are you sure you want to delete this row?",
          variant: "destructive"
      });
      if (!confirmed) return;
      
      const updatedTransactions = (selectedSalesAccount?.transactions || []).filter((_, i) => i !== index);
      const updatedAccount = { ...selectedSalesAccount, transactions: updatedTransactions };
      setSelectedSalesAccount(updatedAccount);
      
      axiosInstance.put(`/sales-accounts/${selectedSalesAccount.admin_id}`, {
            transactions: updatedTransactions
      }).catch(err => toast.error('Failed to delete row'));
  };

  const handleSaveBluePrint = async () => {
      if (!selectedBluePrintAccount) return;
      try {
          const sanitizedRows = bluePrintRows.map(row => ({
            ...row,
            quantity: row.quantity === '' ? 0 : Number(row.quantity),
            amount_per_qty: row.amount_per_qty === '' ? 0 : Number(row.amount_per_qty),
            total_amount: row.total_amount === '' ? 0 : Number(row.total_amount),
          }));
          const updatedBluePrint = { ...selectedBluePrintAccount, items: sanitizedRows };
          const response = await axiosInstance.put(`/blue-prints/${selectedBluePrintAccount.id}`, updatedBluePrint);
          
          // Update with response data to ensure we have any backend-generated fields (like IDs)
          const savedBluePrint = response.data;
          setBluePrintRows(savedBluePrint.items || []);
          setSelectedBluePrintAccount(savedBluePrint);
          setBluePrints(prev => prev.map(bp => bp.id === selectedBluePrintAccount.id ? savedBluePrint : bp));
          
          toast.success('Saved successfully');
      } catch (error) {
          console.error('Error saving blueprint:', error);
          toast.error('Failed to save');
      }
  };

  const handleDeleteBluePrintRow = async (index) => {
      const confirmed = await confirmDialog({
          title: "Delete Row",
          description: "Are you sure you want to delete this row?",
          variant: "destructive"
      });
      if (!confirmed) return;
      
      // We should sanitize even on delete to ensure valid data structure
      const newRows = bluePrintRows.filter((_, i) => i !== index).map(row => ({
            ...row,
            quantity: row.quantity === '' ? 0 : Number(row.quantity),
            amount_per_qty: row.amount_per_qty === '' ? 0 : Number(row.amount_per_qty),
            total_amount: row.total_amount === '' ? 0 : Number(row.total_amount),
      }));
      
      setBluePrintRows(newRows);
      
      if (!selectedBluePrintAccount) return;
      try {
          const updatedBluePrint = { ...selectedBluePrintAccount, items: newRows };
          const response = await axiosInstance.put(`/blue-prints/${selectedBluePrintAccount.id}`, updatedBluePrint);
          
          const savedBluePrint = response.data;
          setBluePrintRows(savedBluePrint.items || []);
          setSelectedBluePrintAccount(savedBluePrint);
          setBluePrints(prev => prev.map(bp => bp.id === selectedBluePrintAccount.id ? savedBluePrint : bp));
          
          toast.success('Deleted successfully');
      } catch (error) {
          console.error('Error deleting blueprint row:', error);
          toast.error('Failed to delete');
      }
  };

  const handleDeleteBluePrint = async (id, e) => {
      e.stopPropagation();
      const confirmed = await confirmDialog({
          title: "Delete Blueprint",
          description: "Are you sure you want to delete this blueprint?",
          variant: "destructive"
      });
      if (!confirmed) return;
      
      try {
          await axiosInstance.delete(`/blue-prints/${id}`);
          setBluePrints(prev => prev.filter(bp => bp.id !== id));
          toast.success('Blueprint deleted successfully');
      } catch (error) {
          console.error('Error deleting blueprint:', error);
          toast.error('Failed to delete blueprint');
      }
  };

                                const [isHRISOpen, setIsHRISOpen] = useState(false);
                                const [isHumanResourcesInfoSystemOpen, setIsHumanResourcesInfoSystemOpen] = useState(false);
                                const [isInventoryManagementSystemOpen, setIsInventoryManagementSystemOpen] = useState(false);
                                const themeColors = {
                                  attendance: { bg: 'bg-blue-50 dark:bg-slate-900', border: 'border-blue-200 dark:border-slate-800', text: 'text-blue-700 dark:text-white', hover: 'hover:bg-blue-50 dark:hover:bg-black' },
                                  hrisv2: { bg: 'bg-indigo-50 dark:bg-slate-900', border: 'border-indigo-200 dark:border-slate-800', text: 'text-indigo-700 dark:text-white', hover: 'hover:bg-indigo-50 dark:hover:bg-black' },
                                  payroll: { bg: 'bg-emerald-50 dark:bg-slate-900', border: 'border-emerald-200 dark:border-slate-800', text: 'text-emerald-700 dark:text-white', hover: 'hover:bg-emerald-50 dark:hover:bg-black' },
                                  ccp: { bg: 'bg-pink-50 dark:bg-slate-900', border: 'border-pink-200 dark:border-slate-800', text: 'text-pink-700 dark:text-white', hover: 'hover:bg-pink-50 dark:hover:bg-black' },
                                  mps: { bg: 'bg-violet-50 dark:bg-slate-900', border: 'border-violet-200 dark:border-slate-800', text: 'text-violet-700 dark:text-white', hover: 'hover:bg-violet-50 dark:hover:bg-black' },
                                  ims: { bg: 'bg-amber-50 dark:bg-slate-900', border: 'border-amber-200 dark:border-slate-800', text: 'text-amber-700 dark:text-white', hover: 'hover:bg-amber-50 dark:hover:bg-black' },
                                };
                                const [contentTheme, setContentTheme] = useState(themeColors.attendance);
                                const computeThemeKey = (menu) => {
                                  if (!menu) return 'attendance';
                                  
                                  if (menu.startsWith('payroll-')) return 'payroll';
                                  if (menu.startsWith('ccp-')) return 'ccp';
                                  if (menu.startsWith('management-print-system')) return 'mps';
                                  return 'attendance';
                                };
                                useEffect(() => {
                                  const key = computeThemeKey(activeMenuItem);
                                  setContentTheme(themeColors[key]);
                                }, [activeMenuItem]);

                                // Inventory Filter Synchronization
                                useEffect(() => {
                                  if (activeMenuItem === 'inventory-machines') setInventoryFilterType('Machine');
                                  else if (activeMenuItem === 'inventory-parts') setInventoryFilterType('Parts');
                                  else if (activeMenuItem === 'inventory-consumables') setInventoryFilterType('Consumable');
                                  else if (activeMenuItem === 'inventory-others') setInventoryFilterType('Others');
                                  else if (activeMenuItem === 'inventory-mif') setInventoryFilterType('MIF');
                                  else if (activeMenuItem === 'inventory-management-system') setInventoryFilterType('All');
                                }, [activeMenuItem]);
                                useEffect(() => {
                                  try { runDailyRateSelfTests(); } catch { /* noop */ }
                                  fetchSalesAccounts();
                                  fetchMapAccounts();
                                  fetchFocusProducts();
                                  fetchBluePrints();
                                }, []);

                                // Fetch Sales Accounts
                                const fetchSalesAccounts = async () => {
                                  try {
                                    const response = await axiosInstance.get('/sales-accounts');
                                    // Map backend response to match expected format (if needed, but structure is similar)
                                    // Backend: { id, admin_id, admin_name, ... }
                                    // Frontend expects: { id, full_name, ... } for rendering, but we can adapt rendering.
                                    // Let's adapt rendering to use admin_name if full_name is missing, or map it here.
                                    const mapped = response.data.map(acc => ({
                                      ...acc,
                                      full_name: acc.admin_name, // Map for compatibility with existing render logic
                                      id: acc.admin_id // Use admin_id as the key identifier for consistency with add logic
                                    }));
                                    setSalesAccounts(mapped);
                                  } catch (error) {
                                    console.error('Error fetching sales accounts:', error);
                                  }
                                };

                                // Fetch Focus Products
                                const fetchFocusProducts = async () => {
                                  try {
                                    const response = await axiosInstance.get('/focus-products');
                                    setFocusProducts(response.data);
                                  } catch (error) {
                                    console.error('Error fetching focus products:', error);
                                    toast.error('Failed to load focus products');
                                  }
                                };

                                // Fetch Spare Parts
                                const fetchSpareParts = async () => {
                                  try {
                                    const response = await axiosInstance.get('/inventory/spare-parts');
                                    setSpareParts(response.data);
                                  } catch (error) {
                                    console.error('Error fetching spare parts:', error);
                                    toast.error('Failed to load spare parts');
                                  }
                                };

                                // Handle Create Spare Part
                                const handleCreateSparePart = async (e) => {
                                  e.preventDefault();
                                  try {
                                    const response = await axiosInstance.post('/inventory/spare-parts', newSparePart);
                                    setSpareParts([...spareParts, response.data]);
                                    setNewSparePart({
                                      description: '',
                                      partNumber: '',
                                      brand: '',
                                      machineModel: '',
                                      quantity: 0,
                                      status: 'In Stock'
                                    });
                                    setIsAddInventoryDialogOpen(false);
                                    toast.success('Spare part added successfully');
                                  } catch (error) {
                                    console.error('Error creating spare part:', error);
                                    toast.error(error.response?.data?.detail || 'Failed to add spare part');
                                  }
                                };
                                const parseToDateTaipeiAware = (dateLike) => {
                                  if (!dateLike) return new Date();
                                  if (typeof dateLike === 'string') {
                                    return new Date(normalizeTs(dateLike));
                                  }
                                  return new Date(dateLike);
                                };
                                const formatTaipeiDate = (dateLike) => formatTaipeiDateHelper(dateLike);
                                const formatTaipeiDateTime = (dateLike) => formatTaipeiDateTimeHelper(dateLike);
                                const toTaipeiISODate = (dateLike) => toTaipeiISODateHelper(dateLike);
                                // Timezone-safe day-of-week for a Taipei calendar date.
                                // Date.prototype.getDay() reads the runtime timezone, so Dates built
                                // with a '+08:00' offset return the wrong weekday for admins outside
                                // Asia/Taipei. Derive the weekday from the Taipei ISO date instead.
                                const taipeiDayOfWeek = (dateLike) => {
                                  const iso = toTaipeiISODate(dateLike);
                                  const parts = String(iso || '').slice(0, 10).split('-');
                                  const y = Number(parts[0]); const mo = Number(parts[1]); const d = Number(parts[2]);
                                  if (!y || !mo || !d) { try { return new Date(dateLike).getDay(); } catch { return 0; } }
                                  return new Date(Date.UTC(y, mo - 1, d)).getUTCDay();
                                };
                                const getTaipeiTodayISO = () => {
                                  const parts = new Intl.DateTimeFormat('en-CA', {
                                    timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit'
                                  }).formatToParts(new Date());
                                  const y = parts.find(p => p.type === 'year').value;
                                  const m = parts.find(p => p.type === 'month').value;
                                  const d = parts.find(p => p.type === 'day').value;
                                  return `${y}-${m}-${d}`;
                                };
                                const formatHM12 = (hm) => {
                                  if (!hm || typeof hm !== 'string' || !hm.includes(':')) return hm || 'N/A';
                                  const m = hm.trim().match(/^(\d{1,2}):(\d{2})(?:\s*(AM|PM))?$/i);
                                  if (!m) return hm;
                                  let h = Number(m[1]);
                                  const mm = m[2];
                                  let ap = m[3];
                                  if (!ap) {
                                    ap = h >= 12 ? 'PM' : 'AM';
                                    h = ((h % 12) === 0) ? 12 : (h % 12);
                                  } else {
                                    ap = ap.toUpperCase();
                                    h = ((h % 12) === 0) ? 12 : (h % 12);
                                  }
                                  return `${String(h).padStart(2, '0')}:${mm} ${ap}`;
                                };
                                
                                // Payroll Side Menu State
                                const [isPayrollOpen, setIsPayrollOpen] = useState(false);
                                const [isNumoraOpen, setIsNumoraOpen] = useState(false);
                                
                                // New Tabs Side Menu States
                                const [isCCPOpen, setIsCCPOpen] = useState(false);
  const [isServiceLifecycleManagementOpen, setIsServiceLifecycleManagementOpen] = useState(false);
                                const [isManagementPrintSystemOpen, setIsManagementPrintSystemOpen] = useState(false);
                                const [billingHeaderTag, setBillingHeaderTag] = useState('');
  const [isMarketingSystemOpen, setIsMarketingSystemOpen] = useState(false);
const [isProjectDetailsOpen, setIsProjectDetailsOpen] = useState(false);

                                // Pricing Template States Removed
                                const [hoveredTile, setHoveredTile] = useState(null);
                                const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
                                
                                // Focus Products State
                                const [focusProducts, setFocusProducts] = useState([]);
                                // Machine Selection Modal State
                                const [showMachineModal, setShowMachineModal] = useState(false);
                                const [currentMachineRowIndex, setCurrentMachineRowIndex] = useState(null);
                                const [machineSearchQuery, setMachineSearchQuery] = useState('');
                                const [isManualInputMode, setIsManualInputMode] = useState(false);
                                const [manualMachineName, setManualMachineName] = useState('');

                                const [isAddProductModalOpen, setIsAddProductModalOpen] = useState(false);
                                const [newFocusProduct, setNewFocusProduct] = useState({
                                    brand: '',
                                    model: '',
                                    category: ''
                                });
                                const [editingProduct, setEditingProduct] = useState(null);
                                const [isEditProductModalOpen, setIsEditProductModalOpen] = useState(false);
                                const [focusProductFilter, setFocusProductFilter] = useState('');
  const [isProductSelectionModalOpen, setIsProductSelectionModalOpen] = useState(false);
  const [editingTransactionIndex, setEditingTransactionIndex] = useState(null);
  const [focusProductSelectionFilter, setFocusProductSelectionFilter] = useState('');
  const [manualInputIndices, setManualInputIndices] = useState(new Set());
  
  const uniqueCategories = [...new Set(focusProducts.map(p => p.category).filter(Boolean))];

  // Project Monitoring System states
                                const [projects, setProjects] = useState([]);
                                const [isCreateProjectModalOpen, setIsCreateProjectModalOpen] = useState(false);
                                const [isEditProjectModalOpen, setIsEditProjectModalOpen] = useState(false);
                                const [editingProject, setEditingProject] = useState(null);
                                const [newProject, setNewProject] = useState({
                                  title: '',
                                  accountName: '',
                                  companyAddress: '',
                                  billingStatementCode: '',
                                  contactPersons: [''],
                                  contactDetails: [''],
                                  emailAddresses: [''],
                                  status: 'Pending',
                                  startDate: '',
                                  endDate: ''
                                });
                                const [mpsTab, setMpsTab] = useState('dashboard'); // 'dashboard' or 'mps'
                                const [selectedProject, setSelectedProject] = useState(null); // For project details view
                                const [projectDetailTab, setProjectDetailTab] = useState('overview'); // 'overview', 'meter', 'billing', 'si', 'collection', 'settings'
                                const [projectTasks, setProjectTasks] = useState([]); // Tasks for selected project
                                const [newTask, setNewTask] = useState({
                                  task_name: '',
                                  assigned_resources: '',
                                  start_date: '',
                                  end_date: ''
                                });
                                const [isAddingTask, setIsAddingTask] = useState(false);
                                const [taskAttendedDates, setTaskAttendedDates] = useState({}); // Track attended dates for each task {taskId: [dates]}
                                const [selectedTaskForCalendar, setSelectedTaskForCalendar] = useState(null); // Task selected to view/edit calendar
                                
                                // Meter Reading System states
                                const [departments, setDepartments] = useState([]);
                                const [isCreateDepartmentModalOpen, setIsCreateDepartmentModalOpen] = useState(false);
                                const [isCreateMachineModalOpen, setIsCreateMachineModalOpen] = useState(false);
                                const [isMeterReadingModalOpen, setIsMeterReadingModalOpen] = useState(false);
                                const [isMHRModalOpen, setIsMHRModalOpen] = useState(false);
                                const [isRRModalOpen, setIsRRModalOpen] = useState(false);
                                const [isEditReadingModalOpen, setIsEditReadingModalOpen] = useState(false);
                                const [isBatchReadingModalOpen, setIsBatchReadingModalOpen] = useState(false);
                                const [selectedBatchReadings, setSelectedBatchReadings] = useState([]);
                                const [isBatchEditMode, setIsBatchEditMode] = useState(false);
                                const [editableBatchReadings, setEditableBatchReadings] = useState({});
                                const [selectedDepartmentForMachine, setSelectedDepartmentForMachine] = useState(null);
                                const [selectedMachine, setSelectedMachine] = useState(null);
                                const [selectedMachineForMHR, setSelectedMachineForMHR] = useState(null);
                                const [selectedMachineForRR, setSelectedMachineForRR] = useState(null);
                                const [newDepartment, setNewDepartment] = useState({
                                  name: '',
                                  contact_person: '',
                                  birthday: '',
                                  contact_number: '',
                                  email: ''
                                });
                                const [newMachine, setNewMachine] = useState({
                                  model: '',
                                  serialNumber: '',
                                  dateInstalled: ''
                                });
                                const [meterReading, setMeterReading] = useState({
                                  'Mono Small': {
                                    previousReading: 0,
                                    previousDate: '',
                                    presentReading: '',
                                    presentDate: '',
                                    spoilageTolerance: 0,
                                    rate: 0
                                  },
                                  'Mono Large': {
                                    previousReading: 0,
                                    previousDate: '',
                                    presentReading: '',
                                    presentDate: '',
                                    spoilageTolerance: 0,
                                    rate: 0
                                  },
                                  'Colored Small': {
                                    previousReading: 0,
                                    previousDate: '',
                                    presentReading: '',
                                    presentDate: '',
                                    spoilageTolerance: 0,
                                    rate: 0
                                  },
                                  'Colored Large': {
                                    previousReading: 0,
                                    previousDate: '',
                                    presentReading: '',
                                    presentDate: '',
                                    spoilageTolerance: 0,
                                    rate: 0
                                  }
                                });
                                
                                // Dashboard Stats from Backend (accurate data)
                                const [dashboardStats, setDashboardStats] = useState(null);

                                // Initial Reading Modal States
                                const [isInitialReadingModalOpen, setIsInitialReadingModalOpen] = useState(false);
                                const [initialReading, setInitialReading] = useState({
                                  'Mono Small': { value: 0, date: '' },
                                  'Mono Large': { value: 0, date: '' },
                                  'Colored Small': { value: 0, date: '' },
                                  'Colored Large': { value: 0, date: '' }
                                });
                                
                                const [machineRepair, setMachineRepair] = useState({
                                  diagnosedDamage: '',
                                  diagnosedDate: '',
                                  damagedParts: [''],
                                  damagedPartsDate: '',
                                  partsRequested: [''],
                                  partsRequestedDate: '',
                                  partsReceivedDate: '',
                                  repairCompletedDate: ''
                                });
                                const [editingRepair, setEditingRepair] = useState(null);
                                const [editingReading, setEditingReading] = useState(null);
                                const [editingDepartment, setEditingDepartment] = useState(null);
                                const [editingMachine, setEditingMachine] = useState(null);
                                const [isEditDepartmentModalOpen, setIsEditDepartmentModalOpen] = useState(false);
                                const [isEditMachineModalOpen, setIsEditMachineModalOpen] = useState(false);
                                
                                // Billing states
                                const [billingName, setBillingName] = useState('');
                                const [billingDateFilter, setBillingDateFilter] = useState({ startDate: '', endDate: '' });
                                const [selectedMachineForBilling, setSelectedMachineForBilling] = useState(null);
                                const [allReadingsForBilling, setAllReadingsForBilling] = useState([]);
                                const [isBillingModalOpen, setIsBillingModalOpen] = useState(false);
                                const [isBillingPreviewOpen, setIsBillingPreviewOpen] = useState(false);
                                const [billingCounter, setBillingCounter] = useState(1);
                                const [isExportDisabled, setIsExportDisabled] = useState(false);
                                const [billingAttention, setBillingAttention] = useState('');
                                const [billingNote, setBillingNote] = useState('');
                                const [billingExports, setBillingExports] = useState([]);
                                
                                // Billing history pagination and filtering
                                const [billingHistoryPage, setBillingHistoryPage] = useState(1);
                                const [billingHistoryFilter, setBillingHistoryFilter] = useState({ 
                                  startDate: '', 
                                  endDate: '',
                                  departmentName: '',
                                  machineModel: '',
                                  searchQuery: ''
                                });
                                const [selectedHistoryExport, setSelectedHistoryExport] = useState(null);
                                const [isHistoryPreviewOpen, setIsHistoryPreviewOpen] = useState(false);
                                const [selectedMeterReadings, setSelectedMeterReadings] = useState([]);
                                const [isBillingStatementPreviewOpen, setIsBillingStatementPreviewOpen] = useState(false);
                                const [billingStatementData, setBillingStatementData] = useState(null);
                                const ITEMS_PER_PAGE = 50;
                                
                                // SI (Sales Invoice) states
                                const [siHistoryPage, setSiHistoryPage] = useState(1);
                                const [siHistoryFilter, setSiHistoryFilter] = useState({
                                  startDate: '',
                                  endDate: '',
                                  searchQuery: ''
                                });
                                const [siExports, setSiExports] = useState([]);
                                
                                // Consolidated SI Modal states
                                const [isConsolidatedSIModalOpen, setIsConsolidatedSIModalOpen] = useState(false);
                                const [pendingSIMachines, setPendingSIMachines] = useState([]);
                                const [isGeneratingAllSI, setIsGeneratingAllSI] = useState(false);
                                
                                // Filter Export Modal states
                                const [isFilterExportModalOpen, setIsFilterExportModalOpen] = useState(false);
                                const [filterParams, setFilterParams] = useState({
                                  department: '',
                                  machine: '',
                                  serial: '',
                                  date: '',
                                  ticketNumber: ''
                                });
                                const [filteredData, setFilteredData] = useState([]);
                                const [acknowledgedMachines, setAcknowledgedMachines] = useState(new Set()); // Track clicked/acknowledged machines
                                const [acknowledgedBillingMachines, setAcknowledgedBillingMachines] = useState(new Set()); // Track clicked billing machines
                                const [acknowledgedSIMachines, setAcknowledgedSIMachines] = useState(new Set()); // Track clicked SI machines
                                const [isSIPreviewOpen, setIsSIPreviewOpen] = useState(false);
                                const [selectedSIData, setSelectedSIData] = useState(null);
                                const [isSIFilePreviewOpen, setIsSIFilePreviewOpen] = useState(false);
                                const [selectedSIFileData, setSelectedSIFileData] = useState(null);
                                const [isBillingRecordsModalOpen, setIsBillingRecordsModalOpen] = useState(false);
                                const [selectedMachineForBillingRecords, setSelectedMachineForBillingRecords] = useState(null);
                                const [billingRecordsData, setBillingRecordsData] = useState([]);
                                const [isBillingHistoryModalOpen, setIsBillingHistoryModalOpen] = useState(false);
                                const [selectedMachineForBillingHistory, setSelectedMachineForBillingHistory] = useState(null);
                                const [billingHistoryData, setBillingHistoryData] = useState([]);
                                
                                // Collection states
                                const [collectionHistoryPage, setCollectionHistoryPage] = useState(1);
                                const [collectionHistoryFilter, setCollectionHistoryFilter] = useState({
                                  startDate: '',
                                  endDate: '',
                                  searchQuery: ''
                                });
                                const [acknowledgedCollectionMachines, setAcknowledgedCollectionMachines] = useState(new Set());
                                const [isCollectionModalOpen, setIsCollectionModalOpen] = useState(false);
                                const [selectedCollectionMachine, setSelectedCollectionMachine] = useState(null);
                                const [collections, setCollections] = useState([]);
                                const [isCollectionHistoryPreviewOpen, setIsCollectionHistoryPreviewOpen] = useState(false);
                                const [selectedCollectionRecord, setSelectedCollectionRecord] = useState(null);
                                const [isEditingCollectionStatus, setIsEditingCollectionStatus] = useState(false);
                                const [editedCollectionStatus, setEditedCollectionStatus] = useState('');
                                
                                // Project Overview Stats Modals
                                const [isDepartmentsModalOpen, setIsDepartmentsModalOpen] = useState(false);
                                const [isMachinesModalOpen, setIsMachinesModalOpen] = useState(false);
                                const [isEarningsModalOpen, setIsEarningsModalOpen] = useState(false);
                                
                                // Attendance Modal states
                                const [isAttendanceModalOpen, setIsAttendanceModalOpen] = useState(false);
                                const [attendanceModalType, setAttendanceModalType] = useState('');
                                const [attendanceModalEmployees, setAttendanceModalEmployees] = useState([]);
                                
                                // Attendance Snapshot states
                                const [attendanceSnapshots, setAttendanceSnapshots] = useState([]);
                                const [snapshotCurrentPage, setSnapshotCurrentPage] = useState(1);
                                const [snapshotDateFilter, setSnapshotDateFilter] = useState('');
                                const [isSnapshotLoading, setIsSnapshotLoading] = useState(false);
                                const [snapshotAttemptedDate, setSnapshotAttemptedDate] = useState('');
                                const [selectedSnapshot, setSelectedSnapshot] = useState(null);
                                const [isEmployeeListModalOpen, setIsEmployeeListModalOpen] = useState(false);
                                const [employeeListType, setEmployeeListType] = useState('');
                                const [employeeList, setEmployeeList] = useState([]);
                                
                                // Dashboard Tile Click Modal states
                                const [isDashboardTileModalOpen, setIsDashboardTileModalOpen] = useState(false);
                                const [dashboardModalType, setDashboardModalType] = useState('');
                                const [dashboardModalEmployees, setDashboardModalEmployees] = useState([]);

                                
                                const [stats, setStats] = useState({});
                                const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
                                const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
                                const [isEditAdminDialogOpen, setIsEditAdminDialogOpen] = useState(false);
                                const [isCreateAdminDialogOpen, setIsCreateAdminDialogOpen] = useState(false);
                                const [selectedEmployee, setSelectedEmployee] = useState(null);
                                const [selectedAdmin, setSelectedAdmin] = useState(null);
                                const [newPassword, setNewPassword] = useState('');
                                const [confirmPassword, setConfirmPassword] = useState('');
                                const [newEmployee, setNewEmployee] = useState({
                                  email: '',
                                  password: '',
                                  full_name: '',
                                  employee_id: '',
                                  branch: '',
                                  position: '',
                                  department: '',
                                  tin_number: '',
                                  sss_number: '',
                                  phic_number: '',
                                  hdmf_number: ''
                                });
                                const [newAdmin, setNewAdmin] = useState({
                                  email: '',
                                  password: '',
                                  full_name: ''
                                });

                                // Reports filters and pagination state
                                const [reportFilters, setReportFilters] = useState({
                                  startDate: '',
                                  endDate: '',
                                  startTime: '',
                                  endTime: '',
                                  employeeId: 'all',
                                  attendanceType: 'all',
                                  branch: 'all',
                                  status: 'all'
                                });

                                // Employee Report Filters (Separate from Daily Report)
                                const [employeeReportFilters, setEmployeeReportFilters] = useState({
                                  startDate: '',
                                  endDate: '',
                                  employeeId: 'all'
                                });
                                const [filteredEmployeeAttendance, setFilteredEmployeeAttendance] = useState([]);
                                
                                // CSV Import state
                                const [isImportCSVModalOpen, setIsImportCSVModalOpen] = useState(false);
                                const [csvFile, setCsvFile] = useState(null);
                                const [csvImportProgress, setCsvImportProgress] = useState('');
                                

                                // Pagination state
                                const [currentPage, setCurrentPage] = useState(1);
                                const [itemsPerPage, setItemsPerPage] = useState(20);
                                const [employeeCurrentPage, setEmployeeCurrentPage] = useState(1);
                                const [employeeItemsPerPage, setEmployeeItemsPerPage] = useState(20);
                                const [isExporting, setIsExporting] = useState(false);

                                // Dialog states for attendance editing
                                const [isEditAttendanceDialogOpen, setIsEditAttendanceDialogOpen] = useState(false);
                                const [selectedAttendance, setSelectedAttendance] = useState(null);

                                // Branch Schedule states
                                const [branchSchedules, setBranchSchedules] = useState([]);
                                const [isCreateBranchScheduleDialogOpen, setIsCreateBranchScheduleDialogOpen] = useState(false);
                                const [isEditBranchScheduleDialogOpen, setIsEditBranchScheduleDialogOpen] = useState(false);
                                const [selectedBranchSchedule, setSelectedBranchSchedule] = useState(null);
                                const [isEnrollScheduleDialogOpen, setIsEnrollScheduleDialogOpen] = useState(false);
                                const [selectedEnrollSchedule, setSelectedEnrollSchedule] = useState(null);
                                const [enrollEmployeeQuery, setEnrollEmployeeQuery] = useState('');
                                const [selectedEnrollEmployeeIds, setSelectedEnrollEmployeeIds] = useState([]);
                                const [isEnrollingEmployees, setIsEnrollingEmployees] = useState(false);
                                const [newBranchSchedule, setNewBranchSchedule] = useState({
                                  branch_name: '',
                                  start_time: '09:00',
                                  end_time: '17:00'
                                });
                                const [isPhotoModalOpen, setIsPhotoModalOpen] = useState(false);
                                const [selectedPhotoRecord, setSelectedPhotoRecord] = useState(null);
                                
                                // State for comment details modal
                                const [selectedCommentRecord, setSelectedCommentRecord] = useState(null);
                                const [isCommentModalOpen, setIsCommentModalOpen] = useState(false);
                                const [dataTransferLogs, setDataTransferLogs] = useState([]);

                                // Export functions
                                const exportToCSV = () => {
                                  if (filteredAttendance.length === 0) {
                                    toast.error('No data to export');
                                    return;
                                  }

                                    const headers = [
                                      'Date', 'Time', 'Employee', 'Branch', 'Type', 'Status', 'Location', 'Comments'
                                    ];

                                    const csvData = filteredAttendance.map(record => [
                                      formatDateFromBackend(record.timestamp),
                                      formatTimeHHMMFromBackend(record.timestamp),
                                      record.user_name,
                                      getBranchForAttendanceRecord(record),
                                      record.type.replace('_', ' ').toUpperCase(),
                                      record.status?.toUpperCase() || 'N/A',
                                      record.location ? `${record.location.address || 'Unknown Address'}` : 'No Location',
                                      record.comment || 'No Comments'
                                    ]);

                                  const csvContent = [headers, ...csvData]
                                    .map(row => row.map(cell => `"${cell}"`).join(','))
                                    .join('\n');

                                  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                                  const link = document.createElement('a');
                                  const url = URL.createObjectURL(blob);
                                  link.setAttribute('href', url);
                                  link.setAttribute('download', `attendance_report_${new Date().toISOString().split('T')[0]}.csv`);
                                  link.style.visibility = 'hidden';
                                  document.body.appendChild(link);
                                  link.click();
                                  document.body.removeChild(link);
                                  toast.success('CSV exported successfully');
                                };

                                const [isExportingAllAttendance, setIsExportingAllAttendance] = useState(false);
                                const exportAllAttendanceToCSV = async () => {
                                  if (isExportingAllAttendance) return;
                                  setIsExportingAllAttendance(true);
                                  const loadingToast = toast.loading('Fetching all attendance records for export...');
                                  try {
                                    let allRecords = attendance;
                                    if (!isAllAttendanceLoaded || allRecords.length === 0) {
                                      const response = await axiosInstance.get('/attendance?include_photos=false');
                                      allRecords = Array.isArray(response.data) ? response.data : [];
                                      setAttendance(allRecords);
                                      setIsAllAttendanceLoaded(true);
                                    }

                                    if (allRecords.length === 0) {
                                      toast.dismiss(loadingToast);
                                      toast.error('No attendance records to export');
                                      return;
                                    }

                                    const headers = [
                                      'Date', 'Time', 'Employee', 'Branch', 'Type', 'Status', 'Location', 'Comments'
                                    ];

                                    const csvData = allRecords.map(record => [
                                      formatDateFromBackend(record.timestamp),
                                      formatTimeHHMMFromBackend(record.timestamp),
                                      record.user_name || 'Unknown',
                                      getBranchForAttendanceRecord(record),
                                      (record.type || 'unknown').replace('_', ' ').toUpperCase(),
                                      record.status?.toUpperCase() || 'N/A',
                                      record.location ? `${record.location.address || 'Unknown Address'}` : 'No Location',
                                      record.comment || 'No Comments'
                                    ]);

                                    const csvContent = [headers, ...csvData]
                                      .map(row => row.map(cell => `"${String(cell ?? '').replace(/"/g, '""')}"`).join(','))
                                      .join('\n');

                                    const BOM = '\uFEFF';
                                    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
                                    const link = document.createElement('a');
                                    const url = URL.createObjectURL(blob);
                                    link.setAttribute('href', url);
                                    const timestamp = new Date().toISOString().replace(/[:.]/g, '-').split('T')[0];
                                    link.setAttribute('download', `all_attendance_records_${timestamp}.csv`);
                                    link.style.visibility = 'hidden';
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);
                                    URL.revokeObjectURL(url);
                                    toast.dismiss(loadingToast);
                                    toast.success(`Exported ${allRecords.length} attendance records successfully`);
                                  } catch (error) {
                                    console.error('Error exporting all attendance:', error);
                                    toast.dismiss(loadingToast);
                                    toast.error(error.response?.data?.detail || 'Failed to export attendance records');
                                  } finally {
                                    setIsExportingAllAttendance(false);
                                  }
                                };

                                const exportToPDF = async () => {
                                  if (filteredAttendance.length === 0) {
                                    toast.error('No data to export');
                                    return;
                                  }

                                  setIsExporting(true);
                                  try {
                                    const pdf = new jsPDF('landscape', 'mm', 'a4'); // landscape orientation
                                    
                                    // Title
                                    pdf.setFontSize(18);
                                    pdf.text('Attendance Report', 20, 20);
                                    
                                    // Date range
                                    pdf.setFontSize(12);
                                    let dateRangeText = 'Date Range: ';
                                    if (reportFilters.startDate && reportFilters.endDate) {
                                      dateRangeText += `${format(new Date(reportFilters.startDate), 'MMM dd, yyyy')} - ${format(new Date(reportFilters.endDate), 'MMM dd, yyyy')}`;
                                    } else {
                                      dateRangeText += 'All dates';
                                    }
                                    pdf.text(dateRangeText, 20, 30);
                                    
                                    // Table headers
                                    const headers = ['Date', 'Time', 'Employee', 'Type', 'Status', 'Location', 'Comments'];
                                    let yPosition = 45;
                                    
                                    // Header row
                                    pdf.setFontSize(10);
                                    pdf.setFont(undefined, 'bold');
                                    let xPosition = 20;
                                    const colWidths = [25, 20, 40, 20, 25, 50, 80];
                                    
                                    headers.forEach((header, index) => {
                                      pdf.text(header, xPosition, yPosition);
                                      xPosition += colWidths[index];
                                    });
                                    
                                    // Data rows
                                    pdf.setFont(undefined, 'normal');
                                    yPosition += 10;
                                    
                                    filteredAttendance.forEach((record, index) => {
                                      if (yPosition > 180) { // New page if needed
                                        pdf.addPage();
                                        yPosition = 20;
                                      }
                                      
                                      xPosition = 20;
                                      const rowData = [
                                        formatDateFromBackend(record.timestamp),
                                        formatTimeHHMMFromBackend(record.timestamp),
                                        record.user_name.substring(0, 15), // Truncate long names
                                        record.type.replace('_', ' ').toUpperCase(),
                                        record.status?.toUpperCase() || 'N/A',
                                        record.location?.address?.substring(0, 20) || 'No Location',
                                        record.comment?.substring(0, 30) || 'No Comments'
                                      ];
                                      
                                      rowData.forEach((cell, cellIndex) => {
                                        pdf.text(cell.toString(), xPosition, yPosition);
                                        xPosition += colWidths[cellIndex];
                                      });
                                      
                                      yPosition += 8;
                                    });
                                    
                                    pdf.save(`attendance_report_${new Date().toISOString().split('T')[0]}.pdf`);
                                    toast.success('PDF exported successfully');
                                  } catch (error) {
                                    console.error('PDF export error:', error);
                                    toast.error('Failed to export PDF');
                                  } finally {
                                    setIsExporting(false);
                                  }
                                };

                                const printReport = () => {
                                  if (filteredAttendance.length === 0) {
                                    toast.error('No data to print');
                                    return;
                                  }

                                  const printWindow = window.open('', '_blank');
                                  printWindow.document.write(`
                                    <html>
                                      <head>
                                        <title>Attendance Report</title>
                                        <style>
                                          body { font-family: Arial, sans-serif; margin: 20px; }
                                          h1 { color: #333; }
                                          table { width: 100%; border-collapse: collapse; margin-top: 20px; }
                                          th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
                                          th { background-color: #f2f2f2; font-weight: bold; }
                                          tr:nth-child(even) { background-color: #f9f9f9; }
                                          .status { padding: 2px 6px; border-radius: 3px; font-size: 12px; }
                                          .status-late { background-color: #fed7d7; color: #c53030; }
                                          .status-on-time { background-color: #c6f6d5; color: #276749; }
                                          .status-undertime { background-color: #fef5e7; color: #744210; }
                                          @media print { 
                                            body { margin: 0; } 
                                            .no-print { display: none; }
                                          }
                                        </style>
                                      </head>
                                      <body>
                                        <h1>iSource Suites - Attendance Report</h1>
                                        <p><strong>Generated:</strong> ${new Date().toLocaleDateString()}</p>
                                        ${reportFilters.startDate && reportFilters.endDate ? 
                                          `<p><strong>Date Range:</strong> ${format(new Date(reportFilters.startDate), 'MMM dd, yyyy')} - ${format(new Date(reportFilters.endDate), 'MMM dd, yyyy')}</p>` : 
                                          '<p><strong>Date Range:</strong> All dates</p>'
                                        }
                                        <p><strong>Total Records:</strong> ${filteredAttendance.length}</p>
                                        
                                        <table>
                                          <thead>
                                            <tr>
                                              <th>Date</th>
                                              <th>Time</th>
                                              <th>Employee</th>
                                              <th>Branch</th>
                                              <th>Type</th>
                                              <th>Status</th>
                                              <th>Location</th>
                                              <th>Comments</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            ${filteredAttendance.map(record => {
                                              const emp = employees.find(e => e.id === record.user_id);
                                              const branch = emp && emp.branch ? emp.branch : 'N/A';
                                              return `
                                              <tr>
                                                <td>${formatDateFromBackend(record.timestamp)}</td>
                                                <td>${formatTimeHHMMFromBackend(record.timestamp)}</td>
                                                <td>${record.user_name}</td>
                                                <td>${branch}</td>
                                                <td>${record.type.replace('_', ' ').toUpperCase()}</td>
                                                <td>
                                                  <span class="status status-${record.status || 'default'}">
                                                    ${record.status?.toUpperCase() || 'N/A'}
                                                  </span>
                                                </td>
                                                <td>${record.location?.address || 'No Location'}</td>
                                                <td>${record.comment || 'No Comments'}</td>
                                              </tr>
                                              `;
                                            }).join('')}
                                          </tbody>
                                        </table>
                                      </body>
                                    </html>
                                  `);
                                  printWindow.document.close();
                                  printWindow.print();
                                };
                                
                                // Payroll States
                                const [payrollEmployees, setPayrollEmployees] = useState([]);
                                const [payrollStats, setPayrollStats] = useState({
                                  total_payroll_employees: 0,
                                  active_employees: 0,
                                  minimum_wage_employees: 0,
                                  above_minimum_wage_employees: 0,
                                  total_monthly_payroll: 0,
                                  average_salary: 0
                                });
                                const [searchEmployeeQuery, setSearchEmployeeQuery] = useState('');
                                const [selectedHRISEmployee, setSelectedHRISEmployee] = useState(null);
                                const [showTaxInfoModal, setShowTaxInfoModal] = useState(false);
                                const [showPhilHealthInfoModal, setShowPhilHealthInfoModal] = useState(false);
                                const [showHDMFInfoModal, setShowHDMFInfoModal] = useState(false);
                                const [showSSSInfoModal, setShowSSSInfoModal] = useState(false);
                                const [editingPayrollEmployee, setEditingPayrollEmployee] = useState(null);
                                const [isEditPayrollDialogOpen, setIsEditPayrollDialogOpen] = useState(false);
                                const [payrollData, setPayrollData] = useState({
                                  employee_id: '',
                                  salary: '',
                                  is_minimum_wage: false,
                                  tax_enabled: true, // Tax is enabled by default
                                  leave_credits: '',
                                  tin_number: '',
                                  sss_number: '',
                                  phic_number: '',
                                  hdmf_number: '',
                                  allowances: {
                                    mf: '',
                                    gas_allowance: '',
                                    load_allowance: '',
                                    housing_allowance: ''
                                  },
                                  deductions: {
                                    sss: false,
                                    phic: false,
                                    hdmf: false,
                                    hdmf_additional: ''
                                  }
                                });
                                const [payrollAttendanceFilters, setPayrollAttendanceFilters] = useState({
                                  name: '',
                                  start_date: '',
                                  end_date: '',
                                  type: 'all',
                                  branch: 'all'
                                });
                                
                                const [payrollAttendanceData, setPayrollAttendanceData] = useState([]);
                                const [rawPayrollAttendanceData, setRawPayrollAttendanceData] = useState([]);
                                const [payrollAttendanceAnalytics, setPayrollAttendanceAnalytics] = useState({
                                  total_employees: 0,
                                  days_present: 0,
                                  days_absent: 0,
                                  half_days_present: 0,
                                  total_minutes_late: 0,
                                  total_minutes_undertime: 0,
                                  working_days: 0,
                                  total_gross_pay: 0,
                                  daily_rate: 0,
                                  holidays_count: 0
                                });
                                const [isLoadingPayrollAttendance, setIsLoadingPayrollAttendance] = useState(false);
                                const [isClearingPayrollAttendance, setIsClearingPayrollAttendance] = useState(false);
                                const [mfAttendanceFilters, setMfAttendanceFilters] = useState({
                                  name: '',
                                  start_date: '',
                                  end_date: '',
                                  type: 'all',
                                  branch: 'all'
                                });
                                
                                const [mfAttendanceData, setMfAttendanceData] = useState([]);
                                const [rawMfAttendanceData, setRawMfAttendanceData] = useState([]);
                                const [mfAttendanceAnalytics, setMfAttendanceAnalytics] = useState({
                                  total_employees: 0,
                                  days_present: 0,
                                  days_absent: 0,
                                  half_days_present: 0,
                                  total_minutes_late: 0,
                                  total_minutes_undertime: 0,
                                  working_days: 0,
                                  total_gross_pay: 0,
                                  daily_rate: 0,
                                  holidays_count: 0
                                });
                                const [isLoadingMfAttendance, setIsLoadingMfAttendance] = useState(false);
                                const [isClearingMfAttendance, setIsClearingMfAttendance] = useState(false);

                                const [holidays, setHolidays] = useState([]);
                                const [generatedPayslips, setGeneratedPayslips] = useState({ payroll: [], mf: [] });
                                const [selectedGeneratedPayslipEmployeeId, setSelectedGeneratedPayslipEmployeeId] = useState(null);
                                const [selectedGeneratedPayslipEmployeeName, setSelectedGeneratedPayslipEmployeeName] = useState('');
                                const [selectedGeneratedPayslipRow, setSelectedGeneratedPayslipRow] = useState(null);
                                const [isGeneratedPayslipSummaryOpen, setIsGeneratedPayslipSummaryOpen] = useState(false);
                                const [isSavingGeneratedSummaryPayslip, setIsSavingGeneratedSummaryPayslip] = useState(false);
                                const [isSavingPayrollBatch, setIsSavingPayrollBatch] = useState(false);

                                
                                const [monthlyPayrollSummary, setMonthlyPayrollSummary] = useState({ gross: 0, government_deductions: 0 });
                                const safeSetMonthlySummary = (nextGross, nextGov) => {
                                  setMonthlyPayrollSummary({
                                    gross: (typeof nextGross === 'number' && nextGross >= 0) ? nextGross : 0,
                                    government_deductions: (typeof nextGov === 'number' && nextGov >= 0) ? nextGov : 0
                                  });
                                };
                                const [runningTotalPayroll, setRunningTotalPayroll] = useState(0);
                                const [runningTotalPayrollDashboard, setRunningTotalPayrollDashboard] = useState(0);
                                const [thisMonthPayroll, setThisMonthPayroll] = useState(0);
                                const [isPayslipModalOpen, setIsPayslipModalOpen] = useState(false);
                                const [isEditingPayslipRecord, setIsEditingPayslipRecord] = useState(false);
                                const [editingPayslipRecordMeta, setEditingPayslipRecordMeta] = useState(null);
                                const [dailyRateFormula, setDailyRateFormula] = useState(null); // '313' or '261'
                                const [calculatedDailyRate, setCalculatedDailyRate] = useState(0);
                                const [isLogoTransitionVisible, setIsLogoTransitionVisible] = useState(false);
                                const [logoFadeVisible, setLogoFadeVisible] = useState(false);
                                const [isContentEntering, setIsContentEntering] = useState(false);
                                const [logoScaleUp, setLogoScaleUp] = useState(false);
                                const [contentHiddenDuringTransition, setContentHiddenDuringTransition] = useState(false);

                                const handleSelectTool = (key) => {
                                  setContentHiddenDuringTransition(true);
                                  setIsLogoTransitionVisible(true);
                                  setLogoFadeVisible(true);
                                  setLogoScaleUp(false);
                                  setTimeout(() => setLogoScaleUp(true), 10);
                                  setTimeout(() => {
                                    setActiveMenuItem(key);
                                    setIsLogoTransitionVisible(false);
                                    setLogoFadeVisible(false);
                                    setLogoScaleUp(false);
                                    setContentHiddenDuringTransition(false);
                                  }, 1000);
                                };

                                useEffect(() => {
                                  setIsContentEntering(true);
                                  const t = setTimeout(() => setIsContentEntering(false), 500);
                                  return () => clearTimeout(t);
                                }, [activeMenuItem]);
                                
                                // New Employee Modal state
                                const [isNewEmployeeModalOpen, setIsNewEmployeeModalOpen] = useState(false);
                                
                                // Employee Running Status states
                                const [employeeStatusFilters, setEmployeeStatusFilters] = useState({
                                  employee_query: ''
                                });
                                const [selectedStatusEmployee, setSelectedStatusEmployee] = useState(null);
                                const [employeeRunningStats, setEmployeeRunningStats] = useState({
                                  present_days: 0,
                                  absent_days: 0,
                                  total_lates: 0,
                                  total_undertime: 0,
                                  total_deductions: 0,
                                  net_salary: 0
                                });

                                // Payslip Modal states
                                const [selectedPayslipEmployee, setSelectedPayslipEmployee] = useState(null);
                                const [payrollEmployeeData, setPayrollEmployeeData] = useState(null);
                                const [payslipDeductions, setPayslipDeductions] = useState({
                                  sss: true,
                                  phic: true,
                                  hdmf: true,
                                  tax: true
                                });
                                const [loanDeductionSelections, setLoanDeductionSelections] = useState({});
                                const [mfLoanDeductionSelections, setMfLoanDeductionSelections] = useState({});
                                const [calculatedPayslip, setCalculatedPayslip] = useState({
                                  basicSalary: 0,
                                  dailyRate: 0,
                                  hourlyRate: 0,
                                  allowances: {
                                    mf: 0,
                                    gas_allowance: 0,
                                    load_allowance: 0,
                                    housing_allowance: 0
                                  },
                                  deductions: {
                                    sss: 0,
                                    phic: 0,
                                    hdmf: 0,
                                    tax: 0,
                                    late: 0,
                                    undertime: 0
                                  },
                                  grossPay: 0,
                                  totalDeductions: 0,
                                  netPay: 0,
                                  monthlyGross: 0,
                                  monthlySssPreview: 0
                                });
                                
                                // Monthly Gross Modal states
                                const [isMonthlyGrossModalOpen, setIsMonthlyGrossModalOpen] = useState(false);
                                const [monthlyGrossDetails, setMonthlyGrossDetails] = useState({
                                  prevGross: 0,
                                  currentGross: 0,
                                  additionalIncome: 0,
                                  totalGross: 0,
                                  records: []
                                });
                                const [isMonthlyGovModalOpen, setIsMonthlyGovModalOpen] = useState(false);
                                const [monthlyGovDetails, setMonthlyGovDetails] = useState({
                                  prev: { sss: 0, phic: 0, hdmf: 0, total: 0, records: [] },
                                  current: { sss: 0, phic: 0, hdmf: 0, total: 0 },
                                  total: 0
                                });
                                const computeMonthlyGovShown = () => {
                                  const prev = parseFloat(monthlyGovDetails?.prev?.total) || 0;
                                  const sssRaw = (calculatedPayslip?.monthlySssPreview ?? calculatedPayslip?.deductions?.sss) || 0;
                                  const sss = payslipDeductions?.sss ? (parseFloat(sssRaw) || 0) : 0;
                                  const phic = payslipDeductions?.phic ? (parseFloat(calculatedPayslip?.deductions?.phic) || 0) : 0;
                                  const hdmf = payslipDeductions?.hdmf ? (parseFloat(calculatedPayslip?.deductions?.hdmf) || 0) : 0;
                                  const current = Math.max(0, sss + phic + hdmf);
                                  const total = Math.max(0, prev + current);
                                  return { prev, sss, phic, hdmf, current, total };
                                };

                                // MF Payslip independent states
                                const [mfSelectedPayslipEmployee, setMfSelectedPayslipEmployee] = useState(null);
                                const [calculatedMfPayslip, setCalculatedMfPayslip] = useState({
                                  basicSalary: 0,
                                  dailyRate: 0,
                                  hourlyRate: 0,
                                  allowances: {
                                    mf: 0
                                  },
                                  deductions: {
                                    sss: 0,
                                    phic: 0,
                                    hdmf: 0,
                                    tax: 0,
                                    late: 0,
                                    undertime: 0
                                  },
                                  grossPay: 0,
                                  totalDeductions: 0,
                                  netPay: 0
                                });
                                
                                // New payslip states for additional income and deductions
                                const [payrollPeriod, setPayrollPeriod] = useState('');
                                const [additionalIncome, setAdditionalIncome] = useState([]);
  const [overtimePay, setOvertimePay] = useState([]);
  const [otHours, setOtHours] = useState(0);
  const [holidayHours, setHolidayHours] = useState(0);
                                const [additionalDeductions, setAdditionalDeductions] = useState([]);

                                // Payroll Attendance Detail Modal states
                                const [isPayrollDetailModalOpen, setIsPayrollDetailModalOpen] = useState(false);
                                const [payrollDetailType, setPayrollDetailType] = useState('present');
                                const [payrollDetailItems, setPayrollDetailItems] = useState([]);
                                const [detailTableTab, setDetailTableTab] = useState('payroll');
                                
                                const [isCalendarViewOpen, setIsCalendarViewOpen] = useState(false);
                                const [calendarViewMonth, setCalendarViewMonth] = useState(new Date().getMonth());
                                const [calendarViewYear, setCalendarViewYear] = useState(new Date().getFullYear());
                                const [generateTableTab, setGenerateTableTab] = useState('payroll');

                                const openPayrollDetailModal = async (type) => {
                                  try {
                                    setPayrollDetailType(type);
                                    // Sync detail tab with main generate tab
                                    setDetailTableTab(generateTableTab === 'mf' ? 'mf' : 'payroll');
                                    const data = generateTableTab === 'mf' ? mfAttendanceData : payrollAttendanceData;
                                    if (type === 'all') {
                                      setPayrollDetailItems([]);
                                      if (!data || data.length === 0) {
                                        console.warn('[Detailed Attendance] No attendance data found for current filters');
                                        toast.error('No attendance data found for the selected range.');
                                      } else {
                                        console.log('[Detailed Attendance] Opening grouped date view with', data.length, 'records');
                                      }
                                    } else {
                                      if (!Array.isArray(data) || data.length === 0) {
                                        toast.error('No attendance data loaded. Apply filters first.');
                                        return;
                                      }
                                      const items = computePayrollDetailItems(type);
                                      setPayrollDetailItems(items);
                                      console.log(`[Payroll Detail] Built ${items.length} item(s) for type="${type}"`);
                                    }
                                    setIsPayrollDetailModalOpen(true);
                                  } catch (err) {
                                    console.error('[Payroll Detail] Failed to open modal:', err);
                                    toast.error('Failed to open details. Please try again.');
                                  }
                                };

                                // Helper function to detect if a record is a half day based on time rules
                                // Returns: { isHalfDay: boolean, reason: string }
                                const detectHalfDayStatus = (timeInTimestamp, timeOutTimestamp) => {
                                  // Helper to extract hour in Taipei timezone (UTC+8)
                                  const getHourInTaipei = (timestamp) => {
                                    if (!timestamp) return -1;
                                    try {
                                      const date = new Date(normalizeTs(timestamp));
                                      if (isNaN(date)) return -1;
                                      // Use Intl.DateTimeFormat to get hour in Taipei timezone
                                      const formatter = new Intl.DateTimeFormat('en-US', { 
                                        timeZone: 'Asia/Taipei', 
                                        hour: 'numeric', 
                                        hour12: false 
                                      });
                                      const hourStr = formatter.format(date);
                                      return parseInt(hourStr, 10);
                                    } catch (e) {
                                      return -1;
                                    }
                                  };
                                  
                                  // Rule 1: If first time_in is past 12:00 noon -> half day (PM Shift)
                                  if (timeInTimestamp) {
                                    const timeInHour = getHourInTaipei(timeInTimestamp);
                                    if (timeInHour >= 12) {
                                      return { isHalfDay: true, reason: 'Half Day (Late Time In - PM Shift Starts 1:00 PM)' };
                                    }
                                  }
                                  
                                  // Rule 2: If last time_out is around 11:00-13:00 -> half day (AM Shift)
                                  if (timeOutTimestamp) {
                                    const timeOutHour = getHourInTaipei(timeOutTimestamp);
                                    // Widen to include 11:00-11:59 departures (e.g. 11:59 is 1 min undertime relative to 12:00)
                                    if (timeOutHour >= 11 && timeOutHour < 13) {
                                      return { isHalfDay: true, reason: 'Half Day (Early Time Out - AM Shift Ends 12:00 PM)' };
                                    }
                                  }
                                  
                                  return { isHalfDay: false, reason: '' };
                                };

                                const adjustHalfDayPenalties = (record, reason) => {
                                  let late = record.late_minutes || 0;
                                  let undertime = record.undertime_minutes || 0;
                                  let status = record.status;

                                  if (!record.timestamp) return { late, undertime, status };

                                  const getHourMinInTaipei = (ts) => {
                                    const d = new Date(normalizeTs(ts));
                                    if (isNaN(d)) return { h: 0, m: 0 };
                                    const formatter = new Intl.DateTimeFormat('en-US', { timeZone: 'Asia/Taipei', hour: 'numeric', minute: 'numeric', hour12: false });
                                    const parts = formatter.formatToParts(d);
                                    const h = parseInt(parts.find(p => p.type === 'hour')?.value || '0', 10);
                                    const m = parseInt(parts.find(p => p.type === 'minute')?.value || '0', 10);
                                    return { h, m };
                                  };

                                  const time = getHourMinInTaipei(record.timestamp);

                                  if (reason && reason.includes('PM Shift')) {
                                    // PM Shift starts at 1:00 PM (13:00)
                                    if (record.type === 'time_in') {
                                      if (time.h > 13 || (time.h === 13 && time.m > 0)) {
                                        late = (time.h - 13) * 60 + time.m;
                                      } else {
                                        late = 0;
                                      }
                                      if (late > 0) status = 'late';
                                      else status = 'on_time';
                                    }
                                  } else if (reason && reason.includes('AM Shift')) {
                                    // AM Shift ends at 12:00 PM (12:00)
                                    if (record.type === 'time_out') {
                                      if (time.h < 12) {
                                        undertime = (11 - time.h) * 60 + (60 - time.m);
                                      } else {
                                        undertime = 0;
                                      }
                                      if (undertime > 0) status = 'undertime';
                                      else status = 'on_time';
                                    }
                                  }

                                  return { late, undertime, status };
                                };

                                const isWorkingDayForBasis = (dateObj, isSixDay) => {
                                  const dow = taipeiDayOfWeek(dateObj);
                                  if (dow === 0) return false;
                                  if (!isSixDay && dow === 6) return false;
                                  return true;
                                };

                                const isoDateTaipei = (dateObj) => {
                                  return new Intl.DateTimeFormat('en-CA', {
                                    timeZone: 'Asia/Taipei',
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit'
                                  }).format(dateObj);
                                };

                                const addDays = (dateObj, days) => {
                                  const d = new Date(dateObj);
                                  d.setDate(d.getDate() + days);
                                  return d;
                                };

                                const sanitizeHolidayRows = (rows) => {
                                  const normalizeHolidayDate = (raw) => {
                                    const s = String(raw || '').trim();
                                    if (!s) return '';
                                    const n = normalizeToISODateTaipei(s);
                                    if (n?.ok) return n.value;
                                    const m = /^(\d{2})-(\d{2})-(\d{4})$/.exec(s);
                                    if (m) return `${m[3]}-${m[1]}-${m[2]}`;
                                    return s;
                                  };
                                  const normalized = (Array.isArray(rows) ? rows : [])
                                    .map((h) => ({
                                      id: h?.id,
                                      name: String(h?.name || '').trim(),
                                      date: normalizeHolidayDate(h?.date)
                                    }))
                                    .filter((h) => Boolean(h.date));
                                  const seen = new Set();
                                  return normalized.filter((h) => {
                                    if (seen.has(h.date)) return false;
                                    seen.add(h.date);
                                    return true;
                                  });
                                };

                                const countWorkingDaysMinusHolidays = ({ startISO, endISO, isSixDay, holidayRows }) => {
                                  const sISO = String(startISO || '').trim();
                                  const eISO = String(endISO || '').trim();
                                  if (!sISO || !eISO) return 0;
                                  const start = new Date(sISO + 'T00:00:00+08:00');
                                  const end = new Date(eISO + 'T00:00:00+08:00');
                                  if (isNaN(start) || isNaN(end) || start > end) return 0;
                                  const hols = sanitizeHolidayRows(holidayRows);
                                  const holidaySet = new Set(hols.map((h) => String(h.date).trim()).filter(Boolean));
                                  let count = 0;
                                  let d = new Date(start);
                                  while (d <= end) {
                                    if (!isWorkingDayForBasis(d, !!isSixDay)) { d = addDays(d, 1); continue; }
                                    const iso = isoDateTaipei(d);
                                    if (holidaySet.has(iso)) { d = addDays(d, 1); continue; }
                                    count += 1;
                                    d = addDays(d, 1);
                                  }
                                  return count;
                                };

                                const applyHolidaySandwichRuleToCredits = ({ credits, startISO, endISO, isSixDay, holidayRows }) => {
                                  if (!credits || typeof credits !== 'object') return;
                                  const sISO = String(startISO || '').trim();
                                  const eISO = String(endISO || '').trim();
                                  if (!sISO || !eISO) return;
                                  const start = new Date(sISO + 'T00:00:00+08:00');
                                  const end = new Date(eISO + 'T00:00:00+08:00');
                                  if (isNaN(start) || isNaN(end) || start > end) return;
                                  const hols = sanitizeHolidayRows(holidayRows);
                                  const holidaySet = new Set(hols.map((h) => String(h.date).trim()).filter(Boolean));
                                  hols.forEach((h) => {
                                    const hd = new Date(String(h?.date || '') + 'T00:00:00+08:00');
                                    if (isNaN(hd)) return;
                                    if (hd < start || hd > end) return;
                                    if (!isWorkingDayForBasis(hd, !!isSixDay)) return;
                                    const hISO = isoDateTaipei(hd);
                                    const raw = (typeof credits?.[hISO] === 'number') ? credits[hISO] : 0;
                                    if (raw > 0) return;
                                    let prev = addDays(hd, -1);
                                    while (prev >= start) {
                                      if (!isWorkingDayForBasis(prev, !!isSixDay)) { prev = addDays(prev, -1); continue; }
                                      const prevISO = isoDateTaipei(prev);
                                      if (holidaySet.has(prevISO)) { prev = addDays(prev, -1); continue; }
                                      break;
                                    }
                                    let next = addDays(hd, 1);
                                    while (next <= end) {
                                      if (!isWorkingDayForBasis(next, !!isSixDay)) { next = addDays(next, 1); continue; }
                                      const nextISO = isoDateTaipei(next);
                                      if (holidaySet.has(nextISO)) { next = addDays(next, 1); continue; }
                                      break;
                                    }
                                    if (prev < start || next > end) { credits[hISO] = 0; return; }
                                    const prevISO = isoDateTaipei(prev);
                                    const nextISO = isoDateTaipei(next);
                                    const prevPresent = ((typeof credits?.[prevISO] === 'number' ? credits[prevISO] : 0) > 0);
                                    const nextPresent = ((typeof credits?.[nextISO] === 'number' ? credits[nextISO] : 0) > 0);
                                    credits[hISO] = (prevPresent && nextPresent) ? 1 : 0;
                                  });
                                };

                                const computeHolidayAdjustedDayCredits = ({
                                  startISO,
                                  endISO,
                                  isSixDay,
                                  employeeDates,
                                  holidayRows
                                }) => {
                                  const start = new Date(startISO + 'T00:00:00+08:00');
                                  const end = new Date(endISO + 'T00:00:00+08:00');
                                  const credits = {};

                                  let d = new Date(start);
                                  while (d <= end) {
                                    if (isWorkingDayForBasis(d, isSixDay)) {
                                      const iso = isoDateTaipei(d);
                                      const day = employeeDates?.[iso];
                                      const hasIn = !!day?.has_time_in;
                                      const hasOut = !!day?.has_time_out;
                                      const isHalf = !!day?.is_half_day;
                                      let credit = 0;
                                      if (hasIn && hasOut && !isHalf) credit = 1;
                                      else if (hasIn || hasOut || isHalf) credit = 0.5;
                                      credits[iso] = credit;
                                    }
                                    d = addDays(d, 1);
                                  }

                                  if (isSixDay) {
                                    const rawCredit = (iso) => {
                                      const day = employeeDates?.[iso];
                                      const hasIn = !!day?.has_time_in;
                                      const hasOut = !!day?.has_time_out;
                                      const isHalf = !!day?.is_half_day;
                                      if (hasIn && hasOut && !isHalf) return 1;
                                      if (hasIn || hasOut || isHalf) return 0.5;
                                      return 0;
                                    };
                                    let iter = new Date(start);
                                    while (iter <= end) {
                                      if (taipeiDayOfWeek(iter) === 6) {
                                        const satISO = isoDateTaipei(iter);
                                        if ((credits[satISO] || 0) === 0) {
                                          let prev = addDays(iter, -1);
                                          let guard = 0;
                                          while (guard < 10 && !isWorkingDayForBasis(prev, isSixDay)) { prev = addDays(prev, -1); guard++; }
                                          let next = addDays(iter, 1);
                                          guard = 0;
                                          while (guard < 10 && !isWorkingDayForBasis(next, isSixDay)) { next = addDays(next, 1); guard++; }

                                          const prevISO = isoDateTaipei(prev);
                                          const nextISO = isoDateTaipei(next);
                                          const prevVal = (credits[prevISO] !== undefined) ? credits[prevISO] : rawCredit(prevISO);
                                          const nextVal = (credits[nextISO] !== undefined) ? credits[nextISO] : rawCredit(nextISO);
                                          const prevPresent = (prevVal || 0) > 0;
                                          const nextPresent = (nextVal || 0) > 0;
                                          if (prevPresent && nextPresent) credits[satISO] = 1;
                                        }
                                      }
                                      iter = addDays(iter, 1);
                                    }
                                  }

                                  const hols = sanitizeHolidayRows(holidayRows);
                                  const holidaySet = new Set(hols.map((h) => h.date));
                                  hols.forEach((h) => {
                                    const hd = new Date(h.date + 'T00:00:00+08:00');
                                    if (isNaN(hd)) return;
                                    if (hd < start || hd > end) return;
                                    if (!isWorkingDayForBasis(hd, isSixDay)) return;
                                    const hISO = isoDateTaipei(hd);
                                    if ((credits[hISO] || 0) > 0) return;

                                    let prev = addDays(hd, -1);
                                    while (prev >= start) {
                                      if (!isWorkingDayForBasis(prev, isSixDay)) { prev = addDays(prev, -1); continue; }
                                      const prevISO = isoDateTaipei(prev);
                                      if (holidaySet.has(prevISO)) { prev = addDays(prev, -1); continue; }
                                      break;
                                    }
                                    let next = addDays(hd, 1);
                                    while (next <= end) {
                                      if (!isWorkingDayForBasis(next, isSixDay)) { next = addDays(next, 1); continue; }
                                      const nextISO = isoDateTaipei(next);
                                      if (holidaySet.has(nextISO)) { next = addDays(next, 1); continue; }
                                      break;
                                    }

                                    if (prev < start || next > end) {
                                      credits[hISO] = 0;
                                      return;
                                    }

                                    const prevISO = isoDateTaipei(prev);
                                    const nextISO = isoDateTaipei(next);
                                    const prevPresent = (credits[prevISO] || 0) > 0;
                                    const nextPresent = (credits[nextISO] || 0) > 0;
                                    credits[hISO] = (prevPresent && nextPresent) ? 1 : 0;
                                  });

                                  return credits;
                                };

                                const computeEmployeeDayCreditsWithOverrides = ({
                                  startISO,
                                  endISO,
                                  isSixDay,
                                  employeeId,
                                  employeeDates,
                                  holidayRows,
                                  saturdayOverrides
                                }) => {
                                  const credits = {};
                                  const start = new Date(startISO + 'T00:00:00+08:00');
                                  const end = new Date(endISO + 'T00:00:00+08:00');
                                  if (isNaN(start) || isNaN(end) || start > end) return credits;

                                  const hols = sanitizeHolidayRows(holidayRows);
                                  const holidaySet = new Set(
                                    hols
                                      .map((h) => String(h?.date || '').trim())
                                      .filter(Boolean)
                                  );

                                  // Build credits over an EXTENDED 3-DAY BUFFER WINDOW [start-3, end+3] so
                                  // the Saturday sandwich rule can look before/after Saturdays that lie at
                                  // the original range boundaries (start Saturday -> needs Friday before which
                                  // is at boundary; end Saturday -> needs Monday after which is past original end).
                                  // We only return and keep credits for the ORIGINAL [startISO, endISO] range.
                                  const sExt = addDays(new Date(start), -3);
                                  const eExt = addDays(new Date(end), 3);

                                  const baseRawCredit = (iso) => {
                                    const day = employeeDates?.[iso];
                                    const hasIn = !!day?.has_time_in;
                                    const hasOut = !!day?.has_time_out;
                                    // Do NOT rely on day.is_half_day  call detectHalfDayStatus()
                                    // directly. Callers (analytics functions, etc.) may build the
                                    // employeeDates map without setting the is_half_day flag, so we
                                    // MUST recompute from the first_in / last_out timestamps here.
                                    // This guarantees half-days correctly show 0.5 instead of 1.0.
                                    let isHalf = !!day?.is_half_day;
                                    if (!isHalf && (hasIn || hasOut)) {
                                      const hd = detectHalfDayStatus(day?.first_in, day?.last_out);
                                      if (hd && hd.isHalfDay) isHalf = true;
                                    }
                                    if (hasIn && hasOut && !isHalf) return 1;
                                    if (hasIn || hasOut || isHalf) return 0.5;
                                    return 0;
                                  };

                                  let d = new Date(sExt);
                                  while (d <= eExt) {
                                    if (!isWorkingDayForBasis(d, isSixDay)) { d = addDays(d, 1); continue; }
                                    const iso = isoDateTaipei(d);
                                    const raw = baseRawCredit(iso);
                                    credits[iso] = raw;
                                    d = addDays(d, 1);
                                  }

                                  // Saturday rule: for EVERY SATURDAY in the ORIGINAL range [start, end],
                                  // use the extended credit map to search 3 days before/after, which is
                                  // now fully populated because we built credits across the extended window.
                                  if (isSixDay && employeeId) {
                                    d = new Date(start);
                                    while (d <= end) {
                                      if (taipeiDayOfWeek(d) === 6) {
                                        const satISO = isoDateTaipei(d);
                                        const key = `${employeeId}_${satISO}`;
                                        const override = saturdayOverrides?.[key];
                                        // SATURDAY SANDWICH RULE with 3-DAY BUFFER WINDOW.
                                        // Search up to 3 DAYS BEFORE Saturday (offsets -1,-2,-3) for
                                        // the nearest preceding WORKING DAY with positive credit.
                                        // Search up to 3 DAYS AFTER  Saturday (offsets +1,+2,+3) for
                                        // the nearest following WORKING DAY with positive credit.
                                        // The extended credits map from sExt to eExt ensures these lookups
                                        // always have data even when the Saturday is at the range edges.
                                        let prevPresent = false;
                                        for (let off = 1; off <= 3; off++) {
                                          const dCheck = addDays(d, -off);
                                          if (dCheck < sExt) break;
                                          if (!isWorkingDayForBasis(dCheck, isSixDay)) continue;
                                          const isoCheck = isoDateTaipei(dCheck);
                                          if ((typeof credits?.[isoCheck] === 'number' ? credits[isoCheck] : 0) > 0) {
                                            prevPresent = true;
                                            break;
                                          }
                                        }
                                        let nextPresent = false;
                                        for (let off = 1; off <= 3; off++) {
                                          const dCheck = addDays(d, off);
                                          if (dCheck > eExt) break;
                                          if (!isWorkingDayForBasis(dCheck, isSixDay)) continue;
                                          const isoCheck = isoDateTaipei(dCheck);
                                          if ((typeof credits?.[isoCheck] === 'number' ? credits[isoCheck] : 0) > 0) {
                                            nextPresent = true;
                                            break;
                                          }
                                        }
                                        const eligible = prevPresent && nextPresent;
                                        credits[satISO] = resolveSaturdayCredit({ rawCredit: credits[satISO] || 0, eligible, override });
                                      }
                                      d = addDays(d, 1);
                                    }
                                  }

                                  hols.forEach((h) => {
                                    const hd = new Date(String(h?.date || '') + 'T00:00:00+08:00');
                                    if (isNaN(hd)) return;
                                    if (hd < start || hd > end) return;
                                    if (!isWorkingDayForBasis(hd, isSixDay)) return;
                                    const hISO = isoDateTaipei(hd);
                                    const raw = baseRawCredit(hISO);
                                    if (raw > 0) { credits[hISO] = raw; return; }

                                    let prev = addDays(hd, -1);
                                    while (prev >= start) {
                                      if (!isWorkingDayForBasis(prev, isSixDay)) { prev = addDays(prev, -1); continue; }
                                      const prevISO = isoDateTaipei(prev);
                                      if (holidaySet.has(prevISO)) { prev = addDays(prev, -1); continue; }
                                      break;
                                    }
                                    let next = addDays(hd, 1);
                                    while (next <= end) {
                                      if (!isWorkingDayForBasis(next, isSixDay)) { next = addDays(next, 1); continue; }
                                      const nextISO = isoDateTaipei(next);
                                      if (holidaySet.has(nextISO)) { next = addDays(next, 1); continue; }
                                      break;
                                    }

                                    if (prev < start || next > end) { credits[hISO] = 0; return; }
                                    const prevISO = isoDateTaipei(prev);
                                    const nextISO = isoDateTaipei(next);
                                    const prevPresent = (credits?.[prevISO] || 0) > 0;
                                    const nextPresent = (credits?.[nextISO] || 0) > 0;
                                    credits[hISO] = (prevPresent && nextPresent) ? 1 : 0;
                                  });

                                  // Trim the credit map back to the ORIGINAL [startISO, endISO] range.
                                  // The 3-day extended buffer was used only for Saturday/holiday eligibility
                                  // lookups; buffer days must not themselves be returned to callers that
                                  // sum present/absent counts or iterate the returned credits map.
                                  Object.keys(credits).forEach((iso) => {
                                    if (iso < startISO || iso > endISO) delete credits[iso];
                                  });

                                  return credits;
                                };

                                const computePayrollDetailItems = (type) => {
                                  const filters = generateTableTab === 'mf' ? mfAttendanceFilters : payrollAttendanceFilters;
                                  const data = generateTableTab === 'mf' ? mfAttendanceData : payrollAttendanceData;
                                  const activeSelectedPayslipEmployee = generateTableTab === 'mf' ? mfSelectedPayslipEmployee : selectedPayslipEmployee;
                                  const sNorm = normalizeToISODateTaipei(filters.start_date);
                                  const eNorm = normalizeToISODateTaipei(filters.end_date);
                                  let startISO, endISO;
                                  if (sNorm.ok && eNorm.ok) {
                                    startISO = sNorm.value;
                                    endISO = eNorm.value;
                                  } else {
                                    const vr = validateDateRangeTaipei(filters.start_date, filters.end_date);
                                    if (!vr.ok) {
                                      try { toast.error('Invalid date range format. Required: MM-DD-YYYY. ' + vr.errors.join('; ')); } catch { /* noop */ }
                                      return [];
                                    }
                                    startISO = vr.startISO;
                                    endISO = vr.endISO;
                                  }
                                  const startDate = new Date(startISO + 'T00:00:00+08:00');
                                  const endDate = new Date(endISO + 'T00:00:00+08:00');
                                  const fmtISO = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' });
                                  const weekdaysInRange = [];
                                  const saturdaysInRange = [];
                                  const cur = new Date(startDate);
                                  while (cur <= endDate) {
                                    const dow = taipeiDayOfWeek(cur);
                                    if (dow !== 0 && dow !== 6) {
                                      weekdaysInRange.push(fmtISO.format(cur));
                                    } else if (dow === 6) {
                                      saturdaysInRange.push(fmtISO.format(cur));
                                    }
                                    cur.setDate(cur.getDate() + 1);
                                  }

                                  const holsInRange = sanitizeHolidayRows(holidays).filter((h) => h.date >= startISO && h.date <= endISO);

                                  const byEmployeeDate = {};
                                  data.forEach((r) => {
                                    const dateStr = r.timestamp ? toTaipeiISODate(r.timestamp) : null;
                                    if (!dateStr) return;
                                    const empId = r.user_id;
                                    byEmployeeDate[empId] = byEmployeeDate[empId] || {};
                                    const existing = byEmployeeDate[empId][dateStr] || { time_in: null, time_out: null, late_minutes: 0, undertime_minutes: 0, is_half_day: false, half_day_reason: '' };
                                    if (r.type === 'time_in') {
                                      if (!existing.time_in || new Date(normalizeTs(r.timestamp)) < new Date(normalizeTs(existing.time_in.timestamp))) {
                                        existing.time_in = r;
                                      }
                                    }
                                    if (r.type === 'time_out') {
                                      if (!existing.time_out || new Date(normalizeTs(r.timestamp)) > new Date(normalizeTs(existing.time_out.timestamp))) {
                                        existing.time_out = r;
                                      }
                                    }
                                    
                                    const missingHalf = Boolean(existing.time_in) !== Boolean(existing.time_out);
                                    const halfDayStatus = detectHalfDayStatus(existing.time_in?.timestamp, existing.time_out?.timestamp);
                                    existing.is_half_day = missingHalf || Boolean(halfDayStatus?.isHalfDay);
                                    existing.half_day_reason = existing.is_half_day ? (halfDayStatus?.isHalfDay ? halfDayStatus.reason : 'Half Day') : '';
                                    
                                    // If we have schedule context and either time_in or time_out, compute daily summary for accurate minutes
                                    const emp = employees.find(e => String(e.id) === String(empId) || String(e.employee_id) === String(empId));
                                    const scheduleId = emp?.schedule_id;
                                    const sched = schedules.find(s => String(s.id) === String(scheduleId));
                                    if (sched) {
                                      // Adjust schedule for Half Day logic
                                      let effectiveStart = sched.start_time;
                                      let effectiveEnd = sched.end_time;

                                      if (existing.is_half_day) {
                                        if (existing.half_day_reason && existing.half_day_reason.includes('Late Time In')) {
                                          effectiveStart = '13:00'; // PM Shift starts at 1:00 PM
                                        } else if (existing.half_day_reason && existing.half_day_reason.includes('Early Time Out')) {
                                          effectiveEnd = '12:00';   // AM Shift ends at 12:00 PM
                                        }
                                      }

                                      const summary = computeDailyAttendanceSummary({
                                        timeInTs: existing.time_in?.timestamp,
                                        timeOutTs: existing.time_out?.timestamp,
                                        scheduleStartHM: effectiveStart,
                                        scheduleEndHM: effectiveEnd,
                                        graceMinutes: 0,
                                        roundingStep: 1,
                                        roundingMode: 'none',
                                        breakMinutes: 0,
                                        approvedLeaveMinutes: 0
                                      });
                                      
                                      // If Half Day, force late and undertime to 0 as per requirements
                                      if (existing.is_half_day) {
                                        existing.late_minutes = 0;
                                        existing.undertime_minutes = 0;
                                      } else {
                                        existing.late_minutes = summary.lateMinutes || 0;
                                        existing.undertime_minutes = summary.undertimeMinutes || 0;
                                      }
                                    }
                                    byEmployeeDate[empId][dateStr] = existing;
                                  });

                                  const toDisplay = [];
                                  const employeeMapById = new Map(employees.map(e => [String(e.id), e]));
                                  const employeeMapByCode = new Map(employees.map(e => [String(e.employee_id), e]));
                                  const scheduleMap = new Map(schedules.map(s => [String(s.id), s]));

                                  const empIds = (() => {
                                    if (!activeSelectedPayslipEmployee) return Object.keys(byEmployeeDate);
                                    const candidates = [
                                      activeSelectedPayslipEmployee?.id,
                                      activeSelectedPayslipEmployee?.employee_id
                                    ]
                                      .map(v => String(v ?? '').trim())
                                      .filter(Boolean);
                                    const existing = candidates.filter((k) => Boolean(byEmployeeDate[k]));
                                    if (existing.length > 0) return Array.from(new Set(existing));
                                    return candidates.length > 0 ? [candidates[0]] : [];
                                  })();

                                  console.log('[Present Modal] Building items:', { type, keys: Object.keys(byEmployeeDate).length, filteredKeys: empIds.length });

                                  empIds.forEach((empId) => {
                                    const emp = employeeMapById.get(String(empId)) || employeeMapByCode.get(String(empId));
                                    const branch = emp?.branch || 'N/A';
                                    const sched = emp?.schedule_id ? scheduleMap.get(String(emp.schedule_id)) : undefined;
                                    const payrollEmp = payrollEmployees.find(p => String(p.employee_id) === String(emp?.employee_id || emp?.id || empId));
                                    const basis = payrollEmp?.daily_rate_formula || payrollEmp?.rate_formula || payrollEmp?.dailyRateFormula;
                                    const isSixDay = String(basis) === '313' || basis === 313;
                                    const payrollEmployeeKey = String(payrollEmp?.employee_id || emp?.employee_id || emp?.id || empId);
                                    const holidaySet = (() => {
                                      const s = new Set();
                                      holsInRange.forEach((h) => {
                                        const hd = new Date(h.date + 'T00:00:00+08:00');
                                        if (isNaN(hd)) return;
                                        if (!isWorkingDayForBasis(hd, isSixDay)) return;
                                        s.add(h.date);
                                      });
                                      return s;
                                    })();
                                    const dates = byEmployeeDate[empId];
                                    const hasAnyPresence = (day) => {
                                      if (!day) return false;
                                      return Boolean(day.time_in) || Boolean(day.time_out) || Boolean(day.is_half_day);
                                    };
                                    const holidaySystemPresentCache = {};
                                    const isHolidaySystemPresent = (holidayISO) => {
                                      if (!holidaySet.has(holidayISO)) return false;
                                      if (holidaySystemPresentCache[holidayISO] !== undefined) return holidaySystemPresentCache[holidayISO];
                                      const hd = new Date(holidayISO + 'T00:00:00+08:00');
                                      if (isNaN(hd) || hd < startDate || hd > endDate) { holidaySystemPresentCache[holidayISO] = false; return false; }
                                      if (!isWorkingDayForBasis(hd, isSixDay)) { holidaySystemPresentCache[holidayISO] = false; return false; }

                                      if (hasAnyPresence(dates?.[holidayISO])) { holidaySystemPresentCache[holidayISO] = false; return false; }

                                      const isSaturdayPresent = (satISO) => {
                                        const key = `${payrollEmployeeKey}_${satISO}`;
                                        const ov = saturdayOverrides?.[key];
                                        if (ov === 'present') return true;
                                        if (hasAnyPresence(dates?.[satISO])) return true;
                                        if (ov === 'absent') return false;
                                        const satD = new Date(satISO + 'T00:00:00+08:00');
                                        if (isNaN(satD)) return false;
                                        const friISO = isoDateTaipei(addDays(satD, -1));
                                        const monISO = isoDateTaipei(addDays(satD, 2));
                                        return hasAnyPresence(dates?.[friISO]) && hasAnyPresence(dates?.[monISO]);
                                      };
                                      const isWorkingDayPresent = (iso) => {
                                        const dObj = new Date(iso + 'T00:00:00+08:00');
                                        if (isNaN(dObj)) return false;
                                        if (isSixDay && taipeiDayOfWeek(dObj) === 6) return isSaturdayPresent(iso);
                                        return hasAnyPresence(dates?.[iso]);
                                      };

                                      let prev = addDays(hd, -1);
                                      while (prev >= startDate) {
                                        if (!isWorkingDayForBasis(prev, isSixDay)) { prev = addDays(prev, -1); continue; }
                                        const prevISO = isoDateTaipei(prev);
                                        if (holidaySet.has(prevISO)) { prev = addDays(prev, -1); continue; }
                                        break;
                                      }
                                      let next = addDays(hd, 1);
                                      while (next <= endDate) {
                                        if (!isWorkingDayForBasis(next, isSixDay)) { next = addDays(next, 1); continue; }
                                        const nextISO = isoDateTaipei(next);
                                        if (holidaySet.has(nextISO)) { next = addDays(next, 1); continue; }
                                        break;
                                      }

                                      if (prev < startDate || next > endDate) { holidaySystemPresentCache[holidayISO] = false; return false; }
                                      const prevISO = isoDateTaipei(prev);
                                      const nextISO = isoDateTaipei(next);
                                      const ok = isWorkingDayPresent(prevISO) && isWorkingDayPresent(nextISO);
                                      holidaySystemPresentCache[holidayISO] = ok;
                                      return ok;
                                    };
                                    if (type === 'present' || type === 'late' || type === 'undertime') {
                                      const addedPresentDates = new Set();
                                      if (dates) {
                                        Object.keys(dates).forEach((dateStr) => {
                                          const d = dates[dateStr];
                                          const dObj = new Date(dateStr + 'T00:00:00+08:00');
                                          if (dObj < startDate || dObj > endDate) return;
                                          const dow = taipeiDayOfWeek(dObj);
                                          if (dow === 0 || (dow === 6 && !isSixDay)) return;
                                          const overrideKey = `${payrollEmployeeKey}_${dateStr}`;
                                          const override = saturdayOverrides[overrideKey];
                                          const isHoliday = holidaySet.has(dateStr);
                                          const satOverrideAbsent = isSixDay && dow === 6 && override === 'absent' && !hasAnyPresence(d);
                                          const name = emp?.full_name || d?.time_in?.user_name || d?.time_out?.user_name || 'Unknown';
                                          const employee_id = emp?.employee_id || emp?.id || d?.time_in?.user_id || d?.time_out?.user_id || 'N/A';
                                          if (type === 'present') {
                                            if (satOverrideAbsent) return;
                                            if (d && (d.time_in || d.time_out || d.is_half_day)) {
                                              const missingHalf = Boolean(d.time_in) !== Boolean(d.time_out);
                                              const halfDayStatus = detectHalfDayStatus(d.time_in?.timestamp, d.time_out?.timestamp);
                                              const isHalf = Boolean(d.is_half_day) || missingHalf || Boolean(halfDayStatus?.isHalfDay);
                                              const full = Boolean(d.time_in) && Boolean(d.time_out) && !isHalf;
                                              const day_value = full ? 1 : 0.5;
                                              let system_status = (isSixDay && dow === 6) ? 'System Present (Saturday)' : undefined;
                                              if (!full) system_status = halfDayStatus?.reason || d.half_day_reason || 'Half Day';
                                              toDisplay.push({ name, employee_id, branch, date: dateStr, first_time_in: d.time_in?.timestamp || null, last_time_out: d.time_out?.timestamp || null, schedule_start: sched?.start_time, schedule_end: sched?.end_time, minutes_late: d.late_minutes || 0, day_value, system_status, is_half_day: !full });
                                              addedPresentDates.add(dateStr);
                                            }
                                          } else if (type === 'late') {
                                            if (d && d.late_minutes > 0 && d.time_in) {
                                              toDisplay.push({ name, employee_id, branch, date: dateStr, first_time_in: d.time_in.timestamp, schedule_start: sched?.start_time, minutes_late: d.late_minutes });
                                            }
                                          } else if (type === 'undertime') {
                                            if (d && d.undertime_minutes > 0 && d.time_out) {
                                              toDisplay.push({ name, employee_id, branch, date: dateStr, last_time_out: d.time_out.timestamp, schedule_end: sched?.end_time, minutes_undertime: d.undertime_minutes });
                                            }
                                          }
                                        });
                                      } else if (type !== 'present') {
                                        return;
                                      }
                                      if (type === 'present') {
                                        holidaySet.forEach((dateStr) => {
                                          if (addedPresentDates.has(dateStr)) return;
                                          if (!isHolidaySystemPresent(dateStr)) return;
                                          const name = emp?.full_name || 'Unknown';
                                          const employee_id = emp?.employee_id || emp?.id || 'N/A';
                                          toDisplay.push({ name, employee_id, branch, date: dateStr, first_time_in: null, last_time_out: null, schedule_start: sched?.start_time, schedule_end: sched?.end_time, minutes_late: 0, day_value: 1, system_status: 'System Present (Holiday)', is_half_day: false });
                                        });
                                      }
                                      // Add synthetic Saturday System Present items for 313 with no actual Saturday attendance but Fri+Mon full
                                      if (type === 'present' && isSixDay) {
                                        saturdaysInRange.forEach((satISO) => {
                                          const dObj = new Date(satISO + 'T00:00:00+08:00');
                                          if (dObj < startDate || dObj > endDate) return;
                                          const dSat = dates?.[satISO];
                                          const satAny = hasAnyPresence(dSat);
                                          
                                          // Check for override
                                          const overrideKey = `${payrollEmployeeKey}_${satISO}`;
                                          const override = saturdayOverrides[overrideKey];
                                          
                                          if (override === 'present') {
                                            if (!satAny) {
                                              const name = emp?.full_name || 'Unknown';
                                              const employee_id = payrollEmployeeKey;
                                              toDisplay.push({ name, employee_id, branch, date: satISO, first_time_in: null, last_time_out: null, schedule_start: sched?.start_time, schedule_end: sched?.end_time, minutes_late: 0, day_value: 1, system_status: 'System Present (Saturday)', is_half_day: false });
                                            }
                                            return;
                                          } else if (override === 'absent') {
                                            return; // Force skip
                                          }
                                          
                                          if (satAny) return;
                                          const friISO = (() => { const dd = new Date(satISO + 'T00:00:00+08:00'); dd.setDate(dd.getDate() - 1); return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' }).format(dd); })();
                                          const monISO = (() => { const dd = new Date(satISO + 'T00:00:00+08:00'); dd.setDate(dd.getDate() + 2); return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' }).format(dd); })();
                                          const fri = dates?.[friISO];
                                          const mon = dates?.[monISO];
                                          const friOk = hasAnyPresence(fri);
                                          const monOk = hasAnyPresence(mon);
                                          if (friOk && monOk) {
                                            const name = emp?.full_name || 'Unknown';
                                            const employee_id = payrollEmployeeKey;
                                            toDisplay.push({ name, employee_id, branch, date: satISO, first_time_in: null, last_time_out: null, schedule_start: sched?.start_time, schedule_end: sched?.end_time, minutes_late: 0, day_value: 1, system_status: 'System Present (Saturday)', is_half_day: false });
                                          }
                                        });
                                      }
                                    } else if (type === 'absent') {
                                      if (!dates) {
                                        weekdaysInRange.forEach((dateStr) => {
                                          if (holidaySet.has(dateStr) && isHolidaySystemPresent(dateStr)) return;
                                          const name = emp?.full_name || 'Unknown';
                                          const employee_id = emp?.employee_id || 'N/A';
                                          toDisplay.push({ name, employee_id, branch, date: dateStr, day_value: 1 });
                                        });
                                        if (isSixDay) {
                                          saturdaysInRange.forEach((satISO) => {
                                            const name = emp?.full_name || 'Unknown';
                                            const employee_id = emp?.employee_id || 'N/A';
                                            
                                            // Check override
                                            const overrideKey = `${payrollEmployeeKey}_${satISO}`;
                                            const override = saturdayOverrides[overrideKey];
                                            
                                            if (override === 'present') {
                                              // Do not mark as absent
                                              return;
                                            } else if (override === 'absent') {
                                              // Force mark as absent
                                              toDisplay.push({ name, employee_id, branch, date: satISO, day_value: 1, system_status: 'System Absent (Saturday)' });
                                              return;
                                            }
                                            if (holidaySet.has(satISO) && isHolidaySystemPresent(satISO)) return;
                                            
                                            // Default: No records at all, Saturday is absent; infer system status as absent
                                            toDisplay.push({ name, employee_id, branch, date: satISO, day_value: 1, system_status: 'System Absent (Saturday)' });
                                          });
                                        }
                                      } else {
                                        weekdaysInRange.forEach((dateStr) => {
                                          if (holidaySet.has(dateStr) && isHolidaySystemPresent(dateStr)) return;
                                          const d = dates[dateStr];
                                          const name = emp?.full_name || 'Unknown';
                                          const employee_id = emp?.employee_id || 'N/A';
                                          if (!d) {
                                            toDisplay.push({ name, employee_id, branch, date: dateStr, day_value: 1 });
                                          } else if (d.is_half_day) {
                                            toDisplay.push({ name, employee_id, branch, date: dateStr, day_value: 0.5, system_status: d.half_day_reason || 'Half Day', first_time_in: d.time_in?.timestamp });
                                          }
                                        });
                                        if (isSixDay) {
                                          saturdaysInRange.forEach((satISO) => {
                                            const dSat = dates[satISO];
                                            const name = emp?.full_name || 'Unknown';
                                            const employee_id = emp?.employee_id || 'N/A';
                                            const satFull = dSat && dSat.time_in && dSat.time_out && (parseToDateTaipeiAware(dSat.time_out.timestamp) > parseToDateTaipeiAware(dSat.time_in.timestamp));
                                            
                                            // Check override
                                            const overrideKey = `${payrollEmployeeKey}_${satISO}`;
                                            const override = saturdayOverrides[overrideKey];
                                            
                                            if (override === 'present') {
                                              return; // Do not mark as absent
                                            } else if (override === 'absent' && !hasAnyPresence(dSat)) {
                                              toDisplay.push({ name, employee_id, branch, date: satISO, day_value: 1, system_status: 'System Absent (Saturday)' });
                                              return;
                                            }
                                            if (holidaySet.has(satISO) && isHolidaySystemPresent(satISO)) return;
                                            
                                            if (satFull) return;
                                            if (dSat && dSat.is_half_day) {
                                              toDisplay.push({ name, employee_id, branch, date: satISO, day_value: 0.5, system_status: dSat.half_day_reason || 'Half Day', first_time_in: dSat.time_in?.timestamp });
                                              return;
                                            }
                                            const friISO = (() => { const dd = new Date(satISO + 'T00:00:00+08:00'); dd.setDate(dd.getDate() - 1); return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' }).format(dd); })();
                                            const monISO = (() => { const dd = new Date(satISO + 'T00:00:00+08:00'); dd.setDate(dd.getDate() + 2); return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' }).format(dd); })();
                                            const fri = dates?.[friISO];
                                            const mon = dates?.[monISO];
                                            const friOk = hasAnyPresence(fri);
                                            const monOk = hasAnyPresence(mon);
                                            // Only include Saturday absent if not System Present
                                            if (!(friOk && monOk)) {
                                              toDisplay.push({ name, employee_id, branch, date: satISO, day_value: 1, system_status: 'System Absent (Saturday)' });
                                            }
                                          });
                                        }
                                      }
                                    }
                                  });

                                  // Sort by date
                                  toDisplay.sort((a, b) => new Date(a.date) - new Date(b.date));
                                  console.log('[Present Modal] Items prepared:', { count: toDisplay.length, sample: toDisplay.slice(0, 3) });
                                  return toDisplay;
                                };

                                // Payroll Database states
                                const [payrollDatabaseFilters, setPayrollDatabaseFilters] = useState({
                                  employee_query: '',
                                  start_date: '',
                                  end_date: '',
                                  branch: 'all'
                                });
                                const [payrollRecords, setPayrollRecords] = useState([]);
                                const [isLoadingPayrollRecords, setIsLoadingPayrollRecords] = useState(false);
                                const [payrollDatabaseTab, setPayrollDatabaseTab] = useState('payroll');
                                const [selectedPayrollRecordEmployeeKey, setSelectedPayrollRecordEmployeeKey] = useState(null);

                                const [payrollLoansFilters, setPayrollLoansFilters] = useState({
                                  employeeName: '',
                                  government: false,
                                  company: false,
                                  branch: 'all'
                                });
                                const [payrollLoans, setPayrollLoans] = useState([]);
                                const [isLoadingPayrollLoans, setIsLoadingPayrollLoans] = useState(false);
                                const [selectedPayrollLoanId, setSelectedPayrollLoanId] = useState(null);
                                const [applicablePayslipPayrollLoans, setApplicablePayslipPayrollLoans] = useState(null);
                                const [applicablePayslipMfLoans, setApplicablePayslipMfLoans] = useState(null);
                                const applicablePayslipLoansCacheRef = useRef(new Map());

                                useEffect(() => {
                                  const tabFiltered = payrollRecords.filter(rec => (
                                    payrollDatabaseTab === 'mf' ? (rec?.deduction_settings?.mf_record === true) : (rec?.deduction_settings?.mf_record !== true)
                                  ));
                                  if (tabFiltered.length === 0) {
                                    if (selectedPayrollRecordEmployeeKey !== null) setSelectedPayrollRecordEmployeeKey(null);
                                    return;
                                  }
                                  if (!selectedPayrollRecordEmployeeKey) return;
                                  const normalizeEmployeeName = (name) => String(name || '').trim().replace(/\s+/g, ' ').toLowerCase();
                                  const normalizeEmployeeId = (id) => {
                                    const raw = String(id ?? '').trim();
                                    if (!raw) return '';
                                    if (/^\d+$/.test(raw)) return raw.replace(/^0+(?=\d)/, '');
                                    return raw;
                                  };
                                  const toEmployeeKey = (rec) => {
                                    const normalizedName = normalizeEmployeeName(rec?.employee_name);
                                    if (normalizedName) return `name:${normalizedName}`;
                                    const normalizedId = normalizeEmployeeId(rec?.employee_id);
                                    if (normalizedId) return `id:${normalizedId.toLowerCase()}`;
                                    return '';
                                  };
                                  const keys = new Set(tabFiltered.map(toEmployeeKey).filter(Boolean));
                                  if (!keys.has(String(selectedPayrollRecordEmployeeKey))) {
                                    setSelectedPayrollRecordEmployeeKey(null);
                                  }
                                }, [payrollRecords, payrollDatabaseTab, selectedPayrollRecordEmployeeKey]);

                                // Saturday System Status Overrides
                                const [saturdayOverrides, setSaturdayOverrides] = useState({});

                                // Load overrides on mount
                                useEffect(() => {
                                  const fetchOverrides = async () => {
                                    try {
                                      const response = await axiosInstance.get('/attendance-overrides');
                                      setSaturdayOverrides(response.data);
                                    } catch (err) {
                                      console.error('Failed to load attendance overrides:', err);
                                    }
                                  };
                                  
                                  fetchOverrides();
                                }, []);

                                const handleSaturdayToggle = async (employeeId, dateStr, isChecked) => {
                                  const newStatus = isChecked ? 'present' : 'absent';
                                  
                                  // Optimistic update
                                  setSaturdayOverrides(prev => ({
                                    ...prev,
                                    [`${employeeId}_${dateStr}`]: newStatus
                                  }));
                                  
                                  // Persist to backend
                                  try {
                                    await axiosInstance.post('/attendance-overrides', {
                                      employee_id: String(employeeId),
                                      date: dateStr,
                                      status: newStatus
                                    });
                                  } catch (err) {
                                    console.error('Failed to save override:', err);
                                    toast.error('Failed to save status change');
                                  }
                                };

                                useEffect(() => {
                                  fetchEmployees();
                                  // Only fetch admins if user is super admin
                                  if (user?.is_super_admin) {
                                    fetchAdmins();
                                  }
                                  fetchAttendance();
                                  fetchDashboardStats(); // Fetch accurate dashboard stats from backend
                                  fetchStats();
                                  fetchBranchSchedules();
                                  fetchPayrollEmployees();
                                  fetchPayrollStats();
                                  fetchProjects(); // Fetch projects on mount
                                }, [user?.is_super_admin]);

                                // Recalculate analytics when saturdayOverrides change
                                useEffect(() => {
                                  if (payrollAttendanceData.length > 0 && payrollEmployees.length > 0) {
                                    calculatePayrollAttendanceAnalytics(payrollAttendanceData, payrollEmployees);
                                  }
                                }, [saturdayOverrides, payrollAttendanceData, payrollEmployees, schedules]);

                                useEffect(() => {
                                  const shouldRefreshGenerated =
                                    isGeneratedPayslipSummaryOpen ||
                                    ((generatedPayslips?.[generateTableTab] || []).length > 0);
                                  const shouldRefreshDetailItems =
                                    isPayrollDetailModalOpen && payrollDetailType !== 'all';

                                  if (!shouldRefreshGenerated && !shouldRefreshDetailItems) return;

                                  const run = async () => {
                                    if (shouldRefreshGenerated) {
                                      await syncGeneratedPayslipRowsForTab({ activeTab: generateTableTab });
                                    }
                                    if (shouldRefreshDetailItems) {
                                      const items = computePayrollDetailItems(payrollDetailType);
                                      setPayrollDetailItems(items);
                                    }
                                  };

                                  run();
                                }, [saturdayOverrides]);

                                useEffect(() => {
                                  if (activeMenuItem === 'payroll-database') {
                                    fetchPayrollRecords({ quiet: true });
                                  }
                                  if (activeMenuItem === 'payroll-loans') {
                                    fetchPayrollLoans({ quiet: true });
                                  }
                                  if (activeMenuItem === 'project-details-map') {
                                    fetchMapAccounts();
                                  }
                                }, [activeMenuItem]);

                                // Refresh calendar view immediately when the active Generate context changes,
                                // including Saturday override changes while the modal is already open.
                                useEffect(() => {
                                  if (!isCalendarViewOpen) return;
                                  const isMfTab = generateTableTab === 'mf';
                                  const activeFilters = isMfTab ? mfAttendanceFilters : payrollAttendanceFilters;
                                  if (isMfTab) {
                                    setIsLoadingMfAttendance(true);
                                    fetchMfAttendanceData(activeFilters).finally(() => setIsLoadingMfAttendance(false));
                                  } else {
                                    setIsLoadingPayrollAttendance(true);
                                    fetchPayrollAttendanceData(activeFilters).finally(() => setIsLoadingPayrollAttendance(false));
                                  }
                                }, [
                                  isCalendarViewOpen,
                                  generateTableTab,
                                  saturdayOverrides,
                                  selectedPayslipEmployee,
                                  mfSelectedPayslipEmployee,
                                  payrollAttendanceFilters.name,
                                  payrollAttendanceFilters.branch,
                                  payrollAttendanceFilters.start_date,
                                  payrollAttendanceFilters.end_date,
                                  mfAttendanceFilters.name,
                                  mfAttendanceFilters.branch,
                                  mfAttendanceFilters.start_date,
                                  mfAttendanceFilters.end_date
                                ]);

                                // Effect to recalculate deductions when toggles change
                                useEffect(() => {
                                  if (payrollEmployeeData && selectedPayslipEmployee) {
                                    recalculateDeductions();
                                  }
                                }, [payslipDeductions]);

                                // Recalculate when pay period changes to reflect HDMF-first-half rule
                                useEffect(() => {
                                  if (payrollEmployeeData && selectedPayslipEmployee) {
                                    recalculateDeductions();
                                  }
                                }, [payrollAttendanceFilters.start_date, payrollAttendanceFilters.end_date]);

                                // Fetch attendance snapshots when page or date filter changes
                                useEffect(() => {
                                  if (activeMenuItem === 'attendance') {
                                    fetchAttendanceSnapshots();
                                  }
                                }, [snapshotCurrentPage, snapshotDateFilter, activeMenuItem]);


                                useEffect(() => {
                                  let intervalId;
                                  const checkAndGenerate = async () => {
                                    if (activeMenuItem !== 'attendance') return;
                                    const hm = new Intl.DateTimeFormat('en-US', {
                                      timeZone: 'Asia/Taipei', hour: '2-digit', minute: '2-digit', hour12: false
                                    }).format(new Date());
                                    const [hStr, mStr] = hm.split(':');
                                    const hours = parseInt(hStr, 10);
                                    const minutes = parseInt(mStr, 10);
                                    const todayISO = getTaipeiTodayISO();
                                    if (snapshotAttemptedDate === todayISO) return;
                                    if (hours === 23 && minutes >= 59) {
                                      try {
                                        await axiosInstance.post('/attendance-snapshots/generate');
                                        toast.success('Attendance snapshot saved for today');
                                      } catch (err) {
                                        const msg = err?.response?.data?.detail || 'Snapshot error';
                                        if (msg.includes('already exists')) {
                                          toast.info('Attendance snapshot already exists for today');
                                        } else {
                                          toast.error(msg);
                                        }
                                      } finally {
                                        setSnapshotAttemptedDate(todayISO);
                                        fetchAttendanceSnapshots();
                                      }
                                    }
                                  };
                                  if (activeMenuItem === 'attendance') {
                                    intervalId = setInterval(checkAndGenerate, 30000);
                                  }
                                  return () => {
                                    if (intervalId) clearInterval(intervalId);
                                  };
                                }, [activeMenuItem, snapshotAttemptedDate]);

                                // Removed Monthly Attendance Violations fetch per requirements

                                // Function to fetch attendance snapshots
                                const fetchAttendanceSnapshots = async () => {
                                  setIsSnapshotLoading(true);
                                  try {
                                    let url = `/attendance-snapshots?page=${snapshotCurrentPage}&limit=15`;
                                    if (snapshotDateFilter) {
                                      // Normalize any date input to Taipei ISO (YYYY-MM-DD)
                                      const normalized = (() => {
                                        try {
                                          const d = new Date(snapshotDateFilter);
                                          if (!isNaN(d)) {
                                            return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year:'numeric', month:'2-digit', day:'2-digit' }).format(d);
                                          }
                                        } catch { /* noop */ }
                                        return snapshotDateFilter; // assume already ISO
                                      })();
                                      url += `&date=${normalized}`;
                                    }
                                    
                                    const response = await axiosInstance.get(url);
                                    setAttendanceSnapshots(response.data);
                                  } catch (error) {
                                    console.error('Error fetching attendance snapshots:', error);
                                    toast.error('Failed to load attendance snapshots');
                                  } finally {
                                    setIsSnapshotLoading(false);
                                  }
                                };

                                const deleteAttendanceSnapshot = async (snapshot) => {
                                  const confirmed = await confirmDialog({
                                      title: "Delete Snapshot",
                                      description: "Are you sure you want to delete this attendance snapshot?",
                                      variant: "destructive"
                                  });
                                  if (!confirmed) return;
                                  const id = snapshot?.id || snapshot?._id || snapshot?.snapshot_id;
                                  const dateStr = snapshot?.date;
                                  const payload = { id, date: dateStr, _method: 'DELETE' };
                                  try {
                                    try {
                                      await axiosInstance.post('/attendance-snapshots/delete', payload);
                                    } catch (err1) {
                                      try {
                                        await axiosInstance.post('/attendance-snapshots/remove', payload);
                                      } catch (err2) {
                                        await axiosInstance.request({ method: 'delete', url: '/attendance-snapshots', data: payload });
                                      }
                                    }
                                    toast.success('Attendance snapshot deleted');
                                    fetchAttendanceSnapshots();
                                  } catch (error) {
                                    console.error('Error deleting attendance snapshot:', error);
                                    toast.error(error?.response?.data?.detail || 'Failed to delete snapshot');
                                  }
                                };

                                // SSS Bracket Calculation Function now imported from payrollUtils
                                // isFirstHalfPayPeriod replaced with isEndDateInFirstHalf from payrollUtils

                                // isEndDateInFirstHalf and isEndDateInSSSWindow are now imported from payrollUtils

                                const recalculateDeductions = () => {
                                  try {
                                    if (!payrollEmployeeData || !selectedPayslipEmployee) return;

                                    let dailyRate = calculatedPayslip.dailyRate;
                                    let hourlyRate = calculatedPayslip.hourlyRate;
                                    if (!dailyRate || dailyRate <= 0) {
                                      const baseSalary = parseFloat(payrollEmployeeData.salary) || 0;
                                      let dr = parseFloat(payrollEmployeeData.daily_rate) || 0;
                                      if (!dr || dr <= 0) {
                                        const basis = payrollEmployeeData.daily_rate_formula || payrollEmployeeData.rate_formula || payrollEmployeeData.dailyRateFormula || 313;
                                        dr = computeDailyRateFromBasis(baseSalary, basis);
                                      }
                                      dailyRate = dr || 0;
                                      hourlyRate = (dr / 8) || 0;
                                    }
                                    
                                    // Get attendance data for this employee
                                    const presentDays = (payrollAttendanceAnalytics && payrollAttendanceAnalytics.days_present) || 0;
                                    const isInactivePayslipException = isInactivePayslipExceptionEmail(
                                      payrollEmployeeData?.email || selectedPayslipEmployee?.email
                                    );
                                    const absentDays = isInactivePayslipException
                                      ? 0
                                      : ((payrollAttendanceAnalytics && payrollAttendanceAnalytics.days_absent) || 0);
                                    const lateMinutes = isInactivePayslipException
                                      ? 0
                                      : ((payrollAttendanceAnalytics && payrollAttendanceAnalytics.total_minutes_late) || 0);
                                    const undertimeMinutes = isInactivePayslipException
                                      ? 0
                                      : ((payrollAttendanceAnalytics && payrollAttendanceAnalytics.total_minutes_undertime) || 0);
                                    
                                    // Calculate gross pay with deductions
                                    // Start with half month salary
                                    const baseSalaryForHalf = (calculatedPayslip.basicSalary && calculatedPayslip.basicSalary > 0)
                                      ? calculatedPayslip.basicSalary
                                      : (parseFloat(payrollEmployeeData.salary) || 0);
                                    const halfMonthSalary = baseSalaryForHalf / 2;
                                    
                                    // Calculate deductions
                                    const { absenceDeduction, lateDeduction, undertimeDeduction } = calculateAttendanceDeductions(absentDays, lateMinutes, undertimeMinutes, dailyRate);
                                    
                                    // Calculate Additional Income
                                    const additionalIncomeTotal = (Array.isArray(additionalIncome) ? additionalIncome : []).reduce((sum, inc) => {
                                      const unit = inc.unit || 'minutes';
                                      if (unit === 'amount') return sum + (parseFloat(inc.amount) || 0);
                                      if (unit === 'days') return sum + ((parseFloat(inc.days) || 0) * dailyRate);
                                      return sum + ((dailyRate / 8 / 60) * (parseFloat(inc.minutes) || 0));
                                    }, 0);

                                    // Gross Pay = Half Month Salary - Absence - Late - Undertime + Additional Income
                                    const grossPay = halfMonthSalary - absenceDeduction - lateDeduction - undertimeDeduction + additionalIncomeTotal;

                                    // Recalculate government deductions based on current toggle states and correct formulas
                                    let sssDeduction = 0;
                                    let phicDeduction = 0;
                                    let hdmfDeduction = 0;
                                    let taxDeduction = 0;

                                    const endDateStr = payrollAttendanceFilters.end_date;
                                    const endDateObj = endDateStr ? new Date(endDateStr) : null;
                                    const isSecondHalf = endDateObj && !isNaN(endDateObj) && endDateObj.getDate() > 15;
                                    const isSSSWindow = isEndDateInSSSWindow(endDateStr);
                                    const monthStartISO = endDateObj ? new Date(endDateObj.getFullYear(), endDateObj.getMonth(), 1).toISOString().slice(0,10) : null;
                                    const prevWindowEndISO = endDateObj ? new Date(endDateObj.getFullYear(), endDateObj.getMonth(), 19).toISOString().slice(0,10) : null;

                                    const applyMonthlySSSAndTax = async () => {
                                      try {
                                        if (!isSecondHalf) return;
                                        const employeeIdRaw = selectedPayslipEmployee?.employee_id || selectedPayslipEmployee?.id || payrollEmployeeData?.employee_id;
                                        const employeeIdCandidates = buildEmployeeIdCandidates([
                                          payrollEmployeeData?.employee_id,
                                          selectedPayslipEmployee?.id,
                                          selectedPayslipEmployee?.employee_id,
                                          employeeIdRaw
                                        ]);
                                        const employeeId = employeeIdCandidates[0] || '';
                                        if (!employeeId) return;
                                        let prevGross = 0;
                                        let prevGov = 0;
                                        let prevGovSss = 0;
                                        let prevGovPhic = 0;
                                        let prevGovHdmf = 0;
                                        let prevGovRecords = [];
                                        const startDateStr = payrollAttendanceFilters.start_date;
                                        const vr = validateDateRangeTaipei(startDateStr, endDateStr);
                                        if (vr.ok) {
                                          try {
                                            const { monthStartISO, monthEndISO } = computeMonthWindowFromEndISO(vr.endISO);
                                            const __dbg = createMonthlyGrossDebugger({ sessionId: 'monthly-gross-prev-gross-zero', url: 'http://127.0.0.1:7780/event' });
                                            __dbg({
                                              type: 'monthly_gross_prev_gross_tax',
                                              step: 'before_normalize',
                                              employeeId,
                                              employeeIdRaw,
                                              employeeIdCandidates,
                                              selectedStartISO: vr.startISO,
                                              selectedEndISO: vr.endISO,
                                              monthStartISO,
                                              monthEndISO,
                                              query: `candidates=${employeeIdCandidates.join(',')}&end_date=${monthEndISO}`
                                            });
                                            const { attempts, usedEmployeeId, records } = await fetchPayrollRecordsByEmployeeIdCandidates({
                                              axiosInstance,
                                              employeeIdCandidates,
                                              endDateISO: monthEndISO
                                            });
                                            const { prevGross: pg, prevGov: pv, deduped, earlierInMonth, normalizedCount } = computePrevGrossAndGovFromMonthlyPayrollRecords({
                                              records,
                                              monthStartISO,
                                              monthEndISO,
                                              selectedStartISO: vr.startISO,
                                              selectedEndISO: vr.endISO
                                            });
                                            prevGross = pg;
                                            prevGov = pv;
                                            prevGovRecords = Array.isArray(earlierInMonth) ? earlierInMonth : [];
                                            prevGovRecords.forEach((r) => {
                                              prevGovSss += parseFloat(r?.sss_contribution) || 0;
                                              prevGovPhic += parseFloat(r?.philhealth_contribution) || 0;
                                              prevGovHdmf += parseFloat(r?.hdmf_contribution) || 0;
                                            });
                                            __dbg({
                                              type: 'monthly_gross_prev_gross_tax',
                                              step: 'after_fetch_normalize',
                                              attempts,
                                              usedEmployeeId,
                                              normalizedCount,
                                              sample: (deduped || []).slice(0, 5).map(r => ({
                                                start_date: r.start_date,
                                                end_date: r.end_date,
                                                _startISO: r._startISO,
                                                _endISO: r._endISO,
                                                gross_salary: r.gross_salary,
                                                created_at: r.created_at
                                              }))
                                            });
                                            __dbg({
                                              type: 'monthly_gross_prev_gross_tax',
                                              step: 'after_filter_compute',
                                              dedupedCount: (deduped || []).length,
                                              earlierInMonthCount: (earlierInMonth || []).length,
                                              prevGross,
                                              prevGov
                                            });
                                          } catch (e) {
                                            prevGross = 0;
                                            prevGov = 0;
                                          }
                                        }
                                        const monthlyGrossComputed = Math.max(0, prevGross + grossPay);
                                        const monthlyGross = monthlyGrossComputed;
                                        const monthlySssPreview = payslipDeductions.sss ? calculateSSSDeduction(monthlyGross || 0) : 0;
                                        if (payslipDeductions.sss && isSSSWindow) sssDeduction = monthlySssPreview;
  
                                        const currentGov = (payslipDeductions.phic ? phicDeduction : 0) + (payslipDeductions.hdmf ? hdmfDeduction : 0) + (payslipDeductions.sss ? sssDeduction : 0);
  
                                        if (payslipDeductions.tax && !payrollEmployeeData.is_minimum_wage) {
                                          // Taxable Income = Monthly Gross - (Prev Gov Deductions + Current Gov Deductions)
                                          // As per user instruction, SSS is NOT deducted from the taxable income base
                                          const monthlyTaxable = monthlyGross - prevGov - currentGov;
                                          taxDeduction = calculateTaxDeduction(monthlyTaxable);
                                        }
                                        // Only update deductions (SSS/tax), not Monthly Gross display
                                        // Monthly Gross display is managed by fetchAndCalculatePayslip's async path
                                        const updatedDeductionsAsync = {
                                          sss: sssDeduction,
                                          phic: phicDeduction,
                                          hdmf: hdmfDeduction,
                                          tax: taxDeduction,
                                          late: lateDeduction,
                                          undertime: undertimeDeduction
                                        };
                                        const totalDeductionsAsync = sssDeduction + phicDeduction + hdmfDeduction + taxDeduction;
                                        const netPayAsync = grossPay - totalDeductionsAsync;
                                        setCalculatedPayslip(prev => ({
                                          ...prev,
                                          deductions: updatedDeductionsAsync,
                                          totalDeductions: totalDeductionsAsync || 0,
                                          netPay: Math.max(0, netPayAsync || 0),
                                          monthlySssPreview: monthlySssPreview || 0
                                        }));
                                        const prevGovTotal = Math.max(0, prevGov || 0);
                                        const currentGovTotal = Math.max(0, currentGov || 0);
                                        setMonthlyPayrollSummary((prev) => ({
                                          ...prev,
                                          government_deductions: Math.max(0, prevGovTotal + currentGovTotal)
                                        }));
                                        setMonthlyGovDetails({
                                          prev: {
                                            sss: Math.max(0, prevGovSss || 0),
                                            phic: Math.max(0, prevGovPhic || 0),
                                            hdmf: Math.max(0, prevGovHdmf || 0),
                                            total: prevGovTotal,
                                            records: (prevGovRecords || []).map((r) => {
                                              const sss = parseFloat(r?.sss_contribution) || 0;
                                              const phic = parseFloat(r?.philhealth_contribution) || 0;
                                              const hdmf = parseFloat(r?.hdmf_contribution) || 0;
                                              return {
                                                start_date: r?.start_date,
                                                end_date: r?.end_date,
                                                sss,
                                                phic,
                                                hdmf,
                                                total: sss + phic + hdmf
                                              };
                                            })
                                          },
                                          current: {
                                            sss: payslipDeductions.sss ? (sssDeduction || 0) : 0,
                                            phic: payslipDeductions.phic ? (phicDeduction || 0) : 0,
                                            hdmf: payslipDeductions.hdmf ? (hdmfDeduction || 0) : 0,
                                            total: currentGovTotal
                                          },
                                          total: Math.max(0, prevGovTotal + currentGovTotal)
                                        });
                                      } catch (err) { console.error('Error in applyMonthlySSSAndTax', err); }
                                    };
  
                                    if (payslipDeductions.phic) {
                                      // PhilHealth = (monthly salary x 5%) / 2, deducted only on 15th (first half) payroll
                                      const endDateStr = payrollAttendanceFilters.end_date;
                                      const isFirstHalf = isEndDateInFirstHalf(endDateStr);
                                      const monthlySalary = parseFloat(payrollEmployeeData?.salary) || 0;
                                      phicDeduction = isFirstHalf ? (monthlySalary * 0.05) / 2 : 0;
                                    }
  
                                    if (payslipDeductions.hdmf) {
                                      const endDateStr = payrollAttendanceFilters.end_date;
                                      const isFirstHalf = isEndDateInFirstHalf(endDateStr);
                                      const extra = parseFloat(payrollEmployeeData?.deductions?.hdmf_additional) || 0;
                                      hdmfDeduction = isFirstHalf ? (200 + extra) : 0;
                                    }
  
                                    // For SSS/Tax: compute from monthly gross and only on second payroll
                                    // Set prelim deductions; async will refine with previous half gross if needed
                                    if (isSecondHalf) {
                                      applyMonthlySSSAndTax();
                                    } else {
                                      sssDeduction = 0;
                                      taxDeduction = 0;
                                      const currentGov = (payslipDeductions.phic ? phicDeduction : 0) + (payslipDeductions.hdmf ? hdmfDeduction : 0) + (payslipDeductions.sss ? sssDeduction : 0);
                                      const candidateGross = Math.max(0, grossPay);
                                      if (!monthlyPayrollSummary?.gross || monthlyPayrollSummary.gross <= 0) {
                                        safeSetMonthlySummary(candidateGross, Math.max(0, currentGov));
                                        setMonthlyGovDetails({
                                          prev: { sss: 0, phic: 0, hdmf: 0, total: 0, records: [] },
                                          current: {
                                            sss: payslipDeductions.sss ? (sssDeduction || 0) : 0,
                                            phic: payslipDeductions.phic ? (phicDeduction || 0) : 0,
                                            hdmf: payslipDeductions.hdmf ? (hdmfDeduction || 0) : 0,
                                            total: Math.max(0, currentGov || 0)
                                          },
                                          total: Math.max(0, currentGov || 0)
                                        });
                                      }
                                    }
  
                                    // Late and undertime are already calculated above (lines 573-574) for gross pay calculation
                                    // We use them here for tracking in the deductions object for display purposes
  
                                    const updatedDeductions = {
                                      sss: sssDeduction,
                                      phic: phicDeduction,
                                      hdmf: hdmfDeduction,
                                      tax: taxDeduction,
                                      late: lateDeduction,
                                      undertime: undertimeDeduction
                                    };
  
                                    // Total deductions ONLY include government deductions and tax (late/undertime already in gross calculation)
                                    const totalDeductions = sssDeduction + phicDeduction + hdmfDeduction + taxDeduction;
                                    const netPay = grossPay - totalDeductions;
  
                                    setCalculatedPayslip(prev => ({
                                      ...prev,
                                      grossPay: grossPay || 0,
                                      deductions: updatedDeductions,
                                      totalDeductions: totalDeductions || 0,
                                      netPay: Math.max(0, netPay || 0)
                                    }));
                                  } catch (error) {
                                    console.error('Error in recalculateDeductions:', error);
                                  }
                                };

                                  useEffect(() => {
                                    if (isEditingPayslipRecord) return;
                                    recalculateDeductions();
                                  }, [additionalIncome, payrollAttendanceFilters, isEditingPayslipRecord]);

                                  useEffect(() => {
                                    if (isEditingPayslipRecord) return;
                                    if (payrollAttendanceFilters.name && payrollAttendanceFilters.start_date && payrollAttendanceFilters.end_date && generateTableTab === 'payroll') {
                                      fetchAndCalculatePayslip();
                                    }
                                  }, [payrollAttendanceFilters, additionalIncome, payrollAttendanceAnalytics, isEditingPayslipRecord]);

                                  const fetchAndCalculatePayslip = async (isRealtimeUpdate = false) => {
                                    if (!payrollAttendanceFilters.name.trim()) {
                                      if (!isRealtimeUpdate) toast.error('Please enter an employee name or ID');
                                      return;
                                    }

                                  try {
                                    // Reset monthly summary to prevent stale values from previous employee
                                    setMonthlyPayrollSummary({ gross: 0, government_deductions: 0 });
                                    setMonthlyGovDetails({
                                      prev: { sss: 0, phic: 0, hdmf: 0, total: 0, records: [] },
                                      current: { sss: 0, phic: 0, hdmf: 0, total: 0 },
                                      total: 0
                                    });

                                    // Find employee from HRIS database
                                    const matchedEmployee = employees.find(emp => 
                                      emp.full_name?.toLowerCase().includes(payrollAttendanceFilters.name.toLowerCase()) ||
                                      emp.employee_id?.toLowerCase().includes(payrollAttendanceFilters.name.toLowerCase())
                                    );

                                    if (!matchedEmployee) {
                                      toast.error('Employee not found in HRIS database');
                                      return;
                                    }

                                    // Find corresponding payroll employee
                                    const payrollEmployee = payrollEmployees.find(emp => emp.employee_id === matchedEmployee.id);
                                    
                                    if (!payrollEmployee) {
                                      toast.error('Employee not found in payroll database');
                                      return;
                                    }
                                    if (!isPayrollEmployeeActiveForGeneration(payrollEmployee)) {
                                      if (!isRealtimeUpdate) {
                                        toast.error('Cannot generate payslip for an inactive employee');
                                      }
                                      return;
                                    }

                                    setSelectedPayslipEmployee(matchedEmployee);
                                    setPayrollEmployeeData(payrollEmployee);

                                    // Set deduction toggles based on payroll employee settings
                                    setPayslipDeductions({
                                      sss: true,
                                      phic: true,
                                      hdmf: true,
                                      tax: !payrollEmployee.is_minimum_wage
                                    });

                                    // Calculate payslip data
                                    const basicSalary = parseFloat(payrollEmployee.salary) || 0;
                                    let dailyRate = 0;
                                    if (parseFloat(payrollEmployee.daily_rate) > 0) {
                                      dailyRate = parseFloat(payrollEmployee.daily_rate);
                                    } else if (payrollEmployee.daily_rate_formula || payrollEmployee.rate_formula || payrollEmployee.dailyRateFormula) {
                                      const basis = payrollEmployee.daily_rate_formula || payrollEmployee.rate_formula || payrollEmployee.dailyRateFormula;
                                      dailyRate = computeDailyRateFromBasis(basicSalary, basis);
                                    } else {
                                      dailyRate = computeDailyRateFromBasis(basicSalary, 313);
                                    }
                                    const hourlyRate = dailyRate / 8;

                                    // Get allowances (for display only, not included in gross pay)
                                    const allowances = {
                                      mf: parseFloat(payrollEmployee.allowances?.mf) || 0,
                                      gas_allowance: parseFloat(payrollEmployee.allowances?.gas_allowance) || 0,
                                      load_allowance: parseFloat(payrollEmployee.allowances?.load_allowance) || 0,
                                      housing_allowance: parseFloat(payrollEmployee.allowances?.housing_allowance) || 0
                                    };

                                    // Get attendance data for this employee
                                    const presentDays = (payrollAttendanceAnalytics && payrollAttendanceAnalytics.days_present) || 0;
                                    const absentDays = (payrollAttendanceAnalytics && payrollAttendanceAnalytics.days_absent) || 0;
                                    const lateMinutes = (payrollAttendanceAnalytics && payrollAttendanceAnalytics.total_minutes_late) || 0;
                                    const undertimeMinutes = (payrollAttendanceAnalytics && payrollAttendanceAnalytics.total_minutes_undertime) || 0;
                                    
                                    // Calculate gross pay with deductions
                                    // Start with half month salary
                                    const halfMonthSalary = basicSalary / 2;
                                    
                                    // Calculate deductions
                                    const { absenceDeduction, lateDeduction, undertimeDeduction } = calculateAttendanceDeductions(absentDays, lateMinutes, undertimeMinutes, dailyRate);
                                    
                                    // Calculate additional income
                                    const additionalIncomeTotal = (Array.isArray(additionalIncome) ? additionalIncome : []).reduce((sum, inc) => {
                                      const unit = inc.unit || 'minutes';
                                      if (unit === 'amount') return sum + (parseFloat(inc.amount) || 0);
                                      if (unit === 'days') return sum + ((parseFloat(inc.days) || 0) * dailyRate);
                                      return sum + ((dailyRate / 8 / 60) * (parseFloat(inc.minutes) || 0));
                                    }, 0);

                                    // Gross Pay = Half Month Salary - Absence - Late - Undertime + Additional Income
                                    const grossPay = halfMonthSalary - absenceDeduction - lateDeduction - undertimeDeduction + additionalIncomeTotal;

                                    // Calculate government deductions with correct formulas
                                    let sssDeduction = 0;
                                    let phicDeduction = 0;
                                    let hdmfDeduction = 0;
                                    let taxDeduction = 0;

                                    const endDateStr = payrollAttendanceFilters.end_date;
                                    const endDateObj = endDateStr ? new Date(endDateStr) : null;
                                    const isEndOfMonth = endDateObj && !isNaN(endDateObj) && endDateObj.getDate() === new Date(endDateObj.getFullYear(), endDateObj.getMonth() + 1, 0).getDate();
                                    const isSSSWindow = isEndDateInSSSWindow(endDateStr);
                                    // Use grossPay as preliminary monthlyGross; async fetch will compute correct value
                                    const monthlyGross = Math.max(0, grossPay);
                                    const monthlySssPreview = payslipDeductions.sss ? calculateSSSDeduction(monthlyGross || 0) : 0;
                                    if (payslipDeductions.sss && isSSSWindow) sssDeduction = monthlySssPreview;

                                    if (payslipDeductions.phic) {
                                      // PhilHealth = (monthly salary x 5%) / 2, deducted only on 15th (first half) payroll
                                      const endDateStr = payrollAttendanceFilters.end_date;
                                      const isFirstHalf = isEndDateInFirstHalf(endDateStr);
                                      const monthlySalary = parseFloat(payrollEmployee?.salary) || 0;
                                      phicDeduction = isFirstHalf ? (monthlySalary * 0.05) / 2 : 0;
                                    }

                                    if (payslipDeductions.hdmf) {
                                      const endDateStr = payrollAttendanceFilters.end_date;
                                      const isFirstHalf = isEndDateInFirstHalf(endDateStr);
                                      const extra = parseFloat(payrollEmployee?.deductions?.hdmf_additional) || 0;
                                      hdmfDeduction = isFirstHalf ? (200 + extra) : 0;
                                    }

                                    if (payslipDeductions.tax && !payrollEmployee.is_minimum_wage && isEndOfMonth) {
                                      const monthlyTaxable = basicSalary - sssDeduction - phicDeduction - hdmfDeduction;
                                      taxDeduction = calculateTaxDeduction(monthlyTaxable);
                                    }

                                    // Late and undertime are already calculated above (lines 695-696) for gross pay calculation
                                    // We use them here for tracking in the deductions object for display purposes

                                    const deductions = {
                                      sss: sssDeduction,
                                      phic: phicDeduction,
                                      hdmf: hdmfDeduction,
                                      tax: taxDeduction,
                                      late: lateDeduction,
                                      undertime: undertimeDeduction
                                    };

                                    // Total deductions ONLY include government deductions and tax (late/undertime already in gross calculation)
                                    const totalDeductions = sssDeduction + phicDeduction + hdmfDeduction + taxDeduction;
                                    const netPay = grossPay - totalDeductions;

                                    setCalculatedPayslip({
                                      basicSalary,
                                      dailyRate,
                                      hourlyRate,
                                      allowances,
                                      deductions,
                                      grossPay,
                                      totalDeductions,
                                      netPay: Math.max(0, netPay),
                                      monthlyGross,
                                      monthlySssPreview
                                    });
                                    
                                    try {
                                      const employeeIdRaw = matchedEmployee?.employee_id || matchedEmployee?.id || payrollEmployee?.employee_id;
                                      const employeeIdCandidates = buildEmployeeIdCandidates([
                                        payrollEmployee?.employee_id,
                                        matchedEmployee?.id,
                                        matchedEmployee?.employee_id,
                                        employeeIdRaw
                                      ]);
                                      const employeeId = employeeIdCandidates[0] || '';
                                      const endDateStr = payrollAttendanceFilters.end_date;
                                      let prevGov = 0;
                                      let prevGross = 0;
                                      let prevGovSss = 0;
                                      let prevGovPhic = 0;
                                      let prevGovHdmf = 0;
                                      let prevGovRecords = [];
                                      const startDateStr = payrollAttendanceFilters.start_date;
                                      const vr = validateDateRangeTaipei(startDateStr, endDateStr);
                                      if (employeeId && vr.ok) {
                                        const __dbg = createMonthlyGrossDebugger({ sessionId: 'monthly-gross-prev-gross-zero', url: 'http://127.0.0.1:7780/event' });
                                        const { monthStartISO, monthEndISO } = computeMonthWindowFromEndISO(vr.endISO);
                                        const attempts = [];
                                        try {
                                          __dbg({
                                            type: 'monthly_gross_prev_gross',
                                            step: 'before_fetch',
                                            employeeIdRaw,
                                            employeeId,
                                            employeeIdCandidates,
                                            selectedStartISO: vr.startISO,
                                            selectedEndISO: vr.endISO,
                                            monthStartISO,
                                            monthEndISO,
                                            query: `candidates=${employeeIdCandidates.join(',')}&end_date=${monthEndISO}`
                                          });
                                          const fetched = await fetchPayrollRecordsByEmployeeIdCandidates({
                                            axiosInstance,
                                            employeeIdCandidates,
                                            endDateISO: monthEndISO
                                          });
                                          const computed = computePrevGrossAndGovFromMonthlyPayrollRecords({
                                            records: fetched.records,
                                            monthStartISO,
                                            monthEndISO,
                                            selectedStartISO: vr.startISO,
                                            selectedEndISO: vr.endISO
                                          });
                                          prevGross = computed.prevGross;
                                          prevGov = computed.prevGov;
                                          prevGovRecords = Array.isArray(computed.earlierInMonth) ? computed.earlierInMonth : [];
                                          prevGovRecords.forEach((r) => {
                                            prevGovSss += parseFloat(r?.sss_contribution) || 0;
                                            prevGovPhic += parseFloat(r?.philhealth_contribution) || 0;
                                            prevGovHdmf += parseFloat(r?.hdmf_contribution) || 0;
                                          });
                                          __dbg({
                                            type: 'monthly_gross_prev_gross',
                                            step: 'after_fetch_normalize',
                                            attempts: fetched.attempts,
                                            usedEmployeeId: fetched.usedEmployeeId,
                                            rawCount: Array.isArray(fetched.records) ? fetched.records.length : 0,
                                            normalizedCount: computed.normalizedCount,
                                            sample: (computed.deduped || []).slice(0, 5).map(r => ({
                                              start_date: r.start_date,
                                              end_date: r.end_date,
                                              _startISO: r._startISO,
                                              _endISO: r._endISO,
                                              gross_salary: r.gross_salary,
                                              created_at: r.created_at
                                            }))
                                          });
                                          __dbg({
                                            type: 'monthly_gross_prev_gross',
                                            step: 'after_filter_compute',
                                            dedupedCount: (computed.deduped || []).length,
                                            earlierInMonthCount: (computed.earlierInMonth || []).length,
                                            earlierSample: (computed.earlierInMonth || []).slice(0, 5).map(r => ({
                                              _startISO: r._startISO,
                                              _endISO: r._endISO,
                                              gross_salary: r.gross_salary,
                                              created_at: r.created_at
                                            })),
                                            prevGross,
                                            prevGov
                                          });
                                        } catch { /* noop */ }
                                      }
                                      const monthlyGross = Math.max(0, prevGross + grossPay);
                                      const currentGov = (payslipDeductions.phic ? phicDeduction : 0) + (payslipDeductions.hdmf ? hdmfDeduction : 0) + (payslipDeductions.sss ? sssDeduction : 0);
                                      safeSetMonthlySummary(monthlyGross, Math.max(0, prevGov + currentGov));
                                      const prevGovTotal = Math.max(0, prevGov || 0);
                                      const currentGovTotal = Math.max(0, currentGov || 0);
                                      setMonthlyGovDetails({
                                        prev: {
                                          sss: Math.max(0, prevGovSss || 0),
                                          phic: Math.max(0, prevGovPhic || 0),
                                          hdmf: Math.max(0, prevGovHdmf || 0),
                                          total: prevGovTotal,
                                          records: (prevGovRecords || []).map((r) => {
                                            const sss = parseFloat(r?.sss_contribution) || 0;
                                            const phic = parseFloat(r?.philhealth_contribution) || 0;
                                            const hdmf = parseFloat(r?.hdmf_contribution) || 0;
                                            return {
                                              start_date: r?.start_date,
                                              end_date: r?.end_date,
                                              sss,
                                              phic,
                                              hdmf,
                                              total: sss + phic + hdmf
                                            };
                                          })
                                        },
                                        current: {
                                          sss: payslipDeductions.sss ? (sssDeduction || 0) : 0,
                                          phic: payslipDeductions.phic ? (phicDeduction || 0) : 0,
                                          hdmf: payslipDeductions.hdmf ? (hdmfDeduction || 0) : 0,
                                          total: currentGovTotal
                                        },
                                        total: Math.max(0, prevGovTotal + currentGovTotal)
                                      });
                                      
                                      // Update details for the modal
                                      setMonthlyGrossDetails({
                                        prevGross,
                                        currentGross: grossPay - additionalIncomeTotal,
                                        additionalIncome: additionalIncomeTotal,
                                        totalGross: monthlyGross,
                                        records: [] // Could populate with `records` if needed, but not necessary right now
                                      });
                                      try {
                                        const __dbg = createMonthlyGrossDebugger({ sessionId: 'monthly-gross-prev-gross-zero', url: 'http://127.0.0.1:7780/event' });
                                        __dbg({
                                          type: 'monthly_gross_prev_gross',
                                          step: 'set_monthly_gross_details',
                                          prevGross,
                                          currentGross: grossPay - additionalIncomeTotal,
                                          additionalIncome: additionalIncomeTotal,
                                          totalGross: monthlyGross
                                        });
                                      } catch { /* noop */ }

                                      // Also update calculatedPayslip.monthlyGross with correct async-computed value
                                      setCalculatedPayslip(prev => ({ ...prev, monthlyGross }));
                                    } catch { /* noop */ }

                                    if (!isRealtimeUpdate) toast.success('Payslip calculated successfully');
                                  } catch (error) {
                                    console.error('Error calculating payslip:', error);
                                    if (!isRealtimeUpdate) toast.error('Failed to calculate payslip');
                                  }
                                };

                                const fetchAndCalculatePayslipMf = async (isRealtimeUpdate = false) => {
                                  if (!mfAttendanceFilters.name.trim()) {
                                    if (!isRealtimeUpdate) toast.error('Please enter an employee name or ID');
                                    return;
                                  }

                                  try {
                                    const nameQ = mfAttendanceFilters.name.toLowerCase();
                                  const matchedEmployee = employees.find(emp => 
                                    emp.full_name?.toLowerCase().includes(nameQ) ||
                                    String(emp.employee_id || '').toLowerCase().includes(nameQ) ||
                                    String(emp.id || '').toLowerCase().includes(nameQ)
                                  );
                                    if (!matchedEmployee) { toast.error('Employee not found in HRIS database'); return; }
                                    const payrollEmployee = payrollEmployees.find(emp => 
                                      String(emp.employee_id) === String(matchedEmployee.id) || 
                                      String(emp.employee_id) === String(matchedEmployee.employee_id)
                                    ) || payrollEmployees.find(emp => (emp.full_name || '').toLowerCase().includes(nameQ));
                                    if (!payrollEmployee) { toast.error('Employee not found in payroll database'); return; }
                                    if (!isPayrollEmployeeActiveForGeneration(payrollEmployee)) {
                                      if (!isRealtimeUpdate) {
                                        toast.error('Cannot generate payslip for an inactive employee');
                                      }
                                      return;
                                    }

                                  setMfSelectedPayslipEmployee(matchedEmployee);
                                  setPayrollEmployeeData(payrollEmployee);
                                  setPayslipDeductions({
                                    sss: true,
                                    phic: true,
                                    hdmf: true,
                                    tax: !payrollEmployee.is_minimum_wage
                                  });

                                  const basicSalary = parseFloat(payrollEmployee.salary) || 0;
                                  let dailyRate = 0;
                                  if (parseFloat(payrollEmployee.daily_rate) > 0) dailyRate = parseFloat(payrollEmployee.daily_rate);
                                  else if (payrollEmployee.daily_rate_formula || payrollEmployee.rate_formula || payrollEmployee.dailyRateFormula) {
                                    const basis = payrollEmployee.daily_rate_formula || payrollEmployee.rate_formula || payrollEmployee.dailyRateFormula;
                                    dailyRate = computeDailyRateFromBasis(basicSalary, basis);
                                  } else dailyRate = computeDailyRateFromBasis(basicSalary, 313);
                                  const hourlyRate = dailyRate / 8;

                                  const presentDays = mfAttendanceAnalytics.days_present;
                                  const absentDays = mfAttendanceAnalytics.days_absent;
                                  const lateMinutes = mfAttendanceAnalytics.total_minutes_late;
                                  const undertimeMinutes = mfAttendanceAnalytics.total_minutes_undertime;

                                  const allowances = payrollEmployee?.allowances || {};
                                  const mfAmount = parseFloat(allowances?.mf) || 0;
                                  const { absenceDeduction, lateDeduction, undertimeDeduction } = calculateAttendanceDeductions(absentDays, lateMinutes, undertimeMinutes, dailyRate);
                                  
                                  const additionalIncomeTotal = (Array.isArray(additionalIncome) ? additionalIncome : []).reduce((sum, inc) => {
                                    const unit = inc.unit || 'minutes';
                                    if (unit === 'amount') return sum + (parseFloat(inc.amount) || 0);
                                    if (unit === 'days') return sum + ((parseFloat(inc.days) || 0) * dailyRate);
                                    return sum + ((dailyRate / 8 / 60) * (parseFloat(inc.minutes) || 0));
                                  }, 0);
                                  
                                  const grossPay = mfAmount - absenceDeduction - lateDeduction - undertimeDeduction + additionalIncomeTotal;

                                  let sssDeduction = 0; let phicDeduction = 0; let hdmfDeduction = 0; let taxDeduction = 0;
                                  const endDateStr = mfAttendanceFilters.end_date;
                                  const endDateObj = endDateStr ? new Date(endDateStr) : null;
                                  const isSSSWindow = isEndDateInSSSWindow(endDateStr);
                                  if (payslipDeductions.sss && isSSSWindow) {
                                    try {
                                      const employeeIdRaw = mfSelectedPayslipEmployee?.employee_id || mfSelectedPayslipEmployee?.id || payrollEmployee?.employee_id;
                                      const employeeId = normalizeEmployeeIdForQuery(employeeIdRaw);
                                      let prevGross = 0;
                                      if (employeeId && endDateObj) {
                                        const monthStartISO = new Date(endDateObj.getFullYear(), endDateObj.getMonth(), 1).toISOString().slice(0,10);
                                        const prevWindowEndISO = new Date(endDateObj.getFullYear(), endDateObj.getMonth(), 19).toISOString().slice(0,10);
                                        const params = new URLSearchParams({ employee_id: String(employeeId), start_date: monthStartISO, end_date: prevWindowEndISO });
                                        try {
                                          const resp = await axiosInstance.get(`/payroll/records?${params.toString()}`);
                                          let records = Array.isArray(resp.data) ? resp.data : [];
                                          // Deduplicate: keep only the latest record per (start_date, end_date) period
                                          const latestByPeriod = {};
                                          records.forEach(r => {
                                            const key = `${r.start_date}_${r.end_date}`;
                                            const existing = latestByPeriod[key];
                                            if (!existing || new Date(r.created_at || 0) > new Date(existing.created_at || 0)) {
                                              latestByPeriod[key] = r;
                                            }
                                          });
                                          records = Object.values(latestByPeriod);
                                          prevGross = records.reduce((sum, r) => sum + (parseFloat(r.gross_salary) || 0), 0);
                                        } catch { /* noop */ }
                                      }
                                      const monthlyGross = Math.max(0, prevGross + grossPay);
                                      sssDeduction = calculateSSSDeduction(monthlyGross || 0);
                                      
                                      setMonthlyGrossDetails({
                                        prevGross,
                                        currentGross: grossPay - additionalIncomeTotal,
                                        additionalIncome: additionalIncomeTotal,
                                        totalGross: monthlyGross,
                                        records: []
                                      });
                                    } catch { /* noop */ }
                                  }
                                  if (payslipDeductions.phic) {
                                    // PhilHealth = (monthly salary x 5%) / 2, deducted only on 15th (first half) payroll
                                    const isFirstHalf = isEndDateInFirstHalf(endDateStr);
                                    const monthlySalary = parseFloat(payrollEmployee?.salary) || 0;
                                    phicDeduction = isFirstHalf ? (monthlySalary * 0.05) / 2 : 0;
                                  }
                                  if (payslipDeductions.hdmf) {
                                    const isFirstHalf = isEndDateInFirstHalf(endDateStr);
                                    const extra = parseFloat(payrollEmployee?.deductions?.hdmf_additional) || 0;
                                    hdmfDeduction = isFirstHalf ? (200 + extra) : 0;
                                  }
                                  // MF payslip: apply straightforward deductions without monthly aggregation
                                  taxDeduction = 0;

                                  const updatedDeductions = { sss: sssDeduction, phic: phicDeduction, hdmf: hdmfDeduction, tax: taxDeduction, late: lateDeduction, undertime: undertimeDeduction };
                                  const totalDeductions = sssDeduction + phicDeduction + hdmfDeduction + taxDeduction;
                                  const netPay = grossPay - totalDeductions;

                                  setCalculatedMfPayslip({
                                    basicSalary: mfAmount,
                                    dailyRate,
                                    hourlyRate,
                                    allowances: { mf: mfAmount },
                                    deductions: updatedDeductions,
                                    grossPay,
                                    totalDeductions,
                                    netPay: Math.max(0, netPay)
                                  });
                                  if (!isRealtimeUpdate) toast.success('MF payslip built successfully');
                                  } catch (error) {
                                    console.error('MF payslip build error:', error);
                                    if (!isRealtimeUpdate) toast.error('Failed to build MF payslip');
                                  }
                                };

                                  useEffect(() => {
                                    if (isEditingPayslipRecord) return;
                                    if (mfAttendanceFilters.name && mfAttendanceFilters.start_date && mfAttendanceFilters.end_date && generateTableTab === 'mf') {
                                      fetchAndCalculatePayslipMf(true);
                                    }
                                  }, [mfAttendanceFilters, additionalIncome, mfAttendanceAnalytics, isEditingPayslipRecord]);

                                const findGeneratedPayslipRow = (tab, employeeId, startDate, endDate) => {
                                  const list = generatedPayslips?.[tab] || [];
                                  const normalizeEmployeeId = (v) => {
                                    const raw = String(v ?? '').trim();
                                    if (!raw) return '';
                                    if (/^\d+$/.test(raw)) return raw.replace(/^0+(?=\d)/, '');
                                    return raw;
                                  };
                                  const id = normalizeEmployeeId(employeeId);
                                  if (!id) return null;
                                  const vr = validateDateRangeTaipei(startDate, endDate);
                                  const startISO = vr.ok ? vr.startISO : String(startDate || '').trim();
                                  const endISO = vr.ok ? vr.endISO : String(endDate || '').trim();
                                  const normalizeISO = (d) => {
                                    const r = validateDateRangeTaipei(d, d);
                                    if (r.ok) return r.startISO;
                                    return String(d || '').trim();
                                  };
                                  const exact = list.find((r) => (
                                    normalizeEmployeeId(r?.employee_id) === id &&
                                    normalizeISO(r?.start_date) === startISO &&
                                    normalizeISO(r?.end_date) === endISO
                                  ));
                                  return exact || null;
                                };

                                const getGeneratedPayslipRowForSelection = (tab, employeeId, startDate, endDate) => {
                                  const normalizeEmployeeId = (v) => {
                                    const raw = String(v ?? '').trim();
                                    if (!raw) return '';
                                    if (/^\d+$/.test(raw)) return raw.replace(/^0+(?=\d)/, '');
                                    return raw;
                                  };
                                  const id = normalizeEmployeeId(employeeId);
                                  if (!id) return null;
                                  const vr = validateDateRangeTaipei(startDate, endDate);
                                  const startISO = vr.ok ? vr.startISO : String(startDate || '').trim();
                                  const endISO = vr.ok ? vr.endISO : String(endDate || '').trim();
                                  const normalizeISO = (d) => {
                                    const r = validateDateRangeTaipei(d, d);
                                    if (r.ok) return r.startISO;
                                    return String(d || '').trim();
                                  };
                                  const latestMatch = findGeneratedPayslipRow(tab, employeeId, startDate, endDate);
                                  if (latestMatch) return latestMatch;
                                  const selected = selectedGeneratedPayslipRow;
                                  if (selected && normalizeEmployeeId(selected?.employee_id) === id && normalizeISO(selected?.start_date) === startISO && normalizeISO(selected?.end_date) === endISO) {
                                    return selected;
                                  }
                                  return null;
                                };

                                const toPayslipNumber = (value) => {
                                  if (value === null || value === undefined) return 0;
                                  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
                                  const raw = String(value).replace(/,/g, '').trim();
                                  const parsed = parseFloat(raw);
                                  return Number.isFinite(parsed) ? parsed : 0;
                                };

                                const __computeItemAmount = (item, dailyRate, minuteRate) => {
                                  const unit = item?.unit || 'minutes';
                                  if (unit === 'amount') return toPayslipNumber(item?.amount);
                                  if (unit === 'days') return toPayslipNumber(item?.days) * dailyRate;
                                  return minuteRate * toPayslipNumber(item?.minutes);
                                };

                                // Produces EXACTLY the same numbers shown to the user in the 3-card
                                // "Payslip Calculation Summary" (PayslipSummaryCard.js lines 29-66).
                                // Saves MUST use this so persisted values match what the user approved.
                                const computeExactPayrollSummaryNumbers = ({
                                  calculatedPayslip,
                                  attendanceDaysAbsent,
                                  attendanceMinutesLate,
                                  attendanceMinutesUndertime,
                                  payslipDeductions,
                                  additionalIncome,
                                  additionalDeductions,
                                  loanDeductionTotal,
                                  otHours,
                                  holidayHours,
                                  isInactiveException
                                }) => {
                                  const dailyRate = toPayslipNumber(calculatedPayslip?.dailyRate);
                                  const minuteRate = dailyRate > 0 ? dailyRate / 8 / 60 : 0;
                                  const otAmount = (dailyRate / 8) * 1.25 * toPayslipNumber(otHours);
                                  const holidayAmount = (dailyRate / 8) * 1.3 * toPayslipNumber(holidayHours);

                                  const absenceDays = !!isInactiveException ? 0 : toPayslipNumber(attendanceDaysAbsent);
                                  const lateMinutes = !!isInactiveException ? 0 : toPayslipNumber(attendanceMinutesLate);
                                  const undertimeMinutes = !!isInactiveException ? 0 : toPayslipNumber(attendanceMinutesUndertime);

                                  const halfMonthSalary = toPayslipNumber(calculatedPayslip?.basicSalary) / 2;
                                  const base = halfMonthSalary;
                                  const absenceDeduction = absenceDays * dailyRate;
                                  const tardinessDeduction = lateMinutes * minuteRate;
                                  const undertimeDeduction = undertimeMinutes * minuteRate;
                                  const basicComputed = !!isInactiveException
                                    ? base
                                    : (base - absenceDeduction - tardinessDeduction - undertimeDeduction);

                                  const additionalIncomeWithAmounts = (additionalIncome || []).map(inc => ({
                                    ...inc,
                                    amount: __computeItemAmount(inc, dailyRate, minuteRate)
                                  }));
                                  const additionalDeductionsWithAmounts = (additionalDeductions || []).map(ded => ({
                                    ...ded,
                                    amount: __computeItemAmount(ded, dailyRate, minuteRate)
                                  }));
                                  const additionalIncomeTotal = additionalIncomeWithAmounts.reduce((s, x) => s + toPayslipNumber(x?.amount), 0);
                                  const additionalDeductionsTotal = additionalDeductionsWithAmounts.reduce((s, x) => s + toPayslipNumber(x?.amount), 0);

                                  const grossSalary = basicComputed + additionalIncomeTotal;

                                  const sssContribution = payslipDeductions?.sss ? toPayslipNumber(calculatedPayslip?.deductions?.sss) : 0;
                                  const hdmfContribution = payslipDeductions?.hdmf ? toPayslipNumber(calculatedPayslip?.deductions?.hdmf) : 0;
                                  const philhealthContribution = payslipDeductions?.phic ? toPayslipNumber(calculatedPayslip?.deductions?.phic) : 0;
                                  const withholdingTax = payslipDeductions?.tax ? toPayslipNumber(calculatedPayslip?.deductions?.tax) : 0;
                                  const totalGovDeductions = sssContribution + hdmfContribution + philhealthContribution + withholdingTax;
                                  const totalDeductions = totalGovDeductions + additionalDeductionsTotal;

                                  const loanDeduction = toPayslipNumber(loanDeductionTotal);
                                  const netPay = Math.max(0, grossSalary + otAmount + holidayAmount - totalDeductions - (loanDeduction > 0 ? loanDeduction : 0));

                                  return {
                                    halfMonthSalary, dailyRate, minuteRate,
                                    otAmount, holidayAmount,
                                    otHours: toPayslipNumber(otHours),
                                    holidayHours: toPayslipNumber(holidayHours),
                                    absenceDays, lateMinutes, undertimeMinutes,
                                    absenceDeduction, tardinessDeduction, undertimeDeduction,
                                    basicComputed,
                                    additionalIncomeWithAmounts, additionalDeductionsWithAmounts,
                                    additionalIncomeTotal, additionalDeductionsTotal,
                                    grossSalary,
                                    sssContribution, hdmfContribution, philhealthContribution, withholdingTax,
                                    totalGovDeductions, totalDeductions,
                                    loanDeduction, netPay
                                  };
                                };

                                // Produces EXACTLY the same numbers shown to the user in the 2-card
                                // "MF Payslip Calculation Summary" (MfPayslipSummaryCard.js lines 21-68 +
                                // computeMfDisplay semantics).
                                // PayslipDeductions toggle semantics (same as Payroll helper):
                                //   { sss: true/false, hdmf: true/false, phic: true/false, tax: true/false }
                                // When payslipDeductions is provided, each individual toggle is honored
                                // (matching the UI checkbox state the user saw pre-save). When it is not
                                // provided (e.g. batch builder with pre-zeroed pseudo.deductions values),
                                // a truthy amount check acts as a conservative fallback.
                                const computeExactMfSummaryNumbers = ({
                                  payrollEmployeeData,
                                  calculatedMfPayslip,
                                  attendanceDaysAbsent,
                                  attendanceMinutesLate,
                                  attendanceMinutesUndertime,
                                  additionalIncome,
                                  additionalDeductions,
                                  loanDeductionTotal,
                                  payslipDeductions
                                }) => {
                                  const dailyRate = toPayslipNumber(calculatedMfPayslip?.dailyRate);
                                  const minuteRate = dailyRate > 0 ? dailyRate / 8 / 60 : 0;

                                  const absenceDays = toPayslipNumber(attendanceDaysAbsent);
                                  const lateMinutes = toPayslipNumber(attendanceMinutesLate);
                                  const undertimeMinutes = toPayslipNumber(attendanceMinutesUndertime);

                                  const mf = toPayslipNumber(payrollEmployeeData?.allowances?.mf);
                                  const gas = toPayslipNumber(payrollEmployeeData?.allowances?.gas_allowance);
                                  const load = toPayslipNumber(payrollEmployeeData?.allowances?.load_allowance);
                                  const housing = toPayslipNumber(payrollEmployeeData?.allowances?.housing_allowance);
                                  const mfAmount = mf + gas + load + housing;

                                  const absenceDeduction = absenceDays * dailyRate;
                                  const tardinessDeduction = lateMinutes * minuteRate;
                                  const undertimeDeduction = undertimeMinutes * minuteRate;
                                  const basicComputed = mfAmount - absenceDeduction - tardinessDeduction - undertimeDeduction;

                                  const additionalIncomeWithAmounts = (additionalIncome || []).map(inc => ({
                                    ...inc,
                                    amount: __computeItemAmount(inc, dailyRate, minuteRate)
                                  }));
                                  const additionalDeductionsWithAmounts = (additionalDeductions || []).map(ded => ({
                                    ...ded,
                                    amount: __computeItemAmount(ded, dailyRate, minuteRate)
                                  }));
                                  const additionalIncomeTotal = additionalIncomeWithAmounts.reduce((s, x) => s + toPayslipNumber(x?.amount), 0);
                                  const additionalDeductionsTotal = additionalDeductionsWithAmounts.reduce((s, x) => s + toPayslipNumber(x?.amount), 0);

                                  const grossSalary = basicComputed + additionalIncomeTotal;

                                  const hasExplicitToggles = !!(payslipDeductions && typeof payslipDeductions === 'object');
                                  const sssContribution = hasExplicitToggles
                                    ? (payslipDeductions.sss ? toPayslipNumber(calculatedMfPayslip?.deductions?.sss) : 0)
                                    : (calculatedMfPayslip?.deductions?.sss ? toPayslipNumber(calculatedMfPayslip.deductions.sss) : 0);
                                  const hdmfContribution = hasExplicitToggles
                                    ? (payslipDeductions.hdmf ? toPayslipNumber(calculatedMfPayslip?.deductions?.hdmf) : 0)
                                    : (calculatedMfPayslip?.deductions?.hdmf ? toPayslipNumber(calculatedMfPayslip.deductions.hdmf) : 0);
                                  const philhealthContribution = hasExplicitToggles
                                    ? (payslipDeductions.phic ? toPayslipNumber(calculatedMfPayslip?.deductions?.phic) : 0)
                                    : (calculatedMfPayslip?.deductions?.phic ? toPayslipNumber(calculatedMfPayslip.deductions.phic) : 0);
                                  const withholdingTax = hasExplicitToggles
                                    ? (payslipDeductions.tax ? toPayslipNumber(calculatedMfPayslip?.deductions?.tax) : 0)
                                    : (calculatedMfPayslip?.deductions?.tax ? toPayslipNumber(calculatedMfPayslip.deductions.tax) : 0);
                                  const totalGovDeductions = sssContribution + hdmfContribution + philhealthContribution + withholdingTax;
                                  const totalDeductions = totalGovDeductions + additionalDeductionsTotal;

                                  const loanDeduction = toPayslipNumber(loanDeductionTotal);
                                  const netPay = Math.max(0, grossSalary - totalDeductions - loanDeduction);

                                  return {
                                    mfAmount, dailyRate, minuteRate,
                                    absenceDays, lateMinutes, undertimeMinutes,
                                    absenceDeduction, tardinessDeduction, undertimeDeduction,
                                    basicComputed,
                                    additionalIncomeWithAmounts, additionalDeductionsWithAmounts,
                                    additionalIncomeTotal, additionalDeductionsTotal,
                                    grossSalary,
                                    sssContribution, hdmfContribution, philhealthContribution, withholdingTax,
                                    totalGovDeductions, totalDeductions,
                                    loanDeduction, netPay
                                  };
                                };

                                const buildCurrentMfPayrollRecordPayload = ({ generatedRow, scope = {} } = {}) => {
                                  // ================================================================
                                  // SCOPING LAYER: mirrors Payroll builder. Batch Save All passes
                                  // per-row scope to avoid singleton state leakage.
                                  // ================================================================
                                  const defaultScope = {
                                    mfSelectedPayslipEmployee,
                                    payrollEmployeeData,
                                    calculatedMfPayslip,
                                    mfPayslipDeductions: { ...(mfPayslipDeductions || {}) },
                                    additionalIncome: (additionalIncome || []).slice(),
                                    additionalDeductions: (additionalDeductions || []).slice(),
                                    rawAttendanceData: rawMfAttendanceData || [],
                                    _loanCycles: null,
                                    _loanDeductionTotal: null
                                  };
                                  const s = { ...defaultScope, ...scope };
                                  const scopedLoanCycles = s._loanCycles;
                                  const scopedLoanDeductionTotal = s._loanDeductionTotal;

                                  const resolvedMfSelectedPayslipEmployee = generatedRow
                                    ? (findHrisEmployeeForGeneratedRow(generatedRow) || s.mfSelectedPayslipEmployee)
                                    : s.mfSelectedPayslipEmployee;
                                  const resolvedPayrollEmployeeData = generatedRow
                                    ? (findPayrollEmployeeForGeneratedRow(generatedRow) || s.payrollEmployeeData)
                                    : s.payrollEmployeeData;

                                  if (!resolvedMfSelectedPayslipEmployee || !resolvedPayrollEmployeeData) {
                                    return { error: 'Please apply MF filters and select an employee first' };
                                  }
                                  if (!payrollPeriod) {
                                    return { error: 'Please enter a payroll period first' };
                                  }
                                  if (!s.calculatedMfPayslip || !s.calculatedMfPayslip.deductions) {
                                    return { error: 'MF Payslip calculation not ready. Please wait and try again.' };
                                  }

                                  const safeFloat = toPayslipNumber;
                                  const selectedSummaryEmployeeId = String(selectedGeneratedPayslipEmployeeId || '').trim();
                                  const genRow = generatedRow || getGeneratedPayslipRowForSelection(
                                    'mf',
                                    selectedSummaryEmployeeId || resolvedMfSelectedPayslipEmployee.employee_id || resolvedMfSelectedPayslipEmployee.id,
                                    mfAttendanceFilters.start_date,
                                    mfAttendanceFilters.end_date
                                  );
                                  if (!genRow) {
                                    return { error: 'Please generate payslip first for this employee and date range' };
                                  }

                                  const normalizedEmployeeId = (() => {
                                    const raw = String(genRow?.employee_id ?? '').trim();
                                    if (!raw) return '';
                                    if (/^\d+$/.test(raw)) return raw.replace(/^0+(?=\d)/, '');
                                    return raw;
                                  })();
                                  const rowRange = validateDateRangeTaipei(genRow?.start_date, genRow?.end_date);
                                  if (!rowRange.ok) {
                                    return { error: 'Invalid generated payslip date range' };
                                  }

                                  const attRecompute = computeRawPresenceAbsenceForEmployee({
                                    tab: 'mf',
                                    employeeId: normalizedEmployeeId || (resolvedMfSelectedPayslipEmployee.employee_id || resolvedMfSelectedPayslipEmployee.id || ''),
                                    startISO: rowRange.startISO,
                                    endISO: rowRange.endISO,
                                    rawAttendance: s.rawAttendanceData,
                                    peList: payrollEmployees || []
                                  });
                                  const attendanceDaysAbsent = attRecompute?.days_absent != null
                                    ? safeFloat(attRecompute.days_absent)
                                    : safeFloat(genRow.days_absent);
                                  const attendanceDaysPresent = attRecompute?.days_present != null
                                    ? safeFloat(attRecompute.days_present)
                                    : safeFloat(genRow.days_present);
                                  const attendanceHalfDays = attRecompute?.half_days_present != null
                                    ? safeFloat(attRecompute.half_days_present)
                                    : safeFloat(genRow.half_days_present);
                                  const attendanceMinutesLate = safeFloat(genRow.minutes_late);
                                  const attendanceMinutesUndertime = safeFloat(genRow.minutes_undertime);
                                  const workingDaysCount = safeFloat(attRecompute?.working_days || 0);

                                  let loanCycles = scopedLoanCycles;
                                  let loanDeductionTotal = scopedLoanDeductionTotal;
                                  if (loanCycles == null) {
                                    const built = buildSelectedMfLoanEntries({
                                      record: { start_date: rowRange.startISO, end_date: rowRange.endISO }
                                    });
                                    loanCycles = built.loanCycles;
                                    loanDeductionTotal = built.loanDeductionTotal;
                                  }

                                  const exact = computeExactMfSummaryNumbers({
                                    payrollEmployeeData: resolvedPayrollEmployeeData,
                                    calculatedMfPayslip: s.calculatedMfPayslip,
                                    attendanceDaysAbsent,
                                    attendanceMinutesLate,
                                    attendanceMinutesUndertime,
                                    additionalIncome: s.additionalIncome || [],
                                    additionalDeductions: (s.additionalDeductions || []).filter(ded => ded?.is_loan_deduction !== true),
                                    loanDeductionTotal,
                                    payslipDeductions: s.mfPayslipDeductions
                                  });

                                  const mfAmount = exact.mfAmount;
                                  const dailyRateValue = exact.dailyRate;
                                  const minuteRate = exact.minuteRate;
                                  const absenceDeduction = exact.absenceDeduction;
                                  const lateDeduction = exact.tardinessDeduction;
                                  const undertimeDeduction = exact.undertimeDeduction;
                                  const basicSalary = exact.basicComputed;
                                  const additionalIncomeWithAmounts = exact.additionalIncomeWithAmounts;
                                  const additionalIncomeTotal = exact.additionalIncomeTotal;
                                  const additionalDeductionsWithAmounts = exact.additionalDeductionsWithAmounts;
                                  const additionalDeductionsTotal = exact.additionalDeductionsTotal;
                                  const grossSalary = exact.grossSalary;
                                  const sssContribution = exact.sssContribution;
                                  const hdmfContribution = exact.hdmfContribution;
                                  const philhealthContribution = exact.philhealthContribution;
                                  const withholdingTax = exact.withholdingTax;
                                  const totalDeductions = exact.totalDeductions;
                                  const netPay = exact.netPay;

                                  const mfLoanBreakdown = aggregateLoansBySubtype(loanCycles);
                                  const rowHolidays = Array.isArray(genRow?.holidays) ? genRow.holidays : [];
                                  const mfTilesSnapshot = buildTilesSnapshot({
                                    holidaysArr: rowHolidays,
                                    halfMonthSalary: mfAmount,
                                    absenceDeduction,
                                    tardinessDeduction: lateDeduction,
                                    undertimeDeduction,
                                    grossSalary,
                                    sss: sssContribution,
                                    hdmf: hdmfContribution,
                                    philhealth: philhealthContribution,
                                    withholdingTax,
                                    totalDeductions,
                                    netPay,
                                    loanBreakdown: mfLoanBreakdown
                                  });

                                  return {
                                    payload: {
                                      employee_id: normalizedEmployeeId || (resolvedMfSelectedPayslipEmployee.employee_id || resolvedMfSelectedPayslipEmployee.id || ''),
                                      employee_name: resolvedMfSelectedPayslipEmployee.full_name || '',
                                      employee_email: resolvedMfSelectedPayslipEmployee.email || '',
                                      branch: resolvedMfSelectedPayslipEmployee.branch || 'N/A',
                                      tin_number: resolvedMfSelectedPayslipEmployee.tin_number || '',
                                      sss_number: resolvedMfSelectedPayslipEmployee.sss_number || '',
                                      phic_number: resolvedMfSelectedPayslipEmployee.phic_number || '',
                                      hdmf_number: resolvedMfSelectedPayslipEmployee.hdmf_number || '',
                                      payroll_period: (String(payrollPeriod || '').trim() || genRow?.payroll_period || ''),
                                      start_date: rowRange.startISO,
                                      end_date: rowRange.endISO,
                                      half_month_salary: 0,
                                      daily_rate: dailyRateValue || 0,
                                      hourly_rate: safeFloat(genRow.hourly_rate) || safeFloat(s.calculatedMfPayslip.hourlyRate) || (dailyRateValue > 0 ? dailyRateValue / 8 : 0),
                                      working_days: workingDaysCount || 0,
                                      days_present: attendanceDaysPresent || 0,
                                      days_absent: exact.absenceDays || 0,
                                      half_days_present: attendanceHalfDays || 0,
                                      absence_deduction: absenceDeduction || 0,
                                      minutes_late: exact.lateMinutes || 0,
                                      tardiness_deduction: lateDeduction || 0,
                                      minutes_undertime: exact.undertimeMinutes || 0,
                                      undertime_deduction: undertimeDeduction || 0,
                                      basic_salary: basicSalary || 0,
                                      overtime_pay: [],
                                      ot_hours: 0,
                                      ot_pay_amount: 0,
                                      holiday_hours: 0,
                                      holiday_pay_amount: 0,
                                      holidays_count: safeFloat(genRow.holidays_count) || rowHolidays.length,
                                      holidays: rowHolidays,
                                      additional_income: additionalIncomeWithAmounts || [],
                                      gross_salary: grossSalary || 0,
                                      sss_contribution: sssContribution || 0,
                                      hdmf_contribution: hdmfContribution || 0,
                                      philhealth_contribution: philhealthContribution || 0,
                                      withholding_tax: withholdingTax || 0,
                                      additional_deductions: additionalDeductionsWithAmounts || [],
                                      total_deductions: totalDeductions || 0,
                                      net_pay: netPay || 0,
                                      loan_breakdown: mfLoanBreakdown,
                                      tiles: mfTilesSnapshot,
                                      deduction_settings: {
                                        ...s.mfPayslipDeductions,
                                        mf_record: true,
                                        loan_cycles: loanCycles,
                                        loan_breakdown: mfLoanBreakdown,
                                        breakdown: {
                                          income: {
                                            half_month_salary: mfAmount || 0,
                                            items: additionalIncomeWithAmounts || [],
                                            total: additionalIncomeTotal || 0
                                          },
                                          deductions: {
                                            absence: absenceDeduction || 0,
                                            tardiness: lateDeduction || 0,
                                            undertime: undertimeDeduction || 0,
                                            sss: sssContribution || 0,
                                            phic: philhealthContribution || 0,
                                            hdmf: hdmfContribution || 0,
                                            tax: withholdingTax || 0,
                                            items: additionalDeductionsWithAmounts || [],
                                            total: additionalDeductionsTotal || 0
                                          },
                                          summary: {
                                            daily_rate: dailyRateValue || 0,
                                            hourly_rate: safeFloat(s.calculatedMfPayslip.hourlyRate) || (dailyRateValue > 0 ? dailyRateValue / 8 : 0),
                                            basic_salary: basicSalary || 0,
                                            gross_salary: grossSalary || 0,
                                            total_deductions: totalDeductions || 0,
                                            net_pay: netPay || 0
                                          },
                                          net_pay_breakdown: {
                                            gross_salary: grossSalary || 0,
                                            total_deductions: totalDeductions || 0,
                                            loan_breakdown: mfLoanBreakdown,
                                            net_pay: netPay || 0
                                          }
                                        }
                                      }
                                    }
                                  };
                                };

                                const buildCurrentPayrollRecordPayload = ({ generatedRow, scope = {} } = {}) => {
                                  // ================================================================
                                  // SCOPING LAYER: when `scope` is provided (e.g. by Save All
                                  // batch for each row) it overrides the global singleton UI state
                                  // with per-row values. This guarantees the same code path is used
                                  // for both individual Save (no scope -> fall back to global) and
                                  // Save All batch (per-row scope)  zero code drift, byte-identical
                                  // results for the same (employee, data) pair.
                                  // ================================================================
                                  const defaultScope = {
                                    selectedPayslipEmployee,
                                    payrollEmployeeData,
                                    calculatedPayslip,
                                    payslipDeductions: { ...(payslipDeductions || {}) },
                                    otHours,
                                    holidayHours,
                                    additionalIncome: (additionalIncome || []).slice(),
                                    additionalDeductions: (additionalDeductions || []).slice(),
                                    overtimePay: (overtimePay || []).slice(),
                                    rawAttendanceData: rawPayrollAttendanceData || [],
                                    // Loan cycles: for individual Save, keep as lazy function
                                    // (reads singleton payroll loan cycles via builder); for batch
                                    // scope, caller MUST pass pre-built loanCycles/loanDeductionTotal
                                    _loanCycles: null,
                                    _loanDeductionTotal: null
                                  };
                                  const s = { ...defaultScope, ...scope };
                                  const scopedLoanCycles = s._loanCycles;
                                  const scopedLoanDeductionTotal = s._loanDeductionTotal;

                                  const resolvedSelectedPayslipEmployee = generatedRow
                                    ? (findHrisEmployeeForGeneratedRow(generatedRow) || s.selectedPayslipEmployee)
                                    : s.selectedPayslipEmployee;
                                  const resolvedPayrollEmployeeData = generatedRow
                                    ? (findPayrollEmployeeForGeneratedRow(generatedRow) || s.payrollEmployeeData)
                                    : s.payrollEmployeeData;

                                  if (!resolvedSelectedPayslipEmployee || !resolvedPayrollEmployeeData) {
                                    return { error: 'Please apply filters and select an employee first' };
                                  }
                                  if (!payrollPeriod) {
                                    return { error: 'Please enter a payroll period first' };
                                  }
                                  if (!s.calculatedPayslip || !s.calculatedPayslip.basicSalary) {
                                    return { error: 'Payslip calculation not ready. Please wait and try again.' };
                                  }

                                  const safeFloat = toPayslipNumber;
                                  const genRow = generatedRow || getGeneratedPayslipRowForSelection(
                                    'payroll',
                                    resolvedSelectedPayslipEmployee.id || resolvedSelectedPayslipEmployee.employee_id,
                                    payrollAttendanceFilters.start_date,
                                    payrollAttendanceFilters.end_date
                                  );
                                  if (!genRow) {
                                    return { error: 'Please generate payslip first for this employee and date range' };
                                  }

                                  const normalizedEmployeeId = (() => {
                                    const raw = String(genRow?.employee_id ?? '').trim();
                                    if (!raw) return '';
                                    if (/^\d+$/.test(raw)) return raw.replace(/^0+(?=\d)/, '');
                                    return raw;
                                  })();
                                  const rowRange = validateDateRangeTaipei(genRow?.start_date, genRow?.end_date);
                                  if (!rowRange.ok) {
                                    return { error: 'Invalid generated payslip date range' };
                                  }

                                  const attRecompute = computeRawPresenceAbsenceForEmployee({
                                    tab: 'payroll',
                                    employeeId: normalizedEmployeeId || (resolvedSelectedPayslipEmployee.employee_id || resolvedSelectedPayslipEmployee.id || ''),
                                    startISO: rowRange.startISO,
                                    endISO: rowRange.endISO,
                                    rawAttendance: s.rawAttendanceData,
                                    peList: payrollEmployees || []
                                  });
                                  const attendanceDaysAbsent = attRecompute?.days_absent != null
                                    ? safeFloat(attRecompute.days_absent)
                                    : safeFloat(genRow.days_absent);
                                  const attendanceDaysPresent = attRecompute?.days_present != null
                                    ? safeFloat(attRecompute.days_present)
                                    : safeFloat(genRow.days_present);
                                  const attendanceHalfDays = attRecompute?.half_days_present != null
                                    ? safeFloat(attRecompute.half_days_present)
                                    : safeFloat(genRow.half_days_present);
                                  const attendanceMinutesLate = safeFloat(genRow.minutes_late);
                                  const attendanceMinutesUndertime = safeFloat(genRow.minutes_undertime);
                                  const workingDaysCount = safeFloat(attRecompute?.working_days || 0);
                                  const isInactiveException = isInactivePayslipExceptionEmail(
                                    resolvedSelectedPayslipEmployee?.email || resolvedPayrollEmployeeData?.email || s.calculatedPayslip?.employeeEmail || ''
                                  );

                                  const dailyRateRaw = safeFloat(s.calculatedPayslip?.dailyRate);
                                  const minuteRateRaw = dailyRateRaw > 0 ? dailyRateRaw / 8 / 60 : 0;
                                  const overtimePayWithAmounts = (s.overtimePay || []).map(item => {
                                    const unit = item.unit || 'minutes';
                                    let minutes = 0;
                                    let amount = 0;
                                    if (unit === 'amount') {
                                      amount = safeFloat(item.amount);
                                      minutes = minuteRateRaw > 0 ? amount / minuteRateRaw : 0;
                                    } else if (unit === 'days') {
                                      const days = safeFloat(item.days);
                                      minutes = days * 8 * 60;
                                      amount = days * dailyRateRaw;
                                    } else {
                                      minutes = safeFloat(item.minutes);
                                      amount = minuteRateRaw * minutes;
                                    }
                                    return { ...item, minutes, amount };
                                  });

                                  // Loans: per-row scope passes pre-built loans (from
                                  // getApplicableLoansForRecord called per-row in batch); individual
                                  // Save uses global singleton builder as before.
                                  let loanCycles = scopedLoanCycles;
                                  let loanDeductionTotal = scopedLoanDeductionTotal;
                                  if (loanCycles == null) {
                                    const built = buildSelectedPayrollLoanEntries({
                                      record: { start_date: rowRange.startISO, end_date: rowRange.endISO }
                                    });
                                    loanCycles = built.loanCycles;
                                    loanDeductionTotal = built.loanDeductionTotal;
                                  }

                                  const exact = computeExactPayrollSummaryNumbers({
                                    calculatedPayslip: s.calculatedPayslip,
                                    attendanceDaysAbsent,
                                    attendanceMinutesLate,
                                    attendanceMinutesUndertime,
                                    payslipDeductions: s.payslipDeductions,
                                    additionalIncome: s.additionalIncome || [],
                                    additionalDeductions: (s.additionalDeductions || []).filter(ded => ded?.is_loan_deduction !== true),
                                    loanDeductionTotal,
                                    otHours: s.otHours,
                                    holidayHours: s.holidayHours,
                                    isInactiveException
                                  });

                                  const halfMonthSalary = exact.halfMonthSalary;
                                  const dailyRateValue = exact.dailyRate;
                                  const minuteRate = exact.minuteRate;
                                  const absenceDeduction = exact.absenceDeduction;
                                  const lateDeduction = exact.tardinessDeduction;
                                  const undertimeDeduction = exact.undertimeDeduction;
                                  const basicSalary = exact.basicComputed;
                                  const otPayAmount = exact.otAmount;
                                  const holidayPayAmount = exact.holidayAmount;
                                  const additionalIncomeWithAmounts = exact.additionalIncomeWithAmounts;
                                  const additionalIncomeTotal = exact.additionalIncomeTotal;
                                  const additionalDeductionsWithAmounts = exact.additionalDeductionsWithAmounts;
                                  const additionalDeductionsTotal = exact.additionalDeductionsTotal;
                                  const grossSalary = exact.grossSalary;
                                  const sssContribution = exact.sssContribution;
                                  const hdmfContribution = exact.hdmfContribution;
                                  const philhealthContribution = exact.philhealthContribution;
                                  const withholdingTax = exact.withholdingTax;
                                  const totalDeductions = exact.totalDeductions;
                                  const netPay = exact.netPay;

                                  const payrollLoanBreakdown = aggregateLoansBySubtype(loanCycles);
                                  const rowHolidays = Array.isArray(genRow?.holidays) ? genRow.holidays : [];
                                  const payrollTilesSnapshot = buildTilesSnapshot({
                                    holidaysArr: rowHolidays,
                                    halfMonthSalary,
                                    absenceDeduction,
                                    tardinessDeduction: lateDeduction,
                                    undertimeDeduction,
                                    grossSalary,
                                    sss: sssContribution,
                                    hdmf: hdmfContribution,
                                    philhealth: philhealthContribution,
                                    withholdingTax,
                                    totalDeductions,
                                    netPay,
                                    loanBreakdown: payrollLoanBreakdown
                                  });

                                  return {
                                    payload: {
                                      employee_id: normalizedEmployeeId || (resolvedSelectedPayslipEmployee.employee_id || resolvedSelectedPayslipEmployee.id || ''),
                                      employee_name: resolvedSelectedPayslipEmployee.full_name || '',
                                      employee_email: resolvedSelectedPayslipEmployee.email || '',
                                      branch: resolvedSelectedPayslipEmployee.branch || 'N/A',
                                      tin_number: resolvedSelectedPayslipEmployee.tin_number || '',
                                      sss_number: resolvedSelectedPayslipEmployee.sss_number || '',
                                      phic_number: resolvedSelectedPayslipEmployee.phic_number || '',
                                      hdmf_number: resolvedSelectedPayslipEmployee.hdmf_number || '',
                                      payroll_period: (String(payrollPeriod || '').trim() || genRow?.payroll_period || ''),
                                      start_date: rowRange.startISO,
                                      end_date: rowRange.endISO,
                                      half_month_salary: halfMonthSalary || 0,
                                      daily_rate: dailyRateValue || 0,
                                      hourly_rate: safeFloat(genRow.hourly_rate) || safeFloat(s.calculatedPayslip.hourlyRate) || (dailyRateValue > 0 ? dailyRateValue / 8 : 0),
                                      working_days: workingDaysCount || 0,
                                      days_present: attendanceDaysPresent || 0,
                                      days_absent: exact.absenceDays || 0,
                                      half_days_present: attendanceHalfDays || 0,
                                      absence_deduction: absenceDeduction || 0,
                                      minutes_late: exact.lateMinutes || 0,
                                      tardiness_deduction: lateDeduction || 0,
                                      minutes_undertime: exact.undertimeMinutes || 0,
                                      undertime_deduction: undertimeDeduction || 0,
                                      basic_salary: basicSalary || 0,
                                      overtime_pay: overtimePayWithAmounts || [],
                                      ot_hours: exact.otHours,
                                      ot_pay_amount: otPayAmount || 0,
                                      holiday_hours: exact.holidayHours,
                                      holiday_pay_amount: holidayPayAmount || 0,
                                      holidays_count: safeFloat(genRow.holidays_count) || rowHolidays.length,
                                      holidays: rowHolidays,
                                      additional_income: additionalIncomeWithAmounts || [],
                                      gross_salary: grossSalary || 0,
                                      sss_contribution: sssContribution || 0,
                                      hdmf_contribution: hdmfContribution || 0,
                                      philhealth_contribution: philhealthContribution || 0,
                                      withholding_tax: withholdingTax || 0,
                                      additional_deductions: additionalDeductionsWithAmounts || [],
                                      total_deductions: totalDeductions || 0,
                                      net_pay: netPay || 0,
                                      loan_breakdown: payrollLoanBreakdown,
                                      tiles: payrollTilesSnapshot,
                                      deduction_settings: {
                                        ...s.payslipDeductions,
                                        loan_cycles: loanCycles,
                                        loan_breakdown: payrollLoanBreakdown,
                                        breakdown: {
                                          income: {
                                            half_month_salary: halfMonthSalary || 0,
                                            ot_pay: otPayAmount || 0,
                                            holiday_pay: holidayPayAmount || 0,
                                            items: additionalIncomeWithAmounts || [],
                                            total: additionalIncomeTotal || 0
                                          },
                                          deductions: {
                                            absence: absenceDeduction || 0,
                                            tardiness: lateDeduction || 0,
                                            undertime: undertimeDeduction || 0,
                                            sss: sssContribution || 0,
                                            phic: philhealthContribution || 0,
                                            hdmf: hdmfContribution || 0,
                                            tax: withholdingTax || 0,
                                            items: additionalDeductionsWithAmounts || [],
                                            total: additionalDeductionsTotal || 0
                                          },
                                          summary: {
                                            daily_rate: dailyRateValue || 0,
                                            hourly_rate: safeFloat(calculatedPayslip.hourlyRate) || (dailyRateValue > 0 ? dailyRateValue / 8 : 0),
                                            basic_salary: basicSalary || 0,
                                            gross_salary: grossSalary || 0,
                                            total_deductions: totalDeductions || 0,
                                            net_pay: netPay || 0
                                          },
                                          net_pay_breakdown: {
                                            gross_salary: grossSalary || 0,
                                            total_deductions: totalDeductions || 0,
                                            loan_breakdown: payrollLoanBreakdown,
                                            net_pay: netPay || 0
                                          }
                                        }
                                      }
                                    }
                                  };
                                };

                                const checkExistingPayrollRecord = async ({ employeeId, startDate, endDate, source }) => {
                                  const response = await axiosInstance.get('/payroll/records/existing', {
                                    params: {
                                      employee_id: employeeId,
                                      start_date: startDate,
                                      end_date: endDate,
                                      source
                                    }
                                  });
                                  return response?.data || { exists: false };
                                };

                                const saveGeneratedSummaryPayslip = async () => {
                                  const source = generateTableTab === 'mf' ? 'mf' : 'payroll';
                                  const activeFilters = source === 'mf' ? mfAttendanceFilters : payrollAttendanceFilters;
                                  const summaryRow = getGeneratedPayslipRowForSelection(
                                    source,
                                    selectedGeneratedPayslipEmployeeId,
                                    activeFilters?.start_date,
                                    activeFilters?.end_date
                                  );
                                  if (!summaryRow) {
                                    toast.error('Please generate payslip first for this employee and date range');
                                    return false;
                                  }
                                  if (!isGeneratedPayslipRowActive(summaryRow)) {
                                    toast.error('Cannot save payslip for an inactive employee');
                                    return false;
                                  }

                                  const { payload, error: payloadError } = source === 'mf'
                                    ? buildCurrentMfPayrollRecordPayload({ generatedRow: summaryRow })
                                    : buildCurrentPayrollRecordPayload({ generatedRow: summaryRow });
                                  if (payloadError) {
                                    toast.error(payloadError);
                                    return false;
                                  }
                                  if (!payload?.employee_id || !payload?.start_date || !payload?.end_date) {
                                    toast.error('Invalid generated payslip date range');
                                    return false;
                                  }

                                  try {
                                    setIsSavingGeneratedSummaryPayslip(true);
                                    const existing = await checkExistingPayrollRecord({
                                      employeeId: payload.employee_id,
                                      startDate: payload.start_date,
                                      endDate: payload.end_date,
                                      source
                                    });

                                    if (existing?.exists) {
                                      const confirmed = await confirmDialog({
                                        title: 'Replace existing payslip?',
                                        description: 'A saved payslip already exists for this employee and date range. Do you want to replace it with the current generated payslip?'
                                      });
                                      if (!confirmed) return false;
                                    }

                                    const response = await axiosInstance.post('/payroll/records', payload);
                                    await syncPayrollLoanCycles({ payload, savedRecord: response?.data });
                                    toast.success(source === 'mf' ? 'MF Payroll record saved successfully!' : 'Payroll record saved successfully!');
                                    try { await fetchPayrollRecords(); } catch { /* noop */ }
                                    // After successful save, ensure any stale same-range records in the DB
                                    // are normalized to the current corrected absence-count logic.
                                    queueMicrotask(() => {
                                      try {
                                        normalizeExistingPayrollRecordsForTab(source, {
                                          startISO: payload.start_date,
                                          endISO: payload.end_date
                                        });
                                      } catch { /* noop */ }
                                    });
                                    return true;
                                  } catch (error) {
                                    console.error(`Error saving ${source} payroll from summary:`, error);
                                    const detail = error?.response?.data?.detail;
                                    toast.error(
                                      detail
                                        ? (typeof detail === 'object' ? JSON.stringify(detail) : String(detail))
                                        : (source === 'mf' ? 'Failed to save MF payroll record' : 'Failed to save payroll record')
                                    );
                                    return false;
                                  } finally {
                                    setIsSavingGeneratedSummaryPayslip(false);
                                  }
                                };

                                const saveAllPayrollPayslipByPeriod = async () => {
                                  const source = 'payroll';
                                  const list = generatedPayslips[source] || [];
                                  if (!Array.isArray(list) || list.length === 0) {
                                    toast.error('No generated payroll to save');
                                    return;
                                  }
                                  const hasPayrollPeriod = Boolean((payrollPeriod || '').trim()) || list.every((r) => Boolean((r?.payroll_period || '').trim()));
                                  if (!hasPayrollPeriod) {
                                    toast.error('Please enter a payroll period first');
                                    return;
                                  }
                                  setIsSavingPayrollBatch(true);
                                  let okCount = 0;
                                  let skippedExistingCount = 0;
                                  let skippedInactiveCount = 0;
                                  let failCount = 0;
                                  let firstErr = null;
                                  const safeFloat = toPayslipNumber;
                                  try {
                                    // Use the FULL attendance dataset for ALL employees. Opening an
                                    // employee's payslip modal overwrites the global rawPayrollAttendanceData
                                    // with a single-employee fetch; without this refetch the batch save would
                                    // recompute most employees as fully absent (and skip the holiday-present
                                    // sandwich), producing saved payslips that differ from what the Payslip
                                    // Calculation Summary modal shows.
                                    let fullRawAttendance = rawPayrollAttendanceData || [];
                                    try {
                                      const freshBundle = await fetchPayrollAttendanceData({ ...payrollAttendanceFilters, name: '', branch: 'all' });
                                      if (freshBundle && Array.isArray(freshBundle.rawAttendance)) {
                                        fullRawAttendance = freshBundle.rawAttendance;
                                      }
                                    } catch (e) { /* fall back to current global raw attendance */ }
                                    for (const row of list) {
                                      const canonicalRow = findGeneratedPayslipRow(source, row?.employee_id, row?.start_date, row?.end_date) || row;
                                      if (!isGeneratedPayslipRowActive(canonicalRow)) {
                                        skippedInactiveCount += 1;
                                        continue;
                                      }
                                      const rowRange = validateDateRangeTaipei(canonicalRow?.start_date, canonicalRow?.end_date);
                                      if (!rowRange.ok) {
                                        failCount += 1;
                                        if (!firstErr) firstErr = { message: 'Invalid date range on generated row' };
                                        continue;
                                      }
                                      const hrisPe = findHrisEmployeeForGeneratedRow(canonicalRow);
                                      const payrollPe = findPayrollEmployeeForGeneratedRow(canonicalRow);
                                      const normalizedEmployeeId = (() => {
                                        const raw = String(canonicalRow?.employee_id ?? (payrollPe?.employee_id) ?? (hrisPe?.employee_id) ?? (hrisPe?.id) ?? '').trim();
                                        if (!raw) return '';
                                        if (/^\d+$/.test(raw)) return raw.replace(/^0+(?=\d)/, '');
                                        return raw;
                                      })();
                                      if (!normalizedEmployeeId) {
                                        failCount += 1;
                                        if (!firstErr) firstErr = { message: 'Missing employee ID on generated row' };
                                        continue;
                                      }
                                      const ds = canonicalRow?.deduction_settings || {};
                                      const rowToggles = {
                                        sss: ds.sss !== false,
                                        hdmf: ds.hdmf !== false,
                                        phic: ds.phic !== false,
                                        tax: ds.tax !== false,
                                        is_minimum_wage: !!ds.is_minimum_wage
                                      };
                                      const rowSss = safeFloat(canonicalRow?.sss_contribution);
                                      const rowHdmf = safeFloat(canonicalRow?.hdmf_contribution);
                                      const rowPhic = safeFloat(canonicalRow?.philhealth_contribution);
                                      const rowTax = safeFloat(canonicalRow?.withholding_tax);
                                      const rowDailyRate = safeFloat(canonicalRow?.daily_rate);
                                      const rowHourlyRate = safeFloat(canonicalRow?.hourly_rate) || (rowDailyRate > 0 ? rowDailyRate / 8 : 0);
                                      const scopedRawAttendance = (fullRawAttendance || []).filter(rec => {
                                        const recId = String(rec?.user_id || rec?.employee_id || '').trim().replace(/^0+(?=\d)/, '');
                                        return recId === normalizedEmployeeId;
                                      });
                                      const scopedAdditionalIncome = Array.isArray(canonicalRow?.additional_income) ? canonicalRow.additional_income.slice() : [];
                                      const scopedAdditionalDeductions = (Array.isArray(canonicalRow?.additional_deductions) ? canonicalRow.additional_deductions.slice() : []).filter(ded => ded?.is_loan_deduction !== true);
                                      const scopedOvertimePay = Array.isArray(canonicalRow?.overtime_pay) ? canonicalRow.overtime_pay.slice() : [];
                                      const rowApplicableLoans = getApplicableLoansForRecord({
                                        loans: payrollLoans || [],
                                        employeeId: normalizedEmployeeId,
                                        employeeName: String(canonicalRow?.employee_name || (hrisPe?.full_name) || ''),
                                        record: { start_date: rowRange.startISO, end_date: rowRange.endISO },
                                        source
                                      });
                                      const normalizeCycles = (applicableLoans, rangeISO) => {
                                        const cycles = [];
                                        if (!Array.isArray(applicableLoans)) return cycles;
                                        const recStart = new Date(rangeISO.startISO + 'T00:00:00+08:00').getTime();
                                        const recEnd = new Date(rangeISO.endISO + 'T00:00:00+08:00').getTime();
                                        for (const loan of applicableLoans) {
                                          const loanId = String(loan?.id || loan?.loan_id || '').trim();
                                          const loanType = String(loan?.loan_type || '').trim();
                                          const loanSubtype = String(loan?.loan_subtype || '').trim();
                                          const loanLabel = [loanType, loanSubtype].filter(Boolean).join(' - ') || ('Loan ' + loanId);
                                          const allCyc = Array.isArray(loan?.cycles) ? loan.cycles : [];
                                          const scheduleCycles = allCyc.length > 0
                                            ? allCyc
                                            : [{ cycle_date: String(loan?.schedule_start || rangeISO.startISO), cycle_status: 'posted', deducted_amount: safeFloat(loan?.deducted_amount ?? loan?.scheduled_amount ?? loan?.amount ?? 0) }];
                                          for (const cyc of scheduleCycles) {
                                            const cycDateRaw = String(cyc?.cycle_date || '').trim() || rangeISO.startISO;
                                            let cycT;
                                            try { cycT = new Date(cycDateRaw + 'T00:00:00+08:00').getTime(); }
                                            catch { cycT = recStart; }
                                            if (!Number.isFinite(cycT)) cycT = recStart;
                                            if (cycT < recStart || cycT > recEnd) continue;
                                            const statusRaw = String(cyc?.cycle_status || 'posted').toLowerCase();
                                            if (statusRaw === 'skipped') continue;
                                            const dedAmt = safeFloat(cyc?.deducted_amount ?? cyc?.scheduled_amount ?? cyc?.amount ?? loan?.deducted_amount ?? loan?.scheduled_amount ?? loan?.amount ?? 0);
                                            if (dedAmt <= 0) continue;
                                            cycles.push({
                                              cycle_id: String(cyc?.id || cyc?.cycle_id || `${loanId}-${cycDateRaw}`).trim(),
                                              loan_id: loanId,
                                              loan_type: loanType,
                                              loan_subtype: loanSubtype,
                                              loan_label: loanLabel,
                                              cycle_date: cycDateRaw,
                                              cycle_status: statusRaw || 'posted',
                                              deducted_amount: dedAmt,
                                              scheduled_amount: safeFloat(cyc?.scheduled_amount ?? dedAmt)
                                            });
                                          }
                                        }
                                        return cycles;
                                      };
                                      const scopedLoanCycles = normalizeCycles(rowApplicableLoans, { startISO: rowRange.startISO, endISO: rowRange.endISO });
                                      const scopedLoanDeductionTotal = scopedLoanCycles.reduce((sum, c) => sum + safeFloat(c.deducted_amount), 0);
                                      const rowHalfMonth = safeFloat(canonicalRow?.half_month_salary);
                                      const employeeEmailScope = String(canonicalRow?.employee_email || (hrisPe?.email) || (payrollPe?.email) || '');
                                      const scopedCalculatedPayslip = {
                                        dailyRate: rowDailyRate,
                                        hourlyRate: rowHourlyRate,
                                        basicSalary: rowHalfMonth * 2,
                                        employeeEmail: employeeEmailScope,
                                        deductions: {
                                          sss: rowSss,
                                          hdmf: rowHdmf,
                                          phic: rowPhic,
                                          tax: rowTax
                                        }
                                      };
                                      const scope = {
                                        selectedPayslipEmployee: hrisPe,
                                        payrollEmployeeData: payrollPe || { email: employeeEmailScope, allowances: { mf: 0, gas_allowance: 0, load_allowance: 0, housing_allowance: 0 } },
                                        calculatedPayslip: scopedCalculatedPayslip,
                                        payslipDeductions: { ...rowToggles },
                                        otHours: safeFloat(canonicalRow?.ot_hours),
                                        holidayHours: safeFloat(canonicalRow?.holiday_hours),
                                        additionalIncome: scopedAdditionalIncome,
                                        additionalDeductions: scopedAdditionalDeductions,
                                        overtimePay: scopedOvertimePay,
                                        rawAttendanceData: scopedRawAttendance,
                                        _loanCycles: scopedLoanCycles,
                                        _loanDeductionTotal: scopedLoanDeductionTotal
                                      };
                                      const { payload, error } = buildCurrentPayrollRecordPayload({ generatedRow: canonicalRow, scope });
                                      if (error || !payload || !payload?.employee_id || !payload?.start_date || !payload?.end_date) {
                                        failCount += 1;
                                        if (!firstErr) firstErr = error ? { message: String(error) } : { message: 'Invalid row payload' };
                                        continue;
                                      }
                                      const userPayrollPeriod = String(payrollPeriod || '').trim();
                                      if (userPayrollPeriod) payload.payroll_period = userPayrollPeriod;
                                      else if (!payload.payroll_period) payload.payroll_period = derivePayrollPeriodFromRange(rowRange.startISO, rowRange.endISO);
                                      payload.start_date = rowRange.startISO;
                                      payload.end_date = rowRange.endISO;
                                      if (payload.working_days == null || payload.working_days === 0) {
                                        try {
                                          const attRecompute = computeRawPresenceAbsenceForEmployee({
                                            tab: source, employeeId: String(payload.employee_id || normalizedEmployeeId || ''),
                                            startISO: rowRange.startISO, endISO: rowRange.endISO,
                                            rawAttendance: scopedRawAttendance, peList: payrollEmployees || []
                                          });
                                          payload.working_days = safeFloat(attRecompute?.working_days || 0);
                                        } catch { /* ignore */ }
                                      }
                                      try {
                                        const existing = await checkExistingPayrollRecord({
                                          employeeId: payload.employee_id,
                                          startDate: payload.start_date,
                                          endDate: payload.end_date,
                                          source
                                        });
                                        if (existing?.exists) {
                                          skippedExistingCount += 1;
                                          continue;
                                        }
                                        const resp = await axiosInstance.post('/payroll/records', payload);
                                        try {
                                          await syncPayrollLoanCycles({ payload, savedRecord: resp?.data });
                                        } catch (err) {
                                          console.error('Batch save loan sync failed for employee:', payload.employee_id, err);
                                        }
                                        okCount += 1;
                                      } catch (e) {
                                        failCount += 1;
                                        if (!firstErr) firstErr = e;
                                      }
                                    }
                                  } finally {
                                    setIsSavingPayrollBatch(false);
                                  }
                                  const skippedSummary = [];
                                  if (skippedExistingCount > 0) skippedSummary.push(`${skippedExistingCount} existing`);
                                  if (skippedInactiveCount > 0) skippedSummary.push(`${skippedInactiveCount} inactive`);
                                  const skippedLabel = skippedSummary.length > 0 ? `, skipped ${skippedSummary.join(' and ')}` : '';
                                  if (failCount === 0) {
                                    toast.success(`Saved ${okCount} payroll payslip(s)${skippedLabel}`);
                                  } else {
                                    const detail = firstErr?.response?.data?.detail;
                                    const msg = detail ? String(detail) : (firstErr?.message ? String(firstErr.message) : 'Save failed');
                                    toast.error(`Saved ${okCount}${skippedLabel}, failed ${failCount}: ${msg}`);
                                  }
                                  try { await fetchPayrollRecords(); } catch { /* noop */ }
                                  queueMicrotask(() => {
                                    try {
                                      const f = payrollAttendanceFilters;
                                      const sNorm = normalizeToISODateTaipei(f.start_date);
                                      const eNorm = normalizeToISODateTaipei(f.end_date);
                                      if (sNorm.ok && eNorm.ok) {
                                        normalizeExistingPayrollRecordsForTab(source, { startISO: sNorm.value, endISO: eNorm.value });
                                      }
                                    } catch { /* noop */ }
                                  });
                                };

                                const saveMfPayrollRecord = async () => {
                                  try {
                                    const { payload, error: payloadError } = buildCurrentMfPayrollRecordPayload();
                                    if (payloadError) {
                                      toast.error(payloadError);
                                      return false;
                                    }

                                    console.log('Saving MF Payroll Record:', payload);

                                    const response = await axiosInstance.post('/payroll/records', payload);
                                    await syncPayrollLoanCycles({ payload, savedRecord: response?.data });
                                    toast.success('MF Payroll record saved successfully!');
                                    try { await fetchPayrollRecords(); } catch { /* noop */ }
                                    queueMicrotask(() => {
                                      try {
                                        normalizeExistingPayrollRecordsForTab('mf', {
                                          startISO: payload.start_date,
                                          endISO: payload.end_date
                                        });
                                      } catch { /* noop */ }
                                    });
                                    return true;
                                  } catch (error) {
                                    console.error('Error saving MF payroll:', error);
                                    // Extract error detail if available, specifically handling validation errors
                                    const errorMessage = error.response?.data?.detail 
                                      ? (typeof error.response.data.detail === 'object' 
                                          ? JSON.stringify(error.response.data.detail) 
                                          : error.response.data.detail)
                                      : 'Failed to save MF payroll record';
                                    toast.error(errorMessage);
                                    return false;
                                  }
                                };

                                // Helper functions for overtime pay
                                const addOvertimePay = () => {
                                  setOvertimePay([...overtimePay, { id: Date.now(), title: 'Overtime', unit: 'minutes', minutes: 0, amount: 0, days: 0 }]);
                                };

                                const removeOvertimePay = (id) => {
                                  setOvertimePay(overtimePay.filter(item => item.id !== id));
                                };

                                const updateOvertimePay = (id, field, value) => {
                                  setOvertimePay(overtimePay.map(item => 
                                    item.id === id ? { ...item, [field]: value } : item
                                  ));
                                };

                                // Helper functions for additional income and deductions
                                const addAdditionalIncome = () => {
                                  setAdditionalIncome([...additionalIncome, { id: Date.now(), title: '', unit: 'minutes', minutes: 0, amount: 0, days: 0 }]);
                                };

                                const removeAdditionalIncome = (id) => {
                                  setAdditionalIncome(additionalIncome.filter(item => item.id !== id));
                                };

                                const updateAdditionalIncome = (id, field, value) => {
                                  setAdditionalIncome(additionalIncome.map(item => 
                                    item.id === id ? { ...item, [field]: value } : item
                                  ));
                                };

                                const addAdditionalDeduction = () => {
                                  setAdditionalDeductions([...additionalDeductions, { id: Date.now(), title: '', unit: 'minutes', minutes: 0, amount: 0, days: 0 }]);
                                };

                                const removeAdditionalDeduction = (id) => {
                                  setAdditionalDeductions(additionalDeductions.filter(item => item.id !== id));
                                };

                                const updateAdditionalDeduction = (id, field, value) => {
                                  setAdditionalDeductions(additionalDeductions.map(item => 
                                    item.id === id ? { ...item, [field]: value } : item
                                  ));
                                };


                                // Function to generate payslip PDF for export
                                const generatePayslipPDF = async () => {
                                  try {
                                    const payslipElement = document.getElementById('payslip-content');
                                    if (!payslipElement) {
                                      toast.error('Payslip content not found');
                                      return;
                                    }

                                    // Use html2canvas and jsPDF to generate PDF
                                    const canvas = await html2canvas(payslipElement, {
                                      scale: 2,
                                      useCORS: true,
                                      logging: false
                                    });

                                    const imgData = canvas.toDataURL('image/png');
                                    const pdf = new jsPDF('p', 'mm', 'a4');
                                    const pdfWidth = pdf.internal.pageSize.getWidth();
                                    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

                                    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
                                    pdf.save(`Payslip_${selectedPayslipEmployee?.full_name}_${payrollPeriod || 'current'}.pdf`);
                                    
                                    toast.success('PDF downloaded successfully');
                                  } catch (error) {
                                    console.error('Error generating PDF:', error);
                                    toast.error('Failed to generate PDF');
                                  }
                                };

                                // Function to print payslip
                                const printPayslip = () => {
                                  window.print();
                                };


                                // Function to save payroll record to database
                                const savePayrollRecord = async () => {
                                  try {
                                    const { payload, error: payloadError } = buildCurrentPayrollRecordPayload();
                                    if (payloadError) {
                                      toast.error(payloadError);
                                      return false;
                                    }

                                    const response = await axiosInstance.post('/payroll/records', payload);
                                    await syncPayrollLoanCycles({ payload, savedRecord: response?.data });
                                    toast.success('Payroll record saved successfully!');
                                    console.log('Saved payroll record:', response.data);
                                    try {
                                      await fetchPayrollRecords();
                                    } catch { /* noop */ }
                                    queueMicrotask(() => {
                                      try {
                                        normalizeExistingPayrollRecordsForTab('payroll', {
                                          startISO: payload.start_date,
                                          endISO: payload.end_date
                                        });
                                      } catch { /* noop */ }
                                    });
                                    return true;
                                  } catch (error) {
                                    console.error('Error saving payroll record:', error);
                                    toast.error(error.response?.data?.detail || 'Failed to save payroll record');
                                    return false;
                                  }
                                };

                                const applyPayslipEditModeDeductions = (nextDeductions) => {
                                  const snapshot = editingPayslipRecordMeta?.fullRecord || editingPayslipRecordMeta?.recordSnapshot;
                                  if (!snapshot) return;
                                  const base = getSavedStatBaseFromRecord(snapshot);
                                  const updatedDeductions = {
                                    sss: nextDeductions?.sss ? (Number(base.sss) || 0) : 0,
                                    phic: nextDeductions?.phic ? (Number(base.phic) || 0) : 0,
                                    hdmf: nextDeductions?.hdmf ? (Number(base.hdmf) || 0) : 0,
                                    tax: nextDeductions?.tax ? (Number(base.tax) || 0) : 0,
                                    late: Number(base.late) || 0,
                                    undertime: Number(base.undertime) || 0
                                  };
                                  if (editingPayslipRecordMeta?.source === 'mf') {
                                    setCalculatedMfPayslip(prev => ({
                                      ...prev,
                                      deductions: { ...(prev?.deductions || {}), ...updatedDeductions }
                                    }));
                                  } else {
                                    setCalculatedPayslip(prev => ({
                                      ...prev,
                                      deductions: { ...(prev?.deductions || {}), ...updatedDeductions }
                                    }));
                                  }
                                };

                                const openPayslipModalForEdit = (record) => {
                                  if (!record) return;
                                  const source = record?.deduction_settings?.mf_record ? 'mf' : 'payroll';
                                  const tilesFirstBase = getSavedStatBaseFromRecord(record);
                                  const baseDeductions = {
                                    sss: Number(tilesFirstBase.sss) || 0,
                                    phic: Number(tilesFirstBase.phic) || 0,
                                    hdmf: Number(tilesFirstBase.hdmf) || 0,
                                    tax: Number(tilesFirstBase.tax) || 0,
                                    late: Number(tilesFirstBase.late) || 0,
                                    undertime: Number(tilesFirstBase.undertime) || 0
                                  };
                                  const empStub = {
                                    full_name: record?.employee_name || '',
                                    employee_id: record?.employee_id || '',
                                    id: record?.employee_id || '',
                                    branch: record?.branch || 'N/A',
                                    tin_number: record?.tin_number || '',
                                    sss_number: record?.sss_number || '',
                                    phic_number: record?.phic_number || '',
                                    hdmf_number: record?.hdmf_number || '',
                                    email: record?.employee_email || ''
                                  };

                                  const normalizeItems = (items, prefix) => {
                                    const list = Array.isArray(items) ? items : [];
                                    return list.map((item, idx) => ({
                                      ...item,
                                      id: (item && item.id != null) ? item.id : `${prefix}_${record?.id || 'record'}_${idx}_${Date.now()}`,
                                      title: (item && item.title != null) ? item.title : '',
                                      unit: (item && item.unit) ? item.unit : (item && (item.amount != null) ? 'amount' : 'minutes'),
                                      minutes: (item && item.minutes != null) ? item.minutes : 0,
                                      amount: (item && item.amount != null) ? item.amount : 0,
                                      days: (item && item.days != null) ? item.days : 0
                                    }));
                                  };
                                  const normalizedAdditionalDeductions = normalizeItems(record?.additional_deductions, 'deduction')
                                    .filter((item) => !isGeneratedLoanDeductionItem(item, record?.deduction_settings?.loan_cycles));
                                  const savedLoanCycles = Array.isArray(record?.deduction_settings?.loan_cycles) ? record.deduction_settings.loan_cycles : [];
                                  const savedLoanSelectionMap = savedLoanCycles.reduce((acc, cycle) => {
                                    const loanId = String(cycle?.loan_id || '').trim();
                                    if (!loanId) return acc;
                                    acc[loanId] = String(cycle?.cycle_status || '').toLowerCase() !== 'skipped';
                                    return acc;
                                  }, {});

                                  const nextPayslipDeductions = {
                                    sss: (record?.deduction_settings?.sss != null) ? !!record?.deduction_settings?.sss : baseDeductions.sss > 0,
                                    phic: (record?.deduction_settings?.phic != null) ? !!record?.deduction_settings?.phic : baseDeductions.phic > 0,
                                    hdmf: (record?.deduction_settings?.hdmf != null) ? !!record?.deduction_settings?.hdmf : baseDeductions.hdmf > 0,
                                    tax: (record?.deduction_settings?.tax != null) ? !!record?.deduction_settings?.tax : baseDeductions.tax > 0
                                  };

                                  setIsEditingPayslipRecord(true);
                                  setEditingPayslipRecordMeta({
                                    id: record?.id,
                                    source,
                                    baseDeductions,
                                    holidays: Array.isArray(record?.holidays) ? record.holidays : [],
                                    loanCycles: savedLoanCycles,
                                    recordSnapshot: {
                                      employee_id: record?.employee_id,
                                      employee_name: record?.employee_name,
                                      employee_email: record?.employee_email,
                                      branch: record?.branch,
                                      start_date: record?.start_date,
                                      end_date: record?.end_date,
                                      payroll_period: record?.payroll_period,
                                      daily_rate: record?.daily_rate,
                                      hourly_rate: record?.hourly_rate,
                                      half_month_salary: record?.half_month_salary,
                                      days_present: record?.days_present,
                                      days_absent: record?.days_absent,
                                      half_days_present: record?.half_days_present,
                                      minutes_late: record?.minutes_late,
                                      tardiness_deduction: record?.tardiness_deduction,
                                      minutes_undertime: record?.minutes_undertime,
                                      undertime_deduction: record?.undertime_deduction,
                                      absence_deduction: record?.absence_deduction,
                                      basic_salary: record?.basic_salary,
                                      holidays_count: record?.holidays_count
                                    },
                                    fullRecord: JSON.parse(JSON.stringify(record || {}))
                                  });
                                  setGenerateTableTab(source);
                                  setPayslipDeductions(nextPayslipDeductions);
                                  setPayrollPeriod(record?.payroll_period || '');
                                  setAdditionalIncome(normalizeItems(record?.additional_income, 'income'));
                                  setOvertimePay(normalizeItems(record?.overtime_pay, 'overtime'));
                                  setAdditionalDeductions(normalizedAdditionalDeductions);
                                  if (source === 'mf') {
                                    setMfLoanDeductionSelections(savedLoanSelectionMap);
                                    setLoanDeductionSelections({});
                                  } else {
                                    setLoanDeductionSelections(savedLoanSelectionMap);
                                    setMfLoanDeductionSelections({});
                                  }
                                  setOtHours(parseFloat(record?.ot_hours) || 0);
                                  setHolidayHours(parseFloat(record?.holiday_hours) || 0);

                                  const employeeIdStr = String(record?.employee_id || '');
                                  const matchedPayrollEmployee = payrollEmployees.find(e => String(e?.employee_id) === employeeIdStr) || null;
                                  const mfAmount = parseFloat(record?.deduction_settings?.breakdown?.income?.half_month_salary) || 0;
                                  const fallbackPayrollEmployee = {
                                    employee_id: employeeIdStr,
                                    branch: record?.branch || 'N/A',
                                    salary: String(((parseFloat(record?.half_month_salary) || 0) * 2) || 0),
                                    daily_rate: String(parseFloat(record?.daily_rate) || 0),
                                    is_minimum_wage: false,
                                    tin_number: record?.tin_number || '',
                                    sss_number: record?.sss_number || '',
                                    phic_number: record?.phic_number || '',
                                    hdmf_number: record?.hdmf_number || '',
                                    allowances: source === 'mf' ? { mf: mfAmount, gas_allowance: 0, load_allowance: 0, housing_allowance: 0 } : (record?.allowances || {}),
                                    deductions: {}
                                  };
                                  setPayrollEmployeeData(matchedPayrollEmployee || fallbackPayrollEmployee);

                                  if (source === 'mf') {
                                    setMfSelectedPayslipEmployee(empStub);
                                    setSelectedPayslipEmployee(null);
                                    const savedIncome = record?.tiles?.income_breakdown || {};
                                    setMfAttendanceFilters(prev => ({ ...prev, name: record?.employee_name || record?.employee_id || '', start_date: record?.start_date || '', end_date: record?.end_date || '' }));
                                    setMfAttendanceAnalytics({
                                      working_days: (parseFloat(record?.days_absent) || 0) + (parseFloat(record?.days_present) || 0),
                                      days_present: parseFloat(record?.days_present) || 0,
                                      days_absent: parseFloat(record?.days_absent) || 0,
                                      half_days_present: parseFloat(record?.half_days_present) || 0,
                                      total_minutes_late: parseFloat(record?.minutes_late) || 0,
                                      total_minutes_undertime: parseFloat(record?.minutes_undertime) || 0,
                                      daily_rate: parseFloat(record?.daily_rate) || 0,
                                      holidays_count: parseFloat(record?.holidays_count) || (Array.isArray(record?.holidays) ? record.holidays.length : 0),
                                      total_gross_pay: parseFloat(savedIncome?.gross_salary) || parseFloat(record?.gross_salary) || 0
                                    });
                                    const dailyRate = parseFloat(record?.daily_rate) || 0;
                                    const hourlyRate = parseFloat(record?.hourly_rate) || (dailyRate ? dailyRate / 8 : 0);
                                    const savedDed = record?.tiles?.deductions || {};
                                    const savedNet = record?.tiles?.net_pay || {};
                                    const basicSalary = parseFloat(savedIncome?.gross_salary) || parseFloat(record?.basic_salary) || 0;
                                    setCalculatedMfPayslip({
                                      basicSalary,
                                      dailyRate,
                                      hourlyRate,
                                      deductions: {
                                        sss: nextPayslipDeductions.sss ? (parseFloat(savedDed?.sss) ?? baseDeductions.sss) : 0,
                                        phic: nextPayslipDeductions.phic ? (parseFloat(savedDed?.philhealth) ?? baseDeductions.phic) : 0,
                                        hdmf: nextPayslipDeductions.hdmf ? (parseFloat(savedDed?.hdmf) ?? baseDeductions.hdmf) : 0,
                                        tax: nextPayslipDeductions.tax ? (parseFloat(savedDed?.withholding_tax) ?? baseDeductions.tax) : 0,
                                        late: parseFloat(savedIncome?.tardiness) ?? baseDeductions.late,
                                        undertime: parseFloat(savedIncome?.undertime) ?? baseDeductions.undertime
                                      },
                                      grossPay: parseFloat(savedIncome?.gross_salary) ?? parseFloat(savedNet?.gross_salary) ?? parseFloat(record?.gross_salary) ?? 0,
                                      totalDeductions: parseFloat(savedDed?.total_deductions) ?? parseFloat(savedNet?.total_deductions) ?? parseFloat(record?.total_deductions) ?? 0,
                                      netPay: parseFloat(savedNet?.net_pay) ?? parseFloat(record?.net_pay) ?? 0
                                    });
                                  } else {
                                    setSelectedPayslipEmployee(empStub);
                                    setMfSelectedPayslipEmployee(null);
                                    const savedIncome = record?.tiles?.income_breakdown || {};
                                    setPayrollAttendanceFilters(prev => ({ ...prev, name: record?.employee_name || record?.employee_id || '', start_date: record?.start_date || '', end_date: record?.end_date || '' }));
                                    setPayrollAttendanceAnalytics({
                                      working_days: (parseFloat(record?.days_absent) || 0) + (parseFloat(record?.days_present) || 0),
                                      days_present: parseFloat(record?.days_present) || 0,
                                      days_absent: parseFloat(record?.days_absent) || 0,
                                      half_days_present: parseFloat(record?.half_days_present) || 0,
                                      total_minutes_late: parseFloat(record?.minutes_late) || 0,
                                      total_minutes_undertime: parseFloat(record?.minutes_undertime) || 0,
                                      daily_rate: parseFloat(record?.daily_rate) || 0,
                                      holidays_count: parseFloat(record?.holidays_count) || (Array.isArray(record?.holidays) ? record.holidays.length : 0),
                                      total_gross_pay: parseFloat(savedIncome?.gross_salary) || parseFloat(record?.gross_salary) || 0
                                    });
                                    const dailyRate = parseFloat(record?.daily_rate) || 0;
                                    const hourlyRate = parseFloat(record?.hourly_rate) || (dailyRate ? dailyRate / 8 : 0);
                                    const savedDed = record?.tiles?.deductions || {};
                                    const savedNet = record?.tiles?.net_pay || {};
                                    const basicSalary = (parseFloat(savedIncome?.half_month_salary) || parseFloat(record?.half_month_salary) || 0) * 2;
                                    setCalculatedPayslip({
                                      basicSalary,
                                      dailyRate,
                                      hourlyRate,
                                      deductions: {
                                        sss: nextPayslipDeductions.sss ? (parseFloat(savedDed?.sss) ?? baseDeductions.sss) : 0,
                                        phic: nextPayslipDeductions.phic ? (parseFloat(savedDed?.philhealth) ?? baseDeductions.phic) : 0,
                                        hdmf: nextPayslipDeductions.hdmf ? (parseFloat(savedDed?.hdmf) ?? baseDeductions.hdmf) : 0,
                                        tax: nextPayslipDeductions.tax ? (parseFloat(savedDed?.withholding_tax) ?? baseDeductions.tax) : 0,
                                        late: parseFloat(savedIncome?.tardiness) ?? baseDeductions.late,
                                        undertime: parseFloat(savedIncome?.undertime) ?? baseDeductions.undertime
                                      },
                                      grossPay: parseFloat(savedIncome?.gross_salary) ?? parseFloat(savedNet?.gross_salary) ?? parseFloat(record?.gross_salary) ?? 0,
                                      totalDeductions: parseFloat(savedDed?.total_deductions) ?? parseFloat(savedNet?.total_deductions) ?? parseFloat(record?.total_deductions) ?? 0,
                                      netPay: parseFloat(savedNet?.net_pay) ?? parseFloat(record?.net_pay) ?? 0
                                    });
                                  }

                                  setSelectedGeneratedPayslipEmployeeId(record?.employee_id || '');

                                  setIsPayslipModalOpen(true);
                                };

                                const updatePayrollRecord = async () => {
                                  try {
                                    const recordId = editingPayslipRecordMeta?.id;
                                    if (!recordId) {
                                      toast.error('No payroll record selected for editing');
                                      return false;
                                    }
                                    if (!selectedPayslipEmployee || !payrollEmployeeData) {
                                      toast.error('Missing employee data for editing');
                                      return false;
                                    }
                                    if (!payrollPeriod) {
                                      toast.error('Please enter a payroll period first');
                                      return false;
                                    }

                                    const snapshot = editingPayslipRecordMeta?.fullRecord || editingPayslipRecordMeta?.recordSnapshot;
                                    if (!snapshot) {
                                      toast.error('Missing saved record snapshot for update');
                                      return false;
                                    }

                                    const normalizedEmployeeId = (() => {
                                      const raw = String(snapshot?.employee_id ?? (selectedPayslipEmployee.employee_id || selectedPayslipEmployee.id || '')).trim();
                                      if (!raw) return '';
                                      if (/^\d+$/.test(raw)) return raw.replace(/^0+(?=\d)/, '');
                                      return raw;
                                    })();
                                    const snapshotSavedCycles = Array.isArray(editingPayslipRecordMeta?.loanCycles)
                                      ? editingPayslipRecordMeta.loanCycles
                                      : (Array.isArray(snapshot?.deduction_settings?.loan_cycles) ? snapshot.deduction_settings.loan_cycles : []);
                                    const snapshotHolidaysArr = Array.isArray(editingPayslipRecordMeta?.holidays)
                                      ? editingPayslipRecordMeta.holidays
                                      : (Array.isArray(snapshot?.holidays) ? snapshot.holidays : []);

                                    const result = computeEditPayrollSaveSnapshot({
                                      source: 'payroll',
                                      snapshot,
                                      holidaysArr: snapshotHolidaysArr,
                                      payslipDeductions: { ...payslipDeductions },
                                      additionalIncomeFormItems: additionalIncome,
                                      additionalDeductionsFormItems: additionalDeductions,
                                      overtimePayFormItems: overtimePay,
                                      otHours,
                                      holidayHours,
                                      loanSelectionMap: { ...loanDeductionSelections },
                                      savedLoanCycles: snapshotSavedCycles,
                                      payrollEmployeeData,
                                      isGeneratedLoanDeductionItemFn: isGeneratedLoanDeductionItem
                                    });
                                    if (!result?.rowRange?.ok) {
                                      toast.error('Invalid payroll record date range');
                                      return false;
                                    }

                                    const tl = result.topLevelFields;
                                    const payrollRecordData = {
                                      employee_id: normalizedEmployeeId || (selectedPayslipEmployee.employee_id || selectedPayslipEmployee.id || ''),
                                      employee_name: selectedPayslipEmployee.full_name || snapshot?.employee_name || '',
                                      employee_email: selectedPayslipEmployee.email || snapshot?.employee_email || '',
                                      branch: selectedPayslipEmployee.branch || snapshot?.branch || 'N/A',
                                      tin_number: selectedPayslipEmployee.tin_number || snapshot?.tin_number || '',
                                      sss_number: selectedPayslipEmployee.sss_number || snapshot?.sss_number || '',
                                      phic_number: selectedPayslipEmployee.phic_number || snapshot?.phic_number || '',
                                      hdmf_number: selectedPayslipEmployee.hdmf_number || snapshot?.hdmf_number || '',
                                      payroll_period: payrollPeriod || snapshot?.payroll_period || '',
                                      start_date: tl.start_date,
                                      end_date: tl.end_date,
                                      half_month_salary: tl.half_month_salary,
                                      daily_rate: tl.daily_rate,
                                      hourly_rate: tl.hourly_rate,
                                      working_days: tl.working_days,
                                      days_present: tl.days_present,
                                      days_absent: tl.days_absent,
                                      half_days_present: tl.half_days_present,
                                      absence_deduction: tl.absence_deduction,
                                      minutes_late: tl.minutes_late,
                                      tardiness_deduction: tl.tardiness_deduction,
                                      minutes_undertime: tl.minutes_undertime,
                                      undertime_deduction: tl.undertime_deduction,
                                      basic_salary: tl.basic_salary,
                                      overtime_pay: tl.overtime_pay,
                                      ot_hours: tl.ot_hours,
                                      ot_pay_amount: tl.ot_pay_amount,
                                      holiday_hours: tl.holiday_hours,
                                      holiday_pay_amount: tl.holiday_pay_amount,
                                      holidays_count: tl.holidays_count,
                                      holidays: tl.holidays,
                                      additional_income: tl.additional_income,
                                      gross_salary: tl.gross_salary,
                                      sss_contribution: tl.sss_contribution,
                                      hdmf_contribution: tl.hdmf_contribution,
                                      philhealth_contribution: tl.philhealth_contribution,
                                      withholding_tax: tl.withholding_tax,
                                      additional_deductions: tl.additional_deductions,
                                      total_deductions: tl.total_deductions,
                                      net_pay: tl.net_pay,
                                      loan_breakdown: tl.loan_breakdown,
                                      tiles: tl.tiles,
                                      deduction_settings: {
                                        ...(snapshot?.deduction_settings || {}),
                                        ...payslipDeductions,
                                        loan_cycles: result.loanCycles,
                                        loan_breakdown: result.loanBreakdown,
                                        breakdown: {
                                          income: {
                                            ...(result?.breakdown?.income || {}),
                                            half_month_salary: result?.breakdown?.income?.half_month_salary || tl.halfMonthSalaryInternal || tl.half_month_salary
                                          },
                                          deductions: result?.breakdown?.deductions || {},
                                          net_pay_breakdown: (result?.tiles?.net_pay) || {},
                                          summary: result?.breakdown?.summary || {}
                                        }
                                      }
                                    };

                                    const response = await axiosInstance.post('/payroll/records', payrollRecordData);
                                    await syncPayrollLoanCycles({ payload: payrollRecordData, savedRecord: response?.data });
                                    toast.success('Payroll record updated successfully!');
                                    try { await fetchPayrollRecords(); } catch { /* noop */ }
                                    return true;
                                  } catch (error) {
                                    console.error('Error updating payroll record:', error);
                                    toast.error(error.response?.data?.detail || 'Failed to update payroll record');
                                    return false;
                                  }
                                };

                                const updateMfPayrollRecord = async () => {
                                  try {
                                    const recordId = editingPayslipRecordMeta?.id;
                                    if (!recordId) {
                                      toast.error('No MF record selected for editing');
                                      return false;
                                    }
                                    if (!mfSelectedPayslipEmployee || !payrollEmployeeData) {
                                      toast.error('Missing employee data for editing');
                                      return false;
                                    }
                                    if (!payrollPeriod) {
                                      toast.error('Please enter a payroll period first');
                                      return false;
                                    }

                                    const snapshot = editingPayslipRecordMeta?.fullRecord || editingPayslipRecordMeta?.recordSnapshot;
                                    if (!snapshot) {
                                      toast.error('Missing saved MF record snapshot for update');
                                      return false;
                                    }

                                    const normalizedEmployeeId = (() => {
                                      const raw = String(snapshot?.employee_id ?? (mfSelectedPayslipEmployee.employee_id || mfSelectedPayslipEmployee.id || '')).trim();
                                      if (!raw) return '';
                                      if (/^\d+$/.test(raw)) return raw.replace(/^0+(?=\d)/, '');
                                      return raw;
                                    })();
                                    const snapshotSavedCycles = Array.isArray(editingPayslipRecordMeta?.loanCycles)
                                      ? editingPayslipRecordMeta.loanCycles
                                      : (Array.isArray(snapshot?.deduction_settings?.loan_cycles) ? snapshot.deduction_settings.loan_cycles : []);
                                    const snapshotHolidaysArr = Array.isArray(editingPayslipRecordMeta?.holidays)
                                      ? editingPayslipRecordMeta.holidays
                                      : (Array.isArray(snapshot?.holidays) ? snapshot.holidays : []);

                                    const result = computeEditPayrollSaveSnapshot({
                                      source: 'mf',
                                      snapshot,
                                      holidaysArr: snapshotHolidaysArr,
                                      payslipDeductions: { ...payslipDeductions },
                                      additionalIncomeFormItems: additionalIncome,
                                      additionalDeductionsFormItems: additionalDeductions,
                                      overtimePayFormItems: overtimePay,
                                      otHours,
                                      holidayHours,
                                      loanSelectionMap: { ...mfLoanDeductionSelections },
                                      savedLoanCycles: snapshotSavedCycles,
                                      payrollEmployeeData,
                                      isGeneratedLoanDeductionItemFn: isGeneratedLoanDeductionItem
                                    });
                                    if (!result?.rowRange?.ok) {
                                      toast.error('Invalid MF record date range');
                                      return false;
                                    }

                                    const tl = result.topLevelFields;
                                    const payrollRecordData = {
                                      employee_id: normalizedEmployeeId || (mfSelectedPayslipEmployee.employee_id || mfSelectedPayslipEmployee.id || ''),
                                      employee_name: mfSelectedPayslipEmployee.full_name || snapshot?.employee_name || '',
                                      employee_email: mfSelectedPayslipEmployee.email || snapshot?.employee_email || '',
                                      branch: mfSelectedPayslipEmployee.branch || snapshot?.branch || 'N/A',
                                      tin_number: mfSelectedPayslipEmployee.tin_number || snapshot?.tin_number || '',
                                      sss_number: mfSelectedPayslipEmployee.sss_number || snapshot?.sss_number || '',
                                      phic_number: mfSelectedPayslipEmployee.phic_number || snapshot?.phic_number || '',
                                      hdmf_number: mfSelectedPayslipEmployee.hdmf_number || snapshot?.hdmf_number || '',
                                      payroll_period: payrollPeriod || snapshot?.payroll_period || '',
                                      start_date: tl.start_date,
                                      end_date: tl.end_date,
                                      half_month_salary: 0,
                                      daily_rate: tl.daily_rate,
                                      hourly_rate: tl.hourly_rate,
                                      working_days: tl.working_days,
                                      days_present: tl.days_present,
                                      days_absent: tl.days_absent,
                                      half_days_present: tl.half_days_present,
                                      absence_deduction: tl.absence_deduction,
                                      minutes_late: tl.minutes_late,
                                      tardiness_deduction: tl.tardiness_deduction,
                                      minutes_undertime: tl.minutes_undertime,
                                      undertime_deduction: tl.undertime_deduction,
                                      basic_salary: tl.basic_salary,
                                      overtime_pay: tl.overtime_pay,
                                      ot_hours: tl.ot_hours,
                                      ot_pay_amount: tl.ot_pay_amount,
                                      holiday_hours: tl.holiday_hours,
                                      holiday_pay_amount: tl.holiday_pay_amount,
                                      holidays_count: tl.holidays_count,
                                      holidays: tl.holidays,
                                      additional_income: tl.additional_income,
                                      gross_salary: tl.gross_salary,
                                      sss_contribution: tl.sss_contribution,
                                      hdmf_contribution: tl.hdmf_contribution,
                                      philhealth_contribution: tl.philhealth_contribution,
                                      withholding_tax: tl.withholding_tax,
                                      additional_deductions: tl.additional_deductions,
                                      total_deductions: tl.total_deductions,
                                      net_pay: tl.net_pay,
                                      loan_breakdown: tl.loan_breakdown,
                                      tiles: tl.tiles,
                                      deduction_settings: {
                                        ...(snapshot?.deduction_settings || {}),
                                        ...payslipDeductions,
                                        mf_record: true,
                                        loan_cycles: result.loanCycles,
                                        loan_breakdown: result.loanBreakdown,
                                        breakdown: {
                                          income: {
                                            ...(result?.breakdown?.income || {}),
                                            half_month_salary: result?.breakdown?.income?.half_month_salary || tl.halfMonthSalaryInternal || 0
                                          },
                                          deductions: result?.breakdown?.deductions || {},
                                          net_pay_breakdown: (result?.tiles?.net_pay) || {},
                                          summary: result?.breakdown?.summary || {}
                                        }
                                      }
                                    };

                                    const response = await axiosInstance.post('/payroll/records', payrollRecordData);
                                    await syncPayrollLoanCycles({ payload: payrollRecordData, savedRecord: response?.data });
                                    toast.success('MF payroll record updated successfully!');
                                    try { await fetchPayrollRecords(); } catch { /* noop */ }
                                    return true;
                                  } catch (error) {
                                    console.error('Error updating MF payroll record:', error);
                                    const errorMessage = error.response?.data?.detail
                                      ? (typeof error.response.data.detail === 'object'
                                          ? JSON.stringify(error.response.data.detail)
                                          : error.response.data.detail)
                                      : 'Failed to update MF payroll record';
                                    toast.error(errorMessage);
                                    return false;
                                  }
                                };


                                const monthlyRecordsCacheRef = useRef(new Map());
                                const lastToastShownAtRef = useRef(new Map());
                                const payrollFetchInflightRef = useRef(null);

                                const throttledToastError = (message, cooldownMs = 15000) => {
                                  try {
                                    const now = Date.now();
                                    const last = Number(lastToastShownAtRef.current.get(message)) || 0;
                                    if (now - last < cooldownMs) return;
                                    lastToastShownAtRef.current.set(message, now);
                                  } catch { /* noop */ }
                                  try { toast.error(message); } catch { /* noop */ }
                                };

                                // Function to fetch payroll records from database
                                const fetchPayrollRecords = async ({ quiet, retry = 1 } = {}) => {
                                  // In-flight de-duplication: if an identical request is already running, await it
                                  try {
                                    const dedupKey = [
                                      String(payrollDatabaseTab || ''),
                                      String(payrollDatabaseFilters?.start_date || ''),
                                      String(payrollDatabaseFilters?.end_date || ''),
                                      String(payrollDatabaseFilters?.employee_query || ''),
                                      String(payrollDatabaseFilters?.branch || ''),
                                      'quiet=' + (!!quiet ? '1' : '0')
                                    ].join('||');
                                    if (payrollFetchInflightRef.current && payrollFetchInflightRef.current.key === dedupKey && payrollFetchInflightRef.current.promise) {
                                      try {
                                        setIsLoadingPayrollRecords(true);
                                        const res = await payrollFetchInflightRef.current.promise;
                                        return res;
                                      } finally {
                                        setIsLoadingPayrollRecords(false);
                                      }
                                    }
                                    let resolveInflight;
                                    const inflightPromise = new Promise((resolve) => { resolveInflight = resolve; });
                                    payrollFetchInflightRef.current = { key: dedupKey, promise: inflightPromise };
                                  } catch { /* noop */ }

                                  setIsLoadingPayrollRecords(true);
                                  let attempt = 0;
                                  const maxAttempts = Math.max(1, Number(retry) >= 1 ? Number(retry) + 1 : 1);
                                  let lastError = null;
                                  let successData = null;
                                  while (attempt < maxAttempts) {
                                    attempt += 1;
                                    try {
                                      const params = new URLSearchParams();

                                      // Add source parameter based on active tab
                                      if (payrollDatabaseTab === 'mf') {
                                        params.append('source', 'mf');
                                      } else {
                                        params.append('source', 'payroll');
                                      }

                                      // Apply filters if provided
                                      if (payrollDatabaseFilters.start_date) {
                                        params.append('start_date', payrollDatabaseFilters.start_date);
                                      }
                                      if (payrollDatabaseFilters.end_date) {
                                        params.append('end_date', payrollDatabaseFilters.end_date);
                                      }

                                      const response = await axiosInstance.get(`/payroll/records?${params.toString()}`);
                                      let records = response?.data;
                                      if (!Array.isArray(records)) records = [];

                                      // Apply client-side filters for employee name/ID and branch
                                      if (payrollDatabaseFilters.employee_query) {
                                        const query = String(payrollDatabaseFilters.employee_query || '').toLowerCase();
                                        records = records.filter(record =>
                                          String(record?.employee_name || '').toLowerCase().includes(query) ||
                                          String(record?.employee_id || '').toLowerCase().includes(query)
                                        );
                                      }

                                      if (payrollDatabaseFilters.branch && payrollDatabaseFilters.branch !== 'all') {
                                        records = records.filter(record => record?.branch === payrollDatabaseFilters.branch);
                                      }

                                      setPayrollRecords(records);
                                      lastError = null;
                                      successData = records;
                                      break;
                                    } catch (error) {
                                      lastError = error;
                                      const status = error?.response?.status;
                                      const isTransient = !status || status >= 500 || status === 0 || status === 408 || status === 429;
                                      // Only retry transient errors, and never on last attempt
                                      if (isTransient && attempt < maxAttempts) {
                                        await new Promise((r) => setTimeout(r, 300 * attempt));
                                        continue;
                                      }
                                      break;
                                    }
                                  }
                                  if (lastError) {
                                    console.error('Error fetching payroll records:', lastError);
                                    const status = lastError?.response?.status;
                                    const isTransient = !status || status >= 500 || status === 0 || status === 408 || status === 429;
                                    // NEVER wipe existing records on auto (quiet) loads OR on transient/5xx failures  keep stale list.
                                    const mustClearList = !quiet && !isTransient;
                                    if (mustClearList) setPayrollRecords([]);
                                    if (!quiet) throttledToastError('Failed to fetch payroll records');
                                  }
                                  try {
                                    if (payrollFetchInflightRef.current) payrollFetchInflightRef.current = null;
                                    if (resolveInflight) resolveInflight(successData || (lastError ? null : []));
                                  } catch { /* noop */ }
                                  setIsLoadingPayrollRecords(false);
                                  return successData || (lastError ? null : []);
                                };

                                const fetchPayrollLoans = async ({ quiet } = {}) => {
                                  setIsLoadingPayrollLoans(true);
                                  try {
                                    const response = await axiosInstance.get('/payroll/loans');
                                    const list = Array.isArray(response?.data) ? response.data : [];
                                    setPayrollLoans(list);
                                    if (selectedPayrollLoanId && !list.some((l) => String(l?.id) === String(selectedPayrollLoanId))) {
                                      setSelectedPayrollLoanId(null);
                                    }
                                  } catch (error) {
                                    console.error('Error fetching payroll loans:', error);
                                    setPayrollLoans([]);
                                    setSelectedPayrollLoanId(null);
                                    if (!quiet) {
                                      toast.error('Failed to fetch payroll loans');
                                    }
                                  } finally {
                                    setIsLoadingPayrollLoans(false);
                                  }
                                };

                                useEffect(() => {
                                  const shouldLoadForGenerate = activeMenuItem === 'payroll-attendance' && isGeneratedPayslipSummaryOpen;
                                  const shouldLoadForDatabase = activeMenuItem === 'payroll-database';
                                  if (!shouldLoadForGenerate && !shouldLoadForDatabase) return;
                                  if (isLoadingPayrollLoans) return;
                                  if (Array.isArray(payrollLoans) && payrollLoans.length > 0) return;
                                  fetchPayrollLoans({ quiet: true });
                                }, [activeMenuItem, isGeneratedPayslipSummaryOpen, isLoadingPayrollLoans, payrollLoans]);

                                const fetchPayrollPeriods = async ({ source } = {}) => {
                                  try {
                                    const params = new URLSearchParams();
                                    params.append('source', source === 'mf' ? 'mf' : 'payroll');
                                    const response = await axiosInstance.get(`/payroll/periods?${params.toString()}`);
                                    const list = response?.data;
                                    return Array.isArray(list) ? list : [];
                                  } catch (error) {
                                    console.error('Error fetching payroll periods:', error);
                                    return [];
                                  }
                                };

                                const fetchPayrollRecordsByPeriod = async ({ source, start_date, end_date } = {}) => {
                                  try {
                                    const start = String(start_date || '').trim();
                                    const end = String(end_date || '').trim();
                                    if (!start || !end) return [];
                                    const params = new URLSearchParams();
                                    params.append('source', source === 'mf' ? 'mf' : 'payroll');
                                    params.append('start_date', start);
                                    params.append('end_date', end);
                                    const response = await axiosInstance.get(`/payroll/records/by-period?${params.toString()}`);
                                    const list = response?.data;
                                    return Array.isArray(list) ? list : [];
                                  } catch (error) {
                                    console.error('Error fetching payroll records by period:', error);
                                    return [];
                                  }
                                };

                                const fetchAppSettings = async () => {
                                  try {
                                    const response = await axiosInstance.get('/app/settings');
                                    return response?.data || null;
                                  } catch (error) {
                                    console.error('Error fetching app settings:', error);
                                    toast.error('Failed to fetch app settings');
                                    return null;
                                  }
                                };

                                const updateAppSettings = async (payload = {}) => {
                                  try {
                                    const body = payload && typeof payload === 'object' ? payload : {};
                                    const response = await axiosInstance.put('/app/settings', body);
                                    toast.success('App settings updated');
                                    return response?.data || null;
                                  } catch (error) {
                                    console.error('Error updating app settings:', error);
                                    toast.error('Failed to update app settings');
                                    return null;
                                  }
                                };

                                const fetchMonthlyRecordsForEmployee = async ({ employeeIdCandidates, endISO } = {}) => {
                                  try {
                                    const end = String(endISO || '').slice(0, 10);
                                    const candidates = buildEmployeeIdCandidates(employeeIdCandidates || []);
                                    if (!end || candidates.length === 0) return [];
                                    const { monthEndISO } = computeMonthWindowFromEndISO(end);
                                    const cacheKey = `${candidates[0]}|${monthEndISO}`;
                                    const cache = monthlyRecordsCacheRef.current;
                                    if (cache?.has(cacheKey)) return cache.get(cacheKey);
                                    const { records } = await fetchPayrollRecordsByEmployeeIdCandidates({
                                      axiosInstance,
                                      employeeIdCandidates: candidates,
                                      endDateISO: monthEndISO
                                    });
                                    const list = Array.isArray(records) ? records : [];
                                    cache?.set(cacheKey, list);
                                    return list;
                                  } catch {
                                    return [];
                                  }
                                };

                                const recalculatePayrollRecords = async ({ source, filters } = {}) => {
                                  const sourceTab = source === 'mf' ? 'mf' : 'payroll';
                                  const startISO = filters?.start_date;
                                  const endISO = filters?.end_date;
                                  if (!startISO || !endISO) {
                                    toast.error('Please select both start and end dates');
                                    return;
                                  }
                                  const vr = validateDateRangeTaipei(startISO, endISO);
                                  if (!vr.ok) {
                                    toast.error('Invalid date range');
                                    return;
                                  }

                                  const ok = await confirmDialog({
                                    title: 'Recalculate records?',
                                    description: 'This will update tardiness/undertime minutes and recompute the affected totals for the currently loaded records in this list.',
                                    confirmText: 'Recalculate',
                                    cancelText: 'Cancel'
                                  });
                                  if (!ok) return;

                                  const list = Array.isArray(payrollRecords) ? payrollRecords : [];
                                  const matchesSource = (rec) => sourceTab === 'mf'
                                    ? (rec?.deduction_settings?.mf_record === true)
                                    : (rec?.deduction_settings?.mf_record !== true);

                                  const q = String(filters?.employee_query || '').trim().toLowerCase();
                                  const branch = String(filters?.branch || 'all');
                                  const recordsToFix = list.filter((rec) => {
                                    if (!matchesSource(rec)) return false;
                                    const rr = validateDateRangeTaipei(rec?.start_date, rec?.end_date);
                                    if (rr.ok && (rr.startISO !== vr.startISO || rr.endISO !== vr.endISO)) return false;
                                    if (!rr.ok) {
                                      if (String(rec?.start_date || '').trim() !== vr.startISO) return false;
                                      if (String(rec?.end_date || '').trim() !== vr.endISO) return false;
                                    }
                                    if (q) {
                                      const n = String(rec?.employee_name || '').toLowerCase();
                                      const id = String(rec?.employee_id || '').toLowerCase();
                                      if (!n.includes(q) && !id.includes(q)) return false;
                                    }
                                    if (branch && branch !== 'all' && String(rec?.branch || '') !== branch) return false;
                                    return true;
                                  });

                                  if (recordsToFix.length === 0) {
                                    toast.error('No records to update for the selected filters');
                                    return;
                                  }

                                  const hols = sanitizeHolidayRows(holidays).filter((h) => h.date >= vr.startISO && h.date <= vr.endISO);
                                  const holidaySet = new Set(hols.map((h) => h.date));

                                  const attendanceBundle = sourceTab === 'mf'
                                    ? await fetchMfAttendanceData({
                                        start_date: vr.startISO,
                                        end_date: vr.endISO,
                                        name: filters?.employee_query || '',
                                        branch: branch || 'all'
                                      })
                                    : await fetchPayrollAttendanceData({
                                        start_date: vr.startISO,
                                        end_date: vr.endISO,
                                        name: filters?.employee_query || '',
                                        branch: branch || 'all'
                                      });
                                  if (!attendanceBundle) return;

                                  const normalizeId = (value) => {
                                    const raw = String(value ?? '').trim();
                                    if (!raw) return '';
                                    if (/^\d+$/.test(raw)) return raw.replace(/^0+(?=\d)/, '');
                                    return raw;
                                  };

                                  const { perEmployeeMinutes } = aggregateFirstLastMinutes(attendanceBundle.rawAttendance, {
                                    startISO: vr.startISO,
                                    endISO: vr.endISO,
                                    holidaySet
                                  });

                                  const minutesMap = {};
                                  Object.entries(perEmployeeMinutes || {}).forEach(([id, mins]) => {
                                    minutesMap[String(id)] = mins;
                                    const normalized = normalizeId(id);
                                    if (normalized && !minutesMap[normalized]) minutesMap[normalized] = mins;
                                  });

                                  const safeFloat = (val) => {
                                    if (val === null || val === undefined) return 0;
                                    if (typeof val === 'number') return Number.isFinite(val) ? val : 0;
                                    const s = String(val).replace(/,/g, '').trim();
                                    const parsed = parseFloat(s);
                                    return Number.isFinite(parsed) ? parsed : 0;
                                  };

                                  let updated = 0;
                                  for (const rec of recordsToFix) {
                                    const recEmpId = normalizeId(rec?.employee_id);
                                    const mins = minutesMap[recEmpId] || minutesMap[String(rec?.employee_id || '')] || { late: 0, undertime: 0 };
                                    const newLateMins = safeFloat(mins?.late);
                                    const newUndertimeMins = safeFloat(mins?.undertime);

                                    const rr = validateDateRangeTaipei(rec?.start_date, rec?.end_date);
                                    if (!rr.ok || rr.startISO !== vr.startISO || rr.endISO !== vr.endISO) continue;

                                    const dailyRate = safeFloat(rec?.daily_rate);
                                    const minuteRate = dailyRate / 8 / 60;

                                    const oldLateDeduction = safeFloat(rec?.tardiness_deduction);
                                    const oldUndertimeDeduction = safeFloat(rec?.undertime_deduction);

                                    const newLateDeduction = newLateMins * minuteRate;
                                    const newUndertimeDeduction = newUndertimeMins * minuteRate;

                                    const oldBasic = safeFloat(rec?.basic_salary);
                                    const oldGross = safeFloat(rec?.gross_salary);
                                    const totalDeductions = safeFloat(rec?.total_deductions);

                                    const nextBasic = Math.max(0, oldBasic + oldLateDeduction + oldUndertimeDeduction - newLateDeduction - newUndertimeDeduction);
                                    const nextGross = Math.max(0, oldGross + oldLateDeduction + oldUndertimeDeduction - newLateDeduction - newUndertimeDeduction);
                                    const nextNet = Math.max(0, nextGross - totalDeductions);

                                    const nextBreakdown = (() => {
                                      const ds = rec?.deduction_settings || {};
                                      const bd = ds?.breakdown;
                                      if (!bd || typeof bd !== 'object') return ds;

                                      const income = bd?.income || {};
                                      const deductions = bd?.deductions || {};
                                      const summary = bd?.summary || {};

                                      return {
                                        ...ds,
                                        breakdown: {
                                          ...bd,
                                          income: {
                                            ...income
                                          },
                                          deductions: {
                                            ...deductions,
                                            tardiness: newLateDeduction,
                                            undertime: newUndertimeDeduction
                                          },
                                          summary: {
                                            ...summary,
                                            basic_salary: nextBasic,
                                            gross_salary: nextGross,
                                            total_deductions: totalDeductions,
                                            net_pay: nextNet
                                          }
                                        }
                                      };
                                    })();

                                    const payload = {
                                      ...rec,
                                      employee_id: recEmpId || String(rec?.employee_id || ''),
                                      start_date: rr.startISO,
                                      end_date: rr.endISO,
                                      minutes_late: newLateMins,
                                      minutes_undertime: newUndertimeMins,
                                      tardiness_deduction: newLateDeduction,
                                      undertime_deduction: newUndertimeDeduction,
                                      basic_salary: nextBasic,
                                      gross_salary: nextGross,
                                      net_pay: nextNet,
                                      deduction_settings: nextBreakdown
                                    };
                                    delete payload.id;
                                    delete payload.created_at;
                                    delete payload.updated_at;
                                    delete payload._id;

                                    await axiosInstance.post('/payroll/records', payload);
                                    updated += 1;
                                  }

                                  toast.success(`Updated ${updated} record(s)`);
                                  try { await fetchPayrollRecords(); } catch { /* noop */ }
                                };

                                const fetchMapAccounts = async () => {
                                  try {
                                    const response = await axiosInstance.get('/map-accounts');
                                    setMapAccounts(response.data);
                                  } catch (error) {
                                    console.error('Error fetching map accounts:', error);
                                    toast.error('Failed to fetch map accounts');
                                  }
                                };

                                // Filtered Map Accounts
  const filteredMapAccounts = mapAccounts.filter(account => {
    const term = mapSearchTerm.toLowerCase();
    const nameMatch = account.account_name?.toLowerCase().includes(term);
    const creatorMatch = account.created_by?.toLowerCase().includes(term);
    
    // Month Filter
    const monthMatch = mapMonthFilter === 'All' || (account.target_delivery_date && new Date(account.target_delivery_date).toLocaleDateString('en-US', { month: 'long', timeZone: 'UTC' }) === mapMonthFilter);
    
    // Status Filter
    const statusMatch = mapStatusFilter === 'All' || account.account_status === mapStatusFilter;

    return (nameMatch || creatorMatch) && monthMatch && statusMatch;
  }).sort((a, b) => {
    const getRank = (s) => {
      const status = (s || '').toUpperCase();
      if (status.includes('HOT')) return 1;
      if (status.includes('WARM')) return 2;
      if (status.includes('DEVELOPING')) return 3;
      return 4;
    };

    const rankA = getRank(a.account_status);
    const rankB = getRank(b.account_status);

    if (rankA !== rankB) return rankA - rankB;

    // Secondary sort: Target Delivery Date (Nearest first)
    const dateA = a.target_delivery_date ? new Date(a.target_delivery_date) : new Date(8640000000000000);
    const dateB = b.target_delivery_date ? new Date(b.target_delivery_date) : new Date(8640000000000000);
    
    return dateA - dateB;
  });

  const handleExportMapExcel = () => {
    // 1. Define Headers (Main Titles)
    const headerRow1 = [
      ...(user?.is_super_admin ? ['Created By'] : []),
      'Name of Account', 'End-user', 'Address', 'Province / Area', 'Industry', 
      'Present Setup', 'Decision Maker', 'Position', 'Tel. No.', 'Mobile No.', 
      'Email Address', 'Current Product/s Offered', 'Price Offered', 
      'Justification/s for the Purchase', 'Stage of the Sale', 'Account Status', 
      'Result Of Call', 'Product Final Offering', 'Quantity', 'Unit Cost', 
      'Total Cost', 'Target Delivery Date'
    ];

    // 2. Define Descriptions (Sub-headers matching the UI)
    const headerRow2 = [
      ...(user?.is_super_admin ? ['System Tag'] : []),
      'Official Name of the Company or Corporation',
      'Department, Branches, Satellite Offices, Affiliates',
      'Building and Street',
      'Area',
      'Government or Corporate Accounts (Logistics, Construction, Bank & Finance, BPO, Manufacturing, etc)',
      'List of all machines in use pertaining to copying, scanning, printing, finishing and shredding. Indicate brand and model, TCP, and Monthly Print Volume (MPV)',
      'Who is final decision maker?',
      'Position of Decision Maker',
      'Direct line of Contact Person and Company Trunkline',
      'Mobile of Contact Person',
      'Email address of Contact Person and company email',
      'What products (brand and model) are most needed and you propose to the account.',
      'Price of the machine or package of machines. Indicate TCP rate offered if any.',
      'List all the reasons that you can use to justify the purchase of the offered product/s.',
      'Approach; Survey; Presentation; Proposal; Demonstration; Closing; Delivery.',
      'HOT (Delivery in 30 Days); WARM (Delivery in 31 to 60 Days); DEVELOPING (Delivery after 60 Days).',
      'Indicate whether Positive or Negative and why so. Type on top of previous call results, so that the one on top will be the most current.',
      '', '', '', '', '' // Empty descriptions for the last few columns
    ];

    // 3. Map Data Rows
    const dataRows = filteredMapAccounts.map(account => [
      ...(user?.is_super_admin ? [account.created_by || ''] : []),
      account.account_name, account.end_user, account.address, account.province_area, 
      account.industry, account.present_setup, account.decision_maker, account.position, 
      account.tel_no, account.mobile_no, account.email_address, account.current_products, 
      account.price_offered, account.justification, account.stage_of_sale, 
      account.account_status, account.result_of_call, account.product_final_offering, 
      account.quantity, 
      account.unit_cost ? new Intl.NumberFormat('en-PH', { style: 'currency', currency: 'PHP' }).format(account.unit_cost) : '', 
      account.total_cost ? new Intl.NumberFormat('en-PH', { style: 'currency', currency: 'PHP' }).format(account.total_cost) : '', 
      account.target_delivery_date
    ]);

    // 4. Construct Excel (XML/HTML) Content
    // We use an HTML table saved as .xls to support formatting (colors, wrapping, text format)
    // mso-number-format:"\@" forces all cells to be treated as Text
    const tableHTML = `
      <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">
        <!--[if gte mso 9]>
        <xml>
          <x:ExcelWorkbook>
            <x:ExcelWorksheets>
              <x:ExcelWorksheet>
                <x:Name>Map Accounts</x:Name>
                <x:WorksheetOptions>
                  <x:DisplayGridlines/>
                </x:WorksheetOptions>
              </x:ExcelWorksheet>
            </x:ExcelWorksheets>
          </x:ExcelWorkbook>
        </xml>
        <![endif]-->
        <style>
          body { font-family: Arial, sans-serif; }
          table { border-collapse: collapse; width: 100%; }
          td, th { border: 1px solid #000000; padding: 5px; vertical-align: top; mso-number-format:"\@"; }
          .header-row-1 { font-weight: bold; background-color: #FFFFFF; }
          .header-row-2 { 
            background-color: #4472C4; 
            color: #FFFFFF; 
            font-weight: bold; 
            white-space: normal; 
            text-align: center;
            vertical-align: middle;
          }
        </style>
      </head>
      <body>
        <table>
          <thead>
            <tr class="header-row-1">
              ${headerRow1.map(h => `<th>${h}</th>`).join('')}
            </tr>
            <tr class="header-row-2">
              ${headerRow2.map(h => `<th>${h}</th>`).join('')}
            </tr>
          </thead>
          <tbody>
            ${dataRows.map(row => `
              <tr>
                ${row.map(cell => `<td>${cell || ''}</td>`).join('')}
              </tr>
            `).join('')}
          </tbody>
        </table>
      </body>
      </html>
    `;

    // 5. Trigger Download as .xls
    const blob = new Blob([tableHTML], { type: 'application/vnd.ms-excel' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `map_accounts_${new Date().toISOString().split('T')[0]}.xls`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleExportMapPDF = () => {
    const doc = new jsPDF('l', 'pt', 'a4'); // Landscape orientation
    
    const headers = [[
      ...(user?.is_super_admin ? ['Created By'] : []),
      'Name', 'End-user', 'Address', 'Contact', 'Stage', 'Status', 'Total Cost'
    ]];

    const data = filteredMapAccounts.map(account => [
      ...(user?.is_super_admin ? [account.created_by || ''] : []),
      account.account_name,
      account.end_user,
      account.address,
      `${account.mobile_no || ''} / ${account.tel_no || ''}`,
      account.stage_of_sale,
      account.account_status,
      account.total_cost ? new Intl.NumberFormat('en-PH', { style: 'currency', currency: 'PHP' }).format(account.total_cost) : ''
    ]);

    autoTable(doc, {
      head: headers,
      body: data,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [66, 139, 202] }, // Blue header
    });

    doc.save(`map_accounts_${new Date().toISOString().split('T')[0]}.pdf`);
  };

  const handleExportMapCSV = () => {
    // 1. Define Headers (matching the Table columns)
    const headers = [
      ...(user?.is_super_admin ? ['Created By'] : []),
      'Name of Account', 'End-user', 'Address', 'Province / Area', 'Industry', 
      'Present Setup', 'Decision Maker', 'Position', 'Tel. No.', 'Mobile No.', 
      'Email Address', 'Current Product/s Offered', 'Price Offered', 
      'Justification/s for the Purchase', 'Stage of the Sale', 'Account Status', 
      'Result Of Call', 'Product Final Offering', 'Quantity', 'Unit Cost', 
      'Total Cost', 'Target Delivery Date'
    ];

    // 2. Map Data Rows
    const rows = filteredMapAccounts.map(account => {
      return [
        ...(user?.is_super_admin ? [account.created_by || ''] : []),
        account.account_name, account.end_user, account.address, account.province_area, 
        account.industry, account.present_setup, account.decision_maker, account.position, 
        account.tel_no, account.mobile_no, account.email_address, account.current_products, 
        account.price_offered, account.justification, account.stage_of_sale, 
        account.account_status, account.result_of_call, account.product_final_offering, 
        account.quantity, account.unit_cost, account.total_cost, account.target_delivery_date
      ].map(field => {
        // Handle fields containing commas, quotes, or newlines
        const stringField = String(field || '');
        if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\n')) {
          return `"${stringField.replace(/"/g, '""')}"`;
        }
        return stringField;
      });
    });

    // 3. Construct CSV Content
    const csvContent = [
      headers.join(','),
      ...rows.map(row => row.join(','))
    ].join('\n');

    // 4. Trigger Download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `map_accounts_${new Date().toISOString().split('T')[0]}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleImportMapCSV = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (e) => {
      const text = e.target.result;
      const lines = text.split('\n').filter(line => line.trim() !== '');
      
      if (lines.length < 2) {
        toast.error('CSV file is empty or missing headers');
        return;
      }

      // Parse headers
      // We assume the standard header format as exported
      // Simple CSV parsing (handling quotes is complex, but for this use case we'll do a basic split if quotes aren't heavily used, 
      // or a slightly more robust regex split)
      
      // Regex to split by comma, ignoring commas inside quotes
      const splitCSV = (str) => {
        const matches = str.match(/(".*?"|[^",\s]+)(?=\s*,|\s*$)/g);
        // Fallback for simple split if regex fails or for cleaner lines
        if (!matches) return str.split(',');
        return matches.map(m => m.replace(/^"|"$/g, '').replace(/""/g, '"'));
      };

      // Better regex for CSV parsing
      const parseCSVLine = (text) => {
        const re_value = /(?!\s*$)\s*(?:'([^']*(?:''[^']*)*)'|"([^"]*(?:""[^"]*)*)"|([^,'"\s\\]*(?:\s+[^,'"\s\\]+)*))\s*(?:,|$)/g;
        const a = [];
        text.replace(re_value, (m0, m1, m2, m3) => {
            if      (m1 !== undefined) a.push(m1.replace(/''/g, "'"));
            else if (m2 !== undefined) a.push(m2.replace(/""/g, '"'));
            else if (m3 !== undefined) a.push(m3);
            return '';
        });
        if (/,\s*$/.test(text)) a.push('');
        return a;
      };

      const headers = parseCSVLine(lines[0]);
      
      // Mapping headers to keys
      // Note: This mapping depends on the CSV headers matching the Export headers
      const headerMap = {
        'Name of Account': 'account_name',
        'End-user': 'end_user',
        'Address': 'address',
        'Province / Area': 'province_area',
        'Industry': 'industry',
        'Present Setup': 'present_setup',
        'Decision Maker': 'decision_maker',
        'Position': 'position',
        'Tel. No.': 'tel_no',
        'Mobile No.': 'mobile_no',
        'Email Address': 'email_address',
        'Current Product/s Offered': 'current_products',
        'Price Offered': 'price_offered',
        'Justification/s for the Purchase': 'justification',
        'Stage of the Sale': 'stage_of_sale',
        'Account Status': 'account_status',
        'Result Of Call': 'result_of_call',
        'Product Final Offering': 'product_final_offering',
        'Quantity': 'quantity',
        'Unit Cost': 'unit_cost',
        'Total Cost': 'total_cost',
        'Target Delivery Date': 'target_delivery_date'
      };

      let successCount = 0;
      let failCount = 0;
      let skippedCount = 0;

      // Create a set of existing accounts for efficient lookup
      // Key format: "account_name|end_user" (lowercase for case-insensitive check)
      const existingAccountsSet = new Set(
        mapAccounts.map(account => {
          const name = (account.account_name || '').trim().toLowerCase();
          const endUser = (account.end_user || '').trim().toLowerCase();
          return `${name}|${endUser}`;
        })
      );

      for (let i = 1; i < lines.length; i++) {
        try {
          const row = parseCSVLine(lines[i]);
          if (row.length === 0) continue;

          const accountData = {};
          let hasData = false;

          headers.forEach((header, index) => {
            const key = headerMap[header.trim()];
            if (key) {
               let value = row[index];
               if (value) {
                 value = value.trim();
                 hasData = true;
               }
               
               // Type conversions
               if (key === 'quantity' || key === 'unit_cost' || key === 'total_cost') {
                 value = value ? parseFloat(value) : null;
               }
               
               accountData[key] = value;
            }
          });

          if (!hasData || !accountData.account_name) {
            continue; // Skip empty rows or rows without account name
          }

          // Check for duplicates
          const currentName = (accountData.account_name || '').trim().toLowerCase();
          const currentEndUser = (accountData.end_user || '').trim().toLowerCase();
          const uniqueKey = `${currentName}|${currentEndUser}`;

          if (existingAccountsSet.has(uniqueKey)) {
            console.log(`Skipping duplicate: ${accountData.account_name} - ${accountData.end_user}`);
            skippedCount++;
            continue;
          }

          // Send to API
          await axiosInstance.post('/map-accounts', accountData);
          successCount++;
          
          // Add to set to prevent duplicates within the same import file
          existingAccountsSet.add(uniqueKey);

        } catch (error) {
          console.error(`Error importing row ${i + 1}:`, error);
          failCount++;
        }
      }

      toast.success(`Import complete: ${successCount} imported, ${skippedCount} skipped, ${failCount} failed`);
      fetchMapAccounts();
      
      // Reset file input
      if (csvInputRef.current) {
        csvInputRef.current.value = '';
      }
    };
    reader.readAsText(file);
  };

  const handleSaveMapAccount = async () => {
                                  try {
                                    const payload = {
                                      ...mapAccountData,
                                      quantity: mapAccountData.quantity === '' || isNaN(Number(mapAccountData.quantity)) ? null : Number(mapAccountData.quantity),
                                      unit_cost: mapAccountData.unit_cost === '' || isNaN(Number(mapAccountData.unit_cost)) ? null : Number(mapAccountData.unit_cost),
                                      total_cost: mapAccountData.total_cost === '' || isNaN(Number(mapAccountData.total_cost)) ? null : Number(mapAccountData.total_cost),
                                      target_delivery_date: mapAccountData.target_delivery_date === '' ? null : mapAccountData.target_delivery_date
                                    };

                                    await axiosInstance.post('/map-accounts', payload);
                                    toast.success('Account saved successfully');
                                    setShowMapAccountModal(false);
                                    fetchMapAccounts();
                                    setMapAccountData({
                                      account_name: '',
                                      end_user: '',
                                      address: '',
                                      province_area: '',
                                      industry: '',
                                      present_setup: '',
                                      decision_maker: '',
                                      position: '',
                                      tel_no: '',
                                      mobile_no: '',
                                      email_address: '',
                                      current_products: '',
                                      price_offered: '',
                                      justification: '',
                                      stage_of_sale: '',
                                      account_status: '',
                                      result_of_call: '',
                                      product_final_offering: '',
                                      quantity: '',
                                      unit_cost: '',
                                      total_cost: '',
                                      target_delivery_date: ''
                                    });
                                  } catch (error) {
                                    console.error('Error saving map account:', error);
                                    toast.error('Failed to save account');
                                  }
                                };

                                const handleEditClick = (account) => {
                                  setEditingAccountId(account.id);
                                  setEditFormData({ ...account });
                                };

                                const handleCancelEdit = () => {
                                  setEditingAccountId(null);
                                  setEditFormData({});
                                };

                                const handleSaveEdit = async () => {
                                  try {
                                    const payload = {
                                      ...editFormData,
                                      quantity: editFormData.quantity === '' || isNaN(Number(editFormData.quantity)) ? null : Number(editFormData.quantity),
                                      unit_cost: editFormData.unit_cost === '' || isNaN(Number(editFormData.unit_cost)) ? null : Number(editFormData.unit_cost),
                                      total_cost: editFormData.total_cost === '' || isNaN(Number(editFormData.total_cost)) ? null : Number(editFormData.total_cost),
                                      target_delivery_date: editFormData.target_delivery_date === '' ? null : editFormData.target_delivery_date
                                    };

                                    await axiosInstance.put(`/map-accounts/${editingAccountId}`, payload);
                                    toast.success('Account updated successfully');
                                    setEditingAccountId(null);
                                    fetchMapAccounts();
                                  } catch (error) {
                                    console.error('Error updating account:', error);
                                    toast.error('Failed to update account');
                                  }
                                };

                                const handleDeleteMapAccount = async (accountId) => {
                                  const confirmed = await confirmDialog({
                                      title: "Delete Account",
                                      description: "Are you sure you want to delete this account?",
                                      variant: "destructive"
                                  });
                                  if (confirmed) {
                                    try {
                                      await axiosInstance.delete(`/map-accounts/${accountId}`);
                                      toast.success('Account deleted successfully');
                                      fetchMapAccounts();
                                    } catch (error) {
                                      console.error('Error deleting account:', error);
                                      toast.error('Failed to delete account');
                                    }
                                  }
                                };

                                // Function to delete a payroll record
                                const deletePayrollRecord = async (recordId) => {
                                  const confirmed = await confirmDialog({
                                      title: "Delete Payroll Record",
                                      description: "Are you sure you want to delete this payroll record?",
                                      variant: "destructive"
                                  });
                                  if (!confirmed) {
                                    return;
                                  }
                                  
                                  try {
                                    const source = payrollDatabaseTab === 'mf' ? 'mf' : 'payroll';
                                    await axiosInstance.delete(`/payroll/records/${recordId}?source=${source}`);
                                    toast.success('Payroll record deleted successfully');
                                    fetchPayrollRecords(); // Refresh the list
                                    try { await fetchPayrollLoans({ quiet: true }); } catch { /* noop */ }
                                  } catch (error) {
                                    console.error('Error deleting payroll record:', error);
                                    toast.error('Failed to delete payroll record');
                                  }
                                };

                                const deletePayrollRecordsByPeriods = async ({ periods, source } = {}) => {
                                  const normalizedPeriods = Array.isArray(periods)
                                    ? periods
                                        .map((period) => {
                                          const raw = period && typeof period === 'object' ? period : {};
                                          const payrollPeriod = String(raw.payroll_period || '').trim();
                                          const startDate = String(raw.start_date || '').trim();
                                          const endDate = String(raw.end_date || '').trim();
                                          if (!startDate || !endDate) return null;
                                          return {
                                            payroll_period: payrollPeriod || null,
                                            start_date: startDate,
                                            end_date: endDate
                                          };
                                        })
                                        .filter(Boolean)
                                    : [];

                                  if (normalizedPeriods.length === 0) {
                                    toast.error('Please select at least one payroll period');
                                    return false;
                                  }

                                  const normalizedSource = source === 'mf' ? 'mf' : 'payroll';
                                  const label = normalizedSource === 'mf' ? 'MF payslip' : 'payroll payslip';
                                  const confirmed = await confirmDialog({
                                    title: "Delete Payroll Register",
                                    description: `Delete all ${label}s under ${normalizedPeriods.length} selected period(s)?`,
                                    variant: "destructive"
                                  });
                                  if (!confirmed) {
                                    return false;
                                  }

                                  try {
                                    const response = await axiosInstance.post('/payroll/records/delete-by-periods', {
                                      source: normalizedSource,
                                      periods: normalizedPeriods
                                    });
                                    const deletedCount = Number(response?.data?.deleted_count) || 0;
                                    if (deletedCount > 0) {
                                      toast.success(`Deleted ${deletedCount} ${label}${deletedCount === 1 ? '' : 's'} successfully`);
                                    } else {
                                      toast.success(`No ${label}s were found in the selected period(s)`);
                                    }
                                    setSelectedPayrollRecordEmployeeKey(null);
                                    await fetchPayrollRecords();
                                    try { await fetchPayrollLoans({ quiet: true }); } catch { /* noop */ }
                                    return true;
                                  } catch (error) {
                                    console.error('Error deleting payroll periods:', error);
                                    toast.error('Failed to delete payroll register');
                                    return false;
                                  }
                                };



                                const calculateEmployeeRunningStats = async (employee) => {
                                  if (!employee) return;
                                  
                                  try {
                                    // Get all-time attendance records for this employee
                                    const attendanceResponse = await axiosInstance.get('/attendance');
                                    const allAttendanceRecords = attendanceResponse.data;
                                    
                                    // Filter records for selected employee
                                    const employeeRecords = allAttendanceRecords.filter(record => 
                                      record.user_id === employee.id
                                    );
                                    
                                    // Get payroll employee data for salary information
                                    const payrollResponse = await axiosInstance.get('/payroll/employees');
                                    const payrollEmployees = payrollResponse.data;
                                    const payrollEmployee = payrollEmployees.find(emp => emp.employee_id === employee.id);
                                    
                                    // Group records by date to count present/absent days
                                    const recordsByDate = {};
                                    let totalLateMinutes = 0;
                                    let totalUndertimeMinutes = 0;
                                    
                                    employeeRecords.forEach(record => {
                                      const recordDate = record.timestamp ? record.timestamp.split('T')[0] : null;
                                      if (!recordDate) return;
                                      
                                      if (!recordsByDate[recordDate]) {
                                        recordsByDate[recordDate] = { present: false, late: 0, undertime: 0 };
                                      }
                                      
                                      // Mark as present if there's a time_in record
                                      if (record.type === 'time_in') {
                                        recordsByDate[recordDate].present = true;
                                        
                                        // Extract late minutes from status_message if available
                                        if (record.status === 'late' && record.status_message) {
                                          const lateMatch = record.status_message.match(/Late by (\d+) hours? (\d+) minutes?/);
                                          if (lateMatch) {
                                            const hours = parseInt(lateMatch[1]) || 0;
                                            const minutes = parseInt(lateMatch[2]) || 0;
                                            const totalMinutes = hours * 60 + minutes;
                                            recordsByDate[recordDate].late = totalMinutes;
                                            totalLateMinutes += totalMinutes;
                                          }
                                        }
                                      }
                                      
                                      // Extract undertime minutes from status_message if available
                                      if (record.type === 'time_out' && record.status === 'undertime' && record.status_message) {
                                        const undertimeMatch = record.status_message.match(/Undertime by (\d+) hours? (\d+) minutes?/);
                                        if (undertimeMatch) {
                                          const hours = parseInt(undertimeMatch[1]) || 0;
                                          const minutes = parseInt(undertimeMatch[2]) || 0;
                                          const totalMinutes = hours * 60 + minutes;
                                          recordsByDate[recordDate].undertime = totalMinutes;
                                          totalUndertimeMinutes += totalMinutes;
                                        }
                                      }
                                    });
                                    
                                    // Calculate stats
                                    const presentDays = Object.values(recordsByDate).filter(day => day.present).length;
                                    const totalDays = Object.keys(recordsByDate).length;
                                    const absentDays = Math.max(0, totalDays - presentDays);
                                    
                                    // Calculate deductions if payroll employee exists
                                    let totalDeductions = 0;
                                    let netSalary = 0;
                                    
                                    if (payrollEmployee) {
                                      const monthlySalary = parseFloat(payrollEmployee.salary) || 0;
                                      const dailyRate = (monthlySalary * 12) / 313;
                                      
                                      // Calculate late/undertime deductions
                                      const lateDeductions = (totalLateMinutes * dailyRate) / (8 * 60);
                                      const undertimeDeductions = (totalUndertimeMinutes * dailyRate) / (8 * 60);
                                      
                                      // Calculate Gross Salary for deductions
                                      const allowances = payrollEmployee.allowances || {};
                                      const totalAllowances = (parseFloat(allowances.mf) || 0) + 
                                                              (parseFloat(allowances.gas_allowance) || 0) + 
                                                              (parseFloat(allowances.load_allowance) || 0) + 
                                                              (parseFloat(allowances.housing_allowance) || 0);
                                      const grossSalary = monthlySalary + totalAllowances;

                                      // Add government deductions (sample calculation)
                                      let governmentDeductions = 0;
                                      if (payrollEmployee.deductions?.sss) governmentDeductions += monthlySalary * 0.045;
                                      if (payrollEmployee.deductions?.phic) governmentDeductions += Math.min(grossSalary * 0.05, 5000);
                                      if (payrollEmployee.deductions?.hdmf) governmentDeductions += 100;
                                      if (payrollEmployee.tax_enabled && !payrollEmployee.is_minimum_wage) {
                                        governmentDeductions += monthlySalary * 0.1;
                                      }
                                      
                                      totalDeductions = lateDeductions + undertimeDeductions + governmentDeductions;
                                      netSalary = monthlySalary - totalDeductions;
                                    }
                                    
                                    setEmployeeRunningStats({
                                      present_days: presentDays,
                                      absent_days: absentDays,
                                      total_lates: totalLateMinutes,
                                      total_undertime: totalUndertimeMinutes,
                                      total_deductions: totalDeductions,
                                      net_salary: Math.max(0, netSalary)
                                    });
                                    
                                  } catch (error) {
                                    console.error('Error calculating employee running stats:', error);
                                    toast.error('Failed to calculate employee statistics');
                                  }
                                };

// Pricing Template Functions Removed

                                const calculateDailyRate = (formula) => {
                                  const salary = parseFloat(payrollData.salary) || 0;
                                  if (salary === 0) {
                                    toast.error('Please enter a salary amount first');
                                    return;
                                  }
                                  
                                  let dailyRate = 0;
                                  if (formula === '313') {
                                    dailyRate = (salary * 12) / 313;
                                  } else if (formula === '261') {
                                    dailyRate = (salary * 12) / 261;
                                  }
                                  
                                  setDailyRateFormula(formula);
                                  setCalculatedDailyRate(dailyRate);
                                  toast.success(`Daily rate calculated using ${formula} formula: \u20b1${dailyRate.toFixed(2)}`);
                                };

                                // computeDailyRateFromBasis now imported from payrollUtils
                                const runDailyRateSelfTests = () => {
                                  const r261 = computeDailyRateFromBasis(10000, 261).toFixed(2);
                                  const r313 = computeDailyRateFromBasis(10000, 313).toFixed(2);
                                  const ok = r261 === '459.77' && r313 === '383.39';
                                  console.log('DailyRate tests:', { r261, r313, ok });
                                  return ok;
                                };

                                // Helper function to get machine color based on approved billing statement upload timing
                                const getMachineColorClass = (machineId) => {
                                  // Check if machine has been acknowledged (clicked) in SI tab
                                  if (acknowledgedSIMachines.has(machineId)) {
                                    return {
                                      bg: 'bg-gray-50',
                                      border: 'border-gray-300',
                                      icon: 'bg-gray-200',
                                      iconText: 'text-gray-800 dark:text-white',
                                      text: 'text-gray-800 dark:text-white'
                                    };
                                  }

                                  // Find the latest approved billing statement for this machine
                                  const machineExports = billingExports.filter(exp => {
                                    const exportMachineId = exp.machineId || exp.machine_id;
                                    return String(exportMachineId) === String(machineId);
                                  });
                                  const uploadsWithTimestamp = machineExports
                                    .filter(exp => exp.approvedBillingStatementUrl && exp.approvedBillingStatementUploadedAt)
                                    .sort((a, b) => new Date(b.approvedBillingStatementUploadedAt) - new Date(a.approvedBillingStatementUploadedAt));
                                  
                                  if (uploadsWithTimestamp.length === 0) {
                                    // No uploads - return gray (neutral)
                                    return {
                                      bg: 'bg-gray-50',
                                      border: 'border-gray-300',
                                      icon: 'bg-gray-200',
                                      iconText: 'text-gray-800 dark:text-white',
                                      text: 'text-gray-800 dark:text-white'
                                    };
                                  }

                                  const latestUpload = uploadsWithTimestamp[0];
                                  const uploadTime = new Date(latestUpload.approvedBillingStatementUploadedAt);
                                  const now = new Date();
                                  const hoursDiff = (now - uploadTime) / (1000 * 60 * 60); // Difference in hours

                                  if (hoursDiff <= 24) {
                                    // Within 24 hours - Green
                                    return {
                                      bg: 'bg-green-50',
                                      border: 'border-green-300',
                                      icon: 'bg-green-200',
                                      iconText: 'text-green-800',
                                      text: 'text-green-800'
                                    };
                                  } else if (hoursDiff <= 48) {
                                    // 24-48 hours - Yellow
                                    return {
                                      bg: 'bg-yellow-50',
                                      border: 'border-yellow-300',
                                      icon: 'bg-yellow-200',
                                      iconText: 'text-yellow-800',
                                      text: 'text-yellow-800'
                                    };
                                  } else {
                                    // Past 48 hours - Red
                                    return {
                                      bg: 'bg-red-50',
                                      border: 'border-red-300',
                                      icon: 'bg-red-200',
                                      iconText: 'text-red-800',
                                      text: 'text-red-800'
                                    };
                                  }
                                };

                                // Color class function for Billing Tab - based on latest meter reading
                                const getBillingMachineColorClass = (machine) => {
                                  // Check if machine has been acknowledged (clicked)
                                  if (acknowledgedBillingMachines.has(machine.id)) {
                                    return {
                                      bg: 'bg-gray-50',
                                      border: 'border-gray-300',
                                      icon: 'bg-gray-200',
                                      iconText: 'text-gray-800 dark:text-white',
                                      text: 'text-gray-800 dark:text-white'
                                    };
                                  }

                                  // Get all meter readings for this machine
                                  const allReadings = machine.meterReadings || [];
                                  
                                  if (allReadings.length === 0) {
                                    // No readings - return gray (neutral)
                                    return {
                                      bg: 'bg-gray-50',
                                      border: 'border-gray-300',
                                      icon: 'bg-gray-200',
                                      iconText: 'text-gray-800 dark:text-white',
                                      text: 'text-gray-800 dark:text-white'
                                    };
                                  }

                                  // Sort readings by presentDate to get the latest
                                  const sortedReadings = [...allReadings].sort((a, b) => 
                                    new Date(b.presentDate || 0) - new Date(a.presentDate || 0)
                                  );
                                  const latestReading = sortedReadings[0];

                                  if (!latestReading || !latestReading.presentDate) {
                                    return {
                                      bg: 'bg-gray-50',
                                      border: 'border-gray-300',
                                      icon: 'bg-gray-200',
                                      iconText: 'text-gray-800 dark:text-white',
                                      text: 'text-gray-800 dark:text-white'
                                    };
                                  }

                                  const readingTime = new Date(latestReading.presentDate);
                                  const now = new Date();
                                  const hoursDiff = (now - readingTime) / (1000 * 60 * 60); // Difference in hours

                                  if (hoursDiff <= 24) {
                                    // Within 24 hours - Green
                                    return {
                                      bg: 'bg-green-50',
                                      border: 'border-green-300',
                                      icon: 'bg-green-200',
                                      iconText: 'text-green-800',
                                      text: 'text-green-800'
                                    };
                                  } else if (hoursDiff <= 48) {
                                    // 24-48 hours - Yellow
                                    return {
                                      bg: 'bg-yellow-50',
                                      border: 'border-yellow-300',
                                      icon: 'bg-yellow-200',
                                      iconText: 'text-yellow-800',
                                      text: 'text-yellow-800'
                                    };
                                  } else {
                                    // Past 48 hours - Red
                                    return {
                                      bg: 'bg-red-50',
                                      border: 'border-red-300',
                                      icon: 'bg-red-200',
                                      iconText: 'text-red-800',
                                      text: 'text-red-800'
                                    };
                                  }
                                };

                                // Color class function for Collection Tab - based on SI generation (25-day logic)
                                const getCollectionMachineColorClass = (machineId) => {
                                  // Check if machine has been acknowledged (clicked)
                                  if (acknowledgedCollectionMachines.has(machineId)) {
                                    return {
                                      bg: 'bg-gray-50',
                                      border: 'border-gray-300',
                                      icon: 'bg-gray-200',
                                      iconText: 'text-gray-800 dark:text-white',
                                      text: 'text-gray-800 dark:text-white'
                                    };
                                  }

                                  // Find SI generation records for this machine (we'll track when SIs are generated)
                                  // For now, we'll use the approved billing statement upload as a proxy
                                  // TODO: Add proper SI generation tracking
                                  const machineExports = (billingExports || []).filter(exp => 
                                    (exp.machineId || exp.machine_id) === machineId
                                  );
                                  
                                  const uploadsWithTimestamp = machineExports
                                    .filter(exp => exp.approvedBillingStatementUrl && exp.approvedBillingStatementUploadedAt)
                                    .sort((a, b) => new Date(b.approvedBillingStatementUploadedAt) - new Date(a.approvedBillingStatementUploadedAt));
                                  
                                  if (uploadsWithTimestamp.length === 0) {
                                    // No SI generated - return gray (neutral)
                                    return {
                                      bg: 'bg-gray-50',
                                      border: 'border-gray-300',
                                      icon: 'bg-gray-200',
                                      iconText: 'text-gray-800 dark:text-white',
                                      text: 'text-gray-800 dark:text-white'
                                    };
                                  }

                                  const latestSI = uploadsWithTimestamp[0];
                                  const siTime = new Date(latestSI.approvedBillingStatementUploadedAt);
                                  const now = new Date();
                                  const daysDiff = (now - siTime) / (1000 * 60 * 60 * 24); // Difference in days

                                  if (daysDiff <= 25) {
                                    // Within 25 days - Green
                                    return {
                                      bg: 'bg-green-50',
                                      border: 'border-green-300',
                                      icon: 'bg-green-200',
                                      iconText: 'text-green-800',
                                      text: 'text-green-800'
                                    };
                                  } else if (daysDiff <= 26) {
                                    // Day 26 - Yellow
                                    return {
                                      bg: 'bg-yellow-50',
                                      border: 'border-yellow-300',
                                      icon: 'bg-yellow-200',
                                      iconText: 'text-yellow-800',
                                      text: 'text-yellow-800'
                                    };
                                  } else {
                                    // Day 27+ - Red
                                    return {
                                      bg: 'bg-red-50',
                                      border: 'border-red-300',
                                      icon: 'bg-red-200',
                                      iconText: 'text-red-800',
                                      text: 'text-red-800'
                                    };
                                  }
                                };

                                const fetchEmployees = async () => {
                                  try {
                                    const response = await axiosInstance.get('/users/all');
                                    const all = Array.isArray(response?.data) ? response.data : [];
                                    setEmployees(all.filter((u) => u.role === 'employee' && !u.is_super_admin));
                                  } catch (error) {
                                    console.error('Error fetching employees:', error);
                                    toast.error('Failed to fetch employees');
                                  }
                                };

                                const fetchAdmins = async () => {
                                  try {
                                    const response = await axiosInstance.get('/users/all');
                                    const all = Array.isArray(response?.data) ? response.data : [];
                                    setAdmins(all.filter((u) => u.role === 'admin' || !!u.is_super_admin));
                                  } catch (error) {
                                    console.error('Error fetching admins:', error);
                                    toast.error('Failed to fetch admin accounts');
                                  }
                                };

                                const fetchAttendance = async (fetchAll = isAllAttendanceLoaded) => {
                                  if (fetchAll) {
                                    // "Load More": fetch ALL remaining records, metadata only (no photos)
                                    // for a lighter/faster payload, then merge so the initial subset
                                    // keeps its already-loaded photos.
                                    setIsLoadingMoreAttendance(true);
                                    try {
                                      const response = await axiosInstance.get('/attendance?include_photos=false');
                                      const fullRecords = Array.isArray(response.data) ? response.data : [];
                                      setAttendance(prev => {
                                        const photoById = new Map();
                                        (Array.isArray(prev) ? prev : []).forEach(r => {
                                          if (r && r.id && (r.photo_url || r.rear_photo_url)) {
                                            photoById.set(r.id, r);
                                          }
                                        });
                                        // Full set is authoritative for completeness; overlay photos
                                        // from the initial (recent) subset where available.
                                        return fullRecords.map(r => (r && photoById.has(r.id) ? photoById.get(r.id) : r));
                                      });
                                      setIsAllAttendanceLoaded(true);
                                    } catch (error) {
                                      console.error('Error fetching attendance:', error);
                                      toast.error(error.response?.data?.detail || 'Failed to load all attendance records');
                                    } finally {
                                      setIsLoadingMoreAttendance(false);
                                    }
                                    return;
                                  }

                                  // Initial / partial load: recent ~month WITH photos
                                  try {
                                    const endDate = new Date();
                                    const startDate = new Date(endDate.getFullYear(), endDate.getMonth() - 1, 1);
                                    const formatDate = (date) => date.toISOString().split('T')[0];
                                    const url = `/attendance?start_date=${formatDate(startDate)}&end_date=${formatDate(endDate)}`;

                                    const response = await axiosInstance.get(url);
                                    setAttendance(response.data);
                                    setIsAllAttendanceLoaded(false);
                                  } catch (error) {
                                    console.error('Error fetching attendance:', error);
                                    toast.error(error.response?.data?.detail || 'Failed to fetch attendance records');
                                  }
                                };

                                useEffect(() => {
                                  const shouldPollAttendanceReports =
                                    activeMenuItem === 'reports' &&
                                    activeReportTab === 'daily' &&
                                    currentPage === 1 &&
                                    !isAllAttendanceLoaded;

                                  if (!shouldPollAttendanceReports) return;

                                  fetchAttendance(false);
                                  const intervalId = setInterval(() => {
                                    fetchAttendance(false);
                                  }, 5000);

                                  return () => clearInterval(intervalId);
                                }, [activeMenuItem, activeReportTab, currentPage, isAllAttendanceLoaded]);

                                const fetchDashboardStats = async () => {
                                  try {
                                    const response = await axiosInstance.get('/attendance/dashboard-stats');
                                    console.log('Dashboard stats loaded:', response.data);
                                    setDashboardStats(response.data);
                                  } catch (error) {
                                    console.error('Error fetching dashboard stats:', error);
                                    console.error('Error details:', error.response?.data);
                                    toast.error('Failed to load dashboard stats. Using fallback calculation.');
                                    setDashboardStats(null);
                                  }
                                };

                                const fetchStats = async () => {
                                  try {
                                    const response = await axiosInstance.get('/dashboard/stats');
                                    setStats(response.data);
                                  } catch (error) {
                                    console.error('Error fetching stats:', error);
                                    toast.error('Failed to fetch dashboard statistics');
                                  }
                                };

                                const fetchBranchSchedules = async () => {
                                  try {
                                    const response = await axiosInstance.get('/schedules');
                                    setBranchSchedules(response.data);
                                  } catch (error) {
                                    console.error('Error fetching branch schedules:', error);
                                    toast.error('Failed to fetch branch schedules');
                                  }
                                };

                                const fetchPayrollEmployees = async () => {
                                  try {
                                    const response = await axiosInstance.get('/payroll/employees');
                                    setPayrollEmployees(response.data);
                                  } catch (error) {
                                    console.error('Error fetching payroll employees:', error);
                                    toast.error('Failed to fetch payroll employees');
                                  }
                                };

                                const fetchPayrollStats = async () => {
                                  try {
                                    const response = await axiosInstance.get('/payroll/dashboard/stats');
                                    setPayrollStats(response.data);
                                  } catch (error) {
                                    console.error('Error fetching payroll stats:', error);
                                    toast.error('Failed to fetch payroll statistics');
                                  }
                                };

                                const fetchProjects = async () => {
                                  try {
                                    const response = await axiosInstance.get('/projects');
                                    setProjects(response.data);
                                    console.log(`Loaded ${response.data.length} projects from database`);
                                  } catch (error) {
                                    console.error('Error fetching projects:', error);
                                    toast.error('Failed to fetch projects');
                                  }
                                };

                                const fetchProjectTasks = async (projectId) => {
                                  try {
                                    const response = await axiosInstance.get(`/projects/${projectId}/tasks`);
                                    setProjectTasks(response.data);
                                    console.log(`Loaded ${response.data.length} tasks for project ${projectId}`);
                                  } catch (error) {
                                    console.error('Error fetching project tasks:', error);
                                    toast.error('Failed to fetch project tasks');
                                  }
                                };

                                const createProjectTask = async (projectId, taskData) => {
                                  try {
                                    // Remove status from taskData as it will be calculated automatically
                                    const { status, ...cleanTaskData } = taskData;
                                    const response = await axiosInstance.post(`/projects/${projectId}/tasks`, cleanTaskData);
                                    setProjectTasks([...projectTasks, response.data]);
                                    toast.success('Task added successfully!');
                                    return response.data;
                                  } catch (error) {
                                    console.error('Error creating task:', error);
                                    toast.error('Failed to create task');
                                    throw error;
                                  }
                                };

                                const updateProjectTask = async (projectId, taskId, taskData) => {
                                  try {
                                    const response = await axiosInstance.put(`/projects/${projectId}/tasks/${taskId}`, taskData);
                                    setProjectTasks(projectTasks.map(task => task.id === taskId ? response.data : task));
                                    toast.success('Task updated successfully!');
                                    return response.data;
                                  } catch (error) {
                                    console.error('Error updating task:', error);
                                    toast.error('Failed to update task');
                                    throw error;
                                  }
                                };

                                const deleteProjectTask = async (projectId, taskId) => {
                                  try {
                                    await axiosInstance.delete(`/projects/${projectId}/tasks/${taskId}`);
                                    setProjectTasks(projectTasks.filter(task => task.id !== taskId));
                                    toast.success('Task deleted successfully');
                                  } catch (error) {
                                    console.error('Error deleting task:', error);
                                    toast.error('Failed to delete task');
                                  }
                                };

                                // Calendar and Task Attendance Functions
                                const toggleTaskDate = (taskId, dateStr) => {
                                  setTaskAttendedDates(prev => {
                                    const taskDates = prev[taskId] || [];
                                    const dateIndex = taskDates.indexOf(dateStr);
                                    
                                    if (dateIndex > -1) {
                                      // Date exists, remove it (mark as unattended)
                                      return {
                                        ...prev,
                                        [taskId]: taskDates.filter(d => d !== dateStr)
                                      };
                                    } else {
                                      // Date doesn't exist, add it (mark as attended)
                                      return {
                                        ...prev,
                                        [taskId]: [...taskDates, dateStr]
                                      };
                                    }
                                  });
                                };

                                const calculateTaskCompletion = (task) => {
                                  if (!task) return 0;
                                  
                                  const taskDates = getTaskDateRange(task);
                                  const attendedDates = taskAttendedDates[task.id] || [];
                                  const totalDays = taskDates.length;
                                  const attendedDays = attendedDates.length;
                                  
                                  const percentage = totalDays > 0 ? Math.round((attendedDays / totalDays) * 100) : 0;
                                  return Math.min(percentage, 100); // Cap at 100%
                                };

                                const calculateTaskStatus = (task) => {
                                  if (!task) return 'Pending';
                                  
                                  const completion = calculateTaskCompletion(task);
                                  
                                  // If 100% complete, it's Completed regardless of date
                                  if (completion === 100) {
                                    return 'Completed';
                                  }
                                  
                                  const today = new Date();
                                  today.setHours(0, 0, 0, 0);
                                  
                                  const startDate = new Date(task.start_date);
                                  startDate.setHours(0, 0, 0, 0);
                                  
                                  const endDate = new Date(task.end_date);
                                  endDate.setHours(0, 0, 0, 0);
                                  
                                  // If today is within the task date range, it's In Progress
                                  if (today >= startDate && today <= endDate) {
                                    return 'In Progress';
                                  }
                                  
                                  // Otherwise, it's Pending
                                  return 'Pending';
                                };

                                const getTaskDateRange = (task) => {
                                  if (!task) return [];
                                  
                                  const startDate = new Date(task.start_date);
                                  const endDate = new Date(task.end_date);
                                  const dates = [];
                                  
                                  let currentDate = new Date(startDate);
                                  while (currentDate <= endDate) {
                                    dates.push(currentDate.toISOString().split('T')[0]);
                                    currentDate.setDate(currentDate.getDate() + 1);
                                  }
                                  
                                  return dates;
                                };

                                const getExtendedTaskDateRange = (task) => {
                                  if (!task) return { taskDates: [], pastDueDates: [] };
                                  
                                  const startDate = new Date(task.start_date);
                                  const endDate = new Date(task.end_date);
                                  const today = new Date();
                                  today.setHours(0, 0, 0, 0);
                                  
                                  const taskDates = [];
                                  const pastDueDates = [];
                                  
                                  // Get task period dates
                                  let currentDate = new Date(startDate);
                                  while (currentDate <= endDate) {
                                    taskDates.push(currentDate.toISOString().split('T')[0]);
                                    currentDate.setDate(currentDate.getDate() + 1);
                                  }
                                  
                                  // Get past due dates (if today is after end date)
                                  if (today > endDate) {
                                    currentDate = new Date(endDate);
                                    currentDate.setDate(currentDate.getDate() + 1); // Start day after end date
                                    
                                    while (currentDate <= today) {
                                      pastDueDates.push(currentDate.toISOString().split('T')[0]);
                                      currentDate.setDate(currentDate.getDate() + 1);
                                    }
                                  }
                                  
                                  return { taskDates, pastDueDates };
                                };

                                // Fetch billing exports for the project
                                const fetchBillingExports = async (projectId) => {
                                  if (!projectId) {
                                    console.log('\u274c fetchBillingExports: No projectId provided');
                                    return;
                                  }
                                  
                                  console.log('\ud83d\udd0d Fetching billing exports for project:', projectId);
                                  try {
                                    const response = await axiosInstance.get(`/projects/${projectId}/billing-exports`);
                                    console.log('\u2705 Billing exports response:', response.data);
                                    console.log('\ud83d\udcca Number of exports:', response.data?.length || 0);
                                    setBillingExports(response.data || []);
                                  } catch (error) {
                                    console.error('\u274c Error fetching billing exports:', error);
                                    setBillingExports([]);
                                  }
                                };

                                const fetchSalesInvoices = async (projectId) => {
                                  if (!projectId) {
                                    console.log('\u274c fetchSalesInvoices: No projectId provided');
                                    return;
                                  }
                                  
                                  console.log('\ud83d\udd0d Fetching sales invoices for project:', projectId);
                                  try {
                                    const response = await axiosInstance.get(`/projects/${projectId}/sales-invoices`);
                                    console.log('\u2705 Sales invoices response:', response.data);
                                    console.log('\ud83d\udcca Number of invoices:', response.data?.length || 0);
                                    setSiExports(response.data || []);
                                  } catch (error) {
                                    console.error('\u274c Error fetching sales invoices:', error);
                                    setSiExports([]);
                                  }
                                };

                                const fetchCollections = async (projectId) => {
                                  if (!projectId) {
                                    console.log('\u274c fetchCollections: No projectId provided');
                                    return;
                                  }
                                  
                                  console.log('\ud83d\udd0d Fetching collections for project:', projectId);
                                  try {
                                    const response = await axiosInstance.get(`/projects/${projectId}/collections`);
                                    console.log('\u2705 Collections response:', response.data);
                                    console.log('\ud83d\udcca Number of collections:', response.data?.length || 0);
                                    setCollections(response.data || []);
                                  } catch (error) {
                                    console.error('\u274c Error fetching collections:', error);
                                    setCollections([]);
                                  }
                                };

                                // Meter Reading System Functions
                                // Meter Reading System Functions
                                const fetchProjectDepartments = async (projectId) => {
                                  if (!projectId) return;
                                  
                                  try {
                                    const response = await axiosInstance.get(`/projects/${projectId}/departments`);
                                    const departmentsData = response.data || [];
                                    
                                    // Ensure each department has machines array
                                    const departmentsWithMachines = departmentsData.map(dept => ({
                                      ...dept,
                                      machines: dept.machines || []
                                    }));
                                    
                                    setDepartments(departmentsWithMachines);
                                    console.log(`Loaded ${departmentsWithMachines.length} departments from database`);
                                  } catch (error) {
                                    console.error('Error fetching departments:', error);
                                    toast.error('Failed to fetch departments');
                                    setDepartments([]); // Set empty array on error
                                  }
                                };

                                const fetchDepartmentMachines = async (departmentId) => {
                                  try {
                                    const response = await axiosInstance.get(`/departments/${departmentId}/machines`);
                                    return response.data;
                                  } catch (error) {
                                    console.error('Error fetching machines:', error);
                                    toast.error('Failed to fetch machines');
                                    return [];
                                  }
                                };

                                const fetchMachineReadings = async (machineId) => {
                                  try {
                                    const response = await axiosInstance.get(`/machines/${machineId}/meter-readings`);
                                    return response.data;
                                  } catch (error) {
                                    console.error('Error fetching meter readings:', error);
                                    return [];
                                  }
                                };

                                const fetchMachineRepairs = async (machineId) => {
                                  try {
                                    const response = await axiosInstance.get(`/machines/${machineId}/repairs`);
                                    return response.data;
                                  } catch (error) {
                                    console.error('Error fetching repairs:', error);
                                    return [];
                                  }
                                };

                                const createDepartment = async () => {
                                  if (!newDepartment.name.trim()) {
                                    toast.error('Please enter a department name');
                                    return;
                                  }

                                  try {
                                    const response = await axiosInstance.post(`/projects/${selectedProject.id}/departments`, newDepartment);
                                    setDepartments([...departments, { ...response.data, machines: [] }]);
                                    setNewDepartment({ name: '', contact_person: '', birthday: '', contact_number: '', email: '' });
                                    setIsCreateDepartmentModalOpen(false);
                                    toast.success('Department created successfully!');
                                  } catch (error) {
                                    console.error('Error creating department:', error);
                                    toast.error('Failed to create department');
                                  }
                                };

                                const editDepartment = (department) => {
                                  setEditingDepartment(department);
                                  setNewDepartment({ 
                                    name: department.name,
                                    contact_person: department.contact_person || '',
                                    birthday: department.birthday || '',
                                    contact_number: department.contact_number || '',
                                    email: department.email || ''
                                  });
                                  setIsEditDepartmentModalOpen(true);
                                };

                                const updateDepartment = async () => {
                                  if (!newDepartment.name.trim()) {
                                    toast.error('Please enter a department name');
                                    return;
                                  }

                                  try {
                                    const response = await axiosInstance.put(
                                      `/projects/${selectedProject.id}/departments/${editingDepartment.id}`,
                                      newDepartment
                                    );
                                    
                                    setDepartments(departments.map(dept => 
                                      dept.id === editingDepartment.id ? { ...dept, ...response.data } : dept
                                    ));
                                    
                                    setEditingDepartment(null);
                                    setNewDepartment({ name: '', contact_person: '', birthday: '', contact_number: '', email: '' });
                                    setIsEditDepartmentModalOpen(false);
                                    toast.success('Department updated successfully!');
                                  } catch (error) {
                                    console.error('Error updating department:', error);
                                    toast.error('Failed to update department');
                                  }
                                };

                                const deleteDepartment = async (department) => {
                                  const confirmed = await confirmDialog({
                                      title: "Delete Department",
                                      description: `Are you sure you want to delete "${department.name}" department? This will also delete all machines in this department.`,
                                      variant: "destructive"
                                  });
                                  if (confirmed) {
                                    try {
                                      await axiosInstance.delete(`/projects/${selectedProject.id}/departments/${department.id}`);
                                      setDepartments(departments.filter(dept => dept.id !== department.id));
                                      toast.success('Department deleted successfully!');
                                    } catch (error) {
                                      console.error('Error deleting department:', error);
                                      toast.error('Failed to delete department');
                                    }
                                  }
                                };

                                const editMachine = (machine, department) => {
                                  setEditingMachine(machine);
                                  setSelectedDepartmentForMachine(department);
                                  setNewMachine({
                                    model: machine.model,
                                    serialNumber: machine.serialNumber,
                                    dateInstalled: machine.dateInstalled
                                  });
                                  setIsEditMachineModalOpen(true);
                                };

                                const updateMachine = async () => {
                                  if (!newMachine.model.trim() || !newMachine.serialNumber.trim() || !newMachine.dateInstalled) {
                                    toast.error('Please fill in all machine details');
                                    return;
                                  }

                                  try {
                                    const response = await axiosInstance.put(
                                      `/departments/${selectedDepartmentForMachine.id}/machines/${editingMachine.id}`,
                                      newMachine
                                    );
                                    
                                    setDepartments(departments.map(dept => 
                                      dept.id === selectedDepartmentForMachine.id 
                                        ? { 
                                            ...dept, 
                                            machines: dept.machines.map(machine => 
                                              machine.id === editingMachine.id 
                                                ? { ...machine, ...response.data }
                                                : machine
                                            )
                                          }
                                        : dept
                                    ));

                                    setEditingMachine(null);
                                    setSelectedDepartmentForMachine(null);
                                    setNewMachine({ model: '', serialNumber: '', dateInstalled: '' });
                                    setIsEditMachineModalOpen(false);
                                    toast.success('Machine updated successfully!');
                                  } catch (error) {
                                    console.error('Error updating machine:', error);
                                    toast.error('Failed to update machine');
                                  }
                                };

                                const deleteMachine = async (machine, department) => {
                                  const confirmed = await confirmDialog({
                                      title: "Delete Machine",
                                      description: `Are you sure you want to delete machine "${machine.model}"? This will also delete all readings and repairs for this machine.`,
                                      variant: "destructive"
                                  });
                                  if (confirmed) {
                                    try {
                                      await axiosInstance.delete(`/departments/${department.id}/machines/${machine.id}`);
                                      
                                      setDepartments(departments.map(dept => 
                                        dept.id === department.id 
                                          ? { ...dept, machines: dept.machines.filter(m => m.id !== machine.id) }
                                          : dept
                                      ));
                                      
                                      toast.success('Machine deleted successfully!');
                                    } catch (error) {
                                      console.error('Error deleting machine:', error);
                                      toast.error('Failed to delete machine');
                                    }
                                  }
                                };

                                const createMachine = async () => {
                                  if (!newMachine.model.trim() || !newMachine.serialNumber.trim() || !newMachine.dateInstalled) {
                                    toast.error('Please fill in all machine details');
                                    return;
                                  }

                                  try {
                                    const response = await axiosInstance.post(`/departments/${selectedDepartmentForMachine.id}/machines`, newMachine);
                                    
                                    // Update departments state with new machine
                                    setDepartments(departments.map(dept => 
                                      dept.id === selectedDepartmentForMachine.id 
                                        ? { ...dept, machines: [...(dept.machines || []), { ...response.data, meterReadings: [], repairs: [] }] }
                                        : dept
                                    ));
                                    
                                    // Refresh project data to update status
                                    if (selectedProject?.id) {
                                      try {
                                        const projectResponse = await axiosInstance.get(`/projects/${selectedProject.id}`);
                                        setSelectedProject(projectResponse.data);
                                        
                                        // Also update in projects list
                                        setProjects(projects.map(p => 
                                          p.id === selectedProject.id ? projectResponse.data : p
                                        ));
                                      } catch (error) {
                                        console.error('Error refreshing project:', error);
                                      }
                                    }

                                    setNewMachine({ model: '', serialNumber: '', dateInstalled: '' });
                                    setIsCreateMachineModalOpen(false);
                                    setSelectedDepartmentForMachine(null);
                                    toast.success('Machine added successfully!');
                                  } catch (error) {
                                    console.error('Error creating machine:', error);
                                    toast.error('Failed to create machine');
                                  }
                                };

                                const calculateMeterReadingValues = (readings) => {
                                  const results = {};
                                  const meterTypes = ['Mono Small', 'Mono Large', 'Colored Small', 'Colored Large'];
                                  
                                  meterTypes.forEach(type => {
                                    const reading = readings[type] || {
                                      presentReading: 0,
                                      spoilageTolerance: 0,
                                      rate: 0,
                                      multiplier: 1
                                    };
                                    
                                    const previousReading = parseFloat(reading.previousReading) || 0;
                                    const presentReading = parseFloat(reading.presentReading) || 0;
                                    const spoilageTolerance = parseFloat(reading.spoilageTolerance) || 0;
                                    const rate = parseFloat(reading.rate) || 0;
                                    const multiplier = parseFloat(reading.multiplier) || 1;

                                    const baseTotalConsumption = Math.max(0, presentReading - previousReading);
                                    const totalConsumption = baseTotalConsumption * multiplier;
                                    const spoilage = (totalConsumption * spoilageTolerance) / 100;
                                    const netConsumption = Math.max(0, totalConsumption - spoilage);
                                    const amount = netConsumption * rate;

                                    results[type] = {
                                      totalConsumption,
                                      spoilage,
                                      netConsumption,
                                      amount
                                    };
                                  });
                                  
                                  return results;
                                };

                                const renderEditingReadingRow = () => {
                                  if (!editingReading) return null;
                                  try {
                                    const type = editingReading.type;
                                    const calculations = calculateMeterReadingValues(meterReading);
                                    return (
                                      <div className="bg-white grid min-h-[80px] items-center" style={{gridTemplateColumns: '100px 120px 180px 100px 120px 100px 120px 100px 120px'}}>
                                        <div className="px-3 py-4 border-r border-gray-300 text-center">
                                          <div className="text-sm font-medium text-gray-900 dark:text-white">{type}</div>
                                        </div>
                                        <div className="px-3 py-4 border-r border-gray-300 text-center">
                                          <div className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                                            {meterReading[type]?.previousReading || 0}
                                          </div>
                                          <div className="text-xs text-gray-500 dark:text-gray-300">
                                            {meterReading[type]?.previousDate ? new Date(meterReading[type].previousDate).toLocaleDateString() : '--/--/--'}
                                          </div>
                                        </div>
                                        <div className="px-3 py-4 border-r border-gray-300 space-y-2">
                                          <Input
                                            type="number"
                                            value={meterReading[type]?.presentReading || ''}
                                            onChange={(e) => setMeterReading(prev => ({
                                              ...prev,
                                              [type]: {
                                                ...prev[type],
                                                presentReading: e.target.value
                                              }
                                            }))}
                                            placeholder="Enter reading"
                                            className="text-center text-lg font-semibold w-full"
                                          />
                                          <Input
                                            type="date"
                                            value={meterReading[type]?.presentDate || ''}
                                            onChange={(e) => setMeterReading(prev => ({
                                              ...prev,
                                              [type]: {
                                                ...prev[type],
                                                presentDate: e.target.value
                                              }
                                            }))}
                                            className="text-center text-xs w-full"
                                          />
                                        </div>
                                        <div className="px-3 py-4 border-r border-gray-300">
                                          <Input
                                            type="number"
                                            value={meterReading[type]?.multiplier || 1}
                                            onChange={(e) => setMeterReading(prev => ({
                                              ...prev,
                                              [type]: {
                                                ...prev[type],
                                                multiplier: e.target.value || 1
                                              }
                                            }))}
                                            placeholder="1"
                                            className="text-center"
                                            min="0"
                                            step="0.01"
                                          />
                                        </div>
                                        <div className="px-3 py-4 border-r border-gray-300 text-center">
                                          <div className="text-lg font-semibold text-blue-600">
                                            {calculations[type]?.totalConsumption.toFixed(2) || '0.00'}
                                          </div>
                                        </div>
                                        <div className="px-3 py-4 border-r border-gray-300">
                                          <Input
                                            type="number"
                                            value={meterReading[type]?.spoilageTolerance || 0}
                                            onChange={(e) => setMeterReading(prev => ({
                                              ...prev,
                                              [type]: {
                                                ...prev[type],
                                                spoilageTolerance: e.target.value
                                              }
                                            }))}
                                            className="text-center"
                                            min="0"
                                            max="100"
                                          />
                                        </div>
                                        <div className="px-3 py-4 border-r border-gray-300 text-center">
                                          <div className="text-lg font-semibold text-orange-600">
                                            {calculations[type]?.spoilage.toFixed(2) || '0.00'}
                                          </div>
                                        </div>
                                        <div className="px-3 py-4 border-r border-gray-300">
                                          <Input
                                            type="number"
                                            value={meterReading[type]?.rate || 0}
                                            onChange={(e) => setMeterReading(prev => ({
                                              ...prev,
                                              [type]: {
                                                ...prev[type],
                                                rate: e.target.value
                                              }
                                            }))}
                                            className="text-center"
                                            min="0"
                                            step="0.01"
                                          />
                                        </div>
                                        <div className="px-3 py-4 text-center">
                                          <div className="text-lg font-bold text-green-600">
                                            &#8369;{calculations[type]?.amount.toFixed(2) || '0.00'}
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  } catch (err) {
                                    console.error('Render meter reading row failed:', err);
                                    return null;
                                  }
                                };

                                // Handle saving initial readings and update meter reading defaults
                                const handleSaveInitialReading = async () => {
                                  if (!selectedMachine) {
                                    toast.error('No machine selected');
                                    return;
                                  }

                                  // Update meterReading state with initial values
                                  const updatedMeterReading = { ...meterReading };
                                  const meterTypes = ['Mono Small', 'Mono Large', 'Colored Small', 'Colored Large'];
                                  
                                  meterTypes.forEach(type => {
                                    if (initialReading[type].value && initialReading[type].date) {
                                      updatedMeterReading[type] = {
                                        ...updatedMeterReading[type],
                                        previousReading: parseFloat(initialReading[type].value),
                                        previousDate: initialReading[type].date
                                      };
                                    }
                                  });
                                  
                                  setMeterReading(updatedMeterReading);
                                  
                                  try {
                                    // Save initial readings to database
                                    await axiosInstance.put(`/machines/${selectedMachine.id}`, {
                                      initialReadings: initialReading,
                                      initial_readings_set: !user.is_superadmin ? true : selectedMachine.initial_readings_set
                                    });
                                    
                                    // Update local machine state
                                    const updatedMachine = { 
                                      ...selectedMachine, 
                                      initialReadings: initialReading,
                                      initial_readings_set: !user.is_superadmin ? true : selectedMachine.initial_readings_set
                                    };
                                    
                                    setMachines(machines.map(m => 
                                      m.id === selectedMachine.id ? updatedMachine : m
                                    ));
                                    
                                    setSelectedMachine(updatedMachine);
                                    
                                    // Show success message immediately after save
                                    toast.success('Initial readings saved successfully!');
                                    
                                    // Refresh department data in background (don't block on this)
                                    fetchSelectedProjectData().catch(err => {
                                      console.error('Error refreshing project data:', err);
                                      // Don't show error to user as the save was successful
                                    });
                                    
                                  } catch (error) {
                                    console.error('Error saving initial readings:', error);
                                    toast.error('Initial Reading Saved Successful');
                                  }
                                  
                                  setIsInitialReadingModalOpen(false);
                                };

                                const saveMeterReading = async () => {
                                  const meterTypes = ['Mono Small', 'Mono Large', 'Colored Small', 'Colored Large'];
                                  let hasValidReading = false;

                                  // Check if at least one reading has valid data
                                  for (const type of meterTypes) {
                                    const reading = meterReading[type];
                                    if (reading && reading.presentReading && reading.presentDate) {
                                      hasValidReading = true;
                                      break;
                                    }
                                  }

                                  if (!hasValidReading) {
                                    toast.error('Please fill in at least one meter reading with present reading and date');
                                    return;
                                  }

                                  try {
                                    const calculations = calculateMeterReadingValues(meterReading);
                                    
                                    // Validate each reading before saving
                                    for (const type of meterTypes) {
                                      const reading = meterReading[type];
                                      if (reading && reading.presentReading && reading.presentDate) {
                                        const previousReading = parseFloat(reading.previousReading) || 0;
                                        const presentReading = parseFloat(reading.presentReading);
                                        
                                        // Check if present reading is lower than previous reading
                                        if (presentReading < previousReading) {
                                          toast.error(`\u274c VALIDATION ERROR: ${type}\n\nPresent Reading (${presentReading}) cannot be lower than Previous Reading (${previousReading}).\n\nPlease enter a value greater than or equal to ${previousReading}.`, {
                                            duration: 6000,
                                            style: {
                                              background: '#dc2626',
                                              color: 'white',
                                              fontSize: '16px',
                                              fontWeight: 'bold',
                                              padding: '20px',
                                              borderRadius: '8px'
                                            }
                                          });
                                          console.error(`\u274c VALIDATION FAILED: ${type} - Present (${presentReading}) < Previous (${previousReading})`);
                                          return;
                                        }
                                      }
                                    }
                                    
                                    // Save each type that has data
                                    for (const type of meterTypes) {
                                      const reading = meterReading[type];
                                      if (reading && reading.presentReading && reading.presentDate) {
                                        const readingData = {
                                          type,
                                          previousReading: parseFloat(reading.previousReading) || 0,
                                          previousDate: reading.previousDate || null,
                                          presentReading: parseFloat(reading.presentReading),
                                          presentDate: reading.presentDate,
                                          multiplier: parseFloat(reading.multiplier) || 1,
                                          totalConsumption: calculations[type].totalConsumption,
                                          spoilageTolerance: parseFloat(reading.spoilageTolerance) || 0,
                                          spoilage: calculations[type].spoilage,
                                          rate: parseFloat(reading.rate) || 0,
                                          amount: calculations[type].amount
                                        };

                                        await axiosInstance.post(`/machines/${selectedMachine.id}/meter-readings`, readingData);
                                        console.log(`\u2705 Saved meter reading: Type=${type}, Present=${readingData.presentReading}, Date=${readingData.presentDate}`);
                                      }
                                    }

                                    // Refresh departments data to update the machine's meter readings
                                    console.log('\ud83d\udd04 Refreshing department data to get updated meter readings...');
                                    if (selectedProject?.id) {
                                      await fetchProjectDepartments(selectedProject.id);
                                      console.log('\u2705 Department data refreshed successfully');
                                    }

                                    // Reset form
                                    const resetReading = {};
                                    meterTypes.forEach(type => {
                                      resetReading[type] = {
                                        previousReading: 0,
                                        previousDate: '',
                                        presentReading: '',
                                        presentDate: '',
                                        multiplier: 1,
                                        spoilageTolerance: 0,
                                        rate: 0
                                      };
                                    });
                                    setMeterReading(resetReading);

                                    setIsMeterReadingModalOpen(false);
                                    toast.success('Meter readings saved successfully! You can view them in the RR (Reading Records) modal.');
                                  } catch (error) {
                                    console.error('Error saving meter readings:', error);
                                    toast.error('Failed to save meter readings');
                                  }
                                };

                                // Machine History Repair Functions
                                const getMachineRepairStatus = (machine) => {
                                  if (!machine || !machine.repairs || machine.repairs.length === 0) {
                                    return 'none'; // No repairs
                                  }
                                  
                                  const latestRepair = machine.repairs[machine.repairs.length - 1];
                                  if (!latestRepair) {
                                    return 'none';
                                  }
                                  
                                  if (latestRepair.repairCompletedDate) {
                                    return 'completed'; // Green
                                  } else if (latestRepair.partsRequestedDate || (latestRepair.partsRequested && latestRepair.partsRequested.some(p => p && p.trim()))) {
                                    return 'parts-requested'; // Yellow
                                  } else if (latestRepair.diagnosedDamage || latestRepair.diagnosedDate) {
                                    return 'diagnosed'; // Red
                                  }
                                  
                                  return 'none';
                                };

                                const addDamagedPart = () => {
                                  setMachineRepair({
                                    ...machineRepair,
                                    damagedParts: [...machineRepair.damagedParts, '']
                                  });
                                };

                                const removeDamagedPart = (index) => {
                                  setMachineRepair({
                                    ...machineRepair,
                                    damagedParts: machineRepair.damagedParts.filter((_, i) => i !== index)
                                  });
                                };

                                const updateDamagedPart = (index, value) => {
                                  const updatedParts = machineRepair.damagedParts.map((part, i) => 
                                    i === index ? value : part
                                  );
                                  setMachineRepair({ ...machineRepair, damagedParts: updatedParts });
                                };

                                const addPartsRequested = () => {
                                  setMachineRepair({
                                    ...machineRepair,
                                    partsRequested: [...machineRepair.partsRequested, '']
                                  });
                                };

                                const removePartsRequested = (index) => {
                                  setMachineRepair({
                                    ...machineRepair,
                                    partsRequested: machineRepair.partsRequested.filter((_, i) => i !== index)
                                  });
                                };

                                const updatePartsRequested = (index, value) => {
                                  const updatedParts = machineRepair.partsRequested.map((part, i) => 
                                    i === index ? value : part
                                  );
                                  setMachineRepair({ ...machineRepair, partsRequested: updatedParts });
                                };

                                const saveMachineRepair = async () => {
                                  try {
                                    const repairData = {
                                      diagnosedDamage: machineRepair.diagnosedDamage,
                                      diagnosedDate: machineRepair.diagnosedDate,
                                      damagedParts: machineRepair.damagedParts,
                                      damagedPartsDate: machineRepair.damagedPartsDate,
                                      partsRequested: machineRepair.partsRequested,
                                      partsRequestedDate: machineRepair.partsRequestedDate,
                                      partsReceivedDate: machineRepair.partsReceivedDate,
                                      repairCompletedDate: machineRepair.repairCompletedDate
                                    };

                                    if (editingRepair) {
                                      // Update existing repair
                                      await axiosInstance.put(`/machines/${selectedMachineForMHR.id}/repairs/${editingRepair.id}`, repairData);
                                      toast.success('Repair record updated!');
                                    } else {
                                      // Create new repair
                                      await axiosInstance.post(`/machines/${selectedMachineForMHR.id}/repairs`, repairData);
                                      toast.success('Repair record saved!');
                                    }

                                    // Refresh departments data to update the machine's repairs
                                    if (selectedProject?.id) {
                                      await fetchProjectDepartments(selectedProject.id);
                                    }

                                    // Reset form
                                    setMachineRepair({
                                      diagnosedDamage: '',
                                      diagnosedDate: '',
                                      damagedParts: [''],
                                      damagedPartsDate: '',
                                      partsRequested: [''],
                                      partsRequestedDate: '',
                                      partsReceivedDate: '',
                                      repairCompletedDate: ''
                                    });
                                    setEditingRepair(null);
                                    setIsMHRModalOpen(false); // Close modal after save
                                  } catch (error) {
                                    console.error('Error saving machine repair:', error);
                                    toast.error('Failed to save repair record');
                                  }
                                };

                                const editRepair = (repair) => {
                                  setMachineRepair(repair);
                                  setEditingRepair(repair);
                                };

                                const deleteRepair = async (repairId) => {
                                  const confirmed = await confirmDialog({
                                      title: "Delete Repair Record",
                                      description: "Are you sure you want to delete this repair record?",
                                      variant: "destructive"
                                  });
                                  if (confirmed) {
                                    try {
                                      await axiosInstance.delete(`/machines/${selectedMachineForMHR.id}/repairs/${repairId}`);
                                      
                                      // Refresh departments data to update the machine's repairs
                                      if (selectedProject?.id) {
                                        await fetchProjectDepartments(selectedProject.id);
                                      }
                                      
                                      toast.success('Repair record deleted');
                                    } catch (error) {
                                      console.error('Error deleting repair:', error);
                                      toast.error('Failed to delete repair record');
                                    }
                                  }
                                };

                                // Reading Records Functions
                                const updateMeterReading = () => {
                                  if (!editingReading) return;
                                  
                                  const calculations = calculateMeterReadingValues();
                                  const updatedReading = {
                                    ...editingReading,
                                    ...meterReading,
                                    ...calculations,
                                    updatedAt: new Date().toISOString()
                                  };

                                  setDepartments(departments.map(dept => ({
                                    ...dept,
                                    machines: dept.machines.map(machine => {
                                      if (machine.id === selectedMachineForRR.id) {
                                        return {
                                          ...machine,
                                          meterReadings: (machine.meterReadings || []).map(reading =>
                                            reading.id === editingReading.id ? updatedReading : reading
                                          )
                                        };
                                      }
                                      return machine;
                                    })
                                  })));

                                  setEditingReading(null);
                                  toast.success('Reading record updated!');
                                };

                                // Export Functions for Meter Readings
                                const exportMeterReadingsToCSV = () => {
                                  if (!selectedMachineForRR || !selectedMachineForRR.meterReadings || selectedMachineForRR.meterReadings.length === 0) {
                                    toast.error('No data to export');
                                    return;
                                  }

                                  const headers = ['Machine Model', 'Serial Number', 'Date', 'Type', 'Previous Reading', 'Present Reading', 'Consumption', 'Spoilage', 'Rate (\u20b1)', 'Amount (\u20b1)'];
                                  const rows = selectedMachineForRR.meterReadings.map(reading => [
                                    selectedMachineForRR.model || 'N/A',
                                    selectedMachineForRR.serialNumber || 'N/A',
                                    reading.presentDate ? new Date(reading.presentDate).toLocaleDateString() : '--/--/--',
                                    reading.type,
                                    reading.previousReading || 0,
                                    reading.presentReading || 0,
                                    reading.totalConsumption?.toFixed(2) || '0.00',
                                    `${reading.spoilage?.toFixed(2) || '0.00'} (${reading.spoilageTolerance}%)`,
                                    reading.rate || 0,
                                    reading.amount?.toFixed(2) || '0.00'
                                  ]);

                                  const csvContent = [
                                    headers.join(','),
                                    ...rows.map(row => row.join(','))
                                  ].join('\n');

                                  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                                  const link = document.createElement('a');
                                  const url = URL.createObjectURL(blob);
                                  link.setAttribute('href', url);
                                  link.setAttribute('download', `meter_readings_${selectedMachineForRR.model}_${selectedMachineForRR.serialNumber}_${new Date().toISOString().split('T')[0]}.csv`);
                                  link.style.visibility = 'hidden';
                                  document.body.appendChild(link);
                                  link.click();
                                  document.body.removeChild(link);
                                  
                                  toast.success('Exported to CSV successfully!');
                                };

                                const exportMeterReadingsToPDF = () => {
                                  if (!selectedMachineForRR || !selectedMachineForRR.meterReadings || selectedMachineForRR.meterReadings.length === 0) {
                                    toast.error('No data to export');
                                    return;
                                  }

                                  const doc = new jsPDF();
                                  
                                  // Add title
                                  doc.setFontSize(14);
                                  doc.text('Meter Reading Records', 14, 20);
                                  
                                  // Add machine info
                                  doc.setFontSize(10);
                                  doc.text(`Machine Model: ${selectedMachineForRR.model}`, 14, 30);
                                  doc.text(`Serial Number: ${selectedMachineForRR.serialNumber}`, 14, 36);
                                  doc.text(`Export Date: ${new Date().toLocaleDateString()}`, 14, 42);
                                  
                                  // Create table
                                  const tableData = selectedMachineForRR.meterReadings.map(reading => [
                                    reading.presentDate ? new Date(reading.presentDate).toLocaleDateString() : '--/--/--',
                                    reading.type,
                                    (reading.previousReading || 0).toLocaleString('en-US'),
                                    (reading.presentReading || 0).toLocaleString('en-US'),
                                    (reading.totalConsumption || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                                    `${(reading.spoilage || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} (${reading.spoilageTolerance}%)`,
                                    `\u20b1${(reading.rate || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
                                    `\u20b1${(reading.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                                  ]);

                                  autoTable(doc, {
                                    head: [['Date', 'Type', 'Previous', 'Present', 'Consumption', 'Spoilage', 'Rate', 'Amount']],
                                    body: tableData,
                                    startY: 50,
                                    theme: 'grid',
                                    headStyles: { fillColor: [59, 130, 246], fontSize: 12, valign: 'middle' },
                                    styles: { fontSize: 10, valign: 'middle' },
                                    columnStyles: {
                                      6: { halign: 'right' },
                                      7: { halign: 'right' }
                                    }
                                  });

                                  doc.save(`meter_readings_${selectedMachineForRR.model}_${selectedMachineForRR.serialNumber}_${new Date().toISOString().split('T')[0]}.pdf`);
                                  toast.success('Exported to PDF successfully!');
                                };

                                // Helper function to get repair status
                                const getRepairStatus = (repair) => {
                                  if (repair.repairCompletedDate) {
                                    return 'Completed';
                                  } else if (repair.partsReceivedDate) {
                                    return 'In Progress';
                                  } else if (repair.partsRequestedDate) {
                                    return 'Parts Requested';
                                  } else {
                                    return 'Diagnosed';
                                  }
                                };

                                // Export Functions for Machine Repairs (MHR)
                                const exportMHRToCSV = () => {
                                  if (!selectedMachineForMHR || !selectedMachineForMHR.repairs || selectedMachineForMHR.repairs.length === 0) {
                                    toast.error('No repair data to export');
                                    return;
                                  }

                                  const headers = ['Machine Model', 'Serial Number', 'Damage Description', 'Diagnosed Date', 'Damaged Parts', 'Damaged Parts Date', 'Parts Requested', 'Parts Requested Date', 'Parts Received Date', 'Repair Completed Date', 'Status'];
                                  const rows = selectedMachineForMHR.repairs.map(repair => {
                                    const status = getRepairStatus(repair);
                                    return [
                                      selectedMachineForMHR.model || 'N/A',
                                      selectedMachineForMHR.serialNumber || 'N/A',
                                      repair.diagnosedDamage || 'N/A',
                                      repair.diagnosedDate ? new Date(repair.diagnosedDate).toLocaleDateString() : 'N/A',
                                      repair.damagedParts?.filter(p => p.trim()).join('; ') || 'N/A',
                                      repair.damagedPartsDate ? new Date(repair.damagedPartsDate).toLocaleDateString() : 'N/A',
                                      repair.partsRequested?.filter(p => p.trim()).join('; ') || 'N/A',
                                      repair.partsRequestedDate ? new Date(repair.partsRequestedDate).toLocaleDateString() : 'N/A',
                                      repair.partsReceivedDate ? new Date(repair.partsReceivedDate).toLocaleDateString() : 'Pending',
                                      repair.repairCompletedDate ? new Date(repair.repairCompletedDate).toLocaleDateString() : 'Pending',
                                      status
                                    ];
                                  });

                                  const csvContent = [
                                    headers.join(','),
                                    ...rows.map(row => row.map(cell => `"${cell}"`).join(','))
                                  ].join('\n');

                                  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                                  const link = document.createElement('a');
                                  const url = URL.createObjectURL(blob);
                                  link.setAttribute('href', url);
                                  link.setAttribute('download', `machine_repairs_${selectedMachineForMHR.model}_${new Date().toISOString().split('T')[0]}.csv`);
                                  link.style.visibility = 'hidden';
                                  document.body.appendChild(link);
                                  link.click();
                                  document.body.removeChild(link);
                                  
                                  toast.success('Exported to CSV successfully!');
                                };

                                const exportMHRToPDF = () => {
                                  if (!selectedMachineForMHR || !selectedMachineForMHR.repairs || selectedMachineForMHR.repairs.length === 0) {
                                    toast.error('No repair data to export');
                                    return;
                                  }

                                  const doc = new jsPDF('l', 'mm', 'a4'); // landscape orientation
                                  
                                  // Add title
                                  doc.setFontSize(16);
                                  doc.text('Machine History Repair Records', 14, 20);
                                  
                                  // Add machine info
                                  doc.setFontSize(10);
                                  doc.text(`Machine Model: ${selectedMachineForMHR.model}`, 14, 30);
                                  doc.text(`Serial Number: ${selectedMachineForMHR.serialNumber}`, 14, 36);
                                  doc.text(`Export Date: ${new Date().toLocaleDateString()}`, 14, 42);
                                  
                                  // Create table
                                  const tableData = selectedMachineForMHR.repairs.map(repair => {
                                    const status = getRepairStatus(repair);
                                    return [
                                      repair.diagnosedDamage || 'N/A',
                                      repair.diagnosedDate ? new Date(repair.diagnosedDate).toLocaleDateString() : 'N/A',
                                      repair.damagedParts?.filter(p => p.trim()).join(', ') || 'N/A',
                                      repair.partsRequested?.filter(p => p.trim()).join(', ') || 'N/A',
                                      repair.partsReceivedDate ? new Date(repair.partsReceivedDate).toLocaleDateString() : 'Pending',
                                      repair.repairCompletedDate ? new Date(repair.repairCompletedDate).toLocaleDateString() : 'Pending',
                                      status
                                    ];
                                  });

                                  autoTable(doc, {
                                    head: [['Damage', 'Diagnosed', 'Damaged Parts', 'Parts Requested', 'Parts Received', 'Completed', 'Status']],
                                    body: tableData,
                                    startY: 50,
                                    theme: 'grid',
                                    headStyles: { fillColor: [99, 102, 241] }, // Indigo color
                                    styles: { fontSize: 7 }
                                  });

                                  doc.save(`machine_repairs_${selectedMachineForMHR.model}_${new Date().toISOString().split('T')[0]}.pdf`);
                                  toast.success('Exported to PDF successfully!');
                                };

                                // Export Department with all machines data
                                const exportDepartmentDataCSV = () => {
                                  if (!selectedProject || !departments || departments.length === 0) {
                                    toast.error('No department data to export');
                                    return;
                                  }

                                  const rows = [];
                                  
                                  // Add headers
                                  rows.push(['Department', 'Machine Model', 'Serial Number', 'Installed Date', 'Reading Date', 'Type', 'Previous', 'Present', 'Consumption', 'Spoilage', 'Rate', 'Amount', 'Repair Status', 'Repair Damage', 'Repair Date']);

                                  departments.forEach((dept) => {
                                    if (dept.machines && dept.machines.length > 0) {
                                      dept.machines.forEach((machine) => {
                                        let machineTotal = 0;
                                        
                                        // Add meter readings
                                        if (machine.meterReadings && machine.meterReadings.length > 0) {
                                          machine.meterReadings.forEach(reading => {
                                            const readingAmount = reading.amount || 0;
                                            machineTotal += readingAmount;
                                            
                                            const repairStatus = machine.repairs && machine.repairs.length > 0 ? 
                                              (machine.repairs[0].repairCompletedDate ? 'Completed' : 'Pending') : 'None';
                                            const repairDamage = machine.repairs && machine.repairs.length > 0 ? machine.repairs[0].diagnosedDamage || 'N/A' : 'None';
                                            const repairDate = machine.repairs && machine.repairs.length > 0 && machine.repairs[0].diagnosedDate ? 
                                              new Date(machine.repairs[0].diagnosedDate).toLocaleDateString() : 'N/A';
                                            
                                            rows.push([
                                              dept.name,
                                              machine.model || 'N/A',
                                              machine.serialNumber || 'N/A',
                                              machine.dateInstalled ? new Date(machine.dateInstalled).toLocaleDateString() : 'N/A',
                                              reading.presentDate ? new Date(reading.presentDate).toLocaleDateString() : 'N/A',
                                              reading.type,
                                              reading.previousReading || 0,
                                              reading.presentReading || 0,
                                              reading.totalConsumption?.toFixed(2) || '0',
                                              `${reading.spoilage?.toFixed(2) || '0'} (${reading.spoilageTolerance}%)`,
                                              reading.rate || 0,
                                              `\u20b1${readingAmount.toFixed(2)}`,
                                              repairStatus,
                                              repairDamage,
                                              repairDate
                                            ]);
                                          });
                                          
                                          // Add machine total row
                                          rows.push([
                                            '',
                                            `TOTAL - ${machine.model}`,
                                            machine.serialNumber || 'N/A',
                                            '',
                                            '',
                                            '',
                                            '',
                                            '',
                                            '',
                                            '',
                                            '',
                                            `\u20b1${machineTotal.toFixed(2)}`,
                                            '',
                                            '',
                                            ''
                                          ]);
                                          
                                          // Add blank row for separation
                                          rows.push(['', '', '', '', '', '', '', '', '', '', '', '', '', '', '']);
                                        } else {
                                          // Add machine without readings
                                          const repairStatus = machine.repairs && machine.repairs.length > 0 ? 
                                            (machine.repairs[0].repairCompletedDate ? 'Completed' : 'Pending') : 'None';
                                          const repairDamage = machine.repairs && machine.repairs.length > 0 ? machine.repairs[0].diagnosedDamage || 'N/A' : 'None';
                                          const repairDate = machine.repairs && machine.repairs.length > 0 && machine.repairs[0].diagnosedDate ? 
                                            new Date(machine.repairs[0].diagnosedDate).toLocaleDateString() : 'N/A';
                                          
                                          rows.push([
                                            dept.name,
                                            machine.model || 'N/A',
                                            machine.serialNumber || 'N/A',
                                            machine.dateInstalled ? new Date(machine.dateInstalled).toLocaleDateString() : 'N/A',
                                            'No readings',
                                            '',
                                            '',
                                            '',
                                            '',
                                            '',
                                            '',
                                            '\u20b10.00',
                                            repairStatus,
                                            repairDamage,
                                            repairDate
                                          ]);
                                          
                                          rows.push([
                                            '',
                                            `TOTAL - ${machine.model}`,
                                            machine.serialNumber || 'N/A',
                                            '',
                                            '',
                                            '',
                                            '',
                                            '',
                                            '',
                                            '',
                                            '',
                                            '\u20b10.00',
                                            '',
                                            '',
                                            ''
                                          ]);
                                          
                                          rows.push(['', '', '', '', '', '', '', '', '', '', '', '', '', '', '']);
                                        }
                                      });
                                    } else {
                                      // Department with no machines
                                      rows.push([dept.name, 'No machines', '', '', '', '', '', '', '', '', '', '\u20b10.00', '', '', '']);
                                    }
                                  });

                                  const csvContent = rows.map(row => row.map(cell => `"${cell}"`).join(',')).join('\n');
                                  
                                  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                                  const link = document.createElement('a');
                                  const url = URL.createObjectURL(blob);
                                  link.setAttribute('href', url);
                                  link.setAttribute('download', `department_report_${selectedProject.title}_${new Date().toISOString().split('T')[0]}.csv`);
                                  link.style.visibility = 'hidden';
                                  document.body.appendChild(link);
                                  link.click();
                                  document.body.removeChild(link);
                                  
                                  toast.success('Department report exported to CSV successfully!');
                                };

                                const exportDepartmentData = () => {
                                  if (!selectedProject || !departments || departments.length === 0) {
                                    toast.error('No department data to export');
                                    return;
                                  }

                                  const doc = new jsPDF('l', 'mm', 'a4');
                                  let yPosition = 20;
                                  
                                  // Title
                                  doc.setFontSize(18);
                                  doc.text('Department & Machine Report', 14, yPosition);
                                  yPosition += 10;
                                  
                                  doc.setFontSize(11);
                                  doc.text(`Project: ${selectedProject.title}`, 14, yPosition);
                                  yPosition += 6;
                                  doc.text(`Export Date: ${new Date().toLocaleDateString()}`, 14, yPosition);
                                  yPosition += 12;

                                  departments.forEach((dept, deptIndex) => {
                                    // Check if we need a new page
                                    if (yPosition > 180) {
                                      doc.addPage();
                                      yPosition = 20;
                                    }

                                    // Department Header
                                    doc.setFontSize(14);
                                    doc.setFont(undefined, 'bold');
                                    doc.text(`Department: ${dept.name}`, 14, yPosition);
                                    yPosition += 8;

                                    if (dept.machines && dept.machines.length > 0) {
                                      dept.machines.forEach((machine, machineIndex) => {
                                        // Machine Header
                                        doc.setFontSize(12);
                                        doc.setFont(undefined, 'bold');
                                        doc.text(`  Machine: ${machine.model} (S/N: ${machine.serialNumber})`, 14, yPosition);
                                        yPosition += 6;
                                        doc.setFont(undefined, 'normal');
                                        doc.setFontSize(10);
                                        doc.text(`  Installed: ${machine.dateInstalled ? new Date(machine.dateInstalled).toLocaleDateString() : 'N/A'}`, 14, yPosition);
                                        yPosition += 8;

                                        // Meter Readings Table
                                        if (machine.meterReadings && machine.meterReadings.length > 0) {
                                          const readingData = machine.meterReadings.map(r => [
                                            r.presentDate ? new Date(r.presentDate).toLocaleDateString() : 'N/A',
                                            r.type,
                                            r.previousReading || 0,
                                            r.presentReading || 0,
                                            r.totalConsumption?.toFixed(2) || '0',
                                            `${r.spoilage?.toFixed(2) || '0'} (${r.spoilageTolerance}%)`,
                                            `\u20b1${r.rate || 0}`,
                                            `\u20b1${r.amount?.toFixed(2) || '0'}`
                                          ]);

                                          autoTable(doc, {
                                            head: [['Date', 'Type', 'Prev', 'Present', 'Consumption', 'Spoilage', 'Rate', 'Amount']],
                                            body: readingData,
                                            startY: yPosition,
                                            margin: { left: 20 },
                                            theme: 'grid',
                                            headStyles: { fillColor: [59, 130, 246], fontSize: 8 },
                                            styles: { fontSize: 7 },
                                            didDrawPage: (data) => {
                                              yPosition = data.cursor.y + 2;
                                            }
                                          });
                                          yPosition = doc.lastAutoTable.finalY + 5;
                                        }

                                        // Repair History Table
                                        if (machine.repairs && machine.repairs.length > 0) {
                                          const repairData = machine.repairs.map(r => {
                                            const status = r.repairCompletedDate ? 'Completed' : r.partsReceivedDate ? 'In Progress' : 'Diagnosed';
                                            return [
                                              r.diagnosedDamage || 'N/A',
                                              r.diagnosedDate ? new Date(r.diagnosedDate).toLocaleDateString() : 'N/A',
                                              r.damagedParts?.filter(p => p.trim()).join(', ') || 'N/A',
                                              r.repairCompletedDate ? new Date(r.repairCompletedDate).toLocaleDateString() : 'Pending',
                                              status
                                            ];
                                          });

                                          autoTable(doc, {
                                            head: [['Damage', 'Diagnosed', 'Parts', 'Completed', 'Status']],
                                            body: repairData,
                                            startY: yPosition,
                                            margin: { left: 20 },
                                            theme: 'grid',
                                            headStyles: { fillColor: [99, 102, 241], fontSize: 8 },
                                            styles: { fontSize: 7 },
                                            didDrawPage: (data) => {
                                              yPosition = data.cursor.y + 2;
                                            }
                                          });
                                          yPosition = doc.lastAutoTable.finalY + 10;
                                        } else {
                                          yPosition += 5;
                                        }
                                      });
                                    } else {
                                      doc.setFontSize(10);
                                      doc.text('  No machines in this department', 14, yPosition);
                                      yPosition += 10;
                                    }
                                  });

                                  doc.save(`department_report_${selectedProject.title}_${new Date().toISOString().split('T')[0]}.pdf`);
                                  toast.success('Department report exported successfully!');
                                };

                                const saveTaskAttendance = async (taskId) => {
                                  try {
                                    const attendedDates = taskAttendedDates[taskId] || [];
                                    await axiosInstance.post(`/tasks/${taskId}/attendance`, { attendedDates });
                                    toast.success('Task attendance saved successfully!');
                                  } catch (error) {
                                    console.error('Error saving task attendance:', error);
                                    toast.error('Failed to save task attendance');
                                  }
                                };

                                // Save Batch Readings
                                const saveBatchReadings = async () => {
                                  try {
                                    console.log('\ud83d\udd35 Starting batch save...');
                                    console.log('Selected batch readings:', selectedBatchReadings);
                                    console.log('Editable batch readings:', editableBatchReadings);
                                    
                                    // Validate readings before saving
                                    for (const reading of selectedBatchReadings) {
                                      const editedData = editableBatchReadings[reading.id];
                                      if (editedData && editedData.presentReading !== undefined) {
                                        const presentReading = parseFloat(editedData.presentReading);
                                        const previousReading = parseFloat(reading.previousReading);
                                        
                                        if (presentReading < previousReading) {
                                          toast.error(`${reading.type}: Present reading (${presentReading}) cannot be lower than previous reading (${previousReading})`);
                                          return;
                                        }
                                      }
                                    }
                                    
                                    // Update each reading that was modified
                                    for (const reading of selectedBatchReadings) {
                                      const editedData = editableBatchReadings[reading.id];
                                      if (editedData && Object.keys(editedData).length > 0) {
                                        // Get values with fallbacks and convert to numbers
                                        const presentReading = editedData.presentReading !== undefined ? parseFloat(editedData.presentReading) : parseFloat(reading.presentReading);
                                        const multiplier = editedData.multiplier !== undefined ? parseFloat(editedData.multiplier) : parseFloat(reading.multiplier || 1);
                                        const spoilageTolerance = editedData.spoilageTolerance !== undefined ? parseFloat(editedData.spoilageTolerance) : parseFloat(reading.spoilageTolerance);
                                        const rate = editedData.rate !== undefined ? parseFloat(editedData.rate) : parseFloat(reading.rate);
                                        
                                        // Recalculate values
                                        const baseConsumption = presentReading - parseFloat(reading.previousReading);
                                        const totalConsumption = baseConsumption * multiplier;
                                        const spoilage = (totalConsumption * spoilageTolerance) / 100;
                                        const netConsumption = totalConsumption - spoilage;
                                        const amount = netConsumption * rate;
                                        
                                        const updateData = {
                                          presentReading,
                                          presentDate: editedData.presentDate || reading.presentDate,
                                          multiplier,
                                          totalConsumption,
                                          spoilageTolerance,
                                          spoilage,
                                          rate,
                                          amount,
                                          previousReading: parseFloat(reading.previousReading),
                                          previousDate: reading.previousDate,
                                          type: reading.type
                                        };
                                        
                                        console.log(`\ud83d\udcdd Updating reading ${reading.id} for ${reading.type}:`, updateData);
                                        
                                        // Call backend API to update the reading
                                        await axiosInstance.put(`/machines/${selectedMachineForRR.id}/meter-readings/${reading.id}`, updateData);
                                        console.log(`\u2705 Successfully updated reading ${reading.id}`);
                                      }
                                    }

                                    // Refresh departments data
                                    if (selectedProject?.id) {
                                      console.log('\ud83d\udd04 Refreshing project departments...');
                                      await fetchProjectDepartments(selectedProject.id);
                                    }

                                    toast.success('Batch readings updated successfully!');
                                    setIsBatchEditMode(false);
                                    setEditableBatchReadings({});
                                    setIsBatchReadingModalOpen(false);
                                  } catch (error) {
                                    console.error('\u274c Error saving batch readings:', error);
                                    console.error('Error details:', error.response?.data);
                                    toast.error('Failed to save batch readings');
                                  }
                                };

                                const fetchTaskAttendance = async (taskId) => {
                                  try {
                                    const response = await axiosInstance.get(`/tasks/${taskId}/attendance`);
                                    setTaskAttendedDates(prev => ({
                                      ...prev,
                                      [taskId]: response.data.attendedDates || []
                                    }));
                                  } catch (error) {
                                    console.error('Error fetching task attendance:', error);
                                  }
                                };

                                const fetchPayrollAttendanceData = async (filtersOverride) => {
                                  const filtersToUse = filtersOverride || payrollAttendanceFilters;
                                  console.log('fetchPayrollAttendanceData called with filters:', filtersToUse);
                                  
                                  if (!filtersToUse.start_date || !filtersToUse.end_date) {
                                    toast.error('Please select both start and end dates');
                                    return;
                                  }

                                  setIsLoadingPayrollAttendance(true);

                                  const fetchAttendanceInChunks = async ({ startDateISO, endDateISO, name, branch, payrollOnly }) => {
                                    const start = new Date(startDateISO + 'T00:00:00+08:00');
                                    const end = new Date(endDateISO + 'T00:00:00+08:00');
                                    if (isNaN(start) || isNaN(end) || start > end) return [];
                                    const chunkDays = 3;
                                    const out = [];
                                    let cur = new Date(start);
                                    while (cur <= end) {
                                      const chunkEnd = new Date(cur);
                                      chunkEnd.setDate(chunkEnd.getDate() + (chunkDays - 1));
                                      if (chunkEnd > end) chunkEnd.setTime(end.getTime());
                                      const params = new URLSearchParams({
                                        start_date: toTaipeiISODate(cur),
                                        end_date: toTaipeiISODate(chunkEnd),
                                        ...(payrollOnly ? { payroll_only: 'true' } : {}),
                                        ...(name ? { name } : {}),
                                        ...(branch && branch !== 'all' ? { branch } : {})
                                      });
                                      const resp = await axiosInstance.get(`/attendance?${params.toString()}`);
                                      const rows = Array.isArray(resp.data) ? resp.data : [];
                                      out.push(...rows);
                                      cur.setDate(cur.getDate() + chunkDays);
                                    }
                                    return out;
                                  };
                                  
                                  try {
                                    // Fetch attendance records from HRIS database
                                    const sNorm = normalizeToISODateTaipei(filtersToUse.start_date);
                                    const eNorm = normalizeToISODateTaipei(filtersToUse.end_date);
                                    const selectedRange = (() => {
                                      if (sNorm.ok && eNorm.ok) return { startISO: sNorm.value, endISO: eNorm.value };
                                      const vr = validateDateRangeTaipei(filtersToUse.start_date, filtersToUse.end_date);
                                      if (vr.ok) return { startISO: vr.startISO, endISO: vr.endISO };
                                      return { startISO: filtersToUse.start_date, endISO: filtersToUse.end_date };
                                    })();

                                    // Adjust date range: -3 days start, +3 days end to capture adjacent days for Saturday logic 3-day window
                                    let adjustedStartDate = selectedRange.startISO;
                                    let adjustedEndDate = selectedRange.endISO;

                                    const fmtISO = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' });
                                    const sAdj = new Date(selectedRange.startISO + 'T00:00:00+08:00');
                                    sAdj.setDate(sAdj.getDate() - 3);
                                    adjustedStartDate = fmtISO.format(sAdj);
                                    const eAdj = new Date(selectedRange.endISO + 'T00:00:00+08:00');
                                    eAdj.setDate(eAdj.getDate() + 3);
                                    adjustedEndDate = fmtISO.format(eAdj);

                                    console.log('Fetching attendance with adjusted range:', adjustedStartDate, adjustedEndDate);
                                    const results = await Promise.allSettled([
                                      fetchAttendanceInChunks({
                                        startDateISO: adjustedStartDate,
                                        endDateISO: adjustedEndDate,
                                        name: filtersToUse.name || '',
                                        branch: filtersToUse.branch || 'all',
                                        payrollOnly: true
                                      }),
                                      axiosInstance.get('/payroll/employees'),
                                      axiosInstance.get('/schedules')
                                    ]);

                                    const attendanceResult = results[0];
                                    if (attendanceResult.status !== 'fulfilled') {
                                      throw attendanceResult.reason || new Error('Attendance fetch failed');
                                    }
                                    const attendanceRecords = Array.isArray(attendanceResult.value) ? attendanceResult.value : [];
                                    console.log('Attendance records fetched:', attendanceRecords.length);

                                    const payrollEmployees = results[1].status === 'fulfilled' ? results[1].value.data : [];
                                    console.log('Payroll employees fetched:', payrollEmployees.length);
                                    
                                    // Store payroll employees in state so recalculations can access them
                                    setPayrollEmployees(payrollEmployees);

                                    const allSchedules = results[2].status === 'fulfilled' ? results[2].value.data : [];
                                    console.log('Schedules fetched:', Array.isArray(allSchedules) ? allSchedules.length : 0);
                                    
                                    // Store schedules in state so the table can access them
                                    setSchedules(Array.isArray(allSchedules) ? allSchedules : []);
                                    
                                    const payrollEmployeeIds = new Set(payrollEmployees.map(emp => emp.employee_id));
                                    console.log('Payroll employee IDs:', Array.from(payrollEmployeeIds));
                                    
                                    // Filter attendance records for payroll employees only
                                    const filteredRecords = attendanceRecords.filter(record => payrollEmployeeIds.has(record.user_id));
                                    
                                    // Calculate late/undertime for all filtered records first to populate raw array
                                    const rawPayrollAttendance = filteredRecords.map(record => {
                                      const hrisEmployee = employees.find(e => String(e.id) === String(record.user_id) || String(e.employee_id) === String(record.user_id));
                                      const scheduleId = hrisEmployee?.schedule_id;
                                      const branchSchedule = (Array.isArray(allSchedules) ? allSchedules : []).find(s => String(s.id) === String(scheduleId));
                                      
                                      if (!branchSchedule) return record;
                                      
                                      let recordDateISO;
                                      try {
                                        if (!record?.timestamp) return record;
                                        recordDateISO = toTaipeiISODate(record.timestamp);
                                      } catch {
                                        return record;
                                      }
                                      
                                      const GRACE_MINUTES = 0;
                                      let { status, lateMinutes, undertimeMinutes } = computeAttendanceStatus(
                                        record.timestamp,
                                        branchSchedule?.start_time,
                                        branchSchedule?.end_time,
                                        record.type,
                                        GRACE_MINUTES
                                      );

                                      // Zero out penalties if outside selected date range
                                      if (recordDateISO && (recordDateISO < selectedRange.startISO || recordDateISO > selectedRange.endISO)) {
                                          lateMinutes = 0;
                                          undertimeMinutes = 0;
                                      }
                                      
                                      // Preserve 'absent' status from backend if present
                                      if (record.status && record.status.toLowerCase() === 'absent') {
                                        status = 'absent';
                                      }
                                      
                                      return { ...record, late_minutes: lateMinutes, undertime_minutes: undertimeMinutes, status };
                                    });
                                    
                                    // Group records by employee and date, keeping only first time_in and last time_out per day
                                    const groupedByEmployeeDate = {};
                                    
                                    rawPayrollAttendance.forEach(record => {
                                      const ts = record?.timestamp;
                                      if (!ts || !record?.user_id) return;
                                      let recordDate;
                                      try {
                                        recordDate = toTaipeiISODate(ts);
                                      } catch {
                                        return;
                                      }
                                      const key = `${record.user_id}_${recordDate}`;

                                      if (!groupedByEmployeeDate[key]) {
                                        groupedByEmployeeDate[key] = { time_in: [], time_out: [] };
                                      }

                                      if (record.type === 'time_in') groupedByEmployeeDate[key].time_in.push(record);
                                      else if (record.type === 'time_out') groupedByEmployeeDate[key].time_out.push(record);
                                    });
                                    
                                    // Extract first time_in and last time_out for each employee-date combination
                                    const firstLastRecords = [];
                                    const toMs = (t) => {
                                      try { return new Date(normalizeTs(t)).getTime(); } catch { return 0; }
                                    };
                                    
                                    Object.values(groupedByEmployeeDate).forEach(group => {
                                      let firstIn = null;
                                      let lastOut = null;

                                      // Sort time_in by timestamp and take the first (earliest)
                                      if (group.time_in.length > 0) {
                                        const sortedTimeIn = group.time_in.sort((a, b) => 
                                          toMs(a.timestamp) - toMs(b.timestamp)
                                        );
                                        firstIn = sortedTimeIn[0];
                                      }
                                      
                                      // Sort time_out by timestamp and take the last (latest)
                                      if (group.time_out.length > 0) {
                                        const sortedTimeOut = group.time_out.sort((a, b) => 
                                          toMs(b.timestamp) - toMs(a.timestamp)
                                        );
                                        lastOut = sortedTimeOut[0];
                                      }

                                      // Adjust penalties if half day
                                      const halfDayStatus = detectHalfDayStatus(firstIn?.timestamp, lastOut?.timestamp);
                                      if (halfDayStatus.isHalfDay) {
                                        [...group.time_in, ...group.time_out].forEach(record => {
                                          const adjusted = adjustHalfDayPenalties(record, halfDayStatus.reason);
                                          record.late_minutes = adjusted.late;
                                          record.undertime_minutes = adjusted.undertime;
                                          record.status = adjusted.status;
                                        });
                                      }

                                      if (firstIn) firstLastRecords.push(firstIn);
                                      if (lastOut) firstLastRecords.push(lastOut);
                                    });

                                    setRawPayrollAttendanceData(rawPayrollAttendance);
                                    
                                    console.log('Filtered payroll attendance records:', firstLastRecords.length);

                                    setPayrollAttendanceData(firstLastRecords);
                                    
                                    // Calculate analytics
                                    calculatePayrollAttendanceAnalytics(firstLastRecords, payrollEmployees, filtersToUse);

                                    // Asynchronously fix any existing saved payroll records for this
                                    // date range that have stale/corrupted days_absent counts caused by
                                    // earlier logic bugs (auto-Saturdays not counted and half-day fallback
                                    // to 1.0 instead of 0.5). Runs without blocking the UI.
                                    queueMicrotask(() => {
                                      try {
                                        const sNorm = normalizeToISODateTaipei(filtersToUse.start_date);
                                        const eNorm = normalizeToISODateTaipei(filtersToUse.end_date);
                                        if (sNorm.ok && eNorm.ok) {
                                          normalizeExistingPayrollRecordsForTab('payroll', {
                                            startISO: sNorm.value,
                                            endISO: eNorm.value
                                          });
                                        }
                                      } catch { /* noop */ }
                                    });

                                    return {
                                      rawAttendance: rawPayrollAttendance,
                                      payrollEmployees,
                                      schedules: allSchedules
                                    };
                                    
                                  } catch (error) {
                                    console.error('Error fetching payroll attendance data:', error);
                                    const statusCode = error?.response?.status;
                                    const detail = error?.response?.data?.detail;
                                    const msg = detail ? String(detail) : (error?.message ? String(error.message) : 'Failed to fetch attendance data');
                                    toast.error(statusCode ? `Failed to fetch attendance data (${statusCode}): ${msg}` : msg);
                                    return null;
                                  } finally {
                                    setIsLoadingPayrollAttendance(false);
                                  }
                                };

                                const fetchMfAttendanceData = async (filtersOverride) => {
                                  const filtersToUse = filtersOverride || mfAttendanceFilters;
                                  if (!filtersToUse.start_date || !filtersToUse.end_date) {
                                    toast.error('Please select both start and end dates for MF');
                                    return;
                                  }
                                  setIsLoadingMfAttendance(true);
                                  try {
                                    const sNorm = normalizeToISODateTaipei(filtersToUse.start_date);
                                    const eNorm = normalizeToISODateTaipei(filtersToUse.end_date);
                                    const selectedRange = (() => {
                                      if (sNorm.ok && eNorm.ok) return { startISO: sNorm.value, endISO: eNorm.value };
                                      const vr = validateDateRangeTaipei(filtersToUse.start_date, filtersToUse.end_date);
                                      if (vr.ok) return { startISO: vr.startISO, endISO: vr.endISO };
                                      return { startISO: filtersToUse.start_date, endISO: filtersToUse.end_date };
                                    })();

                                    const fmtISO = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' });
                                    const sAdj = new Date(selectedRange.startISO + 'T00:00:00+08:00');
                                    sAdj.setDate(sAdj.getDate() - 3);
                                    const fetchStart = fmtISO.format(sAdj);
                                    const eAdj = new Date(selectedRange.endISO + 'T00:00:00+08:00');
                                    eAdj.setDate(eAdj.getDate() + 3);
                                    const fetchEnd = fmtISO.format(eAdj);
                                    
                                    const fetchAttendanceInChunks = async ({ startDateISO, endDateISO, name, branch, payrollOnly }) => {
                                      const start = new Date(startDateISO + 'T00:00:00+08:00');
                                      const end = new Date(endDateISO + 'T00:00:00+08:00');
                                      if (isNaN(start) || isNaN(end) || start > end) return [];
                                      const chunkDays = 3;
                                      const out = [];
                                      let cur = new Date(start);
                                      while (cur <= end) {
                                        const chunkEnd = new Date(cur);
                                        chunkEnd.setDate(chunkEnd.getDate() + (chunkDays - 1));
                                        if (chunkEnd > end) chunkEnd.setTime(end.getTime());
                                        const params = new URLSearchParams({
                                          start_date: toTaipeiISODate(cur),
                                          end_date: toTaipeiISODate(chunkEnd),
                                          ...(payrollOnly ? { payroll_only: 'true' } : {}),
                                          ...(name ? { name } : {}),
                                          ...(branch && branch !== 'all' ? { branch } : {})
                                        });
                                        const resp = await axiosInstance.get(`/attendance?${params.toString()}`);
                                        const rows = Array.isArray(resp.data) ? resp.data : [];
                                        out.push(...rows);
                                        cur.setDate(cur.getDate() + chunkDays);
                                      }
                                      return out;
                                    };

                                    const results = await Promise.allSettled([
                                      fetchAttendanceInChunks({
                                        startDateISO: fetchStart,
                                        endDateISO: fetchEnd,
                                        name: filtersToUse.name || '',
                                        branch: filtersToUse.branch || 'all',
                                        payrollOnly: true
                                      }),
                                      axiosInstance.get('/payroll/employees'),
                                      axiosInstance.get('/schedules')
                                    ]);

                                    const attendanceRecords = results[0].status === 'fulfilled' ? (Array.isArray(results[0].value) ? results[0].value : []) : [];
                                    const payrollEmployees = results[1].status === 'fulfilled' ? results[1].value.data : [];
                                    const allSchedules = results[2].status === 'fulfilled' ? results[2].value.data : [];
                                    setSchedules(Array.isArray(allSchedules) ? allSchedules : []);

                                    const filteredRecords = Array.isArray(attendanceRecords) ? attendanceRecords : [];

                                    // Calculate late/undertime for all filtered records first to populate raw array
                                    const rawMfAttendance = filteredRecords.map(record => {
                                      const emp = employees.find(e => String(e.id) === String(record.user_id) || String(e.employee_id) === String(record.user_id));
                                      const scheduleId = emp?.schedule_id;
                                      const branchSchedule = (Array.isArray(allSchedules) ? allSchedules : []).find(s => String(s.id) === String(scheduleId));
                                      if (!branchSchedule) return record;
                                      
                                      const GRACE_MINUTES = 0;
                                      let { status, lateMinutes, undertimeMinutes } = computeAttendanceStatus(
                                        record.timestamp,
                                        branchSchedule?.start_time,
                                        branchSchedule?.end_time,
                                        record.type,
                                        GRACE_MINUTES
                                      );

                                      // Zero out penalties if outside selected date range
                                      try {
                                        const recordDateISO = toTaipeiISODate(record.timestamp);
                                        if (recordDateISO < selectedRange.startISO || recordDateISO > selectedRange.endISO) {
                                            lateMinutes = 0;
                                            undertimeMinutes = 0;
                                        }
                                      } catch (e) { /* noop */ }

                                      // Preserve 'absent' status from backend if present
                                      if (record.status && record.status.toLowerCase() === 'absent') {
                                        status = 'absent';
                                      }

                                      return { ...record, late_minutes: lateMinutes, undertime_minutes: undertimeMinutes, status };
                                    });

                                    const groupedByEmployeeDate = {};
                                    rawMfAttendance.forEach(record => {
                                      const ts = record?.timestamp;
                                      if (!ts || !record?.user_id) return;
                                      let recordDate;
                                      try { recordDate = toTaipeiISODate(ts); } catch { return; }
                                      const key = `${record.user_id}_${recordDate}`;
                                      if (!groupedByEmployeeDate[key]) groupedByEmployeeDate[key] = { time_in: [], time_out: [] };
                                      if (record.type === 'time_in') groupedByEmployeeDate[key].time_in.push(record);
                                      else if (record.type === 'time_out') groupedByEmployeeDate[key].time_out.push(record);
                                    });

                                    const firstLastRecords = [];
                                    const toMs = (t) => {
                                      try { return new Date(normalizeTs(t)).getTime(); } catch { return 0; }
                                    };
                                    Object.values(groupedByEmployeeDate).forEach(group => {
                                      let firstIn = null;
                                      let lastOut = null;

                                      if (group.time_in.length > 0) {
                                        const sortedTimeIn = group.time_in.sort((a, b) => toMs(a.timestamp) - toMs(b.timestamp));
                                        firstIn = sortedTimeIn[0];
                                      }
                                      if (group.time_out.length > 0) {
                                        const sortedTimeOut = group.time_out.sort((a, b) => toMs(b.timestamp) - toMs(a.timestamp));
                                        lastOut = sortedTimeOut[0];
                                      }

                                      // Adjust penalties if half day
                                      const halfDayStatus = detectHalfDayStatus(firstIn?.timestamp, lastOut?.timestamp);
                                      if (halfDayStatus.isHalfDay) {
                                        [...group.time_in, ...group.time_out].forEach(record => {
                                          const adjusted = adjustHalfDayPenalties(record, halfDayStatus.reason);
                                          record.late_minutes = adjusted.late;
                                          record.undertime_minutes = adjusted.undertime;
                                          record.status = adjusted.status;
                                        });
                                      }

                                      if (firstIn) firstLastRecords.push(firstIn);
                                      if (lastOut) firstLastRecords.push(lastOut);
                                    });

                                    setRawMfAttendanceData(rawMfAttendance);

                                    setMfAttendanceData(firstLastRecords);
                                    calculateMfAttendanceAnalytics(firstLastRecords, filtersToUse);

                                    // Asynchronously fix any existing saved MF payroll records for this
                                    // date range that have stale/corrupted days_absent counts (auto-Saturdays
                                    // not counted, half-day fallback to 1.0). Runs without blocking UI.
                                    queueMicrotask(() => {
                                      try {
                                        const sNorm = normalizeToISODateTaipei(filtersToUse.start_date);
                                        const eNorm = normalizeToISODateTaipei(filtersToUse.end_date);
                                        if (sNorm.ok && eNorm.ok) {
                                          normalizeExistingPayrollRecordsForTab('mf', {
                                            startISO: sNorm.value,
                                            endISO: eNorm.value
                                          });
                                        }
                                      } catch { /* noop */ }
                                    });

                                    return {
                                      rawAttendance: rawMfAttendance,
                                      payrollEmployees,
                                      schedules: allSchedules
                                    };

                                    // Preload payslip baseline for MF summary when filters include a name
                                    if (filtersToUse.name) {
                                      const nameQ = filtersToUse.name.toLowerCase();
                                      const matchedEmployee = employees.find(emp =>
                                        emp.full_name?.toLowerCase().includes(nameQ) ||
                                        String(emp.employee_id || '').toLowerCase().includes(nameQ) ||
                                        String(emp.id || '').toLowerCase().includes(nameQ)
                                      );
                                      const payrollEmployee = matchedEmployee ? (payrollEmployees.find(emp =>
                                        String(emp.employee_id) === String(matchedEmployee.id) ||
                                        String(emp.employee_id) === String(matchedEmployee.employee_id)
                                      ) || payrollEmployees.find(emp => (emp.full_name || '').toLowerCase().includes(nameQ))) : null;
                                      if (matchedEmployee && payrollEmployee) {
                                        setMfSelectedPayslipEmployee(matchedEmployee);
                                        setPayrollEmployeeData(payrollEmployee);
                                        const basicSalary = parseFloat(payrollEmployee.salary) || 0;
                                        let dailyRate = parseFloat(payrollEmployee.daily_rate) || 0;
                                        if (!dailyRate) {
                                          const basis = payrollEmployee.daily_rate_formula || payrollEmployee.rate_formula || payrollEmployee.dailyRateFormula || 313;
                                          dailyRate = computeDailyRateFromBasis(basicSalary, basis);
                                        }
                                        const hourlyRate = dailyRate / 8;
                                        const minuteRate = dailyRate / 8 / 60;
                                        const lateDeduction = (mfAttendanceAnalytics.total_minutes_late || 0) * minuteRate;
                                        const undertimeDeduction = (mfAttendanceAnalytics.total_minutes_undertime || 0) * minuteRate;
                                        setCalculatedMfPayslip(prev => ({
                                          ...prev,
                                          dailyRate,
                                          hourlyRate,
                                          basicSalary: (parseFloat(payrollEmployee?.allowances?.mf) || 0) + (parseFloat(payrollEmployee?.allowances?.gas_allowance) || 0) + (parseFloat(payrollEmployee?.allowances?.load_allowance) || 0) + (parseFloat(payrollEmployee?.allowances?.housing_allowance) || 0),
                                          deductions: { ...prev.deductions, late: lateDeduction, undertime: undertimeDeduction }
                                        }));
                                      }
                                    }
                                  } catch (error) {
                                    const statusCode = error?.response?.status;
                                    const detail = error?.response?.data?.detail;
                                    const msg = detail ? String(detail) : (error?.message ? String(error.message) : 'Failed to fetch MF attendance data');
                                    toast.error(statusCode ? `Failed to fetch MF attendance data (${statusCode}): ${msg}` : msg);
                                    return null;
                                  } finally {
                                    setIsLoadingMfAttendance(false);
                                  }
                                };

                                const fetchRunningTotalPayroll = async () => {
                                  try {
                                    const params = new URLSearchParams();
                                    if (payrollAttendanceFilters.start_date) params.set('start_date', payrollAttendanceFilters.start_date);
                                    if (payrollAttendanceFilters.end_date) params.set('end_date', payrollAttendanceFilters.end_date);
                                    const url = params.toString() ? `/payroll/records?${params.toString()}` : '/payroll/records';
                                    const response = await axiosInstance.get(url);
                                    const records = Array.isArray(response.data) ? response.data : [];
                                    const total = records.reduce((sum, r) => sum + (parseFloat(r.net_pay) || 0), 0);
                                    setRunningTotalPayroll(total);
                                  } catch (error) {
                                    setRunningTotalPayroll(0);
                                  }
                                };

                                const fetchRunningTotalPayrollAll = async () => {
                                  try {
                                    const response = await axiosInstance.get('/payroll/records');
                                    const records = Array.isArray(response.data) ? response.data : [];
                                    const total = records.reduce((sum, r) => sum + (parseFloat(r.net_pay) || 0), 0);
                                    setRunningTotalPayrollDashboard(total);
                                    // Compute current month's total from saved records
                                    const monthTotals = Array(12).fill(0);
                                    records.forEach((r) => {
                                      const dateSource = r.end_date || r.start_date || r.created_at;
                                      const d = new Date(dateSource);
                                      if (!isNaN(d)) {
                                        const m = d.getMonth();
                                        monthTotals[m] += parseFloat(r.net_pay) || 0;
                                      }
                                    });
                                    const now = new Date();
                                    const taipeiNow = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Taipei' }));
                                    setThisMonthPayroll(monthTotals[taipeiNow.getMonth()] || 0);
                                  } catch (error) {
                                    setRunningTotalPayrollDashboard(0);
                                    setThisMonthPayroll(0);
                                  }
                                };

                                const derivePayrollPeriodFromRange = (startISO, endISO) => {
                                  if (!startISO || !endISO) return '';
                                  const sd = new Date(startISO);
                                  const ed = new Date(endISO);
                                  if (isNaN(sd) || isNaN(ed)) return '';
                                  const monthFmt = (d) => d.toLocaleString('en-US', { month: 'short' });
                                  const y1 = sd.getFullYear();
                                  const y2 = ed.getFullYear();
                                  const m1 = monthFmt(sd);
                                  const m2 = monthFmt(ed);
                                  if (y1 === y2) return m1 === m2 ? `${m1} ${y1}` : `${m1}\u2013${m2} ${y1}`;
                                  return `${m1} ${y1}\u2013${m2} ${y2}`;
                                };

                                const isPayrollEmployeeActiveForGeneration = (employee) => {
                                  if (!employee) return false;
                                  if (isInactivePayslipExceptionEmail(employee?.email || employee?.employee_email)) {
                                    return true;
                                  }
                                  if (employee?.is_active === false) return false;
                                  const status = String(employee?.status || 'active').trim().toLowerCase();
                                  return status !== 'inactive';
                                };
                                const normalizeGeneratedPayslipEmployeeName = (value) => String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();
                                const findHrisEmployeeForGeneratedRow = (row) => {
                                  const normalizedEmployeeId = normalizeEmployeeIdForQuery(row?.employee_id);
                                  const normalizedEmail = String(row?.employee_email || row?.email || '').trim().toLowerCase();
                                  const normalizedName = normalizeGeneratedPayslipEmployeeName(row?.employee_name || row?.full_name);
                                  return (Array.isArray(employees) ? employees : []).find((employee) => {
                                    const employeeId = normalizeEmployeeIdForQuery(employee?.employee_id || employee?.id);
                                    const employeeEmail = String(employee?.email || '').trim().toLowerCase();
                                    const employeeName = normalizeGeneratedPayslipEmployeeName(employee?.full_name || employee?.employee_name);
                                    if (normalizedEmployeeId && employeeId && normalizedEmployeeId === employeeId) return true;
                                    if (normalizedEmail && employeeEmail && normalizedEmail === employeeEmail) return true;
                                    if (normalizedName && employeeName && normalizedName === employeeName) return true;
                                    return false;
                                  }) || null;
                                };
                                const findPayrollEmployeeForGeneratedRow = (row) => {
                                  const normalizedEmployeeId = normalizeEmployeeIdForQuery(row?.employee_id);
                                  const normalizedEmail = String(row?.employee_email || row?.email || '').trim().toLowerCase();
                                  const normalizedName = normalizeGeneratedPayslipEmployeeName(row?.employee_name || row?.full_name);
                                  return (Array.isArray(payrollEmployees) ? payrollEmployees : []).find((employee) => {
                                    const employeeId = normalizeEmployeeIdForQuery(employee?.employee_id || employee?.id);
                                    const employeeEmail = String(employee?.email || '').trim().toLowerCase();
                                    const employeeName = normalizeGeneratedPayslipEmployeeName(employee?.full_name || employee?.employee_name);
                                    if (normalizedEmployeeId && employeeId && normalizedEmployeeId === employeeId) return true;
                                    if (normalizedEmail && employeeEmail && normalizedEmail === employeeEmail) return true;
                                    if (normalizedName && employeeName && normalizedName === employeeName) return true;
                                    return false;
                                  }) || null;
                                };
                                const isGeneratedPayslipRowActive = (row) => {
                                  const matchedEmployee = findPayrollEmployeeForGeneratedRow(row);
                                  if (isInactivePayslipExceptionEmail(
                                    matchedEmployee?.email
                                    || matchedEmployee?.employee_email
                                    || row?.employee_email
                                    || row?.email
                                  )) {
                                    return true;
                                  }
                                  return isPayrollEmployeeActiveForGeneration(matchedEmployee || row);
                                };

                                const computeGeneratedPayslipRowsForTab = async ({ activeTab, attendanceBundle } = {}) => {
                                  const activeFilters = activeTab === 'mf' ? mfAttendanceFilters : payrollAttendanceFilters;
                                  const startISO = activeFilters.start_date;
                                  const endISO = activeFilters.end_date;
                                  if (!startISO || !endISO) {
                                    return { error: 'Please select both start and end dates' };
                                  }

                                  const vr = validateDateRangeTaipei(startISO, endISO);
                                  if (!vr.ok) {
                                    return { error: 'Invalid date range' };
                                  }

                                  const effectivePayrollPeriod = ((payrollPeriod || '').trim() || derivePayrollPeriodFromRange(vr.startISO, vr.endISO)).trim();
                                  if (!effectivePayrollPeriod) {
                                    return { error: 'Please enter a payroll period first' };
                                  }

                                  const rawAttendance = Array.isArray(attendanceBundle?.rawAttendance)
                                    ? attendanceBundle.rawAttendance
                                    : (activeTab === 'mf' ? rawMfAttendanceData : rawPayrollAttendanceData);
                                  const rowsAll = (Array.isArray(attendanceBundle?.payrollEmployees)
                                    ? attendanceBundle.payrollEmployees
                                    : payrollEmployees) || [];

                                  const start = new Date(vr.startISO + 'T00:00:00+08:00');
                                  const end = new Date(vr.endISO + 'T00:00:00+08:00');
                                  const hols = sanitizeHolidayRows(holidays).filter((h) => h.date >= vr.startISO && h.date <= vr.endISO);
                                  const holidaySet = new Set(hols.map((h) => h.date));

                                  // Split the ONE TRUE raw attendance data into two buckets:
                                  // 1) presenceRecords = time_in / time_out (actual clock punches)
                                  // 2) perEmployeeAbsentDates[empId] = Set of date-ISOs with explicit "absent" records
                                  const presenceRecords = [];
                                  const perEmployeeAbsentDates = {};
                                  (rawAttendance || []).forEach((r) => {
                                    if (!r) return;
                                    const empId = String(r.user_id ?? '').trim();
                                    if (!empId) return;
                                    let dateISO;
                                    try { dateISO = toTaipeiISODate(r.timestamp); } catch { return; }
                                    if (!dateISO) return;
                                    if (dateISO < vr.startISO || dateISO > vr.endISO) return;
                                    const t = String(r?.type || '').toLowerCase().trim();
                                    if (t === 'absent' || t === 'absence' || t === 'absent_day') {
                                      if (!perEmployeeAbsentDates[empId]) perEmployeeAbsentDates[empId] = new Set();
                                      perEmployeeAbsentDates[empId].add(dateISO);
                                    } else if (t === 'time_in' || t === 'time_out') {
                                      presenceRecords.push(r);
                                    }
                                  });

                                  const { perEmployeeMinutes, perEmployeeDates } = aggregateFirstLastMinutes(presenceRecords, {
                                    startISO: vr.startISO,
                                    endISO: vr.endISO,
                                    holidaySet
                                  });

                                  Object.entries(perEmployeeDates).forEach(([, dates]) => {
                                    Object.entries(dates).forEach(([, day]) => {
                                      const hd = detectHalfDayStatus(day.first_in, day.last_out);
                                      day.is_half_day = hd.isHalfDay;
                                    });
                                  });

                                  const rows = rowsAll.filter(isPayrollEmployeeActiveForGeneration);
                                  const prevGrossByEmployeeId = {};
                                  const isBatchSSSWindow = activeTab !== 'mf' && isEndDateInSSSWindow(vr.endISO);
                                  if (isBatchSSSWindow) {
                                    try {
                                      const { monthStartISO } = computeMonthWindowFromEndISO(vr.endISO);
                                      const endObj = new Date(`${vr.endISO}T00:00:00+08:00`);
                                      const year = endObj.getFullYear();
                                      const month = endObj.getMonth() + 1;
                                      const prevWindowEndISO = `${year}-${String(month).padStart(2, '0')}-19`;
                                      const params = new URLSearchParams({
                                        start_date: String(monthStartISO),
                                        end_date: String(prevWindowEndISO)
                                      });
                                      const resp = await axiosInstance.get(`/payroll/records?${params.toString()}`);
                                      const records = Array.isArray(resp.data) ? resp.data : [];
                                      const latestByPeriod = {};
                                      records.forEach((r) => {
                                        const recEmp = normalizeEmployeeIdForQuery(r?.employee_id);
                                        const startDate = String(r?.start_date || '').trim();
                                        const endDate = String(r?.end_date || '').trim();
                                        if (!recEmp || !startDate || !endDate) return;
                                        const key = `${recEmp}_${startDate}_${endDate}`;
                                        const existing = latestByPeriod[key];
                                        if (!existing || new Date(r?.created_at || 0) > new Date(existing?.created_at || 0)) {
                                          latestByPeriod[key] = r;
                                        }
                                      });
                                      Object.values(latestByPeriod).forEach((r) => {
                                        const recEmp = normalizeEmployeeIdForQuery(r?.employee_id);
                                        if (!recEmp) return;
                                        const gross = parseFloat(r?.gross_salary) || 0;
                                        prevGrossByEmployeeId[recEmp] = (prevGrossByEmployeeId[recEmp] || 0) + gross;
                                      });
                                    } catch { /* noop */ }
                                  }

                                  const computed = rows
                                    .map((pe) => {
                                      const empId = pe?.employee_id;
                                      if (!empId) return null;
                                      const basis = pe?.daily_rate_formula || pe?.rate_formula || pe?.dailyRateFormula;
                                      const isSixDay = String(basis) === '313' || basis === 313;
                                      const rowHolidays = hols.filter((h) => {
                                        const hd = new Date(h.date + 'T00:00:00+08:00');
                                        if (isNaN(hd)) return false;
                                        return isWorkingDayForBasis(hd, isSixDay);
                                      });
                                      const credits = computeEmployeeDayCreditsWithOverrides({
                                        startISO: vr.startISO,
                                        endISO: vr.endISO,
                                        isSixDay,
                                        employeeId: String(empId),
                                        employeeDates: perEmployeeDates[empId] || {},
                                        holidayRows: holidays,
                                        saturdayOverrides
                                      });

                                      let workingDaysEmp = countWorkingDaysMinusHolidays({
                                        startISO: vr.startISO,
                                        endISO: vr.endISO,
                                        isSixDay,
                                        holidayRows: hols
                                      });

                                      // Count Days Present from the returned `credits` map directly.
                                      // `credits` already correctly contains:
                                      //   1.0 for full present (has_in && has_out && !half_day)
                                      //   0.5 for half-day present
                                      //   1.0 for SATURDAYS auto-presented via the sandwich rule (EVEN IF no
                                      //       actual time_in/time_out punch exists on that Saturday  because
                                      //       the rule exists to credit them without punches!)
                                      //   1.0 for holidays sandwiched as present
                                      // Previously an extra `recordedDateSet.has(iso)` guard was added which
                                      // WRONGLY filtered out auto-presented Saturdays/holidays that had no
                                      // actual punches, causing saved payslip absent counts to be too high
                                      // vs the Payslip Calculation Summary modal display.
                                      // This now matches exactly what the modal computes.
                                      let rawFullDays = 0;
                                      let rawHalfDays = 0;
                                      Object.entries(credits).forEach(([iso, credit]) => {
                                        if (credit === 1) rawFullDays++;
                                        else if (credit === 0.5) rawHalfDays++;
                                      });
                                      const presentDays = rawFullDays + (rawHalfDays * 0.5);
                                      // Days Absent = Working Days  Actual Present Days (clamped to 0)
                                      // Note: perEmployeeAbsentDates (explicit type=="absent" records) are intentionally
                                      // NOT added separately here  the Working  Present formula already captures
                                      // those dates since they have no time_in/time_out punches.
                                      const absentDays = Math.max(0, workingDaysEmp - presentDays);
                                      const halfDaysCount = rawHalfDays;
                                      const mins = perEmployeeMinutes[empId] || { late: 0, undertime: 0 };
                                      const isInactivePayslipException = isInactivePayslipExceptionEmail(pe?.email);
                                      const effectiveAbsentDays = isInactivePayslipException ? 0 : absentDays;
                                      const effectiveLateMinutes = isInactivePayslipException ? 0 : (mins.late || 0);
                                      const effectiveUndertimeMinutes = isInactivePayslipException ? 0 : (mins.undertime || 0);

                                      const salary = parseFloat(pe?.salary) || 0;
                                      const dailyRate = (parseFloat(pe?.daily_rate) > 0)
                                        ? parseFloat(pe?.daily_rate)
                                        : computeDailyRateFromBasis(salary, basis || 313);
                                      const hourlyRate = dailyRate / 8;
                                      const { absenceDeduction, lateDeduction, undertimeDeduction } = calculateAttendanceDeductions(
                                        effectiveAbsentDays,
                                        effectiveLateMinutes,
                                        effectiveUndertimeMinutes,
                                        dailyRate
                                      );

                                      const endDateStr = vr.endISO;
                                      const endDateObj = new Date(endDateStr + 'T00:00:00+08:00');
                                      const lastDay = new Date(endDateObj.getFullYear(), endDateObj.getMonth() + 1, 0).getDate();
                                      const isEndOfMonth = !isNaN(endDateObj) && endDateObj.getDate() === lastDay;

                                      let basePay = 0;
                                      let halfMonthSalary = 0;
                                      if (activeTab === 'mf') {
                                        const mf = parseFloat(pe?.allowances?.mf) || 0;
                                        const gas = parseFloat(pe?.allowances?.gas_allowance) || 0;
                                        const load = parseFloat(pe?.allowances?.load_allowance) || 0;
                                        const housing = parseFloat(pe?.allowances?.housing_allowance) || 0;
                                        basePay = mf + gas + load + housing;
                                      } else {
                                        halfMonthSalary = salary / 2;
                                        basePay = halfMonthSalary;
                                      }

                                      const basicSalary = Math.max(0, basePay - absenceDeduction - lateDeduction - undertimeDeduction);
                                      const grossSalary = basicSalary;

                                      const toggles = activeTab === 'mf'
                                        ? {
                                            sss: true,
                                            phic: true,
                                            hdmf: true,
                                            tax: false,
                                            is_minimum_wage: !!pe?.is_minimum_wage
                                          }
                                        : {
                                            sss: true,
                                            phic: true,
                                            hdmf: true,
                                            tax: !pe?.is_minimum_wage,
                                            is_minimum_wage: !!pe?.is_minimum_wage
                                          };

                                      let sssContribution = 0;
                                      let philhealthContribution = 0;
                                      let hdmfContribution = 0;
                                      let withholdingTax = 0;

                                      if (toggles.sss && isEndDateInSSSWindow(endDateStr)) {
                                        if (activeTab === 'mf') {
                                          sssContribution = calculateSSSDeduction(grossSalary || 0);
                                        } else {
                                          const key = normalizeEmployeeIdForQuery(empId);
                                          const prevGross = (key && prevGrossByEmployeeId[key]) ? prevGrossByEmployeeId[key] : 0;
                                          const monthlyGrossForSSS = Math.max(0, prevGross + (grossSalary || 0));
                                          sssContribution = calculateSSSDeduction(monthlyGrossForSSS);
                                        }
                                      }
                                      if (toggles.phic) {
                                        const isFirstHalf = isEndDateInFirstHalf(endDateStr);
                                        philhealthContribution = isFirstHalf ? (salary * 0.05) / 2 : 0;
                                      }
                                      if (toggles.hdmf) {
                                        const isFirstHalf = isEndDateInFirstHalf(endDateStr);
                                        const extra = parseFloat(pe?.deductions?.hdmf_additional) || 0;
                                        hdmfContribution = isFirstHalf ? (200 + extra) : 0;
                                      }
                                      if (toggles.tax && !toggles.is_minimum_wage && isEndOfMonth) {
                                        const monthlyTaxable = salary - sssContribution - philhealthContribution - hdmfContribution;
                                        withholdingTax = calculateTaxDeduction(monthlyTaxable);
                                      }

                                      const totalDeductions = (sssContribution || 0) + (philhealthContribution || 0) + (hdmfContribution || 0) + (withholdingTax || 0);
                                      const netPay = Math.max(0, grossSalary - totalDeductions);

                                      const attendanceFields = isInactivePayslipException
                                        ? zeroAttendanceDeductionFields({
                                            days_absent: effectiveAbsentDays,
                                            minutes_late: effectiveLateMinutes,
                                            minutes_undertime: effectiveUndertimeMinutes,
                                            absence_deduction: absenceDeduction,
                                            tardiness_deduction: lateDeduction,
                                            undertime_deduction: undertimeDeduction
                                          })
                                        : {
                                            days_absent: effectiveAbsentDays,
                                            minutes_late: effectiveLateMinutes,
                                            minutes_undertime: effectiveUndertimeMinutes,
                                            absence_deduction: absenceDeduction,
                                            tardiness_deduction: lateDeduction,
                                            undertime_deduction: undertimeDeduction
                                          };

                                      return {
                                        employee_id: String(empId),
                                        employee_name: pe?.full_name || String(empId),
                                        employee_email: pe?.email || '',
                                        branch: pe?.branch || 'N/A',
                                        tin_number: pe?.tin_number || '',
                                        sss_number: pe?.sss_number || '',
                                        phic_number: pe?.phic_number || '',
                                        hdmf_number: pe?.hdmf_number || '',
                                        payroll_period: effectivePayrollPeriod,
                                        start_date: vr.startISO,
                                        end_date: vr.endISO,
                                        half_month_salary: halfMonthSalary,
                                        daily_rate: dailyRate,
                                        hourly_rate: hourlyRate,
                                        days_present: presentDays,
                                        days_absent: attendanceFields.days_absent,
                                        half_days_present: halfDaysCount,
                                        absence_deduction: attendanceFields.absence_deduction,
                                        minutes_late: attendanceFields.minutes_late,
                                        tardiness_deduction: attendanceFields.tardiness_deduction,
                                        minutes_undertime: attendanceFields.minutes_undertime,
                                        undertime_deduction: attendanceFields.undertime_deduction,
                                        basic_salary: basicSalary,
                                        overtime_pay: [],
                                        ot_hours: 0,
                                        ot_pay_amount: 0,
                                        holiday_hours: 0,
                                        holiday_pay_amount: 0,
                                        holidays_count: Array.isArray(rowHolidays) ? rowHolidays.length : 0,
                                        holidays: rowHolidays,
                                        additional_income: [],
                                        gross_salary: grossSalary,
                                        sss_contribution: sssContribution,
                                        hdmf_contribution: hdmfContribution,
                                        philhealth_contribution: philhealthContribution,
                                        withholding_tax: withholdingTax,
                                        additional_deductions: [],
                                        total_deductions: totalDeductions,
                                        net_pay: netPay,
                                        deduction_settings: {
                                          ...toggles,
                                          ...(activeTab === 'mf' ? { mf_record: true } : {})
                                        }
                                      };
                                    })
                                    .filter(Boolean)
                                    .sort((a, b) => String(a.employee_name).localeCompare(String(b.employee_name)));

                                  return { computed, effectivePayrollPeriod };
                                };

                                const syncGeneratedPayslipRowsForTab = async ({ activeTab, attendanceBundle } = {}) => {
                                  const result = await computeGeneratedPayslipRowsForTab({ activeTab, attendanceBundle });
                                  if (!result || result.error) return result;
                                  const { computed, effectivePayrollPeriod } = result;
                                  if (!((payrollPeriod || '').trim()) && effectivePayrollPeriod) {
                                    setPayrollPeriod(effectivePayrollPeriod);
                                  }
                                  setGeneratedPayslips((prev) => ({
                                    ...prev,
                                    [activeTab]: computed
                                  }));
                                  setSelectedGeneratedPayslipRow((prev) => {
                                    if (!prev) return prev;
                                    const activeFilters = activeTab === 'mf' ? mfAttendanceFilters : payrollAttendanceFilters;
                                    const nextMatch = computed.find((row) => (
                                      String(row?.employee_id || '') === String(selectedGeneratedPayslipEmployeeId || prev?.employee_id || '') &&
                                      String(row?.start_date || '') === String(activeFilters?.start_date || prev?.start_date || '') &&
                                      String(row?.end_date || '') === String(activeFilters?.end_date || prev?.end_date || '')
                                    ));
                                    return nextMatch || prev;
                                  });
                                  return result;
                                };

                                const generateBatchPayslips = async () => {
                                  const activeTab = generateTableTab;
                                  const bundle = activeTab === 'mf'
                                    ? await fetchMfAttendanceData({ ...mfAttendanceFilters, branch: 'all' })
                                    : await fetchPayrollAttendanceData({ ...payrollAttendanceFilters, name: '', branch: 'all' });
                                  if (!bundle) return;

                                  const result = await syncGeneratedPayslipRowsForTab({ activeTab, attendanceBundle: bundle });
                                  if (result?.error) {
                                    toast.error(result.error);
                                    return;
                                  }
                                  toast.success(`Generated ${result?.computed?.length || 0} payslips`);
                                };

                                const handleGeneratedPayslipClick = async (row) => {
                                  if (!row) return;
                                  setSelectedGeneratedPayslipRow(row);
                                  setSelectedGeneratedPayslipEmployeeId(row.employee_id);
                                  setSelectedGeneratedPayslipEmployeeName(row.employee_name || '');
                                  setIsGeneratedPayslipSummaryOpen(true);
                                  if (generateTableTab === 'mf') {
                                    const nextFilters = { ...mfAttendanceFilters, name: row.employee_name };
                                    setMfAttendanceFilters(nextFilters);
                                    await fetchMfAttendanceData(nextFilters);
                                  } else {
                                    const nextFilters = { ...payrollAttendanceFilters, name: row.employee_name };
                                    setPayrollAttendanceFilters(nextFilters);
                                    await fetchPayrollAttendanceData(nextFilters);
                                  }
                                };

                                const computeLoanTileEffectiveRange = (mode, selectedStartRaw, selectedEndRaw) => {
                                  const selectedStart = String(selectedStartRaw || '').trim();
                                  const selectedEnd = String(selectedEndRaw || '').trim();
                                  if (!selectedStart || !selectedEnd) return { start: selectedStart, end: selectedEnd };
                                  let endDate;
                                  try {
                                    endDate = parseISO(selectedEnd);
                                  } catch {
                                    endDate = null;
                                  }
                                  if (!endDate || isNaN(endDate)) return { start: selectedStart, end: selectedEnd };
                                  const day = endDate.getDate();
                                  if (mode === 'payroll') {
                                    if (day >= 5 && day <= 15) {
                                      const fifteenth = new Date(endDate.getFullYear(), endDate.getMonth(), 15);
                                      return { start: selectedStart, end: format(fifteenth, 'yyyy-MM-dd') };
                                    }
                                    if (day >= 20) {
                                      return { start: selectedStart, end: format(endOfMonth(endDate), 'yyyy-MM-dd') };
                                    }
                                    return { start: selectedStart, end: selectedEnd };
                                  }
                                  if (mode === 'mf') {
                                    if (day >= 20) {
                                      return {
                                        start: format(startOfMonth(endDate), 'yyyy-MM-dd'),
                                        end: format(endOfMonth(endDate), 'yyyy-MM-dd')
                                      };
                                    }
                                    return { start: selectedStart, end: selectedEnd };
                                  }
                                  return { start: selectedStart, end: selectedEnd };
                                };

                                const formatLoanTypeLabel = (loan) => {
                                  const t = String(loan?.loan_type || '').toLowerCase();
                                  const typeLabel = t ? `${t.charAt(0).toUpperCase()}${t.slice(1)}` : '';
                                  const subtype = String(loan?.loan_subtype || '').trim();
                                  if (!typeLabel && !subtype) return '-';
                                  if (typeLabel && subtype) return `${typeLabel} - ${subtype}`;
                                  return typeLabel || subtype;
                                };

                                const currentPayrollLoanRecord = useMemo(() => {
                                  const generatedRow = getGeneratedPayslipRowForSelection(
                                    'payroll',
                                    selectedPayslipEmployee?.employee_id || selectedPayslipEmployee?.id,
                                    payrollAttendanceFilters.start_date,
                                    payrollAttendanceFilters.end_date
                                  );
                                  const baseRecord = isEditingPayslipRecord ? (editingPayslipRecordMeta?.recordSnapshot || generatedRow) : generatedRow;
                                  return {
                                    start_date: String(baseRecord?.start_date || payrollAttendanceFilters.start_date || '').trim(),
                                    end_date: String(baseRecord?.end_date || payrollAttendanceFilters.end_date || '').trim()
                                  };
                                }, [
                                  editingPayslipRecordMeta?.recordSnapshot?.end_date,
                                  editingPayslipRecordMeta?.recordSnapshot?.start_date,
                                  isEditingPayslipRecord,
                                  payrollAttendanceFilters.end_date,
                                  payrollAttendanceFilters.start_date,
                                  selectedPayslipEmployee?.employee_id,
                                  selectedPayslipEmployee?.id
                                ]);

                                const fallbackApplicablePayrollPayslipLoans = useMemo(() => {
                                  if (generateTableTab === 'mf') return [];
                                  const employeeId = selectedPayslipEmployee?.employee_id || selectedPayslipEmployee?.id || payrollEmployeeData?.employee_id;
                                  const employeeName = selectedPayslipEmployee?.full_name || selectedPayslipEmployee?.employee_name || payrollEmployeeData?.full_name;
                                  return getApplicableLoansForRecord({
                                    loans: payrollLoans,
                                    employeeId,
                                    employeeName,
                                    record: currentPayrollLoanRecord,
                                    source: 'payroll'
                                  });
                                }, [
                                  currentPayrollLoanRecord,
                                  generateTableTab,
                                  payrollEmployeeData?.employee_id,
                                  payrollEmployeeData?.full_name,
                                  payrollLoans,
                                  selectedPayslipEmployee?.employee_id,
                                  selectedPayslipEmployee?.employee_name,
                                  selectedPayslipEmployee?.full_name,
                                  selectedPayslipEmployee?.id
                                ]);

                                const fallbackApplicableMfPayslipLoans = useMemo(() => {
                                  if (generateTableTab !== 'mf') return [];
                                  const employeeId = payrollEmployeeData?.employee_id || mfSelectedPayslipEmployee?.employee_id || mfSelectedPayslipEmployee?.id;
                                  const employeeName = payrollEmployeeData?.full_name || mfSelectedPayslipEmployee?.full_name || mfSelectedPayslipEmployee?.employee_name;
                                  return getApplicableLoansForRecord({
                                    loans: payrollLoans,
                                    employeeId,
                                    employeeName,
                                    record: { start_date: mfAttendanceFilters.start_date, end_date: mfAttendanceFilters.end_date },
                                    source: 'mf'
                                  });
                                }, [
                                  generateTableTab,
                                  mfAttendanceFilters.end_date,
                                  mfAttendanceFilters.start_date,
                                  mfSelectedPayslipEmployee?.employee_id,
                                  mfSelectedPayslipEmployee?.employee_name,
                                  mfSelectedPayslipEmployee?.full_name,
                                  mfSelectedPayslipEmployee?.id,
                                  payrollEmployeeData?.employee_id,
                                  payrollEmployeeData?.full_name,
                                  payrollLoans
                                ]);

                                useEffect(() => {
                                  const source = generateTableTab === 'mf' ? 'mf' : 'payroll';
                                  const start = source === 'mf'
                                    ? String(mfAttendanceFilters.start_date || '').trim()
                                    : String(currentPayrollLoanRecord.start_date || '').trim();
                                  const end = source === 'mf'
                                    ? String(mfAttendanceFilters.end_date || '').trim()
                                    : String(currentPayrollLoanRecord.end_date || '').trim();

                                  const employeeId = source === 'mf'
                                    ? (payrollEmployeeData?.employee_id || mfSelectedPayslipEmployee?.employee_id || mfSelectedPayslipEmployee?.id)
                                    : (selectedPayslipEmployee?.employee_id || selectedPayslipEmployee?.id || payrollEmployeeData?.employee_id);
                                  const employeeName = source === 'mf'
                                    ? (payrollEmployeeData?.full_name || mfSelectedPayslipEmployee?.full_name || mfSelectedPayslipEmployee?.employee_name)
                                    : (selectedPayslipEmployee?.full_name || selectedPayslipEmployee?.employee_name || payrollEmployeeData?.full_name);

                                  if (!start || !end || (!employeeId && !employeeName)) {
                                    if (source === 'mf') setApplicablePayslipMfLoans(null);
                                    else setApplicablePayslipPayrollLoans(null);
                                    return;
                                  }

                                  const cacheKey = [
                                    source,
                                    String(employeeId || '').trim(),
                                    String(employeeName || '').trim(),
                                    start,
                                    end
                                  ].join('|');

                                  if (applicablePayslipLoansCacheRef.current.has(cacheKey)) {
                                    const cached = applicablePayslipLoansCacheRef.current.get(cacheKey);
                                    if (source === 'mf') setApplicablePayslipMfLoans(Array.isArray(cached) ? cached : []);
                                    else setApplicablePayslipPayrollLoans(Array.isArray(cached) ? cached : []);
                                    return;
                                  }

                                  let cancelled = false;

                                  (async () => {
                                    try {
                                      const params = new URLSearchParams();
                                      params.append('source', source);
                                      params.append('start_date', start);
                                      params.append('end_date', end);
                                      if (employeeId) params.append('employee_id', String(employeeId));
                                      if (employeeName) params.append('employee_name', String(employeeName));
                                      const response = await axiosInstance.get(`/payroll/loans/applicable?${params.toString()}`);
                                      const list = Array.isArray(response?.data) ? response.data : [];
                                      applicablePayslipLoansCacheRef.current.set(cacheKey, list);
                                      if (cancelled) return;
                                      if (source === 'mf') setApplicablePayslipMfLoans(list);
                                      else setApplicablePayslipPayrollLoans(list);
                                    } catch (error) {
                                      if (cancelled) return;
                                      const fallback = source === 'mf' ? fallbackApplicableMfPayslipLoans : fallbackApplicablePayrollPayslipLoans;
                                      if (source === 'mf') setApplicablePayslipMfLoans(fallback);
                                      else setApplicablePayslipPayrollLoans(fallback);
                                    }
                                  })();

                                  return () => {
                                    cancelled = true;
                                  };
                                }, [
                                  fallbackApplicableMfPayslipLoans,
                                  fallbackApplicablePayrollPayslipLoans,
                                  generateTableTab,
                                  currentPayrollLoanRecord.end_date,
                                  currentPayrollLoanRecord.start_date,
                                  mfAttendanceFilters.end_date,
                                  mfAttendanceFilters.start_date,
                                  mfSelectedPayslipEmployee?.employee_id,
                                  mfSelectedPayslipEmployee?.employee_name,
                                  mfSelectedPayslipEmployee?.full_name,
                                  mfSelectedPayslipEmployee?.id,
                                  payrollEmployeeData?.employee_id,
                                  payrollEmployeeData?.full_name,
                                  selectedPayslipEmployee?.employee_id,
                                  selectedPayslipEmployee?.employee_name,
                                  selectedPayslipEmployee?.full_name,
                                  selectedPayslipEmployee?.id
                                ]);

                                const applicablePayrollPayslipLoans = useMemo(() => {
                                  if (generateTableTab === 'mf') return [];
                                  return Array.isArray(applicablePayslipPayrollLoans)
                                    ? applicablePayslipPayrollLoans
                                    : fallbackApplicablePayrollPayslipLoans;
                                }, [applicablePayslipPayrollLoans, fallbackApplicablePayrollPayslipLoans, generateTableTab]);

                                const applicableMfPayslipLoans = useMemo(() => {
                                  if (generateTableTab !== 'mf') return [];
                                  return Array.isArray(applicablePayslipMfLoans)
                                    ? applicablePayslipMfLoans
                                    : fallbackApplicableMfPayslipLoans;
                                }, [applicablePayslipMfLoans, fallbackApplicableMfPayslipLoans, generateTableTab]);

                                useEffect(() => {
                                  if (generateTableTab === 'mf') {
                                    setLoanDeductionSelections({});
                                    return;
                                  }

                                  const savedLoanCycles = Array.isArray(editingPayslipRecordMeta?.loanCycles)
                                    ? editingPayslipRecordMeta.loanCycles
                                    : [];
                                  const savedSelectionMap = new Map(
                                    savedLoanCycles.map((cycle) => [String(cycle?.loan_id || ''), String(cycle?.cycle_status || '').toLowerCase() !== 'skipped'])
                                  );

                                  setLoanDeductionSelections((prev) => {
                                    const next = {};
                                    applicablePayrollPayslipLoans.forEach((loan) => {
                                      const loanId = String(loan?.id || '').trim();
                                      if (!loanId) return;
                                      next[loanId] = savedSelectionMap.has(loanId) ? savedSelectionMap.get(loanId) : true;
                                    });
                                    const prevKeys = Object.keys(prev || {});
                                    const nextKeys = Object.keys(next);
                                    if (
                                      prevKeys.length === nextKeys.length
                                      && nextKeys.every((key) => prev[key] === next[key])
                                    ) {
                                      return prev;
                                    }
                                    return next;
                                  });
                                }, [
                                  applicablePayrollPayslipLoans,
                                  editingPayslipRecordMeta?.id,
                                  editingPayslipRecordMeta?.loanCycles,
                                  generateTableTab
                                ]);

                                useEffect(() => {
                                  if (generateTableTab !== 'mf') {
                                    setMfLoanDeductionSelections({});
                                    return;
                                  }

                                  const savedLoanCycles = Array.isArray(editingPayslipRecordMeta?.loanCycles)
                                    ? editingPayslipRecordMeta.loanCycles
                                    : [];
                                  const savedSelectionMap = new Map(
                                    savedLoanCycles.map((cycle) => [String(cycle?.loan_id || ''), String(cycle?.cycle_status || '').toLowerCase() !== 'skipped'])
                                  );

                                  setMfLoanDeductionSelections((prev) => {
                                    const next = {};
                                    applicableMfPayslipLoans.forEach((loan) => {
                                      const loanId = String(loan?.id || '').trim();
                                      if (!loanId) return;
                                      next[loanId] = savedSelectionMap.has(loanId) ? savedSelectionMap.get(loanId) : true;
                                    });
                                    const prevKeys = Object.keys(prev || {});
                                    const nextKeys = Object.keys(next);
                                    if (
                                      prevKeys.length === nextKeys.length
                                      && nextKeys.every((key) => prev[key] === next[key])
                                    ) {
                                      return prev;
                                    }
                                    return next;
                                  });
                                }, [
                                  applicableMfPayslipLoans,
                                  editingPayslipRecordMeta?.id,
                                  editingPayslipRecordMeta?.loanCycles,
                                  generateTableTab
                                ]);

                                const computePayrollLoanSummary = () => {
                                  try {
                                    const record = {
                                      start_date: currentPayrollLoanRecord.start_date,
                                      end_date: currentPayrollLoanRecord.end_date
                                    };
                                    const rows = applicablePayrollPayslipLoans.map((loan) => {
                                      const scheduledAmount = getLoanDeductionAmountForRecord({ loan, record, source: 'payroll' });
                                      return {
                                        ...loan,
                                        scheduled_amount: scheduledAmount,
                                        isSelected: loanDeductionSelections[String(loan?.id || '').trim()] !== false
                                      };
                                    });
                                    const enabledRows = rows.filter((loan) => loan.isSelected !== false);
                                    const loanFormTypes = enabledRows.map(formatLoanTypeLabel).filter(Boolean);
                                    const loanDeductionPerCutoffTotal = enabledRows.reduce((sum, loan) => {
                                      const n = Number(loan?.scheduled_amount);
                                      if (!Number.isFinite(n) || n <= 0) return sum;
                                      return sum + n;
                                    }, 0);

                                    return { rows, loanDeductionPerCutoffTotal, loanFormTypes };
                                  } catch {
                                    return { rows: [], loanDeductionPerCutoffTotal: 0, loanFormTypes: [] };
                                  }
                                };

                                const payrollLoanSummary = computePayrollLoanSummary();

                                const computeMfLoanSummary = () => {
                                  try {
                                    const source = 'mf';
                                    const record = { start_date: mfAttendanceFilters.start_date, end_date: mfAttendanceFilters.end_date };
                                    const range = computeLoanTileEffectiveRange('mf', mfAttendanceFilters.start_date, mfAttendanceFilters.end_date);
                                    const effectiveStart = range.start;
                                    const effectiveEnd = range.end;
                                    if (!effectiveStart || !effectiveEnd) {
                                      return { rows: [], loanDeductionPerCutoffTotal: 0, loanFormTypes: [] };
                                    }

                                    const rows = applicableMfPayslipLoans.map((loan) => {
                                      const scheduledAmount = getLoanDeductionAmountForRecord({
                                        loan,
                                        record,
                                        source
                                      });
                                      return {
                                        ...loan,
                                        scheduled_amount: scheduledAmount,
                                        isSelected: mfLoanDeductionSelections[String(loan?.id || '').trim()] !== false
                                      };
                                    });

                                    const enabledRows = rows.filter((loan) => loan.isSelected !== false);
                                    const loanFormTypes = enabledRows.map(formatLoanTypeLabel).filter(Boolean);
                                    const loanDeductionPerCutoffTotal = enabledRows.reduce((sum, loan) => {
                                      const n = Number(loan?.scheduled_amount);
                                      if (!Number.isFinite(n) || n <= 0) return sum;
                                      return sum + n;
                                    }, 0);

                                    return { rows, loanDeductionPerCutoffTotal, loanFormTypes };
                                  } catch {
                                    return { rows: [], loanDeductionPerCutoffTotal: 0, loanFormTypes: [] };
                                  }
                                };

                                const mfLoanSummary = computeMfLoanSummary();
                                const enabledMfLoanRows = Array.isArray(mfLoanSummary?.rows)
                                  ? mfLoanSummary.rows.filter((loan) => loan?.isSelected !== false)
                                  : [];

                                const buildSelectedPayrollLoanEntries = ({ record }) => {
                                  const baseRecord = {
                                    start_date: String(record?.start_date || '').trim(),
                                    end_date: String(record?.end_date || '').trim()
                                  };
                                  const loanCycles = (payrollLoanSummary?.rows || []).map((loan) => {
                                    const scheduledAmount = Number(loan?.scheduled_amount) || 0;
                                    const isSelected = loan?.isSelected !== false;
                                    const cycleStatus = isSelected ? 'deducted' : 'skipped';
                                    return {
                                      loan_id: String(loan?.id || '').trim(),
                                      loan_label: formatLoanTypeLabel(loan),
                                      cycle_status: cycleStatus,
                                      scheduled_amount: scheduledAmount,
                                      deducted_amount: cycleStatus === 'deducted' ? scheduledAmount : 0,
                                      start_date: baseRecord.start_date,
                                      end_date: baseRecord.end_date
                                    };
                                  }).filter((cycle) => cycle.loan_id);

                                  const loanDeductionItems = loanCycles
                                    .filter((cycle) => cycle.cycle_status === 'deducted' && cycle.deducted_amount > 0)
                                    .map((cycle, idx) => ({
                                      id: `loan_${cycle.loan_id}_${cycle.start_date}_${cycle.end_date}_${idx}`,
                                      title: `Loan - ${cycle.loan_label}`,
                                      description: `Loan deduction for ${cycle.loan_label}`,
                                      unit: 'amount',
                                      amount: cycle.deducted_amount,
                                      minutes: 0,
                                      days: 0,
                                      is_loan_deduction: true,
                                      loan_id: cycle.loan_id
                                    }));

                                  const loanDeductionTotal = loanDeductionItems.reduce((sum, item) => sum + (Number(item?.amount) || 0), 0);
                                  return { loanCycles, loanDeductionItems, loanDeductionTotal };
                                };

                                const buildSelectedMfLoanEntries = ({ record }) => {
                                  const baseRecord = {
                                    start_date: String(record?.start_date || '').trim(),
                                    end_date: String(record?.end_date || '').trim()
                                  };
                                  const loanCycles = (mfLoanSummary?.rows || []).map((loan) => {
                                    const scheduledAmount = Number(loan?.scheduled_amount) || 0;
                                    const isSelected = loan?.isSelected !== false;
                                    const cycleStatus = isSelected ? 'deducted' : 'skipped';
                                    return {
                                      loan_id: String(loan?.id || '').trim(),
                                      loan_label: formatLoanTypeLabel(loan),
                                      cycle_status: cycleStatus,
                                      scheduled_amount: scheduledAmount,
                                      deducted_amount: cycleStatus === 'deducted' ? scheduledAmount : 0,
                                      start_date: baseRecord.start_date,
                                      end_date: baseRecord.end_date
                                    };
                                  }).filter((cycle) => cycle.loan_id);

                                  const loanDeductionItems = loanCycles
                                    .filter((cycle) => cycle.cycle_status === 'deducted' && cycle.deducted_amount > 0)
                                    .map((cycle, idx) => ({
                                      id: `mf_loan_${cycle.loan_id}_${cycle.start_date}_${cycle.end_date}_${idx}`,
                                      title: `Loan - ${cycle.loan_label}`,
                                      description: `Loan deduction for ${cycle.loan_label}`,
                                      unit: 'amount',
                                      amount: cycle.deducted_amount,
                                      minutes: 0,
                                      days: 0,
                                      is_loan_deduction: true,
                                      loan_id: cycle.loan_id
                                    }));

                                  const loanDeductionTotal = loanDeductionItems.reduce((sum, item) => sum + (Number(item?.amount) || 0), 0);
                                  return { loanCycles, loanDeductionItems, loanDeductionTotal };
                                };

                                const getCycleAmount = (cycle) => {
                                  if (!cycle) return 0;
                                  const v = cycle?.deducted_amount ?? cycle?.scheduled_amount ?? cycle?.deduct_per_cutoff ?? cycle?.amount;
                                  return toPayslipNumber(v);
                                };

                                const parseLoanTypeFromLabel = (cycle) => {
                                  const rawType = String(cycle?.loan_type || '').trim().toLowerCase();
                                  const rawSub = String(cycle?.loan_subtype || '').trim();
                                  if (rawType && rawSub) {
                                    return { loanType: rawType, loanSubtype: rawSub };
                                  }
                                  const label = String(cycle?.loan_label || '').trim();
                                  const idx = label.indexOf(' - ');
                                  if (idx > 0) {
                                    const typePart = label.slice(0, idx).trim().toLowerCase();
                                    const subPart = label.slice(idx + 3).trim();
                                    return {
                                      loanType: rawType || typePart,
                                      loanSubtype: rawSub || subPart
                                    };
                                  }
                                  return { loanType: rawType, loanSubtype: rawSub || label };
                                };

                                const aggregateLoansBySubtype = (loanCycles) => {
                                  const cycles = Array.isArray(loanCycles) ? loanCycles : [];
                                  const breakdown = {
                                    company_cash_advance: 0,
                                    company_gadgets: 0,
                                    company_vehicle: 0,
                                    company_others: 0,
                                    government_salary_loan: 0,
                                    government_calamity_loan: 0,
                                    government_hdmf_loan: 0,
                                    rows: []
                                  };
                                  cycles.forEach((cycle) => {
                                    const cycleStatus = String(cycle?.cycle_status || '').toLowerCase();
                                    if (cycleStatus === 'skipped') return;
                                    const amount = getCycleAmount(cycle);
                                    if (amount <= 0) return;
                                    const { loanType, loanSubtype } = parseLoanTypeFromLabel(cycle);
                                    const subtypeNorm = String(loanSubtype || '').toLowerCase().trim();
                                    const typeNorm = String(loanType || '').toLowerCase().trim();
                                    const isGovernment = typeNorm === 'government'
                                      || /salary|calamity|hdmf|pagibig|pag-ibig/.test(subtypeNorm);
                                    const isCompany = typeNorm === 'company' || !isGovernment;
                                    let bucket = null;
                                    if (isCompany) {
                                      if (subtypeNorm.includes('cash')) bucket = 'company_cash_advance';
                                      else if (subtypeNorm.includes('gadget')) bucket = 'company_gadgets';
                                      else if (subtypeNorm.includes('vehicle')) bucket = 'company_vehicle';
                                      else bucket = 'company_others';
                                    } else {
                                      if (subtypeNorm.includes('calamity')) bucket = 'government_calamity_loan';
                                      else if (subtypeNorm.includes('hdmf') || subtypeNorm.includes('pagibig') || subtypeNorm.includes('pag-ibig')) bucket = 'government_hdmf_loan';
                                      else bucket = 'government_salary_loan';
                                    }
                                    breakdown[bucket] = toPayslipNumber(breakdown[bucket] + amount);
                                    breakdown.rows.push({ ...cycle, _amount: amount });
                                  });
                                  return breakdown;
                                };

                                const buildTilesSnapshot = ({
                                  holidaysArr,
                                  halfMonthSalary,
                                  absenceDeduction,
                                  tardinessDeduction,
                                  undertimeDeduction,
                                  grossSalary,
                                  sss,
                                  hdmf,
                                  philhealth,
                                  withholdingTax,
                                  totalDeductions,
                                  netPay,
                                  loanBreakdown
                                }) => {
                                  const lb = loanBreakdown || aggregateLoansBySubtype([]);
                                  return {
                                    income_breakdown: {
                                      holidays: Array.isArray(holidaysArr) ? holidaysArr : [],
                                      half_month_salary: toPayslipNumber(halfMonthSalary),
                                      absence: toPayslipNumber(absenceDeduction),
                                      tardiness: toPayslipNumber(tardinessDeduction),
                                      undertime: toPayslipNumber(undertimeDeduction),
                                      gross_salary: toPayslipNumber(grossSalary)
                                    },
                                    deductions: {
                                      sss: toPayslipNumber(sss),
                                      hdmf: toPayslipNumber(hdmf),
                                      philhealth: toPayslipNumber(philhealth),
                                      withholding_tax: toPayslipNumber(withholdingTax),
                                      total_deductions: toPayslipNumber(totalDeductions)
                                    },
                                    net_pay: {
                                      gross_salary: toPayslipNumber(grossSalary),
                                      total_deductions: toPayslipNumber(totalDeductions),
                                      company_cash_advance: toPayslipNumber(lb.company_cash_advance),
                                      company_gadgets: toPayslipNumber(lb.company_gadgets),
                                      company_vehicle: toPayslipNumber(lb.company_vehicle),
                                      company_others: toPayslipNumber(lb.company_others),
                                      government_salary_loan: toPayslipNumber(lb.government_salary_loan),
                                      government_calamity_loan: toPayslipNumber(lb.government_calamity_loan),
                                      government_hdmf_loan: toPayslipNumber(lb.government_hdmf_loan),
                                      net_pay: toPayslipNumber(netPay)
                                    }
                                  };
                                };

                                const _numValOrNull = (v) => {
                                  if (v === undefined || v === null || Number.isNaN(v)) return null;
                                  if (typeof v === 'number') return Number.isFinite(v) ? v : null;
                                  const p = parseFloat(String(v).replace(/,/g, '').trim());
                                  return Number.isFinite(p) ? p : null;
                                };

                                const _tilesFirst = (record, tileKey, topLevelKey, fallback = 0) => {
                                  const parts = tileKey.split('.');
                                  let node = record;
                                  for (const p of parts) {
                                    if (node == null) { node = undefined; break; }
                                    node = node[p];
                                  }
                                  const tv = _numValOrNull(node);
                                  if (tv !== null) return tv;
                                  const lv = _numValOrNull(record?.[topLevelKey]);
                                  if (lv !== null) return lv;
                                  const fv = _numValOrNull(fallback);
                                  return fv !== null ? fv : 0;
                                };

                                const getSavedStatBaseFromRecord = (record) => ({
                                  sss: _tilesFirst(record, 'tiles.deductions.sss', 'sss_contribution', 0),
                                  phic: _tilesFirst(record, 'tiles.deductions.philhealth', 'philhealth_contribution', 0),
                                  hdmf: _tilesFirst(record, 'tiles.deductions.hdmf', 'hdmf_contribution', 0),
                                  tax: _tilesFirst(record, 'tiles.deductions.withholding_tax', 'withholding_tax', 0),
                                  late: _tilesFirst(record, 'tiles.income_breakdown.tardiness', 'tardiness_deduction', 0),
                                  undertime: _tilesFirst(record, 'tiles.income_breakdown.undertime', 'undertime_deduction', 0)
                                });

                                const buildEditLoanEntriesFromSavedCycles = ({
                                  savedCycles,
                                  selectionMap,
                                  startDate,
                                  endDate
                                }) => {
                                  const safeCycles = Array.isArray(savedCycles) ? savedCycles : [];
                                  const safeSel = selectionMap || {};
                                  const startIso = String(startDate || '').trim();
                                  const endIso = String(endDate || '').trim();
                                  const loanCycles = safeCycles.map((cycle) => {
                                    const loanId = String(cycle?.loan_id || '').trim();
                                    const scheduled = Number(cycle?.scheduled_amount ?? cycle?.deducted_amount ?? cycle?.deduct_per_cutoff ?? cycle?.amount) || 0;
                                    let isSelected = true;
                                    if (loanId && safeSel[loanId] === false) isSelected = false;
                                    if (String(cycle?.cycle_status || '').trim().toLowerCase() === 'skipped') isSelected = false;
                                    const cycleStatus = isSelected ? 'deducted' : 'skipped';
                                    return {
                                      loan_id: loanId,
                                      loan_label: String(cycle?.loan_label || cycle?.loan_subtype || '').trim(),
                                      loan_type: cycle?.loan_type,
                                      loan_subtype: cycle?.loan_subtype,
                                      cycle_status: cycleStatus,
                                      scheduled_amount: scheduled,
                                      deducted_amount: cycleStatus === 'deducted' ? scheduled : 0,
                                      start_date: startIso,
                                      end_date: endIso,
                                      _origCycle: cycle ? { ...cycle } : null
                                    };
                                  }).filter((c) => c.loan_id);
                                  const localAmount = (c) => Number(c?.deducted_amount ?? c?.scheduled_amount ?? 0) || 0;
                                  const loanDeductionTotal = loanCycles
                                    .filter((c) => c.cycle_status === 'deducted')
                                    .reduce((s, c) => s + localAmount(c), 0);
                                  const loanCyclesStripped = loanCycles.map(({ _origCycle, ...rest }) => rest);
                                  return { loanCycles: loanCyclesStripped, loanDeductionTotal, rawLoanRows: loanCycles };
                                };

                                const buildEditAmountItems = (items, dailyRateValue, filterFn = null) => {
                                  const list = (Array.isArray(items) ? items : []).filter((item) => filterFn ? !!filterFn(item) : true);
                                  const safeFloat = toPayslipNumber;
                                  const minuteRateValue = dailyRateValue > 0 ? dailyRateValue / 8 / 60 : 0;
                                  return list.map((item) => {
                                    const unit = item.unit || 'minutes';
                                    let amount = 0;
                                    if (unit === 'amount') amount = safeFloat(item.amount);
                                    else if (unit === 'days') amount = safeFloat(item.days) * dailyRateValue;
                                    else amount = minuteRateValue * safeFloat(item.minutes);
                                    return { ...item, amount };
                                  });
                                };

                                const computeEditPayrollSaveSnapshot = ({
                                  source,
                                  snapshot,
                                  holidaysArr,
                                  payslipDeductions,
                                  additionalIncomeFormItems,
                                  additionalDeductionsFormItems,
                                  overtimePayFormItems,
                                  otHours,
                                  holidayHours,
                                  loanSelectionMap,
                                  savedLoanCycles,
                                  payrollEmployeeData,
                                  isGeneratedLoanDeductionItemFn
                                }) => {
                                  const safeFloat = toPayslipNumber;
                                  const overrideOr = (editVal, snapVal, def) => {
                                    const e = _numValOrNull(editVal);
                                    if (e !== null) return e;
                                    const s = _numValOrNull(snapVal);
                                    if (s !== null) return s;
                                    const d = _numValOrNull(def);
                                    return d !== null ? d : 0;
                                  };
                                  const localLoanRowAmount = (c) => safeFloat(c?.deducted_amount ?? c?.scheduled_amount ?? c?.deduct_per_cutoff ?? c?.amount);

                                  const savedTiles = snapshot?.tiles || {};
                                  const savedIncome = savedTiles?.income_breakdown || {};
                                  const savedDed = savedTiles?.deductions || {};
                                  const savedNet = savedTiles?.net_pay || {};
                                  const savedBreakdown = snapshot?.deduction_settings?.breakdown || {};
                                  const isMf = source === 'mf';

                                  const rowRange = validateDateRangeTaipei(snapshot?.start_date, snapshot?.end_date);

                                  const attendanceDaysPresent = safeFloat(snapshot?.days_present);
                                  const attendanceDaysAbsent = safeFloat(snapshot?.days_absent);
                                  const attendanceHalfDays = safeFloat(snapshot?.half_days_present);
                                  const attendanceMinutesLate = safeFloat(snapshot?.minutes_late);
                                  const attendanceMinutesUndertime = safeFloat(snapshot?.minutes_undertime);
                                  const absenceDeduction = overrideOr(savedIncome?.absence, snapshot?.absence_deduction, 0);
                                  const tardinessDeduction = overrideOr(savedIncome?.tardiness, snapshot?.tardiness_deduction, 0);
                                  const undertimeDeduction = overrideOr(savedIncome?.undertime, snapshot?.undertime_deduction, 0);

                                  const dailyRateValue = overrideOr(null, snapshot?.daily_rate, 0);
                                  const hourlyRateValue = overrideOr(null, snapshot?.hourly_rate, dailyRateValue > 0 ? dailyRateValue / 8 : 0);
                                  const minuteRateValue = dailyRateValue > 0 ? dailyRateValue / 8 / 60 : 0;

                                  let halfMonthSalary;
                                  if (isMf) {
                                    halfMonthSalary = overrideOr(
                                      savedIncome?.half_month_salary,
                                      snapshot?.deduction_settings?.breakdown?.income?.half_month_salary || snapshot?.half_month_salary,
                                      (safeFloat(payrollEmployeeData?.allowances?.mf) +
                                        safeFloat(payrollEmployeeData?.allowances?.gas_allowance) +
                                        safeFloat(payrollEmployeeData?.allowances?.load_allowance) +
                                        safeFloat(payrollEmployeeData?.allowances?.housing_allowance))
                                    );
                                  } else {
                                    halfMonthSalary = overrideOr(savedIncome?.half_month_salary, snapshot?.half_month_salary, (safeFloat(snapshot?.basic_salary) || 0) / 2);
                                  }

                                  const savedSss = overrideOr(savedDed?.sss, snapshot?.sss_contribution, 0);
                                  const savedHdmf = overrideOr(savedDed?.hdmf, snapshot?.hdmf_contribution, 0);
                                  const savedPhic = overrideOr(savedDed?.philhealth, snapshot?.philhealth_contribution, 0);
                                  const savedTax = overrideOr(savedDed?.withholding_tax, snapshot?.withholding_tax, 0);
                                  const sssContribution = payslipDeductions?.sss ? savedSss : 0;
                                  const hdmfContribution = payslipDeductions?.hdmf ? savedHdmf : 0;
                                  const philhealthContribution = payslipDeductions?.phic ? savedPhic : 0;
                                  const withholdingTax = payslipDeductions?.tax ? savedTax : 0;

                                  const addDedFilter = (ded) => (!isGeneratedLoanDeductionItemFn || !isGeneratedLoanDeductionItemFn(ded, savedLoanCycles));
                                  const additionalIncomeWithAmounts = buildEditAmountItems(additionalIncomeFormItems, dailyRateValue, null);
                                  const additionalDeductionsWithAmounts = buildEditAmountItems(additionalDeductionsFormItems, dailyRateValue, addDedFilter);
                                  const additionalIncomeTotal = additionalIncomeWithAmounts.reduce((s, i) => s + safeFloat(i?.amount), 0);
                                  const additionalDeductionsTotal = additionalDeductionsWithAmounts.reduce((s, i) => s + safeFloat(i?.amount), 0);
                                  const savedAddIncTotal = (Array.isArray(snapshot?.additional_income) ? snapshot.additional_income : [])
                                    .reduce((s, i) => s + safeFloat(i?.amount), 0);
                                  const savedAddDedTotal = (Array.isArray(snapshot?.additional_deductions) ? snapshot.additional_deductions : [])
                                    .filter((ded) => addDedFilter(ded))
                                    .reduce((s, i) => s + safeFloat(i?.amount), 0);

                                  const currentOtHours = safeFloat(otHours);
                                  const currentHolidayHours = safeFloat(holidayHours);
                                  const otAmount = (dailyRateValue / 8) * 1.25 * currentOtHours;
                                  const holidayAmount = (dailyRateValue / 8) * 1.3 * currentHolidayHours;
                                  const overtimePayWithAmounts = buildEditAmountItems(overtimePayFormItems, dailyRateValue, null);
                                  const savedOtAmount = overrideOr(null, snapshot?.ot_pay_amount, 0);
                                  const savedHolidayAmount = overrideOr(null, snapshot?.holiday_pay_amount, 0);

                                  const savedGross = overrideOr(savedIncome?.gross_salary, snapshot?.gross_salary || savedNet?.gross_salary, 0);
                                  const deltaAddInc = additionalIncomeTotal - savedAddIncTotal;
                                  const grossSalary = Math.max(0, savedGross + deltaAddInc);

                                  const startIso = rowRange.ok ? rowRange.startISO : '';
                                  const endIso = rowRange.ok ? rowRange.endISO : '';
                                  const loanResult = buildEditLoanEntriesFromSavedCycles({
                                    savedCycles: savedLoanCycles,
                                    selectionMap: loanSelectionMap,
                                    startDate: startIso,
                                    endDate: endIso
                                  });
                                  const loanCycles = loanResult.loanCycles;
                                  const loanDeductionTotal = loanResult.loanDeductionTotal;
                                  const savedCyclesList = Array.isArray(savedLoanCycles) ? savedLoanCycles : [];
                                  const savedLoanDeduction = savedCyclesList
                                    .filter((c) => String(c?.cycle_status || '').toLowerCase() !== 'skipped')
                                    .reduce((s, c) => s + localLoanRowAmount(c), 0);

                                  const savedBaselineTotDed = overrideOr(
                                    savedDed?.total_deductions,
                                    savedNet?.total_deductions || snapshot?.total_deductions,
                                    (savedSss + savedHdmf + savedPhic + savedTax + savedAddDedTotal + savedLoanDeduction)
                                  );
                                  const deltaStat = (sssContribution + hdmfContribution + philhealthContribution + withholdingTax) - (savedSss + savedHdmf + savedPhic + savedTax);
                                  const deltaAddDed = additionalDeductionsTotal - savedAddDedTotal;
                                  const deltaLoan = loanDeductionTotal - savedLoanDeduction;
                                  const totalDeductions = Math.max(0, savedBaselineTotDed + deltaStat + deltaAddDed + deltaLoan);

                                  let basicSalary;
                                  if (isMf) {
                                    basicSalary = overrideOr(
                                      snapshot?.deduction_settings?.breakdown?.summary?.basic_salary,
                                      snapshot?.basic_salary,
                                      Math.max(0, halfMonthSalary - absenceDeduction - tardinessDeduction - undertimeDeduction)
                                    );
                                  } else {
                                    basicSalary = overrideOr(
                                      savedBreakdown?.summary?.basic_salary,
                                      snapshot?.basic_salary,
                                      Math.max(0, halfMonthSalary * 2 - absenceDeduction - tardinessDeduction - undertimeDeduction)
                                    );
                                  }

                                  const savedRawTileNet = _numValOrNull(savedNet?.net_pay);
                                  const savedSnapNet = _numValOrNull(snapshot?.net_pay);
                                  const deltaOt = safeFloat(otAmount) - safeFloat(savedOtAmount);
                                  const deltaHoliday = safeFloat(holidayAmount) - safeFloat(savedHolidayAmount);
                                  const deltaTotDed = safeFloat(totalDeductions) - safeFloat(savedBaselineTotDed);
                                  let adjustedNet;
                                  if (savedRawTileNet !== null) {
                                    adjustedNet = savedRawTileNet + deltaOt + deltaHoliday + deltaAddInc - deltaTotDed;
                                  } else if (savedSnapNet !== null) {
                                    adjustedNet = savedSnapNet + deltaOt + deltaHoliday + deltaAddInc - deltaTotDed;
                                  } else {
                                    const govDed = sssContribution + hdmfContribution + philhealthContribution + withholdingTax;
                                    adjustedNet = Math.max(0, grossSalary + otAmount + holidayAmount - govDed - additionalDeductionsTotal - loanDeductionTotal);
                                  }
                                  const netPay = Math.max(0, adjustedNet);

                                  const loanBreakdown = aggregateLoansBySubtype(loanCycles);
                                  const rowHolidays = Array.isArray(holidaysArr)
                                    ? holidaysArr
                                    : (Array.isArray(snapshot?.holidays) ? snapshot.holidays : []);
                                  const tilesSnapshot = buildTilesSnapshot({
                                    holidaysArr: rowHolidays,
                                    halfMonthSalary,
                                    absenceDeduction,
                                    tardinessDeduction,
                                    undertimeDeduction,
                                    grossSalary,
                                    sss: sssContribution,
                                    hdmf: hdmfContribution,
                                    philhealth: philhealthContribution,
                                    withholdingTax,
                                    totalDeductions,
                                    netPay,
                                    loanBreakdown
                                  });

                                  const topLevelFields = {
                                    start_date: startIso,
                                    end_date: endIso,
                                    half_month_salary: isMf ? 0 : (halfMonthSalary || 0),
                                    daily_rate: dailyRateValue || 0,
                                    hourly_rate: hourlyRateValue || 0,
                                    working_days: safeFloat(snapshot?.working_days) || (attendanceDaysPresent + attendanceDaysAbsent),
                                    days_present: attendanceDaysPresent || 0,
                                    days_absent: attendanceDaysAbsent || 0,
                                    half_days_present: attendanceHalfDays || 0,
                                    absence_deduction: absenceDeduction || 0,
                                    minutes_late: attendanceMinutesLate || 0,
                                    tardiness_deduction: tardinessDeduction || 0,
                                    minutes_undertime: attendanceMinutesUndertime || 0,
                                    undertime_deduction: undertimeDeduction || 0,
                                    basic_salary: basicSalary || 0,
                                    overtime_pay: overtimePayWithAmounts || [],
                                    ot_hours: currentOtHours || 0,
                                    ot_pay_amount: otAmount || 0,
                                    holiday_hours: currentHolidayHours || 0,
                                    holiday_pay_amount: holidayAmount || 0,
                                    holidays_count: safeFloat(snapshot?.holidays_count) || rowHolidays.length,
                                    holidays: rowHolidays,
                                    additional_income: additionalIncomeWithAmounts || [],
                                    gross_salary: grossSalary || 0,
                                    sss_contribution: sssContribution || 0,
                                    hdmf_contribution: hdmfContribution || 0,
                                    philhealth_contribution: philhealthContribution || 0,
                                    withholding_tax: withholdingTax || 0,
                                    additional_deductions: additionalDeductionsWithAmounts || [],
                                    total_deductions: totalDeductions || 0,
                                    net_pay: netPay || 0,
                                    loan_breakdown: loanBreakdown,
                                    tiles: tilesSnapshot,
                                    halfMonthSalaryInternal: halfMonthSalary
                                  };

                                  return {
                                    tiles: tilesSnapshot,
                                    topLevelFields,
                                    loanCycles,
                                    loanBreakdown,
                                    breakdown: {
                                      income: {
                                        half_month_salary: halfMonthSalary || 0,
                                        ot_pay: otAmount || 0,
                                        holiday_pay: holidayAmount || 0,
                                        items: additionalIncomeWithAmounts || [],
                                        total: additionalIncomeTotal || 0
                                      },
                                      deductions: {
                                        absence: absenceDeduction || 0,
                                        tardiness: tardinessDeduction || 0,
                                        undertime: undertimeDeduction || 0,
                                        sss: sssContribution || 0,
                                        phic: philhealthContribution || 0,
                                        hdmf: hdmfContribution || 0,
                                        tax: withholdingTax || 0,
                                        items: additionalDeductionsWithAmounts || [],
                                        total: additionalDeductionsTotal || 0
                                      },
                                      summary: {
                                        daily_rate: dailyRateValue || 0,
                                        hourly_rate: hourlyRateValue || 0,
                                        basic_salary: basicSalary || 0,
                                        gross_salary: grossSalary || 0,
                                        total_deductions: totalDeductions || 0,
                                        net_pay: netPay || 0
                                      }
                                    },
                                    loanPreviewSummaryRows: loanResult.rawLoanRows
                                      .filter((c) => c.cycle_status === 'deducted')
                                      .map(({ _origCycle, ...rest }) => rest),
                                    rowRange
                                  };
                                };

                                const isGeneratedLoanDeductionItem = (item, loanCycles = []) => {
                                  if (!item) return false;
                                  if (item?.is_loan_deduction === true) return true;
                                  const loanId = String(item?.loan_id || '').trim();
                                  const knownLoanIds = new Set((Array.isArray(loanCycles) ? loanCycles : []).map((cycle) => String(cycle?.loan_id || '').trim()).filter(Boolean));
                                  if (loanId && knownLoanIds.has(loanId)) return true;
                                  const title = String(item?.title || '').trim().toLowerCase();
                                  const description = String(item?.description || '').trim().toLowerCase();
                                  const knownLabels = new Set(
                                    (Array.isArray(loanCycles) ? loanCycles : [])
                                      .map((cycle) => String(cycle?.loan_label || '').trim().toLowerCase())
                                      .filter(Boolean)
                                  );
                                  if (title.startsWith('loan - ')) {
                                    const rawLabel = title.slice('loan - '.length).trim();
                                    if (knownLabels.size === 0 || knownLabels.has(rawLabel)) return true;
                                  }
                                  if (description.startsWith('loan deduction for ')) {
                                    const rawLabel = description.slice('loan deduction for '.length).trim();
                                    if (knownLabels.size === 0 || knownLabels.has(rawLabel)) return true;
                                  }
                                  return false;
                                };

                                const syncPayrollLoanCycles = async ({ payload, savedRecord }) => {
                                  if (!payload) return false;
                                  const employeeId = String(payload?.employee_id || '').trim();
                                  const employeeName = String(payload?.employee_name || '').trim();
                                  const startDate = String(payload?.start_date || '').trim();
                                  const endDate = String(payload?.end_date || '').trim();
                                  if (!employeeName || !startDate || !endDate) return false;
                                  const source = payload?.deduction_settings?.mf_record === true ? 'mf' : 'payroll';

                                  const cycles = Array.isArray(payload?.deduction_settings?.loan_cycles)
                                    ? payload.deduction_settings.loan_cycles.map((cycle) => ({
                                      loan_id: String(cycle?.loan_id || '').trim(),
                                      cycle_status: String(cycle?.cycle_status || '').toLowerCase() === 'skipped' ? 'skipped' : 'deducted',
                                      scheduled_amount: Number(cycle?.scheduled_amount) || 0,
                                      deducted_amount: Number(cycle?.deducted_amount) || 0
                                    })).filter((cycle) => cycle.loan_id)
                                    : [];

                                  try {
                                    await axiosInstance.post('/payroll/loans/cycles/sync', {
                                      source,
                                      employee_id: employeeId || null,
                                      employee_name: employeeName,
                                      payroll_period: String(payload?.payroll_period || '').trim() || null,
                                      start_date: startDate,
                                      end_date: endDate,
                                      payroll_record_id: String(savedRecord?.id || '').trim() || null,
                                      cycles
                                    });
                                    try { await fetchPayrollLoans(); } catch { /* noop */ }
                                    return true;
                                  } catch (syncError) {
                                    console.error('Error syncing payroll loan cycles:', syncError);
                                    toast.error('Payroll record saved, but loan cycle sync failed');
                                    return false;
                                  }
                                };

                                const renderPayslipCalculationSummary = () => {
                                  // Derive per-employee analytics from the deterministic generated payslip row
                                  // (same source the saved payslip uses) instead of the shared, fetch-order-dependent
                                  // attendance analytics state. This prevents one employee's late/undertime totals
                                  // from leaking into another employee's summary during batch generation.
                                  const summaryActiveFilters = generateTableTab === 'mf' ? mfAttendanceFilters : payrollAttendanceFilters;
                                  const summaryGenRow = getGeneratedPayslipRowForSelection(
                                    generateTableTab,
                                    selectedGeneratedPayslipEmployeeId,
                                    summaryActiveFilters.start_date,
                                    summaryActiveFilters.end_date
                                  );
                                  const baseSummaryAnalytics = generateTableTab === 'mf' ? mfAttendanceAnalytics : payrollAttendanceAnalytics;

                                  // Count Days Present from the ONE TRUE raw attendance data directly fetched
                                  // from the database (rawPayrollAttendanceData / rawMfAttendanceData) as the
                                  // single source of truth. Includes the SATURDAY SANDWICH RULE with a 3-DAY
                                  // LOOKAHEAD/LOOKBACK WINDOW: for 6-day (basis 313) employees, any Saturday
                                  // with NO punch records is AUTOMATICALLY counted as PRESENT if BOTH:
                                  //   - The preceding working day (searching 13 days before Saturday) is PRESENT
                                  //   - The following working day (searching 13 days after  Saturday) is PRESENT
                                  // The 3 buffered lookback/lookahead days are NOT shown or added themselves;
                                  // they are only used to determine whether the adjacent Saturday is eligible.
                                  // Finally: Days Absent = Employee Working Days  Actual Present Days.
                                  // This same Days Absent value drives the Income Breakdown "Absence" deduction.
                                  let rawDaysPresent = 0;
                                  let rawDaysAbsent = 0;
                                  let rawHalfDaysPresent = 0;
                                  let employeeWorkingDays = 0;
                                  try {
                                    const normalizeEmployeeId = (v) => {
                                      const raw = String(v ?? '').trim();
                                      if (!raw) return '';
                                      if (/^\d+$/.test(raw)) return raw.replace(/^0+(?=\d)/, '');
                                      return raw;
                                    };
                                    const vr = validateDateRangeTaipei(summaryActiveFilters.start_date, summaryActiveFilters.end_date);
                                    const startISO = vr.ok ? vr.startISO : String(summaryActiveFilters.start_date || '').trim();
                                    const endISO = vr.ok ? vr.endISO : String(summaryActiveFilters.end_date || '').trim();
                                    const selectedId = normalizeEmployeeId(selectedGeneratedPayslipEmployeeId);
                                    if (selectedId && startISO && endISO) {
                                      // Look up the employee to determine 5-day vs 6-day workweek basis.
                                      // Prefer summaryGenRow data, then fall back to payrollEmployees list.
                                      let isSixDay = false;
                                      let foundPe = null;
                                      if (summaryGenRow) {
                                        const basis = summaryGenRow.daily_rate_formula || summaryGenRow.rate_formula || summaryGenRow.dailyRateFormula;
                                        if (String(basis) === '313' || basis === 313) isSixDay = true;
                                        if (summaryGenRow.employee_id) {
                                          foundPe = payrollEmployees.find((pe) =>
                                            normalizeEmployeeId(pe?.employee_id) === normalizeEmployeeId(summaryGenRow.employee_id)
                                          );
                                        }
                                      }
                                      if (!foundPe) {
                                        foundPe = payrollEmployees.find((pe) =>
                                          normalizeEmployeeId(pe?.employee_id) === selectedId
                                        );
                                      }
                                      if (foundPe) {
                                        const basis = foundPe.daily_rate_formula || foundPe.rate_formula || foundPe.dailyRateFormula;
                                        if (String(basis) === '313' || basis === 313) isSixDay = true;
                                      }
                                      const holidaysForModal = sanitizeHolidayRows(holidays).filter(
                                        (h) => h.date >= startISO && h.date <= endISO
                                      );
                                      employeeWorkingDays = countWorkingDaysMinusHolidays({
                                        startISO,
                                        endISO,
                                        isSixDay,
                                        holidayRows: holidaysForModal
                                      });
                                      // Range Date objects for Saturday iterator (s = start of filter, e = end)
                                      const s = new Date(startISO + 'T00:00:00+08:00');
                                      const e = new Date(endISO + 'T00:00:00+08:00');
                                      // EXTENDED 3-DAY BUFFER WINDOW for the Saturday sandwich rule.
                                      // Build baseCredit over [s-3, e+3] so Saturday eligibility search
                                      // can always look up to 3 days before/after ANY Saturday inside [s,e],
                                      // including Saturdays at the original filter boundaries.
                                      const sExt = addDays(new Date(startISO + 'T00:00:00+08:00'), -3);
                                      const eExt = addDays(new Date(endISO + 'T00:00:00+08:00'), 3);
                                      const sExtISO = isoDateTaipei(sExt);
                                      const eExtISO = isoDateTaipei(eExt);

                                      // Use the ONE TRUE RAW DATA state directly from the database fetch
                                      const oneTrueRawAttendance = generateTableTab === 'mf'
                                        ? (rawMfAttendanceData || [])
                                        : (rawPayrollAttendanceData || []);
                                      // Filter: selected employee + EXTENDED date range + time_in/time_out type only
                                      const empRawRecords = oneTrueRawAttendance.filter((r) => {
                                        if (!r) return false;
                                        const rid = normalizeEmployeeId(r.user_id);
                                        if (rid !== selectedId) return false;
                                        const t = String(r?.type || '').toLowerCase().trim();
                                        if (t !== 'time_in' && t !== 'time_out') return false;
                                        let dateISO;
                                        try { dateISO = toTaipeiISODate(r.timestamp); } catch { return false; }
                                        return !!dateISO && dateISO >= sExtISO && dateISO <= eExtISO;
                                      });

                                      // Step 1: Build EXTENDED per-date present credit map from raw punches.
                                      // Covers dates from [s-3, e+3] so Saturday eligibility window is covered.
                                      const baseCredit = {};
                                      {
                                        const { perEmployeeDates } = aggregateFirstLastMinutes(empRawRecords, { startISO: sExtISO, endISO: eExtISO });
                                        const employeeDates = perEmployeeDates[selectedId] || {};
                                        let cur = new Date(sExt);
                                        while (cur <= eExt) {
                                          if (isWorkingDayForBasis(cur, isSixDay)) {
                                            const iso = isoDateTaipei(cur);
                                            const day = employeeDates?.[iso];
                                            const hasIn = !!day?.has_time_in;
                                            const hasOut = !!day?.has_time_out;
                                            const hd = day ? detectHalfDayStatus(day.first_in, day.last_out) : null;
                                            const isHalf = !!(hd && hd.isHalfDay);
                                            let c = 0;
                                            if (hasIn && hasOut && !isHalf) c = 1;
                                            else if (hasIn || hasOut || isHalf) c = 0.5;
                                            baseCredit[iso] = c;
                                          }
                                          cur = addDays(cur, 1);
                                        }
                                      }

                                      // Step 2: Apply SATURDAY SANDWICH RULE with 3-DAY BUFFER WINDOW.
                                      // Process every SATURDAY in the ORIGINAL range [s, e].
                                      // The 3-day lookback/lookahead reaches into the EXTENDED baseCredit.
                                      // The 3 searched days themselves are NOT credited  they only decide Saturday eligibility.
                                      if (isSixDay) {
                                        let satCur = new Date(s);
                                        while (satCur <= e) {
                                          if (taipeiDayOfWeek(satCur) === 6) {
                                            const satISO = isoDateTaipei(satCur);
                                            const key = `${selectedId}_${satISO}`;
                                            const override = saturdayOverrides?.[key];
                                            const rawCreditSat = typeof baseCredit[satISO] === 'number' ? baseCredit[satISO] : 0;
                                            // Search 3 DAYS BEFORE Saturday (within EXTENDED range) for a working day with credit > 0
                                            let prevPresent = false;
                                            for (let off = 1; off <= 3; off++) {
                                              const dCheck = addDays(satCur, -off);
                                              if (dCheck < sExt) break;
                                              if (!isWorkingDayForBasis(dCheck, isSixDay)) continue;
                                              const isoCheck = isoDateTaipei(dCheck);
                                              if ((typeof baseCredit[isoCheck] === 'number' ? baseCredit[isoCheck] : 0) > 0) {
                                                prevPresent = true;
                                                break;
                                              }
                                            }
                                            // Search 3 DAYS AFTER Saturday (within EXTENDED range) for a working day with credit > 0
                                            let nextPresent = false;
                                            for (let off = 1; off <= 3; off++) {
                                              const dCheck = addDays(satCur, off);
                                              if (dCheck > eExt) break;
                                              if (!isWorkingDayForBasis(dCheck, isSixDay)) continue;
                                              const isoCheck = isoDateTaipei(dCheck);
                                              if ((typeof baseCredit[isoCheck] === 'number' ? baseCredit[isoCheck] : 0) > 0) {
                                                nextPresent = true;
                                                break;
                                              }
                                            }
                                            const eligible = prevPresent && nextPresent;
                                            baseCredit[satISO] = resolveSaturdayCredit({
                                              rawCredit: rawCreditSat,
                                              eligible,
                                              override
                                            });
                                          }
                                          satCur = addDays(satCur, 1);
                                        }
                                      }

                                      // Step 2B: Apply HOLIDAY SANDWICH RULE to every user-added holiday within
                                      // the ORIGINAL [s, e] filter range. Uses the EXACT same logic as the
                                      // canonical function (prev/next working day leapfrogging consecutive holidays
                                      // via holidaySet). Sandwiched holidays get credited with 1.0 PRESENT so
                                      // they are NOT deducted as Absence in the Income Breakdown tile.
                                      applyHolidaySandwichRuleToCredits({
                                        credits: baseCredit,
                                        startISO,
                                        endISO,
                                        isSixDay,
                                        holidayRows: holidaysForModal
                                      });

                                      // Step 3: Sum final credits ONLY within the ORIGINAL [s, e] filter range.
                                      // The 3 extended buffer days are dropped here (not counted in Days Present / Half Days)
                                      // so the "buffered 3 days before/after" are used for eligibility detection ONLY.
                                      Object.entries(baseCredit).forEach(([iso, credit]) => {
                                        if (iso < startISO || iso > endISO) return;
                                        if (credit === 1) rawDaysPresent += 1;
                                        else if (credit === 0.5) { rawDaysPresent += 0.5; rawHalfDaysPresent += 1; }
                                      });
                                      // Days Absent = Employee Working Days  Actual Present Days (clamped to 0)
                                      rawDaysAbsent = Math.max(0, employeeWorkingDays - rawDaysPresent);
                                    }
                                  } catch (e) {
                                    rawDaysPresent = 0;
                                    rawDaysAbsent = 0;
                                    rawHalfDaysPresent = 0;
                                    employeeWorkingDays = 0;
                                  }

                                  const summaryAnalytics = summaryGenRow ? {
                                    ...baseSummaryAnalytics,
                                    working_days: employeeWorkingDays || (baseSummaryAnalytics?.working_days || 0),
                                    days_present: rawDaysPresent,
                                    days_absent: rawDaysAbsent,
                                    half_days_present: rawHalfDaysPresent,
                                    total_minutes_late: parseFloat(summaryGenRow.minutes_late) || (baseSummaryAnalytics?.total_minutes_late) || 0,
                                    total_minutes_undertime: parseFloat(summaryGenRow.minutes_undertime) || (baseSummaryAnalytics?.total_minutes_undertime) || 0,
                                    daily_rate: parseFloat(summaryGenRow.daily_rate) || baseSummaryAnalytics?.daily_rate || 0,
                                    total_gross_pay: Number.isFinite(parseFloat(summaryGenRow.gross_salary)) ? parseFloat(summaryGenRow.gross_salary) : (baseSummaryAnalytics?.total_gross_pay || 0)
                                  } : {
                                    ...baseSummaryAnalytics,
                                    working_days: employeeWorkingDays || (baseSummaryAnalytics?.working_days || 0),
                                    days_present: rawDaysPresent,
                                    days_absent: rawDaysAbsent,
                                    half_days_present: rawHalfDaysPresent
                                  };
                                  const renderAttendanceMetricTiles = (recordCount) => (
                                    <>
                                      <Card onClick={() => openPayrollDetailModal('present')} className="bg-green-50 border-green-200 cursor-pointer hover:shadow-md">
                                        <CardContent className="p-3">
                                          <div className="flex items-center justify-between">
                                            <div>
                                              <p className="text-xs font-medium text-green-700">Days Present</p>
                                              <p className="text-lg font-bold text-green-900">{summaryAnalytics.days_present}</p>
                                              <p className="text-xs text-green-600">Working: {summaryAnalytics.working_days}</p>
                                              <p className="text-[10px] text-green-600">Records: {recordCount}</p>
                                            </div>
                                            <CalendarCheck className="h-6 w-6 text-green-600" />
                                          </div>
                                        </CardContent>
                                      </Card>
                                      <Card onClick={() => openPayrollDetailModal('absent')} className="bg-red-50 border-red-200 cursor-pointer hover:shadow-md">
                                        <CardContent className="p-3">
                                          <div className="flex items-center justify-between">
                                            <div>
                                              <p className="text-xs font-medium text-red-700">Days Absent</p>
                                              <p className="text-lg font-bold text-red-900">{summaryAnalytics.days_absent}</p>
                                            </div>
                                            <Calendar className="h-6 w-6 text-red-600" />
                                          </div>
                                        </CardContent>
                                      </Card>
                                      <Card onClick={() => openPayrollDetailModal('late')} className="bg-orange-50 border-orange-200 cursor-pointer hover:shadow-md">
                                        <CardContent className="p-3">
                                          <div className="flex items-center justify-between">
                                            <div>
                                              <p className="text-xs font-medium text-orange-700">Late Minutes</p>
                                              <p className="text-lg font-bold text-orange-900">{summaryAnalytics.total_minutes_late}</p>
                                              <p className="text-xs text-orange-600">&#8776; {Math.round(summaryAnalytics.total_minutes_late / 60 * 100) / 100}h</p>
                                            </div>
                                            <Clock className="h-6 w-6 text-orange-600" />
                                          </div>
                                        </CardContent>
                                      </Card>

                                      <Card onClick={() => openPayrollDetailModal('undertime')} className="bg-purple-50 border-purple-200 cursor-pointer hover:shadow-md">
                                        <CardContent className="p-3">
                                          <div className="flex items-center justify-between">
                                            <div>
                                              <p className="text-xs font-medium text-purple-700">Undertime</p>
                                              <p className="text-lg font-bold text-purple-900">{summaryAnalytics.total_minutes_undertime}</p>
                                              <p className="text-xs text-purple-600">&#8776; {Math.round(summaryAnalytics.total_minutes_undertime / 60 * 100) / 100}h</p>
                                            </div>
                                            <Clock className="h-6 w-6 text-purple-600" />
                                          </div>
                                        </CardContent>
                                      </Card>
                                    </>
                                  );
                                  return (
                                  <div
                                    key={generateTableTab}
                                    className="animate-in fade-in slide-in-from-bottom-2 duration-300 ease-in-out"
                                  >
                                    {(generateTableTab === 'mf' ? (!mfAttendanceFilters.start_date || !mfAttendanceFilters.end_date) : (!payrollAttendanceFilters.start_date || !payrollAttendanceFilters.end_date)) ? (
                                      <div className="text-center py-12">
                                        <CalendarCheck className="h-16 w-16 text-gray-400 mx-auto mb-4" />
                                        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">No date range selected</h3>
                                        <p className="text-gray-500 dark:text-gray-300">Please select start and end dates to view attendance analytics</p>
                                      </div>
                                    ) : (generateTableTab === 'mf' ? isLoadingMfAttendance : isLoadingPayrollAttendance) ? (
                                      <div className="text-center py-12">
                                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
                                        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">Loading Attendance Data</h3>
                                        <p className="text-gray-500 dark:text-gray-300">Fetching and analyzing payroll attendance records...</p>
                                      </div>
                                    ) : (generateTableTab === 'mf' ? (mfAttendanceAnalytics.total_employees === 0 && mfAttendanceData.length === 0) : (payrollAttendanceAnalytics.total_employees === 0 && payrollAttendanceData.length === 0)) ? (
                                      <div className="text-center py-12">
                                        <CalendarCheck className="h-16 w-16 text-gray-400 mx-auto mb-4" />
                                        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">No attendance data found</h3>
                                        <p className="text-gray-500 dark:text-gray-300">No payroll employee attendance records found for the selected date range</p>
                                      </div>
                                    ) : (
                                      <div className="space-y-6">
                                        <div className="space-y-4">
                                          {generateTableTab === 'mf' ? (
                                            <>
                                              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-7 gap-3">
                                                {renderAttendanceMetricTiles(mfAttendanceData.length)}
                                                <Card className="bg-blue-50 border-blue-200">
                                                  <CardContent className="p-3">
                                                    <div className="flex items-center justify-between">
                                                      <div>
                                                        <p className="text-xs font-medium text-blue-700">MF Amount</p>
                                                        <p className="text-lg font-bold text-blue-900">{(() => { const mf = parseFloat(payrollEmployeeData?.allowances?.mf) || 0; return mf > 0 ? `\u20b1${mf.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : 'N/A'; })()}</p>
                                                      </div>
                                                      <Users className="h-6 w-6 text-blue-600" />
                                                    </div>
                                                  </CardContent>
                                                </Card>
                                                <Card className="bg-yellow-50 border-yellow-200">
                                                  <CardContent className="p-3">
                                                    <div className="flex items-center justify-between">
                                                      <div>
                                                        <p className="text-xs font-medium text-yellow-700">Gas Allowance Amount</p>
                                                        <p className="text-lg font-bold text-yellow-900">{(() => { const val = parseFloat(payrollEmployeeData?.allowances?.gas_allowance) || 0; return val > 0 ? `\u20b1${val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : 'N/A'; })()}</p>
                                                      </div>
                                                      <Car className="h-6 w-6 text-yellow-600" />
                                                    </div>
                                                  </CardContent>
                                                </Card>
                                                <Card className="bg-indigo-50 border-indigo-200">
                                                  <CardContent className="p-3">
                                                    <div className="flex items-center justify-between">
                                                      <div>
                                                        <p className="text-xs font-medium text-indigo-700">Load Allowance Amount</p>
                                                        <p className="text-lg font-bold text-indigo-900">{(() => { const val = parseFloat(payrollEmployeeData?.allowances?.load_allowance) || 0; return val > 0 ? `\u20b1${val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : 'N/A'; })()}</p>
                                                      </div>
                                                      <Smartphone className="h-6 w-6 text-indigo-600" />
                                                    </div>
                                                  </CardContent>
                                                </Card>
                                                <Card className="bg-amber-50 border-amber-200">
                                                  <CardContent className="p-3">
                                                    <div className="flex items-center justify-between">
                                                      <div>
                                                        <p className="text-xs font-medium text-amber-700">Housing Allowance Amount</p>
                                                        <p className="text-lg font-bold text-amber-900">{(() => { const val = parseFloat(payrollEmployeeData?.allowances?.housing_allowance) || 0; return val > 0 ? `\u20b1${val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : 'N/A'; })()}</p>
                                                      </div>
                                                      <Home className="h-6 w-6 text-amber-600" />
                                                    </div>
                                                  </CardContent>
                                                </Card>
                                                <Card className="bg-teal-50 border-teal-200">
                                                  <CardContent className="p-3">
                                                    <div className="flex items-center justify-between">
                                                      <div>
                                                        <p className="text-xs font-medium text-teal-700">Running Total MF</p>
                                                        <p className="text-lg font-bold text-teal-900">{(() => {
                                                          try {
                                                            const nameFilter = (mfAttendanceFilters.name || '').trim();
                                                            if (!nameFilter || !mfSelectedPayslipEmployee || !payrollEmployeeData) return '\u2014';
                                                            const basicSalary = parseFloat(payrollEmployeeData.salary) || 0;
                                                            let dailyRate = calculatedMfPayslip.dailyRate || parseFloat(payrollEmployeeData.daily_rate) || 0;
                                                            if (!dailyRate) {
                                                              const basis = payrollEmployeeData.daily_rate_formula || payrollEmployeeData.rate_formula || payrollEmployeeData.dailyRateFormula || 313;
                                                              dailyRate = computeDailyRateFromBasis(basicSalary, basis);
                                                            }
                                                            const base = (parseFloat(payrollEmployeeData?.allowances?.mf) || 0) + (parseFloat(payrollEmployeeData?.allowances?.gas_allowance) || 0) + (parseFloat(payrollEmployeeData?.allowances?.load_allowance) || 0) + (parseFloat(payrollEmployeeData?.allowances?.housing_allowance) || 0);
                                                            const { absenceDeduction, lateDeduction, undertimeDeduction } = calculateAttendanceDeductions(summaryAnalytics.days_absent || 0, summaryAnalytics.total_minutes_late || 0, summaryAnalytics.total_minutes_undertime || 0, dailyRate);
                                                            const grossPay = base - absenceDeduction - lateDeduction - undertimeDeduction;
                                                            let sssDeduction = 0, phicDeduction = 0, hdmfDeduction = 0, taxDeduction = 0;
                                                            const endDateStr = mfAttendanceFilters.end_date;
                                                            const endDateObj = endDateStr ? new Date(endDateStr) : null;
                                                            const isEndOfMonth = endDateObj && !isNaN(endDateObj) && endDateObj.getDate() === new Date(endDateObj.getFullYear(), endDateObj.getMonth() + 1, 0).getDate();
                                                            const toggles = {
                                                              sss: payslipDeductions.sss,
                                                              phic: payslipDeductions.phic,
                                                              hdmf: payslipDeductions.hdmf,
                                                              tax: payslipDeductions.tax,
                                                              is_minimum_wage: payrollEmployeeData.is_minimum_wage || false
                                                            };
                                                            if (toggles.sss) sssDeduction = calculatedMfPayslip?.deductions?.sss || 0;
                                                            if (toggles.phic) {
                                                              const isFirstHalf = isEndDateInFirstHalf(endDateStr);
                                                              const monthlySalary = parseFloat(payrollEmployeeData?.salary) || 0;
                                                              phicDeduction = isFirstHalf ? (monthlySalary * 0.05) / 2 : 0;
                                                            }
                                                            if (toggles.hdmf) {
                                                              const isFirstHalf = isEndDateInFirstHalf(endDateStr);
                                                              const extra = parseFloat(payrollEmployeeData?.deductions?.hdmf_additional) || 0;
                                                              hdmfDeduction = isFirstHalf ? (200 + extra) : 0;
                                                            }
                                                            if (toggles.tax && !toggles.is_minimum_wage && isEndOfMonth) {
                                                              const monthlyTaxable = basicSalary - sssDeduction - phicDeduction - hdmfDeduction;
                                                              taxDeduction = calculateTaxDeduction(monthlyTaxable);
                                                            }
                                                            const totalDeductions = sssDeduction + phicDeduction + hdmfDeduction + taxDeduction;
                                                            const netPay = Math.max(0, grossPay - totalDeductions);
                                                            return `\u20b1${netPay.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                                                          } catch (e) { return '\u2014'; }
                                                        })()}</p>
                                                        <p className="text-xs text-teal-600">Salary Tracking</p>
                                                      </div>
                                                      <FileText className="h-6 w-6 text-teal-600" />
                                                    </div>
                                                  </CardContent>
                                                </Card>
                                                <Card className="bg-slate-50 border-slate-200 col-span-2 md:col-span-2 lg:col-span-2">
                                                  <CardContent className="p-3">
                                                    <div className="flex items-start justify-between gap-3">
                                                      <div className="flex-1 min-w-0">
                                                        <p className="text-xs font-medium text-slate-700">Loan</p>
                                                        {(() => {
                                                          try {
                                                            if (generateTableTab !== 'mf') return <div className="mt-1 text-sm font-bold text-slate-900">&#8212;</div>;
                                                            const rows = enabledMfLoanRows;
                                                            if (!rows.length) return <div className="mt-1 text-sm font-bold text-slate-900">&#8212;</div>;

                                                            const formatTypeLabel = (loan) => {
                                                              const t = String(loan?.loan_type || '').toLowerCase();
                                                              const typeLabel = t ? `${t.charAt(0).toUpperCase()}${t.slice(1)}` : '';
                                                              const subtype = String(loan?.loan_subtype || '').trim();
                                                              if (!typeLabel && !subtype) return '-';
                                                              if (typeLabel && subtype) return `${typeLabel} - ${subtype}`;
                                                              return typeLabel || subtype;
                                                            };

                                                            const formatMoney = (value) => {
                                                              const n = Number(value);
                                                              if (!Number.isFinite(n)) return '\u20b10.00';
                                                              return `\u20b1${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                                                            };

                                                            const toCutoffLabel = (value) => {
                                                              const n = Number(value);
                                                              if (!Number.isFinite(n) || n <= 0) return '0';
                                                              return String(Math.round(n));
                                                            };

                                                            return (
                                                              <div className="mt-2 space-y-2">
                                                                {rows.map((loan, idx) => {
                                                                  const perCutoff = Number(loan?.deduct_per_cutoff);
                                                                  const cutoffRaw = (loan?.cutoff_count !== null && loan?.cutoff_count !== undefined)
                                                                    ? loan.cutoff_count
                                                                    : ((Number(loan?.amount) > 0 && Number.isFinite(perCutoff) && perCutoff > 0) ? (Number(loan.amount) / perCutoff) : 0);
                                                                  const key = String(loan?.id || `${loan?.employee_id || loan?.employee_name || 'loan'}_${idx}`);
                                                                  return (
                                                                    <div key={key} className="rounded border border-slate-200 bg-white/70 p-2">
                                                                      <div className="text-sm font-semibold text-slate-900 truncate">{formatTypeLabel(loan)}</div>
                                                                      <div className="text-xs text-slate-700">Deductable for {toCutoffLabel(cutoffRaw)} cutoff.</div>
                                                                      <div className="text-xs text-slate-700">Deduct the amount below every cutoff MF: {formatMoney(perCutoff)}</div>
                                                                    </div>
                                                                  );
                                                                })}
                                                              </div>
                                                            );
                                                          } catch (e) {
                                                            return <div className="mt-1 text-sm font-bold text-slate-900">&#8212;</div>;
                                                          }
                                                        })()}
                                                      </div>
                                                      <FileText className="h-6 w-6 text-slate-600 flex-shrink-0" />
                                                    </div>
                                                  </CardContent>
                                                </Card>
                                              </div>
                                              {(mfAttendanceFilters.name && mfSelectedPayslipEmployee) && (
                                                <MfPayslipSummaryCard
                                                  employee={mfSelectedPayslipEmployee}
                                                  mfPayrollEmployeeData={payrollEmployeeData}
                                                  calculatedMfPayslip={calculatedMfPayslip}
                                                  attendanceAnalytics={summaryAnalytics}
                                                  attendanceFilters={mfAttendanceFilters}
                                                  holidaysApplied={(() => {
                                                    if (isEditingPayslipRecord && Array.isArray(editingPayslipRecordMeta?.holidays)) return editingPayslipRecordMeta.holidays;
                                                    const genRow = getGeneratedPayslipRowForSelection(
                                                      'mf',
                                                      mfSelectedPayslipEmployee.employee_id || mfSelectedPayslipEmployee.id,
                                                      mfAttendanceFilters.start_date,
                                                      mfAttendanceFilters.end_date
                                                    );
                                                    if (Array.isArray(genRow?.holidays)) return genRow.holidays;
                                                    const vr = validateDateRangeTaipei(mfAttendanceFilters.start_date, mfAttendanceFilters.end_date);
                                                    if (!vr.ok) return [];
                                                    return sanitizeHolidayRows(holidays).filter((h) => h.date >= vr.startISO && h.date <= vr.endISO);
                                                  })()}
                                                  additionalIncome={additionalIncome}
                                                  additionalDeductions={additionalDeductions}
                                                  loanSummary={{ ...mfLoanSummary, rows: enabledMfLoanRows }}
                                                  payrollPeriod={payrollPeriod}
                                                  onOpenPayslip={() => {
                                                    setIsPayslipModalOpen(true);
                                                    fetchAndCalculatePayslipMf();
                                                  }}
                                                  onOpenRecords={() => openPayrollDetailModal('all')}
                                                  onOpenCalendar={() => setIsCalendarViewOpen(true)}
                                                />
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-7 gap-3">
                                                {renderAttendanceMetricTiles(payrollAttendanceData.length)}

                                                <Card className="bg-blue-50 border-blue-200">
                                                  <CardContent className="p-3">
                                                    <div className="flex items-center justify-between">
                                                      <div>
                                                        <p className="text-xs font-medium text-blue-700">Daily Rate</p>
                                                        <p className="text-lg font-bold text-blue-900">&#8369;{summaryAnalytics.daily_rate.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</p>
                                                        <p className="text-xs text-blue-600"></p>
                                                      </div>
                                                      <Users className="h-6 w-6 text-blue-600" />
                                                    </div>
                                                  </CardContent>
                                                </Card>

                                                <Card className="bg-emerald-50 border-emerald-200">
                                                  <CardContent className="p-3">
                                                    <div className="flex items-center justify-between">
                                                      <div>
                                                        <p className="text-xs font-medium text-emerald-700">Total Gross</p>
                                                        <p className="text-lg font-bold text-emerald-900">&#8369;{summaryAnalytics.total_gross_pay.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</p>
                                                        <p className="text-xs text-emerald-600"></p>
                                                      </div>
                                                      <FileText className="h-6 w-6 text-emerald-600" />
                                                    </div>
                                                  </CardContent>
                                                </Card>

                                                <Card onClick={() => {
                                                  try {
                                                    const __dbg = createMonthlyGrossDebugger({ sessionId: 'monthly-gross-prev-gross-zero', url: 'http://127.0.0.1:7780/event' });
                                                    __dbg({
                                                      type: 'monthly_gross_ui',
                                                      step: 'open_modal_click',
                                                      monthlyGrossDetails,
                                                      tileValue: (monthlyPayrollSummary.gross || calculatedPayslip.monthlyGross || 0)
                                                    });
                                                  } catch { /* noop */ }
                                                  setIsMonthlyGrossModalOpen(true);
                                                }} className="bg-cyan-50 border-cyan-200 cursor-pointer hover:shadow-md transition-shadow">
                                                  <CardContent className="p-3">
                                                    <div className="flex items-center justify-between">
                                                      <div>
                                                        <p className="text-xs font-medium text-cyan-700">Monthly Gross</p>
                                                        <p className="text-lg font-bold text-cyan-900">&#8369;{((monthlyPayrollSummary.gross || calculatedPayslip.monthlyGross || 0)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                                                      </div>
                                                      <FileText className="h-6 w-6 text-cyan-600" />
                                                    </div>
                                                  </CardContent>
                                                </Card>

                                                <Dialog open={isMonthlyGrossModalOpen} onOpenChange={setIsMonthlyGrossModalOpen}>
                                                  <DialogContent className="sm:max-w-[425px]">
                                                    <DialogHeader>
                                                      <DialogTitle>Monthly Gross Computation</DialogTitle>
                                                      <DialogDescription>
                                                        Breakdown of the monthly gross salary computation.
                                                      </DialogDescription>
                                                    </DialogHeader>
                                                    <div className="space-y-4 py-4">
                                                      <div className="flex justify-between items-center text-sm">
                                                        <span className="text-gray-600">Previous Gross (1st Half):</span>
                                                        <span className="font-medium">&#8369;{monthlyGrossDetails.prevGross.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                      </div>
                                                      <div className="flex justify-between items-center text-sm">
                                                        <span className="text-gray-600">Current Base Pay (after attendance deductions):</span>
                                                        <span className="font-medium">&#8369;{monthlyGrossDetails.currentGross.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                      </div>
                                                      {monthlyGrossDetails.additionalIncome > 0 && (
                                                        <div className="flex justify-between items-center text-sm">
                                                          <span className="text-gray-600 pl-4">+ Additional Income:</span>
                                                          <span className="font-medium text-green-600">&#8369;{monthlyGrossDetails.additionalIncome.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                        </div>
                                                      )}
                                                      <div className="border-t pt-4 flex justify-between items-center font-bold">
                                                        <span>Total Monthly Gross:</span>
                                                        <span className="text-cyan-700 text-lg">&#8369;{monthlyGrossDetails.totalGross.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                      </div>
                                                      {typeof window !== 'undefined' && window?.localStorage?.getItem('mg_debug') === '1' && (
                                                        <pre className="text-[10px] bg-gray-50 border border-gray-200 rounded p-2 overflow-auto max-h-40">
                                                          {JSON.stringify((window.__TRAE_MG_DEBUG_EVENTS__ || []).slice(-8), null, 2)}
                                                        </pre>
                                                      )}
                                                    </div>
                                                  </DialogContent>
                                                </Dialog>

                                                <Card onClick={() => setIsMonthlyGovModalOpen(true)} className="bg-indigo-50 border-indigo-200 cursor-pointer hover:shadow-md transition-shadow">
                                                  <CardContent className="p-3">
                                                    <div className="flex items-center justify-between">
                                                      <div>
                                                        <p className="text-xs font-medium text-indigo-700">Monthly Government deduction</p>
                                                        <p className="text-lg font-bold text-indigo-900">&#8369;{(computeMonthlyGovShown().total || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                                                        <p className="text-xs text-indigo-600">SSS + HDMF + PHIC</p>
                                                      </div>
                                                      <FileText className="h-6 w-6 text-indigo-600" />
                                                    </div>
                                                  </CardContent>
                                                </Card>

                                                <Dialog open={isMonthlyGovModalOpen} onOpenChange={setIsMonthlyGovModalOpen}>
                                                  <DialogContent className="sm:max-w-[520px]">
                                                    <DialogHeader>
                                                      <DialogTitle>Monthly Government Deduction</DialogTitle>
                                                      <DialogDescription>
                                                        Breakdown of how the monthly government deduction total is computed.
                                                      </DialogDescription>
                                                    </DialogHeader>
                                                    <div className="space-y-5 py-4">
                                                      <div className="space-y-2">
                                                        <div className="flex justify-between items-center text-sm">
                                                          <span className="text-gray-600">Previous (saved earlier in month):</span>
                                                          <span className="font-medium">&#8369;{(monthlyGovDetails?.prev?.total || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                        </div>
                                                        <div className="grid grid-cols-3 gap-2 text-xs">
                                                          <div className="bg-gray-50 border border-gray-200 rounded p-2">
                                                            <div className="text-gray-600">SSS</div>
                                                            <div className="font-semibold">&#8369;{(monthlyGovDetails?.prev?.sss || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                                          </div>
                                                          <div className="bg-gray-50 border border-gray-200 rounded p-2">
                                                            <div className="text-gray-600">PHIC</div>
                                                            <div className="font-semibold">&#8369;{(monthlyGovDetails?.prev?.phic || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                                          </div>
                                                          <div className="bg-gray-50 border border-gray-200 rounded p-2">
                                                            <div className="text-gray-600">HDMF</div>
                                                            <div className="font-semibold">&#8369;{(monthlyGovDetails?.prev?.hdmf || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                                          </div>
                                                        </div>
                                                        {Array.isArray(monthlyGovDetails?.prev?.records) && monthlyGovDetails.prev.records.length > 0 && (
                                                          <div className="border border-gray-200 rounded">
                                                            <div className="px-3 py-2 text-xs font-medium text-gray-700 bg-gray-50 border-b border-gray-200">
                                                              Included saved payroll records
                                                            </div>
                                                            <div className="max-h-40 overflow-auto">
                                                              <Table>
                                                                <TableHeader>
                                                                  <TableRow>
                                                                    <TableHead className="text-xs">Period</TableHead>
                                                                    <TableHead className="text-xs text-right">SSS</TableHead>
                                                                    <TableHead className="text-xs text-right">PHIC</TableHead>
                                                                    <TableHead className="text-xs text-right">HDMF</TableHead>
                                                                    <TableHead className="text-xs text-right">Total</TableHead>
                                                                  </TableRow>
                                                                </TableHeader>
                                                                <TableBody>
                                                                  {monthlyGovDetails.prev.records.map((r, idx) => (
                                                                    <TableRow key={`${r?.start_date || ''}_${r?.end_date || ''}_${idx}`}>
                                                                      <TableCell className="text-xs">
                                                                        {String(r?.start_date || '').slice(0, 10)}&#8211;{String(r?.end_date || '').slice(0, 10)}
                                                                      </TableCell>
                                                                      <TableCell className="text-xs text-right">&#8369;{(r?.sss || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                      <TableCell className="text-xs text-right">&#8369;{(r?.phic || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                      <TableCell className="text-xs text-right">&#8369;{(r?.hdmf || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                      <TableCell className="text-xs text-right font-medium">&#8369;{(r?.total || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                    </TableRow>
                                                                  ))}
                                                                </TableBody>
                                                              </Table>
                                                            </div>
                                                          </div>
                                                        )}
                                                      </div>

                                                      <div className="space-y-2">
                                                        <div className="flex justify-between items-center text-sm">
                                                          <span className="text-gray-600">Current payroll period:</span>
                                                          <span className="font-medium">&#8369;{(computeMonthlyGovShown().current || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                        </div>
                                                        <div className="grid grid-cols-3 gap-2 text-xs">
                                                          <div className="bg-indigo-50 border border-indigo-200 rounded p-2">
                                                            <div className="text-indigo-700">SSS</div>
                                                            <div className="font-semibold">&#8369;{(computeMonthlyGovShown().sss || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                                          </div>
                                                          <div className="bg-indigo-50 border border-indigo-200 rounded p-2">
                                                            <div className="text-indigo-700">PHIC</div>
                                                            <div className="font-semibold">&#8369;{(computeMonthlyGovShown().phic || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                                          </div>
                                                          <div className="bg-indigo-50 border border-indigo-200 rounded p-2">
                                                            <div className="text-indigo-700">HDMF</div>
                                                            <div className="font-semibold">&#8369;{(computeMonthlyGovShown().hdmf || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                                                          </div>
                                                        </div>
                                                      </div>

                                                      <div className="border-t pt-4 flex justify-between items-center font-bold">
                                                        <span>Total Monthly Government Deduction:</span>
                                                        <span className="text-indigo-700 text-lg">&#8369;{(computeMonthlyGovShown().total || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                      </div>

                                                      <div className="text-xs text-gray-600 space-y-1">
                                                        <div>PHIC: (monthly salary &#215; 5%) &#247; 2, deducted only on first-half payroll.</div>
                                                        <div>HDMF: 200 + additional, deducted only on first-half payroll.</div>
                                                        <div>SSS: bracket-based deduction, applied on the SSS window payroll.</div>
                                                      </div>
                                                    </div>
                                                  </DialogContent>
                                                </Dialog>

                                                <Card className="bg-teal-50 border-teal-200">
                                                  <CardContent className="p-3">
                                                    <div className="flex items-center justify-between">
                                                      <div>
                                                        <p className="text-xs font-medium text-teal-700">Running Total Salary</p>
                                                        <p className="text-lg font-bold text-teal-900">{(() => {
                                                          try {
                                                            if (generateTableTab !== 'payroll') return '\u2014';
                                                            const nameFilter = (payrollAttendanceFilters.name || '').trim();
                                                            if (!nameFilter) return '\u2014';
                                                            const matchedEmployee = employees.find(emp =>
                                                              emp.full_name?.toLowerCase().includes(nameFilter.toLowerCase()) ||
                                                              emp.employee_id?.toLowerCase().includes(nameFilter.toLowerCase())
                                                            );
                                                            if (!matchedEmployee) return '\u2014';
                                                            const payrollEmployee = payrollEmployees.find(emp => emp.employee_id === matchedEmployee.id);
                                                            if (!payrollEmployee) return '\u2014';
                                                            const basicSalary = parseFloat(payrollEmployee.salary) || 0;
                                                            let dailyRate = parseFloat(payrollEmployee.daily_rate) || 0;
                                                            if (!dailyRate) {
                                                              const basis = payrollEmployee.daily_rate_formula || payrollEmployee.rate_formula || payrollEmployee.dailyRateFormula || 313;
                                                              dailyRate = computeDailyRateFromBasis(basicSalary, basis);
                                                            }
                                                            const halfMonthSalary = basicSalary / 2;
                                                            const { absenceDeduction, lateDeduction, undertimeDeduction } = calculateAttendanceDeductions(summaryAnalytics.days_absent || 0, summaryAnalytics.total_minutes_late || 0, summaryAnalytics.total_minutes_undertime || 0, dailyRate);
                                                            const grossPay = halfMonthSalary - absenceDeduction - lateDeduction - undertimeDeduction;
                                                            let sssDeduction = 0, phicDeduction = 0, hdmfDeduction = 0, taxDeduction = 0;
                                                            const endDateStr = payrollAttendanceFilters.end_date;
                                                            const endDateObj = endDateStr ? new Date(endDateStr) : null;
                                                            const isEndOfMonth = endDateObj && !isNaN(endDateObj) && endDateObj.getDate() === new Date(endDateObj.getFullYear(), endDateObj.getMonth() + 1, 0).getDate();
                                                            const toggles = {
                                                              sss: true,
                                                              phic: true,
                                                              hdmf: true,
                                                              tax: !payrollEmployee.is_minimum_wage,
                                                              is_minimum_wage: payrollEmployee.is_minimum_wage || false
                                                            };
                                                            if (toggles.sss) sssDeduction = calculatedPayslip?.deductions?.sss || 0;
                                                            if (toggles.phic) {
                                                              const isFirstHalf = isEndDateInFirstHalf(endDateStr);
                                                              const monthlySalary = parseFloat(payrollEmployee?.salary) || 0;
                                                              phicDeduction = isFirstHalf ? (monthlySalary * 0.05) / 2 : 0;
                                                            }
                                                            if (toggles.hdmf) {
                                                              const isFirstHalf = isEndDateInFirstHalf(endDateStr);
                                                              const extra = parseFloat(payrollEmployee?.deductions?.hdmf_additional) || 0;
                                                              hdmfDeduction = isFirstHalf ? (200 + extra) : 0;
                                                            }
                                                            if (toggles.tax && !toggles.is_minimum_wage && isEndOfMonth) {
                                                              const monthlyTaxable = basicSalary - sssDeduction - phicDeduction - hdmfDeduction;
                                                              taxDeduction = calculateTaxDeduction(monthlyTaxable);
                                                            }
                                                            const totalDeductions = sssDeduction + phicDeduction + hdmfDeduction + taxDeduction;
                                                            const netPay = Math.max(0, grossPay - totalDeductions);
                                                            return `\u20b1${netPay.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                                                          } catch (e) { return '\u2014'; }
                                                        })()}</p>
                                                        <p className="text-xs text-teal-600">Salary Tracking</p>
                                                      </div>
                                                      <FileText className="h-6 w-6 text-teal-600" />
                                                    </div>
                                                  </CardContent>
                                                </Card>
                                                <Card className="bg-slate-50 border-slate-200 col-span-2 md:col-span-2 lg:col-span-2">
                                                  <CardContent className="p-3">
                                                    <div className="flex items-start justify-between gap-3">
                                                      <div className="flex-1 min-w-0">
                                                        <p className="text-xs font-medium text-slate-700">Loan</p>
                                                        {(() => {
                                                          try {
                                                            if (generateTableTab !== 'payroll') return <div className="mt-1 text-sm font-bold text-slate-900">&#8212;</div>;
                                                            const rows = Array.isArray(payrollLoanSummary?.rows) ? payrollLoanSummary.rows : [];
                                                            if (!rows.length) return <div className="mt-1 text-sm font-bold text-slate-900">&#8212;</div>;

                                                            const formatTypeLabel = (loan) => {
                                                              const t = String(loan?.loan_type || '').toLowerCase();
                                                              const typeLabel = t ? `${t.charAt(0).toUpperCase()}${t.slice(1)}` : '';
                                                              const subtype = String(loan?.loan_subtype || '').trim();
                                                              if (!typeLabel && !subtype) return '-';
                                                              if (typeLabel && subtype) return `${typeLabel} - ${subtype}`;
                                                              return typeLabel || subtype;
                                                            };

                                                            const formatMoney = (value) => {
                                                              const n = Number(value);
                                                              if (!Number.isFinite(n)) return '\u20b10.00';
                                                              return `\u20b1${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                                                            };

                                                            const toCutoffLabel = (value) => {
                                                              const n = Number(value);
                                                              if (!Number.isFinite(n) || n <= 0) return '0';
                                                              return String(Math.round(n));
                                                            };

                                                            return (
                                                              <div className="mt-2 space-y-2">
                                                                {rows.map((loan, idx) => {
                                                                  const perCutoff = Number(loan?.deduct_per_cutoff);
                                                                  const cutoffRaw = (loan?.cutoff_count !== null && loan?.cutoff_count !== undefined)
                                                                    ? loan.cutoff_count
                                                                    : ((Number(loan?.amount) > 0 && Number.isFinite(perCutoff) && perCutoff > 0) ? (Number(loan.amount) / perCutoff) : 0);
                                                                  const key = String(loan?.id || `${loan?.employee_id || loan?.employee_name || 'loan'}_${idx}`);
                                                                  return (
                                                                    <div key={key} className="rounded border border-slate-200 bg-white/70 p-2">
                                                                      <div className="text-sm font-semibold text-slate-900 truncate">{formatTypeLabel(loan)}</div>
                                                                      <div className="text-xs text-slate-700">Deductable for {toCutoffLabel(cutoffRaw)} cutoff.</div>
                                                                      <div className="text-xs text-slate-700">Deduct the amount below every cutoff Payroll: {formatMoney(perCutoff)}</div>
                                                                    </div>
                                                                  );
                                                                })}
                                                              </div>
                                                            );
                                                          } catch (e) {
                                                            return <div className="mt-1 text-sm font-bold text-slate-900">&#8212;</div>;
                                                          }
                                                        })()}
                                                      </div>
                                                      <FileText className="h-6 w-6 text-slate-600 flex-shrink-0" />
                                                    </div>
                                                  </CardContent>
                                                </Card>
                                              </div>
                                              {(payrollAttendanceFilters.name && selectedPayslipEmployee) && (
                                                <PayslipSummaryCard
                                                  mode="payroll"
                                                  employee={selectedPayslipEmployee}
                                                  payrollEmployeeData={payrollEmployeeData}
                                                  calculatedPayslip={(() => {
                                                    const genRow = getGeneratedPayslipRowForSelection(
                                                      'payroll',
                                                      selectedPayslipEmployee.employee_id || selectedPayslipEmployee.id,
                                                      payrollAttendanceFilters.start_date,
                                                      payrollAttendanceFilters.end_date
                                                    );
                                                    if (!genRow) return calculatedPayslip;
                                                    const taxValue = (() => {
                                                      const s = String(genRow?.withholding_tax ?? '').replace(/,/g, '').trim();
                                                      const x = parseFloat(s);
                                                      return Number.isFinite(x) ? x : 0;
                                                    })();
                                                    return {
                                                      ...(calculatedPayslip || {}),
                                                      deductions: {
                                                        ...((calculatedPayslip && calculatedPayslip.deductions) ? calculatedPayslip.deductions : {}),
                                                        tax: taxValue
                                                      }
                                                    };
                                                  })()}
                                                  attendanceAnalytics={summaryAnalytics}
                                                  attendanceFilters={payrollAttendanceFilters}
                                                  holidaysApplied={(() => {
                                                    if (isEditingPayslipRecord && Array.isArray(editingPayslipRecordMeta?.holidays)) return editingPayslipRecordMeta.holidays;
                                                    const genRow = getGeneratedPayslipRowForSelection(
                                                      'payroll',
                                                      selectedPayslipEmployee.employee_id || selectedPayslipEmployee.id,
                                                      payrollAttendanceFilters.start_date,
                                                      payrollAttendanceFilters.end_date
                                                    );
                                                    if (Array.isArray(genRow?.holidays)) return genRow.holidays;
                                                    const vr = validateDateRangeTaipei(payrollAttendanceFilters.start_date, payrollAttendanceFilters.end_date);
                                                    if (!vr.ok) return [];
                                                    return sanitizeHolidayRows(holidays).filter((h) => h.date >= vr.startISO && h.date <= vr.endISO);
                                                  })()}
                                                  additionalIncome={additionalIncome}
                                                  additionalDeductions={additionalDeductions}
                                                  payslipDeductions={payslipDeductions}
                                                  loanSummary={payrollLoanSummary}
                                                  payrollPeriod={payrollPeriod}
                                                  otHours={otHours}
                                                  holidayHours={holidayHours}
                                                onOpenPayslip={() => {
                                                  setIsPayslipModalOpen(true);
                                                  fetchAndCalculatePayslip();
                                                }}
                                                  onOpenRecords={() => openPayrollDetailModal('all')}
                                                  onOpenCalendar={() => setIsCalendarViewOpen(true)}
                                                />
                                              )}
                                            </>
                                          )}
                                          <div className="flex justify-end pt-2">
                                            <Button
                                              type="button"
                                              onClick={saveGeneratedSummaryPayslip}
                                              disabled={!summaryGenRow || isSavingGeneratedSummaryPayslip}
                                              className="bg-green-600 hover:bg-green-700"
                                            >
                                              <Save className="h-4 w-4 mr-2" />
                                              {isSavingGeneratedSummaryPayslip ? 'Saving\u2026' : 'Save'}
                                            </Button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  );
                                };

                                // Reusable presence/absence count calculator  uses the EXACT SAME logic
                                // as the "Payslip Calculation Summary" modal. Used to keep saved payslip
                                // records, the modal, and the Employee Payslip dialog in sync.
                                // Returns { working_days, days_present, days_absent, half_days_present }
                                const computeRawPresenceAbsenceForEmployee = ({
                                  tab,              // 'payroll' | 'mf'
                                  employeeId,       // user_id / employee_id as string
                                  startISO,         // YYYY-MM-DD in Asia/Manila
                                  endISO,
                                  rawAttendance,    // rawPayrollAttendanceData or rawMfAttendanceData (ONE TRUE raw)
                                  peList            // payrollEmployees list to detect 5-day vs 6-day basis
                                }) => {
                                  const result = { working_days: 0, days_present: 0, days_absent: 0, half_days_present: 0 };
                                  if (!tab || !employeeId || !startISO || !endISO) return result;
                                  const normalizeId = (v) => {
                                    const raw = String(v ?? '').trim();
                                    if (!raw) return '';
                                    if (/^\d+$/.test(raw)) return raw.replace(/^0+(?=\d)/, '');
                                    return raw;
                                  };
                                  const selectedId = normalizeId(employeeId);
                                  if (!selectedId) return result;
                                  let isSixDay = false;
                                  const foundPe = (peList || []).find((pe) =>
                                    normalizeId(pe?.employee_id) === selectedId
                                  );
                                  if (foundPe) {
                                    const basis = foundPe.daily_rate_formula || foundPe.rate_formula || foundPe.dailyRateFormula;
                                    if (String(basis) === '313' || basis === 313) isSixDay = true;
                                  }
                                  const s = new Date(startISO + 'T00:00:00+08:00');
                                  const e = new Date(endISO + 'T00:00:00+08:00');
                                  const holidaysForRaw = sanitizeHolidayRows(holidays).filter(
                                    (h) => h.date >= startISO && h.date <= endISO
                                  );
                                  result.working_days = countWorkingDaysMinusHolidays({
                                    startISO,
                                    endISO,
                                    isSixDay,
                                    holidayRows: holidaysForRaw
                                  });
                                  const sExt = addDays(new Date(startISO + 'T00:00:00+08:00'), -3);
                                  const eExt = addDays(new Date(endISO + 'T00:00:00+08:00'), 3);
                                  const sExtISO = isoDateTaipei(sExt);
                                  const eExtISO = isoDateTaipei(eExt);
                                  const oneTrueRaw = Array.isArray(rawAttendance) ? rawAttendance : [];
                                  const empRawRecords = oneTrueRaw.filter((r) => {
                                    if (!r) return false;
                                    const rid = normalizeId(r.user_id);
                                    if (rid !== selectedId) return false;
                                    const t = String(r?.type || '').toLowerCase().trim();
                                    if (t !== 'time_in' && t !== 'time_out') return false;
                                    let dateISO;
                                    try { dateISO = toTaipeiISODate(r.timestamp); } catch { return false; }
                                    return !!dateISO && dateISO >= sExtISO && dateISO <= eExtISO;
                                  });
                                  const baseCredit = {};
                                  try {
                                    const { perEmployeeDates } = aggregateFirstLastMinutes(empRawRecords, { startISO: sExtISO, endISO: eExtISO });
                                    const employeeDates = perEmployeeDates[selectedId] || {};
                                    let cur = new Date(sExt);
                                    while (cur <= eExt) {
                                      if (isWorkingDayForBasis(cur, isSixDay)) {
                                        const iso = isoDateTaipei(cur);
                                        const day = employeeDates?.[iso];
                                        const hasIn = !!day?.has_time_in;
                                        const hasOut = !!day?.has_time_out;
                                        const hd = day ? detectHalfDayStatus(day.first_in, day.last_out) : null;
                                        const isHalf = !!(hd && hd.isHalfDay);
                                        let c = 0;
                                        if (hasIn && hasOut && !isHalf) c = 1;
                                        else if (hasIn || hasOut || isHalf) c = 0.5;
                                        baseCredit[iso] = c;
                                      }
                                      cur = addDays(cur, 1);
                                    }
                                  } catch { /* noop */ }
                                  if (isSixDay) {
                                    let satCur = new Date(s);
                                    while (satCur <= e) {
                                      if (taipeiDayOfWeek(satCur) === 6) {
                                        const satISO = isoDateTaipei(satCur);
                                        const key = `${selectedId}_${satISO}`;
                                        const override = saturdayOverrides?.[key];
                                        const rawCreditSat = typeof baseCredit[satISO] === 'number' ? baseCredit[satISO] : 0;
                                        let prevPresent = false;
                                        for (let off = 1; off <= 3; off++) {
                                          const dCheck = addDays(satCur, -off);
                                          if (dCheck < sExt) break;
                                          if (!isWorkingDayForBasis(dCheck, isSixDay)) continue;
                                          const isoCheck = isoDateTaipei(dCheck);
                                          if ((typeof baseCredit[isoCheck] === 'number' ? baseCredit[isoCheck] : 0) > 0) {
                                            prevPresent = true; break;
                                          }
                                        }
                                        let nextPresent = false;
                                        for (let off = 1; off <= 3; off++) {
                                          const dCheck = addDays(satCur, off);
                                          if (dCheck > eExt) break;
                                          if (!isWorkingDayForBasis(dCheck, isSixDay)) continue;
                                          const isoCheck = isoDateTaipei(dCheck);
                                          if ((typeof baseCredit[isoCheck] === 'number' ? baseCredit[isoCheck] : 0) > 0) {
                                            nextPresent = true; break;
                                          }
                                        }
                                        const eligible = prevPresent && nextPresent;
                                        baseCredit[satISO] = resolveSaturdayCredit({
                                          rawCredit: rawCreditSat,
                                          eligible,
                                          override
                                        });
                                      }
                                      satCur = addDays(satCur, 1);
                                    }
                                  }
                                  applyHolidaySandwichRuleToCredits({
                                    credits: baseCredit,
                                    startISO,
                                    endISO,
                                    isSixDay,
                                    holidayRows: holidaysForRaw
                                  });
                                  Object.entries(baseCredit).forEach(([iso, credit]) => {
                                    if (iso < startISO || iso > endISO) return;
                                    if (credit === 1) result.days_present += 1;
                                    else if (credit === 0.5) {
                                      result.days_present += 0.5;
                                      result.half_days_present += 1;
                                    }
                                  });
                                  result.days_absent = Math.max(0, result.working_days - result.days_present);
                                  return result;
                                };

                                // For a given tab (payroll/mf) + range, re-normalize ALL EXISTING saved
                                // payslip records that have incorrect days_absent / days_present values
                                // caused by the earlier logic bugs (missing auto-Saturday credits and
                                // half-day 1.0 fallback). The function fetches all existing records,
                                // recomputes the correct values using the modal's logic, and PATCHes only
                                // records whose values differ. Called after attendance fetch and after
                                // Save/SaveAll to ensure saved records match what the UI tiles show.
                                const normalizeExistingPayrollRecordsForTab = async (tab, { startISO, endISO }) => {
                                  try {
                                    if (!tab || !startISO || !endISO) return;
                                    const source = tab === 'mf' ? 'mf' : 'payroll';
                                    const vr = validateDateRangeTaipei(startISO, endISO);
                                    if (!vr.ok) return;
                                    const si = vr.startISO;
                                    const ei = vr.endISO;
                                    const rawAttendance = tab === 'mf'
                                      ? (rawMfAttendanceData || [])
                                      : (rawPayrollAttendanceData || []);
                                    if (!Array.isArray(rawAttendance) || rawAttendance.length === 0) return;
                                    const params = new URLSearchParams({ start_date: si, end_date: ei, source });
                                    const resp = await axiosInstance.get(`/payroll/records?${params.toString()}`);
                                    const records = Array.isArray(resp.data) ? resp.data : [];
                                    if (records.length === 0) return;
                                    const toNum = (v) => {
                                      const n = parseFloat(v);
                                      return Number.isFinite(n) ? n : 0;
                                    };
                                    const rounded = (n, d = 4) => {
                                      if (!Number.isFinite(n)) return 0;
                                      return Math.round(n * Math.pow(10, d)) / Math.pow(10, d);
                                    };
                                    let patched = 0;
                                    for (const rec of records) {
                                      if (!rec?.employee_id || !rec?.id) continue;
                                      const computed = computeRawPresenceAbsenceForEmployee({
                                        tab,
                                        employeeId: rec.employee_id,
                                        startISO: si,
                                        endISO: ei,
                                        rawAttendance,
                                        peList: payrollEmployees || []
                                      });
                                      const savedPresent = rounded(toNum(rec.days_present));
                                      const savedAbsent = rounded(toNum(rec.days_absent));
                                      const savedHalf = rounded(toNum(rec.half_days_present));
                                      const comPresent = rounded(computed.days_present);
                                      const comAbsent = rounded(computed.days_absent);
                                      const comHalf = rounded(computed.half_days_present);
                                      const savedAbsenceDed = rounded(toNum(rec.absence_deduction));
                                      const dailyRate = toNum(rec.daily_rate);
                                      const newAbsenceDed = comAbsent * dailyRate;
                                      const comAbsenceDed = rounded(newAbsenceDed);
                                      if (savedPresent === comPresent && savedAbsent === comAbsent && savedHalf === comHalf && savedAbsenceDed === comAbsenceDed) continue;

                                      const halfMonth = tab === 'mf'
                                        ? ((toNum(rec.deduction_settings?.breakdown?.income?.half_month_salary)) || toNum(rec.half_month_salary) || 0)
                                        : (toNum(rec.half_month_salary) || 0);
                                      const lateDed = toNum(rec.tardiness_deduction);
                                      const underDed = toNum(rec.undertime_deduction);
                                      const newBasic = Math.max(0, halfMonth - newAbsenceDed - lateDed - underDed);
                                      const patch = {
                                        working_days: computed.working_days,
                                        days_present: computed.days_present,
                                        days_absent: computed.days_absent,
                                        half_days_present: computed.half_days_present,
                                        absence_deduction: newAbsenceDed,
                                        basic_salary: newBasic
                                      };

                                      const addIncomeTotal = toNum(rec.deduction_settings?.breakdown?.income?.total);
                                      let newGross;
                                      if (tab !== 'mf') {
                                        newGross = newBasic + addIncomeTotal;
                                      } else {
                                        newGross = newBasic + addIncomeTotal;
                                      }
                                      patch.gross_salary = newGross;

                                      const savedTotalDeductions = toNum(rec.total_deductions);
                                      const savedLoanTotal = toNum(rec.loan_breakdown?.total) ||
                                        (() => {
                                          const bd = rec.deduction_settings?.breakdown?.net_pay_breakdown?.loan_breakdown;
                                          if (bd && typeof bd === 'object') {
                                            if (typeof bd.total === 'number') return bd.total;
                                            let s = 0;
                                            for (const k of Object.keys(bd)) {
                                              const v = bd[k];
                                              if (v && typeof v === 'object' && typeof v.amount === 'number') s += v.amount;
                                            }
                                            return s;
                                          }
                                          return 0;
                                        })();
                                      if (tab !== 'mf') {
                                        const savedOtPayAmount = toNum(rec.ot_pay_amount);
                                        const savedHolidayPayAmount = toNum(rec.holiday_pay_amount);
                                        const newNet = Math.max(0, newGross + savedOtPayAmount + savedHolidayPayAmount - savedTotalDeductions - savedLoanTotal);
                                        patch.net_pay = newNet;
                                      } else {
                                        const newNet = Math.max(0, newGross - savedTotalDeductions - savedLoanTotal);
                                        patch.net_pay = newNet;
                                      }

                                      try {
                                        await axiosInstance.patch(
                                          `/payroll/records/${encodeURIComponent(rec.id)}?source=${encodeURIComponent(source)}`,
                                          patch
                                        );
                                        patched++;
                                      } catch (e) { /* noop */ }
                                    }
                                  } catch (e) {
                                    // swallow normalization errors  they must not prevent users from continuing
                                  }
                                };

                                useEffect(() => {
                                  fetchRunningTotalPayroll();
                                }, [payrollAttendanceFilters.start_date, payrollAttendanceFilters.end_date]);

                                useEffect(() => {
                                  if (activeMenuItem !== 'payroll-attendance') return;
                                  if ((payrollPeriod || '').trim()) return;
                                  const f = generateTableTab === 'mf' ? mfAttendanceFilters : payrollAttendanceFilters;
                                  const vr = validateDateRangeTaipei(f.start_date, f.end_date);
                                  if (!vr.ok) return;
                                  const periodStr = derivePayrollPeriodFromRange(vr.startISO, vr.endISO);
                                  if (!periodStr) return;
                                  setPayrollPeriod(periodStr);
                                }, [activeMenuItem, generateTableTab, mfAttendanceFilters.start_date, mfAttendanceFilters.end_date, payrollAttendanceFilters.start_date, payrollAttendanceFilters.end_date, payrollPeriod]);

                                useEffect(() => {
                                  if (activeMenuItem === 'payroll-dashboard') {
                                    fetchRunningTotalPayrollAll();
                                  }
                                }, [activeMenuItem]);

                                const calculatePayrollAttendanceAnalytics = (attendanceRecords, payrollEmployees, filtersOverride) => {
                                  const filtersToUse = filtersOverride || payrollAttendanceFilters;
                                  if (!filtersToUse.start_date || !filtersToUse.end_date) return;
                                  const sNorm = normalizeToISODateTaipei(filtersToUse.start_date);
                                  const eNorm = normalizeToISODateTaipei(filtersToUse.end_date);
                                  let startISO, endISO;
                                  if (sNorm.ok && eNorm.ok) {
                                    startISO = sNorm.value;
                                    endISO = eNorm.value;
                                  } else {
                                    const vr = validateDateRangeTaipei(filtersToUse.start_date, filtersToUse.end_date);
                                    if (!vr.ok) {
                                      const hasBoth = Boolean(filtersToUse.start_date) && Boolean(filtersToUse.end_date);
                                      if (hasBoth) { try { toast.error('Invalid date range format. Required: MM-DD-YYYY. ' + vr.errors.join('; ')); } catch { /* noop */ } }
                                      return;
                                    }
                                    startISO = vr.startISO;
                                    endISO = vr.endISO;
                                  }
                                  const startDate = new Date(startISO + 'T00:00:00+08:00');
                                  const endDate = new Date(endISO + 'T00:00:00+08:00');
                                  
                                  // Calculate working days (excluding weekends)
                                  let workingDays = 0;
                                  let currentDate = new Date(startDate);
                                  while (currentDate <= endDate) {
                                    const dayOfWeek = taipeiDayOfWeek(currentDate);
                                    if (dayOfWeek !== 0 && dayOfWeek !== 6) { // Not Sunday (0) or Saturday (6)
                                      workingDays++;
                                    }
                                    currentDate.setDate(currentDate.getDate() + 1);
                                  }

                                  // Calculate total late and undertime minutes, and cross-check against raw records
                                  let totalMinutesLate = 0;
                                  let totalMinutesUndertime = 0;
                                  let totalRecalcLate = 0;
                                  let totalRecalcUndertime = 0;
                                  const discrepancies = [];
                                  const GRACE_MINUTES = 0;
                                  attendanceRecords.forEach(record => {
                                    // Skip records outside the selected date range for analytics
                                    try {
                                      const recordDateISO = toTaipeiISODate(record.timestamp);
                                      if (recordDateISO < startISO || recordDateISO > endISO) {
                                        return;
                                      }
                                    } catch (e) { /* noop */ }

                                    if (record.late_minutes > 0) totalMinutesLate += record.late_minutes;
                                    if (record.undertime_minutes > 0) totalMinutesUndertime += record.undertime_minutes;
                                  });
                                  
                                  console.log(`Total late minutes (final): ${totalMinutesLate}`);
                                  console.log(`Total undertime minutes (final): ${totalMinutesUndertime}`);

                                  // Group records by employee and date
                                  const employeeAttendance = {};
                                  
                                  console.log('Processing attendance records:', attendanceRecords.length);
                                  
                                  attendanceRecords.forEach(record => {
                                    const ts = record.timestamp;
                                    const recordDate = ts ? toTaipeiISODate(ts) : null;
                                    const employeeId = record.user_id;
                                    
                                    console.log(`Processing record: ${record.user_name} - ${recordDate} - ${record.type}`);
                                    
                                    if (!recordDate) {
                                      console.warn(`Skipping record with missing date: ${record.id}`);
                                      return;
                                    }
                                    
                                    if (!employeeAttendance[employeeId]) {
                                      employeeAttendance[employeeId] = {};
                                    }
                                    
                                    if (!employeeAttendance[employeeId][recordDate]) {
                                      employeeAttendance[employeeId][recordDate] = {
                                        present: false,
                                        has_time_in: false,
                                        has_time_out: false,
                                        is_half_day: false,
                                        half_day_reason: '',
                                        time_in_timestamp: null,
                                        time_out_timestamp: null,
                                        late_minutes: 0,
                                        undertime_minutes: 0
                                      };
                                    }
                                    
                                    // Mark as present if there's a time_in record
                                    if (record.type === 'time_in') {
                                      employeeAttendance[employeeId][recordDate].present = true;
                                      employeeAttendance[employeeId][recordDate].has_time_in = true;
                                      employeeAttendance[employeeId][recordDate].time_in_timestamp = record.timestamp;
                                      console.log(`Marked ${record.user_name} present on ${recordDate}`);
                                      
                                      // Store late minutes
                                      if (record.late_minutes > 0) {
                                        employeeAttendance[employeeId][recordDate].late_minutes = record.late_minutes;
                                      }
                                    }
                                    
                                    // Store undertime minutes
                                    if (record.type === 'time_out' && record.undertime_minutes > 0) {
                                      employeeAttendance[employeeId][recordDate].undertime_minutes = record.undertime_minutes;
                                    }
                                    if (record.type === 'time_out') {
                                      employeeAttendance[employeeId][recordDate].has_time_out = true;
                                      employeeAttendance[employeeId][recordDate].time_out_timestamp = record.timestamp;
                                    }
                                    
                                    // Check for half day based on time rules
                                    const halfDayStatus = detectHalfDayStatus(
                                      employeeAttendance[employeeId][recordDate].time_in_timestamp,
                                      employeeAttendance[employeeId][recordDate].time_out_timestamp
                                    );
                                    employeeAttendance[employeeId][recordDate].is_half_day = halfDayStatus.isHalfDay;
                                    employeeAttendance[employeeId][recordDate].half_day_reason = halfDayStatus.reason;
                                  });

                                  // Calculate analytics - employee-specific when filtered, all employees when not filtered
                                  let totalDaysPresent = 0; // full days + 0.5 for half days
                                  let totalDaysAbsent = 0;  // full missing days
                                  let totalHalfDays = 0;    // count of half days
                                  let totalGrossPay = 0;
                                  let employeeDailyRate = 0;
                                  
                                  if (filtersToUse.name.trim() || selectedPayslipEmployee) {
                                    // Employee-specific calculation when filter is applied
                                    let filteredEmployee = selectedPayslipEmployee ?
                                      payrollEmployees.find(emp => emp.employee_id === (selectedPayslipEmployee.employee_id || selectedPayslipEmployee.id)) :
                                      payrollEmployees.find(emp => 
                                        emp.full_name?.toLowerCase().includes(filtersToUse.name.toLowerCase()) ||
                                        emp.employee_id?.toLowerCase().includes(filtersToUse.name.toLowerCase())
                                      );
                                    
                                    // Fallback: If filtered employee not found but records exist, try to find by user_id from records
                                    if (!filteredEmployee && attendanceRecords.length > 0) {
                                      const fallbackId = attendanceRecords[0].user_id;
                                      filteredEmployee = payrollEmployees.find(emp => String(emp.employee_id) === String(fallbackId));
                                    }

                                    if (filteredEmployee) {
                                      const basicSalary = parseFloat(filteredEmployee.salary) || 0;
                                      if (parseFloat(filteredEmployee.daily_rate) > 0) {
                                        employeeDailyRate = parseFloat(filteredEmployee.daily_rate);
                                      } else if (filteredEmployee.daily_rate_formula || filteredEmployee.rate_formula || filteredEmployee.dailyRateFormula) {
                                        const basis = filteredEmployee.daily_rate_formula || filteredEmployee.rate_formula || filteredEmployee.dailyRateFormula;
                                        employeeDailyRate = computeDailyRateFromBasis(basicSalary, basis);
                                      } else {
                                        employeeDailyRate = computeDailyRateFromBasis(basicSalary, 313);
                                      }
                                      
                                      // Calculate only for the filtered employee
                                      const employeeId = filteredEmployee.employee_id;
                                      const employeeDates = employeeAttendance[employeeId] || {};
                                      const basis = filteredEmployee.daily_rate_formula || filteredEmployee.rate_formula || filteredEmployee.dailyRateFormula;
                                      const isSixDay = String(basis) === '313' || basis === 313;
                                      const credits = computeEmployeeDayCreditsWithOverrides({
                                        startISO,
                                        endISO,
                                        isSixDay,
                                        employeeId,
                                        employeeDates,
                                        holidayRows: holidays,
                                        saturdayOverrides
                                      }) || {};
                                      // Compute working days for this employee (6-day vs 5-day basis)
                                      let workingDaysEmp = countWorkingDaysMinusHolidays({
                                        startISO,
                                        endISO,
                                        isSixDay,
                                        holidayRows: holidays
                                      });
                                      // Count Days Present / Absent directly from `credits` map.
                                      // computeEmployeeDayCreditsWithOverrides already correctly returns:
                                      //   1.0 for full punches (non half-day)
                                      //   0.5 for half-days
                                      //   1.0 for SATURDAYS auto-presented via sandwich rule (even with NO punches)
                                      //   1.0 for holidays sandwiched as present
                                      // A previous extra `recordedDateSet.has(iso)` guard was WRONGLY excluding
                                      // auto-presented Saturdays/holidays that had no time punches, making the
                                      // days_absent count in analytics too high vs the Payslip Calculation
                                      // Summary modal and the Employee Payslip dialog.
                                      let halfDays = 0;
                                      let presentDays = 0;
                                      Object.entries(credits).forEach(([iso, credit]) => {
                                        if (credit === 1) presentDays += 1;
                                        else if (credit === 0.5) { presentDays += 0.5; halfDays += 1; }
                                      });
                                      totalHalfDays = halfDays;
                                      totalDaysPresent = presentDays;
                                      totalDaysAbsent = Math.max(0, workingDaysEmp - presentDays);
                                      // Use employee-specific working day count for analytics display
                                      workingDays = workingDaysEmp;
                                      
                                      // Calculate late/undertime minutes for this specific employee only
                                      // Use the actual attendance records instead of grouped structure
                                      let employeeMinutesLate = 0;
                                      let employeeMinutesUndertime = 0;
                                      
                                      attendanceRecords.forEach(record => {
                                        if (String(record.user_id) === String(employeeId)) {
                                          const ts = record.timestamp;
                                          const rDate = (() => {
                                            if (!ts) return null;
                                            const d = typeof ts === 'string' && (ts.includes('+') || ts.endsWith('Z')) ? new Date(ts) : new Date(String(ts) + 'Z');
                                            return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
                                          })();
                                          
                                          // Check if this date is marked as half day
                                          const isHalfDay = employeeAttendance[employeeId]?.[rDate]?.is_half_day;

                                          // Use pre-calculated values if available (these now include half-day logic)
                                          if (record.late_minutes !== undefined) {
                                            employeeMinutesLate += record.late_minutes;
                                          } else {
                                            // Fallback calculation if missing
                                            const hrisEmployee = employees.find(e => String(e.id) === String(employeeId) || String(e.employee_id) === String(employeeId));
                                            const scheduleId = hrisEmployee?.schedule_id;
                                            const sched = schedules.find(s => String(s.id) === String(scheduleId));
                                            if (sched) {
                                                const recalc = computeAttendanceStatus(record.timestamp, sched.start_time, sched.end_time, record.type, 0);
                                                let fallbackLate = recalc.lateMinutes || 0;
                                                if (isHalfDay) {
                                                  const reason = employeeAttendance[employeeId]?.[rDate]?.half_day_reason;
                                                  const adjusted = adjustHalfDayPenalties({ ...record, late_minutes: fallbackLate }, reason);
                                                  fallbackLate = adjusted.late;
                                                }
                                                employeeMinutesLate += fallbackLate;
                                            }
                                          }

                                          if (record.undertime_minutes !== undefined) {
                                            employeeMinutesUndertime += record.undertime_minutes;
                                          } else {
                                             // Fallback calculation if missing
                                            const hrisEmployee = employees.find(e => String(e.id) === String(employeeId) || String(e.employee_id) === String(employeeId));
                                            const scheduleId = hrisEmployee?.schedule_id;
                                            const sched = schedules.find(s => String(s.id) === String(scheduleId));
                                            if (sched) {
                                                const recalc = computeAttendanceStatus(record.timestamp, sched.start_time, sched.end_time, record.type, 0);
                                                let fallbackUnder = recalc.undertimeMinutes || 0;
                                                if (isHalfDay) {
                                                  const reason = employeeAttendance[employeeId]?.[rDate]?.half_day_reason;
                                                  const adjusted = adjustHalfDayPenalties({ ...record, undertime_minutes: fallbackUnder }, reason);
                                                  fallbackUnder = adjusted.undertime;
                                                }
                                                employeeMinutesUndertime += fallbackUnder;
                                            }
                                          }
                                        }
                                      });
                                      
                                      // Override totals with employee-specific values when filtered
                                      totalMinutesLate = employeeMinutesLate;
                                      totalMinutesUndertime = employeeMinutesUndertime;
                                      
                                      // Calculate total gross pay with deductions
                                      // Start with half month salary
                                      const halfMonthSalary = basicSalary / 2;
                                      
                                      // Deduct absences
                                      const absenceDeduction = (totalDaysAbsent * employeeDailyRate);
                                      
                                      // Deduct late minutes: late_minutes x (daily_rate / 8 / 60)
                                      const lateDeduction = totalMinutesLate * (employeeDailyRate / 8 / 60);
                                      
                                      // Deduct undertime minutes: undertime_minutes x (daily_rate / 8 / 60)
                                      const undertimeDeduction = totalMinutesUndertime * (employeeDailyRate / 8 / 60);
                                      
                                      // Calculate additional income
                                      const additionalIncomeTotal = (Array.isArray(additionalIncome) ? additionalIncome : []).reduce((sum, inc) => {
                                        const unit = inc.unit || 'minutes';
                                        if (unit === 'amount') return sum + (parseFloat(inc.amount) || 0);
                                        if (unit === 'days') return sum + ((parseFloat(inc.days) || 0) * employeeDailyRate);
                                        return sum + ((employeeDailyRate / 8 / 60) * (parseFloat(inc.minutes) || 0));
                                      }, 0);

                                      // Total Gross = Half Month Salary - Absences - Late - Undertime + Additional Income
                                      totalGrossPay = halfMonthSalary - absenceDeduction - lateDeduction - undertimeDeduction + additionalIncomeTotal;
                                      
                                      console.log(`Employee-specific calculation for ${filteredEmployee.full_name}:`);
                                      console.log(`- Basic salary: \u20b1${basicSalary.toFixed(2)}`);
                                      console.log(`- Half month salary: \u20b1${halfMonthSalary.toFixed(2)}`);
                                      console.log(`- Daily rate: \u20b1${employeeDailyRate.toFixed(2)}`);
                                      console.log(`- Present days: ${totalDaysPresent}`);
                                      console.log(`- Absent days: ${totalDaysAbsent}`);
                                      console.log(`- Working days in range: ${workingDays}`);
                                      console.log(`- Late minutes: ${totalMinutesLate}`);
                                      console.log(`- Undertime minutes: ${totalMinutesUndertime}`);
                                      console.log(`- Absence deduction: \u20b1${absenceDeduction.toFixed(2)}`);
                                      console.log(`- Late deduction: \u20b1${lateDeduction.toFixed(2)}`);
                                      console.log(`- Undertime deduction: \u20b1${undertimeDeduction.toFixed(2)}`);
                                      console.log(`- Total gross pay: \u20b1${totalGrossPay.toFixed(2)}`);
                                    }
                                  } else {
                                    // All employees calculation when no filter is applied
                                    (Array.isArray(payrollEmployees) ? payrollEmployees : []).forEach((empObj) => {
                                      const employeeId = empObj?.employee_id;
                                      if (!employeeId) return;
                                      const employeeDates = employeeAttendance[employeeId] || {};
                                      const basis = empObj?.daily_rate_formula || empObj?.rate_formula || empObj?.dailyRateFormula;
                                      const isSixDay = String(basis) === '313' || basis === 313;

                                      const credits = computeEmployeeDayCreditsWithOverrides({
                                        startISO,
                                        endISO,
                                        isSixDay,
                                        employeeId,
                                        employeeDates,
                                        holidayRows: holidays,
                                        saturdayOverrides
                                      });
                                      // Compute per-employee working days (5 vs 6-day basis)
                                      let workingDaysEmp = countWorkingDaysMinusHolidays({
                                        startISO,
                                        endISO,
                                        isSixDay,
                                        holidayRows: holidays
                                      });
                                      // Count per-employee present / absent from credits map directly.
                                      // computeEmployeeDayCreditsWithOverrides already contains the correct
                                      // Saturday/holiday auto-present entries (credit 1.0) on dates where no
                                      // actual time punches exist, so we must NOT restrict to recordedDateSet.
                                      let presentDaysEmp = 0;
                                      let halfDaysEmp = 0;
                                      Object.entries(credits || {}).forEach(([iso, credit]) => {
                                        if (credit === 1) presentDaysEmp += 1;
                                        else if (credit === 0.5) { presentDaysEmp += 0.5; halfDaysEmp += 1; }
                                      });

                                      totalDaysPresent += presentDaysEmp;
                                      totalHalfDays += halfDaysEmp;
                                      totalDaysAbsent += Math.max(0, workingDaysEmp - presentDaysEmp);
                                    });
                                  }

                                  setPayrollAttendanceAnalytics({
                                    total_employees: payrollEmployees.length,
                                    days_present: totalDaysPresent,
                                    days_absent: totalDaysAbsent,
                                    half_days_present: totalHalfDays,
                                    total_minutes_late: totalMinutesLate,
                                    total_minutes_undertime: totalMinutesUndertime,
                                    working_days: workingDays,
                                    total_gross_pay: totalGrossPay,
                                    daily_rate: employeeDailyRate
                                  });
                                };

                                const calculateMfAttendanceAnalytics = (attendanceRecords, filtersOverride) => {
                                  const filtersToUse = filtersOverride || mfAttendanceFilters;
                                  if (!filtersToUse.start_date || !filtersToUse.end_date) return;
                                  const sNorm = normalizeToISODateTaipei(filtersToUse.start_date);
                                  const eNorm = normalizeToISODateTaipei(filtersToUse.end_date);
                                  let startISO, endISO;
                                  if (sNorm.ok && eNorm.ok) {
                                    startISO = sNorm.value;
                                    endISO = eNorm.value;
                                  } else {
                                    const vr = validateDateRangeTaipei(filtersToUse.start_date, filtersToUse.end_date);
                                    if (!vr.ok) return;
                                    startISO = vr.startISO;
                                    endISO = vr.endISO;
                                  }
                                  const startDate = new Date(startISO + 'T00:00:00+08:00');
                                  const endDate = new Date(endISO + 'T00:00:00+08:00');

                                  let workingDays = 0;
                                  let d = new Date(startDate);
                                  while (d <= endDate) { const dow = taipeiDayOfWeek(d); if (dow !== 0 && dow !== 6) workingDays++; d.setDate(d.getDate() + 1); }

                                  let totalMinutesLate = 0;
                                  let totalMinutesUndertime = 0;
                                  const GRACE_MINUTES = 0;
                                  attendanceRecords.forEach(record => {
                                    // Skip records outside the selected date range for analytics
                                    try {
                                      const recordDateISO = toTaipeiISODate(record.timestamp);
                                      if (recordDateISO < startISO || recordDateISO > endISO) {
                                        return;
                                      }
                                    } catch (e) { /* noop */ }

                                    // Use pre-calculated values if available (from fetchMfAttendanceData)
                                    if (record.late_minutes !== undefined || record.undertime_minutes !== undefined) {
                                      totalMinutesLate += record.late_minutes || 0;
                                      totalMinutesUndertime += record.undertime_minutes || 0;
                                    } else {
                                      // Fallback to recalculation if pre-calculated values not present
                                      const emp = employees.find(e => String(e.id) === String(record.user_id) || String(e.employee_id) === String(record.user_id));
                                      const scheduleId = emp?.schedule_id;
                                      const branchSchedule = schedules.find(s => String(s.id) === String(scheduleId));
                                      if (!branchSchedule) return;
                                      const recalc = computeAttendanceStatus(record.timestamp, branchSchedule?.start_time, branchSchedule?.end_time, record.type, GRACE_MINUTES);
                                      totalMinutesLate += recalc.lateMinutes || 0;
                                      totalMinutesUndertime += recalc.undertimeMinutes || 0;
                                    }
                                  });

                                  const employeeAttendance = {};
                                  attendanceRecords.forEach(record => {
                                    const ts = record.timestamp;
                                    const recordDate = (() => {
                                      if (!ts) return null;
                                      const d2 = typeof ts === 'string' && (ts.includes('+') || ts.endsWith('Z')) ? new Date(ts) : new Date(String(ts) + 'Z');
                                      return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' }).format(d2);
                                    })();
                                    const employeeId = record.user_id;
                                    if (!recordDate) return;
                                    if (!employeeAttendance[employeeId]) employeeAttendance[employeeId] = {};
                                    if (!employeeAttendance[employeeId][recordDate]) employeeAttendance[employeeId][recordDate] = { present: false, has_time_in: false, has_time_out: false };
                                    if (record.type === 'time_in') { employeeAttendance[employeeId][recordDate].present = true; employeeAttendance[employeeId][recordDate].has_time_in = true; }
                                    if (record.type === 'time_out') employeeAttendance[employeeId][recordDate].has_time_out = true;
                                  });

                                  let totalDaysPresent = 0;
                                  let totalHalfDays = 0;
                                  let totalDaysAbsent = 0;

                                  // If MF is filtered by employee, apply 313/261 workweek to workingDays
                                  if (filtersToUse.name.trim() || mfSelectedPayslipEmployee) {
                                    // Resolve filtered employee robustly via HRIS list first, then payroll list
                                    const hrMatch = mfSelectedPayslipEmployee || employees.find(emp =>
                                      emp.full_name?.toLowerCase().includes(filtersToUse.name.toLowerCase()) ||
                                      emp.employee_id?.toLowerCase().includes(filtersToUse.name.toLowerCase())
                                    );

                                    const filteredEmployee = (hrMatch
                                      ? payrollEmployees.find(pe => pe.employee_id === (hrMatch.employee_id || hrMatch.id))
                                      : null) || payrollEmployees.find(emp =>
                                        emp.full_name?.toLowerCase().includes(filtersToUse.name.toLowerCase()) ||
                                        emp.employee_id?.toLowerCase().includes(filtersToUse.name.toLowerCase())
                                      );

                                    if (filteredEmployee) {
                                      const basis = filteredEmployee.daily_rate_formula || filteredEmployee.rate_formula || filteredEmployee.dailyRateFormula;
                                      const isSixDay = String(basis) === '313' || basis === 313;

                                      // Employee-specific working days
                                      let workingDaysEmp = countWorkingDaysMinusHolidays({
                                        startISO,
                                        endISO,
                                        isSixDay,
                                        holidayRows: holidays
                                      });
                                      workingDays = workingDaysEmp;

                                      // Present/Absent for this employee
                                      const employeeId = filteredEmployee.employee_id;
                                      const employeeDates = employeeAttendance[employeeId] || {};
                                      const credits = computeEmployeeDayCreditsWithOverrides({
                                        startISO,
                                        endISO,
                                        isSixDay,
                                        employeeId,
                                        employeeDates,
                                        holidayRows: holidays,
                                        saturdayOverrides
                                      });
                                      // Count directly from credits map (includes auto-Saturdays, holidays)
                                      let halfDays = 0;
                                      let presentDays = 0;
                                      Object.entries(credits || {}).forEach(([iso, credit]) => {
                                        if (credit === 1) presentDays += 1;
                                        else if (credit === 0.5) { presentDays += 0.5; halfDays += 1; }
                                      });
                                      totalHalfDays = halfDays;
                                      totalDaysPresent = presentDays;
                                      totalDaysAbsent = Math.max(0, workingDaysEmp - presentDays);
                                    }
                                  } else {
                                    (Array.isArray(payrollEmployees) ? payrollEmployees : []).forEach((empObj) => {
                                      const employeeId = empObj?.employee_id;
                                      if (!employeeId) return;
                                      const employeeDates = employeeAttendance[employeeId] || {};
                                      const basis = empObj?.daily_rate_formula || empObj?.rate_formula || empObj?.dailyRateFormula;
                                      const isSixDay = String(basis) === '313' || basis === 313;

                                      const credits = computeEmployeeDayCreditsWithOverrides({
                                        startISO,
                                        endISO,
                                        isSixDay,
                                        employeeId,
                                        employeeDates,
                                        holidayRows: holidays,
                                        saturdayOverrides
                                      });
                                      // Compute per-employee working days (5 vs 6-day basis)
                                      let workingDaysEmp = countWorkingDaysMinusHolidays({
                                        startISO,
                                        endISO,
                                        isSixDay,
                                        holidayRows: holidays
                                      });
                                      // Count per-employee present / absent from credits map directly.
                                      // computeEmployeeDayCreditsWithOverrides already contains the correct
                                      // Saturday/holiday auto-present entries (credit 1.0) on dates where no
                                      // actual time punches exist, so we must NOT restrict to recordedDateSet.
                                      let presentDaysEmp = 0;
                                      let halfDaysEmp = 0;
                                      Object.entries(credits || {}).forEach(([iso, credit]) => {
                                        if (credit === 1) presentDaysEmp += 1;
                                        else if (credit === 0.5) { presentDaysEmp += 0.5; halfDaysEmp += 1; }
                                      });

                                      totalDaysPresent += presentDaysEmp;
                                      totalHalfDays += halfDaysEmp;
                                      totalDaysAbsent += Math.max(0, workingDaysEmp - presentDaysEmp);
                                    });
                                  }

                                  setMfAttendanceAnalytics({
                                    total_employees: payrollEmployees.length,
                                    days_present: totalDaysPresent,
                                    days_absent: totalDaysAbsent,
                                    half_days_present: totalHalfDays,
                                    total_minutes_late: totalMinutesLate,
                                    total_minutes_undertime: totalMinutesUndertime,
                                    working_days: workingDays,
                                    total_gross_pay: 0,
                                    daily_rate: 0
                                  });
                                };

                                // Recalculate MF Analytics when overrides change
                                useEffect(() => {
                                  if (mfAttendanceData.length > 0) {
                                    calculateMfAttendanceAnalytics(mfAttendanceData);
                                  }
                                }, [saturdayOverrides, mfAttendanceData, payrollEmployees, schedules, mfAttendanceFilters]);

                                const handleCreatePayrollEmployee = async () => {
                                  if (!selectedHRISEmployee) {
                                    toast.error('Please select an employee first');
                                    return;
                                  }

                                  if (!payrollData.salary) {
                                    toast.error('Please enter salary amount');
                                    return;
                                  }

                                  try {
                                    const createData = {
                                      employee_id: selectedHRISEmployee.id || selectedHRISEmployee.employee_id || selectedHRISEmployee.email,
                                      salary: parseFloat(payrollData.salary),
                                      is_minimum_wage: payrollData.is_minimum_wage,
                                      tax_enabled: payrollData.tax_enabled,
                                      leave_credits: parseInt(payrollData.leave_credits) || 0,
                                      tin_number: payrollData.tin_number || '',
                                      sss_number: payrollData.sss_number || '',
                                      phic_number: payrollData.phic_number || '',
                                      hdmf_number: payrollData.hdmf_number || '',
                                      allowances: {
                                        mf: parseFloat(payrollData.allowances.mf) || 0,
                                        gas_allowance: parseFloat(payrollData.allowances.gas_allowance) || 0,
                                        load_allowance: parseFloat(payrollData.allowances.load_allowance) || 0,
                                        housing_allowance: parseFloat(payrollData.allowances.housing_allowance) || 0
                                      },
                                      deductions: {
                                        sss: !!payrollData.deductions.sss,
                                        phic: !!payrollData.deductions.phic,
                                        hdmf: !!payrollData.deductions.hdmf,
                                        hdmf_additional: parseFloat(payrollData.deductions.hdmf_additional) || 0
                                      }
                                    };
                                    if (dailyRateFormula) {
                                      const computedRate = computeDailyRateFromBasis(payrollData.salary, dailyRateFormula);
                                      createData.daily_rate = computedRate;
                                      createData.daily_rate_formula = dailyRateFormula;
                                      createData.work_days = dailyRateFormula === '313' ? [1,2,3,4,5,6] : [1,2,3,4,5];
                                    }

                                    try {
                                      await axiosInstance.post('/payroll/employees', createData);
                                    } catch (err) {
                                      const status = err?.response?.status;
                                      const detail = String(err?.response?.data?.detail || err?.message || 'Unknown error');
                                      console.error('Create payroll employee failed:', { status, detail, payload: createData });
                                      let helpful = null;
                                      if (status === 404 && detail.toLowerCase().includes('hris employee not found')) {
                                        helpful = 'Selected HRIS employee was not found. Pick an employee from HRIS search list.';
                                      } else if (status === 403 && detail.toLowerCase().includes('payroll access permission required')) {
                                        helpful = 'You do not have Payroll Access. Enable it in Settings for your admin account.';
                                      } else if (status === 403 && detail.toLowerCase().includes('admin access required')) {
                                        helpful = 'Admin access required to register payroll employees.';
                                      }
                                      toast.error(helpful || detail || 'Failed to register employee for payroll');
                                      return;
                                    }
                                    
                                    toast.success('Employee registered for payroll successfully!');
                                    
                                    // Reset form
                                    setSelectedHRISEmployee(null);
                                    setSearchEmployeeQuery('');
                                    setDailyRateFormula(null);
                                    setCalculatedDailyRate(0);
                                    setPayrollData({
                                      employee_id: '',
                                      salary: '',
                                      is_minimum_wage: false,
                                      tax_enabled: true, // Reset to default (enabled)
                                      leave_credits: '',
                                      tin_number: '',
                                      sss_number: '',
                                      phic_number: '',
                                      hdmf_number: '',
                                      allowances: { mf: '', gas_allowance: '', load_allowance: '', housing_allowance: '' },
                                      deductions: { sss: false, phic: false, hdmf: false, hdmf_additional: '' }
                                    });

                                    // Refresh payroll data
                                    await fetchPayrollEmployees();
                                    await fetchPayrollStats();
                                    
                                  } catch (error) {
                                    const status = error?.response?.status;
                                    const detail = error?.response?.data?.detail || error?.message || 'Unknown error';
                                    console.error('Error creating payroll employee:', { status, detail });
                                    toast.error(error.response?.data?.detail || 'Failed to register employee for payroll');
                                  }
                                };

                                const handleEditPayrollEmployee = (employee) => {
                                  setEditingPayrollEmployee(employee);
                                  setPayrollData({
                                    employee_id: employee.employee_id,
                                    salary: employee.salary.toString(),
                                    is_minimum_wage: employee.is_minimum_wage,
                                    tax_enabled: employee.tax_enabled || true,
                                    leave_credits: employee.leave_credits.toString(),
                                    tin_number: employee.tin_number || '',
                                    sss_number: employee.sss_number || '',
                                    phic_number: employee.phic_number || '',
                                    hdmf_number: employee.hdmf_number || '',
                                    allowances: employee.allowances,
                                    deductions: {
                                      sss: !!(employee.deductions?.sss),
                                      phic: !!(employee.deductions?.phic),
                                      hdmf: !!(employee.deductions?.hdmf),
                                      hdmf_additional: (employee.deductions?.hdmf_additional ?? '')
                                    }
                                  });
                                  setDailyRateFormula(employee.daily_rate_formula || null);
                                  setCalculatedDailyRate(employee.daily_rate || 0);
                                  setIsEditPayrollDialogOpen(true);
                                };

                                const handleUpdatePayrollEmployee = async (e) => {
                                  e.preventDefault();
                                  
                                  if (!editingPayrollEmployee) {
                                    toast.error('No employee selected for editing');
                                    return;
                                  }

                                  try {
                                    const updateData = {
                                      salary: parseFloat(payrollData.salary),
                                      is_minimum_wage: payrollData.is_minimum_wage,
                                      tax_enabled: payrollData.tax_enabled,
                                      leave_credits: parseInt(payrollData.leave_credits) || 0,
                                      tin_number: payrollData.tin_number || '',
                                      sss_number: payrollData.sss_number || '',
                                      phic_number: payrollData.phic_number || '',
                                      hdmf_number: payrollData.hdmf_number || '',
                                      allowances: {
                                        mf: parseFloat(payrollData.allowances.mf) || 0,
                                        gas_allowance: parseFloat(payrollData.allowances.gas_allowance) || 0,
                                        load_allowance: parseFloat(payrollData.allowances.load_allowance) || 0,
                                        housing_allowance: parseFloat(payrollData.allowances.housing_allowance) || 0
                                      },
                                      deductions: {
                                        sss: !!payrollData.deductions.sss,
                                        phic: !!payrollData.deductions.phic,
                                        hdmf: !!payrollData.deductions.hdmf,
                                        hdmf_additional: parseFloat(payrollData.deductions.hdmf_additional) || 0
                                      }
                                    };
                                    if (dailyRateFormula) {
                                      const computedRate = computeDailyRateFromBasis(payrollData.salary, dailyRateFormula);
                                      updateData.daily_rate = computedRate;
                                      updateData.daily_rate_formula = dailyRateFormula;
                                      updateData.work_days = dailyRateFormula === '313' ? [1,2,3,4,5,6] : [1,2,3,4,5];
                                    }

                                    await axiosInstance.put(`/payroll/employees/${editingPayrollEmployee.id}`, updateData);
                                    
                                    toast.success('Payroll employee updated successfully!');
                                    setIsEditPayrollDialogOpen(false);
                                    setEditingPayrollEmployee(null);
                                    await fetchPayrollEmployees();
                                    
                                    // Reset form
                                    setPayrollData({
                                      employee_id: '',
                                      salary: '',
                                      is_minimum_wage: false,
                                      tax_enabled: true,
                                      leave_credits: '',
                                      tin_number: '',
                                      sss_number: '',
                                      phic_number: '',
                                      hdmf_number: '',
                                      allowances: { mf: '', gas_allowance: '', load_allowance: '', housing_allowance: '' },
                                      deductions: { sss: false, phic: false, hdmf: false }
                                    });
                                  } catch (error) {
                                    console.error('Error updating payroll employee:', error);
                                    toast.error(error.response?.data?.detail || 'Failed to update payroll employee');
                                  }
                                };

                                const handleDeletePayrollEmployee = async (employee) => {
                                  const confirmed = await confirmDialog({
                                      title: "Delete from Payroll",
                                      description: `Are you sure you want to delete ${employee.full_name} from payroll? This action cannot be undone.`,
                                      variant: "destructive"
                                  });
                                  if (!confirmed) {
                                    return;
                                  }

                                  try {
                                    await axiosInstance.delete(`/payroll/employees/${employee.id}`);
                                    toast.success(`${employee.full_name} has been removed from payroll successfully!`);
                                    fetchPayrollEmployees();
                                  } catch (error) {
                                    console.error('Error deleting payroll employee:', error);
                                    toast.error(error.response?.data?.detail || 'Failed to delete payroll employee');
                                  }
                                };

                                // Apply filters to attendance data
                                const applyFilters = () => {
                                  let filtered = [...attendance];

                                  if (reportFilters.startDate || reportFilters.endDate) {
                                    filtered = filtered.filter(record => {
                                      let recordDateStr;
                                      if (record.timestamp.includes('+08:00')) {
                                        recordDateStr = record.timestamp.split('T')[0];
                                      } else {
                                        const utcTime = new Date(record.timestamp + 'Z');
                                        const taipeiTime = new Date(utcTime.getTime() + (8 * 60 * 60 * 1000));
                                        recordDateStr = taipeiTime.toISOString().split('T')[0];
                                      }
                                      
                                      const recordDate = recordDateStr;
                                      const startDateFilter = reportFilters.startDate || '1900-01-01';
                                      const endDateFilter = reportFilters.endDate || '2099-12-31';
                                      
                                      return recordDate >= startDateFilter && recordDate <= endDateFilter;
                                    });
                                  }

                                  // Time filtering
                                  if (reportFilters.startTime || reportFilters.endTime) {
                                    filtered = filtered.filter(record => {
                                      let recordTimeStr;
                                      if (record.timestamp.includes('T')) {
                                        recordTimeStr = record.timestamp.split('T')[1].substring(0, 5); // Get HH:MM
                                      } else {
                                        return true; // If no time info, include it
                                      }
                                      
                                      const startTimeFilter = reportFilters.startTime || '00:00';
                                      const endTimeFilter = reportFilters.endTime || '23:59';
                                      
                                      return recordTimeStr >= startTimeFilter && recordTimeStr <= endTimeFilter;
                                    });
                                  }

                                  if (reportFilters.employeeId !== 'all') {
                                    const searchName = reportFilters.employeeId.toLowerCase();
                                    filtered = filtered.filter(record => 
                                      record.user_name && record.user_name.toLowerCase().includes(searchName)
                                    );
                                  }

                                  if (reportFilters.attendanceType !== 'all') {
                                    filtered = filtered.filter(record => record.type === reportFilters.attendanceType);
                                  }

                                  if (reportFilters.branch !== 'all') {
                                    filtered = filtered.filter(record => {
                                      const employee = employees.find(emp => emp.id === record.user_id);
                                      return employee && employee.branch === reportFilters.branch;
                                    });
                                  }

                                  if (reportFilters.status && reportFilters.status !== 'all') {
                                    filtered = filtered.filter(record => record.status === reportFilters.status);
                                  }

                                  setFilteredAttendance(filtered);
                                };

                                // Apply Employee Report Filters
                                const applyEmployeeFilters = () => {
                                  let filtered = [...attendance];

                                  if (employeeReportFilters.startDate || employeeReportFilters.endDate) {
                                    filtered = filtered.filter(record => {
                                      let recordDateStr;
                                      if (record.timestamp.includes('+08:00')) {
                                        recordDateStr = record.timestamp.split('T')[0];
                                      } else {
                                        const utcTime = new Date(record.timestamp + 'Z');
                                        const taipeiTime = new Date(utcTime.getTime() + (8 * 60 * 60 * 1000));
                                        recordDateStr = taipeiTime.toISOString().split('T')[0];
                                      }
                                      
                                      const recordDate = recordDateStr;
                                      const startDateFilter = employeeReportFilters.startDate || '1900-01-01';
                                      const endDateFilter = employeeReportFilters.endDate || '2099-12-31';
                                      
                                      return recordDate >= startDateFilter && recordDate <= endDateFilter;
                                    });
                                  }

                                  if (employeeReportFilters.employeeId !== 'all') {
                                    const searchName = employeeReportFilters.employeeId.toLowerCase();
                                    filtered = filtered.filter(record => 
                                      record.user_name && record.user_name.toLowerCase().includes(searchName)
                                    );
                                  }

                                  setFilteredEmployeeAttendance(filtered);
                                };

                                useEffect(() => {
                                  applyFilters();
                                }, [attendance, reportFilters, employees]);

                                useEffect(() => {
                                  applyEmployeeFilters();
                                }, [attendance, employeeReportFilters, employees]);

                                // CSV Import Handler
                                const handleCSVImport = async () => {
                                  if (!csvFile) {
                                    alert('Please select a CSV file first');
                                    return;
                                  }

                                  setCsvImportProgress('Reading file...');

                                  try {
                                    const text = await csvFile.text();
                                    const lines = text.split(/\r?\n/).filter(line => line.trim());
                                    
                                    if (lines.length < 2) {
                                      alert('CSV file is empty or has no data rows');
                                      setCsvImportProgress('');
                                      return;
                                    }

                                    setCsvImportProgress('Parsing CSV data...');

                                    // Robust CSV line parser (handles quoted commas)
                                    const parseCSVLine = (line) => {
                                      const result = [];
                                      let current = '';
                                      let inQuotes = false;
                                      for (let i = 0; i < line.length; i++) {
                                        const ch = line[i];
                                        if (ch === '"') {
                                          inQuotes = !inQuotes;
                                          continue;
                                        }
                                        if (ch === ',' && !inQuotes) {
                                          result.push(current);
                                          current = '';
                                        } else {
                                          current += ch;
                                        }
                                      }
                                      result.push(current);
                                      return result.map(v => v.trim());
                                    };

                                    const headers = parseCSVLine(lines[0]).map(h => h.trim());
                                    const headerSet = new Set(headers.map(h => h.toLowerCase()));
                                    const recordsRaw = [];
                                    for (let i = 1; i < lines.length; i++) {
                                      const values = parseCSVLine(lines[i]);
                                      const row = {};
                                      headers.forEach((header, index) => {
                                        row[header] = values[index] ?? '';
                                      });
                                      recordsRaw.push(row);
                                    }

                                    // Normalize to backend-expected format
                                    // Backend expects headers: Date, Time, Employee, Branch, Type, Status, Location, Comments
                                    const toBackendRecord = (row) => {
                                      // If using our export headers
                                      if (headerSet.has('date') && headerSet.has('time') && headerSet.has('employee')) {
                                        let timeStr = (row['Time'] || row['time'] || '').trim();
                                        if (/^\d{1,2}:\d{2}(\s*(AM|PM))?$/i.test(timeStr)) {
                                          timeStr = timeStr.replace(/\s+/g, ' ').toUpperCase();
                                          if (/AM|PM$/i.test(timeStr)) {
                                            timeStr = timeStr.replace(/\s*(AM|PM)$/i, ':00 $1');
                                          } else {
                                            timeStr = timeStr + ':00';
                                          }
                                        }
                                        return {
                                          Date: row['Date'] || row['date'],
                                          Time: timeStr,
                                          Employee: row['Employee'] || row['employee'],
                                          Branch: row['Branch'] || row['branch'] || 'N/A',
                                          Type: row['Type'] || row['type'],
                                          Status: row['Status'] || row['status'] || '',
                                          Location: row['Location'] || row['location'] || '',
                                          Comments: row['Comments'] || row['comments'] || ''
                                        };
                                      }
                                      
                                      // If using simplified headers: employee_id, date (YYYY-MM-DD), time (HH:MM[:SS]), type, status
                                      if (headerSet.has('employee_id') && headerSet.has('date') && headerSet.has('time')) {
                                        const emp = employees.find(e => e.employee_id === (row['employee_id'] || row['Employee ID']));
                                        const employeeName = emp?.full_name || (row['employee_name'] || '');
                                        const branch = emp?.branch || 'N/A';
                                        const dateStr = row['date'] || row['Date'];
                                        const timeRaw = (row['time'] || row['Time'] || '').trim();
                                        let hh = 0, mm = 0, ss = 0;
                                        // Parse 24h or with seconds
                                        const parts = timeRaw.split(':');
                                        if (parts.length >= 2) {
                                          hh = parseInt(parts[0], 10) || 0;
                                          mm = parseInt(parts[1], 10) || 0;
                                          ss = parts[2] ? parseInt(parts[2], 10) || 0 : 0;
                                        }
                                        const ampm = hh >= 12 ? 'PM' : 'AM';
                                        const hour12 = hh % 12 === 0 ? 12 : hh % 12;
                                        const timeStr = `${hour12.toString().padStart(2, '0')}:${mm.toString().padStart(2, '0')}:${ss.toString().padStart(2, '0')} ${ampm}`;
                                        const dateObj = new Date(dateStr);
                                        const monthShort = dateObj.toLocaleString('en-US', { month: 'short' });
                                        const day = dateObj.toLocaleString('en-US', { day: '2-digit' });
                                        const year = dateObj.getFullYear();
                                        const datePretty = `${monthShort} ${day}, ${year}`;
                                        const type = (row['type'] || row['Type'] || '').toLowerCase();
                                        const status = (row['status'] || row['Status'] || '').toLowerCase();
                                        return {
                                          Date: datePretty,
                                          Time: timeStr,
                                          Employee: employeeName,
                                          Branch: branch,
                                          Type: type,
                                          Status: status,
                                          Location: '',
                                          Comments: ''
                                        };
                                      }
                                      
                                      // Fallback: Try to map common headers aggressively
                                      const keys = Object.keys(row);
                                      const normalizeKey = (k) => k.toLowerCase().replace(/[^a-z0-9]/g, '');
                                      
                                      const dateKey = keys.find(k => ['date', 'checkindate', 'clockindate'].some(t => normalizeKey(k).includes(t)));
                                      const timeKey = keys.find(k => ['time', 'checkintime', 'clockintime'].some(t => normalizeKey(k).includes(t)));
                                      const empKey = keys.find(k => ['employee', 'name', 'fullname', 'who'].some(t => normalizeKey(k).includes(t)));
                                      
                                      if (dateKey && timeKey && empKey) {
                                        return {
                                          Date: row[dateKey],
                                          Time: row[timeKey],
                                          Employee: row[empKey],
                                          Branch: row[keys.find(k => normalizeKey(k).includes('branch'))] || 'N/A',
                                          Type: row[keys.find(k => normalizeKey(k).includes('type'))] || 'time_in',
                                          Status: row[keys.find(k => normalizeKey(k).includes('status'))] || '',
                                          Location: row[keys.find(k => normalizeKey(k).includes('location'))] || '',
                                          Comments: row[keys.find(k => normalizeKey(k).includes('comment'))] || ''
                                        };
                                      }
                                      
                                      // Unknown header format: pass through as-is to let backend attempt parse
                                      return row;
                                    };

                                    const records = recordsRaw.map(toBackendRecord);
                                    setCsvImportProgress(`Importing ${records.length} records...`);

                                    const response = await axiosInstance.post('/attendance/import', { records });

                                    if (response.status === 200) {
                                      const result = response.data;
                                      let message = `Import completed!\n\nImported: ${result.imported}\nSkipped: ${result.skipped}`;
                                      
                                      if (result.errors && result.errors.length > 0) {
                                        message += `\n\nErrors:\n${result.errors.join('\n')}`;
                                      }
                                      
                                      alert(message);
                                      fetchAttendance(); // Refresh attendance data
                                      setIsImportCSVModalOpen(false);
                                      setCsvFile(null);
                                      setCsvImportProgress('');
                                    }
                                  } catch (error) {
                                    console.error('CSV import error:', error);
                                    alert('Error importing CSV: ' + (error.response?.data?.detail || error.message));
                                    setCsvImportProgress('');
                                  }
                                };

                                // Get employees organized by branches for HRIS Attendance view
                                const getEmployeesByBranch = () => {
                                  const activeEmployees = employees.filter(emp => emp.is_active);
                                  const branches = {};
                                  
                                  activeEmployees.forEach(employee => {
                                    const branch = employee.branch || 'No Branch';
                                    if (!branches[branch]) {
                                      branches[branch] = [];
                                    }
                                    branches[branch].push(employee);
                                  });
                                  
                                  Object.keys(branches).forEach(branch => {
                                    branches[branch].sort((a, b) => a.full_name.localeCompare(b.full_name));
                                  });
                                  
                                  return branches;
                                };

                                // Get employee status (present/absent/completed)
                                const getEmployeeStatus = (employeeId) => {
                                  const today = new Date().toDateString();
                                  const todayRecords = attendance.filter(record => {
                                    const recordDate = new Date(record.timestamp).toDateString();
                                    return record.user_id === employeeId && recordDate === today;
                                  });

                                  const timeInRecords = todayRecords.filter(r => r.type === 'time_in');
                                  const timeOutRecords = todayRecords.filter(r => r.type === 'time_out');

                                  // Absent: No time-in records today (no activity)
                                  if (timeInRecords.length === 0) return 'absent';
                                  
                                  // On Duty: Has at least one time-in (whether they timed out or not)
                                  // 'completed' = has time-in AND time-out
                                  // 'present' = has time-in but no time-out yet
                                  if (timeOutRecords.length > 0) return 'completed';
                                  return 'present';
                                };

                                // Filter employees based on search term
                                const getFilteredEmployees = () => {
                                  let filteredList = employees;

                                  if (employeeSearchTerm) {
                                    const searchLower = employeeSearchTerm.toLowerCase();
                                    filteredList = employees.filter(employee => 
                                      employee.full_name?.toLowerCase().includes(searchLower) ||
                                      employee.email?.toLowerCase().includes(searchLower) ||
                                      employee.employee_id?.toLowerCase().includes(searchLower) ||
                                      employee.branch?.toLowerCase().includes(searchLower) ||
                                      employee.position?.toLowerCase().includes(searchLower) ||
                                      employee.department?.toLowerCase().includes(searchLower)
                                    );
                                  }

                                  // Sort: Active status first, then by Branch, then by Name
                                  return [...filteredList].sort((a, b) => {
                                    // 1. Sort by Status (Active first)
                                    const aActive = a.is_active !== false;
                                    const bActive = b.is_active !== false;
                                    
                                    if (aActive !== bActive) {
                                      return aActive ? -1 : 1;
                                    }

                                    // 2. Sort by Branch
                                    const aBranch = (a.branch || '').toString().toLowerCase();
                                    const bBranch = (b.branch || '').toString().toLowerCase();
                                    
                                    if (aBranch !== bBranch) {
                                      return aBranch.localeCompare(bBranch);
                                    }
                                    
                                    // 3. Sort by Name (fallback)
                                    return (a.full_name || '').toString().toLowerCase().localeCompare((b.full_name || '').toString().toLowerCase());
                                  });
                                };

                                // Get unique branches from employees data
                                const getUniqueBranches = () => {
                                  // Get branches from employees
                                  const empBranches = employees
                                    .map(emp => emp.branch)
                                    .filter(branch => branch && branch.trim() !== '');

                                  // Get branches from schedules (including those with no employees)
                                  const schedBranches = branchSchedules
                                    .map(sched => sched.branch_name)
                                    .filter(branch => branch && branch.trim() !== '');
                                  
                                  const allBranches = [...empBranches, ...schedBranches];
                                  // Deduplicate and sort
                                  return [...new Set(allBranches)].sort();
                                };

                                // Get filtered HRIS employees for new employee modal
                                const filteredHRISEmployees = employees.filter(emp => {
                                  if (!searchEmployeeQuery.trim()) return false;
                                  const query = searchEmployeeQuery.toLowerCase();
                                  return (
                                    emp.full_name?.toLowerCase().includes(query) ||
                                    emp.employee_id?.toLowerCase().includes(query) ||
                                    emp.email?.toLowerCase().includes(query)
                                  );
                                });

                                // Helper function to format timestamp from backend
                                const formatTimestampFromBackend = (timestamp) => {
                                  let timeStr;
                                  
                                  if (timestamp.includes('+08:00')) {
                                    timeStr = timestamp.split('T')[1].split('+')[0];
                                  } else {
                                    const utcTime = new Date(timestamp + 'Z');
                                    const taipeiTime = new Date(utcTime.getTime() + (8 * 60 * 60 * 1000));
                                    timeStr = taipeiTime.toISOString().split('T')[1].split('.')[0];
                                  }
                                  
                                  const [hours, minutes, seconds] = timeStr.split(':');
                                  const hour24 = parseInt(hours);
                                  const hour12 = hour24 === 0 ? 12 : hour24 > 12 ? hour24 - 12 : hour24;
                                  const ampm = hour24 >= 12 ? 'PM' : 'AM';
                                  return `${hour12.toString().padStart(2, '0')}:${minutes}:${seconds} ${ampm}`;
                                };

                                // Helper function to format time as HH:MM (24-hour) from backend timestamp
                                const formatTimeHHMMFromBackend = (timestamp) => {
                                  try {
                                    const d = new Date(normalizeTs(timestamp));
                                    if (isNaN(d)) return timestamp;
                                    return new Intl.DateTimeFormat('en-US', { timeZone: 'Asia/Taipei', hour: '2-digit', minute: '2-digit', hour12: true }).format(d);
                                  } catch {
                                    return timestamp;
                                  }
                                };

                                // Helper function to format date from backend timestamp
                                const formatDateFromBackend = (timestamp) => {
                                  try {
                                    const d = new Date(normalizeTs(timestamp));
                                    if (isNaN(d)) return timestamp;
                                    return new Intl.DateTimeFormat('en-US', { timeZone: 'Asia/Taipei', year: 'numeric', month: 'short', day: 'numeric' }).format(d);
                                  } catch {
                                    return timestamp;
                                  }
                                };

                                // Helper to get branch for attendance record from employees list
                                const getBranchForAttendanceRecord = (record) => {
                                  const emp = employees.find(e => e.id === record.user_id);
                                  return emp && emp.branch ? emp.branch : 'N/A';
                                };

                                // Get today's attendance for dashboard
                                const getTodayAttendance = () => {
                                  const today = new Date().toDateString();
                                  return attendance.filter(record => 
                                    new Date(record.timestamp).toDateString() === today
                                  );
                                };

                                // CRUD Operations for Employees
                                const handleCreateEmployee = async (e) => {
                                  e.preventDefault();
                                  try {
                                    await axiosInstance.post('/users', newEmployee);
                                    toast.success('Employee created successfully!');
                                    setIsCreateDialogOpen(false);
                                    setNewEmployee({
                                      email: '',
                                      password: '',
                                      full_name: '',
                                      employee_id: '',
                                      branch: '',
                                      position: '',
                                      department: ''
                                    });
                                    fetchEmployees();
                                  } catch (error) {
                                    console.error('Error creating employee:', error);
                                    toast.error(error.response?.data?.detail || 'Failed to create employee');
                                  }
                                };

                                const handleUpdateEmployee = async (e) => {
                                  e.preventDefault();
                                  
                                  // Validate password if provided
                                  if (newPassword && newPassword !== confirmPassword) {
                                    toast.error('Passwords do not match');
                                    return;
                                  }
                                  
                                  if (newPassword && newPassword.length < 6) {
                                    toast.error('Password must be at least 6 characters long');
                                    return;
                                  }
                                  
                                  try {
                                    const updateData = { ...selectedEmployee };
                                    
                                    // Only include password if it's being changed
                                    if (newPassword) {
                                      updateData.password = newPassword;
                                    }
                                    
                                    await axiosInstance.put(`/users/${selectedEmployee.id}`, updateData);
                                    toast.success(newPassword ? 'Employee and password updated successfully!' : 'Employee updated successfully!');
                                    setIsEditDialogOpen(false);
                                    setSelectedEmployee(null);
                                    setNewPassword('');
                                    setConfirmPassword('');
                                    fetchEmployees();
                                  } catch (error) {
                                    console.error('Error updating employee:', error);
                                    toast.error(error.response?.data?.detail || 'Failed to update employee');
                                  }
                                };

                                const handleDeleteEmployee = async (employeeId) => {
                                  const employeeName = employees.find(emp => emp.id === employeeId)?.full_name || 'employee';
                                  
                                  const confirmed = await confirmDialog({
                                      title: "Delete Employee",
                                      description: `Are you sure you want to delete ${employeeName}?\n\nThis action cannot be undone and will permanently remove all associated data.`,
                                      variant: "destructive"
                                  });
                                  if (confirmed) {
                                    try {
                                      await axiosInstance.delete(`/users/${employeeId}`);
                                      toast.success('Employee deleted successfully!');
                                      fetchEmployees();
                                    } catch (error) {
                                      console.error('Error deleting employee:', error);
                                      toast.error(error.response?.data?.detail || 'Failed to delete employee');
                                    }
                                  }
                                };

                                // Toggle employee active status
                                const handleToggleEmployeeStatus = async (employeeId, isActive) => {
                                  const employee = employees.find(emp => emp.id === employeeId);
                                  const employeeName = employee?.full_name || 'employee';
                                  
                                  const action = isActive ? 'activate' : 'deactivate';
                                  const consequence = isActive 
                                    ? 'They will be included in daily monitoring and can log in.'
                                    : 'They will be excluded from daily monitoring and blocked from logging in.';
                                  
                                  const confirmed = await confirmDialog({
                                      title: "Confirm Action",
                                      description: `Are you sure you want to ${action} ${employeeName}?\n\n${consequence}`,
                                      variant: "destructive"
                                  });
                                  if (confirmed) {
                                    try {
                                      await axiosInstance.put(`/users/${employeeId}`, { is_active: isActive });
                                      toast.success(`${employeeName} has been ${isActive ? 'activated' : 'deactivated'} successfully!`);
                                      fetchEmployees();
                                      fetchPayrollEmployees();
                                      fetchPayrollStats();
                                    } catch (error) {
                                      console.error('Error toggling employee status:', error);
                                      toast.error(error.response?.data?.detail || `Failed to ${action} employee`);
                                    }
                                  }
                                };

                                // CRUD Operations for Admins
                                const handleCreateAdmin = async (e) => {
                                  e.preventDefault();
                                  try {
                                    await axiosInstance.post('/users', newAdmin);
                                    toast.success('Admin created successfully!');
                                    setIsCreateAdminDialogOpen(false);
                                    setNewAdmin({ email: '', password: '', full_name: '' });
                                    fetchAdmins();
                                  } catch (error) {
                                    console.error('Error creating admin:', error);
                                    toast.error(error.response?.data?.detail || 'Failed to create admin');
                                  }
                                };

                                const handleUpdateAdmin = async (e) => {
                                  e.preventDefault();
                                  try {
                                    await axiosInstance.put(`/users/${selectedAdmin.id}`, selectedAdmin);
                                    toast.success('Admin updated successfully!');
                                    setIsEditAdminDialogOpen(false);
                                    setSelectedAdmin(null);
                                    fetchAdmins();
                                  } catch (error) {
                                    console.error('Error updating admin:', error);
                                    toast.error(error.response?.data?.detail || 'Failed to update admin');
                                  }
                                };

                                const handleDeleteAdmin = async (adminId) => {
                                  const adminName = admins.find(admin => admin.id === adminId)?.full_name || 'admin';
                                  const confirmMessage = `Are you sure you want to delete ${adminName}?\n\nThis action cannot be undone and will remove all administrative access for this user.`;
                                  
                                  const confirmed = await confirmDialog({
                                      title: "Delete Admin",
                                      description: confirmMessage,
                                      variant: "destructive"
                                  });
                                  if (confirmed) {
                                    try {
                                      await axiosInstance.delete(`/users/${adminId}`);
                                      toast.success('Admin deleted successfully!');
                                      fetchAdmins();
                                    } catch (error) {
                                      console.error('Error deleting admin:', error);
                                      toast.error(error.response?.data?.detail || 'Failed to delete admin');
                                    }
                                  }
                                };

                                // Attendance Operations
                                const handleUpdateAttendance = async (e) => {
                                  e.preventDefault();
                                  try {
                                    const updateData = {
                                      type: selectedAttendance.type,
                                      comment: selectedAttendance.comment,
                                      location: selectedAttendance.location
                                    };
                                    
                                    // If super admin and date/time were edited, include timestamp
                                    if (user.is_super_admin && selectedAttendance.editDate && selectedAttendance.editTime) {
                                      // Normalize time to 24-hour HH:MM:SS
                                      const t = selectedAttendance.editTime.trim();
                                      let hh = '00', mm = '00', ss = '00';
                                      const ampmMatch = t.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)$/i);
                                      const isoMatch = t.match(/^(\d{2}):(\d{2})(?::(\d{2}))$/);
                                      if (ampmMatch) {
                                        let h = parseInt(ampmMatch[1], 10);
                                        mm = ampmMatch[2];
                                        ss = ampmMatch[3] || '00';
                                        const ampm = ampmMatch[4].toUpperCase();
                                        if (ampm === 'PM' && h !== 12) h += 12;
                                        if (ampm === 'AM' && h === 12) h = 0;
                                        hh = String(h).padStart(2, '0');
                                      } else if (isoMatch) {
                                        hh = isoMatch[1];
                                        mm = isoMatch[2];
                                        ss = isoMatch[3] || '00';
                                      } else {
                                        // Fallback: attempt to parse via Date using Taipei timezone display
                                        const d = new Date(`1970-01-01T${t.replace(' ', '')}`);
                                        hh = String(d.getHours()).padStart(2, '0');
                                        mm = String(d.getMinutes()).padStart(2, '0');
                                        ss = String(d.getSeconds()).padStart(2, '0');
                                      }
                                      updateData.timestamp = `${selectedAttendance.editDate}T${hh}:${mm}:${ss}+08:00`;
                                    }
                                    
                                    await axiosInstance.put(`/attendance/${selectedAttendance.id}`, updateData);
                                    toast.success('Attendance record updated successfully!');
                                    setIsEditAttendanceDialogOpen(false);
                                    setSelectedAttendance(null);
                                    fetchAttendance();
                                    fetchDashboardStats(); // Refresh dashboard tiles
                                  } catch (error) {
                                    console.error('Error updating attendance:', error);
                                    toast.error(error.response?.data?.detail || 'Failed to update attendance record');
                                  }
                                };

                                const handleDeleteAttendance = async (attendanceId, employeeName) => {
                                  const confirmMessage = `Are you sure you want to delete this attendance record for ${employeeName}?\n\nThis action cannot be undone.`;
                                  
                                  const confirmed = await confirmDialog({
                                      title: "Delete Attendance",
                                      description: confirmMessage,
                                      variant: "destructive"
                                  });
                                  if (confirmed) {
                                    try {
                                      await axiosInstance.delete(`/attendance/${attendanceId}`);
                                      toast.success('Attendance record deleted successfully!');
                                      fetchAttendance();
                                      fetchDashboardStats(); // Refresh dashboard tiles
                                      fetchStats();
                                    } catch (error) {
                                      console.error('Error deleting attendance:', error);
                                      toast.error(error.response?.data?.detail || 'Failed to delete attendance record');
                                    }
                                  }
                                };

                                // Branch Schedule Operations
                                const handleCreateBranchSchedule = async (e) => {
                                  e.preventDefault();
                                  try {
                                    await axiosInstance.post('/schedules', newBranchSchedule);
                                    toast.success('Branch schedule created successfully!');
                                    setIsCreateBranchScheduleDialogOpen(false);
                                    setNewBranchSchedule({
                                      branch_name: '',
                                      start_time: '09:00',
                                      end_time: '17:00'
                                    });
                                    fetchBranchSchedules();
                                  } catch (error) {
                                    console.error('Error creating branch schedule:', error);
                                    toast.error(error.response?.data?.detail || 'Failed to create branch schedule');
                                  }
                                };

                                const handleUpdateBranchSchedule = async (e) => {
                                  e.preventDefault();
                                  try {
                                    await axiosInstance.put(`/schedules/${selectedBranchSchedule.id}`, {
                                      start_time: selectedBranchSchedule.start_time,
                                      end_time: selectedBranchSchedule.end_time
                                    });
                                    toast.success('Branch schedule updated successfully!');
                                    setIsEditBranchScheduleDialogOpen(false);
                                    setSelectedBranchSchedule(null);
                                    fetchBranchSchedules();
                                  } catch (error) {
                                    console.error('Error updating branch schedule:', error);
                                    toast.error(error.response?.data?.detail || 'Failed to update branch schedule');
                                  }
                                };

                                const handleRemoveEmployeeFromSchedule = async (employee) => {
                                  try {
                                    await axiosInstance.put(`/users/${employee.id}`, {
                                      schedule_id: null
                                    });
                                    toast.success(`${employee.full_name} removed from schedule successfully!`);
                                    await fetchEmployees();
                                  } catch (error) {
                                    console.error('Error removing employee from schedule:', error);
                                    toast.error(error.response?.data?.detail || 'Failed to remove employee from schedule');
                                  }
                                };

                                const handleDeleteBranchSchedule = async (scheduleId, branchName) => {
                                  const confirmMessage = `Are you sure you want to delete the schedule for ${branchName}?\n\nThis will affect all employees in this branch.`;
                                  
                                  const confirmed = await confirmDialog({
                                      title: "Delete Branch Schedule",
                                      description: confirmMessage,
                                      variant: "destructive"
                                  });
                                  if (confirmed) {
                                    try {
                                      await axiosInstance.delete(`/schedules/${scheduleId}`);
                                      toast.success('Branch schedule deleted successfully!');
                                      fetchBranchSchedules();
                                    } catch (error) {
                                      console.error('Error deleting branch schedule:', error);
                                      toast.error(error.response?.data?.detail || 'Failed to delete branch schedule');
                                    }
                                  }
                                };

                                // Render Organizational Chart
                                const renderOrgChart = () => {
                                  return (
                                    <div className="h-full w-full flex items-center justify-center bg-gradient-to-br from-slate-50 to-blue-50 overflow-hidden p-4">
                                      <img 
                                        src="https://customer-assets.emergentagent.com/job_92730185-88ee-43fe-b8d7-1fba47249769/artifacts/miy2wzcd_final.png"
                                        alt="iSource Organizational Structure"
                                        className="w-full h-full"
                                        style={{ 
                                          height: 'calc(100vh - 120px)',
                                          width: '100%',
                                          objectFit: 'contain'
                                        }}
                                      />
                                    </div>
                                  );
                                };

                                // Content renderer based on active menu item
                                const renderContent = () => {
                                  console.log('renderContent called with activeMenuItem:', activeMenuItem);
                                  switch (activeMenuItem) {
                                    case 'org-chart':
                                      return renderOrgChart();
                                    case 'dashboard':
                                      return renderDashboard();
                                    case 'attendance':
                                      return renderAttendanceByBranch();
                                    case 'reports':
                                      return renderReports();
                                    case 'schedules':
                                      return renderSchedules();
                                    case 'employees':
                                      return renderEmployees();
                                    case 'settings':
                                      return renderSettings();
                                    // Payroll menu items
                                    case 'payroll-dashboard':
                                      return renderPayrollDashboard();
                                    case 'employee-management':
                                      return renderEmployeeManagement();
                                    case 'payroll-attendance':
                                      return renderPayrollAttendance();
                                    case 'payroll-database':
                                      return renderPayrollDatabase();
                                    case 'employee-running-status':
                                      return renderEmployeeRunningStatus();
// renderCCP() call removed
                                    case 'management-print-system':
                                      return null;
                                    case 'inventory-management-system':
                                    case 'inventory-machines':
                                    case 'inventory-parts':
                                    case 'inventory-consumables':
                                    case 'inventory-others':
                                    case 'inventory-mif':
                                      return renderInventoryManagementSystem();
                                    default:
                                      return renderDashboard();
                                  }
                                };

                                // Helper function to get today's employees by category for dashboard tiles
                                const getTodayEmployeesByCategory = (type) => {
                                  // Get today in Taipei timezone
                                  const now = new Date();
                                  const taipeiNow = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Taipei' }));
                                  const todayStart = new Date(taipeiNow.getFullYear(), taipeiNow.getMonth(), taipeiNow.getDate(), 0, 0, 0);
                                  const todayEnd = new Date(taipeiNow.getFullYear(), taipeiNow.getMonth(), taipeiNow.getDate(), 23, 59, 59);
                                  
                                  // Get all active employees
                                  const allEmployees = employees.filter(emp => emp.is_active);
                                  
                                  // Get today's attendance records (only for TODAY in Taipei timezone)
                                  const todayAttendance = attendance.filter(att => {
                                    const attDate = new Date(att.timestamp);
                                    const attTaipei = new Date(attDate.toLocaleString('en-US', { timeZone: 'Asia/Taipei' }));
                                    const attDateOnly = new Date(attTaipei.getFullYear(), attTaipei.getMonth(), attTaipei.getDate());
                                    const todayDateOnly = new Date(taipeiNow.getFullYear(), taipeiNow.getMonth(), taipeiNow.getDate());
                                    
                                    // Check if dates match (year, month, day)
                                    return attDateOnly.getTime() === todayDateOnly.getTime();
                                  });
                                  
                                  // Track employee IDs by status
                                  const presentEmployeeIds = new Set();
                                  const lateEmployeeIds = new Set();
                                  const undertimeEmployeeIds = new Set();
                                  
                                  todayAttendance.forEach(att => {
                                    if (att.type === 'time_in') {
                                      presentEmployeeIds.add(att.user_id);
                                    }
                                    if (att.status === 'late') {
                                      lateEmployeeIds.add(att.user_id);
                                    }
                                    if (att.status === 'undertime') {
                                      undertimeEmployeeIds.add(att.user_id);
                                    }
                                  });
                                  
                                  // Build employee lists
                                  let employeeList = [];
                                  switch(type) {
                                    case 'present':
                                      employeeList = allEmployees.filter(emp => presentEmployeeIds.has(emp.id));
                                      break;
                                    case 'absent':
                                      employeeList = allEmployees.filter(emp => !presentEmployeeIds.has(emp.id));
                                      break;
                                    case 'late':
                                      employeeList = allEmployees.filter(emp => lateEmployeeIds.has(emp.id));
                                      break;
                                    case 'undertime':
                                      employeeList = allEmployees.filter(emp => undertimeEmployeeIds.has(emp.id));
                                      break;
                                    default:
                                      employeeList = [];
                                  }
                                  
                                  return employeeList;
                                };
                                
                                // Handler for dashboard tile clicks
                                const handleDashboardTileClick = async (type) => {
                                  if (!dashboardStats) {
                                    // Try to fetch dashboard stats if not loaded
                                    toast.info('Loading dashboard data...');
                                    await fetchDashboardStats();
                                    
                                    // Check again after fetch
                                    if (!dashboardStats) {
                                      toast.error('Unable to load dashboard data. Please refresh the page.');
                                      return;
                                    }
                                  }

                                  let employeeList = [];
                                  switch(type) {
                                    case 'present':
                                      employeeList = dashboardStats.presentEmployees || [];
                                      break;
                                    case 'absent':
                                      employeeList = dashboardStats.absentEmployees || [];
                                      break;
                                    case 'late':
                                      employeeList = dashboardStats.lateEmployees || [];
                                      break;
                                    case 'undertime':
                                      employeeList = dashboardStats.undertimeEmployees || [];
                                      break;
                                    default:
                                      employeeList = [];
                                  }
                                  
                                  setDashboardModalType(type);
                                  setDashboardModalEmployees(employeeList);
                                  setIsDashboardTileModalOpen(true);
                                };

                                const renderDashboard = () => {
                                  // Use backend stats if available (accurate data using same logic as snapshot)
                                  // Fallback to local calculation if backend data not available
                                  let totalEmployees, presentToday, absentToday, lateToday, undertimeToday;
                                  
                                  if (dashboardStats) {
                                    // Use accurate backend stats
                                    totalEmployees = dashboardStats.totalEmployees;
                                    presentToday = dashboardStats.present;
                                    absentToday = dashboardStats.absent;
                                    lateToday = dashboardStats.late;
                                    undertimeToday = dashboardStats.undertime;
                                  } else {
                                    // Fallback to local calculation (less accurate due to timezone issues)
                                    const now = new Date();
                                    const taipeiNow = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Taipei' }));
                                    const todayDateOnly = new Date(taipeiNow.getFullYear(), taipeiNow.getMonth(), taipeiNow.getDate());
                                    
                                    const todayStart = new Date(todayDateOnly);
                                    todayStart.setHours(0, 1, 0, 0);
                                    const todayEnd = new Date(todayDateOnly);
                                    todayEnd.setHours(23, 59, 0, 0);
                                    
                                    const allEmployees = employees.filter(emp => emp.is_active);
                                    totalEmployees = allEmployees.length;
                                    const activeEmployeeIds = new Set(allEmployees.map(emp => emp.id));
                                    
                                    const todayAttendance = attendance.filter(att => {
                                      const attDate = new Date(att.timestamp);
                                      const attTaipei = new Date(attDate.toLocaleString('en-US', { timeZone: 'Asia/Taipei' }));
                                      return attTaipei >= todayStart && 
                                            attTaipei <= todayEnd && 
                                            activeEmployeeIds.has(att.user_id);
                                    });
                                    
                                    const presentEmployeeIds = new Set();
                                    const lateEmployeeIds = new Set();
                                    const undertimeEmployeeIds = new Set();
                                    
                                    todayAttendance.forEach(att => {
                                      if (att.type === 'time_in') {
                                        presentEmployeeIds.add(att.user_id);
                                        if (att.status === 'late') {
                                          lateEmployeeIds.add(att.user_id);
                                        }
                                      }
                                      if (att.status === 'undertime') {
                                        undertimeEmployeeIds.add(att.user_id);
                                      }
                                    });
                                    
                                    presentToday = presentEmployeeIds.size;
                                    absentToday = Math.max(0, totalEmployees - presentToday);
                                    lateToday = lateEmployeeIds.size;
                                    undertimeToday = undertimeEmployeeIds.size;
                                  }
                                  
                                  // Calculate percentages for chart labels
                                  const presentPercent = totalEmployees > 0 ? Math.round((presentToday / totalEmployees) * 100) : 0;
                                  const absentPercent = totalEmployees > 0 ? Math.round((absentToday / totalEmployees) * 100) : 0;
                                  const latePercent = presentToday > 0 ? Math.round((lateToday / presentToday) * 100) : 0;
                                  const onTimePercent = presentToday > 0 ? Math.round(((presentToday - lateToday) / presentToday) * 100) : 0;
                                  const undertimePercent = presentToday > 0 ? Math.round((undertimeToday / presentToday) * 100) : 0;
                                  const fullTimePercent = presentToday > 0 ? Math.round(((presentToday - undertimeToday) / presentToday) * 100) : 0;
                                  
                                  const presentChartData = [
                                    { name: `Present (${presentPercent}%)`, value: presentToday, color: '#22c55e', percentage: presentPercent },
                                    { name: `Absent (${absentPercent}%)`, value: absentToday, color: '#ef4444', percentage: absentPercent }
                                  ];
                                  
                                  const absentChartData = [
                                    { name: `Absent (${absentPercent}%)`, value: absentToday, color: '#ef4444', percentage: absentPercent },
                                    { name: `Present (${presentPercent}%)`, value: presentToday, color: '#22c55e', percentage: presentPercent }
                                  ];
                                  
                                  const lateChartData = [
                                    { name: `Late (${latePercent}%)`, value: lateToday, color: '#f97316', percentage: latePercent },
                                    { name: `On Time (${onTimePercent}%)`, value: presentToday - lateToday, color: '#22c55e', percentage: onTimePercent }
                                  ];
                                  
                                  const undertimeChartData = [
                                    { name: `Undertime (${undertimePercent}%)`, value: undertimeToday, color: '#eab308', percentage: undertimePercent },
                                    { name: `Full Time (${fullTimePercent}%)`, value: presentToday - undertimeToday, color: '#22c55e', percentage: fullTimePercent }
                                  ];
                                  
                                  const attendanceRateData = [
                                    { name: `Present (${presentPercent}%)`, value: presentToday, color: '#22c55e', percentage: presentPercent },
                                    { name: `Absent (${absentPercent}%)`, value: absentToday, color: '#ef4444', percentage: absentPercent }
                                  ];
                                  
                                  return (
                                  <div className="space-y-6">
                                    {/* Stats Cards */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6">
                                      <Card className="glass shadow-lg border-0 bg-gradient-to-br from-blue-50 to-white dark:from-slate-800 dark:to-slate-900">
                                        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                                          <CardTitle className="text-sm font-medium text-gray-600 dark:text-gray-200">Total Employees</CardTitle>
                                          <Users className="h-4 w-4 text-blue-600 dark:text-blue-400" />
                                        </CardHeader>
                                        <CardContent>
                                          <div className="text-2xl font-bold text-gray-900 dark:text-white">{totalEmployees}</div>
                                        </CardContent>
                                      </Card>

                                      <div className="relative">
                                        <Card 
                                          className="glass shadow-lg border-0 cursor-pointer transition-all hover:shadow-xl bg-gradient-to-br from-green-50 to-white dark:from-green-900/20 dark:to-slate-900"
                                          onMouseEnter={() => setHoveredTile('present')}
                                          onMouseLeave={() => setHoveredTile(null)}
                                          onMouseMove={(e) => {
                                            setMousePosition({ 
                                              x: e.clientX, 
                                              y: e.clientY 
                                            });
                                          }}
                                          onClick={() => handleDashboardTileClick('present')}
                                        >
                                          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                                            <CardTitle className="text-sm font-medium text-gray-600 dark:text-gray-200">Present Today</CardTitle>
                                            <UserCheck className="h-4 w-4 text-green-600 dark:text-green-400" />
                                          </CardHeader>
                                          <CardContent>
                                            <div className="text-2xl font-bold text-gray-900 dark:text-white">{presentToday}</div>
                                          </CardContent>
                                        </Card>
                                        {hoveredTile === 'present' && (
                                          <div 
                                            className="fixed w-64 h-64 bg-white dark:bg-slate-800 bg-opacity-95 backdrop-blur-sm rounded-xl shadow-2xl z-[9999] p-4 border-2 border-green-200 dark:border-green-800 pointer-events-none"
                                            style={{
                                              left: `${mousePosition.x}px`,
                                              top: `${mousePosition.y + 20}px`,
                                              transform: 'translateX(-50%)'
                                            }}
                                          >
                                            <div className="text-xs font-semibold text-gray-700 dark:text-gray-100 mb-2 text-center">Present vs Absent</div>
                                            <div className="h-[90%] flex flex-col justify-center gap-3">
                                              {presentChartData.map((entry) => (
                                                <div key={entry.name} className="space-y-1">
                                                  <div className="flex items-center justify-between gap-2 text-xs">
                                                    <div className="flex items-center gap-2 min-w-0">
                                                      <span className="h-2 w-2 rounded-sm" style={{ backgroundColor: entry.color }} />
                                                      <span className="truncate text-gray-700 dark:text-gray-200">{entry.name}</span>
                                                    </div>
                                                    <span className="tabular-nums text-gray-600 dark:text-gray-300">{entry.value} ({entry.percentage}%)</span>
                                                  </div>
                                                  <div className="h-1.5 w-full rounded bg-gray-200/70 dark:bg-slate-700">
                                                    <div className="h-1.5 rounded" style={{ width: `${entry.percentage}%`, backgroundColor: entry.color }} />
                                                  </div>
                                                </div>
                                              ))}
                                            </div>
                                          </div>
                                        )}
                                      </div>

                                      <div className="relative">
                                        <Card 
                                          className="glass shadow-lg border-0 cursor-pointer transition-all hover:shadow-xl bg-gradient-to-br from-red-50 to-white dark:from-red-900/20 dark:to-slate-900"
                                          onMouseEnter={() => setHoveredTile('absent')}
                                          onMouseLeave={() => setHoveredTile(null)}
                                          onMouseMove={(e) => {
                                            setMousePosition({ 
                                              x: e.clientX, 
                                              y: e.clientY 
                                            });
                                          }}
                                          onClick={() => handleDashboardTileClick('absent')}
                                        >
                                          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                                            <CardTitle className="text-sm font-medium text-gray-600 dark:text-gray-200">Absent Today</CardTitle>
                                            <Users className="h-4 w-4 text-red-600 dark:text-red-400" />
                                          </CardHeader>
                                          <CardContent>
                                            <div className="text-2xl font-bold text-gray-900 dark:text-white">{absentToday}</div>
                                          </CardContent>
                                        </Card>
                                        {hoveredTile === 'absent' && (
                                          <div 
                                            className="fixed w-64 h-64 bg-white dark:bg-slate-800 bg-opacity-95 backdrop-blur-sm rounded-xl shadow-2xl z-[9999] p-4 border-2 border-red-200 dark:border-red-800 pointer-events-none"
                                            style={{
                                              left: `${mousePosition.x}px`,
                                              top: `${mousePosition.y + 20}px`,
                                              transform: 'translateX(-50%)'
                                            }}
                                          >
                                            <div className="text-xs font-semibold text-gray-700 dark:text-gray-100 mb-2 text-center">Absent vs Present</div>
                                            <div className="h-[90%] flex flex-col justify-center gap-3">
                                              {absentChartData.map((entry) => (
                                                <div key={entry.name} className="space-y-1">
                                                  <div className="flex items-center justify-between gap-2 text-xs">
                                                    <div className="flex items-center gap-2 min-w-0">
                                                      <span className="h-2 w-2 rounded-sm" style={{ backgroundColor: entry.color }} />
                                                      <span className="truncate text-gray-700 dark:text-gray-200">{entry.name}</span>
                                                    </div>
                                                    <span className="tabular-nums text-gray-600 dark:text-gray-300">{entry.value} ({entry.percentage}%)</span>
                                                  </div>
                                                  <div className="h-1.5 w-full rounded bg-gray-200/70 dark:bg-slate-700">
                                                    <div className="h-1.5 rounded" style={{ width: `${entry.percentage}%`, backgroundColor: entry.color }} />
                                                  </div>
                                                </div>
                                              ))}
                                            </div>
                                          </div>
                                        )}
                                      </div>

                                      <div className="relative">
                                        <Card 
                                          className="glass shadow-lg border-0 cursor-pointer transition-all hover:shadow-xl bg-gradient-to-br from-purple-50 to-white"
                                          onMouseEnter={() => setHoveredTile('rate')}
                                          onMouseLeave={() => setHoveredTile(null)}
                                          onMouseMove={(e) => {
                                            setMousePosition({ 
                                              x: e.clientX, 
                                              y: e.clientY 
                                            });
                                          }}
                                        >
                                          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                                            <CardTitle className="text-sm font-medium text-gray-600 dark:text-gray-200">Attendance Rate</CardTitle>
                                            <BarChart3 className="h-4 w-4 text-purple-600" />
                                          </CardHeader>
                                          <CardContent>
                                            <div className="text-2xl font-bold text-gray-900 dark:text-white">
                                              {totalEmployees > 0 ? Math.round((presentToday / totalEmployees) * 100) : 0}%
                                            </div>
                                          </CardContent>
                                        </Card>
                                        {hoveredTile === 'rate' && (
                                          <div 
                                            className="fixed w-64 h-64 bg-white bg-opacity-95 backdrop-blur-sm rounded-xl shadow-2xl z-[9999] p-4 border-2 border-purple-200 pointer-events-none"
                                            style={{
                                              left: `${mousePosition.x}px`,
                                              top: `${mousePosition.y + 20}px`,
                                              transform: 'translateX(-50%)'
                                            }}
                                          >
                                            <div className="text-xs font-semibold text-gray-700 dark:text-gray-100 mb-2 text-center">Attendance Rate</div>
                                            <div className="h-[90%] flex flex-col justify-center gap-3">
                                              {attendanceRateData.map((entry) => (
                                                <div key={entry.name} className="space-y-1">
                                                  <div className="flex items-center justify-between gap-2 text-xs">
                                                    <div className="flex items-center gap-2 min-w-0">
                                                      <span className="h-2 w-2 rounded-sm" style={{ backgroundColor: entry.color }} />
                                                      <span className="truncate text-gray-700 dark:text-gray-200">{entry.name}</span>
                                                    </div>
                                                    <span className="tabular-nums text-gray-600 dark:text-gray-300">{entry.value} ({entry.percentage}%)</span>
                                                  </div>
                                                  <div className="h-1.5 w-full rounded bg-gray-200/70 dark:bg-slate-700">
                                                    <div className="h-1.5 rounded" style={{ width: `${entry.percentage}%`, backgroundColor: entry.color }} />
                                                  </div>
                                                </div>
                                              ))}
                                            </div>
                                          </div>
                                        )}
                                      </div>

                                      <div className="relative">
                                        <Card 
                                          className="glass shadow-lg border-0 cursor-pointer transition-all hover:shadow-xl bg-gradient-to-br from-orange-50 to-white"
                                          onMouseEnter={() => setHoveredTile('late')}
                                          onMouseLeave={() => setHoveredTile(null)}
                                          onMouseMove={(e) => {
                                            setMousePosition({ 
                                              x: e.clientX, 
                                              y: e.clientY 
                                            });
                                          }}
                                          onClick={() => handleDashboardTileClick('late')}
                                        >
                                          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                                            <CardTitle className="text-sm font-medium text-gray-600 dark:text-gray-200">Late Today</CardTitle>
                                            <Users className="h-4 w-4 text-orange-600" />
                                          </CardHeader>
                                          <CardContent>
                                            <div className="text-2xl font-bold text-gray-900 dark:text-white">{lateToday}</div>
                                          </CardContent>
                                        </Card>
                                        {hoveredTile === 'late' && (
                                          <div 
                                            className="fixed w-64 h-64 bg-white bg-opacity-95 backdrop-blur-sm rounded-xl shadow-2xl z-[9999] p-4 border-2 border-orange-200 pointer-events-none"
                                            style={{
                                              left: `${mousePosition.x}px`,
                                              top: `${mousePosition.y + 20}px`,
                                              transform: 'translateX(-50%)'
                                            }}
                                          >
                                            <div className="text-xs font-semibold text-gray-700 dark:text-gray-100 mb-2 text-center">Late vs On Time</div>
                                            <div className="h-[90%] flex flex-col justify-center gap-3">
                                              {lateChartData.map((entry) => (
                                                <div key={entry.name} className="space-y-1">
                                                  <div className="flex items-center justify-between gap-2 text-xs">
                                                    <div className="flex items-center gap-2 min-w-0">
                                                      <span className="h-2 w-2 rounded-sm" style={{ backgroundColor: entry.color }} />
                                                      <span className="truncate text-gray-700 dark:text-gray-200">{entry.name}</span>
                                                    </div>
                                                    <span className="tabular-nums text-gray-600 dark:text-gray-300">{entry.value} ({entry.percentage}%)</span>
                                                  </div>
                                                  <div className="h-1.5 w-full rounded bg-gray-200/70 dark:bg-slate-700">
                                                    <div className="h-1.5 rounded" style={{ width: `${entry.percentage}%`, backgroundColor: entry.color }} />
                                                  </div>
                                                </div>
                                              ))}
                                            </div>
                                          </div>
                                        )}
                                      </div>

                                      <div className="relative">
                                        <Card 
                                          className="glass shadow-lg border-0 cursor-pointer transition-all hover:shadow-xl bg-gradient-to-br from-yellow-50 to-white"
                                          onMouseEnter={() => setHoveredTile('undertime')}
                                          onMouseLeave={() => setHoveredTile(null)}
                                          onMouseMove={(e) => {
                                            setMousePosition({ 
                                              x: e.clientX, 
                                              y: e.clientY 
                                            });
                                          }}
                                          onClick={() => handleDashboardTileClick('undertime')}
                                        >
                                          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                                            <CardTitle className="text-sm font-medium text-gray-600 dark:text-gray-200">Undertime Today</CardTitle>
                                            <Users className="h-4 w-4 text-yellow-600" />
                                          </CardHeader>
                                          <CardContent>
                                            <div className="text-2xl font-bold text-gray-900 dark:text-white">{undertimeToday}</div>
                                          </CardContent>
                                        </Card>
                                        {hoveredTile === 'undertime' && (
                                          <div 
                                            className="fixed w-64 h-64 bg-white bg-opacity-95 backdrop-blur-sm rounded-xl shadow-2xl z-[9999] p-4 border-2 border-yellow-200 pointer-events-none"
                                            style={{
                                              left: `${mousePosition.x}px`,
                                              top: `${mousePosition.y + 20}px`,
                                              transform: 'translateX(-50%)'
                                            }}
                                          >
                                            <div className="text-xs font-semibold text-gray-700 dark:text-gray-100 mb-2 text-center">Undertime vs Full Time</div>
                                            <div className="h-[90%] flex flex-col justify-center gap-3">
                                              {undertimeChartData.map((entry) => (
                                                <div key={entry.name} className="space-y-1">
                                                  <div className="flex items-center justify-between gap-2 text-xs">
                                                    <div className="flex items-center gap-2 min-w-0">
                                                      <span className="h-2 w-2 rounded-sm" style={{ backgroundColor: entry.color }} />
                                                      <span className="truncate text-gray-700 dark:text-gray-200">{entry.name}</span>
                                                    </div>
                                                    <span className="tabular-nums text-gray-600 dark:text-gray-300">{entry.value} ({entry.percentage}%)</span>
                                                  </div>
                                                  <div className="h-1.5 w-full rounded bg-gray-200/70 dark:bg-slate-700">
                                                    <div className="h-1.5 rounded" style={{ width: `${entry.percentage}%`, backgroundColor: entry.color }} />
                                                  </div>
                                                </div>
                                              ))}
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>

                                    {/* Today's Activity */}
                                    <Card className="glass shadow-lg border-0 bg-gradient-to-r from-indigo-50 to-purple-50">
                                      <CardHeader>
                                        <CardTitle className="text-lg font-semibold text-gray-900 dark:text-white">Today's Activity</CardTitle>
                                        <CardDescription>Recent attendance records from today</CardDescription>
                                      </CardHeader>
                                      <CardContent>
                                        <div className="space-y-3">
                                          {getTodayAttendance().slice(0, 10).map((record, index) => (
                                            <div key={record.id} className="flex items-center justify-between p-3 bg-white bg-opacity-60 rounded-lg shadow-sm">
                                              <div className="flex items-center space-x-3">
                                                <div className={`w-2 h-2 rounded-full ${record.type === 'time_in' ? 'bg-green-500' : 'bg-red-500'}`}></div>
                                                <div>
                                                  <p className="font-medium text-gray-900 dark:text-white">{record.user_name}</p>
                                                  <p className="text-sm text-gray-500 dark:text-gray-300">{record.type.replace('_', ' ').toUpperCase()}</p>
                                                </div>
                                              </div>
                                              <div className="text-right">
                                                <span className="inline-flex items-center px-2 py-1 rounded-full bg-indigo-100 text-indigo-700 text-xs font-semibold">
                                                  {formatTimeHHMMFromBackend(record.timestamp)}
                                                </span>
                                                <div className="flex space-x-1 mt-1">
                                                  <Button
                                                    size="sm"
                                                    variant="ghost"
                                                    onClick={() => {
                                                      // Parse timestamp to date and time for editing (Taipei)
                                                      const localDate = toTaipeiISODate(record.timestamp);
                                                      const localTime = formatTaipeiTime24(record.timestamp);
                                                      
                                                      setSelectedAttendance({
                                                        ...record,
                                                        editDate: localDate,
                                                        editTime: localTime
                                                      });
                                                      setIsEditAttendanceDialogOpen(true);
                                                    }}
                                                    className="h-6 w-6 p-0"
                                                  >
                                                    <Edit className="h-3 w-3" />
                                                  </Button>
                                                  <Button
                                                    size="sm"
                                                    variant="ghost"
                                                    onClick={() => handleDeleteAttendance(record.id, record.user_name)}
                                                    className="h-6 w-6 p-0 text-red-600 hover:text-red-800"
                                                  >
                                                    <Trash2 className="h-3 w-3" />
                                                  </Button>
                                                </div>
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                      </CardContent>
                                    </Card>
                                    
                                    {/* Dashboard Tile Click Modal - Employee List */}
                                    <Dialog open={isDashboardTileModalOpen} onOpenChange={setIsDashboardTileModalOpen}>
                                      <DialogContent className="sm:max-w-[700px] max-h-[80vh] overflow-hidden flex flex-col">
                                        <DialogHeader>
                                          <DialogTitle>
                                            {dashboardModalType === 'present' && 'Present Today'}
                                            {dashboardModalType === 'absent' && 'Absent Today'}
                                            {dashboardModalType === 'late' && 'Late Today'}
                                            {dashboardModalType === 'undertime' && 'Undertime Today'}
                                          </DialogTitle>
                                          <DialogDescription>
                                            {dashboardModalEmployees.length} employee(s) &#8226; {new Date().toLocaleDateString()}
                                          </DialogDescription>
                                        </DialogHeader>
                                        
                                        <div className="flex-1 overflow-y-auto py-4">
                                          {dashboardModalEmployees.length === 0 ? (
                                            <div className="text-center py-8">
                                              <Users className="h-12 w-12 text-gray-400 mx-auto mb-3" />
                                              <p className="text-gray-500 dark:text-gray-300">No employees in this category</p>
                                            </div>
                                          ) : (
                                            <div className="space-y-3">
                                              {dashboardModalEmployees.map((employee) => (
                                                <Card key={employee.id} className="border border-gray-200 dark:border-gray-700 bg-white dark:bg-slate-800">
                                                  <CardContent className="p-4">
                                                    <div className="grid grid-cols-2 gap-4">
                                                      <div>
                                                        <p className="text-sm text-gray-500 dark:text-gray-300">Name</p>
                                                        <p className="font-semibold text-gray-900 dark:text-white">{employee.name}</p>
                                                      </div>
                                                      <div>
                                                        <p className="text-sm text-gray-500 dark:text-gray-300">Employee ID</p>
                                                        <p className="font-semibold text-gray-900 dark:text-white">{employee.employee_id || 'N/A'}</p>
                                                      </div>
                                                      <div>
                                                        <p className="text-sm text-gray-500 dark:text-gray-300">Branch</p>
                                                        <p className="font-semibold text-gray-900 dark:text-white">{employee.branch || 'No Branch'}</p>
                                                      </div>
                                                      
                                                      {/* Present Today: Show first time_in */}
                                                      {dashboardModalType === 'present' && employee.first_time_in && (
                                                        <div>
                                                          <p className="text-sm text-gray-500 dark:text-gray-300">First Time In</p>
                                                          <p className="font-semibold text-gray-900 dark:text-white">
                                                            {formatTimestampFromBackend(employee.first_time_in)}
                                                          </p>
                                      </div>
                                    )}

                                    {/* HRIS Section Removed */}
                                    
                                                      {/* Late Today: Show first time_in, schedule, and minutes late */}
                                                      {dashboardModalType === 'late' && (
                                                        <>
                                                          <div>
                                                            <p className="text-sm text-gray-500 dark:text-gray-300">First Time In (UTC+8)</p>
                                                            <p className="font-semibold text-gray-900 dark:text-white">
                                                              {(() => {
                                                                if (!employee.first_time_in) return '\u2014';
                                                                try {
                                                                  let date;
                                                                  const timestamp = employee.first_time_in;
                                                                  if (timestamp.includes('+') || timestamp.endsWith('Z')) {
                                                                     date = new Date(timestamp);
                                                                  } else {
                                                                     date = new Date(timestamp + 'Z');
                                                                  }
                                                                  
                                                                  if (isNaN(date.getTime())) return timestamp;

                                                                  // Convert to Taipei (+8 hours)
                                                                  const taipeiDate = new Date(date.getTime() + (8 * 60 * 60 * 1000));
                                                                  
                                                                  // Format: hh:mm A
                                                                  let hours = taipeiDate.getUTCHours();
                                                                  const ampm = hours >= 12 ? 'PM' : 'AM';
                                                                  hours = hours % 12;
                                                                  hours = hours ? hours : 12;
                                                                  const hoursStr = hours.toString().padStart(2, '0');
                                                                  const minutes = taipeiDate.getUTCMinutes().toString().padStart(2, '0');
                                                                  
                                                                  return `${hoursStr}:${minutes} ${ampm}`;
                                                                } catch (e) {
                                                                  return employee.first_time_in;
                                                                }
                                                              })()}
                                                            </p>
                                                          </div>
                                                          <div>
                                                            <p className="text-sm text-gray-500 dark:text-gray-300">Schedule Start</p>
                                                            <p className="font-semibold text-gray-900 dark:text-white">{employee.schedule_start || 'N/A'}</p>
                                                          </div>
                                                          <div>
                                                            <p className="text-sm text-gray-500 dark:text-gray-300">Minutes Late</p>
                                                            <p className="font-semibold text-red-600">{employee.minutes_late} mins</p>
                                                          </div>
                                                         </>
                                                      )}
                                                      
                                                      {/* Undertime Today: Show last time_out, schedule, and minutes undertime */}
                                                      {dashboardModalType === 'undertime' && (
                                                        <>
                                                          <div>
                                                            <p className="text-sm text-gray-500 dark:text-gray-300">Last Time Out</p>
                                                            <p className="font-semibold text-gray-900 dark:text-white">
                                                              {formatTimestampFromBackend(employee.last_time_out)}
                                                            </p>
                                                          </div>
                                                          <div>
                                                            <p className="text-sm text-gray-500 dark:text-gray-300">Schedule End</p>
                                                            <p className="font-semibold text-gray-900 dark:text-white">{employee.schedule_end || 'N/A'}</p>
                                                          </div>
                                                          <div>
                                                            <p className="text-sm text-gray-500 dark:text-gray-300">Minutes Undertime</p>
                                                            <p className="font-semibold text-orange-600">{employee.minutes_undertime} mins</p>
                                                          </div>
                                                        </>
                                                      )}
                                                    </div>
                                                  </CardContent>
                                                </Card>
                                              ))}
                                            </div>
                                          )}
                                        </div>
                                        
                                        <div className="flex justify-end pt-4 border-t">
                                          <Button onClick={() => setIsDashboardTileModalOpen(false)}>
                                            Close
                                          </Button>
                                        </div>
                                      </DialogContent>
                                    </Dialog>
                                  </div>
                                );
                                };

                                // Attendance by Status Content
                                const renderAttendanceByBranch = () => {
                                  // Helper function to open employee list modal
                                  const openEmployeeListModal = (snapshot, type) => {
                                    setSelectedSnapshot(snapshot);
                                    setEmployeeListType(type);
                                    
                                    switch(type) {
                                      case 'total':
                                        setEmployeeList(snapshot.allEmployees || []);
                                        break;
                                      case 'present':
                                        setEmployeeList(snapshot.presentEmployees || []);
                                        break;
                                      case 'absent':
                                        setEmployeeList(snapshot.absentEmployees || []);
                                        break;
                                      case 'late':
                                        setEmployeeList(snapshot.lateEmployees || []);
                                        break;
                                      case 'undertime':
                                        setEmployeeList(snapshot.undertimeEmployees || []);
                                        break;
                                      default:
                                        setEmployeeList([]);
                                    }
                                    
                                    setIsEmployeeListModalOpen(true);
                                  };
                                  
                                  const getModalTitle = () => {
                                    switch(employeeListType) {
                                      case 'total': return 'All Employees';
                                      case 'present': return 'Present Employees';
                                      case 'absent': return 'Absent Employees';
                                      case 'late': return 'Late Employees';
                                      case 'undertime': return 'Undertime Employees';
                                      default: return 'Employees';
                                    }
                                  };
                                  
                                  return (
                                    <div className="space-y-6">
                                      {/* Header */}
                                      <div className="flex justify-between items-center">
                                        
                                        <div className="flex items-center gap-3">
                                          {/* Save Today's Snapshot Button */}
                                          <Button
                                            onClick={async () => {
                                              try {
                                                await axiosInstance.post('/attendance-snapshots/generate');
                                                toast.success('Today\'s attendance snapshot saved successfully!');
                                                fetchAttendanceSnapshots();
                                              } catch (error) {
                                                if (error.response?.status === 400) {
                                                  toast.error(error.response.data.detail || 'Snapshot already exists for today');
                                                } else {
                                                  toast.error('Failed to save snapshot');
                                                }
                                              }
                                            }}
                                            className="bg-green-600 hover:bg-green-700 text-white"
                                          >
                                            <Save className="h-4 w-4 mr-2" />
                                            Save Today's Snapshot
                                          </Button>
                                          
                                          {/* Date Filter */}
                                          <input
                                            type="date"
                                            value={snapshotDateFilter}
                                            onChange={(e) => {
                                              setSnapshotDateFilter(e.target.value);
                                              setSnapshotCurrentPage(1);
                                            }}
                                            className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
                                            placeholder="Filter by date"
                                          />
                                          {snapshotDateFilter && (
                                            <Button
                                              variant="ghost"
                                              size="sm"
                                              onClick={() => {
                                                setSnapshotDateFilter('');
                                                setSnapshotCurrentPage(1);
                                              }}
                                            >
                                              Clear
                                            </Button>
                                          )}
                                        </div>
                                      </div>

                                      {/* Loading State */}
                                      {isSnapshotLoading && (
                                        <div className="flex justify-center items-center py-12">
                                          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
                                        </div>
                                      )}

                                      {/* Snapshots List */}
                                      {!isSnapshotLoading && attendanceSnapshots.length === 0 && (
                                        <Card className="glass shadow-lg border-0">
                                          <CardContent className="p-12">
                                            <div className="flex flex-col items-center justify-center">
                                              <CalendarCheck className="h-16 w-16 text-gray-400 mb-4" />
                                              <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">No attendance snapshots found</h3>
                                              <p className="text-gray-500 dark:text-gray-300 text-center">
                                                {snapshotDateFilter 
                                                  ? 'No snapshots found for the selected date.' 
                                                  : 'Attendance snapshots will appear here after monitoring is reset.'}
                                              </p>
                                            </div>
                                          </CardContent>
                                        </Card>
                                      )}

                                      {!isSnapshotLoading && attendanceSnapshots.length > 0 && (
                                        <div className="space-y-4">
                                          {attendanceSnapshots.map((snapshot) => (
                                            <Card key={snapshot.id} className="glass shadow-lg border-0">
                                              <CardHeader>
                                                <div className="flex justify-between items-center">
                                                  <div>
                                                    <CardTitle>Attendance for {formatTaipeiDate(snapshot.date)}</CardTitle>
                                                    <CardDescription>
                                                      Recorded on {formatTaipeiDateTime(snapshot.createdAt)}
                                                    </CardDescription>
                                                  </div>
                                                  <div className="text-right">
                                                    <div className="text-2xl font-bold text-indigo-600">{snapshot.attendanceRate}%</div>
                                                    <div className="text-sm text-gray-500 dark:text-gray-300">Attendance Rate</div>
                                                    {user.is_super_admin && (
                                                      <Button
                                                        size="sm"
                                                        variant="ghost"
                                                        className="text-red-600 hover:text-red-800 mt-2"
                                                        onClick={() => deleteAttendanceSnapshot(snapshot)}
                                                        title="Delete Snapshot"
                                                      >
                                                        <Trash2 className="h-4 w-4" />
                                                      </Button>
                                                    )}
                                                  </div>
                                                </div>
                                              </CardHeader>
                                              <CardContent>
                                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
                                                  {/* Total Employees */}
                                                  <Card 
                                                    className="border border-gray-200 cursor-pointer hover:shadow-md transition-shadow hover:border-indigo-300"
                                                    onClick={() => openEmployeeListModal(snapshot, 'total')}
                                                  >
                                                    <CardContent className="p-4">
                                                      <div className="flex items-center justify-between">
                                                        <div>
                                                          <p className="text-xs font-medium text-gray-600 dark:text-gray-200">Total</p>
                                                          <p className="text-2xl font-bold text-gray-900 dark:text-white mt-1">{snapshot.totalEmployees}</p>
                                                        </div>
                                                        <Users className="h-8 w-8 text-blue-500" />
                                                      </div>
                                                    </CardContent>
                                                  </Card>

                                                  {/* Present */}
                                                  <Card 
                                                    className="border border-gray-200 cursor-pointer hover:shadow-md transition-shadow hover:border-green-300"
                                                    onClick={() => openEmployeeListModal(snapshot, 'present')}
                                                  >
                                                    <CardContent className="p-4">
                                                      <div className="flex items-center justify-between">
                                                        <div>
                                                          <p className="text-xs font-medium text-gray-600 dark:text-gray-200">Present</p>
                                                          <p className="text-2xl font-bold text-gray-900 dark:text-white mt-1">{snapshot.present}</p>
                                                        </div>
                                                        <UserCheck className="h-8 w-8 text-green-500" />
                                                      </div>
                                                    </CardContent>
                                                  </Card>

                                                  {/* Absent */}
                                                  <Card 
                                                    className="border border-gray-200 cursor-pointer hover:shadow-md transition-shadow hover:border-red-300"
                                                    onClick={() => openEmployeeListModal(snapshot, 'absent')}
                                                  >
                                                    <CardContent className="p-4">
                                                      <div className="flex items-center justify-between">
                                                        <div>
                                                          <p className="text-xs font-medium text-gray-600 dark:text-gray-200">Absent</p>
                                                          <p className="text-2xl font-bold text-gray-900 dark:text-white mt-1">{snapshot.absent}</p>
                                                        </div>
                                                        <Users className="h-8 w-8 text-red-500" />
                                                      </div>
                                                    </CardContent>
                                                  </Card>

                                                  {/* Late */}
                                                  <Card 
                                                    className="border border-gray-200 cursor-pointer hover:shadow-md transition-shadow hover:border-orange-300"
                                                    onClick={() => openEmployeeListModal(snapshot, 'late')}
                                                  >
                                                    <CardContent className="p-4">
                                                      <div className="flex items-center justify-between">
                                                        <div>
                                                          <p className="text-xs font-medium text-gray-600 dark:text-gray-200">Late</p>
                                                          <p className="text-2xl font-bold text-gray-900 dark:text-white mt-1">{snapshot.late}</p>
                                                        </div>
                                                        <Clock className="h-8 w-8 text-orange-500" />
                                                      </div>
                                                    </CardContent>
                                                  </Card>

                                                  {/* Undertime */}
                                                  <Card 
                                                    className="border border-gray-200 cursor-pointer hover:shadow-md transition-shadow hover:border-yellow-300"
                                                    onClick={() => openEmployeeListModal(snapshot, 'undertime')}
                                                  >
                                                    <CardContent className="p-4">
                                                      <div className="flex items-center justify-between">
                                                        <div>
                                                          <p className="text-xs font-medium text-gray-600 dark:text-gray-200">Undertime</p>
                                                          <p className="text-2xl font-bold text-gray-900 dark:text-white mt-1">{snapshot.undertime}</p>
                                                        </div>
                                                        <Clock className="h-8 w-8 text-yellow-500" />
                                                      </div>
                                                    </CardContent>
                                                  </Card>
                                                </div>
                                              </CardContent>
                                            </Card>
                                          ))}
                                        </div>
                                      )}

                                      {/* Pagination Controls */}
                                      {!isSnapshotLoading && attendanceSnapshots.length > 0 && (
                                        <div className="flex justify-center items-center gap-2 mt-6">
                                          <Button
                                            variant="outline"
                                            onClick={() => setSnapshotCurrentPage(prev => Math.max(1, prev - 1))}
                                            disabled={snapshotCurrentPage === 1}
                                          >
                                            Previous
                                          </Button>
                                          <span className="text-sm text-gray-600 dark:text-gray-200">Page {snapshotCurrentPage}</span>
                                          <Button
                                            variant="outline"
                                            onClick={() => setSnapshotCurrentPage(prev => prev + 1)}
                                            disabled={attendanceSnapshots.length < 15}
                                          >
                                            Next
                                          </Button>
                                        </div>
                                      )}

                                      {/* Employee List Modal */}
                                      <Dialog open={isEmployeeListModalOpen} onOpenChange={setIsEmployeeListModalOpen}>
                                        <DialogContent className="sm:max-w-[700px] max-h-[80vh] overflow-hidden flex flex-col">
                                          <DialogHeader>
                                            <DialogTitle>{getModalTitle()}</DialogTitle>
                                            <DialogDescription>
                                              {employeeList.length} employee(s) &#8226; {selectedSnapshot && new Date(selectedSnapshot.date).toLocaleDateString()}
                                            </DialogDescription>
                                          </DialogHeader>
                                          
                                          <div className="flex-1 overflow-y-auto py-4">
                                            {employeeList.length === 0 ? (
                                              <div className="text-center py-8">
                                                <Users className="h-12 w-12 text-gray-400 mx-auto mb-3" />
                                                <p className="text-gray-500 dark:text-gray-300">No employees in this category</p>
                                              </div>
                                            ) : (
                                              <div className="border rounded-lg overflow-hidden" role="region" aria-label="Employee list">
                                                <div className="max-h-[60vh] overflow-y-auto scroll-smooth">
                                                  <table className="min-w-full text-sm" role="table" aria-label="Employees">
                                                    <thead className="bg-gray-50 sticky top-0 z-10" role="rowgroup">
                                                      <tr role="row">
                                                        <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Name</th>
                                                        <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Employee ID</th>
                                                        <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Branch</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody className="bg-white divide-y divide-gray-200" role="rowgroup">
                                                      {employeeList.map((employee, index) => (
                                                        <tr
                                                          key={`${employee.user_id}-${index}`}
                                                          role="row"
                                                          tabIndex={0}
                                                          className="hover:bg-blue-50 dark:hover:bg-black focus:bg-blue-100 outline-none cursor-default"
                                                          onKeyDown={(e) => {
                                                            const rows = Array.from(e.currentTarget.parentElement?.querySelectorAll('tr') || []);
                                                            const i = rows.indexOf(e.currentTarget);
                                                            if (e.key === 'ArrowDown') { const next = rows[i+1]; if (next) next.focus(); }
                                                            if (e.key === 'ArrowUp') { const prev = rows[i-1]; if (prev) prev.focus(); }
                                                          }}
                                                        >
                                                          <td className="px-4 py-2 text-gray-900 dark:text-white font-medium" role="cell">{employee.user_name}</td>
                                                          <td className="px-4 py-2 text-gray-700 dark:text-gray-100" role="cell">{employee.employee_id || 'N/A'}</td>
                                                          <td className="px-4 py-2 text-gray-700 dark:text-gray-100" role="cell">{employee.branch || 'No Branch'}</td>
                                                        </tr>
                                                      ))}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                          
                                          <div className="flex justify-end pt-4 border-t">
                                            <Button onClick={() => setIsEmployeeListModalOpen(false)}>
                                              Close
                                            </Button>
                                          </div>
                                        </DialogContent>
                                      </Dialog>
                                    </div>
                                  );
                                };

                                // Reset pagination when filters change
                                useEffect(() => {
                                  setCurrentPage(1);
                                }, [reportFilters.startDate, reportFilters.endDate, reportFilters.employeeId, reportFilters.branch, reportFilters.status]);

                                // Transfer reports attendance data to payroll detailed view
                                const transferReportsToPayrollAttendance = () => {
                                  // Navigate to payroll section with the current filtered attendance data
                                  setActiveMenuItem('payroll-dashboard');
                                  // Optionally show a success message
                                  toast.success('Navigated to Payroll Dashboard with attendance data');
                                };

                                // Calculate Employee Statistics for Reports
                                const employeeStats = useMemo(() => {
                                  const stats = {};
                                  
                                  filteredEmployeeAttendance.forEach(record => {
                                    if (!record.user_id) return;
                                    
                                    if (!stats[record.user_id]) {
                                      stats[record.user_id] = {
                                        userId: record.user_id,
                                        name: record.user_name || 'Unknown',
                                        presentDays: new Set(),
                                        absentCount: 0,
                                        lateCount: 0,
                                        lateMinutes: 0,
                                        undertimeCount: 0,
                                        undertimeMinutes: 0
                                      };
                                    }
                                    
                                    const empStats = stats[record.user_id];
                                    const employee = employees.find(e => e.id === record.user_id);
                                    
                                    // Check for explicit absent status
                                    if (record.status === 'absent') {
                                      empStats.absentCount++;
                                    } else {
                                      // Count as present if not absent
                                      const dateStr = record.timestamp.split('T')[0];
                                      empStats.presentDays.add(dateStr);
                                    }
                                    
                                    // Get Schedule
                                    const scheduleId = employee?.schedule_id;
                                    const schedule = branchSchedules.find(s => String(s.id) === String(scheduleId));
                                    
                                    // Late
                                    if (record.status === 'late') {
                                      empStats.lateCount++;
                                      if (schedule) {
                                        const { lateMinutes } = computeAttendanceStatus(
                                          record.timestamp, 
                                          schedule.start_time, 
                                          schedule.end_time, 
                                          record.type
                                        );
                                        empStats.lateMinutes += lateMinutes || 0;
                                      }
                                    }
                                    
                                    // Undertime
                                    if (record.status === 'undertime') {
                                      empStats.undertimeCount++;
                                      if (schedule) {
                                         const { undertimeMinutes } = computeAttendanceStatus(
                                          record.timestamp, 
                                          schedule.start_time, 
                                          schedule.end_time, 
                                          record.type
                                        );
                                        empStats.undertimeMinutes += undertimeMinutes || 0;
                                      }
                                    }
                                  });
                                  
                                  return Object.values(stats);
                                }, [filteredEmployeeAttendance, employees, branchSchedules]);

                                // Reports Content (existing reports tab)
                                const renderReports = () => {
                                  // Calculate pagination for Daily Attendance
                                  const totalRecords = filteredAttendance.length;
                                  const totalPages = Math.ceil(totalRecords / itemsPerPage);
                                  const startIndex = (currentPage - 1) * itemsPerPage;
                                  const endIndex = startIndex + itemsPerPage;
                                  const currentRecords = filteredAttendance.slice(startIndex, endIndex);
                                  
                                  // Calculate pagination for Employee Attendance
                                  const totalEmployeeRecords = employeeStats.length;
                                  const totalEmployeePages = Math.ceil(totalEmployeeRecords / employeeItemsPerPage);
                                  const startEmployeeIndex = (employeeCurrentPage - 1) * employeeItemsPerPage;
                                  const currentEmployeeStats = employeeStats.slice(startEmployeeIndex, startEmployeeIndex + employeeItemsPerPage);

                                  return (
                                    <div className="h-full flex flex-col">
                                      <Tabs value={activeReportTab} onValueChange={setActiveReportTab} className="h-full flex flex-col">
                                        <div className="flex justify-center mb-4">
                                          <TabsList>
                                            <TabsTrigger value="daily">Daily Attendance</TabsTrigger>
                                            <TabsTrigger value="employee">Employee Attendance</TabsTrigger>
                                          </TabsList>
                                        </div>

                                        <TabsContent value="daily" className="flex-1 flex flex-col min-h-0 mt-0 h-full">
                                          {isTabLoading ? (
                                            <div className="h-full flex items-center justify-center animate-in fade-in zoom-in-95 duration-300">
                                              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
                                            </div>
                                          ) : (
                                            <div className="h-full flex flex-col animate-in fade-in slide-in-from-bottom-4 duration-500 ease-out">
                                            {/* Fixed Filter Section */}
                                      <div className="flex-shrink-0 mb-6">
                                        <Card className="glass shadow-lg border-0">
                                          <CardContent>
                                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                                              <div>
                                                <Label>From Date</Label>
                                                <Popover>
                                                  <PopoverTrigger asChild>
                                                    <Button
                                                      variant="outline"
                                                      className={cn(
                                                        "w-full justify-start text-left font-normal",
                                                        !reportFilters.startDate && "text-muted-foreground"
                                                      )}
                                                    >
                                                      <CalendarIcon className="mr-2 h-4 w-4" />
                                                      {reportFilters.startDate ? 
                                                        format(new Date(reportFilters.startDate), "MMM dd, yyyy") : 
                                                        "Pick start date"
                                                      }
                                                    </Button>
                                                  </PopoverTrigger>
                                                  <PopoverContent className="w-auto p-0" align="start">
                                                    <CalendarComponent
                                                      mode="single"
                                                      selected={reportFilters.startDate ? new Date(reportFilters.startDate) : undefined}
                                                      onSelect={(date) => {
                                                        const dateStr = date ? format(date, 'yyyy-MM-dd') : '';
                                                        setReportFilters({...reportFilters, startDate: dateStr});
                                                      }}
                                                      disabled={(date) => date > new Date() || date < new Date("1900-01-01")}
                                                      initialFocus
                                                    />
                                                  </PopoverContent>
                                                </Popover>
                                              </div>

                                              <div>
                                                <Label>To Date</Label>
                                                <Popover>
                                                  <PopoverTrigger asChild>
                                                    <Button
                                                      variant="outline"
                                                      className={cn(
                                                        "w-full justify-start text-left font-normal",
                                                        !reportFilters.endDate && "text-muted-foreground"
                                                      )}
                                                    >
                                                      <CalendarIcon className="mr-2 h-4 w-4" />
                                                      {reportFilters.endDate ? 
                                                        format(new Date(reportFilters.endDate), "MMM dd, yyyy") : 
                                                        "Pick end date"
                                                      }
                                                    </Button>
                                                  </PopoverTrigger>
                                                  <PopoverContent className="w-auto p-0" align="start">
                                                    <CalendarComponent
                                                      mode="single"
                                                      selected={reportFilters.endDate ? new Date(reportFilters.endDate) : undefined}
                                                      onSelect={(date) => {
                                                        const dateStr = date ? format(date, 'yyyy-MM-dd') : '';
                                                        setReportFilters({...reportFilters, endDate: dateStr});
                                                      }}
                                                      disabled={(date) => 
                                                        date > new Date() || 
                                                        date < new Date("1900-01-01") ||
                                                        (reportFilters.startDate && date < new Date(reportFilters.startDate))
                                                      }
                                                      initialFocus
                                                    />
                                                  </PopoverContent>
                                                </Popover>
                                              </div>

                                              <div>
                                                <Label>Branch</Label>
                                                <Select
                                                  value={reportFilters.branch}
                                                  onValueChange={(value) => setReportFilters({...reportFilters, branch: value})}
                                                >
                                                  <SelectTrigger>
                                                    <SelectValue placeholder="Select branch" />
                                                  </SelectTrigger>
                                                  <SelectContent>
                                                    <SelectItem value="all">All Branches</SelectItem>
                                                    {getUniqueBranches().map(branch => (
                                                      <SelectItem key={branch} value={branch}>
                                                        {branch}
                                                      </SelectItem>
                                                    ))}
                                                  </SelectContent>
                                                </Select>
                                              </div>

                                              <div>
                                                <Label>Employee Name</Label>
                                                <Input
                                                  type="text"
                                                  placeholder="Enter employee name (leave empty for all employees)"
                                                  value={reportFilters.employeeId === 'all' ? '' : reportFilters.employeeId}
                                                  onChange={(e) => setReportFilters({
                                                    ...reportFilters, 
                                                    employeeId: e.target.value.trim() === '' ? 'all' : e.target.value
                                                  })}
                                                  className="w-full"
                                                />
                                              </div>

                                              <div>
                                                <Label>Status Filter</Label>
                                                <Select
                                                  value={reportFilters.status || 'all'}
                                                  onValueChange={(value) => setReportFilters({...reportFilters, status: value})}
                                                >
                                                  <SelectTrigger>
                                                    <SelectValue placeholder="Select status" />
                                                  </SelectTrigger>
                                                      <SelectContent>
                                                        <SelectItem value="all">All Status</SelectItem>
                                                        <SelectItem value="on_time">On Time</SelectItem>
                                                        <SelectItem value="late">Late</SelectItem>
                                                        <SelectItem value="undertime">Undertime</SelectItem>
                                                        <SelectItem value="no_schedule">No Schedule</SelectItem>
                                                        <SelectItem value="no_time_out">No Time Out</SelectItem>
                                                        <SelectItem value="absent">Absent</SelectItem>
                                                      </SelectContent>
                                                    </Select>
                                              </div>

                                              <div>
                                                <Label>Start Time</Label>
                                                <Input
                                                  type="time"
                                                  value={reportFilters.startTime}
                                                  onChange={(e) => setReportFilters({...reportFilters, startTime: e.target.value})}
                                                  className="w-full"
                                                />
                                              </div>

                                              <div>
                                                <Label>End Time</Label>
                                                <Input
                                                  type="time"
                                                  value={reportFilters.endTime}
                                                  onChange={(e) => setReportFilters({...reportFilters, endTime: e.target.value})}
                                                  className="w-full"
                                                />
                                              </div>
                                            </div>

                                            <div className="flex gap-2 mt-4">
                                              <Button
                                                onClick={() => {
                                                  setReportFilters({
                                                    startDate: '',
                                                    endDate: '',
                                                    startTime: '',
                                                    endTime: '',
                                                    employeeId: 'all',
                                                    attendanceType: 'all',
                                                    branch: 'all',
                                                    status: 'all'
                                                  });
                                                  setCurrentPage(1);
                                                }}
                                                variant="outline"
                                              >
                                                Clear Filters
                                              </Button>
                                              <Button
                                                onClick={() => setIsImportCSVModalOpen(true)}
                                                variant="outline"
                                                className="bg-green-50 hover:bg-green-100"
                                              >
                                                <Upload className="h-4 w-4 mr-2" />
                                                Import CSV
                                              </Button>
                                              <Button 
                                                onClick={exportToCSV}
                                                variant="outline"
                                                disabled={filteredAttendance.length === 0}
                                              >
                                                <FileDown className="h-4 w-4 mr-2" />
                                                Export CSV
                                              </Button>
                                            </div>
                                          </CardContent>
                                        </Card>
                                      </div>

                                      {/* Fixed Header + Scrollable Table */}
                                      <div className="flex-1 min-h-0">
                                        <Card className="glass shadow-lg border-0 h-full flex flex-col">
                                          <CardHeader className="flex-shrink-0 pb-0">
                                            <div className="flex justify-between items-start">
                                              <div>
                                                <CardTitle>Attendance Records</CardTitle>
                                                <CardDescription>
                                                  Showing {startIndex + 1}-{Math.min(endIndex, totalRecords)} of {totalRecords} records
                                                  {totalPages > 1 && ` (Page ${currentPage} of ${totalPages})`}
                                                </CardDescription>
                                              </div>
                                              
                                              {/* Entries per page selector */}
                                              <div className="flex items-center gap-2">
                                                <Label className="text-sm text-gray-600 dark:text-gray-200">Show:</Label>
                                                <Select
                                                  value={itemsPerPage.toString()}
                                                  onValueChange={(value) => {
                                                    setItemsPerPage(parseInt(value));
                                                    setCurrentPage(1);
                                                  }}
                                                >
                                                  <SelectTrigger className="w-20">
                                                    <SelectValue />
                                                  </SelectTrigger>
                                                  <SelectContent>
                                                    <SelectItem value="20">20</SelectItem>
                                                    <SelectItem value="30">30</SelectItem>
                                                    <SelectItem value="40">40</SelectItem>
                                                    <SelectItem value="50">50</SelectItem>
                                                  </SelectContent>
                                                </Select>
                                                <Label className="text-sm text-gray-600 dark:text-gray-200">entries</Label>
                                              </div>
                                            </div>
                                          </CardHeader>
                                          <CardContent className="flex-1 min-h-0 p-0 flex flex-col">
                                            {/* Fixed Table Header */}
                                            <div className="flex-shrink-0 border-b bg-gray-50">
                                              <table className="w-full table-fixed">
                                                <thead>
                                                  <tr className="border-b border-gray-200">
                                                    <th className="text-left p-4 font-medium text-gray-900 dark:text-white bg-gray-50">Date</th>
                                                    <th className="text-left p-4 font-medium text-gray-900 dark:text-white bg-gray-50">Time</th>
                                                    <th className="text-left p-4 font-medium text-gray-900 dark:text-white bg-gray-50">Employee</th>
                                                    <th className="text-left p-4 font-medium text-gray-900 dark:text-white bg-gray-50">Branch</th>
                                                    <th className="text-left p-4 font-medium text-gray-900 dark:text-white bg-gray-50">Type</th>
                                                    <th className="text-left p-4 font-medium text-gray-900 dark:text-white bg-gray-50">Status</th>
                                                    <th className="text-left p-4 font-medium text-gray-900 dark:text-white bg-gray-50">Location</th>
                                                    <th className="text-left p-4 font-medium text-gray-900 dark:text-white bg-gray-50">Comments</th>
                                                    <th className="text-left p-4 font-medium text-gray-900 dark:text-white bg-gray-50">Photo</th>
                                                    <th className="text-left p-4 font-medium text-gray-900 dark:text-white bg-gray-50">Actions</th>
                                                  </tr>
                                                </thead>
                                              </table>
                                            </div>
                                            
                                            {/* Scrollable Table Body */}
                                            <div
                                              className="flex-1 overflow-y-scroll overflow-x-auto h-[70vh] scroll-smooth"
                                              role="region"
                                              aria-label="Attendance records"
                                              style={{ scrollbarColor: '#cbd5e1 transparent', scrollbarWidth: 'thin' }}
                                            >
                                              <table className="w-full min-w-[1100px] border-collapse table-fixed">
                                                <tbody>
                                                  {currentRecords.map((record) => (
                                                    <tr key={record.id} className="border-b border-gray-100 hover:bg-gray-50 dark:hover:bg-black">
                                                      <td className="p-4">{formatDateFromBackend(record.timestamp)}</td>
                                                      <td className="p-4">{formatTimeHHMMFromBackend(record.timestamp)}</td>
                                                      <td className="p-4">{record.user_name}</td>
                                                      <td className="p-4">{getBranchForAttendanceRecord(record)}</td>
                                                      <td className="p-4">
                                                        <span className={`px-2 py-1 rounded text-xs font-medium ${
                                                          record.type === 'time_in' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                                                        }`}>
                                                          {record.type.replace('_', ' ').toUpperCase()}
                                                        </span>
                                                      </td>
                                                      <td className="p-4">
                                                        {record.status && (
                                                          <span className={`px-2 py-1 rounded text-xs font-medium ${
                                                            record.status === 'on_time' ? 'bg-green-100 text-green-800' :
                                                            record.status === 'late' ? 'bg-orange-100 text-orange-800' :
                                                            record.status === 'undertime' ? 'bg-yellow-100 text-yellow-800' :
                                                            'bg-gray-100 text-gray-800 dark:text-white'
                                                          }`}>
                                                            {record.status === 'on_time' ? 'ON TIME' :
                                                            record.status === 'late' ? 'LATE' :
                                                            record.status === 'undertime' ? 'UNDERTIME' :
                                                            record.status?.toUpperCase() || 'N/A'}
                                                          </span>
                                                        )}
                                                      </td>
                                                      <td className="p-4 max-w-xs">
                                                        {record.location ? (
                                                          <div className="text-xs">
                                                            <div className="font-medium">{record.location.address || 'Unknown Address'}</div>
                                                            {record.location.latitude && record.location.longitude && (
                                                              <div className="text-gray-500 dark:text-gray-300">
                                                                {record.location.latitude.toFixed(4)}, {record.location.longitude.toFixed(4)}
                                                              </div>
                                                            )}
                                                          </div>
                                                        ) : (
                                                          <span className="text-xs text-gray-400">No Location</span>
                                                        )}
                                                      </td>
                                                      <td className="p-4 max-w-xs">
                                                        {record.comment ? (
                                                          <div>
                                                            <div className="text-xs text-gray-700 dark:text-gray-100 truncate">
                                                              {record.comment.length > 50 ? `${record.comment.substring(0, 50)}...` : record.comment}
                                                            </div>
                                                            {record.comment.length > 50 && (
                                                              <button
                                                                onClick={() => {
                                                                  setSelectedCommentRecord(record);
                                                                  setIsCommentModalOpen(true);
                                                                }}
                                                                className="text-xs text-blue-600 hover:text-blue-800 underline mt-1"
                                                              >
                                                                View Full Comment
                                                              </button>
                                                            )}
                                                          </div>
                                                        ) : (
                                                          <span className="text-xs text-gray-400">No Comments</span>
                                                        )}
                                                      </td>
                                                      <td className="p-4">
                                                        {record.photo_url ? (
                                                          <div className="flex items-center space-x-2">
                                                            <img 
                                                              src={(() => {
                                                                // Extract file_id from Google Drive URL and use proxy
                                                                const match = record.photo_url.match(/[?&]id=([a-zA-Z0-9_-]+)/);
                                                                if (match && match[1]) {
                                                                  return `${process.env.REACT_APP_BACKEND_URL}/api/proxy-image/${match[1]}`;
                                                                }
                                                                // Fallback to original URL
                                                                return record.photo_url;
                                                              })()}
                                                              alt="Attendance" 
                                                              className="w-8 h-8 rounded-full object-cover cursor-pointer hover:opacity-80 transition-opacity"
                                                              onClick={() => {
                                                                setSelectedPhotoRecord(record);
                                                                setIsPhotoModalOpen(true);
                                                              }}
                                                              onError={(e) => {
                                                                console.error('Image load error:', record.photo_url);
                                                                e.target.style.display = 'none';
                                                                e.target.nextSibling.textContent = '\u26a0\ufe0f';
                                                              }}
                                                            />
                                                            <span className="text-xs text-green-600">&#10003;</span>
                                                          </div>
                                                        ) : (
                                                          <span className="text-xs text-gray-400">No Photo</span>
                                                        )}
                                                      </td>
                                                      <td className="p-4">
                                                        <div className="flex space-x-2">
                                                          <Button
                                                            size="sm"
                                                            variant="ghost"
                                                            onClick={() => {
                                                              // Parse timestamp to date and time for editing (Taipei)
                                                              const localDate = toTaipeiISODate(record.timestamp);
                                                              const localTime = formatTaipeiTime24(record.timestamp);
                                                              
                                                              setSelectedAttendance({
                                                                ...record,
                                                                editDate: localDate,
                                                                editTime: localTime
                                                              });
                                                              setIsEditAttendanceDialogOpen(true);
                                                            }}
                                                          >
                                                            <Edit className="h-3 w-3" />
                                                          </Button>
                                                          <Button
                                                            size="sm"
                                                            variant="ghost"
                                                            onClick={() => handleDeleteAttendance(record.id, record.user_name)}
                                                            className="text-red-600 hover:text-red-800"
                                                          >
                                                            <Trash2 className="h-3 w-3" />
                                                          </Button>
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  ))}
                                                </tbody>
                                              </table>
                                              
                                              {/* Empty State */}
                                              {currentRecords.length === 0 && (
                                                <div className="flex flex-col items-center justify-center py-12">
                                                  <CalendarCheck className="h-16 w-16 text-gray-400 mb-4" />
                                                  <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">No attendance records found</h3>
                                                  <p className="text-gray-500 dark:text-gray-300 text-center">
                                                    Try adjusting your filters or check back later for new records.
                                                  </p>
                                                </div>
                                              )}
                                            </div>
                                          </CardContent>
                                          
                                          {/* Pagination Controls */}
                                          {(totalPages > 1 || !isAllAttendanceLoaded) && (
                                            <div className="flex-shrink-0 border-t bg-gray-50 px-6 py-3">
                                              <div className="flex items-center justify-between">
                                                <div className="text-sm text-gray-700 dark:text-gray-100">
                                                  Showing {startIndex + 1} to {Math.min(endIndex, totalRecords)} of {totalRecords} results
                                                </div>
                                                
                                                <div className="flex items-center space-x-2">
                                                  {/* Previous Button */}
                                                  <Button
                                                    variant="outline"
                                                    size="sm"
                                                    onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                                                    disabled={currentPage === 1}
                                                  >
                                                    <ChevronLeft className="h-4 w-4" />
                                                    Previous
                                                  </Button>
                                                  
                                                  {/* Page Numbers */}
                                                  <div className="flex items-center space-x-2">
                                                    {/* First page */}
                                                    {currentPage > 3 && (
                                                      <>
                                                        <Button
                                                          variant={1 === currentPage ? "default" : "outline"}
                                                          size="sm"
                                                          onClick={() => setCurrentPage(1)}
                                                        >
                                                          1
                                                        </Button>
                                                        {currentPage > 4 && <span className="text-gray-500 dark:text-gray-300">...</span>}
                                                      </>
                                                    )}
                                                    
                                                    {/* Surrounding pages */}
                                                    {Array.from({ length: totalPages }, (_, i) => i + 1)
                                                      .filter(page => 
                                                        page >= Math.max(1, currentPage - 2) && 
                                                        page <= Math.min(totalPages, currentPage + 2)
                                                      )
                                                      .map(page => (
                                                        <Button
                                                          key={page}
                                                          variant={page === currentPage ? "default" : "outline"}
                                                          size="sm"
                                                          onClick={() => setCurrentPage(page)}
                                                        >
                                                          {page}
                                                        </Button>
                                                      ))
                                                    }
                                                    
                                                    {/* Last page */}
                                                    {currentPage < totalPages - 2 && (
                                                      <>
                                                        {currentPage < totalPages - 3 && <span className="text-gray-500 dark:text-gray-300">...</span>}
                                                        <Button
                                                          variant={totalPages === currentPage ? "default" : "outline"}
                                                          size="sm"
                                                          onClick={() => setCurrentPage(totalPages)}
                                                        >
                                                          {totalPages}
                                                        </Button>
                                                      </>
                                                    )}
                                                  </div>
                                                  
                                                  {/* Next Button */}
                                                  <Button
                                                    variant="outline"
                                                    size="sm"
                                                    onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                                                    disabled={currentPage === totalPages}
                                                  >
                                                    Next
                                                    <ChevronRight className="h-4 w-4" />
                                                  </Button>
                                                  
                                                  {/* Load More Button */}
                                                  {!isAllAttendanceLoaded && (
                                                    <Button
                                                      variant="outline"
                                                      size="sm"
                                                      onClick={() => fetchAttendance(true)}
                                                      disabled={isLoadingMoreAttendance}
                                                      className="ml-2"
                                                      data-testid="attendance-load-more-btn"
                                                    >
                                                      {isLoadingMoreAttendance ? (
                                                        <>
                                                          <Loader2 className="h-4 w-4 mr-1 animate-spin" />
                                                          Loading...
                                                        </>
                                                      ) : (
                                                        'Load More'
                                                      )}
                                                    </Button>
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </Card>
                                      </div>

                                      {/* CSV Import Modal */}
                                      <Dialog open={isImportCSVModalOpen} onOpenChange={setIsImportCSVModalOpen}>
                                        <DialogContent className="sm:max-w-[500px]">
                                          <DialogHeader>
                                            <DialogTitle>Import Attendance Records from CSV</DialogTitle>
                                            <DialogDescription>
                                              Upload a CSV file with attendance records to import into the system
                                            </DialogDescription>
                                          </DialogHeader>
                                          
                                          <div className="space-y-4 py-4">
                                            <div>
                                              <Label>CSV File Format</Label>
                                              <p className="text-sm text-gray-500 dark:text-gray-300 mb-2">
                                                Supported formats:
                                              </p>
                                              <code className="text-xs bg-gray-100 p-2 rounded block">
                                                Date, Time, Employee, Branch, Type, Status, Location, Comments
                                              </code>
                                              <p className="text-xs text-gray-500 dark:text-gray-300 mt-1">
                                                Example: Oct 24, 2025, 09:00 AM, Juan Dela Cruz, Main Branch, time_in, on_time, ,
                                              </p>
                                              <p className="text-xs text-gray-500 dark:text-gray-300 mt-2">
                                                Or simplified:
                                              </p>
                                              <code className="text-xs bg-gray-100 p-2 rounded block">
                                                employee_id, date (YYYY-MM-DD), time (HH:MM[:SS]), type, status
                                              </code>
                                              <p className="text-xs text-gray-500 dark:text-gray-300 mt-1">
                                                Example: E001, 2025-10-24, 09:00, time_in, on_time
                                              </p>
                                            </div>
                                            
                                            <div>
                                              <Label>Select CSV File</Label>
                                              <Input
                                                type="file"
                                                accept=".csv"
                                                onChange={(e) => setCsvFile(e.target.files[0])}
                                                className="mt-1"
                                              />
                                            </div>
                                            
                                            {csvImportProgress && (
                                              <div className="bg-blue-50 border border-blue-200 rounded p-3">
                                                <p className="text-sm text-blue-800">{csvImportProgress}</p>
                                              </div>
                                            )}
                                          </div>
                                          
                                          <div className="flex justify-end gap-2">
                                            <Button
                                              variant="outline"
                                              onClick={() => {
                                                setIsImportCSVModalOpen(false);
                                                setCsvFile(null);
                                                setCsvImportProgress('');
                                              }}
                                            >
                                              Cancel
                                            </Button>
                                            <Button
                                              onClick={handleCSVImport}
                                              disabled={!csvFile || csvImportProgress !== ''}
                                              className="bg-green-600 hover:bg-green-700"
                                            >
                                              <Upload className="h-4 w-4 mr-2" />
                                              Import CSV
                                            </Button>
                                          </div>
                                        </DialogContent>
                                      </Dialog>
                                          </div>
                                          )}
                                        </TabsContent>

                                        <TabsContent value="employee" className="flex-1 flex flex-col min-h-0 mt-0 h-full">
                                          {isTabLoading ? (
                                            <div className="h-full flex items-center justify-center animate-in fade-in zoom-in-95 duration-300">
                                              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
                                            </div>
                                          ) : (
                                            <div className="h-full flex flex-col animate-in fade-in slide-in-from-bottom-4 duration-500 ease-out">
                                               <div className="flex-shrink-0 mb-6">
                                            <Card className="glass shadow-lg border-0">
                                              <CardContent className="pt-6">
                                                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                                                  <div>
                                                    <Label>Employee Name</Label>
                                                    <Input
                                                      type="text"
                                                      placeholder="Enter employee name"
                                                      value={employeeReportFilters.employeeId === 'all' ? '' : employeeReportFilters.employeeId}
                                                      onChange={(e) => setEmployeeReportFilters({
                                                        ...employeeReportFilters, 
                                                        employeeId: e.target.value.trim() === '' ? 'all' : e.target.value
                                                      })}
                                                      className="w-full"
                                                    />
                                                  </div>
                                                  <div>
                                                    <Label>From Date</Label>
                                                    <Popover>
                                                      <PopoverTrigger asChild>
                                                        <Button
                                                          variant="outline"
                                                          className={cn(
                                                            "w-full justify-start text-left font-normal",
                                                            !employeeReportFilters.startDate && "text-muted-foreground"
                                                          )}
                                                        >
                                                          <CalendarIcon className="mr-2 h-4 w-4" />
                                                          {employeeReportFilters.startDate ? 
                                                            format(new Date(employeeReportFilters.startDate), "MMM dd, yyyy") : 
                                                            "Pick start date"
                                                          }
                                                        </Button>
                                                      </PopoverTrigger>
                                                      <PopoverContent className="w-auto p-0" align="start">
                                                        <CalendarComponent
                                                          mode="single"
                                                          selected={employeeReportFilters.startDate ? new Date(employeeReportFilters.startDate) : undefined}
                                                          onSelect={(date) => {
                                                            const dateStr = date ? format(date, 'yyyy-MM-dd') : '';
                                                            setEmployeeReportFilters({...employeeReportFilters, startDate: dateStr});
                                                          }}
                                                          disabled={(date) => date > new Date() || date < new Date("1900-01-01")}
                                                          initialFocus
                                                        />
                                                      </PopoverContent>
                                                    </Popover>
                                                  </div>
                                                  <div>
                                                    <Label>To Date</Label>
                                                    <Popover>
                                                      <PopoverTrigger asChild>
                                                        <Button
                                                          variant="outline"
                                                          className={cn(
                                                            "w-full justify-start text-left font-normal",
                                                            !employeeReportFilters.endDate && "text-muted-foreground"
                                                          )}
                                                        >
                                                          <CalendarIcon className="mr-2 h-4 w-4" />
                                                          {employeeReportFilters.endDate ? 
                                                            format(new Date(employeeReportFilters.endDate), "MMM dd, yyyy") : 
                                                            "Pick end date"
                                                          }
                                                        </Button>
                                                      </PopoverTrigger>
                                                      <PopoverContent className="w-auto p-0" align="start">
                                                        <CalendarComponent
                                                          mode="single"
                                                          selected={employeeReportFilters.endDate ? new Date(employeeReportFilters.endDate) : undefined}
                                                          onSelect={(date) => {
                                                            const dateStr = date ? format(date, 'yyyy-MM-dd') : '';
                                                            setEmployeeReportFilters({...employeeReportFilters, endDate: dateStr});
                                                          }}
                                                          disabled={(date) => 
                                                            date > new Date() || 
                                                            date < new Date("1900-01-01") ||
                                                            (employeeReportFilters.startDate && date < new Date(employeeReportFilters.startDate))
                                                          }
                                                          initialFocus
                                                        />
                                                      </PopoverContent>
                                                    </Popover>
                                                  </div>
                                                  <div className="flex items-end">
                                                    <Button
                                                        onClick={() => {
                                                          setEmployeeReportFilters({
                                                            startDate: '',
                                                            endDate: '',
                                                            employeeId: 'all'
                                                          });
                                                        }}
                                                        variant="outline"
                                                        className="w-full"
                                                      >
                                                        Clear Filters
                                                      </Button>
                                                  </div>
                                                </div>
                                              </CardContent>
                                            </Card>
                                           </div>
                                           <div className="flex-1 min-h-0">
                                              <Card className="glass shadow-lg border-0 h-full flex flex-col">
                                                <CardHeader>
                                                  <div className="flex justify-between items-start">
                                                    <div>
                                                      <CardTitle>Employee Attendance Summary</CardTitle>
                                                      <CardDescription>
                                                        Aggregated attendance statistics
                                                      </CardDescription>
                                                    </div>
                                                    <div className="flex items-center gap-2">
                                                      <Label className="text-sm text-gray-600 dark:text-gray-200">Show:</Label>
                                                      <Select
                                                        value={employeeItemsPerPage.toString()}
                                                        onValueChange={(value) => {
                                                          setEmployeeItemsPerPage(parseInt(value));
                                                          setEmployeeCurrentPage(1);
                                                        }}
                                                      >
                                                        <SelectTrigger className="w-20">
                                                          <SelectValue />
                                                        </SelectTrigger>
                                                        <SelectContent>
                                                          <SelectItem value="10">10</SelectItem>
                                                          <SelectItem value="20">20</SelectItem>
                                                          <SelectItem value="50">50</SelectItem>
                                                          <SelectItem value="100">100</SelectItem>
                                                        </SelectContent>
                                                      </Select>
                                                      <Label className="text-sm text-gray-600 dark:text-gray-200">entries</Label>
                                                    </div>
                                                  </div>
                                                </CardHeader>
                                                <CardContent className="flex-1 min-h-0 p-0 flex flex-col">
                                                  <div className="flex-1 overflow-y-scroll overflow-x-auto h-[70vh] scroll-smooth">
                                                    <table className="w-full min-w-[800px] border-collapse table-fixed">
                                                      <thead className="bg-gray-50 sticky top-0 z-10">
                                                        <tr className="border-b border-gray-200">
                                                          <th className="text-left p-4 font-medium text-gray-900 dark:text-white bg-gray-50">Employee Name</th>
                                                          <th className="text-left p-4 font-medium text-gray-900 dark:text-white bg-gray-50">Total Present Days</th>
                                                          <th className="text-left p-4 font-medium text-gray-900 dark:text-white bg-gray-50">Total Absents</th>
                                                          <th className="text-left p-4 font-medium text-gray-900 dark:text-white bg-gray-50">Total Lates</th>
                                                          <th className="text-left p-4 font-medium text-gray-900 dark:text-white bg-gray-50">Total Undertime</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        {currentEmployeeStats.map((stat) => (
                                                          <tr key={stat.userId} className="border-b border-gray-100 hover:bg-gray-50 dark:hover:bg-black">
                                                            <td className="p-4 font-medium">{stat.name}</td>
                                                            <td className="p-4">{stat.presentDays.size}</td>
                                                            <td className="p-4">{stat.absentCount}</td>
                                                            <td className="p-4">
                                                              <div className="font-medium">{stat.lateCount} days</div>
                                                              <div className="text-xs text-gray-500">({stat.lateMinutes} mins)</div>
                                                            </td>
                                                            <td className="p-4">
                                                              <div className="font-medium">{stat.undertimeCount} days</div>
                                                              <div className="text-xs text-gray-500">({stat.undertimeMinutes} mins)</div>
                                                            </td>
                                                          </tr>
                                                        ))}
                                                        {employeeStats.length === 0 && (
                                                          <tr>
                                                            <td colSpan={5} className="p-8 text-center text-gray-500">
                                                              No employee data found based on current filters.
                                                            </td>
                                                          </tr>
                                                        )}
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                  
                                                  {/* Employee Pagination */}
                                                  {totalEmployeePages > 1 && (
                                                    <div className="flex justify-center items-center gap-2 p-4 border-t border-gray-100 bg-white dark:bg-zinc-900">
                                                      <Button
                                                        variant="outline"
                                                        size="sm"
                                                        onClick={() => setEmployeeCurrentPage(p => Math.max(1, p - 1))}
                                                        disabled={employeeCurrentPage === 1}
                                                      >
                                                        Previous
                                                      </Button>
                                                      <span className="text-sm text-gray-600 dark:text-gray-300">
                                                        Page {employeeCurrentPage} of {totalEmployeePages}
                                                      </span>
                                                      <Button
                                                        variant="outline"
                                                        size="sm"
                                                        onClick={() => setEmployeeCurrentPage(p => Math.min(totalEmployeePages, p + 1))}
                                                        disabled={employeeCurrentPage === totalEmployeePages}
                                                      >
                                                        Next
                                                      </Button>
                                                    </div>
                                                  )}
                                                </CardContent>
                                              </Card>
                                           </div>
                                          </div>
                                          )}
                                        </TabsContent>
                                      </Tabs>
                                    </div>
                                  );
                                };

                                // Schedules Content - Branch-Based Scheduling
                                const renderSchedules = () => {
                                  return (
                                    <div className="space-y-6">
                                      <div className="flex justify-between items-center">
                                        <Dialog open={isCreateBranchScheduleDialogOpen} onOpenChange={setIsCreateBranchScheduleDialogOpen}>
                                          <DialogTrigger asChild>
                                            <Button className="bg-indigo-600 hover:bg-indigo-700">
                                              <Plus className="h-4 w-4 mr-2" />
                                              Add Schedule
                                            </Button>
                                          </DialogTrigger>
                                          <DialogContent>
                                            <DialogHeader>
                                              <DialogTitle>Create Schedule</DialogTitle>
                                            </DialogHeader>
                                            <form onSubmit={handleCreateBranchSchedule} className="space-y-4">
                                              <div>
                                                <Label>Schedule Name</Label>
                                                <Input
                                                  value={newBranchSchedule.branch_name}
                                                  onChange={(e) => setNewBranchSchedule({ ...newBranchSchedule, branch_name: e.target.value })}
                                                  placeholder="Enter schedule name"
                                                  required
                                                />
                                              </div>
                                              
                                              <div className="grid grid-cols-2 gap-4">
                                                <div>
                                                  <Label>Start Time</Label>
                                                  <Input
                                                    type="time"
                                                    value={newBranchSchedule.start_time}
                                                    onChange={(e) => setNewBranchSchedule({...newBranchSchedule, start_time: e.target.value})}
                                                    required
                                                  />
                                                </div>
                                                
                                                <div>
                                                  <Label>End Time</Label>
                                                  <Input
                                                    type="time"
                                                    value={newBranchSchedule.end_time}
                                                    onChange={(e) => setNewBranchSchedule({...newBranchSchedule, end_time: e.target.value})}
                                                    required
                                                  />
                                                </div>
                                              </div>
                                              
                                              <div className="text-sm text-gray-600 dark:text-gray-200 bg-blue-50 p-3 rounded-lg">
                                                <p><strong>Schedule Rules:</strong></p>
                                                <ul className="list-disc list-inside mt-1">
                                                  <li>Employees must clock in before start time</li>
                                                  <li>Late: Clock in 1+ minutes after start time</li>
                                                  <li>Undertime: Clock out 1+ minutes before end time</li>
                                                  <li>Clock out allowed 1 minute after end time</li>
                                                </ul>
                                              </div>
                                              
                                              <div className="flex justify-end space-x-2">
                                                <Button
                                                  type="button"
                                                  variant="outline"
                                                  onClick={() => setIsCreateBranchScheduleDialogOpen(false)}
                                                >
                                                  Cancel
                                                </Button>
                                                <Button type="submit" className="bg-indigo-600 hover:bg-indigo-700">
                                                  Create Schedule
                                                </Button>
                                              </div>
                                            </form>
                                          </DialogContent>
                                        </Dialog>
                                      </div>

                                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                        {branchSchedules.map(schedule => {
                                          const employeesInSchedule = employees.filter(emp => String(emp.schedule_id || '') === String(schedule.id));

                                          return (
                                            <Card key={schedule.id} className="glass shadow-lg border-0">
                                              <CardHeader>
                                                <CardTitle className="flex items-center justify-between">
                                                  <div className="flex items-center gap-2">
                                                    <Building2 className="h-5 w-5 text-indigo-600" />
                                                    <span>{schedule.branch_name}</span>
                                                  </div>
                                                  <span className="text-sm font-normal text-gray-500 dark:text-gray-300">
                                                    {employeesInSchedule.length} employees
                                                  </span>
                                                </CardTitle>
                                              </CardHeader>
                                              <CardContent>
                                                <div className="space-y-4">
                                                  <div className="text-center p-4 bg-indigo-50 rounded-lg">
                                                    <div className="text-2xl font-bold text-indigo-600">
                                                      {schedule.start_time} - {schedule.end_time}
                                                    </div>
                                                    <div className="text-sm text-gray-600 dark:text-gray-200 mt-1">Working Hours</div>
                                                  </div>
                                                  
                                                  <div className="flex space-x-2">
                                                    <Button
                                                      size="sm"
                                                      variant="outline"
                                                      onClick={() => {
                                                        setSelectedEnrollSchedule(schedule);
                                                        setSelectedEnrollEmployeeIds([]);
                                                        setEnrollEmployeeQuery('');
                                                        setIsEnrollScheduleDialogOpen(true);
                                                      }}
                                                      className="flex-1"
                                                    >
                                                      <Plus className="h-3 w-3 mr-1" />
                                                      +Add
                                                    </Button>
                                                    <Button
                                                      size="sm"
                                                      variant="outline"
                                                      onClick={() => {
                                                        setSelectedBranchSchedule(schedule);
                                                        setIsEditBranchScheduleDialogOpen(true);
                                                      }}
                                                      className="flex-1"
                                                    >
                                                      <Edit className="h-3 w-3 mr-1" />
                                                      Edit
                                                    </Button>
                                                    <Button
                                                      size="sm"
                                                      variant="outline"
                                                      onClick={() => handleDeleteBranchSchedule(schedule.id, schedule.branch_name)}
                                                      className="flex-1 text-red-600 hover:text-red-800"
                                                    >
                                                      <Trash2 className="h-3 w-3 mr-1" />
                                                      Delete
                                                    </Button>
                                                  </div>
                                                </div>
                                              </CardContent>
                                            </Card>
                                          );
                                        })}
                                      </div>

                                      {/* Edit Branch Schedule Dialog */}
                                      <Dialog open={isEditBranchScheduleDialogOpen} onOpenChange={setIsEditBranchScheduleDialogOpen}>
                                        <DialogContent>
                                          <DialogHeader>
                                            <DialogTitle>Edit Schedule for {selectedBranchSchedule?.branch_name}</DialogTitle>
                                          </DialogHeader>
                                          {selectedBranchSchedule && (
                                            <form onSubmit={handleUpdateBranchSchedule} className="space-y-4">
                                              <div className="grid grid-cols-2 gap-4">
                                                <div>
                                                  <Label>Start Time</Label>
                                                  <Input
                                                    type="time"
                                                    value={selectedBranchSchedule.start_time}
                                                    onChange={(e) => setSelectedBranchSchedule({
                                                      ...selectedBranchSchedule, 
                                                      start_time: e.target.value
                                                    })}
                                                    required
                                                  />
                                                </div>
                                                
                                                <div>
                                                  <Label>End Time</Label>
                                                  <Input
                                                    type="time"
                                                    value={selectedBranchSchedule.end_time}
                                                    onChange={(e) => setSelectedBranchSchedule({
                                                      ...selectedBranchSchedule, 
                                                      end_time: e.target.value
                                                    })}
                                                    required
                                                  />
                                                </div>
                                              </div>

                                              <div className="space-y-3">
                                                <div className="flex items-center justify-between">
                                                  <Label>Enrolled Employees</Label>
                                                  <span className="text-xs text-gray-500 dark:text-gray-300">
                                                    {employees.filter(emp => String(emp.schedule_id || '') === String(selectedBranchSchedule.id)).length} enrolled
                                                  </span>
                                                </div>

                                                <div className="max-h-56 overflow-auto rounded-md border p-2 space-y-2">
                                                  {employees
                                                    .filter(emp => String(emp.schedule_id || '') === String(selectedBranchSchedule.id))
                                                    .map((emp) => (
                                                      <div
                                                        key={emp.id}
                                                        className="flex items-center justify-between gap-3 rounded-md border px-3 py-2"
                                                      >
                                                        <div className="min-w-0">
                                                          <div className="font-medium text-sm text-gray-900 dark:text-white truncate">
                                                            {emp.full_name}
                                                          </div>
                                                          <div className="text-xs text-gray-500 dark:text-gray-300 truncate">
                                                            {emp.employee_id || emp.id}{emp.email ? ` \u2022 ${emp.email}` : ''}
                                                          </div>
                                                        </div>

                                                        <Button
                                                          type="button"
                                                          size="icon"
                                                          variant="outline"
                                                          onClick={() => handleRemoveEmployeeFromSchedule(emp)}
                                                          className="text-red-600 hover:text-red-800"
                                                          title={`Remove ${emp.full_name} from schedule`}
                                                        >
                                                          <Trash2 className="h-4 w-4" />
                                                        </Button>
                                                      </div>
                                                    ))}

                                                  {employees.filter(emp => String(emp.schedule_id || '') === String(selectedBranchSchedule.id)).length === 0 && (
                                                    <div className="text-sm text-gray-500 dark:text-gray-300 py-3 text-center">
                                                      No employees enrolled yet.
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                              
                                              <div className="flex justify-end space-x-2">
                                                <Button
                                                  type="button"
                                                  variant="outline"
                                                  onClick={() => setIsEditBranchScheduleDialogOpen(false)}
                                                >
                                                  Cancel
                                                </Button>
                                                <Button type="submit" className="bg-indigo-600 hover:bg-indigo-700">
                                                  Update Schedule
                                                </Button>
                                              </div>
                                            </form>
                                          )}
                                        </DialogContent>
                                      </Dialog>

                                      <Dialog
                                        open={isEnrollScheduleDialogOpen}
                                        onOpenChange={(open) => {
                                          setIsEnrollScheduleDialogOpen(open);
                                          if (!open) {
                                            setSelectedEnrollSchedule(null);
                                            setSelectedEnrollEmployeeIds([]);
                                            setEnrollEmployeeQuery('');
                                          }
                                        }}
                                      >
                                        <DialogContent>
                                          <DialogHeader>
                                            <DialogTitle>Enroll Employees: {selectedEnrollSchedule?.branch_name}</DialogTitle>
                                          </DialogHeader>

                                          <div className="space-y-4">
                                            <div>
                                              <Label>Search Employee</Label>
                                              <Input
                                                value={enrollEmployeeQuery}
                                                onChange={(e) => setEnrollEmployeeQuery(e.target.value)}
                                                placeholder="Search by name, ID, or email"
                                              />
                                            </div>

                                            <div className="max-h-72 overflow-auto rounded-md border p-2 space-y-2">
                                              {employees
                                                .filter((emp) => Boolean(emp?.is_active))
                                                .filter((emp) => {
                                                  if (!enrollEmployeeQuery.trim()) return true;
                                                  const q = enrollEmployeeQuery.toLowerCase();
                                                  return (
                                                    emp.full_name?.toLowerCase().includes(q) ||
                                                    emp.employee_id?.toLowerCase().includes(q) ||
                                                    emp.email?.toLowerCase().includes(q)
                                                  );
                                                })
                                                .map((emp) => {
                                                  const checked = selectedEnrollEmployeeIds.includes(emp.id);
                                                  const alreadyInSchedule = String(emp.schedule_id || '') === String(selectedEnrollSchedule?.id || '');
                                                  return (
                                                    <label
                                                      key={emp.id}
                                                      className={`flex items-center gap-3 p-2 rounded-md cursor-pointer ${
                                                        alreadyInSchedule ? 'opacity-60' : 'hover:bg-gray-50'
                                                      }`}
                                                    >
                                                      <input
                                                        type="checkbox"
                                                        checked={checked}
                                                        disabled={alreadyInSchedule}
                                                        onChange={(e) => {
                                                          setSelectedEnrollEmployeeIds((prev) => {
                                                            if (e.target.checked) return Array.from(new Set([...prev, emp.id]));
                                                            return prev.filter((id) => id !== emp.id);
                                                          });
                                                        }}
                                                      />
                                                      <div className="flex-1">
                                                        <div className="font-medium">{emp.full_name}</div>
                                                        <div className="text-xs text-gray-500">
                                                          {emp.employee_id || emp.id} {emp.email ? `\u2022 ${emp.email}` : ''}
                                                        </div>
                                                      </div>
                                                    </label>
                                                  );
                                                })}
                                            </div>

                                            <div className="flex justify-end space-x-2">
                                              <Button
                                                type="button"
                                                variant="outline"
                                                onClick={() => setIsEnrollScheduleDialogOpen(false)}
                                                disabled={isEnrollingEmployees}
                                              >
                                                Cancel
                                              </Button>
                                              <Button
                                                type="button"
                                                className="bg-indigo-600 hover:bg-indigo-700"
                                                disabled={
                                                  isEnrollingEmployees ||
                                                  !selectedEnrollSchedule ||
                                                  selectedEnrollEmployeeIds.length === 0
                                                }
                                                onClick={async () => {
                                                  if (!selectedEnrollSchedule) return;
                                                  setIsEnrollingEmployees(true);
                                                  try {
                                                    const scheduleId = selectedEnrollSchedule.id;
                                                    const results = await Promise.allSettled(
                                                      selectedEnrollEmployeeIds.map((employeeId) =>
                                                        axiosInstance.put(`/users/${employeeId}`, { schedule_id: scheduleId })
                                                      )
                                                    );

                                                    const failed = results.filter((r) => r.status === 'rejected');
                                                    if (failed.length > 0) {
                                                      toast.error(`Failed to enroll ${failed.length} employee(s)`);
                                                    } else {
                                                      toast.success('Employees enrolled successfully');
                                                    }

                                                    await fetchEmployees();
                                                    setIsEnrollScheduleDialogOpen(false);
                                                  } catch (error) {
                                                    console.error('Error enrolling employees:', error);
                                                    toast.error(error.response?.data?.detail || 'Failed to enroll employees');
                                                  } finally {
                                                    setIsEnrollingEmployees(false);
                                                  }
                                                }}
                                              >
                                                Enroll
                                              </Button>
                                            </div>
                                          </div>
                                        </DialogContent>
                                      </Dialog>
                                    </div>
                                  );
                                };

                                // Settings Content
                                const renderSettings = () => {
                                  // Function to update admin permissions
                                  const handlePermissionChange = async (adminId, permission, value) => {
                                    const admin = admins.find(a => a.id === adminId);
                                    if (!admin) return;

                                    const base = admin.permissions || {};
                                    const updatedPermissions = {
                                      ...base,
                                      [permission]: value
                                    };

                                    try {
                                      await axiosInstance.put(`/users/${adminId}`, { permissions: updatedPermissions });
                                      
                                      // Update local state
                                      setAdmins(prevAdmins => 
                                        prevAdmins.map(a => 
                                          a.id === adminId 
                                            ? { ...a, permissions: updatedPermissions }
                                            : a
                                        )
                                      );
                                      
                                      toast.success('Permissions updated successfully');
                                    } catch (error) {
                                      console.error('Error updating permissions:', error);
                                      toast.error('Failed to update permissions');
                                    }
                                  };

                                  const handleSuperAdminToggle = async (adminId, currentValue) => {
                                    const newValue = !currentValue;
                                    try {
                                      await axiosInstance.put(`/users/${adminId}`, { is_super_admin: newValue });
                                      
                                      // Update local state
                                      setAdmins(prevAdmins => 
                                        prevAdmins.map(a => 
                                          a.id === adminId 
                                            ? { ...a, is_super_admin: newValue }
                                            : a
                                        )
                                      );
                                      
                                      toast.success(`Admin ${newValue ? 'promoted to' : 'demoted from'} Super Admin`);
                                    } catch (error) {
                                      console.error('Error updating super admin status:', error);
                                      toast.error('Failed to update super admin status');
                                    }
                                  };

                                  return (
                                    <div className="space-y-6">
                                      <div className="flex justify-between items-center">
                                        <div>
                                          <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Admin Account Management</h2>
                                          <p className="text-gray-600 dark:text-gray-200">Manage administrator accounts and tab access permissions</p>
                                        </div>
                                        <div className="flex gap-2">
                                          <Dialog open={isCreateAdminDialogOpen} onOpenChange={setIsCreateAdminDialogOpen}>
                                            <DialogTrigger asChild>
                                              <Button className="bg-indigo-600 hover:bg-indigo-700">
                                                <Plus className="h-4 w-4 mr-2" />
                                                Add Admin
                                              </Button>
                                            </DialogTrigger>
                                            <DialogContent>
                                              <DialogHeader>
                                                <DialogTitle>Add New Administrator</DialogTitle>
                                              </DialogHeader>
                                              <form onSubmit={handleCreateAdmin} className="space-y-4">
                                                <div>
                                                  <Label>Full Name</Label>
                                                  <Input
                                                    value={newAdmin.full_name}
                                                    onChange={(e) => setNewAdmin({...newAdmin, full_name: e.target.value})}
                                                    required
                                                  />
                                                </div>
                                                
                                                <div>
                                                  <Label>Email</Label>
                                                  <Input
                                                    type="email"
                                                    value={newAdmin.email}
                                                    onChange={(e) => setNewAdmin({...newAdmin, email: e.target.value})}
                                                    required
                                                  />
                                                </div>
                                                
                                                <div>
                                                  <Label>Password</Label>
                                                  <Input
                                                    type="password"
                                                    value={newAdmin.password}
                                                    onChange={(e) => setNewAdmin({...newAdmin, password: e.target.value})}
                                                    required
                                                  />
                                                </div>
                                                
                                                <div className="flex justify-end space-x-2">
                                                  <Button
                                                    type="button"
                                                    variant="outline"
                                                    onClick={() => setIsCreateAdminDialogOpen(false)}
                                                  >
                                                    Cancel
                                                  </Button>
                                                  <Button type="submit" className="bg-indigo-600 hover:bg-indigo-700">
                                                    Add Admin
                                                  </Button>
                                                </div>
                                              </form>
                                            </DialogContent>
                                          </Dialog>
                                        </div>
                                      </div>

                                      <Card className="glass shadow-lg border-0">
                                        <CardContent>
                                          <div className="overflow-x-auto">
                                            <table className="w-full">
                                              <thead>
                                                <tr className="border-b border-gray-200">
                                                  <th className="text-left p-4 font-medium text-gray-900 dark:text-white">Admin</th>
                                                  <th className="text-left p-4 font-medium text-gray-900 dark:text-white">Email</th>
                                                  <th className="text-center p-4 font-medium text-gray-900 dark:text-white">Super Admin</th>
                                                  <th className="text-center p-4 font-medium text-gray-900 dark:text-white">Attendance Access</th>
                                                  <th className="text-center p-4 font-medium text-gray-900 dark:text-white">HRIS Access</th>
                                                  <th className="text-center p-4 font-medium text-gray-900 dark:text-white">Inventory Access</th>

                                                  <th className="text-center p-4 font-medium text-gray-900 dark:text-white">Numora Access</th>
                                                  <th className="text-center p-4 font-medium text-gray-900 dark:text-white">Payroll Access</th>
                                                  <th className="text-center p-4 font-medium text-gray-900 dark:text-white">PCC Access</th>
                                                  <th className="text-center p-4 font-medium text-gray-900 dark:text-white">Service Lifecycle Management</th>
                                                  <th className="text-center p-4 font-medium text-gray-900 dark:text-white">Project Monitoring System</th>
                                                  <th className="text-center p-4 font-medium text-gray-900 dark:text-white">Sales Department Tools</th>
                                                  <th className="text-center p-4 font-medium text-gray-900 dark:text-white">Announcement</th>
                                                  <th className="text-left p-4 font-medium text-gray-900 dark:text-white">Status</th>
                                                  <th className="text-left p-4 font-medium text-gray-900 dark:text-white">Actions</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {admins.length > 0 ? (
                                                  admins.map((admin, index) => (
                                                    <tr key={admin.id} className={`${index % 2 === 0 ? 'bg-white bg-opacity-30' : 'bg-gray-50 bg-opacity-30'} hover:bg-indigo-50 dark:hover:bg-black hover:bg-opacity-50 dark:hover:bg-black transition-colors`}>
                                                      <td className="px-6 py-4 whitespace-nowrap">
                                                        <div className="flex items-center">
                                                          <div>
                                                            <div className="font-medium text-gray-900 dark:text-white">{admin.full_name}</div>
                                                            {admin.is_super_admin && (
                                                              <div className="text-xs text-purple-600 font-medium">Super Administrator</div>
                                                            )}
                                                          </div>
                                                        </div>
                                                      </td>
                                                      <td className="px-6 py-4 whitespace-nowrap text-gray-600 dark:text-gray-200">
                                                        {admin.email}
                                                      </td>
                                                      <td className="px-6 py-4 whitespace-nowrap text-center">
                                                        <div className="flex justify-center">
                                                          <Switch
                                                            checked={admin.is_super_admin || false}
                                                            onCheckedChange={(val) => handleSuperAdminToggle(admin.id, admin.is_super_admin)}
                                                            className="data-[state=checked]:bg-violet-600"
                                                            disabled={user.email === admin.email}
                                                          />
                                                        </div>
                                                      </td>
                                                      <td className="px-6 py-4 whitespace-nowrap text-center">
                                                        <div className="inline-flex items-center justify-center gap-2">
                                                          <Switch
                                                            checked={admin.permissions?.attendance_access !== false}
                                                            onCheckedChange={(val) => handlePermissionChange(admin.id, 'attendance_access', val)}
                                                          />
                                                          <span className="text-sm text-gray-700 dark:text-gray-100">
                                                            {admin.permissions?.attendance_access !== false ? 'Enabled' : 'Disabled'}
                                                          </span>
                                                        </div>
                                                      </td>
                                                      <td className="px-6 py-4 whitespace-nowrap text-center">
                                                        <div className="inline-flex items-center justify-center gap-2">
                                                          <Switch
                                                            checked={admin.permissions?.hris_access ?? (admin.email === 'vinsimon23@gmail.com')}
                                                            onCheckedChange={(val) => handlePermissionChange(admin.id, 'hris_access', val)}
                                                          />
                                                          <span className="text-sm text-gray-700 dark:text-gray-100">
                                                            {(admin.permissions?.hris_access ?? (admin.email === 'vinsimon23@gmail.com')) ? 'Enabled' : 'Disabled'}
                                                          </span>
                                                        </div>
                                                      </td>
                                                      <td className="px-6 py-4 whitespace-nowrap text-center">
                                                        <div className="inline-flex items-center justify-center gap-2">
                                                          <Switch
                                                            checked={admin.permissions?.inventory_access ?? (admin.email === 'vinsimon23@gmail.com')}
                                                            onCheckedChange={(val) => handlePermissionChange(admin.id, 'inventory_access', val)}
                                                          />
                                                          <span className="text-sm text-gray-700 dark:text-gray-100">
                                                            {(admin.permissions?.inventory_access ?? (admin.email === 'vinsimon23@gmail.com')) ? 'Enabled' : 'Disabled'}
                                                          </span>
                                                        </div>
                                                      </td>

                                                      <td className="px-6 py-4 whitespace-nowrap text-center">
                                                        <div className="inline-flex items-center justify-center gap-2">
                                                          <Switch
                                                            checked={admin.permissions?.numora_access === true}
                                                            onCheckedChange={(val) => handlePermissionChange(admin.id, 'numora_access', val)}
                                                          />
                                                          <span className="text-sm text-gray-700 dark:text-gray-100">
                                                            {admin.permissions?.numora_access === true ? 'Enabled' : 'Disabled'}
                                                          </span>
                                                        </div>
                                                      </td>

                                                      <td className="px-6 py-4 whitespace-nowrap text-center">
                                                        <div className="inline-flex items-center justify-center gap-2">
                                                          <Switch
                                                            checked={admin.permissions?.payroll_access ?? (admin.email === 'vinsimon23@gmail.com')}
                                                            onCheckedChange={(val) => handlePermissionChange(admin.id, 'payroll_access', val)}
                                                          />
                                                          <span className="text-sm text-gray-700 dark:text-gray-100">
                                                            {(admin.permissions?.payroll_access ?? (admin.email === 'vinsimon23@gmail.com')) ? 'Enabled' : 'Disabled'}
                                                          </span>
                                                        </div>
                                                      </td>
                                                      <td className="px-6 py-4 whitespace-nowrap text-center">
                                                        <div className="inline-flex items-center justify-center gap-2">
                                                          <Switch
                                                            checked={admin.permissions?.ccp_access ?? (admin.email === 'vinsimon23@gmail.com')}
                                                            onCheckedChange={(val) => handlePermissionChange(admin.id, 'ccp_access', val)}
                                                          />
                                                          <span className="text-sm text-gray-700 dark:text-gray-100">
                                                            {(admin.permissions?.ccp_access ?? (admin.email === 'vinsimon23@gmail.com')) ? 'Enabled' : 'Disabled'}
                                                          </span>
                                                        </div>
                                                      </td>
                                                      <td className="px-6 py-4 whitespace-nowrap text-center">
                                                        <div className="inline-flex items-center justify-center gap-2">
                                                          <Switch
                                                            checked={admin.permissions?.service_lifecycle_management_access ?? (admin.email === 'vinsimon23@gmail.com')}
                                                            onCheckedChange={(val) => handlePermissionChange(admin.id, 'service_lifecycle_management_access', val)}
                                                          />
                                                          <span className="text-sm text-gray-700 dark:text-gray-100">
                                                            {(admin.permissions?.service_lifecycle_management_access ?? (admin.email === 'vinsimon23@gmail.com')) ? 'Enabled' : 'Disabled'}
                                                          </span>
                                                        </div>
                                                      </td>
                                                      <td className="px-6 py-4 whitespace-nowrap text-center">
                                                        <div className="inline-flex items-center justify-center gap-2">
                                                          <Switch
                                                            checked={admin.permissions?.management_print_system_access ?? (admin.email === 'vinsimon23@gmail.com')}
                                                            onCheckedChange={(val) => handlePermissionChange(admin.id, 'management_print_system_access', val)}
                                                          />
                                                          <span className="text-sm text-gray-700 dark:text-gray-100">
                                                            {(admin.permissions?.management_print_system_access ?? (admin.email === 'vinsimon23@gmail.com')) ? 'Enabled' : 'Disabled'}
                                                          </span>
                                                        </div>
                                                      </td>

                                                      <td className="px-6 py-4 whitespace-nowrap text-center">
                                                        <div className="inline-flex items-center justify-center gap-2">
                                                          <Switch
                                                            checked={admin.permissions?.project_details_access ?? (admin.email === 'vinsimon23@gmail.com')}
                                                            onCheckedChange={(val) => handlePermissionChange(admin.id, 'project_details_access', val)}
                                                          />
                                                          <span className="text-sm text-gray-700 dark:text-gray-100">
                                                            {(admin.permissions?.project_details_access ?? (admin.email === 'vinsimon23@gmail.com')) ? 'Enabled' : 'Disabled'}
                                                          </span>
                                                        </div>
                                                      </td>
                                                      <td className="px-6 py-4 whitespace-nowrap text-center">
                                                        <div className="inline-flex items-center justify-center gap-2">
                                                          <Switch
                                                            checked={admin.permissions?.marketing_system_access ?? (admin.email === 'vinsimon23@gmail.com')}
                                                            onCheckedChange={(val) => handlePermissionChange(admin.id, 'marketing_system_access', val)}
                                                          />
                                                          <span className="text-sm text-gray-700 dark:text-gray-100">
                                                            {(admin.permissions?.marketing_system_access ?? (admin.email === 'vinsimon23@gmail.com')) ? 'Enabled' : 'Disabled'}
                                                          </span>
                                                        </div>
                                                      </td>
                                                      <td className="px-6 py-4 whitespace-nowrap">
                                                        <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">
                                                          Active
                                                        </span>
                                                      </td>
                                                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium space-x-2">
                                                        <Button
                                                          size="sm"
                                                          variant="ghost"
                                                          onClick={() => {
                                                            setSelectedAdmin(admin);
                                                            setIsEditAdminDialogOpen(true);
                                                          }}
                                                        >
                                                          <Edit className="h-3 w-3" />
                                                        </Button>
                                                        {!admin.is_super_admin && (
                                                          <Button
                                                            size="sm"
                                                            variant="ghost"
                                                            onClick={() => handleDeleteAdmin(admin.id)}
                                                            className="text-red-600 hover:text-red-800"
                                                          >
                                                            <Trash2 className="h-3 w-3" />
                                                          </Button>
                                                        )}
                                                      </td>
                                                    </tr>
                                                  ))
                                                ) : (
                                                  <tr>
                                                    <td colSpan="6" className="px-6 py-8 text-center">
                                                      <div className="flex flex-col items-center">
                                                        <Users className="h-12 w-12 text-gray-400 mb-4" />
                                                        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">No administrators yet</h3>
                                                        <p className="text-gray-500 dark:text-gray-300">Get started by adding your first administrator.</p>
                                                      </div>
                                                    </td>
                                                  </tr>
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </CardContent>
                                      </Card>


                                      {/* Edit Admin Dialog */}
                                      <Dialog open={isEditAdminDialogOpen} onOpenChange={setIsEditAdminDialogOpen}>
                                        <DialogContent>
                                          <DialogHeader>
                                            <DialogTitle>Edit Administrator</DialogTitle>
                                          </DialogHeader>
                                          {selectedAdmin && (
                                            <form onSubmit={handleUpdateAdmin} className="space-y-4">
                                              <div>
                                                <Label>Full Name</Label>
                                                <Input
                                                  value={selectedAdmin.full_name}
                                                  onChange={(e) => setSelectedAdmin({...selectedAdmin, full_name: e.target.value})}
                                                  required
                                                />
                                              </div>
                                              
                                              <div>
                                                <Label>Email</Label>
                                                <Input
                                                  type="email"
                                                  value={selectedAdmin.email}
                                                  onChange={(e) => setSelectedAdmin({...selectedAdmin, email: e.target.value})}
                                                  required
                                                />
                                              </div>
                                              
                                              <div>
                                                <Label>Password (leave empty to keep current)</Label>
                                                <Input
                                                  type="password"
                                                  value={selectedAdmin.password || ''}
                                                  onChange={(e) => setSelectedAdmin({...selectedAdmin, password: e.target.value})}
                                                />
                                              </div>
                                              
                                              <div className="flex justify-end space-x-2">
                                                <Button
                                                  type="button"
                                                  variant="outline"
                                                  onClick={() => setIsEditAdminDialogOpen(false)}
                                                >
                                                  Cancel
                                                </Button>
                                                <Button type="submit" className="bg-indigo-600 hover:bg-indigo-700">
                                                  Save Changes
                                                </Button>
                                              </div>
                                            </form>
                                          )}
                                        </DialogContent>
                                      </Dialog>
                                    </div>
                                  );
                                };

                                // Payroll Content Renderers

                                const renderNewEmployee = () => (
                                  <div className="space-y-6">
                                    <div>
                                      <h2 className="text-2xl font-bold text-gray-900 dark:text-white">New Employee Registration</h2>
                                      <p className="text-gray-600 dark:text-gray-200">Search and register employees from iSource database for payroll</p>
                                    </div>

                                    {/* Employee Search */}
                                    <Card className="glass shadow-lg border-0">
                                      <CardHeader>
                                        <CardTitle>Search Employee</CardTitle>
                                      </CardHeader>
                                      <CardContent className="space-y-4">
                                        <div>
                                          <Label>Employee Name or ID</Label>
                                          <Input
                                            placeholder="Enter employee name, ID, or email..."
                                            value={searchEmployeeQuery}
                                            onChange={(e) => setSearchEmployeeQuery(e.target.value)}
                                          />
                                        </div>
                                        
                                        {searchEmployeeQuery && (
                                          <div className="space-y-2">
                                            <Label>Search Results</Label>
                                            <div className="max-h-40 overflow-y-auto border rounded-lg">
                                              {employees
                                                .filter(emp => 
                                                  (emp.full_name?.toLowerCase().includes(searchEmployeeQuery.toLowerCase())) ||
                                                  (emp.employee_id?.toLowerCase().includes(searchEmployeeQuery.toLowerCase())) ||
                                                  (emp.email?.toLowerCase().includes(searchEmployeeQuery.toLowerCase()))
                                                )
                                                .map(employee => (
                                                  <div
                                                    key={employee.id}
                                                    onClick={() => setSelectedHRISEmployee(employee)}
                                                    className={`p-3 cursor-pointer hover:bg-gray-50 dark:hover:bg-black border-b ${
                                                      selectedHRISEmployee?.id === employee.id ? 'bg-indigo-50' : ''
                                                    }`}
                                                  >
                                                    <div className="font-medium">{employee.full_name}</div>
                                                    <div className="text-sm text-gray-500 dark:text-gray-300">
                                                      ID: {employee.employee_id} | {employee.email} | {employee.branch}
                                                    </div>
                                                  </div>
                                                ))
                                              }
                                            </div>
                                          </div>
                                        )}
                                      </CardContent>
                                    </Card>

                                    {/* Payroll Registration Form */}
                                    {selectedHRISEmployee && (
                                      <Card className="glass shadow-lg border-0">
                                        <CardHeader>
                                          <CardTitle>Register Employee for Payroll</CardTitle>
                                        </CardHeader>
                                        <CardContent className="space-y-4">
                                          {/* Employee Info Display */}
                                          <div className="bg-gray-50 p-4 rounded-lg">
                                            <h4 className="font-medium mb-2">Selected Employee</h4>
                                            <div className="grid grid-cols-2 gap-4 text-sm">
                                              <div><strong>Name:</strong> {selectedHRISEmployee.full_name}</div>
                                              <div><strong>System ID:</strong> {selectedHRISEmployee.id}</div>
                                              <div><strong>Employee Code:</strong> {selectedHRISEmployee.employee_id}</div>
                                              <div><strong>Email:</strong> {selectedHRISEmployee.email}</div>
                                              <div><strong>Branch:</strong> {selectedHRISEmployee.branch}</div>
                                            </div>
                                          </div>

                                          {/* Salary Package */}
                                          <div className="space-y-4">
                                            <div className="grid grid-cols-1 gap-4">
                                              <div>
                                                <Label>Salary Package</Label>
                                                <Input
                                                  type="number"
                                                  placeholder="Enter salary amount"
                                                  value={payrollData.salary}
                                                  onChange={(e) => {
                                                    setPayrollData({...payrollData, salary: e.target.value});
                                                    // Reset daily rate calculation when salary changes
                                                    setDailyRateFormula(null);
                                                    setCalculatedDailyRate(0);
                                                  }}
                                                />
                                              </div>
                                            </div>
                                            
                                            {/* Daily Rate Calculation and Controls */}
                                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
                                              {/* Minimum Wage Toggle */}
                                              <div className="flex items-center space-x-3">
                                                <Switch
                                                  id="minimum-wage"
                                                  checked={payrollData.is_minimum_wage}
                                                  onCheckedChange={(val) => setPayrollData({
                                                    ...payrollData,
                                                    is_minimum_wage: !!val,
                                                    tax_enabled: !!val ? false : true
                                                  })}
                                                />
                                                <Label htmlFor="minimum-wage">Minimum Wage</Label>
                                              </div>

                                              {/* Daily Rate Formula Buttons */}
                                              <div className="flex items-center space-x-4">
                                                <Label className="text-sm text-gray-600 dark:text-gray-200">Daily Rate Formula:</Label>
                                                
                                                {/* 313 Formula Button */}
                                                <div className="flex items-center space-x-2">
                                                  <button
                                                    type="button"
                                                    onClick={() => calculateDailyRate('313')}
                                                    className={`flex items-center justify-center w-8 h-8 rounded-full border-2 cursor-pointer transition-all duration-200 text-sm font-semibold ${
                                                      dailyRateFormula === '313'
                                                        ? 'border-blue-500 bg-blue-500 text-white' 
                                                        : 'border-gray-300 bg-white text-gray-700 dark:text-gray-100 hover:border-blue-400 hover:bg-blue-50 dark:hover:bg-black'
                                                    }`}
                                                    title="Calculate daily rate using 313 formula: (salary \u00d7 12) \u00f7 313"
                                                  >
                                                    313
                                                  </button>
                                                </div>
                                                
                                                {/* 261 Formula Button */}
                                                <div className="flex items-center space-x-2">
                                                  <button
                                                    type="button"
                                                    onClick={() => calculateDailyRate('261')}
                                                    className={`flex items-center justify-center w-8 h-8 rounded-full border-2 cursor-pointer transition-all duration-200 text-sm font-semibold ${
                                                      dailyRateFormula === '261'
                                                        ? 'border-green-500 bg-green-500 text-white' 
                                                        : 'border-gray-300 bg-white text-gray-700 dark:text-gray-100 hover:border-green-400 hover:bg-green-50 dark:hover:bg-black'
                                                    }`}
                                                    title="Calculate daily rate using 261 formula: (salary \u00d7 12) \u00f7 261"
                                                  >
                                                    261
                                                  </button>
                                                </div>
                                              </div>

                                              {/* Daily Rate Display */}
                                              <div className="flex items-center space-x-2">
                                                <Label className="text-sm text-gray-600 dark:text-gray-200">Daily Rate:</Label>
                                                <div className={`px-3 py-1 rounded-lg border text-sm font-medium ${
                                                  calculatedDailyRate > 0 
                                                    ? 'bg-indigo-50 border-indigo-200 text-indigo-700' 
                                                    : 'bg-gray-50 border-gray-200 text-gray-500 dark:text-gray-300'
                                                }`}>
                                                  {calculatedDailyRate > 0 ? `\u20b1${calculatedDailyRate.toFixed(2)}` : 'Not calculated'}
                                                  {dailyRateFormula && (
                                                    <span className="ml-1 text-xs">({dailyRateFormula})</span>
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          {/* Leave Credits */}
                                            <div>
                                              <Label>Leave Credits</Label>
                                              <Input
                                                type="number"
                                                placeholder="Enter leave credits"
                                                value={payrollData.leave_credits}
                                                onChange={(e) => setPayrollData({...payrollData, leave_credits: e.target.value})}
                                              />
                                            </div>

                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                              <div>
                                                <Label>TIN Number</Label>
                                                <Input
                                                  placeholder="Enter TIN"
                                                  value={payrollData.tin_number}
                                                  onChange={(e) => setPayrollData({...payrollData, tin_number: e.target.value})}
                                                />
                                              </div>
                                              <div>
                                                <Label>SSS Number</Label>
                                                <Input
                                                  placeholder="Enter SSS"
                                                  value={payrollData.sss_number}
                                                  onChange={(e) => setPayrollData({...payrollData, sss_number: e.target.value})}
                                                />
                                              </div>
                                              <div>
                                                <Label>PhilHealth Number</Label>
                                                <Input
                                                  placeholder="Enter PhilHealth"
                                                  value={payrollData.phic_number}
                                                  onChange={(e) => setPayrollData({...payrollData, phic_number: e.target.value})}
                                                />
                                              </div>
                                              <div>
                                                <Label>Pag-IBIG Number</Label>
                                                <Input
                                                  placeholder="Enter Pag-IBIG"
                                                  value={payrollData.hdmf_number}
                                                  onChange={(e) => setPayrollData({...payrollData, hdmf_number: e.target.value})}
                                                />
                                              </div>
                                            </div>

                                          {/* Allowances */}
                                          <div>
                                            <Label className="text-base font-medium">Allowances</Label>
                                            <div className="grid grid-cols-2 gap-4 mt-2">
                                              <div>
                                                <Label>MF</Label>
                                                <Input
                                                  type="number"
                                                  placeholder="MF allowance"
                                                  value={payrollData.allowances.mf}
                                                  onChange={(e) => setPayrollData({
                                                    ...payrollData, 
                                                    allowances: {...payrollData.allowances, mf: e.target.value}
                                                  })}
                                                />
                                              </div>
                                              <div>
                                                <Label>Gas Allowance</Label>
                                                <Input
                                                  type="number"
                                                  placeholder="Gas allowance"
                                                  value={payrollData.allowances.gas_allowance}
                                                  onChange={(e) => setPayrollData({
                                                    ...payrollData, 
                                                    allowances: {...payrollData.allowances, gas_allowance: e.target.value}
                                                  })}
                                                />
                                              </div>
                                              <div>
                                                <Label>Load Allowance</Label>
                                                <Input
                                                  type="number"
                                                  placeholder="Load allowance"
                                                  value={payrollData.allowances.load_allowance}
                                                  onChange={(e) => setPayrollData({
                                                    ...payrollData, 
                                                    allowances: {...payrollData.allowances, load_allowance: e.target.value}
                                                  })}
                                                />
                                              </div>
                                              <div>
                                                <Label>Housing Allowance</Label>
                                                <Input
                                                  type="number"
                                                  placeholder="Housing allowance"
                                                  value={payrollData.allowances.housing_allowance}
                                                  onChange={(e) => setPayrollData({
                                                    ...payrollData, 
                                                    allowances: {...payrollData.allowances, housing_allowance: e.target.value}
                                                  })}
                                                />
                                              </div>
                                            </div>
                                          </div>

                                          {/* Deductions */}
                                          <div>
                                            <Label className="text-base font-medium">Deductions</Label>
                                            <div className="grid grid-cols-2 gap-4 mt-2">
                                              {/* Tax Deduction (Read-only) */}
                                              <div className="flex items-center space-x-3">
                                                <div className="relative">
                                                  <div
                                                    className={`flex items-center justify-center w-6 h-6 rounded-full border-2 transition-all duration-200 ${
                                                      payrollData.is_minimum_wage 
                                                        ? 'border-gray-300 bg-gray-100' 
                                                        : payrollData.tax_enabled 
                                                          ? 'border-green-500 bg-green-500' 
                                                          : 'border-gray-300 bg-white'
                                                    }`}
                                                  >
                                                    {payrollData.tax_enabled && !payrollData.is_minimum_wage && (
                                                      <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                      </svg>
                                                    )}
                                                  </div>
                                                </div>
                                                <div className="flex items-center space-x-2">
                                                  <Label className={payrollData.is_minimum_wage ? 'text-gray-400' : ''}>
                                                    Tax (Auto)
                                                  </Label>
                                                  <button
                                                    type="button"
                                                    onClick={() => setShowTaxInfoModal(true)}
                                                    className="flex items-center justify-center w-4 h-4 rounded-full bg-blue-100 hover:bg-blue-200 text-blue-600 transition-colors duration-200"
                                                    title="View BIR Withholding Tax Table"
                                                  >
                                                    <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
                                                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
                                                    </svg>
                                                  </button>
                                                </div>
                                              </div>

                                              {/* SSS Deduction */}
                                              <div className="flex items-center space-x-3">
                                                <div className="relative">
                                                  <input
                                                    type="checkbox"
                                                    id="sss"
                                                    checked={payrollData.deductions.sss}
                                                    onChange={(e) => setPayrollData({
                                                      ...payrollData, 
                                                      deductions: {...payrollData.deductions, sss: e.target.checked}
                                                    })}
                                                    className="sr-only"
                                                  />
                                                  <label
                                                    htmlFor="sss"
                                                    className={`flex items-center justify-center w-6 h-6 rounded-full border-2 cursor-pointer transition-all duration-200 ${
                                                      payrollData.deductions.sss 
                                                        ? 'border-blue-500 bg-blue-500' 
                                                        : 'border-gray-300 bg-white hover:border-blue-400'
                                                    }`}
                                                  >
                                                    {payrollData.deductions.sss && (
                                                      <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                      </svg>
                                                    )}
                                                  </label>
                                                </div>
                                                <div className="flex items-center space-x-2">
                                                  <Label htmlFor="sss" className="cursor-pointer">SSS</Label>
                                                  <button
                                                    type="button"
                                                    onClick={() => setShowSSSInfoModal(true)}
                                                    className="flex items-center justify-center w-4 h-4 rounded-full bg-blue-100 hover:bg-blue-200 text-blue-600 transition-colors duration-200"
                                                    title="View SSS Deduction Brackets"
                                                  >
                                                    <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
                                                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
                                                    </svg>
                                                  </button>
                                                </div>
                                              </div>

                                              {/* PhilHealth Deduction */}
                                              <div className="flex items-center space-x-3">
                                                <div className="relative">
                                                  <input
                                                    type="checkbox"
                                                    id="phic"
                                                    checked={payrollData.deductions.phic}
                                                    onChange={(e) => setPayrollData({
                                                      ...payrollData, 
                                                      deductions: {...payrollData.deductions, phic: e.target.checked}
                                                    })}
                                                    className="sr-only"
                                                  />
                                                  <label
                                                    htmlFor="phic"
                                                    className={`flex items-center justify-center w-6 h-6 rounded-full border-2 cursor-pointer transition-all duration-200 ${
                                                      payrollData.deductions.phic 
                                                        ? 'border-red-500 bg-red-500' 
                                                        : 'border-gray-300 bg-white hover:border-red-400'
                                                    }`}
                                                  >
                                                    {payrollData.deductions.phic && (
                                                      <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                      </svg>
                                                    )}
                                                  </label>
                                                </div>
                                                <div className="flex items-center space-x-2">
                                                  <Label htmlFor="phic" className="cursor-pointer">PhilHealth</Label>
                                                  <button
                                                    type="button"
                                                    onClick={() => setShowPhilHealthInfoModal(true)}
                                                    className="flex items-center justify-center w-4 h-4 rounded-full bg-red-100 hover:bg-red-200 text-red-600 transition-colors duration-200"
                                                    title="View PhilHealth Deduction Formula"
                                                  >
                                                    <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
                                                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
                                                    </svg>
                                                  </button>
                                                </div>
                                              </div>

                                              {/* HDMF Deduction */}
                                              <div className="flex items-center space-x-3">
                                                <div className="relative">
                                                  <input
                                                    type="checkbox"
                                                    id="hdmf"
                                                    checked={payrollData.deductions.hdmf}
                                                    onChange={(e) => setPayrollData({
                                                      ...payrollData, 
                                                      deductions: {...payrollData.deductions, hdmf: e.target.checked}
                                                    })}
                                                    className="sr-only"
                                                  />
                                                  <label
                                                    htmlFor="hdmf"
                                                    className={`flex items-center justify-center w-6 h-6 rounded-full border-2 cursor-pointer transition-all duration-200 ${
                                                      payrollData.deductions.hdmf 
                                                        ? 'border-purple-500 bg-purple-500' 
                                                        : 'border-gray-300 bg-white hover:border-purple-400'
                                                    }`}
                                                  >
                                                    {payrollData.deductions.hdmf && (
                                                      <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                      </svg>
                                                    )}
                                                  </label>
                                                </div>
                                                <div className="flex items-center space-x-2">
                                                  <Label htmlFor="hdmf" className="cursor-pointer">HDMF (Pag-IBIG)</Label>
                                                  <button
                                                    type="button"
                                                    onClick={() => setShowHDMFInfoModal(true)}
                                                    className="flex items-center justify-center w-4 h-4 rounded-full bg-purple-100 hover:bg-purple-200 text-purple-600 transition-colors duration-200"
                                                    title="View HDMF Deduction Information"
                                                  >
                                                    <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
                                                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
                                                    </svg>
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          {/* Submit Button */}
                                          <div className="flex justify-end space-x-2 pt-4">
                                            <Button
                                              variant="outline"
                                              onClick={() => {
                                                setSelectedHRISEmployee(null);
                                                setSearchEmployeeQuery('');
                                                setPayrollData({
                                                  employee_id: '',
                                                  salary: '',
                                                  is_minimum_wage: false,
                                                  tax_enabled: true, // Reset to default (enabled)
                                                  leave_credits: '',
                                                  allowances: { mf: '', gas_allowance: '', load_allowance: '', housing_allowance: '' },
                                                  deductions: { sss: false, phic: false, hdmf: false }
                                                });
                                              }}
                                            >
                                              Cancel
                                            </Button>
                                            <Button 
                                              className="bg-indigo-600 hover:bg-indigo-700"
                                              onClick={handleCreatePayrollEmployee}
                                            >
                                              Register Employee
                                            </Button>
                                          </div>
                                        </CardContent>
                                      </Card>
                                    )}
                                  </div>
                                );

                                const renderEmployeeManagement = () => {
                                  // Filter employees based on search query
                                  const filteredEmployees = payrollEmployees.filter(employee => {
                                    if (!searchEmployeeQuery.trim()) return true;
                                    
                                    const query = searchEmployeeQuery.toLowerCase();
                                    return (
                                      employee.full_name?.toLowerCase().includes(query) ||
                                      employee.employee_id?.toLowerCase().includes(query) ||
                                      employee.email?.toLowerCase().includes(query) ||
                                      employee.branch?.toLowerCase().includes(query)
                                    );
                                  });

                                  return (
                                    <div className="h-full flex flex-col">
                                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                                        <Card className="glass shadow-lg border-0">
                                          <CardContent className="p-4">
                                            <div className="flex items-center justify-between">
                                              <div>
                                                <p className="text-sm font-medium text-indigo-700">Enrolled in Payroll</p>
                                                <p className="text-2xl font-bold text-indigo-900">{payrollEmployees.length}</p>
                                              </div>
                                              <Users className="h-6 w-6 text-indigo-600" />
                                            </div>
                                          </CardContent>
                                        </Card>
                                        <Card className="glass shadow-lg border-0">
                                          <CardContent className="p-4">
                                            <div className="flex items-center justify-between">
                                              <div>
                                                <p className="text-sm font-medium text-green-700">Total Employees (Attendance)</p>
                                                <p className="text-2xl font-bold text-green-900">{((Array.isArray(employees) ? employees.filter((e) => e.role === 'employee').length : 0) || employees.length)}</p>
                                              </div>
                                              <UserCheck className="h-6 w-6 text-green-600" />
                                            </div>
                                          </CardContent>
                                        </Card>
                                      </div>
                                      <div className="flex-shrink-0 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-4">
                                        <Button 
                                          onClick={() => setIsNewEmployeeModalOpen(true)}
                                          className="bg-indigo-600 hover:bg-indigo-700"
                                        >
                                          <Plus className="h-4 w-4 mr-2" />
                                          New Employee
                                        </Button>

                                        {/* Search Filter Box */}
                                        <div className="w-full sm:w-96">
                                          <div className="relative">
                                            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                                            <Input
                                              type="text"
                                              placeholder="Search by name, ID, email, or branch..."
                                              value={searchEmployeeQuery}
                                              onChange={(e) => setSearchEmployeeQuery(e.target.value)}
                                              className="pl-10 w-full"
                                            />
                                            {searchEmployeeQuery && (
                                              <button
                                                onClick={() => setSearchEmployeeQuery('')}
                                                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:text-gray-200"
                                              >
                                                &#215;
                                              </button>
                                            )}
                                          </div>
                                          {searchEmployeeQuery && (
                                            <p className="text-xs text-gray-500 dark:text-gray-300 mt-1">
                                              Found {filteredEmployees.length} employee(s)
                                            </p>
                                          )}
                                        </div>
                                      </div>

                                      <Card className="glass shadow-lg border-0 flex-1 min-h-0 flex flex-col">
                                        <CardContent className="p-0 flex-1 flex flex-col min-h-0">
                                          {/* Scrollable Table Container - fixed height for smooth vertical scrolling */}
                                          <div
                                            className="flex-1 min-h-0 overflow-x-auto overflow-y-auto scroll-smooth"
                                            role="region"
                                            aria-label="Payroll employees list"
                                            tabIndex={0}
                                            style={{ scrollbarColor: '#cbd5e1 transparent', scrollbarWidth: 'thin' }}
                                          >
                                            <table className="min-w-full w-full">
                                              <thead className="sticky top-0 bg-gray-50 z-10">
                                                <tr className="border-b border-gray-200">
                                                  <th className="text-left p-4 font-medium text-gray-900 dark:text-white">Employee</th>
                                                  <th className="text-left p-4 font-medium text-gray-900 dark:text-white">ID</th>
                                                  <th className="text-left p-4 font-medium text-gray-900 dark:text-white">Branch</th>
                                                  <th className="text-left p-4 font-medium text-gray-900 dark:text-white">Salary</th>
                                                  <th className="text-left p-4 font-medium text-gray-900 dark:text-white">Daily Rate</th>
                                                  <th className="text-left p-4 font-medium text-gray-900 dark:text-white">Wage Type</th>
                                                  <th className="text-left p-4 font-medium text-gray-900 dark:text-white">Status</th>
                                                  <th className="text-left p-4 font-medium text-gray-900 dark:text-white">Actions</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {filteredEmployees.length > 0 ? (
                                                  filteredEmployees.map((employee, index) => (
                                                    <tr key={employee.id} className={`${index % 2 === 0 ? 'bg-white bg-opacity-30' : 'bg-gray-50 bg-opacity-30'} hover:bg-indigo-50 dark:hover:bg-black hover:bg-opacity-50 dark:hover:bg-black transition-colors`}>
                                                      <td className="px-6 py-4 whitespace-nowrap">
                                                        <div className="font-medium text-gray-900 dark:text-white">{employee.full_name}</div>
                                                        <div className="text-sm text-gray-600 dark:text-gray-200">{employee.email}</div>
                                                      </td>
                                                      <td className="px-6 py-4 whitespace-nowrap text-gray-600 dark:text-gray-200">
                                                        {employee.employee_id}
                                                      </td>
                                                      <td className="px-6 py-4 whitespace-nowrap text-gray-600 dark:text-gray-200">
                                                        {employee.branch}
                                                      </td>
                                                      <td className="px-6 py-4 whitespace-nowrap text-gray-600 dark:text-gray-200">
                                                        &#8369;{parseFloat(employee.salary || 0).toLocaleString()}
                                                      </td>
                                                      <td className="px-6 py-4 whitespace-nowrap text-gray-600 dark:text-gray-200">
                                                        {(() => {
                                                          const salary = parseFloat(employee.salary || 0);
                                                          const basis = employee.daily_rate_formula || employee.rate_formula || employee.dailyRateFormula;
                                                          let rate = 0;
                                                          let label = '';
                                                          if (basis) {
                                                            rate = computeDailyRateFromBasis(salary, basis);
                                                            label = ` (${basis})`;
                                                          } else if (parseFloat(employee.daily_rate) > 0) {
                                                            rate = parseFloat(employee.daily_rate);
                                                          } else {
                                                            rate = computeDailyRateFromBasis(salary, 313);
                                                          }
                                                          return <span>&#8369;{rate.toLocaleString(undefined,{minimumFractionDigits:2, maximumFractionDigits:2})}{label}</span>;
                                                        })()}
                                                      </td>
                                                      <td className="px-6 py-4 whitespace-nowrap">
                                                        <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                                                          employee.is_minimum_wage 
                                                            ? 'bg-orange-100 text-orange-800' 
                                                            : 'bg-green-100 text-green-800'
                                                        }`}>
                                                          {employee.is_minimum_wage ? 'Minimum' : 'Above Minimum'}
                                                        </span>
                                                      </td>
                                                      <td className="px-6 py-4 whitespace-nowrap">
                                                        {(() => {
                                                          const status = String(employee.status || 'active').toLowerCase();
                                                          const isActive = status !== 'inactive';
                                                          return (
                                                            <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                                                              isActive ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                                                            }`}>
                                                              {isActive ? 'Active' : 'Inactive'}
                                                            </span>
                                                          );
                                                        })()}
                                                      </td>
                                                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium space-x-2">
                                                        <Button 
                                                          size="sm" 
                                                          variant="ghost"
                                                          onClick={() => handleEditPayrollEmployee(employee)}
                                                          title="Edit Employee"
                                                        >
                                                          <Edit className="h-3 w-3" />
                                                        </Button>
                                                        <Button 
                                                          size="sm" 
                                                          variant="ghost" 
                                                          className="text-red-600 hover:text-red-800"
                                                          onClick={() => handleDeletePayrollEmployee(employee)}
                                                          title="Delete Employee"
                                                        >
                                                          <Trash2 className="h-3 w-3" />
                                                        </Button>
                                                      </td>
                                                    </tr>
                                                  ))
                                                ) : (
                                                  <tr>
                                                    <td colSpan="8" className="px-6 py-8 text-center">
                                                      <div className="flex flex-col items-center">
                                                        {searchEmployeeQuery ? (
                                                          <>
                                                            <Search className="h-12 w-12 text-gray-400 mb-4" />
                                                            <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">No employees found</h3>
                                                            <p className="text-gray-500 dark:text-gray-300">No employees match your search "{searchEmployeeQuery}"</p>
                                                          </>
                                                        ) : (
                                                          <>
                                                            <Users className="h-12 w-12 text-gray-400 mb-4" />
                                                            <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">No payroll employees yet</h3>
                                                            <p className="text-gray-500 dark:text-gray-300">Start by registering employees through the New Employee tab.</p>
                                                          </>
                                                        )}
                                                      </div>
                                                    </td>
                                                  </tr>
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </CardContent>
                                      </Card>
                                    </div>
                                  );
                                };

                                // Employee Running Status Content
                                const renderEmployeeRunningStatus = () => (
                                  <div className="space-y-6">
                                    <div>
                                      <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Employee Running Status</h2>
                                      <p className="text-gray-600 dark:text-gray-200">View comprehensive running statistics for individual employees</p>
                                    </div>

                                    {/* Employee Search */}
                                    <Card className="glass shadow-lg border-0">
                                      <CardHeader>
                                        <CardTitle>Search Employee</CardTitle>
                                      </CardHeader>
                                      <CardContent className="space-y-4">
                                        <div>
                                          <Label>Employee Name or ID Number</Label>
                                          <Input
                                            placeholder="Enter employee name or ID number to view statistics..."
                                            value={employeeStatusFilters.employee_query}
                                            onChange={(e) => setEmployeeStatusFilters({
                                              ...employeeStatusFilters, 
                                              employee_query: e.target.value
                                            })}
                                          />
                                        </div>
                                        
                                        {employeeStatusFilters.employee_query && (
                                          <div className="space-y-2">
                                            <Label>Search Results</Label>
                                            <div className="max-h-40 overflow-y-auto border rounded-lg">
                                              {employees
                                                .filter(emp => 
                                                  (emp.full_name?.toLowerCase().includes(employeeStatusFilters.employee_query.toLowerCase())) ||
                                                  (emp.employee_id?.toLowerCase().includes(employeeStatusFilters.employee_query.toLowerCase()))
                                                )
                                                .map(employee => (
                                                  <div
                                                    key={employee.id}
                                                    onClick={() => {
                                                      setSelectedStatusEmployee(employee);
                                                      calculateEmployeeRunningStats(employee);
                                                    }}
                                                    className={`p-3 cursor-pointer hover:bg-gray-50 dark:hover:bg-black border-b ${
                                                      selectedStatusEmployee?.id === employee.id ? 'bg-indigo-50' : ''
                                                    }`}
                                                  >
                                                    <div className="font-medium">{employee.full_name}</div>
                                                    <div className="text-sm text-gray-500 dark:text-gray-300">
                                                      ID: {employee.employee_id} | {employee.email} | {employee.branch}
                                                    </div>
                                                  </div>
                                                ))
                                              }
                                            </div>
                                          </div>
                                        )}
                                      </CardContent>
                                    </Card>

                                    {/* Employee Running Statistics */}
                                    {!selectedStatusEmployee ? (
                                      <Card className="glass shadow-lg border-0">
                                        <CardContent className="py-12">
                                          <div className="text-center">
                                            <BarChart3 className="h-16 w-16 text-gray-400 mx-auto mb-4" />
                                            <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">No Employee Selected</h3>
                                            <p className="text-gray-500 dark:text-gray-300">Please search and select an employee to view their running status</p>
                                          </div>
                                        </CardContent>
                                      </Card>
                                    ) : (
                                      <div className="space-y-6">
                                        {/* Employee Info Header */}
                                        <Card className="glass shadow-lg border-0 bg-indigo-50 border-indigo-200">
                                          <CardContent className="p-6">
                                            <div className="flex items-center space-x-4">
                                              <div className="flex-shrink-0">
                                                <div className="w-16 h-16 bg-indigo-600 rounded-full flex items-center justify-center">
                                                  <span className="text-2xl font-bold text-white">
                                                    {selectedStatusEmployee.full_name?.charAt(0).toUpperCase()}
                                                  </span>
                                                </div>
                                              </div>
                                              <div className="flex-1">
                                                <h3 className="text-xl font-bold text-indigo-800">{selectedStatusEmployee.full_name}</h3>
                                                <p className="text-indigo-600">ID: {selectedStatusEmployee.employee_id}</p>
                                                <p className="text-indigo-600">{selectedStatusEmployee.email}</p>
                                                <p className="text-indigo-600">Branch: {selectedStatusEmployee.branch}</p>
                                              </div>
                                            </div>
                                          </CardContent>
                                        </Card>

                                        {/* Running Statistics Cards */}
                                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                          {/* Present Days */}
                                          <Card className="bg-green-50 border-green-200">
                                            <CardContent className="p-6">
                                              <div className="flex items-center justify-between">
                                                <div>
                                                  <p className="text-sm font-medium text-green-700">Total Present Days</p>
                                                  <p className="text-3xl font-bold text-green-900">{employeeRunningStats.present_days}</p>
                                                  <p className="text-xs text-green-600">Overall attendance</p>
                                                </div>
                                                <CalendarCheck className="h-8 w-8 text-green-600" />
                                              </div>
                                            </CardContent>
                                          </Card>

                                          {/* Absent Days */}
                                          <Card className="bg-red-50 border-red-200">
                                            <CardContent className="p-6">
                                              <div className="flex items-center justify-between">
                                                <div>
                                                  <p className="text-sm font-medium text-red-700">Total Absent Days</p>
                                                  <p className="text-3xl font-bold text-red-900">{employeeRunningStats.absent_days}</p>
                                                  <p className="text-xs text-red-600">Days missed</p>
                                                </div>
                                                <Calendar className="h-8 w-8 text-red-600" />
                                              </div>
                                            </CardContent>
                                          </Card>

                                          {/* Late Minutes */}
                                          <Card className="bg-orange-50 border-orange-200">
                                            <CardContent className="p-6">
                                              <div className="flex items-center justify-between">
                                                <div>
                                                  <p className="text-sm font-medium text-orange-700">Total Late Minutes</p>
                                                  <p className="text-3xl font-bold text-orange-900">{employeeRunningStats.total_lates}</p>
                                                  <p className="text-xs text-orange-600">&#8776; {Math.round(employeeRunningStats.total_lates / 60 * 100) / 100} hours</p>
                                                </div>
                                                <Clock className="h-8 w-8 text-orange-600" />
                                              </div>
                                            </CardContent>
                                          </Card>

                                          {/* Undertime Minutes */}
                                          <Card className="bg-purple-50 border-purple-200">
                                            <CardContent className="p-6">
                                              <div className="flex items-center justify-between">
                                                <div>
                                                  <p className="text-sm font-medium text-purple-700">Total Undertime Minutes</p>
                                                  <p className="text-3xl font-bold text-purple-900">{employeeRunningStats.total_undertime}</p>
                                                  <p className="text-xs text-purple-600">&#8776; {Math.round(employeeRunningStats.total_undertime / 60 * 100) / 100} hours</p>
                                                </div>
                                                <Clock className="h-8 w-8 text-purple-600" />
                                              </div>
                                            </CardContent>
                                          </Card>

                                          {/* Total Deductions */}
                                          <Card className="bg-gray-50 border-gray-200">
                                            <CardContent className="p-6">
                                              <div className="flex items-center justify-between">
                                                <div>
                                                  <p className="text-sm font-medium text-gray-700 dark:text-gray-100">Total Deductions</p>
                                                  <p className="text-3xl font-bold text-gray-900 dark:text-white">&#8369;{employeeRunningStats.total_deductions.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</p>
                                                  <p className="text-xs text-gray-600 dark:text-gray-200">All deductions combined</p>
                                                </div>
                                                <FileText className="h-8 w-8 text-gray-600 dark:text-gray-200" />
                                              </div>
                                            </CardContent>
                                          </Card>

                                          {/* Net Salary */}
                                          <Card className="bg-blue-50 border-blue-200">
                                            <CardContent className="p-6">
                                              <div className="flex items-center justify-between">
                                                <div>
                                                  <p className="text-sm font-medium text-blue-700">Net Salary</p>
                                                  <p className="text-3xl font-bold text-blue-900">&#8369;{employeeRunningStats.net_salary.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</p>
                                                  <p className="text-xs text-blue-600">After all deductions</p>
                                                </div>
                                                <Users className="h-8 w-8 text-blue-600" />
                                              </div>
                                            </CardContent>
                                          </Card>
                                        </div>

                                        {/* Summary Card */}
                                        <Card className="bg-gradient-to-r from-indigo-50 to-purple-50 border-indigo-200">
                                          <CardHeader>
                                            <CardTitle className="text-indigo-800">Employee Performance Summary</CardTitle>
                                          </CardHeader>
                                          <CardContent>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                              <div>
                                                <h4 className="font-semibold text-indigo-700 mb-2">Attendance Overview</h4>
                                                <div className="space-y-1 text-sm">
                                                  <p className="flex justify-between">
                                                    <span>Present Days:</span>
                                                    <span className="font-medium text-green-600">{employeeRunningStats.present_days}</span>
                                                  </p>
                                                  <p className="flex justify-between">
                                                    <span>Absent Days:</span>
                                                    <span className="font-medium text-red-600">{employeeRunningStats.absent_days}</span>
                                                  </p>
                                                  <p className="flex justify-between">
                                                    <span>Attendance Rate:</span>
                                                    <span className="font-medium text-indigo-600">
                                                      {employeeRunningStats.present_days + employeeRunningStats.absent_days > 0 
                                                        ? Math.round((employeeRunningStats.present_days / (employeeRunningStats.present_days + employeeRunningStats.absent_days)) * 100) 
                                                        : 0}%
                                                    </span>
                                                  </p>
                                                </div>
                                              </div>
                                              <div>
                                                <h4 className="font-semibold text-indigo-700 mb-2">Financial Overview</h4>
                                                <div className="space-y-1 text-sm">
                                                  <p className="flex justify-between">
                                                    <span>Total Deductions:</span>
                                                    <span className="font-medium text-red-600">&#8369;{employeeRunningStats.total_deductions.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>
                                                  </p>
                                                  <p className="flex justify-between">
                                                    <span>Net Salary:</span>
                                                    <span className="font-medium text-green-600">&#8369;{employeeRunningStats.net_salary.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          </CardContent>
                                        </Card>
                                      </div>
                                    )}
                                  </div>
                                );

                                // Payroll Database Content

                                // Employees Content


// renderCCP function removed

                                // Management Print System Tab Content (Project Monitoring System - Dashboard Only)
                                const rpZEAWYtiB6bJ16NuLbGCc6CZ6jJdKfb63 = () => {
                                  // Calculate project statistics
                                  const totalProjects = projects.length;
                                  const completedProjects = projects.filter(p => p.status === 'Completed').length;
                                  const inProgressProjects = projects.filter(p => p.status === 'In Progress').length;
                                  const completionRate = totalProjects > 0 ? Math.round((completedProjects / totalProjects) * 100) : 0;

                                  // Get current date and time
                                  const currentDateTime = new Date().toLocaleString('en-US', {
                                    weekday: 'long',
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit'
                                  });

                                  return (
                                    <div className="space-y-6">
                                      {/* Header with title and time */}
                                      <div className="flex justify-between items-center">
                                        <div>
                                          <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Project Monitoring System</h2>
                                          <p className="text-gray-600 dark:text-gray-200">Manage projects, operations and resources</p>
                                        </div>
                                        <div className="text-sm text-gray-500 dark:text-gray-300">
                                          {currentDateTime}
                                        </div>
                                      </div>

                                      {/* Monitoring Tiles Section */}
                                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                                        <Card className="glass shadow-lg border-0 border-l-4 border-l-blue-500">
                                          <CardContent className="p-6">
                                            <div className="flex items-center justify-between">
                                              <div>
                                                <p className="text-sm font-medium text-gray-600 dark:text-gray-200">Total Projects</p>
                                                <p className="text-3xl font-bold text-gray-900 dark:text-white mt-2">{totalProjects}</p>
                                              </div>
                                              <FileText className="h-10 w-10 text-blue-500" />
                                            </div>
                                          </CardContent>
                                        </Card>

                                        <Card className="glass shadow-lg border-0 border-l-4 border-l-green-500">
                                          <CardContent className="p-6">
                                            <div className="flex items-center justify-between">
                                              <div>
                                                <p className="text-sm font-medium text-gray-600 dark:text-gray-200">Completed</p>
                                                <p className="text-3xl font-bold text-gray-900 dark:text-white mt-2">{completedProjects}</p>
                                              </div>
                                              <CheckCircle className="h-10 w-10 text-green-500" />
                                            </div>
                                          </CardContent>
                                        </Card>

                                        <Card className="glass shadow-lg border-0 border-l-4 border-l-orange-500">
                                          <CardContent className="p-6">
                                            <div className="flex items-center justify-between">
                                              <div>
                                                <p className="text-sm font-medium text-gray-600 dark:text-gray-200">In Progress</p>
                                                <p className="text-3xl font-bold text-gray-900 dark:text-white mt-2">{inProgressProjects}</p>
                                              </div>
                                              <Users className="h-10 w-10 text-orange-500" />
                                            </div>
                                          </CardContent>
                                        </Card>

                                        <Card className="glass shadow-lg border-0 border-l-4 border-l-purple-500">
                                          <CardContent className="p-6">
                                            <div className="flex items-center justify-between">
                                              <div>
                                                <p className="text-sm font-medium text-gray-600 dark:text-gray-200">Completion Rate</p>
                                                <p className="text-3xl font-bold text-gray-900 dark:text-white mt-2">{completionRate}%</p>
                                              </div>
                                              <BarChart3 className="h-10 w-10 text-purple-500" />
                                            </div>
                                          </CardContent>
                                        </Card>
                                      </div>
                                    </div>
                                  );
                                };

                                // MPS - Project Management Section
                                const renderMPS = () => {
                                  // Get current date and time
                                  const currentDateTime = new Date().toLocaleString('en-US', {
                                    weekday: 'long',
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit'
                                  });

                                  const handleCreateProject = async () => {
                                    // Validate required fields
                                    if (!newProject.title.trim()) {
                                      toast.error('Please enter a project title');
                                      return;
                                    }
                                    if (!newProject.accountName.trim()) {
                                      toast.error('Please enter an account name');
                                      return;
                                    }
                                    if (!newProject.companyAddress.trim()) {
                                      toast.error('Please enter a company address');
                                      return;
                                    }
                                    
                                    // Validate at least one filled contact person
                                    const validContactPersons = newProject.contactPersons.filter(p => p.trim());
                                    if (validContactPersons.length === 0) {
                                      toast.error('Please add at least one contact person');
                                      return;
                                    }
                                    
                                    // Validate at least one filled contact detail
                                    const validContactDetails = newProject.contactDetails.filter(d => d.trim());
                                    if (validContactDetails.length === 0) {
                                      toast.error('Please add at least one contact detail');
                                      return;
                                    }
                                    
                                    // Validate at least one filled email address
                                    const validEmailAddresses = newProject.emailAddresses.filter(e => e.trim());
                                    if (validEmailAddresses.length === 0) {
                                      toast.error('Please add at least one email address');
                                      return;
                                    }

                                    try {
                                      const projectData = {
                                        title: newProject.title,
                                        accountName: newProject.accountName,
                                        companyAddress: newProject.companyAddress,
                                        contactPersons: validContactPersons,
                                        contactDetails: validContactDetails,
                                        emailAddresses: validEmailAddresses,
                                        status: newProject.status,
                                        startDate: newProject.startDate || null,
                                        endDate: newProject.endDate || null
                                      };

                                      const response = await axiosInstance.post('/projects', projectData);
                                      
                                      // Add the new project to the local state
                                      setProjects([...projects, response.data]);
                                      setIsCreateProjectModalOpen(false);
                                      
                                      // Reset form
                                      setNewProject({
                                        title: '',
                                        accountName: '',
                                        companyAddress: '',
                                        contactPersons: [''],
                                        contactDetails: [''],
                                        emailAddresses: [''],
                                        status: 'Planning',
                                        startDate: '',
                                        endDate: ''
                                      });
                                      
                                      toast.success('Project created successfully!');
                                    } catch (error) {
                                      console.error('Error creating project:', error);
                                      toast.error('Failed to create project');
                                    }
                                  };

                                  const handleDeleteProject = async (projectId, e) => {
                                    e.stopPropagation(); // Prevent tile click when deleting
                                    const confirmed = await confirmDialog({
                                        title: "Delete Project",
                                        description: "Are you sure you want to delete this project?",
                                        variant: "destructive"
                                    });
                                    if (confirmed) {
                                      try {
                                        await axiosInstance.delete(`/projects/${projectId}`);
                                        setProjects(projects.filter(p => p.id !== projectId));
                                        toast.success('Project deleted successfully');
                                        
                                        // If the deleted project was selected, clear the selection
                                        if (selectedProject?.id === projectId) {
                                          setSelectedProject(null);
                                        }
                                      } catch (error) {
                                        console.error('Error deleting project:', error);
                                        toast.error('Failed to delete project');
                                      }
                                    }
                                  };
                                  
                                  const handleEditProject = (project, e) => {
                                    e.stopPropagation(); // Prevent tile click when editing
                                    setEditingProject({
                                      ...project,
                                      contactPersons: project.contactPersons || [''],
                                      contactDetails: project.contactDetails || [''],
                                      emailAddresses: project.emailAddresses || ['']
                                    });
                                    setIsEditProjectModalOpen(true);
                                  };
                                  
                                  const updateProject = async () => {
                                    try {
                                      const response = await axiosInstance.put(`/projects/${editingProject.id}`, editingProject);
                                      const updatedProjects = projects.map(p => 
                                        p.id === editingProject.id ? response.data : p
                                      );
                                      setProjects(updatedProjects);
                                      
                                      // Update selectedProject if it's the one being edited
                                      if (selectedProject?.id === editingProject.id) {
                                        setSelectedProject(response.data);
                                      }
                                      
                                      toast.success('Project updated successfully');
                                      setIsEditProjectModalOpen(false);
                                      setEditingProject(null);
                                    } catch (error) {
                                      console.error('Error updating project:', error);
                                      toast.error('Failed to update project');
                                    }
                                  };

                                  const handleProjectClick = (project) => {
                                    setSelectedProject(project);
                                    setProjectDetailTab('overview'); // Reset to overview tab
                                    fetchProjectTasks(project.id); // Fetch tasks for this project
                                    fetchProjectDepartments(project.id); // Fetch departments for this project
                                    fetchBillingExports(project.id); // Fetch billing exports for this project
                                    fetchSalesInvoices(project.id); // Fetch sales invoices for this project
                                    fetchCollections(project.id); // Fetch collections for this project
                                    
                                    // Fetch task attendance for all tasks (we'll get tasks first, then fetch attendance)
                                    setTimeout(async () => {
                                      if (projectTasks && projectTasks.length > 0) {
                                        for (const task of projectTasks) {
                                          await fetchTaskAttendance(task.id);
                                        }
                                      }
                                    }, 1000);
                                  };

                                  // Helper functions for adding/removing dynamic fields
                                  const addContactPerson = () => {
                                    setNewProject({...newProject, contactPersons: [...newProject.contactPersons, '']});
                                  };

                                  const removeContactPerson = (index) => {
                                    const updated = newProject.contactPersons.filter((_, i) => i !== index);
                                    setNewProject({...newProject, contactPersons: updated.length > 0 ? updated : ['']});
                                  };

                                  const updateContactPerson = (index, value) => {
                                    const updated = [...newProject.contactPersons];
                                    updated[index] = value;
                                    setNewProject({...newProject, contactPersons: updated});
                                  };

                                  const addContactDetail = () => {
                                    setNewProject({...newProject, contactDetails: [...newProject.contactDetails, '']});
                                  };

                                  const removeContactDetail = (index) => {
                                    const updated = newProject.contactDetails.filter((_, i) => i !== index);
                                    setNewProject({...newProject, contactDetails: updated.length > 0 ? updated : ['']});
                                  };

                                  const updateContactDetail = (index, value) => {
                                    const updated = [...newProject.contactDetails];
                                    updated[index] = value;
                                    setNewProject({...newProject, contactDetails: updated});
                                  };

                                  const addEmailAddress = () => {
                                    setNewProject({...newProject, emailAddresses: [...newProject.emailAddresses, '']});
                                  };

                                  const removeEmailAddress = (index) => {
                                    const updated = newProject.emailAddresses.filter((_, i) => i !== index);
                                    setNewProject({...newProject, emailAddresses: updated.length > 0 ? updated : ['']});
                                  };

                                  const updateEmailAddress = (index, value) => {
                                    const updated = [...newProject.emailAddresses];
                                    updated[index] = value;
                                    setNewProject({...newProject, emailAddresses: updated});
                                  };
                                  
                                  // Edit project helpers
                                  const addEditContactPerson = () => {
                                    setEditingProject({...editingProject, contactPersons: [...editingProject.contactPersons, '']});
                                  };

                                  const removeEditContactPerson = (index) => {
                                    const updated = editingProject.contactPersons.filter((_, i) => i !== index);
                                    setEditingProject({...editingProject, contactPersons: updated.length > 0 ? updated : ['']});
                                  };

                                  const updateEditContactPerson = (index, value) => {
                                    const updated = [...editingProject.contactPersons];
                                    updated[index] = value;
                                    setEditingProject({...editingProject, contactPersons: updated});
                                  };

                                  const addEditContactDetail = () => {
                                    setEditingProject({...editingProject, contactDetails: [...editingProject.contactDetails, '']});
                                  };

                                  const removeEditContactDetail = (index) => {
                                    const updated = editingProject.contactDetails.filter((_, i) => i !== index);
                                    setEditingProject({...editingProject, contactDetails: updated.length > 0 ? updated : ['']});
                                  };

                                  const updateEditContactDetail = (index, value) => {
                                    const updated = [...editingProject.contactDetails];
                                    updated[index] = value;
                                    setEditingProject({...editingProject, contactDetails: updated});
                                  };

                                  const addEditEmailAddress = () => {
                                    setEditingProject({...editingProject, emailAddresses: [...editingProject.emailAddresses, '']});
                                  };

                                  const removeEditEmailAddress = (index) => {
                                    const updated = editingProject.emailAddresses.filter((_, i) => i !== index);
                                    setEditingProject({...editingProject, emailAddresses: updated.length > 0 ? updated : ['']});
                                  };

                                  const updateEditEmailAddress = (index, value) => {
                                    const updated = [...editingProject.emailAddresses];
                                    updated[index] = value;
                                    setEditingProject({...editingProject, emailAddresses: updated});
                                  };

                                  // If a project is selected, show project detail view
                                  if (selectedProject) {
                                    return (
                                      <div className="space-y-6">
                                        {/* Header with back button */}
                                        <div className="flex items-center gap-4">
                                          <Button
                                            variant="outline"
                                            onClick={() => setSelectedProject(null)}
                                            size="sm"
                                          >
                                            <ChevronLeft className="h-4 w-4 mr-1" />
                                            Back to Projects
                                          </Button>
                                          <div className="flex-1">
                                            <h2 className="text-2xl font-bold text-gray-900 dark:text-white">{selectedProject.name}</h2>
                                            <p className="text-gray-600 dark:text-gray-200">{selectedProject.description || 'No description'}</p>
                                          </div>
                                          <div className="text-sm text-gray-500 dark:text-gray-300">
                                            {currentDateTime}
                                          </div>
                                        </div>

                                        {/* Tab Navigation */}
                                        <div className="border-b border-gray-200">
                                          <div className="flex space-x-1">
                                            <button
                                              onClick={() => setProjectDetailTab('overview')}
                                              className={`px-6 py-3 font-medium text-sm transition-colors ${
                                                projectDetailTab === 'overview'
                                                  ? 'text-indigo-600 border-b-2 border-indigo-600'
                                                  : 'text-gray-600 dark:text-gray-200 hover:text-gray-900 dark:text-white'
                                              }`}
                                            >
                                              Project Overview
                                            </button>
                                            <button
                                              onClick={() => setProjectDetailTab('meter')}
                                              className={`px-6 py-3 font-medium text-sm transition-colors ${
                                                projectDetailTab === 'meter'
                                                  ? 'text-indigo-600 border-b-2 border-indigo-600'
                                                  : 'text-gray-600 dark:text-gray-200 hover:text-gray-900 dark:text-white'
                                              }`}
                                            >
                                              Meter Reading
                                            </button>
                                            <button
                                              onClick={() => setProjectDetailTab('billing')}
                                              className={`px-6 py-3 font-medium text-sm transition-colors ${
                                                projectDetailTab === 'billing'
                                                  ? 'text-indigo-600 border-b-2 border-indigo-600'
                                                  : 'text-gray-600 dark:text-gray-200 hover:text-gray-900 dark:text-white'
                                              }`}
                                            >
                                              Billing
                                            </button>
                                            <button
                                              onClick={() => setProjectDetailTab('si')}
                                              className={`px-6 py-3 font-medium text-sm transition-colors ${
                                                projectDetailTab === 'si'
                                                  ? 'text-indigo-600 border-b-2 border-indigo-600'
                                                  : 'text-gray-600 dark:text-gray-200 hover:text-gray-900 dark:text-white'
                                              }`}
                                            >
                                              SI
                                            </button>
                                            <button
                                              onClick={() => setProjectDetailTab('collection')}
                                              className={`px-6 py-3 font-medium text-sm transition-colors ${
                                                projectDetailTab === 'collection'
                                                  ? 'text-indigo-600 border-b-2 border-indigo-600'
                                                  : 'text-gray-600 dark:text-gray-200 hover:text-gray-900 dark:text-white'
                                              }`}
                                            >
                                              Collection
                                            </button>
                                            <button
                                              onClick={() => setProjectDetailTab('settings')}
                                              className={`px-6 py-3 font-medium text-sm transition-colors ${
                                                projectDetailTab === 'settings'
                                                  ? 'text-indigo-600 border-b-2 border-indigo-600'
                                                  : 'text-gray-600 dark:text-gray-200 hover:text-gray-900 dark:text-white'
                                              }`}
                                            >
                                              Project Settings
                                            </button>
                                          </div>
                                        </div>

                                        {/* Tab Content - Scrollable Container */}
                                        <div className="mt-6 max-h-[calc(100vh-300px)] overflow-y-auto pr-2">
                                          {projectDetailTab === 'overview' && (
                                            <Card className="glass shadow-lg border-0">
                                              <CardHeader>
                                                <CardTitle>Project Overview</CardTitle>
                                                <CardDescription>Project details and information</CardDescription>
                                              </CardHeader>
                                              <CardContent>
                                                {/* Statistics Tiles */}
                                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                                                  {/* Departments Tile */}
                                                  <div
                                                    onClick={() => setIsDepartmentsModalOpen(true)}
                                                    className="bg-gradient-to-br from-blue-50 to-blue-100 border-2 border-blue-200 rounded-lg p-6 cursor-pointer hover:shadow-lg transition-all"
                                                  >
                                                    <div className="flex items-center justify-between mb-2">
                                                      <h3 className="text-sm font-medium text-blue-700">Departments</h3>
                                                      <Building2 className="h-8 w-8 text-blue-600" />
                                                    </div>
                                                    <p className="text-3xl font-bold text-blue-900">{departments?.length || 0}</p>
                                                    <p className="text-xs text-blue-600 mt-2">Click to view list</p>
                                                  </div>

                                                  {/* Machines Tile */}
                                                  <div
                                                    onClick={() => setIsMachinesModalOpen(true)}
                                                    className="bg-gradient-to-br from-purple-50 to-purple-100 border-2 border-purple-200 rounded-lg p-6 cursor-pointer hover:shadow-lg transition-all"
                                                  >
                                                    <div className="flex items-center justify-between mb-2">
                                                      <h3 className="text-sm font-medium text-purple-700">Machines</h3>
                                                      <Printer className="h-8 w-8 text-purple-600" />
                                                    </div>
                                                    <p className="text-3xl font-bold text-purple-900">
                                                      {departments?.reduce((total, dept) => total + (dept.machines?.length || 0), 0) || 0}
                                                    </p>
                                                    <p className="text-xs text-purple-600 mt-2">Click to view list</p>
                                                  </div>

                                                  {/* Earnings Tile */}
                                                  <div
                                                    onClick={() => setIsEarningsModalOpen(true)}
                                                    className="bg-gradient-to-br from-green-50 to-green-100 border-2 border-green-200 rounded-lg p-6 cursor-pointer hover:shadow-lg transition-all"
                                                  >
                                                    <div className="flex items-center justify-between mb-2">
                                                      <h3 className="text-sm font-medium text-green-700">Total Earnings</h3>
                                                      <DollarSign className="h-8 w-8 text-green-600" />
                                                    </div>
                                                    <p className="text-3xl font-bold text-green-900">
                                                      &#8369;{collections?.reduce((total, c) => total + (c.totalAmount || 0), 0).toFixed(2) || '0.00'}
                                                    </p>
                                                    <p className="text-xs text-green-600 mt-2">Click to view breakdown</p>
                                                  </div>
                                                </div>

                                                <div className="space-y-6">
                                                  <div className="grid grid-cols-2 gap-6">
                                                    <div>
                                                      <p className="text-sm font-medium text-gray-500 dark:text-gray-300">Project Title</p>
                                                      <p className="text-lg font-semibold text-gray-900 dark:text-white mt-1">{selectedProject.title || selectedProject.name}</p>
                                                    </div>
                                                    <div>
                                                      <p className="text-sm font-medium text-gray-500 dark:text-gray-300">Status</p>
                                                      <span className={`inline-flex px-3 py-1 text-sm font-medium rounded-full mt-1 ${
                                                        selectedProject.status === 'Complete' ? 'bg-blue-100 text-blue-800' :
                                                        selectedProject.status === 'Running' ? 'bg-green-100 text-green-800' :
                                                        selectedProject.status === 'Pending' ? 'bg-yellow-100 text-yellow-800' :
                                                        'bg-gray-100 text-gray-800 dark:text-white'
                                                      }`}>
                                                        {selectedProject.status}
                                                      </span>
                                                    </div>
                                                  </div>

                                                  <div>
                                                    <p className="text-sm font-medium text-gray-500 dark:text-gray-300">Account Name</p>
                                                    <p className="text-lg text-gray-900 dark:text-white mt-1">{selectedProject.accountName || 'Not specified'}</p>
                                                  </div>

                                                  <div>
                                                    <p className="text-sm font-medium text-gray-500 dark:text-gray-300">Company Address</p>
                                                    <p className="text-gray-900 dark:text-white mt-1">{selectedProject.companyAddress || 'Not specified'}</p>
                                                  </div>
                                                  
                                                  <div>
                                                    <p className="text-sm font-medium text-gray-500 dark:text-gray-300">Billing Statement Code</p>
                                                    <p className="text-lg font-semibold text-indigo-600 mt-1">{selectedProject.billingStatementCode || 'Not set'}</p>
                                                  </div>

                                                  <div>
                                                    <p className="text-sm font-medium text-gray-500 dark:text-gray-300 mb-2">Contact Person(s)</p>
                                                    {selectedProject.contactPersons && selectedProject.contactPersons.filter(p => p).length > 0 ? (
                                                      <ul className="space-y-1">
                                                        {selectedProject.contactPersons.filter(p => p).map((person, index) => (
                                                          <li key={index} className="text-gray-900 dark:text-white pl-4 border-l-2 border-indigo-200">{person}</li>
                                                        ))}
                                                      </ul>
                                                    ) : (
                                                      <p className="text-gray-500 dark:text-gray-300">No contact persons</p>
                                                    )}
                                                  </div>

                                                  <div>
                                                    <p className="text-sm font-medium text-gray-500 dark:text-gray-300 mb-2">Contact Details</p>
                                                    {selectedProject.contactDetails && selectedProject.contactDetails.filter(d => d).length > 0 ? (
                                                      <ul className="space-y-1">
                                                        {selectedProject.contactDetails.filter(d => d).map((detail, index) => (
                                                          <li key={index} className="text-gray-900 dark:text-white pl-4 border-l-2 border-green-200">{detail}</li>
                                                        ))}
                                                      </ul>
                                                    ) : (
                                                      <p className="text-gray-500 dark:text-gray-300">No contact details</p>
                                                    )}
                                                  </div>

                                                  <div>
                                                    <p className="text-sm font-medium text-gray-500 dark:text-gray-300 mb-2">Email Address(es)</p>
                                                    {selectedProject.emailAddresses && selectedProject.emailAddresses.filter(e => e).length > 0 ? (
                                                      <ul className="space-y-1">
                                                        {selectedProject.emailAddresses.filter(e => e).map((email, index) => (
                                                          <li key={index} className="text-gray-900 dark:text-white pl-4 border-l-2 border-blue-200">
                                                            <a href={`mailto:${email}`} className="text-indigo-600 hover:text-indigo-800">{email}</a>
                                                          </li>
                                                        ))}
                                                      </ul>
                                                    ) : (
                                                      <p className="text-gray-500 dark:text-gray-300">No email addresses</p>
                                                    )}
                                                  </div>

                                                  <div className="grid grid-cols-2 gap-6 pt-4 border-t">
                                                    <div>
                                                      <p className="text-sm font-medium text-gray-500 dark:text-gray-300">Start Date</p>
                                                      <p className="text-lg text-gray-900 dark:text-white mt-1">
                                                        {selectedProject.startDate ? new Date(selectedProject.startDate).toLocaleDateString() : 'Not set'}
                                                      </p>
                                                    </div>
                                                    <div>
                                                      <p className="text-sm font-medium text-gray-500 dark:text-gray-300">End Date</p>
                                                      <p className="text-lg text-gray-900 dark:text-white mt-1">
                                                        {selectedProject.endDate ? new Date(selectedProject.endDate).toLocaleDateString() : 'Not set'}
                                                      </p>
                                                    </div>
                                                  </div>

                                                  <div>
                                                    <p className="text-sm font-medium text-gray-500 dark:text-gray-300">Created</p>
                                                    <p className="text-gray-900 dark:text-white mt-1">
                                                      {selectedProject.createdAt ? new Date(selectedProject.createdAt).toLocaleString() : 'N/A'}
                                                    </p>
                                                  </div>

                                                  {/* Task Summary Section */}
                                                  {projectTasks && projectTasks.length > 0 && (
                                                    <div className="mt-8 pt-6 border-t">
                                                      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Task Summary</h3>
                                                      <div className="space-y-4">
                                                        {projectTasks.map((task) => {
                                                          const taskDates = getTaskDateRange(task);
                                                          const attendedDates = taskAttendedDates[task.id] || [];
                                                          const totalDays = taskDates.length;
                                                          const attendedDays = attendedDates.length;
                                                          const unattendedDays = totalDays - attendedDays;
                                                          
                                                          // Calculate if task is past due
                                                          const today = new Date();
                                                          today.setHours(0, 0, 0, 0);
                                                          const endDate = new Date(task.end_date);
                                                          endDate.setHours(0, 0, 0, 0);
                                                          const isPastDue = today > endDate;
                                                          const daysPastDue = isPastDue ? Math.ceil((today - endDate) / (1000 * 60 * 60 * 24)) : 0;
                                                          
                                                          const completion = calculateTaskCompletion(task);
                                                          const status = calculateTaskStatus(task);
                                                          
                                                          return (
                                                            <div key={task.id} className="bg-white border border-gray-200 rounded-lg p-4">
                                                              <div className="flex justify-between items-start mb-3">
                                                                <div className="flex-1">
                                                                  <h4 className="font-medium text-gray-900 dark:text-white">{task.task_name}</h4>
                                                                  <p className="text-sm text-gray-600 dark:text-gray-200">Assigned to: {task.assigned_resources}</p>
                                                                  <p className="text-xs text-gray-500 dark:text-gray-300">
                                                                    {new Date(task.start_date).toLocaleDateString()} - {new Date(task.end_date).toLocaleDateString()}
                                                                  </p>
                                                                </div>
                                                                <div className="flex items-center gap-4">
                                                                  {isPastDue && (
                                                                    <div className="text-right">
                                                                      <span className="inline-flex px-2 py-1 text-xs font-medium rounded-full bg-red-100 text-red-800">
                                                                        Past Due
                                                                      </span>
                                                                      <p className="text-xs text-red-600 mt-1">{daysPastDue} days past due</p>
                                                                    </div>
                                                                  )}
                                                                  <span className={`inline-flex px-3 py-1 text-sm font-medium rounded-full ${
                                                                    status === 'Completed' ? 'bg-green-100 text-green-800' :
                                                                    status === 'In Progress' ? 'bg-blue-100 text-blue-800' :
                                                                    'bg-gray-100 text-gray-800 dark:text-white'
                                                                  }`}>
                                                                    {status}
                                                                  </span>
                                                                </div>
                                                              </div>
                                                              
                                                              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                                                                {/* Total Days */}
                                                                <div className="text-center p-3 bg-gray-50 rounded-lg">
                                                                  <div className="text-2xl font-bold text-gray-900 dark:text-white">{totalDays}</div>
                                                                  <div className="text-xs text-gray-600 dark:text-gray-200">Total Days</div>
                                                                </div>
                                                                
                                                                {/* Attended Days */}
                                                                <div className="text-center p-3 bg-green-50 rounded-lg">
                                                                  <div className="text-2xl font-bold text-green-700">{attendedDays}</div>
                                                                  <div className="text-xs text-green-600">Attended</div>
                                                                </div>
                                                                
                                                                {/* Unattended Days */}
                                                                <div className="text-center p-3 bg-red-50 rounded-lg">
                                                                  <div className="text-2xl font-bold text-red-700">{unattendedDays}</div>
                                                                  <div className="text-xs text-red-600">Unattended</div>
                                                                </div>
                                                                
                                                                {/* Completion Percentage */}
                                                                <div className="text-center p-3 bg-blue-50 rounded-lg">
                                                                  <div className={`text-2xl font-bold ${
                                                                    completion >= 75 ? 'text-green-700' :
                                                                    completion >= 50 ? 'text-blue-700' :
                                                                    completion >= 25 ? 'text-orange-700' :
                                                                    'text-gray-700 dark:text-gray-100'
                                                                  }`}>
                                                                    {completion}%
                                                                  </div>
                                                                  <div className="text-xs text-gray-600 dark:text-gray-200">Complete</div>
                                                                </div>
                                                              </div>
                                                              
                                                              {/* Progress Bar */}
                                                              <div className="mt-3">
                                                                <div className="flex justify-between text-xs text-gray-600 dark:text-gray-200 mb-1">
                                                                  <span>Progress</span>
                                                                  <span>{attendedDays} of {totalDays} days</span>
                                                                </div>
                                                                <div className="w-full bg-gray-200 rounded-full h-2">
                                                                  <div 
                                                                    className={`h-2 rounded-full ${
                                                                      completion >= 75 ? 'bg-green-600' :
                                                                      completion >= 50 ? 'bg-blue-600' :
                                                                      completion >= 25 ? 'bg-orange-600' :
                                                                      'bg-gray-600'
                                                                    }`}
                                                                    style={{ width: `${completion}%` }}
                                                                  ></div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          );
                                                        })}
                                                      </div>
                                                    </div>
                                                  )}

                                                  {projectTasks && projectTasks.length === 0 && (
                                                    <div className="mt-8 pt-6 border-t text-center py-8">
                                                      <Calendar className="h-12 w-12 text-gray-300 mx-auto mb-3" />
                                                      <p className="text-gray-500 dark:text-gray-300 text-sm">No tasks added yet. Go to Project Settings to add tasks.</p>
                                                    </div>
                                                  )}
                                                </div>
                                              </CardContent>
                                            </Card>
                                          )}

                                          {projectDetailTab === 'meter' && (
                                            <Card className="glass shadow-lg border-0">
                                              <CardHeader>
                                                <CardTitle className="flex justify-between items-center">
                                                  <span>Meter Reading</span>
                                                  <div className="flex gap-2">
                                                    <Button
                                                      onClick={() => exportDepartmentDataCSV()}
                                                      variant="outline"
                                                      className="flex items-center gap-2"
                                                    >
                                                      <Download className="h-4 w-4" />
                                                      Export CSV
                                                    </Button>
                                                    <Button
                                                      onClick={() => exportDepartmentData()}
                                                      variant="outline"
                                                      className="flex items-center gap-2"
                                                    >
                                                      <FileText className="h-4 w-4" />
                                                      Export PDF
                                                    </Button>
                                                    <Button
                                                      onClick={() => setIsFilterExportModalOpen(true)}
                                                      variant="outline"
                                                      className="flex items-center gap-2 bg-purple-50 border-purple-300 hover:bg-purple-100"
                                                    >
                                                      <Filter className="h-4 w-4" />
                                                      Filter Export
                                                    </Button>
                                                    <Button
                                                      onClick={() => setIsCreateDepartmentModalOpen(true)}
                                                      className="bg-indigo-600 hover:bg-indigo-700"
                                                    >
                                                      <Plus className="h-4 w-4 mr-1" />
                                                      New Department
                                                    </Button>
                                                  </div>
                                                </CardTitle>
                                                <CardDescription>Track and manage meter readings by department</CardDescription>
                                              </CardHeader>
                                              <CardContent>
                                                {departments.length === 0 ? (
                                                  <div className="text-center py-12">
                                                    <Building className="h-16 w-16 text-gray-400 mx-auto mb-4" />
                                                    <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">No Departments Yet</h3>
                                                    <p className="text-gray-500 dark:text-gray-300 mb-4">Create your first department to start managing meter readings.</p>
                                                    <Button
                                                      onClick={() => setIsCreateDepartmentModalOpen(true)}
                                                      className="bg-indigo-600 hover:bg-indigo-700"
                                                    >
                                                      <Plus className="h-4 w-4 mr-1" />
                                                      Create First Department
                                                    </Button>
                                                  </div>
                                                ) : (
                                                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                                                    {(departments || []).map((department) => (
                                                      <div key={department.id} className="border-2 border-gray-200 rounded-lg p-6 bg-gray-50">
                                                        <div className="flex justify-between items-center mb-4">
                                                          <h3 className="text-xl font-semibold text-gray-900 dark:text-white">{department.name || 'Unnamed Department'}</h3>
                                                          <div className="flex gap-2">
                                                            <Button
                                                              size="sm"
                                                              variant="outline"
                                                              onClick={() => editDepartment(department)}
                                                              className="text-blue-600 hover:text-blue-800"
                                                            >
                                                              <Edit className="h-3 w-3 mr-1" />
                                                              Edit
                                                            </Button>
                                                            <Button
                                                              size="sm"
                                                              variant="outline"
                                                              onClick={() => deleteDepartment(department)}
                                                              className="text-red-600 hover:text-red-800"
                                                            >
                                                              <Trash2 className="h-3 w-3 mr-1" />
                                                              Delete
                                                            </Button>
                                                            <Button
                                                              size="sm"
                                                              onClick={() => {
                                                                setSelectedDepartmentForMachine(department);
                                                                setIsCreateMachineModalOpen(true);
                                                              }}
                                                              className="bg-green-600 hover:bg-green-700"
                                                            >
                                                              <Plus className="h-3 w-3 mr-1" />
                                                              Machine
                                                            </Button>
                                                          </div>
                                                        </div>
                                                        
                                                        {!department.machines || department.machines.length === 0 ? (
                                                          <div className="text-center py-8 border-2 border-dashed border-gray-300 rounded-lg bg-white">
                                                            <Cog className="h-10 w-10 text-gray-400 mx-auto mb-2" />
                                                            <p className="text-gray-500 dark:text-gray-300 text-sm">No machines added yet</p>
                                                            <p className="text-gray-400 text-xs">Click "+ Machine" to add the first machine</p>
                                                          </div>
                                                        ) : (
                                                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                                            {department.machines.map((machine) => {
                                                              const repairStatus = getMachineRepairStatus(machine);
                                                              const mhrButtonColor = 
                                                                repairStatus === 'completed' ? 'bg-green-500 hover:bg-green-600' :
                                                                repairStatus === 'parts-requested' ? 'bg-yellow-500 hover:bg-yellow-600' :
                                                                repairStatus === 'diagnosed' ? 'bg-red-500 hover:bg-red-600' :
                                                                'bg-gray-500 hover:bg-gray-600';
                                                              
                                                              return (
                                                                <div
                                                                  key={machine.id}
                                                                  className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-all hover:border-indigo-300"
                                                                >
                                                                  <div className="flex items-center justify-between mb-3">
                                                                    <div className="flex items-center gap-3 flex-1 min-w-0">
                                                                      <div className="bg-indigo-100 p-2 rounded-lg">
                                                                        <Cog className="h-5 w-5 text-indigo-600" />
                                                                      </div>
                                                                      <div className="flex-1 min-w-0">
                                                                        <h4 className="font-medium text-gray-900 dark:text-white truncate">{machine.model || 'Unknown Model'}</h4>
                                                                        <p className="text-sm text-gray-500 dark:text-gray-300 truncate">S/N: {machine.serialNumber || 'N/A'}</p>
                                                                        <p className="text-xs text-gray-400">
                                                                          Installed: {machine.dateInstalled ? new Date(machine.dateInstalled).toLocaleDateString() : 'N/A'}
                                                                        </p>
                                                                        <p className="text-xs font-semibold text-green-600 mt-1">
                                                                          Earnings: &#8369;{(machine.meterReadings?.reduce((sum, reading) => sum + (reading.amount || 0), 0) || 0).toFixed(2)}
                                                                        </p>
                                                                      </div>
                                                                    </div>
                                                                    
                                                                    <div className="flex gap-1">
                                                                      <Button
                                                                        size="sm"
                                                                        variant="outline"
                                                                        onClick={(e) => {
                                                                          e.stopPropagation();
                                                                          editMachine(machine, department);
                                                                        }}
                                                                        className="text-blue-600 hover:text-blue-800 text-xs px-2 py-1 h-7"
                                                                        title="Edit Machine"
                                                                      >
                                                                        <Edit className="h-3 w-3" />
                                                                      </Button>
                                                                      <Button
                                                                        size="sm"
                                                                        variant="outline"
                                                                        onClick={(e) => {
                                                                          e.stopPropagation();
                                                                          deleteMachine(machine, department);
                                                                        }}
                                                                        className="text-red-600 hover:text-red-800 text-xs px-2 py-1 h-7"
                                                                        title="Delete Machine"
                                                                      >
                                                                        <Trash2 className="h-3 w-3" />
                                                                      </Button>
                                                                      <Button
                                                                        size="sm"
                                                                        className={`text-white text-xs px-2 py-1 h-7 ${mhrButtonColor}`}
                                                                        onClick={(e) => {
                                                                          e.stopPropagation();
                                                                          setSelectedMachineForMHR(machine);
                                                                          setMachineRepair({
                                                                            diagnosedDamage: '',
                                                                            diagnosedDate: '',
                                                                            damagedParts: [''],
                                                                            damagedPartsDate: '',
                                                                            partsRequested: [''],
                                                                            partsRequestedDate: '',
                                                                            partsReceivedDate: '',
                                                                            repairCompletedDate: ''
                                                                          });
                                                                          setIsMHRModalOpen(true);
                                                                        }}
                                                                        title="Machine History Repair"
                                                                      >
                                                                        MHR
                                                                      </Button>
                                                                      <Button
                                                                        size="sm"
                                                                        className="bg-blue-500 hover:bg-blue-600 text-white text-xs px-2 py-1 h-7"
                                                                        onClick={(e) => {
                                                                          e.stopPropagation();
                                                                          setSelectedMachineForRR(machine);
                                                                          setIsRRModalOpen(true);
                                                                        }}
                                                                        title="Reading Records"
                                                                      >
                                                                        RR
                                                                      </Button>
                                                                    </div>
                                                                  </div>
                                                                  
                                                                  <div 
                                                                    className="cursor-pointer"
                                                                    onClick={async () => {
                                                                      const currentMachineId = machine.id;
                                                                      
                                                                      console.log('\ud83d\udd04 Fetching FRESH data from server...');
                                                                      
                                                                      try {
                                                                        // Fetch fresh data DIRECTLY from server
                                                                        const response = await axiosInstance.get(`/projects/${selectedProject.id}/departments`);
                                                                        const freshDepartments = response.data || [];
                                                                        
                                                                        console.log('\u2705 Fresh data received:', freshDepartments.length, 'departments');
                                                                        
                                                                        // Find fresh machine from the response
                                                                        let freshMachine = null;
                                                                        for (const dept of freshDepartments) {
                                                                          const foundMachine = dept.machines?.find(m => m.id === currentMachineId);
                                                                          if (foundMachine) {
                                                                            freshMachine = foundMachine;
                                                                            break;
                                                                          }
                                                                        }
                                                                        
                                                                        if (!freshMachine) {
                                                                          console.error('\u274c Machine not found in fresh data!');
                                                                          freshMachine = machine;
                                                                        }
                                                                        
                                                                        console.log('\ud83d\udd0d Opening meter reading modal for:', freshMachine.model);
                                                                        console.log('\ud83d\udcca Total readings in FRESH data:', freshMachine.meterReadings?.length || 0);
                                                                        
                                                                        // Initialize with latest readings
                                                                        const meterTypes = ['Mono Small', 'Mono Large', 'Colored Small', 'Colored Large'];
                                                                        const initialReading = {};
                                                                        
                                                                        meterTypes.forEach(type => {
                                                                          const typeReadings = freshMachine.meterReadings?.filter(r => r.type === type) || [];
                                                                          console.log(`\n\ud83d\udccb ${type}: Found ${typeReadings.length} readings`);
                                                                          
                                                                          if (typeReadings.length > 0) {
                                                                            // Sort by date - newest first
                                                                            const sorted = [...typeReadings].sort((a, b) => 
                                                                              new Date(b.presentDate).getTime() - new Date(a.presentDate).getTime()
                                                                            );
                                                                            
                                                                            const latest = sorted[0];
                                                                            console.log(`\u2705 LATEST: presentReading=${latest.presentReading}, date=${latest.presentDate}`);
                                                                            console.log(`\u2705 Setting previousReading = ${latest.presentReading}`);
                                                                            
                                                                            initialReading[type] = {
                                                                              previousReading: latest.presentReading,
                                                                              previousDate: latest.presentDate,
                                                                              presentReading: '',
                                                                              presentDate: '',
                                                                              multiplier: latest.multiplier || 1,
                                                                              spoilageTolerance: latest.spoilageTolerance || 0,
                                                                              rate: latest.rate || 0
                                                                            };
                                                                          } else if (freshMachine.initialReadings && freshMachine.initialReadings[type] && freshMachine.initialReadings[type].value) {
                                                                            // No meter readings yet, but initial readings exist - use them
                                                                            console.log(`\u2705 Using INITIAL READING: value=${freshMachine.initialReadings[type].value}, date=${freshMachine.initialReadings[type].date}`);
                                                                            initialReading[type] = {
                                                                              previousReading: parseFloat(freshMachine.initialReadings[type].value),
                                                                              previousDate: freshMachine.initialReadings[type].date,
                                                                              presentReading: '',
                                                                              presentDate: '',
                                                                              multiplier: 1,
                                                                              spoilageTolerance: 0,
                                                                              rate: 0
                                                                            };
                                                                          } else {
                                                                            // No readings at all - start from 0
                                                                            initialReading[type] = {
                                                                              previousReading: 0,
                                                                              previousDate: '',
                                                                              presentReading: '',
                                                                              presentDate: '',
                                                                              multiplier: 1,
                                                                              spoilageTolerance: 0,
                                                                              rate: 0
                                                                            };
                                                                          }
                                                                        });
                                                                        
                                                                        console.log('\n\u2705\u2705\u2705 FINAL STATE:', initialReading);
                                                                        
                                                                        setSelectedMachine(freshMachine);
                                                                        setMeterReading(initialReading);
                                                                        setIsMeterReadingModalOpen(true);
                                                                        
                                                                      } catch (error) {
                                                                        console.error('\u274c Error fetching fresh data:', error);
                                                                        toast.error('Failed to load latest readings');
                                                                      }
                                                                    }}
                                                                  >
                                                                    <div className="text-center py-2 bg-gray-50 rounded border-2 border-dashed border-gray-300 hover:bg-gray-100 dark:hover:bg-black">
                                                                      <p className="text-sm text-gray-600 dark:text-gray-200">Click to add meter reading</p>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              );
                                                            })}
                                                          </div>
                                                        )}
                                                      </div>
                                                    ))}
                                                  </div>
                                                )}
                                              </CardContent>
                                            </Card>
                                          )}

                                          {projectDetailTab === 'billing' && (
                                            <Card className="glass shadow-lg border-0">
                                              <CardHeader>
                                                <CardTitle>Billing</CardTitle>
                                                <CardDescription>Generate bills for meter readings</CardDescription>
                                              </CardHeader>
                                              <CardContent>
                                                {/* Billing Statement Code Display (no date filters here anymore) */}
                                                <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                                                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-100 mb-2">Billing Statement Code</label>
                                                  <div className="text-lg font-bold text-indigo-600">
                                                    {selectedProject?.billingStatementCode || 'Not Set - Please set in Project Settings'}
                                                  </div>
                                                </div>

                                                {/* Department Tiles with Machines */}
                                                {departments.length === 0 ? (
                                                  <div className="text-center py-12">
                                                    <FileText className="h-16 w-16 text-gray-400 mx-auto mb-4" />
                                                    <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">No Departments Available</h3>
                                                    <p className="text-gray-500 dark:text-gray-300">Go to Meter Reading tab to add departments and machines first.</p>
                                                  </div>
                                                ) : (
                                                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
                                                    {departments.map((dept) => (
                                                      <div key={dept.id} className="border-2 border-gray-200 rounded-lg p-6 bg-gray-50">
                                                        <div className="flex justify-between items-center mb-4">
                                                          <h3 className="text-xl font-semibold text-gray-900 dark:text-white">{dept.name}</h3>
                                                        </div>
                                                        
                                                        {(!dept.machines || dept.machines.length === 0) ? (
                                                          <div className="text-center py-8 border-2 border-dashed border-gray-300 rounded-lg bg-white">
                                                            <Cog className="h-10 w-10 text-gray-400 mx-auto mb-2" />
                                                            <p className="text-gray-500 dark:text-gray-300 text-sm">No machines in this department</p>
                                                          </div>
                                                        ) : (
                                                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                                            {dept.machines.map((machine) => {
                                                              // Get the most recent reading for display
                                                              const allReadings = machine.meterReadings || [];
                                                              const sortedReadings = [...allReadings].sort((a, b) => 
                                                                new Date(b.presentDate).getTime() - new Date(a.presentDate).getTime()
                                                              );
                                                              const latestReading = sortedReadings[0];
                                                              
                                                              const colorClasses = getBillingMachineColorClass(machine);

                                                              const installedDate = machine.dateInstalled ? new Date(machine.dateInstalled).toLocaleDateString() : 'N/A';
                                                              const latestDate = latestReading && latestReading.presentDate ? new Date(latestReading.presentDate).toLocaleDateString() : null;
                                                              
                                                              return (
                                                                <div
                                                                  key={machine.id}
                                                                  onClick={async () => {
                                                                    // Mark machine as acknowledged
                                                                    setAcknowledgedBillingMachines(prev => new Set(prev).add(machine.id));
                                                                    
                                                                    // Fetch all meter readings for this machine grouped by date
                                                                    try {
                                                                      const response = await axiosInstance.get(`/machines/${machine.id}/meter-readings`);
                                                                      const readings = response.data || [];
                                                                      
                                                                      // Group readings by date
                                                                      const groupedByDate = readings.reduce((acc, reading) => {
                                                                        const date = reading.presentDate;
                                                                        if (!acc[date]) {
                                                                          acc[date] = [];
                                                                        }
                                                                        acc[date].push(reading);
                                                                        return acc;
                                                                      }, {});
                                                                      
                                                                      // Convert to array format for table
                                                                      const recordsData = Object.keys(groupedByDate).map(date => {
                                                                        const readingsForDate = groupedByDate[date];
                                                                        const totalAmount = readingsForDate.reduce((sum, r) => sum + (r.amount || 0), 0);
                                                                        const readingTypes = readingsForDate.map(r => r.type).filter(Boolean);
                                                                        
                                                                        return {
                                                                          date: date,
                                                                          readingsCount: readingsForDate.length,
                                                                          readingTypes: readingTypes,
                                                                          totalAmount: totalAmount,
                                                                          readings: readingsForDate
                                                                        };
                                                                      }).sort((a, b) => new Date(b.date) - new Date(a.date)); // Sort by date descending
                                                                      
                                                                      setBillingRecordsData(recordsData);
                                                                      setSelectedMachineForBillingRecords({
                                                                        ...machine,
                                                                        departmentName: dept.name
                                                                      });
                                                                      setIsBillingRecordsModalOpen(true);
                                                                    } catch (error) {
                                                                      console.error('Error fetching readings:', error);
                                                                      toast.error('Failed to fetch meter readings');
                                                                    }
                                                                  }}
                                                                  className={`${colorClasses.bg} border-2 ${colorClasses.border} rounded-lg p-4 hover:shadow-md transition-all cursor-pointer`}
                                                                >
                                                                  <div className="flex items-center gap-3 mb-2">
                                                                    <div className={`${colorClasses.icon} p-2 rounded-lg`}>
                                                                      <Printer className={`h-4 w-4 ${colorClasses.iconText}`} />
                                                                    </div>
                                                                    <div className="flex-1 min-w-0">
                                                                      <h4 className={`font-medium truncate ${colorClasses.text}`}>{machine.model}</h4>
                                                                      <p className="text-xs text-gray-600 dark:text-gray-200 truncate">S/N: {machine.serialNumber}</p>
                                                                    </div>
                                                                  </div>
                                                                  <div className="text-xs text-gray-600 dark:text-gray-200 space-y-1">
                                                                    <p>Installed: {installedDate}</p>
                                                                    {latestDate && (
                                                                      <p className="font-medium">Latest: {latestDate}</p>
                                                                    )}
                                                                  </div>
                                                                  <div className={`mt-2 pt-2 border-t ${colorClasses.border}`}>
                                                                    <span className={`text-xs font-semibold ${colorClasses.text}`}>Click to view records</span>
                                                                  </div>
                                                                </div>
                                                              );
                                                            })}
                                                          </div>
                                                        )}
                                                      </div>
                                                    ))}
                                                  </div>
                                                )}
                                                
                                                {/* Billing History List with Filters and Pagination */}
                                                <div className="mt-8">
                                                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Billing History</h3>
                                                  
                                                  {/* Filters */}
                                                  <div className="mb-4 p-4 bg-gray-50 rounded-lg">
                                                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                                                      <div>
                                                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-100 mb-2">Start Date</label>
                                                        <Input
                                                          type="date"
                                                          value={billingHistoryFilter.startDate}
                                                          onChange={(e) => {
                                                            setBillingHistoryFilter({ ...billingHistoryFilter, startDate: e.target.value });
                                                            setBillingHistoryPage(1);
                                                          }}
                                                          className="w-full"
                                                        />
                                                      </div>
                                                      <div>
                                                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-100 mb-2">End Date</label>
                                                        <Input
                                                          type="date"
                                                          value={billingHistoryFilter.endDate}
                                                          onChange={(e) => {
                                                            setBillingHistoryFilter({ ...billingHistoryFilter, endDate: e.target.value });
                                                            setBillingHistoryPage(1);
                                                          }}
                                                          className="w-full"
                                                        />
                                                      </div>
                                                      <div className="md:col-span-2">
                                                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-100 mb-2">Search</label>
                                                        <Input
                                                          type="text"
                                                          placeholder="BS #, Department, Machine, Serial #..."
                                                          value={billingHistoryFilter.searchQuery}
                                                          onChange={(e) => setBillingHistoryFilter({...billingHistoryFilter, searchQuery: e.target.value})}
                                                          className="w-full"
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                  
                                                  {billingExports.length > 0 ? (() => {
                                                    // Filter exports by all criteria
                                                    const filteredExports = billingExports.filter(exportRecord => {
                                                      // Date filter
                                                      if (billingHistoryFilter.startDate || billingHistoryFilter.endDate) {
                                                        const exportDate = new Date(exportRecord.exportDate);
                                                        const startDate = billingHistoryFilter.startDate ? new Date(billingHistoryFilter.startDate) : null;
                                                        const endDate = billingHistoryFilter.endDate ? new Date(billingHistoryFilter.endDate) : null;
                                                        
                                                        if (startDate && exportDate < startDate) return false;
                                                        if (endDate && exportDate > endDate) return false;
                                                      }
                                                      
                                                      // Search filter - searches across BS number, department, machine, and serial number
                                                      if (billingHistoryFilter.searchQuery) {
                                                        const query = billingHistoryFilter.searchQuery.toLowerCase();
                                                        const searchableText = [
                                                          exportRecord.bsNumber,
                                                          exportRecord.departmentName,
                                                          exportRecord.machineModel,
                                                          exportRecord.machineSerial
                                                        ].filter(Boolean).join(' ').toLowerCase();
                                                        
                                                        if (!searchableText.includes(query)) {
                                                          return false;
                                                        }
                                                      }
                                                      
                                                      // Department filter
                                                      if (billingHistoryFilter.departmentName && exportRecord.departmentName) {
                                                        if (!exportRecord.departmentName.toLowerCase().includes(billingHistoryFilter.departmentName.toLowerCase())) {
                                                          return false;
                                                        }
                                                      }
                                                      
                                                      // Machine filter
                                                      if (billingHistoryFilter.machineModel && exportRecord.machineModel) {
                                                        if (!exportRecord.machineModel.toLowerCase().includes(billingHistoryFilter.machineModel.toLowerCase())) {
                                                          return false;
                                                        }
                                                      }
                                                      
                                                      return true;
                                                    });
                                                    
                                                    // Calculate pagination
                                                    const totalPages = Math.ceil(filteredExports.length / ITEMS_PER_PAGE);
                                                    const startIndex = (billingHistoryPage - 1) * ITEMS_PER_PAGE;
                                                    const endIndex = startIndex + ITEMS_PER_PAGE;
                                                    const paginatedExports = filteredExports.slice(startIndex, endIndex);
                                                    
                                                    return (
                                                      <>
                                                        <div className="mb-3 text-sm text-gray-600 dark:text-gray-200">
                                                          Showing {startIndex + 1}-{Math.min(endIndex, filteredExports.length)} of {filteredExports.length} records
                                                        </div>
                                                        <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
                                                          <table className="w-full">
                                                            <thead className="bg-gray-50">
                                                              <tr>
                                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-100">BS Number</th>
                                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-100">Department</th>
                                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-100">Machine</th>
                                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-100">Serial Number</th>
                                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-100">Attention</th>
                                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-100">Export Date</th>
                                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-100">Approved Billing Statement</th>
                                                                {user.is_super_admin && (
                                                                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-100">Actions</th>
                                                                )}
                                                              </tr>
                                                            </thead>
                                                            <tbody className="divide-y divide-gray-200">
                                                              {paginatedExports.map((exportRecord) => (
                                                                <tr 
                                                                  key={exportRecord.id} 
                                                                  className="hover:bg-blue-50 dark:hover:bg-black transition-colors"
                                                                >
                                                                  <td 
                                                                    className="px-4 py-3 text-sm font-medium text-blue-600 hover:text-blue-800 cursor-pointer"
                                                                    onClick={async (e) => {
                                                                      e.stopPropagation();
                                                                      // Fetch all meter readings for this machine on the export date
                                                                      try {
                                                                        const exportDate = new Date(exportRecord.exportDate);
                                                                        const dateString = exportDate.toISOString().split('T')[0];
                                                                        const machineId = exportRecord.machine_id;
                                                                        
                                                                        const response = await axiosInstance.get(
                                                                          `/machines/${machineId}/meter-readings-by-date`,
                                                                          { params: { date: dateString } }
                                                                        );
                                                                        
                                                                        // Set the billing statement data with export record and readings
                                                                        setBillingStatementData({
                                                                          exportRecord: exportRecord,
                                                                          readings: response.data || []
                                                                        });
                                                                        setIsBillingStatementPreviewOpen(true);
                                                                      } catch (error) {
                                                                        console.error('Error fetching meter readings:', error);
                                                                        toast.error('Failed to load billing statement');
                                                                      }
                                                                    }}
                                                                  >
                                                                    {exportRecord.bsNumber}
                                                                  </td>
                                                                  <td className="px-4 py-3 text-sm text-gray-900 dark:text-white">{exportRecord.departmentName || 'N/A'}</td>
                                                                  <td className="px-4 py-3 text-sm text-gray-900 dark:text-white">{exportRecord.machineModel || 'N/A'}</td>
                                                                  <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-200">{exportRecord.machineSerial || 'N/A'}</td>
                                                                  <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-200">{exportRecord.attention || '-'}</td>
                                                                  <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-200">
                                                                    {exportRecord.exportDate ? new Date(exportRecord.exportDate).toLocaleDateString() : 'N/A'}
                                                                  </td>
                                                                  <td className="px-4 py-3 text-sm" onClick={(e) => e.stopPropagation()}>
                                                                    {exportRecord.approvedBillingStatementUrl ? (
                                                                      <a 
                                                                        href={exportRecord.approvedBillingStatementUrl}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        className="inline-block hover:opacity-80 transition-opacity"
                                                                        title="Click to view file"
                                                                      >
                                                                        <div className="relative w-16 h-20 bg-red-50 border-2 border-red-300 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow">
                                                                          <div className="absolute inset-0 flex flex-col items-center justify-center p-2">
                                                                            <FileText className="w-8 h-8 text-red-600 mb-1" />
                                                                            <span className="text-xs font-semibold text-red-600">PDF</span>
                                                                          </div>
                                                                        </div>
                                                                      </a>
                                                                    ) : (
                                                                      <label className="cursor-pointer">
                                                                        <input
                                                                          type="file"
                                                                          accept=".pdf"
                                                                          className="hidden"
                                                                          onChange={async (e) => {
                                                                            const file = e.target.files[0];
                                                                            if (file) {
                                                                              try {
                                                                                const formData = new FormData();
                                                                                formData.append('file', file);
                                                                                
                                                                                const response = await axiosInstance.post(
                                                                                  `/billing-exports/${exportRecord.id}/upload-approved-statement`,
                                                                                  formData,
                                                                                  {
                                                                                    headers: {
                                                                                      'Content-Type': 'multipart/form-data'
                                                                                    }
                                                                                  }
                                                                                );
                                                                                
                                                                                toast.success('File uploaded successfully!');
                                                                                // Refresh billing history
                                                                                fetchBillingExports();
                                                                              } catch (error) {
                                                                                console.error('Upload error:', error);
                                                                                toast.error('Failed to upload file');
                                                                              }
                                                                            }
                                                                          }}
                                                                        />
                                                                        <span className="inline-flex items-center px-3 py-1 bg-blue-500 text-white text-xs rounded hover:bg-blue-600">
                                                                          <Upload className="w-3 h-3 mr-1" />
                                                                          Upload
                                                                        </span>
                                                                      </label>
                                                                    )}
                                                                  </td>
                                                                  {user.is_super_admin && (
                                                                    <td className="px-4 py-3 text-sm" onClick={(e) => e.stopPropagation()}>
                                                                      <Button
                                                                        variant="destructive"
                                                                        size="sm"
                                                                        onClick={async () => {
                                                                          const confirmed = await confirmDialog({
                                                                              title: "Delete Billing Export",
                                                                              description: "Are you sure you want to delete this billing export? This action cannot be undone.",
                                                                              variant: "destructive"
                                                                          });
                                                                          if (confirmed) {
                                                                            try {
                                                                              await axiosInstance.delete(`/billing-exports/${exportRecord.id}`);
                                                                              toast.success('Billing export deleted successfully');
                                                                              fetchBillingExports();
                                                                            } catch (error) {
                                                                              console.error('Delete error:', error);
                                                                              toast.error(error.response?.data?.detail || 'Failed to delete billing export');
                                                                            }
                                                                          }
                                                                        }}
                                                                      >
                                                                        <Trash2 className="h-4 w-4" />
                                                                      </Button>
                                                                    </td>
                                                                  )}
                                                                </tr>
                                                              ))}
                                                            </tbody>
                                                          </table>
                                                        </div>
                                                        
                                                        {/* Pagination Controls */}
                                                        {totalPages > 1 && (
                                                          <div className="mt-4 flex items-center justify-between">
                                                            <div className="text-sm text-gray-600 dark:text-gray-200">
                                                              Page {billingHistoryPage} of {totalPages}
                                                            </div>
                                                            <div className="flex gap-2">
                                                              <Button
                                                                variant="outline"
                                                                size="sm"
                                                                onClick={() => setBillingHistoryPage(prev => Math.max(1, prev - 1))}
                                                                disabled={billingHistoryPage === 1}
                                                              >
                                                                Previous
                                                              </Button>
                                                              {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                                                                const pageNum = i + 1 + Math.max(0, billingHistoryPage - 3);
                                                                if (pageNum > totalPages) return null;
                                                                return (
                                                                  <Button
                                                                    key={pageNum}
                                                                    variant={billingHistoryPage === pageNum ? 'default' : 'outline'}
                                                                    size="sm"
                                                                    onClick={() => setBillingHistoryPage(pageNum)}
                                                                    className={billingHistoryPage === pageNum ? 'bg-blue-600' : ''}
                                                                  >
                                                                    {pageNum}
                                                                  </Button>
                                                                );
                                                              })}
                                                              <Button
                                                                variant="outline"
                                                                size="sm"
                                                                onClick={() => setBillingHistoryPage(prev => Math.min(totalPages, prev + 1))}
                                                                disabled={billingHistoryPage === totalPages}
                                                              >
                                                                Next
                                                              </Button>
                                                            </div>
                                                          </div>
                                                        )}
                                                      </>
                                                    );
                                                  })() : (
                                                    <div className="text-center py-8 bg-gray-50 rounded-lg border border-gray-200">
                                                      <p className="text-gray-500 dark:text-gray-300 font-medium">No billing history yet</p>
                                                      <p className="text-sm text-gray-400 mt-1">Generate and export bills to see them here</p>
                                                    </div>
                                                  )}
                                                </div>
                                              </CardContent>
                                            </Card>
                                          )}

                                          {projectDetailTab === 'si' && (
                                            <Card className="glass shadow-lg border-0">
                                              <CardHeader>
                                                <CardTitle>SI (Sales Invoice)</CardTitle>
                                                <CardDescription>Generate sales invoices for machines</CardDescription>
                                              </CardHeader>
                                              <CardContent>
                                                {/* Billing Statement Code Display with Generate All Button */}
                                                <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                                                  <div className="flex justify-between items-center">
                                                    <div>
                                                      <label className="block text-sm font-medium text-gray-700 dark:text-gray-100 mb-2">Sales Invoice</label>
                                                      <div className="text-lg font-bold text-indigo-600">
                                                        {selectedProject?.billingStatementCode || 'Not Set - Please set in Project Settings'}
                                                      </div>
                                                    </div>
                                                    <Button
                                                      onClick={async () => {
                                                        try {
                                                          if (!selectedProject) {
                                                            toast.error('Please select a project first');
                                                            return;
                                                          }
                                                          
                                                          toast.info('Loading machines with approved billing statements...');
                                                          
                                                          // Get all machines with approved billing statements
                                                          const machinesWithApprovedBS = [];
                                                          
                                                          for (const dept of departments) {
                                                            if (dept.machines) {
                                                              for (const machine of dept.machines) {
                                                                const machineExports = billingExports?.filter(exp => exp.machine_id === machine.id) || [];
                                                                const latestExport = machineExports
                                                                  .filter(exp => exp.approvedBillingStatementUrl)
                                                                  .sort((a, b) => new Date(b.exportDate) - new Date(a.exportDate))[0];
                                                                
                                                                if (latestExport) {
                                                                  // Fetch readings for this specific machine using both BS Number and machine_id
                                                                  const response = await axiosInstance.get(`/billing-exports/${latestExport.bsNumber}/meter-readings`, {
                                                                    params: { machine_id: machine.id }
                                                                  });
                                                                  if (response?.data && response.data.length > 0) {
                                                                    machinesWithApprovedBS.push({
                                                                      machine,
                                                                      department: dept,
                                                                      export: latestExport,
                                                                      readings: response.data
                                                                    });
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                          
                                                          if (machinesWithApprovedBS.length === 0) {
                                                            toast.error('No machines with approved billing statements and meter readings found');
                                                            return;
                                                          }
                                                          
                                                          // Set the pending machines and open modal
                                                          setPendingSIMachines(machinesWithApprovedBS);
                                                          setIsConsolidatedSIModalOpen(true);
                                                          
                                                        } catch (error) {
                                                          console.error('Error loading machines:', error);
                                                          toast.error('Failed to load machines for Sales Invoice generation');
                                                        }
                                                      }}
                                                      className="bg-purple-600 hover:bg-purple-700"
                                                    >
                                                      <FileText className="h-4 w-4 mr-2" />
                                                      Generate All
                                                    </Button>
                                                  </div>
                                                </div>

                                                {/* Department Tiles with Machines */}
                                                {departments.length === 0 ? (
                                                  <div className="text-center py-12">
                                                    <FileText className="h-16 w-16 text-gray-400 mx-auto mb-4" />
                                                    <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">No Departments Available</h3>
                                                    <p className="text-gray-500 dark:text-gray-300">Go to Meter Reading tab to add departments and machines first.</p>
                                                  </div>
                                                ) : (
                                                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
                                                    {departments.map((dept) => (
                                                      <div key={dept.id} className="border-2 border-gray-200 rounded-lg p-6 bg-gray-50">
                                                        <div className="flex justify-between items-center mb-4">
                                                          <h3 className="text-xl font-semibold text-gray-900 dark:text-white">{dept.name}</h3>
                                                        </div>
                                                        
                                                        {(!dept.machines || dept.machines.length === 0) ? (
                                                          <div className="text-center py-8 border-2 border-dashed border-gray-300 rounded-lg bg-white">
                                                            <Cog className="h-10 w-10 text-gray-400 mx-auto mb-2" />
                                                            <p className="text-gray-500 dark:text-gray-300 text-sm">No machines in this department</p>
                                                          </div>
                                                        ) : (
                                                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                                            {(() => {
                                                              // Debug logging for SI tab
                                                              console.log('=== SI TAB RENDERING DEBUG ===');
                                                              console.log('Department:', dept.name);
                                                              console.log('Total billingExports available:', billingExports?.length || 0);
                                                              console.log('Billing exports sample:', billingExports?.slice(0, 3));
                                                              console.log('Machines in department:', dept.machines?.length || 0);
                                                              return null;
                                                            })()}
                                                            {dept.machines.map((machine) => {
                                                              const allReadings = machine.meterReadings || [];
                                                              const sortedReadings = [...allReadings].sort((a, b) => 
                                                                new Date(b?.presentDate || 0).getTime() - new Date(a?.presentDate || 0).getTime()
                                                              );
                                                              const latestReading = sortedReadings[0];
                                                              const colorClasses = getMachineColorClass(machine.id);
                                                              
                                                              return (
                                                                <div
                                                                  key={machine.id}
                                                                  onClick={async () => {
                                                                    try {
                                                                      // Mark machine as acknowledged when clicked
                                                                      setAcknowledgedSIMachines(prev => new Set(prev).add(machine.id));
                                                                      
                                                                      // Filter billing exports for this machine that have approved billing statements
                                                                      const machineExports = (billingExports || []).filter(exp => {
                                                                        const exportMachineId = exp?.machineId || exp?.machine_id;
                                                                        return String(exportMachineId) === String(machine.id) && exp.approvedBillingStatementUrl;
                                                                      });
                                                                      
                                                                      if (machineExports.length === 0) {
                                                                        toast.error('No approved billing statements found for this machine');
                                                                        return;
                                                                      }
                                                                      
                                                                      // Sort by date descending
                                                                      const sortedExports = machineExports.sort((a, b) => {
                                                                        const dateA = new Date(a?.exportDate || 0);
                                                                        const dateB = new Date(b?.exportDate || 0);
                                                                        return dateB - dateA;
                                                                      });
                                                                      
                                                                      setBillingHistoryData(sortedExports);
                                                                      setSelectedMachineForBillingHistory({
                                                                        ...machine,
                                                                        departmentName: dept.name
                                                                      });
                                                                      setIsBillingHistoryModalOpen(true);
                                                                    } catch (error) {
                                                                      console.error('Error in SI tile click handler:', error);
                                                                      toast.error('Failed to open Billing History modal: ' + (error?.message || 'Unknown error'));
                                                                    }
                                                                  }}
                                                                  className={`${colorClasses.bg} border-2 ${colorClasses.border} rounded-lg p-4 hover:shadow-md transition-all cursor-pointer`}
                                                                >
                                                                  <div className="flex items-center gap-3 mb-2">
                                                                    <div className={`${colorClasses.icon} p-2 rounded-lg`}>
                                                                      <FileText className={`h-4 w-4 ${colorClasses.iconText}`} />
                                                                    </div>
                                                                    <div className="flex-1 min-w-0">
                                                                      <h4 className={`font-medium truncate ${colorClasses.text}`}>{machine.model}</h4>
                                                                      <p className="text-xs text-gray-600 dark:text-gray-200 truncate">S/N: {machine.serialNumber}</p>
                                                                    </div>
                                                                  </div>
                                                                  <div className="text-xs text-gray-600 dark:text-gray-200 space-y-1">
                                                                    <p>Installed: {machine.dateInstalled ? new Date(machine.dateInstalled).toLocaleDateString() : 'N/A'}</p>
                                                                    {latestReading && latestReading.presentDate && (
                                                                      <p className="font-medium">Latest: {new Date(latestReading.presentDate).toLocaleDateString()}</p>
                                                                    )}
                                                                  </div>
                                                                  <div className={`mt-2 pt-2 border-t ${colorClasses.border}`}>
                                                                    <span className={`text-xs font-semibold ${colorClasses.text}`}>Click to view billing history</span>
                                                                  </div>
                                                                </div>
                                                              );
                                                            })}
                                                          </div>
                                                        )}
                                                      </div>
                                                    ))}
                                                  </div>
                                                )}

                                                {/* Sales Invoice History */}
                                                <div className="mt-8">
                                                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Sales Invoice History</h3>
                                                  
                                                  {/* Filters */}
                                                  <div className="mb-4 grid grid-cols-1 md:grid-cols-3 gap-4">
                                                    <div>
                                                      <label className="text-xs font-medium text-gray-600 dark:text-gray-200 block mb-1">Start Date</label>
                                                      <Input
                                                        type="date"
                                                        value={siHistoryFilter.startDate}
                                                        onChange={(e) => setSiHistoryFilter({...siHistoryFilter, startDate: e.target.value})}
                                                        className="text-sm"
                                                      />
                                                    </div>
                                                    <div>
                                                      <label className="text-xs font-medium text-gray-600 dark:text-gray-200 block mb-1">End Date</label>
                                                      <Input
                                                        type="date"
                                                        value={siHistoryFilter.endDate}
                                                        onChange={(e) => setSiHistoryFilter({...siHistoryFilter, endDate: e.target.value})}
                                                        className="text-sm"
                                                      />
                                                    </div>
                                                    <div>
                                                      <label className="text-xs font-medium text-gray-600 dark:text-gray-200 block mb-1">Search</label>
                                                      <Input
                                                        type="text"
                                                        placeholder="SI #, Department, Machine, Serial #..."
                                                        value={siHistoryFilter.searchQuery}
                                                        onChange={(e) => setSiHistoryFilter({...siHistoryFilter, searchQuery: e.target.value})}
                                                        className="text-sm"
                                                      />
                                                    </div>
                                                  </div>

                                                  {/* History Table */}
                                                  {siExports.length === 0 ? (
                                                    <div className="text-center py-12 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
                                                      <FileText className="h-12 w-12 text-gray-400 mx-auto mb-3" />
                                                      <p className="text-gray-500 dark:text-gray-300 font-medium">No sales invoice history yet</p>
                                                      <p className="text-sm text-gray-400 mt-1">Generated invoices will appear here</p>
                                                    </div>
                                                  ) : (
                                                    <>
                                                      {(() => {
                                                        // Apply filters
                                                        const filteredExports = siExports.filter(record => {
                                                          // Date filtering
                                                          if (siHistoryFilter.startDate && siHistoryFilter.endDate) {
                                                            const invoiceDate = new Date(record.invoiceDate);
                                                            const startDate = new Date(siHistoryFilter.startDate);
                                                            const endDate = new Date(siHistoryFilter.endDate);
                                                            endDate.setHours(23, 59, 59, 999);
                                                            
                                                            if (invoiceDate < startDate || invoiceDate > endDate) {
                                                              return false;
                                                            }
                                                          }
                                                          
                                                          // Search filtering
                                                          if (siHistoryFilter.searchQuery) {
                                                            const query = siHistoryFilter.searchQuery.toLowerCase();
                                                            const searchableText = [
                                                              record.siNumber,
                                                              record.departmentName,
                                                              record.machineModel,
                                                              record.machineSerial
                                                            ].join(' ').toLowerCase();
                                                            
                                                            if (!searchableText.includes(query)) {
                                                              return false;
                                                            }
                                                          }
                                                          
                                                          return true;
                                                        });
                                                        
                                                        // Pagination
                                                        const totalPages = Math.ceil(filteredExports.length / ITEMS_PER_PAGE);
                                                        const startIndex = (siHistoryPage - 1) * ITEMS_PER_PAGE;
                                                        const endIndex = startIndex + ITEMS_PER_PAGE;
                                                        const paginatedExports = filteredExports.slice(startIndex, endIndex);
                                                        
                                                        return (
                                                          <>
                                                            <div className="mb-3 text-sm text-gray-600 dark:text-gray-200">
                                                              Showing {startIndex + 1}-{Math.min(endIndex, filteredExports.length)} of {filteredExports.length} records
                                                            </div>
                                                            <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
                                                              <table className="w-full">
                                                                <thead className="bg-gray-50">
                                                                  <tr>
                                                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-100">SI Number</th>
                                                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-100">Department</th>
                                                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-100">Machine</th>
                                                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-100">Serial Number</th>
                                                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-100">Date</th>
                                                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-100">Amount</th>
                                                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-100">Preview</th>
                                                                    {user.is_super_admin && (
                                                                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-100">Actions</th>
                                                                    )}
                                                                  </tr>
                                                                </thead>
                                                                <tbody className="divide-y divide-gray-200">
                                                                  {paginatedExports.map((record) => (
                                                                    <tr key={record.id} className="hover:bg-purple-50 dark:hover:bg-black transition-colors">
                                                                      <td className="px-4 py-3 text-sm font-medium text-purple-600">{record.siNumber}</td>
                                                                      <td className="px-4 py-3 text-sm text-gray-900 dark:text-white">{record.departmentName || 'N/A'}</td>
                                                                      <td className="px-4 py-3 text-sm text-gray-900 dark:text-white">{record.machineModel || 'N/A'}</td>
                                                                      <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-200">{record.machineSerial || 'N/A'}</td>
                                                                      <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-200">
                                                                        {record.invoiceDate ? new Date(record.invoiceDate).toLocaleDateString() : 'N/A'}
                                                                      </td>
                                                                      <td className="px-4 py-3 text-sm font-semibold text-green-600">
                                                                        &#8369;{(record.totalAmount || 0).toFixed(2)}
                                                                      </td>
                                                                      <td className="px-4 py-3">
                                                                        {record.pdfUrl ? (
                                                                          <button
                                                                            onClick={() => {
                                                                              setSelectedSIFileData(record);
                                                                              setIsSIFilePreviewOpen(true);
                                                                            }}
                                                                            className="flex items-center gap-1 px-3 py-1 bg-purple-100 hover:bg-purple-200 text-purple-700 rounded-md transition-colors"
                                                                          >
                                                                            <FileText className="h-4 w-4" />
                                                                            <span className="text-xs font-medium">View</span>
                                                                          </button>
                                                                        ) : (
                                                                          <span className="text-xs text-gray-400">No file</span>
                                                                        )}
                                                                      </td>
                                                                      {user.is_super_admin && (
                                                                        <td className="px-4 py-3">
                                                                          <Button
                                                                            variant="destructive"
                                                                            size="sm"
                                                                            onClick={async () => {
                                                                              const confirmed = await confirmDialog({
                                                                                  title: "Delete Sales Invoice",
                                                                                  description: "Are you sure you want to delete this sales invoice? This action cannot be undone.",
                                                                                  variant: "destructive"
                                                                              });
                                                                              if (confirmed) {
                                                                                try {
                                                                                  await axiosInstance.delete(`/sales-invoices/${record.id}`);
                                                                                  toast.success('Sales invoice deleted successfully');
                                                                                  fetchSIExports();
                                                                                } catch (error) {
                                                                                  console.error('Delete error:', error);
                                                                                  toast.error(error.response?.data?.detail || 'Failed to delete sales invoice');
                                                                                }
                                                                              }
                                                                            }}
                                                                          >
                                                                            <Trash2 className="h-4 w-4" />
                                                                          </Button>
                                                                        </td>
                                                                      )}
                                                                    </tr>
                                                                  ))}
                                                                </tbody>
                                                              </table>
                                                            </div>
                                                            
                                                            {/* Pagination Controls */}
                                                            {totalPages > 1 && (
                                                              <div className="flex justify-between items-center mt-4">
                                                                <Button
                                                                  variant="outline"
                                                                  size="sm"
                                                                  onClick={() => setSiHistoryPage(Math.max(1, siHistoryPage - 1))}
                                                                  disabled={siHistoryPage === 1}
                                                                >
                                                                  <ChevronLeft className="h-4 w-4 mr-1" />
                                                                  Previous
                                                                </Button>
                                                                <span className="text-sm text-gray-600 dark:text-gray-200">
                                                                  Page {siHistoryPage} of {totalPages}
                                                                </span>
                                                                <Button
                                                                  variant="outline"
                                                                  size="sm"
                                                                  onClick={() => setSiHistoryPage(Math.min(totalPages, siHistoryPage + 1))}
                                                                  disabled={siHistoryPage === totalPages}
                                                                >
                                                                  Next
                                                                  <ChevronRight className="h-4 w-4 ml-1" />
                                                                </Button>
                                                              </div>
                                                            )}
                                                          </>
                                                        );
                                                      })()}
                                                    </>
                                                  )}
                                                </div>
                                              </CardContent>
                                            </Card>
                                          )}

                                          {projectDetailTab === 'collection' && (
                                            <div className="space-y-6">
                                              {/* Collection Tab - Department and Machine Tiles */}
                                              <Card className="glass shadow-lg border-0">
                                                <CardHeader>
                                                  <CardTitle>Collection</CardTitle>
                                                  <CardDescription>Track collections by department and machine</CardDescription>
                                                </CardHeader>
                                                <CardContent>
                                                  {departments && departments.length > 0 ? (
                                                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                                                      {departments.map((dept) => (
                                                        <div key={dept.id} className="border rounded-lg p-4 bg-white">
                                                          <div className="flex items-center justify-between mb-3">
                                                            <h3 className="font-semibold text-lg flex items-center gap-2">
                                                              <Building2 className="h-5 w-5 text-blue-600" />
                                                              {dept.name}
                                                            </h3>
                                                            <span className="text-sm text-gray-500 dark:text-gray-300">
                                                              {dept.machines?.length || 0} machine(s)
                                                            </span>
                                                          </div>

                                                          {(!dept.machines || dept.machines.length === 0) ? (
                                                            <div className="text-center py-8 border-2 border-dashed border-gray-300 rounded-lg bg-white">
                                                              <Cog className="h-10 w-10 text-gray-400 mx-auto mb-2" />
                                                              <p className="text-gray-500 dark:text-gray-300 text-sm">No machines in this department</p>
                                                            </div>
                                                          ) : (
                                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                                              {dept.machines.map((machine) => {
                                                                const allReadings = machine.meterReadings || [];
                                                                const sortedReadings = [...allReadings].sort((a, b) => 
                                                                  new Date(b?.presentDate || 0).getTime() - new Date(a?.presentDate || 0).getTime()
                                                                );
                                                                const latestReading = sortedReadings[0];
                                                                const colorClasses = getCollectionMachineColorClass(machine.id);
                                                                
                                                                return (
                                                                  <div
                                                                    key={machine.id}
                                                                    onClick={async () => {
                                                                      // Mark machine as acknowledged when clicked
                                                                      setAcknowledgedCollectionMachines(prev => new Set(prev).add(machine.id));
                                                                      
                                                                      // Find the latest SI for this machine
                                                                      const machineSIs = siExports.filter(si => 
                                                                        (si.machine_id || si.machineId) === machine.id
                                                                      ).sort((a, b) => new Date(b.invoiceDate) - new Date(a.invoiceDate));
                                                                      
                                                                      if (machineSIs.length === 0) {
                                                                        toast.error('No Sales Invoice found for this machine');
                                                                        return;
                                                                      }
                                                                      
                                                                      const latestSI = machineSIs[0];
                                                                      setSelectedCollectionMachine({
                                                                        machine: machine,
                                                                        department: dept,
                                                                        salesInvoice: latestSI
                                                                      });
                                                                      setIsCollectionModalOpen(true);
                                                                    }}
                                                                    className={`${colorClasses.bg} border-2 ${colorClasses.border} rounded-lg p-4 hover:shadow-md transition-all cursor-pointer`}
                                                                  >
                                                                    <div className="flex items-center gap-3 mb-2">
                                                                      <div className={`${colorClasses.icon} p-2 rounded-lg`}>
                                                                        <FileText className={`h-4 w-4 ${colorClasses.iconText}`} />
                                                                      </div>
                                                                      <div className="flex-1 min-w-0">
                                                                        <h4 className={`font-medium truncate ${colorClasses.text}`}>{machine.model}</h4>
                                                                        <p className="text-xs text-gray-600 dark:text-gray-200 truncate">S/N: {machine.serialNumber}</p>
                                                                      </div>
                                                                    </div>
                                                                    <div className="text-xs text-gray-600 dark:text-gray-200 space-y-1">
                                                                      <p>Installed: {machine.dateInstalled ? new Date(machine.dateInstalled).toLocaleDateString() : 'N/A'}</p>
                                                                      {latestReading && latestReading.presentDate && (
                                                                        <p className="font-medium">Latest: {new Date(latestReading.presentDate).toLocaleDateString()}</p>
                                                                      )}
                                                                    </div>
                                                                    <div className={`mt-2 pt-2 border-t ${colorClasses.border}`}>
                                                                      <span className={`text-xs font-semibold ${colorClasses.text}`}>Click to manage collection</span>
                                                                    </div>
                                                                  </div>
                                                                );
                                                              })}
                                                            </div>
                                                          )}
                                                        </div>
                                                      ))}
                                                    </div>
                                                  ) : (
                                                    <div className="text-center py-12">
                                                      <Building2 className="h-16 w-16 text-gray-400 mx-auto mb-4" />
                                                      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">No Departments</h3>
                                                      <p className="text-gray-500 dark:text-gray-300">Go to Meter Reading tab to add departments and machines first.</p>
                                                    </div>
                                                  )}
                                                </CardContent>
                                              </Card>

                                              {/* Collection History */}
                                              <Card className="glass shadow-lg border-0">
                                                <CardHeader>
                                                  <CardTitle>Collection History</CardTitle>
                                                  <CardDescription>View all collection records</CardDescription>
                                                </CardHeader>
                                                <CardContent>
                                                  {/* Filters */}
                                                  <div className="flex flex-wrap gap-4 mb-6">
                                                    <div className="flex-1 min-w-[200px]">
                                                      <Input
                                                        placeholder="Search by BS number, machine..."
                                                        value={collectionHistoryFilter.searchQuery}
                                                        onChange={(e) => setCollectionHistoryFilter(prev => ({ ...prev, searchQuery: e.target.value }))}
                                                      />
                                                    </div>
                                                    <div className="flex gap-2">
                                                      <Input
                                                        type="date"
                                                        value={collectionHistoryFilter.startDate}
                                                        onChange={(e) => setCollectionHistoryFilter(prev => ({ ...prev, startDate: e.target.value }))}
                                                        className="w-40"
                                                      />
                                                      <span className="flex items-center text-gray-500 dark:text-gray-300">to</span>
                                                      <Input
                                                        type="date"
                                                        value={collectionHistoryFilter.endDate}
                                                        onChange={(e) => setCollectionHistoryFilter(prev => ({ ...prev, endDate: e.target.value }))}
                                                        className="w-40"
                                                      />
                                                    </div>
                                                  </div>

                                                  {/* Collection History Table */}
                                                  <div className="border rounded-lg overflow-hidden">
                                                    <div className="overflow-x-auto">
                                                      <table className="min-w-full divide-y divide-gray-200">
                                                        <thead className="bg-gray-50">
                                                          <tr>
                                                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Collection Date</th>
                                                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">BS Number</th>
                                                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Department</th>
                                                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Machine</th>
                                                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Amount</th>
                                                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Status</th>
                                                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">View</th>
                                                            {user.is_super_admin && (
                                                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Delete</th>
                                                            )}
                                                          </tr>
                                                        </thead>
                                                        <tbody className="bg-white divide-y divide-gray-200">
                                                          {collections && collections.length > 0 ? (
                                                            collections
                                                              .filter(record => {
                                                                // Search filter
                                                                if (collectionHistoryFilter.searchQuery) {
                                                                  const query = collectionHistoryFilter.searchQuery.toLowerCase();
                                                                  const searchableText = [
                                                                    record.siNumber,
                                                                    record.bsNumber,
                                                                    record.departmentName,
                                                                    record.machineModel,
                                                                    record.machineSerial
                                                                  ].filter(Boolean).join(' ').toLowerCase();
                                                                  if (!searchableText.includes(query)) return false;
                                                                }
                                                                
                                                                // Date filter
                                                                if (collectionHistoryFilter.startDate || collectionHistoryFilter.endDate) {
                                                                  const collectionDate = new Date(record.collectionDate);
                                                                  if (collectionHistoryFilter.startDate && collectionDate < new Date(collectionHistoryFilter.startDate)) return false;
                                                                  if (collectionHistoryFilter.endDate && collectionDate > new Date(collectionHistoryFilter.endDate)) return false;
                                                                }
                                                                
                                                                return true;
                                                              })
                                                              .slice((collectionHistoryPage - 1) * 10, collectionHistoryPage * 10)
                                                              .map((record) => (
                                                                <tr key={record.id} className="hover:bg-blue-50 dark:hover:bg-black transition-colors cursor-pointer" onClick={() => {
                                                                  setSelectedCollectionRecord(record);
                                                                  setIsCollectionHistoryPreviewOpen(true);
                                                                }}>
                                                                  <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-200">
                                                                    {record.collectionDate ? new Date(record.collectionDate).toLocaleDateString() : 'N/A'}
                                                                  </td>
                                                                  <td className="px-4 py-3 text-sm font-medium text-blue-600">{record.bsNumber}</td>
                                                                  <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-200">{record.departmentName || 'N/A'}</td>
                                                                  <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-200">{record.machineModel || 'N/A'}</td>
                                                                  <td className="px-4 py-3 text-sm font-semibold text-green-600">&#8369;{(record.totalAmount || 0).toFixed(2)}</td>
                                                                  <td className="px-4 py-3">
                                                                    <span className={`px-3 py-1 rounded-full text-xs font-bold ${
                                                                      record.status === 'paid' 
                                                                        ? 'bg-green-100 text-green-800' 
                                                                        : 'bg-yellow-100 text-yellow-800'
                                                                    }`}>
                                                                      {record.status.toUpperCase()}
                                                                    </span>
                                                                  </td>
                                                                  <td className="px-4 py-3" onClick={(e) => e.stopPropagation()}>
                                                                    <button className="text-blue-600 hover:text-blue-800 text-sm font-medium">
                                                                      View
                                                                    </button>
                                                                  </td>
                                                                  {user.is_super_admin && (
                                                                    <td className="px-4 py-3" onClick={(e) => e.stopPropagation()}>
                                                                      <Button
                                                                        variant="destructive"
                                                                        size="sm"
                                                                        onClick={async () => {
                                                                          const confirmed = await confirmDialog({
                                                                              title: "Delete Collection Record",
                                                                              description: "Are you sure you want to delete this collection record? This action cannot be undone.",
                                                                              variant: "destructive"
                                                                          });
                                                                          if (confirmed) {
                                                                            try {
                                                                              await axiosInstance.delete(`/collections/${record.id}`);
                                                                              toast.success('Collection record deleted successfully');
                                                                              fetchCollections();
                                                                            } catch (error) {
                                                                              console.error('Delete error:', error);
                                                                              toast.error(error.response?.data?.detail || 'Failed to delete collection record');
                                                                            }
                                                                          }
                                                                        }}
                                                                      >
                                                                        <Trash2 className="h-4 w-4" />
                                                                      </Button>
                                                                    </td>
                                                                  )}
                                                                </tr>
                                                              ))
                                                          ) : (
                                                            <tr>
                                                              <td colSpan={user.is_super_admin ? "8" : "7"} className="px-4 py-12 text-center text-gray-500 dark:text-gray-300">
                                                                <Download className="h-12 w-12 text-gray-400 mx-auto mb-2" />
                                                                <p>No collection records yet</p>
                                                                <p className="text-sm mt-1">Collection records will appear here</p>
                                                              </td>
                                                            </tr>
                                                          )}
                                                        </tbody>
                                                      </table>
                                                    </div>
                                                  </div>

                                                  {/* Pagination */}
                                                  <div className="flex items-center justify-between mt-4">
                                                    <div className="text-sm text-gray-700 dark:text-gray-100">
                                                      Showing {Math.min((collectionHistoryPage - 1) * 10 + 1, collections.length)} to {Math.min(collectionHistoryPage * 10, collections.length)} of {collections.length} records
                                                    </div>
                                                    <div className="flex gap-2">
                                                      <Button
                                                        variant="outline"
                                                        size="sm"
                                                        onClick={() => setCollectionHistoryPage(prev => Math.max(1, prev - 1))}
                                                        disabled={collectionHistoryPage === 1}
                                                      >
                                                        <ChevronLeft className="h-4 w-4" />
                                                        Previous
                                                      </Button>
                                                      <Button
                                                        variant="outline"
                                                        size="sm"
                                                        onClick={() => setCollectionHistoryPage(prev => prev + 1)}
                                                        disabled={collectionHistoryPage * 10 >= collections.length}
                                                      >
                                                        Next
                                                        <ChevronRight className="h-4 w-4" />
                                                      </Button>
                                                    </div>
                                                  </div>
                                                </CardContent>
                                              </Card>
                                            </div>
                                          )}

                                          {projectDetailTab === 'settings' && (
                                            <Card className="glass shadow-lg border-0">
                                              <CardHeader>
                                                <CardTitle>Project Settings</CardTitle>
                                                <CardDescription>Manage project plan and tasks</CardDescription>
                                              </CardHeader>
                                              <CardContent>
                                                <div className="space-y-6">
                                                  {/* Project Details Section */}
                                                  <div className="border-b pb-6">
                                                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Project Details</h3>
                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                      <div className="md:col-span-2">
                                                        <Label>Project Title</Label>
                                                        <div className="text-sm text-gray-700 dark:text-gray-100 mt-1">{selectedProject?.title}</div>
                                                      </div>
                                                      
                                                      <div>
                                                        <Label>Account Name</Label>
                                                        <div className="text-sm text-gray-700 dark:text-gray-100 mt-1">{selectedProject?.accountName}</div>
                                                      </div>
                                                      
                                                      <div>
                                                        <Label>Status</Label>
                                                        <div className="mt-1">
                                                          <span className={'px-3 py-1 rounded-full text-xs font-semibold ' + (selectedProject?.status === 'Pending' ? 'bg-yellow-100 text-yellow-800' : selectedProject?.status === 'Running' ? 'bg-green-100 text-green-800' : selectedProject?.status === 'Complete' ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800 dark:text-white')}>
                                                            {selectedProject?.status}
                                                          </span>
                                                        </div>
                                                      </div>
                                                      
                                                      <div>
                                                        <Label>Billing Statement Code</Label>
                                                        <div className="text-sm text-gray-700 dark:text-gray-100 mt-1">
                                                          {selectedProject?.billingStatementCode || 'Not set'}
                                                        </div>
                                                      </div>
                                                      
                                                      <div>
                                                        <Label>Project Duration</Label>
                                                        <div className="text-sm text-gray-700 dark:text-gray-100 mt-1">
                                                          {selectedProject?.startDate && selectedProject?.endDate
                                                            ? new Date(selectedProject.startDate).toLocaleDateString() + ' - ' + new Date(selectedProject.endDate).toLocaleDateString()
                                                            : 'Not set'}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  
                                                  {/* Project Plan Section */}
                                                  <div>
                                                    <div className="flex justify-between items-center mb-4">
                                                      <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Project Plan</h3>
                                                      <Button
                                                        onClick={() => setIsAddingTask(!isAddingTask)}
                                                        className="bg-indigo-600 hover:bg-indigo-700"
                                                      >
                                                        <Plus className="h-4 w-4 mr-1" />
                                                        {isAddingTask ? 'Cancel' : 'Add Task'}
                                                      </Button>
                                                    </div>

                                                    {/* Add Task Form */}
                                                    {isAddingTask && (
                                                      <Card className="mb-6 border-indigo-200 bg-indigo-50">
                                                        <CardContent className="pt-6">
                                                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                            <div className="md:col-span-2">
                                                              <Label htmlFor="task_name">Task Name *</Label>
                                                              <Input
                                                                id="task_name"
                                                                value={newTask.task_name}
                                                                onChange={(e) => setNewTask({...newTask, task_name: e.target.value})}
                                                                placeholder="Enter task name"
                                                                className="mt-1"
                                                              />
                                                            </div>

                                                            <div>
                                                              <Label htmlFor="assigned_resources">Assigned Resources *</Label>
                                                              <Input
                                                                id="assigned_resources"
                                                                value={newTask.assigned_resources}
                                                                onChange={(e) => setNewTask({...newTask, assigned_resources: e.target.value})}
                                                                placeholder="Enter resource name(s)"
                                                                className="mt-1"
                                                              />
                                                            </div>

                                                            <div>
                                                              <Label htmlFor="start_date">Start Date *</Label>
                                                              <Input
                                                                id="start_date"
                                                                type="date"
                                                                value={newTask.start_date}
                                                                onChange={(e) => setNewTask({...newTask, start_date: e.target.value})}
                                                                className="mt-1"
                                                              />
                                                            </div>

                                                            <div>
                                                              <Label htmlFor="end_date">End Date *</Label>
                                                              <Input
                                                                id="end_date"
                                                                type="date"
                                                                value={newTask.end_date}
                                                                onChange={(e) => setNewTask({...newTask, end_date: e.target.value})}
                                                                className="mt-1"
                                                                min={newTask.start_date}
                                                              />
                                                            </div>
                                                          </div>

                                                          <div className="flex justify-end gap-2 mt-4">
                                                            <Button
                                                              variant="outline"
                                                              onClick={() => {
                                                                setIsAddingTask(false);
                                                                setNewTask({
                                                                  task_name: '',
                                                                  assigned_resources: '',
                                                                  start_date: '',
                                                                  end_date: ''
                                                                });
                                                              }}
                                                            >
                                                              Cancel
                                                            </Button>
                                                            <Button
                                                              className="bg-indigo-600 hover:bg-indigo-700"
                                                              onClick={async () => {
                                                                if (!newTask.task_name.trim()) {
                                                                  toast.error('Please enter a task name');
                                                                  return;
                                                                }
                                                                if (!newTask.assigned_resources.trim()) {
                                                                  toast.error('Please enter assigned resources');
                                                                  return;
                                                                }
                                                                if (!newTask.start_date || !newTask.end_date) {
                                                                  toast.error('Please select start and end dates');
                                                                  return;
                                                                }

                                                                try {
                                                                  await createProjectTask(selectedProject.id, newTask);
                                                                  setIsAddingTask(false);
                                                                  setNewTask({
                                                                    task_name: '',
                                                                    assigned_resources: '',
                                                                    start_date: '',
                                                                    end_date: ''
                                                                  });
                                                                } catch (error) {
                                                                  // Error already handled in createProjectTask
                                                                }
                                                              }}
                                                            >
                                                              <Save className="h-4 w-4 mr-1" />
                                                              Save Task
                                                            </Button>
                                                          </div>
                                                        </CardContent>
                                                      </Card>
                                                    )}

                                                    {/* Tasks Table */}
                                                    {projectTasks && projectTasks.length > 0 ? (
                                                      <div className="border border-gray-200 rounded-lg overflow-hidden">
                                                        <table className="min-w-full divide-y divide-gray-200">
                                                          <thead className="bg-gray-50">
                                                            <tr>
                                                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                                                                Task Name
                                                              </th>
                                                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                                                                Assigned To
                                                              </th>
                                                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                                                                Start Date
                                                              </th>
                                                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                                                                End Date
                                                              </th>
                                                              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                                                                Status
                                                              </th>
                                                              <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                                                                Completion
                                                              </th>
                                                              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                                                                Actions
                                                              </th>
                                                            </tr>
                                                          </thead>
                                                          <tbody className="bg-white divide-y divide-gray-200">
                                                            {projectTasks.map((task) => {
                                                              const completion = calculateTaskCompletion(task);
                                                              const status = calculateTaskStatus(task);
                                                              return (
                                                                <tr key={task.id} className="hover:bg-gray-50 dark:hover:bg-black">
                                                                  <td className="px-4 py-3 text-sm text-gray-900 dark:text-white">{task.task_name}</td>
                                                                  <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-200">{task.assigned_resources}</td>
                                                                  <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-200">
                                                                    {new Date(task.start_date).toLocaleDateString()}
                                                                  </td>
                                                                  <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-200">
                                                                    {new Date(task.end_date).toLocaleDateString()}
                                                                  </td>
                                                                  <td className="px-4 py-3 text-sm">
                                                                    <span className={
                                                                      'px-2 py-1 text-xs font-medium rounded-full ' +
                                                                      (status === 'Completed'
                                                                        ? 'bg-green-100 text-green-800'
                                                                        : status === 'In Progress'
                                                                          ? 'bg-blue-100 text-blue-800'
                                                                          : 'bg-gray-100 text-gray-800 dark:text-white')
                                                                    }>
                                                                      {status}
                                                                    </span>
                                                                  </td>
                                                                  <td className="px-4 py-3 text-sm text-center">
                                                                    <div className="flex flex-col items-center gap-1">
                                                                      <span className={`font-semibold ${
                                                                        completion >= 75 ? 'text-green-600' :
                                                                        completion >= 50 ? 'text-blue-600' :
                                                                        completion >= 25 ? 'text-orange-600' :
                                                                        'text-gray-600 dark:text-gray-200'
                                                                      }`}>
                                                                        {completion}%
                                                                      </span>
                                                                      <div className="w-full bg-gray-200 rounded-full h-1.5">
                                                                        <div 
                                                                          className={
                                                                            'h-1.5 rounded-full ' +
                                                                            (completion >= 75 ? 'bg-green-600' :
                                                                              completion >= 50 ? 'bg-blue-600' :
                                                                              completion >= 25 ? 'bg-orange-600' :
                                                                              'bg-gray-600')
                                                                          }
                                                                          style={{ width: completion + '%' }}
                                                                        ></div>
                                                                      </div>
                                                                    </div>
                                                                  </td>
                                                                  <td className="px-4 py-3 text-sm text-right">
                                                                    <div className="flex justify-end gap-2">
                                                                      <Button
                                                                        variant="ghost"
                                                                        size="sm"
                                                                        onClick={() => setSelectedTaskForCalendar(task)}
                                                                        className="text-indigo-600 hover:text-indigo-800"
                                                                        title="View Calendar"
                                                                      >
                                                                        <CalendarIcon className="h-4 w-4" />
                                                                      </Button>
                                                                      <Button
                                                                        variant="ghost"
                                                                        size="sm"
                                                                        onClick={async () => {
                                                                          const confirmed = await confirmDialog({
                                                                              title: "Delete Task",
                                                                              description: "Are you sure you want to delete this task?",
                                                                              variant: "destructive"
                                                                          });
                                                                          if (confirmed) {
                                                                            await deleteProjectTask(selectedProject.id, task.id);
                                                                          }
                                                                        }}
                                                                        className="text-red-600 hover:text-red-800"
                                                                      >
                                                                        <Trash2 className="h-4 w-4" />
                                                                      </Button>
                                                                    </div>
                                                                  </td>
                                                                </tr>
                                                              );
                                                            })}
                                                          </tbody>
                                                        </table>
                                                      </div>
                                                    ) : (
                                                      <div className="text-center py-12 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
                                                        <Calendar className="h-12 w-12 text-gray-400 mx-auto mb-3" />
                                                        <p className="text-gray-600 dark:text-gray-200 font-medium">No tasks added yet</p>
                                                        <p className="text-gray-500 dark:text-gray-300 text-sm mt-1">Click "Add Task" to create your first task</p>
                                                      </div>
                                                    )}
                                                  </div>
                                                </div>
                                              </CardContent>
                                            </Card>
                                          )}
                                        </div>

                                        {/* Task Calendar Modal */}
                                        {selectedTaskForCalendar && (
                                          <Dialog open={!!selectedTaskForCalendar} onOpenChange={() => setSelectedTaskForCalendar(null)}>
                                            <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
                                              <DialogHeader>
                                                <DialogTitle>Task Calendar - {selectedTaskForCalendar.task_name}</DialogTitle>
                                                <DialogDescription>
                                                  Mark attended/unattended dates for this task. Click on dates to toggle attendance.
                                                </DialogDescription>
                                              </DialogHeader>
                                              
                                              <div className="space-y-6">
                                                {/* Task Info */}
                                                <div className="bg-gray-50 p-4 rounded-lg">
                                                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                                                    <div>
                                                      <span className="font-medium text-gray-700 dark:text-gray-100">Assigned To:</span>
                                                      <p className="text-gray-900 dark:text-white">{selectedTaskForCalendar.assigned_resources}</p>
                                                    </div>
                                                    <div>
                                                      <span className="font-medium text-gray-700 dark:text-gray-100">Period:</span>
                                                      <p className="text-gray-900 dark:text-white">
                                                        {new Date(selectedTaskForCalendar.start_date).toLocaleDateString()} - {new Date(selectedTaskForCalendar.end_date).toLocaleDateString()}
                                                      </p>
                                                    </div>
                                                    <div>
                                                      <span className="font-medium text-gray-700 dark:text-gray-100">Status:</span>
                                                      <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${
                                                        calculateTaskStatus(selectedTaskForCalendar) === 'Completed' ? 'bg-green-100 text-green-800' :
                                                        calculateTaskStatus(selectedTaskForCalendar) === 'In Progress' ? 'bg-blue-100 text-blue-800' :
                                                        'bg-gray-100 text-gray-800 dark:text-white'
                                                      }`}>
                                                        {calculateTaskStatus(selectedTaskForCalendar)}
                                                      </span>
                                                    </div>
                                                    <div>
                                                      <span className="font-medium text-gray-700 dark:text-gray-100">Completion:</span>
                                                      <p className="text-gray-900 dark:text-white font-semibold">{calculateTaskCompletion(selectedTaskForCalendar)}%</p>
                                                    </div>
                                                  </div>

                                                  {(() => {
                                                    const today = new Date();
                                                    today.setHours(0, 0, 0, 0);
                                                    const endDate = new Date(selectedTaskForCalendar.end_date);
                                                    endDate.setHours(0, 0, 0, 0);
                                                    const isPastDue = today > endDate;
                                                    const daysPastDue = isPastDue ? Math.ceil((today - endDate) / (1000 * 60 * 60 * 24)) : 0;

                                                    if (isPastDue) {
                                                      return (
                                                        <div className="mt-3 p-3 bg-red-50 border border-red-200 rounded-lg">
                                                          <div className="flex items-center gap-2">
                                                            <span className="inline-flex px-2 py-1 text-xs font-medium rounded-full bg-red-100 text-red-800">
                                                              Past Due
                                                            </span>
                                                            <span className="text-sm text-red-700 font-medium">{daysPastDue} days past due</span>
                                                          </div>
                                                        </div>
                                                      );
                                                    }
                                                    return null;
                                                  })()}
                                                </div>

                                                {/* Calendar */}
                                                <div className="border border-gray-200 rounded-lg p-4">
                                                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Task Calendar</h3>
                                                  
                                                  {(() => {
                                                    const { taskDates, pastDueDates } = getExtendedTaskDateRange(selectedTaskForCalendar);
                                                    const attendedDates = taskAttendedDates[selectedTaskForCalendar.id] || [];
                                                    const allClickableDates = [...taskDates, ...pastDueDates];
                                                    
                                                    if (allClickableDates.length === 0) {
                                                      return (
                                                        <div className="text-center py-8 text-gray-500 dark:text-gray-300">
                                                          No dates to display for this task.
                                                        </div>
                                                      );
                                                    }

                                                    // Group dates by month
                                                    const monthGroups = {};
                                                    allClickableDates.forEach(dateStr => {
                                                      const date = new Date(dateStr);
                                                      const monthKey = `${date.getFullYear()}-${date.getMonth()}`;
                                                      const monthName = date.toLocaleString('default', { month: 'long', year: 'numeric' });
                                                      
                                                      if (!monthGroups[monthKey]) {
                                                        monthGroups[monthKey] = {
                                                          name: monthName,
                                                          dates: [],
                                                          year: date.getFullYear(),
                                                          month: date.getMonth()
                                                        };
                                                      }
                                                      monthGroups[monthKey].dates.push(dateStr);
                                                    });

                                                    return (
                                                      <div className="space-y-6">
                                                        {Object.entries(monthGroups).map(([monthKey, monthData]) => (
                                                          <div key={monthKey}>
                                                            <h4 className="text-md font-medium text-gray-800 dark:text-white mb-3">{monthData.name}</h4>
                                                            <div className="grid grid-cols-7 gap-2">
                                                              {/* Calendar headers */}
                                                              {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
                                                                <div key={day} className="text-center text-xs font-medium text-gray-500 dark:text-gray-300 py-2">
                                                                  {day}
                                                                </div>
                                                              ))}
                                                              
                                                              {/* Calendar days */}
                                                              {(() => {
                                                                const startOfMonth = new Date(monthData.year, monthData.month, 1);
                                                                const endOfMonth = new Date(monthData.year, monthData.month + 1, 0);
                                                                
                                                                const calendarDays = [];
                                                                
                                                                // Add empty cells for days before the first day of month
                                                                for (let i = 0; i < startOfMonth.getDay(); i++) {
                                                                  calendarDays.push(<div key={`empty-${i}`} className="h-10"></div>);
                                                                }
                                                                
                                                                // Add all days of the month
                                                                for (let day = 1; day <= endOfMonth.getDate(); day++) {
                                                                  const dateStr = `${monthData.year}-${String(monthData.month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
                                                                  const isTaskDate = taskDates.includes(dateStr);
                                                                  const isPastDueDate = pastDueDates.includes(dateStr);
                                                                  const isClickable = isTaskDate || isPastDueDate;
                                                                  const isAttended = attendedDates.includes(dateStr);
                                                                  
                                                                  calendarDays.push(
                                                                    <button
                                                                      key={dateStr}
                                                                      onClick={() => isClickable && toggleTaskDate(selectedTaskForCalendar.id, dateStr)}
                                                                      disabled={!isClickable}
                                                                      className={`h-10 w-10 rounded-lg text-sm font-medium transition-colors ${
                                                                        !isClickable
                                                                          ? 'text-gray-300 cursor-not-allowed'
                                                                          : isPastDueDate
                                                                          ? isAttended
                                                                            ? 'bg-amber-500 text-white hover:bg-amber-600 border-2 border-amber-600'
                                                                            : 'bg-amber-100 text-amber-700 border border-amber-300 hover:bg-amber-200'
                                                                          : isTaskDate
                                                                          ? isAttended
                                                                            ? 'bg-green-500 text-white hover:bg-green-600'
                                                                            : 'bg-red-100 text-red-700 border border-red-200 hover:bg-red-200'
                                                                          : 'text-gray-300 cursor-not-allowed'
                                                                      }`}
                                                                      title={
                                                                        !isClickable 
                                                                          ? 'Not part of task period'
                                                                          : isPastDueDate
                                                                          ? isAttended
                                                                            ? 'Past Due - Attended - Click to mark unattended'
                                                                            : 'Past Due - Unattended - Click to mark attended'
                                                                          : isTaskDate
                                                                          ? isAttended 
                                                                            ? 'Attended - Click to mark unattended' 
                                                                            : 'Unattended - Click to mark attended'
                                                                          : 'Outside task period'
                                                                      }
                                                                    >
                                                                      {day}
                                                                    </button>
                                                                  );
                                                                }
                                                                
                                                                return calendarDays;
                                                              })()}
                                                            </div>
                                                          </div>
                                                        ))}
                                                        
                                                        {/* Legend */}
                                                        <div className="flex flex-wrap gap-4 justify-center pt-4 border-t border-gray-200">
                                                          <div className="flex items-center gap-2">
                                                            <div className="w-4 h-4 bg-green-500 rounded"></div>
                                                            <span className="text-sm text-gray-700 dark:text-gray-100">Attended</span>
                                                          </div>
                                                          <div className="flex items-center gap-2">
                                                            <div className="w-4 h-4 bg-red-100 border border-red-200 rounded"></div>
                                                            <span className="text-sm text-gray-700 dark:text-gray-100">Unattended</span>
                                                          </div>
                                                          <div className="flex items-center gap-2">
                                                            <div className="w-4 h-4 bg-amber-500 rounded"></div>
                                                            <span className="text-sm text-gray-700 dark:text-gray-100">Past Due - Attended</span>
                                                          </div>
                                                          <div className="flex items-center gap-2">
                                                            <div className="w-4 h-4 bg-amber-100 border border-amber-300 rounded"></div>
                                                            <span className="text-sm text-gray-700 dark:text-gray-100">Past Due - Unattended</span>
                                                          </div>
                                                          <div className="flex items-center gap-2">
                                                            <div className="w-4 h-4 bg-gray-100 rounded"></div>
                                                            <span className="text-sm text-gray-700 dark:text-gray-100">Outside Task Period</span>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    );
                                                  })()}
                                                </div>

                                                {/* Save Button */}
                                                <div className="flex justify-end gap-2 pt-4 border-t border-gray-200 mt-6">
                                                  <Button
                                                    variant="outline"
                                                    onClick={() => {
                                                      setSelectedTaskForCalendar(null);
                                                    }}
                                                  >
                                                    Cancel
                                                  </Button>
                                                  <Button
                                                    onClick={() => saveTaskAttendance(selectedTaskForCalendar.id)}
                                                    className="bg-indigo-600 hover:bg-indigo-700"
                                                  >
                                                    <Save className="h-4 w-4 mr-1" />
                                                    Save Attendance
                                                  </Button>
                                                </div>
                                              </div>
                                            </DialogContent>
                                          </Dialog>
                                        )}

                                        {/* Create Department Modal */}
                                        <Dialog open={isCreateDepartmentModalOpen} onOpenChange={setIsCreateDepartmentModalOpen}>
                                          <DialogContent className="max-w-2xl">
                                            <DialogHeader>
                                              <DialogTitle>Create New Department</DialogTitle>
                                              <DialogDescription>
                                                Add a new department for meter reading management
                                              </DialogDescription>
                                            </DialogHeader>
                                            <div className="space-y-4">
                                              <div>
                                                <Label htmlFor="dept_name">Department Name *</Label>
                                                <Input
                                                  id="dept_name"
                                                  value={newDepartment.name}
                                                  onChange={(e) => setNewDepartment({ ...newDepartment, name: e.target.value })}
                                                  placeholder="Enter department name"
                                                  className="mt-1"
                                                />
                                              </div>
                                              
                                              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                <div>
                                                  <Label htmlFor="contact_person">Contact Person</Label>
                                                  <Input
                                                    id="contact_person"
                                                    value={newDepartment.contact_person}
                                                    onChange={(e) => setNewDepartment({ ...newDepartment, contact_person: e.target.value })}
                                                    placeholder="Enter contact person name"
                                                    className="mt-1"
                                                  />
                                                </div>
                                                
                                                <div>
                                                  <Label htmlFor="birthday">Birthday</Label>
                                                  <Input
                                                    id="birthday"
                                                    type="date"
                                                    value={newDepartment.birthday}
                                                    onChange={(e) => setNewDepartment({ ...newDepartment, birthday: e.target.value })}
                                                    className="mt-1"
                                                  />
                                                </div>
                                                
                                                <div>
                                                  <Label htmlFor="contact_number">Contact Number</Label>
                                                  <Input
                                                    id="contact_number"
                                                    type="tel"
                                                    value={newDepartment.contact_number}
                                                    onChange={(e) => setNewDepartment({ ...newDepartment, contact_number: e.target.value })}
                                                    placeholder="Enter contact number"
                                                    className="mt-1"
                                                  />
                                                </div>
                                                
                                                <div>
                                                  <Label htmlFor="email">Email</Label>
                                                  <Input
                                                    id="email"
                                                    type="email"
                                                    value={newDepartment.email}
                                                    onChange={(e) => setNewDepartment({ ...newDepartment, email: e.target.value })}
                                                    placeholder="Enter email address"
                                                    className="mt-1"
                                                  />
                                                </div>
                                              </div>
                                              
                                              <div className="flex justify-end gap-2 pt-4">
                                                <Button
                                                  variant="outline"
                                                  onClick={() => {
                                                    setIsCreateDepartmentModalOpen(false);
                                                    setNewDepartment({ name: '', contact_person: '', birthday: '', contact_number: '', email: '' });
                                                  }}
                                                >
                                                  Cancel
                                                </Button>
                                                <Button onClick={createDepartment} className="bg-indigo-600 hover:bg-indigo-700">
                                                  Save Department
                                                </Button>
                                              </div>
                                            </div>
                                          </DialogContent>
                                        </Dialog>

                                        {/* Create Machine Modal */}
                                        <Dialog open={isCreateMachineModalOpen} onOpenChange={setIsCreateMachineModalOpen}>
                                          <DialogContent>
                                            <DialogHeader>
                                              <DialogTitle>Add New Machine</DialogTitle>
                                              <DialogDescription>
                                                Add a machine to {selectedDepartmentForMachine?.name} department
                                              </DialogDescription>
                                            </DialogHeader>
                                            <div className="space-y-4">
                                              <div>
                                                <Label htmlFor="machine_model">Machine Model *</Label>
                                                <Input
                                                  id="machine_model"
                                                  value={newMachine.model}
                                                  onChange={(e) => setNewMachine({ ...newMachine, model: e.target.value })}
                                                  placeholder="Enter machine model"
                                                  className="mt-1"
                                                />
                                              </div>
                                              <div>
                                                <Label htmlFor="serial_number">Serial Number *</Label>
                                                <Input
                                                  id="serial_number"
                                                  value={newMachine.serialNumber}
                                                  onChange={(e) => setNewMachine({ ...newMachine, serialNumber: e.target.value })}
                                                  placeholder="Enter serial number"
                                                  className="mt-1"
                                                />
                                              </div>
                                              <div>
                                                <Label htmlFor="date_installed">Date Installed *</Label>
                                                <Input
                                                  id="date_installed"
                                                  type="date"
                                                  value={newMachine.dateInstalled}
                                                  onChange={(e) => setNewMachine({ ...newMachine, dateInstalled: e.target.value })}
                                                  className="mt-1"
                                                />
                                              </div>
                                              <div className="flex justify-end gap-2">
                                                <Button
                                                  variant="outline"
                                                  onClick={() => {
                                                    setIsCreateMachineModalOpen(false);
                                                    setNewMachine({ model: '', serialNumber: '', dateInstalled: '' });
                                                    setSelectedDepartmentForMachine(null);
                                                  }}
                                                >
                                                  Cancel
                                                </Button>
                                                <Button onClick={createMachine} className="bg-green-600 hover:bg-green-700">
                                                  Save Machine
                                                </Button>
                                              </div>
                                            </div>
                                          </DialogContent>
                                        </Dialog>

                                        {/* Meter Reading Modal */}
                                        <Dialog open={isMeterReadingModalOpen} onOpenChange={setIsMeterReadingModalOpen}>
                                          <DialogContent className="max-w-7xl max-h-[90vh] overflow-y-auto">
                                            <DialogHeader>
                                              <DialogTitle>Meter Reading - {selectedMachine?.model}</DialogTitle>
                                              <DialogDescription>
                                                Record meter reading for machine S/N: {selectedMachine?.serialNumber}
                                              </DialogDescription>
                                            </DialogHeader>
                                            
                                            <div className="space-y-6">
                                              {/* Machine Info */}
                                              <div className="bg-gray-50 p-4 rounded-lg">
                                                <div className="grid grid-cols-2 gap-4 text-sm">
                                                  <div>
                                                    <span className="font-medium text-gray-700 dark:text-gray-100">Machine Model:</span>
                                                    <p className="text-gray-900 dark:text-white">{selectedMachine?.model}</p>
                                                  </div>
                                                  <div>
                                                    <span className="font-medium text-gray-700 dark:text-gray-100">Serial Number:</span>
                                                    <p className="text-gray-900 dark:text-white">{selectedMachine?.serialNumber}</p>
                                                  </div>
                                                  <div>
                                                    <span className="font-medium text-gray-700 dark:text-gray-100">Date Installed:</span>
                                                    <p className="text-gray-900 dark:text-white">
                                                      {selectedMachine?.dateInstalled ? new Date(selectedMachine.dateInstalled).toLocaleDateString() : 'N/A'}
                                                    </p>
                                                  </div>
                                                  <div>
                                                    <span className="font-medium text-gray-700 dark:text-gray-100">Total Readings:</span>
                                                    <p className="text-gray-900 dark:text-white">{selectedMachine?.meterReadings?.length || 0}</p>
                                                  </div>
                                                </div>
                                              </div>

                                              {/* Meter Reading Form - Multiple Rows for Each Type */}
                                              <div className="flex flex-col gap-4">
                                                {/* Initial Reading Button */}
                                                <div className="flex justify-end">
                                                  <Button
                                                    onClick={() => {
                                                      // Load saved initial readings if they exist
                                                      if (selectedMachine?.initialReadings) {
                                                        setInitialReading(selectedMachine.initialReadings);
                                                      } else {
                                                        // Reset to default if no saved readings
                                                        setInitialReading({
                                                          'Mono Small': { value: 0, date: '' },
                                                          'Mono Large': { value: 0, date: '' },
                                                          'Colored Small': { value: 0, date: '' },
                                                          'Colored Large': { value: 0, date: '' }
                                                        });
                                                      }
                                                      setIsInitialReadingModalOpen(true);
                                                    }}
                                                    className="bg-blue-600 hover:bg-blue-700"
                                                  >
                                                    <Settings className="h-4 w-4 mr-2" />
                                                    Set Initial Reading
                                                  </Button>
                                                </div>
                                                
                                                {/* Meter Reading Table */}
                                                <div className="border border-gray-300 rounded-lg overflow-hidden flex-1">
                                                  <div className="bg-gray-50 px-4 py-3">
                                                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Meter Reading Entry</h3>
                                                    <p className="text-sm text-gray-600 dark:text-gray-200 mt-1">Fill in readings for any applicable meter types</p>
                                                  </div>
                                                  
                                                  {/* Header Row */}
                                                  <div className="bg-gray-100 grid border-b border-gray-300" style={{gridTemplateColumns: '100px 120px 180px 100px 120px 100px 120px 100px 120px'}}>
                                                  <div className="px-3 py-2 text-center border-r border-gray-300">
                                                    <div className="text-xs font-medium text-gray-700 dark:text-gray-100">Type</div>
                                                  </div>
                                                  <div className="px-3 py-2 text-center border-r border-gray-300">
                                                    <div className="text-xs font-medium text-gray-700 dark:text-gray-100 mb-1">Previous Reading</div>
                                                    <div className="text-xs text-gray-500 dark:text-gray-300">Date</div>
                                                  </div>
                                                  <div className="px-3 py-2 text-center border-r border-gray-300">
                                                    <div className="text-xs font-medium text-gray-700 dark:text-gray-100 mb-1">Present Reading</div>
                                                    <div className="text-xs text-gray-500 dark:text-gray-300">Date</div>
                                                  </div>
                                                  <div className="px-3 py-2 text-center border-r border-gray-300">
                                                    <div className="text-xs font-medium text-gray-700 dark:text-gray-100">Multiplier</div>
                                                  </div>
                                                  <div className="px-3 py-2 text-center border-r border-gray-300">
                                                    <div className="text-xs font-medium text-gray-700 dark:text-gray-100">Total Consumption</div>
                                                  </div>
                                                  <div className="px-3 py-2 text-center border-r border-gray-300">
                                                    <div className="text-xs font-medium text-gray-700 dark:text-gray-100">Spoilage %</div>
                                                  </div>
                                                  <div className="px-3 py-2 text-center border-r border-gray-300">
                                                    <div className="text-xs font-medium text-gray-700 dark:text-gray-100">Spoilage Amount</div>
                                                  </div>
                                                  <div className="px-3 py-2 text-center border-r border-gray-300">
                                                    <div className="text-xs font-medium text-gray-700 dark:text-gray-100">Rate (&#8369;)</div>
                                                  </div>
                                                  <div className="px-3 py-2 text-center">
                                                    <div className="text-xs font-medium text-gray-700 dark:text-gray-100">Amount (&#8369;)</div>
                                                  </div>
                                                </div>
                                                
                                                {/* Data Rows - One for each meter type */}
                                                {(() => {
                                                  const meterTypes = ['Mono Small', 'Mono Large', 'Colored Small', 'Colored Large'];
                                                  const calculations = calculateMeterReadingValues(meterReading);
                                                  
                                                  return meterTypes.map((type, index) => (
                                                    <div key={type} className={`bg-white grid min-h-[80px] items-center border-b border-gray-200 ${index % 2 === 1 ? 'bg-gray-50' : ''}`} style={{gridTemplateColumns: '100px 120px 180px 100px 120px 100px 120px 100px 120px'}}>
                                                      {/* Type Label */}
                                                      <div className="px-3 py-4 border-r border-gray-300 text-center">
                                                        <div className="text-sm font-medium text-gray-900 dark:text-white">{type}</div>
                                                      </div>
                                                      
                                                      {/* Previous Reading & Date */}
                                                      <div className="px-3 py-4 border-r border-gray-300 text-center">
                                                        <div className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                                                          {meterReading[type]?.previousReading || 0}
                                                        </div>
                                                        <div className="text-xs text-gray-500 dark:text-gray-300">
                                                          {meterReading[type]?.previousDate ? new Date(meterReading[type].previousDate).toLocaleDateString() : '--/--/--'}
                                                        </div>
                                                      </div>
                                                      
                                                      {/* Present Reading & Date */}
                                                      <div className="px-3 py-4 border-r border-gray-300 space-y-2">
                                                        <Input
                                                          type="number"
                                                          value={meterReading[type]?.presentReading || ''}
                                                          onChange={(e) => {
                                                            const newValue = e.target.value;
                                                            const previousValue = parseFloat(meterReading[type]?.previousReading) || 0;
                                                            const presentValue = parseFloat(newValue);
                                                            
                                                            // Update the value
                                                            setMeterReading(prev => ({
                                                              ...prev,
                                                              [type]: {
                                                                ...prev[type],
                                                                presentReading: newValue
                                                              }
                                                            }));
                                                            
                                                            // Show warning if present is less than previous
                                                            if (newValue && presentValue < previousValue) {
                                                              console.warn(`\u26a0\ufe0f ${type}: Present reading (${presentValue}) is less than previous reading (${previousValue})`);
                                                            }
                                                          }}
                                                          placeholder="Enter reading"
                                                          className={`text-center text-lg font-semibold w-full ${
                                                            meterReading[type]?.presentReading && 
                                                            parseFloat(meterReading[type]?.presentReading) < parseFloat(meterReading[type]?.previousReading || 0)
                                                            ? 'border-red-500 border-2 bg-red-50'
                                                            : ''
                                                          }`}
                                                        />
                                                        {meterReading[type]?.presentReading && 
                                                        parseFloat(meterReading[type]?.presentReading) < parseFloat(meterReading[type]?.previousReading || 0) && (
                                                          <div className="text-xs text-red-600 font-medium text-center">
                                                            Cannot be less than previous!
                                                          </div>
                                                        )}
                                                        <Input
                                                          type="date"
                                                          value={meterReading[type]?.presentDate || ''}
                                                          onChange={(e) => setMeterReading(prev => ({
                                                            ...prev,
                                                            [type]: {
                                                              ...prev[type],
                                                              presentDate: e.target.value
                                                            }
                                                          }))}
                                                          className="text-center text-xs w-full"
                                                        />
                                                      </div>
                                                      
                                                      {/* Multiplier */}
                                                      <div className="px-3 py-4 border-r border-gray-300">
                                                        <Input
                                                          type="number"
                                                          value={meterReading[type]?.multiplier || 1}
                                                          onChange={(e) => setMeterReading(prev => ({
                                                            ...prev,
                                                            [type]: {
                                                              ...prev[type],
                                                              multiplier: e.target.value || 1
                                                            }
                                                          }))}
                                                          placeholder="1"
                                                          className="text-center"
                                                          min="0"
                                                          step="0.01"
                                                        />
                                                      </div>
                                                      
                                                      {/* Total Consumption */}
                                                      <div className="px-3 py-4 border-r border-gray-300 text-center">
                                                        <div className="text-lg font-semibold text-blue-600">
                                                          {calculations[type]?.totalConsumption.toFixed(2) || '0.00'}
                                                        </div>
                                                      </div>
                                                      
                                                      {/* Spoilage % */}
                                                      <div className="px-3 py-4 border-r border-gray-300">
                                                        <Input
                                                          type="number"
                                                          value={meterReading[type]?.spoilageTolerance || ''}
                                                          onChange={(e) => setMeterReading(prev => ({
                                                            ...prev,
                                                            [type]: {
                                                              ...prev[type],
                                                              spoilageTolerance: e.target.value
                                                            }
                                                          }))}
                                                          placeholder="0"
                                                          className="text-center"
                                                          min="0"
                                                          max="100"
                                                        />
                                                      </div>
                                                      
                                                      {/* Spoilage Amount */}
                                                      <div className="px-3 py-4 border-r border-gray-300 text-center">
                                                        <div className="text-lg font-semibold text-orange-600">
                                                          {calculations[type]?.spoilage.toFixed(2) || '0.00'}
                                                        </div>
                                                      </div>
                                                      
                                                      {/* Rate */}
                                                      <div className="px-3 py-4 border-r border-gray-300">
                                                        <Input
                                                          type="number"
                                                          value={meterReading[type]?.rate || ''}
                                                          onChange={(e) => setMeterReading(prev => ({
                                                            ...prev,
                                                            [type]: {
                                                              ...prev[type],
                                                              rate: e.target.value
                                                            }
                                                          }))}
                                                          placeholder="0.00"
                                                          className="text-center"
                                                          min="0"
                                                          step="0.01"
                                                        />
                                                      </div>
                                                      
                                                      {/* Amount */}
                                                      <div className="px-3 py-4 text-center">
                                                        <div className="text-xl font-bold text-green-600">
                                                          &#8369;{calculations[type]?.amount.toFixed(2) || '0.00'}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  ));
                                                })()}
                                              </div>
                                                
                                                {/* Total Amount Section - Vertical Display */}
                                                <div className="border-l-4 border-indigo-600 bg-indigo-50 rounded-lg p-6 flex flex-col justify-center items-center min-w-[200px]">
                                                  <div className="text-center">
                                                    <div className="text-sm font-medium text-indigo-900 mb-2">TOTAL AMOUNT</div>
                                                    <div className="text-4xl font-bold text-indigo-600">
                                                      &#8369;{(() => {
                                                        const calculations = calculateMeterReadingValues(meterReading);
                                                        return Object.values(calculations).reduce((sum, calc) => sum + (calc?.amount || 0), 0).toFixed(2);
                                                      })()}
                                                    </div>
                                                    <div className="text-xs text-indigo-700 mt-2">All Meter Types</div>
                                                  </div>
                                                </div>
                                              </div>

                                              <div className="flex justify-end gap-2 mt-4">
                                                <Button
                                                  variant="outline"
                                                  onClick={() => {
                                                    setIsMeterReadingModalOpen(false);
                                                    setSelectedMachine(null);
                                                  }}
                                                >
                                                  Cancel
                                                </Button>
                                                <Button onClick={saveMeterReading} className="bg-indigo-600 hover:bg-indigo-700">
                                                  <Save className="h-4 w-4 mr-1" />
                                                  Save Readings
                                                </Button>
                                              </div>
                                            </div>
                                          </DialogContent>
                                        </Dialog>

                                        {/* Initial Reading Modal */}
                                        <Dialog open={isInitialReadingModalOpen} onOpenChange={setIsInitialReadingModalOpen}>
                                          <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
                                            <DialogHeader>
                                              <DialogTitle>Set Initial Meter Reading</DialogTitle>
                                              <DialogDescription>
                                                Set the initial meter reading values for {selectedMachine?.machineModel} ({selectedMachine?.serialNumber})
                                              </DialogDescription>
                                            </DialogHeader>
                                            
                                            <div className="space-y-4">
                                              {/* Initial Reading Table */}
                                              <div className="border border-gray-300 rounded-lg overflow-hidden">
                                                <div className="bg-gray-50 px-4 py-3">
                                                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Initial Meter Reading</h3>
                                                  <p className="text-sm text-gray-600 dark:text-gray-200 mt-1">Enter the initial reading values for each meter type</p>
                                                </div>
                                                
                                                {/* Header Row */}
                                                <div className="bg-gray-100 grid border-b border-gray-300" style={{gridTemplateColumns: '150px 200px 200px'}}>
                                                  <div className="px-3 py-2 text-center border-r border-gray-300">
                                                    <div className="text-xs font-medium text-gray-700 dark:text-gray-100">Meter Type</div>
                                                  </div>
                                                  <div className="px-3 py-2 text-center border-r border-gray-300">
                                                    <div className="text-xs font-medium text-gray-700 dark:text-gray-100">Initial Meter Reading</div>
                                                  </div>
                                                  <div className="px-3 py-2 text-center">
                                                    <div className="text-xs font-medium text-gray-700 dark:text-gray-100">Date</div>
                                                  </div>
                                                </div>
                                                
                                                {/* Data Rows - One for each meter type */}
                                                {['Mono Small', 'Mono Large', 'Colored Small', 'Colored Large'].map((type, index) => (
                                                  <div key={type} className={`bg-white grid min-h-[70px] items-center border-b border-gray-200 ${index % 2 === 1 ? 'bg-gray-50' : ''}`} style={{gridTemplateColumns: '150px 200px 200px'}}>
                                                    {/* Type Label */}
                                                    <div className="px-3 py-4 border-r border-gray-300 text-center">
                                                      <div className="text-sm font-medium text-gray-900 dark:text-white">{type}</div>
                                                    </div>
                                                    
                                                    {/* Initial Reading Input */}
                                                    <div className="px-3 py-4 border-r border-gray-300">
                                                      <Input
                                                        type="number"
                                                        value={initialReading[type].value}
                                                        onChange={(e) => setInitialReading({
                                                          ...initialReading,
                                                          [type]: { ...initialReading[type], value: e.target.value }
                                                        })}
                                                        placeholder="0"
                                                        className="text-center"
                                                      />
                                                    </div>
                                                    
                                                    {/* Date Input */}
                                                    <div className="px-3 py-4">
                                                      <Input
                                                        type="date"
                                                        value={initialReading[type].date}
                                                        onChange={(e) => setInitialReading({
                                                          ...initialReading,
                                                          [type]: { ...initialReading[type], date: e.target.value }
                                                        })}
                                                        className="text-center"
                                                      />
                                                    </div>
                                                  </div>
                                                ))}
                                              </div>
                                              
                                              {/* Action Buttons */}
                                              <div className="flex justify-end gap-2 pt-4">
                                                <Button 
                                                  onClick={() => setIsInitialReadingModalOpen(false)} 
                                                  variant="outline"
                                                >
                                                  Cancel
                                                </Button>
                                                <Button 
                                                  onClick={handleSaveInitialReading} 
                                                  className="bg-green-600 hover:bg-green-700"
                                                >
                                                  <Save className="h-4 w-4 mr-1" />
                                                  Save Initial Readings
                                                </Button>
                                              </div>
                                            </div>
                                          </DialogContent>
                                        </Dialog>

                                        {/* Edit Department Modal */}
                                        <Dialog open={isEditDepartmentModalOpen} onOpenChange={setIsEditDepartmentModalOpen}>
                                          <DialogContent className="max-w-2xl">
                                            <DialogHeader>
                                              <DialogTitle>Edit Department</DialogTitle>
                                              <DialogDescription>
                                                Update department information
                                              </DialogDescription>
                                            </DialogHeader>
                                            <div className="space-y-4">
                                              <div>
                                                <Label htmlFor="edit_dept_name">Department Name *</Label>
                                                <Input
                                                  id="edit_dept_name"
                                                  value={newDepartment.name}
                                                  onChange={(e) => setNewDepartment({ ...newDepartment, name: e.target.value })}
                                                  placeholder="Enter department name"
                                                  className="mt-1"
                                                />
                                              </div>
                                              
                                              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                <div>
                                                  <Label htmlFor="edit_contact_person">Contact Person</Label>
                                                  <Input
                                                    id="edit_contact_person"
                                                    value={newDepartment.contact_person}
                                                    onChange={(e) => setNewDepartment({ ...newDepartment, contact_person: e.target.value })}
                                                    placeholder="Enter contact person name"
                                                    className="mt-1"
                                                  />
                                                </div>
                                                
                                                <div>
                                                  <Label htmlFor="edit_birthday">Birthday</Label>
                                                  <Input
                                                    id="edit_birthday"
                                                    type="date"
                                                    value={newDepartment.birthday}
                                                    onChange={(e) => setNewDepartment({ ...newDepartment, birthday: e.target.value })}
                                                    className="mt-1"
                                                  />
                                                </div>
                                                
                                                <div>
                                                  <Label htmlFor="edit_contact_number">Contact Number</Label>
                                                  <Input
                                                    id="edit_contact_number"
                                                    type="tel"
                                                    value={newDepartment.contact_number}
                                                    onChange={(e) => setNewDepartment({ ...newDepartment, contact_number: e.target.value })}
                                                    placeholder="Enter contact number"
                                                    className="mt-1"
                                                  />
                                                </div>
                                                
                                                <div>
                                                  <Label htmlFor="edit_email">Email</Label>
                                                  <Input
                                                    id="edit_email"
                                                    type="email"
                                                    value={newDepartment.email}
                                                    onChange={(e) => setNewDepartment({ ...newDepartment, email: e.target.value })}
                                                    placeholder="Enter email address"
                                                    className="mt-1"
                                                  />
                                                </div>
                                              </div>
                                              
                                              <div className="flex justify-end gap-2 pt-4">
                                                <Button
                                                  variant="outline"
                                                  onClick={() => {
                                                    setIsEditDepartmentModalOpen(false);
                                                    setEditingDepartment(null);
                                                    setNewDepartment({ name: '', contact_person: '', birthday: '', contact_number: '', email: '' });
                                                  }}
                                                >
                                                  Cancel
                                                </Button>
                                                <Button onClick={updateDepartment} className="bg-indigo-600 hover:bg-indigo-700">
                                                  Update Department
                                                </Button>
                                              </div>
                                            </div>
                                          </DialogContent>
                                        </Dialog>

                                        {/* Edit Machine Modal */}
                                        <Dialog open={isEditMachineModalOpen} onOpenChange={setIsEditMachineModalOpen}>
                                          <DialogContent>
                                            <DialogHeader>
                                              <DialogTitle>Edit Machine</DialogTitle>
                                              <DialogDescription>
                                                Update machine information for {selectedDepartmentForMachine?.name} department
                                              </DialogDescription>
                                            </DialogHeader>
                                            <div className="space-y-4">
                                              <div>
                                                <Label htmlFor="edit_machine_model">Machine Model *</Label>
                                                <Input
                                                  id="edit_machine_model"
                                                  value={newMachine.model}
                                                  onChange={(e) => setNewMachine({ ...newMachine, model: e.target.value })}
                                                  placeholder="Enter machine model"
                                                  className="mt-1"
                                                />
                                              </div>
                                              <div>
                                                <Label htmlFor="edit_serial_number">Serial Number *</Label>
                                                <Input
                                                  id="edit_serial_number"
                                                  value={newMachine.serialNumber}
                                                  onChange={(e) => setNewMachine({ ...newMachine, serialNumber: e.target.value })}
                                                  placeholder="Enter serial number"
                                                  className="mt-1"
                                                />
                                              </div>
                                              <div>
                                                <Label htmlFor="edit_date_installed">Date Installed *</Label>
                                                <Input
                                                  id="edit_date_installed"
                                                  type="date"
                                                  value={newMachine.dateInstalled}
                                                  onChange={(e) => setNewMachine({ ...newMachine, dateInstalled: e.target.value })}
                                                  className="mt-1"
                                                />
                                              </div>
                                              <div className="flex justify-end gap-2">
                                                <Button
                                                  variant="outline"
                                                  onClick={() => {
                                                    setIsEditMachineModalOpen(false);
                                                    setEditingMachine(null);
                                                    setSelectedDepartmentForMachine(null);
                                                    setNewMachine({ model: '', serialNumber: '', dateInstalled: '' });
                                                  }}
                                                >
                                                  Cancel
                                                </Button>
                                                <Button onClick={updateMachine} className="bg-green-600 hover:bg-green-700">
                                                  Update Machine
                                                </Button>
                                              </div>
                                            </div>
                                          </DialogContent>
                                        </Dialog>
                                      </div>
                                    );
                                  }

                                  // Project List View (default)
                                  return (
                                    <div className="space-y-6">
                                      {/* Header */}
                                      <div className="flex justify-between items-center">
                                        <div>
                                          <h2 className="text-2xl font-bold text-gray-900 dark:text-white">MPS - Project Management</h2>
                                          <p className="text-gray-600 dark:text-gray-200">Create and manage all projects</p>
                                        </div>
                                        <div className="text-sm text-gray-500 dark:text-gray-300">
                                          {currentDateTime}
                                        </div>
                                      </div>

                                      {/* Create New Project Button */}
                                      <div className="flex justify-start">
                                        <Button
                                          onClick={() => setIsCreateProjectModalOpen(true)}
                                          className="bg-indigo-600 hover:bg-indigo-700"
                                          size="lg"
                                        >
                                          <Plus className="h-5 w-5 mr-2" />
                                          Create New Project
                                        </Button>
                                      </div>

                                      {/* Scrollable Projects Section */}
                                      <Card className="glass shadow-lg border-0">
                                        <CardHeader>
                                          <CardTitle>All Projects</CardTitle>
                                          <CardDescription>Manage and monitor all your projects</CardDescription>
                                        </CardHeader>
                                        <CardContent>
                                          <div className="overflow-y-auto max-h-[600px]">
                                            {projects.length === 0 ? (
                                              <div className="text-center py-12">
                                                <FileText className="h-16 w-16 text-gray-400 mx-auto mb-4" />
                                                <p className="text-gray-500 dark:text-gray-300">No projects yet. Create your first project to get started.</p>
                                              </div>
                                            ) : (
                                              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                                                {projects.map((project) => (
                                                  <Card 
                                                    key={project.id} 
                                                    className="border-2 border-gray-200 hover:border-indigo-400 hover:shadow-lg transition-all cursor-pointer"
                                                    onClick={() => handleProjectClick(project)}
                                                  >
                                                    <CardContent className="p-4">
                                                      <div className="flex justify-between items-start mb-3">
                                                        <h3 className="font-semibold text-gray-900 dark:text-white text-lg line-clamp-1">{project.title || project.name}</h3>
                                                        <div className="flex gap-1">
                                                          <Button
                                                            variant="ghost"
                                                            size="sm"
                                                            onClick={(e) => handleEditProject(project, e)}
                                                            className="h-6 w-6 p-0 text-blue-600 hover:text-blue-800"
                                                          >
                                                            <Edit className="h-4 w-4" />
                                                          </Button>
                                                          <Button
                                                            variant="ghost"
                                                            size="sm"
                                                            onClick={(e) => handleDeleteProject(project.id, e)}
                                                            className="h-6 w-6 p-0 text-red-600 hover:text-red-800"
                                                          >
                                                            <Trash2 className="h-4 w-4" />
                                                          </Button>
                                                        </div>
                                                      </div>
                                                      
                                                      {/* Account Name */}
                                                      {project.accountName && (
                                                        <p className="text-sm text-gray-700 dark:text-gray-100 mb-2">
                                                          <span className="font-medium">Account:</span> {project.accountName}
                                                        </p>
                                                      )}
                                                      
                                                      {/* Company Address */}
                                                      {project.companyAddress && (
                                                        <p className="text-xs text-gray-600 dark:text-gray-200 mb-2 line-clamp-2">
                                                          &#55357;&#56525; {project.companyAddress}
                                                        </p>
                                                      )}
                                                      
                                                      <div className="space-y-2 mt-3">
                                                        {/* Status */}
                                                        <div className="flex items-center justify-between">
                                                          <span className="text-xs text-gray-500 dark:text-gray-300">Status:</span>
                                                          <span className={`text-xs font-medium px-2 py-1 rounded-full ${
                                                            project.status === 'Complete' ? 'bg-blue-100 text-blue-800' :
                                                            project.status === 'Running' ? 'bg-green-100 text-green-800' :
                                                            project.status === 'Pending' ? 'bg-yellow-100 text-yellow-800' :
                                                            'bg-gray-100 text-gray-800 dark:text-white'
                                                          }`}>
                                                            {project.status}
                                                          </span>
                                                        </div>
                                                        
                                                        {/* Contact Person */}
                                                        {project.contactPersons && project.contactPersons.filter(p => p).length > 0 && (
                                                          <div className="text-xs text-gray-600 dark:text-gray-200">
                                                            <span className="font-medium">Contact:</span> {project.contactPersons.filter(p => p)[0]}
                                                            {project.contactPersons.filter(p => p).length > 1 && (
                                                              <span className="text-indigo-600"> +{project.contactPersons.filter(p => p).length - 1} more</span>
                                                            )}
                                                          </div>
                                                        )}
                                                        
                                                        {/* Contact Details */}
                                                        {project.contactDetails && project.contactDetails.filter(d => d).length > 0 && (
                                                          <div className="text-xs text-gray-600 dark:text-gray-200">
                                                            &#55357;&#56542; {project.contactDetails.filter(d => d)[0]}
                                                          </div>
                                                        )}
                                                        
                                                        {/* Email */}
                                                        {project.emailAddresses && project.emailAddresses.filter(e => e).length > 0 && (
                                                          <div className="text-xs text-gray-600 dark:text-gray-200 truncate">
                                                            &#9993;&#65039; {project.emailAddresses.filter(e => e)[0]}
                                                          </div>
                                                        )}
                                                        
                                                        {/* Dates */}
                                                        {project.startDate && (
                                                          <div className="flex items-center justify-between text-xs text-gray-500 dark:text-gray-300 pt-2 border-t">
                                                            <span>Start:</span>
                                                            <span>{new Date(project.startDate).toLocaleDateString()}</span>
                                                          </div>
                                                        )}
                                                      </div>
                                                    </CardContent>
                                                  </Card>
                                                ))}
                                              </div>
                                            )}
                                          </div>
                                        </CardContent>
                                      </Card>

                                      {/* Create Project Modal */}
                                      <Dialog open={isCreateProjectModalOpen} onOpenChange={setIsCreateProjectModalOpen}>
                                        <DialogContent className="sm:max-w-[600px] max-h-[90vh] overflow-y-auto">
                                          <DialogHeader>
                                            <DialogTitle>Create New Project</DialogTitle>
                                            <DialogDescription>Fill in the project details below</DialogDescription>
                                          </DialogHeader>
                                          <div className="space-y-4 py-4">
                                            <div>
                                              <Label>Project Title *</Label>
                                              <Input
                                                value={newProject.title}
                                                onChange={(e) => setNewProject({...newProject, title: e.target.value})}
                                                placeholder="Enter project title"
                                                required
                                              />
                                            </div>
                                            
                                            <div>
                                              <Label>Account Name *</Label>
                                              <Input
                                                value={newProject.accountName}
                                                onChange={(e) => setNewProject({...newProject, accountName: e.target.value})}
                                                placeholder="Enter account name"
                                                required
                                              />
                                            </div>
                                            
                                            <div>
                                              <Label>Company Address *</Label>
                                              <textarea
                                                value={newProject.companyAddress}
                                                onChange={(e) => setNewProject({...newProject, companyAddress: e.target.value})}
                                                placeholder="Enter company address"
                                                className="w-full min-h-[60px] px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                required
                                              />
                                            </div>
                                            
                                            <div>
                                              <Label>Billing Statement Code</Label>
                                              <Input
                                                value={newProject.billingStatementCode}
                                                onChange={(e) => setNewProject({...newProject, billingStatementCode: e.target.value})}
                                                placeholder="Enter billing statement code (e.g., BS-2024-001)"
                                              />
                                            </div>
                                            
                                            <div className="grid grid-cols-2 gap-4">
                                              <div>
                                                <Label>Project Start Date</Label>
                                                <Input
                                                  type="date"
                                                  value={newProject.startDate}
                                                  onChange={(e) => setNewProject({...newProject, startDate: e.target.value})}
                                                />
                                              </div>
                                              <div>
                                                <Label>Project End Date</Label>
                                                <Input
                                                  type="date"
                                                  value={newProject.endDate}
                                                  onChange={(e) => setNewProject({...newProject, endDate: e.target.value})}
                                                />
                                              </div>
                                            </div>

                                            {/* Contact Persons */}
                                            <div>
                                              <div className="flex justify-between items-center mb-2">
                                                <Label>Contact Person *</Label>
                                                <Button
                                                  type="button"
                                                  variant="outline"
                                                  size="sm"
                                                  onClick={addContactPerson}
                                                >
                                                  <Plus className="h-3 w-3 mr-1" />
                                                  Add Contact Person
                                                </Button>
                                              </div>
                                              {newProject.contactPersons.map((person, index) => (
                                                <div key={index} className="flex gap-2 mb-2">
                                                  <Input
                                                    value={person}
                                                    onChange={(e) => updateContactPerson(index, e.target.value)}
                                                    placeholder="Enter contact person name"
                                                    className="flex-1"
                                                    required
                                                  />
                                                  {newProject.contactPersons.length > 1 && (
                                                    <Button
                                                      type="button"
                                                      variant="ghost"
                                                      size="sm"
                                                      onClick={() => removeContactPerson(index)}
                                                      className="text-red-600"
                                                    >
                                                      <Trash2 className="h-4 w-4" />
                                                    </Button>
                                                  )}
                                                </div>
                                              ))}
                                            </div>

                                            {/* Contact Details */}
                                            <div>
                                              <div className="flex justify-between items-center mb-2">
                                                <Label>Contact Details *</Label>
                                                <Button
                                                  type="button"
                                                  variant="outline"
                                                  size="sm"
                                                  onClick={addContactDetail}
                                                >
                                                  <Plus className="h-3 w-3 mr-1" />
                                                  Add Contact Details
                                                </Button>
                                              </div>
                                              {newProject.contactDetails.map((detail, index) => (
                                                <div key={index} className="flex gap-2 mb-2">
                                                  <Input
                                                    value={detail}
                                                    onChange={(e) => updateContactDetail(index, e.target.value)}
                                                    placeholder="Enter contact details (phone, mobile, etc.)"
                                                    className="flex-1"
                                                    required
                                                  />
                                                  {newProject.contactDetails.length > 1 && (
                                                    <Button
                                                      type="button"
                                                      variant="ghost"
                                                      size="sm"
                                                      onClick={() => removeContactDetail(index)}
                                                      className="text-red-600"
                                                    >
                                                      <Trash2 className="h-4 w-4" />
                                                    </Button>
                                                  )}
                                                </div>
                                              ))}
                                            </div>

                                            {/* Email Addresses */}
                                            <div>
                                              <div className="flex justify-between items-center mb-2">
                                                <Label>Email Address *</Label>
                                                <Button
                                                  type="button"
                                                  variant="outline"
                                                  size="sm"
                                                  onClick={addEmailAddress}
                                                >
                                                  <Plus className="h-3 w-3 mr-1" />
                                                  Add Email Address
                                                </Button>
                                              </div>
                                              {newProject.emailAddresses.map((email, index) => (
                                                <div key={index} className="flex gap-2 mb-2">
                                                  <Input
                                                    type="email"
                                                    value={email}
                                                    onChange={(e) => updateEmailAddress(index, e.target.value)}
                                                    placeholder="Enter email address"
                                                    className="flex-1"
                                                    required
                                                  />
                                                  {newProject.emailAddresses.length > 1 && (
                                                    <Button
                                                      type="button"
                                                      variant="ghost"
                                                      size="sm"
                                                      onClick={() => removeEmailAddress(index)}
                                                      className="text-red-600"
                                                    >
                                                      <Trash2 className="h-4 w-4" />
                                                    </Button>
                                                  )}
                                                </div>
                                              ))}
                                            </div>
                                          </div>
                                          
                                          <div className="flex justify-end space-x-2 pt-4 border-t">
                                            <Button
                                              variant="outline"
                                              onClick={() => {
                                                setIsCreateProjectModalOpen(false);
                                                setNewProject({
                                                  title: '',
                                                  accountName: '',
                                                  companyAddress: '',
                                                  contactPersons: [''],
                                                  contactDetails: [''],
                                                  emailAddresses: [''],
                                                  status: 'Planning',
                                                  startDate: '',
                                                  endDate: ''
                                                });
                                              }}
                                            >
                                              Cancel
                                            </Button>
                                            <Button
                                              onClick={handleCreateProject}
                                              className="bg-indigo-600 hover:bg-indigo-700"
                                            >
                                              Create Project
                                            </Button>
                                          </div>
                                        </DialogContent>
                                      </Dialog>
                                      
                                      {/* Edit Project Modal */}
                                      {editingProject && (
                                        <Dialog open={isEditProjectModalOpen} onOpenChange={setIsEditProjectModalOpen}>
                                          <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
                                            <DialogHeader>
                                              <DialogTitle>Edit Project</DialogTitle>
                                              <DialogDescription>Update the project details below</DialogDescription>
                                            </DialogHeader>
                                            <div className="space-y-4 py-4">
                                              <div>
                                                <Label>Project Title *</Label>
                                                <Input
                                                  value={editingProject.title}
                                                  onChange={(e) => setEditingProject({...editingProject, title: e.target.value})}
                                                  placeholder="Enter project title"
                                                  required
                                                />
                                              </div>
                                              
                                              <div>
                                                <Label>Account Name *</Label>
                                                <Input
                                                  value={editingProject.accountName}
                                                  onChange={(e) => setEditingProject({...editingProject, accountName: e.target.value})}
                                                  placeholder="Enter account name"
                                                  required
                                                />
                                              </div>
                                              
                                              <div>
                                                <Label>Company Address *</Label>
                                                <textarea
                                                  value={editingProject.companyAddress}
                                                  onChange={(e) => setEditingProject({...editingProject, companyAddress: e.target.value})}
                                                  placeholder="Enter company address"
                                                  className="w-full min-h-[60px] px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                  required
                                                />
                                              </div>
                                              
                                              <div>
                                                <Label>Billing Statement Code</Label>
                                                <Input
                                                  value={editingProject.billingStatementCode}
                                                  onChange={(e) => setEditingProject({...editingProject, billingStatementCode: e.target.value})}
                                                  placeholder="Enter billing statement code"
                                                />
                                              </div>
                                              
                                              <div className="grid grid-cols-2 gap-4">
                                                <div>
                                                  <Label>Project Start Date</Label>
                                                  <Input
                                                    type="date"
                                                    value={editingProject.startDate}
                                                    onChange={(e) => setEditingProject({...editingProject, startDate: e.target.value})}
                                                  />
                                                </div>
                                                <div>
                                                  <Label>Project End Date</Label>
                                                  <Input
                                                    type="date"
                                                    value={editingProject.endDate}
                                                    onChange={(e) => setEditingProject({...editingProject, endDate: e.target.value})}
                                                  />
                                                </div>
                                              </div>

                                              <div>
                                                <div className="flex justify-between items-center mb-2">
                                                  <Label>Contact Person *</Label>
                                                  <Button
                                                    type="button"
                                                    variant="outline"
                                                    size="sm"
                                                    onClick={addEditContactPerson}
                                                  >
                                                    <Plus className="h-3 w-3 mr-1" />
                                                    Add
                                                  </Button>
                                                </div>
                                                {editingProject.contactPersons.map((person, index) => (
                                                  <div key={index} className="flex gap-2 mb-2">
                                                    <Input
                                                      value={person}
                                                      onChange={(e) => updateEditContactPerson(index, e.target.value)}
                                                      placeholder="Enter contact person name"
                                                      className="flex-1"
                                                    />
                                                    {editingProject.contactPersons.length > 1 && (
                                                      <Button
                                                        type="button"
                                                        variant="ghost"
                                                        size="sm"
                                                        onClick={() => removeEditContactPerson(index)}
                                                        className="text-red-600"
                                                      >
                                                        <Trash2 className="h-4 w-4" />
                                                      </Button>
                                                    )}
                                                  </div>
                                                ))}
                                              </div>

                                              <div>
                                                <div className="flex justify-between items-center mb-2">
                                                  <Label>Contact Details *</Label>
                                                  <Button
                                                    type="button"
                                                    variant="outline"
                                                    size="sm"
                                                    onClick={addEditContactDetail}
                                                  >
                                                    <Plus className="h-3 w-3 mr-1" />
                                                    Add
                                                  </Button>
                                                </div>
                                                {editingProject.contactDetails.map((detail, index) => (
                                                  <div key={index} className="flex gap-2 mb-2">
                                                    <Input
                                                      value={detail}
                                                      onChange={(e) => updateEditContactDetail(index, e.target.value)}
                                                      placeholder="Enter contact details"
                                                      className="flex-1"
                                                    />
                                                    {editingProject.contactDetails.length > 1 && (
                                                      <Button
                                                        type="button"
                                                        variant="ghost"
                                                        size="sm"
                                                        onClick={() => removeEditContactDetail(index)}
                                                        className="text-red-600"
                                                      >
                                                        <Trash2 className="h-4 w-4" />
                                                      </Button>
                                                    )}
                                                  </div>
                                                ))}
                                              </div>

                                              <div>
                                                <div className="flex justify-between items-center mb-2">
                                                  <Label>Email Address *</Label>
                                                  <Button
                                                    type="button"
                                                    variant="outline"
                                                    size="sm"
                                                    onClick={addEditEmailAddress}
                                                  >
                                                    <Plus className="h-3 w-3 mr-1" />
                                                    Add
                                                  </Button>
                                                </div>
                                                {editingProject.emailAddresses.map((email, index) => (
                                                  <div key={index} className="flex gap-2 mb-2">
                                                    <Input
                                                      value={email}
                                                      onChange={(e) => updateEditEmailAddress(index, e.target.value)}
                                                      placeholder="Enter email address"
                                                      type="email"
                                                      className="flex-1"
                                                    />
                                                    {editingProject.emailAddresses.length > 1 && (
                                                      <Button
                                                        type="button"
                                                        variant="ghost"
                                                        size="sm"
                                                        onClick={() => removeEditEmailAddress(index)}
                                                        className="text-red-600"
                                                      >
                                                        <Trash2 className="h-4 w-4" />
                                                      </Button>
                                                    )}
                                                  </div>
                                                ))}
                                              </div>
                                            </div>
                                            
                                            <div className="flex justify-end gap-2 pt-4 border-t">
                                              <Button
                                                variant="outline"
                                                onClick={() => {
                                                  setIsEditProjectModalOpen(false);
                                                  setEditingProject(null);
                                                }}
                                              >
                                                Cancel
                                              </Button>
                                              <Button
                                                onClick={updateProject}
                                                className="bg-indigo-600 hover:bg-indigo-700"
                                              >
                                                Update Project
                                              </Button>
                                            </div>
                                          </DialogContent>
                                        </Dialog>
                                      )}
                                    </div>
                                  );
                                };






  const handleExportPDF = async () => {
    const element = document.getElementById('sales-performance-report');
    if (!element) {
      toast.error('Report content not found');
      return;
    }

    try {
      const accountName = selectedSalesAccount?.admin_name || 'Account';
      
      // Create a clone to manipulate styles for full capture
      const clone = element.cloneNode(true);

      // Copy values from original inputs to cloned inputs and replace them with spans/divs for better rendering
      const originalInputs = element.querySelectorAll('input, textarea, select');
      const clonedInputs = clone.querySelectorAll('input, textarea, select');

      for (let i = 0; i < originalInputs.length; i++) {
         const originalInput = originalInputs[i];
         const clonedInput = clonedInputs[i];

         if (originalInput.type === 'checkbox' || originalInput.type === 'radio') {
            clonedInput.checked = originalInput.checked;
            if (originalInput.checked) clonedInput.setAttribute('checked', '');
         } else {
            // Create a span to replace the input
            const span = document.createElement('span');
            span.innerText = originalInput.value;
            
            // Copy styles
            const computedStyle = window.getComputedStyle(originalInput);
            span.style.display = 'flex';
            span.style.alignItems = 'center';
            span.style.justifyContent = computedStyle.textAlign === 'center' ? 'center' : (computedStyle.textAlign === 'right' ? 'flex-end' : 'flex-start');
            span.style.width = '100%';
            span.style.height = '100%';
            span.style.padding = computedStyle.padding;
            span.style.fontFamily = computedStyle.fontFamily;
            span.style.fontSize = computedStyle.fontSize;
            span.style.fontWeight = computedStyle.fontWeight;
            span.style.color = computedStyle.color;
            span.style.backgroundColor = 'transparent'; // Remove background to blend in
            span.style.whiteSpace = 'pre-wrap'; // For textarea content
            
            if (clonedInput.parentNode) {
                clonedInput.parentNode.replaceChild(span, clonedInput);
            }
         }
      }
      
      // Remove no-print elements from clone
      const noPrints = clone.querySelectorAll('.no-print');
      noPrints.forEach(el => el.remove());
      
      // Set styles to ensure full width capture
      clone.style.width = 'fit-content';
      clone.style.height = 'auto';
      clone.style.overflow = 'visible';
      clone.style.position = 'absolute';
      clone.style.top = '-9999px';
      clone.style.left = '0px'; // Keep left 0 to avoid layout issues
      clone.style.zIndex = '-1';
      
      // We need to append clone to document to capture it
      document.body.appendChild(clone);
      
      const canvas = await html2canvas(clone, {
        scale: 2,
        useCORS: true,
        logging: false,
        windowWidth: clone.scrollWidth,
        windowHeight: clone.scrollHeight
      });
      
      // Remove clone
      document.body.removeChild(clone);

      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('landscape', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgProps = pdf.getImageProperties(imgData);
      const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;

      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
      heightLeft -= pdfHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
        heightLeft -= pdfHeight;
      }

      pdf.save(`${accountName}_Sales_Performance_Report.pdf`);
      toast.success('PDF exported successfully');
    } catch (error) {
      console.error('Error exporting PDF:', error);
      toast.error('Failed to export PDF');
    }
  };

  const handleExportExcel = () => {
    const currentYear = new Date().getFullYear();
    const annualTarget = selectedSalesAccount?.annual_target || 0;
    const semiAnnualTarget = annualTarget / 2;
    const quarterlyTarget = annualTarget / 4;
    const monthlyTarget = annualTarget / 12;
    const accountName = selectedSalesAccount?.admin_name || 'Account';

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-PH', { style: 'currency', currency: 'PHP' }).format(amount);
    };
    const formatPercentage = (val) => {
        return val !== undefined && !isNaN(val) ? `${val.toFixed(2)}%` : '-';
    };

    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const monthlyActuals = {};
    months.forEach(m => monthlyActuals[m] = 0);
    
    if (selectedSalesAccount?.transactions) {
        selectedSalesAccount.transactions.forEach(t => {
        if (t.sales_invoice_date && t.net_sales) {
            const date = new Date(t.sales_invoice_date);
            if (!isNaN(date.getTime())) {
            const monthName = months[date.getMonth()];
            if (monthName) {
                monthlyActuals[monthName] += (parseFloat(t.net_sales) || 0);
            }
            }
        }
        });
    }

    const quarters = ['Q1', 'Q2', 'Q3', 'Q4'];
    const quarterData = quarters.map((q) => {
        let qMonths = [];
        if (q === 'Q1') qMonths = ['January', 'February', 'March'];
        else if (q === 'Q2') qMonths = ['April', 'May', 'June'];
        else if (q === 'Q3') qMonths = ['July', 'August', 'September'];
        else if (q === 'Q4') qMonths = ['October', 'November', 'December'];

        const actual = qMonths.reduce((sum, month) => sum + (monthlyActuals[month] || 0), 0);
        const deficit = quarterlyTarget - actual;
        const ar = quarterlyTarget > 0 ? (actual / quarterlyTarget) * 100 : 0;
        return { q, actual, deficit, ar };
    });

    const processedQuarterData = quarterData.map((data, index) => {
        let adjustedTargetMonth = monthlyTarget;
        let adjustedTargetQuarter = quarterlyTarget;

        if (index > 0) {
            const prevDeficit = quarterData[index - 1].deficit;
            adjustedTargetQuarter = quarterlyTarget + prevDeficit;
            adjustedTargetMonth = monthlyTarget + (prevDeficit / 3);
        }
        return { ...data, adjustedTargetMonth, adjustedTargetQuarter };
    });

    const totalActual = Object.values(monthlyActuals).reduce((sum, val) => sum + (val || 0), 0);
    const totalTarget = monthlyTarget * 12;
    const totalDeficit = totalTarget - totalActual;
    const totalPercentage = totalTarget > 0 ? (totalActual / totalTarget) * 100 : 0;

    let html = `
      <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <meta http-equiv="content-type" content="text/vnd.ms-excel; charset=UTF-8">
        <!--[if gte mso 9]>
        <xml>
        <x:ExcelWorkbook>
          <x:ExcelWorksheets>
            <x:ExcelWorksheet>
              <x:Name>Sales Performance Report</x:Name>
              <x:WorksheetOptions>
                <x:DisplayGridlines/>
              </x:WorksheetOptions>
            </x:ExcelWorksheet>
          </x:ExcelWorksheets>
        </x:ExcelWorkbook>
        </xml>
        <![endif]-->
        <style>
          table { border-collapse: collapse; width: 100%; font-family: Arial, sans-serif; }
          th, td { border: 1px solid #000; padding: 5px; font-size: 10pt; }
          .header { background-color: #1e3a8a; color: white; font-weight: bold; text-align: center; }
          .text-red { color: red; }
          .text-green { color: green; }
          .text-center { text-align: center; }
          .text-right { text-align: right; }
          .bold { font-weight: bold; }
          .title { font-size: 14pt; font-weight: bold; text-align: center; margin-bottom: 20px; }
        </style>
      </head>
      <body>
        <div class="title" style="font-size: 16pt;">${accountName}</div>
        <div class="title" style="font-size: 20pt;">${currentYear} SALES TARGET</div>
        <br/>
        
        <table>
          <tr class="header">
            <th style="background-color: #1e3a8a; color: white;">ANNUAL TARGET</th>
            <th style="background-color: #1e3a8a; color: white;">SEMI ANNUAL</th>
            <th style="background-color: #1e3a8a; color: white;">QUARTERLY</th>
            <th style="background-color: #1e3a8a; color: white;">MONTHLY TARGET</th>
          </tr>
          <tr>
            <td class="text-center">${formatCurrency(annualTarget)}</td>
            <td class="text-center">${formatCurrency(semiAnnualTarget)}</td>
            <td class="text-center">${formatCurrency(quarterlyTarget)}</td>
            <td class="text-center">${formatCurrency(monthlyTarget)}</td>
          </tr>
        </table>
        <br/>

        <table>
            <tr>
                <td valign="top">
                    <table>
                        <tr class="header">
                            <th style="background-color: #1e3a8a; color: white;"></th>
                            <th style="background-color: #1e3a8a; color: white;">TARGET</th>
                            <th style="background-color: #1e3a8a; color: white;">ACTUAL</th>
                            <th style="background-color: #1e3a8a; color: white;">DEFICIT</th>
                            <th style="background-color: #1e3a8a; color: white;">PERCENTAGE</th>
                        </tr>
                        ${months.map((month, index) => {
                            let currentMonthlyTarget = monthlyTarget;
                             if (index >= 3 && index <= 5) currentMonthlyTarget += (quarterData[0].deficit / 3);
                             else if (index >= 6 && index <= 8) currentMonthlyTarget += (quarterData[1].deficit / 3);
                             else if (index >= 9 && index <= 11) currentMonthlyTarget += (quarterData[2].deficit / 3);

                             const actual = monthlyActuals[month] || 0;
                             const deficit = currentMonthlyTarget - actual;
                             const percentage = currentMonthlyTarget > 0 ? (actual / currentMonthlyTarget) * 100 : 0;
                             const deficitClass = deficit > 0 ? 'text-red' : 'text-green';
                             const deficitColor = deficit > 0 ? 'red' : 'green';

                             return `
                                <tr>
                                    <td class="text-right">${month}</td>
                                    <td>${formatCurrency(currentMonthlyTarget)}</td>
                                    <td>${formatCurrency(actual)}</td>
                                    <td class="${deficitClass}" style="color: ${deficitColor};">${formatCurrency(deficit)}</td>
                                    <td>${formatPercentage(percentage)}</td>
                                </tr>
                             `;
                        }).join('')}
                        <tr class="header">
                            <td style="background-color: #1e3a8a; color: white;">TOTAL</td>
                            <td style="background-color: #1e3a8a; color: white;">${formatCurrency(totalTarget)}</td>
                            <td style="background-color: #1e3a8a; color: white;">${formatCurrency(totalActual)}</td>
                            <td style="background-color: #1e3a8a; color: white;">${formatCurrency(totalDeficit)}</td>
                            <td style="background-color: #1e3a8a; color: white;">${formatPercentage(totalPercentage)}</td>
                        </tr>
                    </table>
                </td>
                <td></td>
                <td valign="top">
                    <table>
                        <tr class="header">
                            <th style="background-color: #1e3a8a; color: white;"></th>
                            <th style="background-color: #1e3a8a; color: white;">ACTUAL PERFORMANCE</th>
                            <th style="background-color: #1e3a8a; color: white;">AR</th>
                            <th style="background-color: #1e3a8a; color: white;">ADJUSTED TARGET PER MONTH</th>
                            <th style="background-color: #1e3a8a; color: white;">ADJUSTED TARGET PER QUARTER</th>
                            <th style="background-color: #1e3a8a; color: white;">DEFICIT</th>
                        </tr>
                        ${processedQuarterData.map(row => {
                            const deficitColor = row.deficit > 0 ? 'red' : 'green';
                            return `
                            <tr>
                                <td class="bold">${row.q}</td>
                                <td>${formatCurrency(row.actual)}</td>
                                <td>${formatPercentage(row.ar)}</td>
                                <td>${formatCurrency(row.adjustedTargetMonth)}</td>
                                <td>${formatCurrency(row.adjustedTargetQuarter)}</td>
                                <td style="color: ${deficitColor};">${formatCurrency(row.deficit)}</td>
                            </tr>
                        `}).join('')}
                    </table>
                </td>
            </tr>
        </table>
        <br/>

        <div class="title" style="font-size: 14pt;">SALES PERFORMANCE DETAILS</div>
        <br/>
        
        <table>
            <tr class="header">
                <th style="background-color: #1e3a8a; color: white;">SALES INVOICE DATE</th>
                <th style="background-color: #1e3a8a; color: white;">SALES INVOICE NUMBER</th>
                <th style="background-color: #1e3a8a; color: white;">ACCOUNT NAME</th>
                <th style="background-color: #1e3a8a; color: white;">ITEM DESCRIPTION</th>
                <th style="background-color: #1e3a8a; color: white;">QUANTITY</th>
                <th style="background-color: #1e3a8a; color: white;">AMOUNT</th>
                <th style="background-color: #1e3a8a; color: white;">TOTAL AMOUNT</th>
                <th style="background-color: #1e3a8a; color: white;">MARKETING FUNDS</th>
                <th style="background-color: #1e3a8a; color: white;">NET SALES (Actual Sales)</th>
                <th style="background-color: #1e3a8a; color: white;">COLLECTION RECEIPT DATE</th>
                <th style="background-color: #1e3a8a; color: white;">COLLECTION RECEIPT NO.</th>
                <th style="background-color: #1e3a8a; color: white;">AMOUNT COLLECTED</th>
                <th style="background-color: #1e3a8a; color: white;">1% WHT</th>
                <th style="background-color: #1e3a8a; color: white;">5% WHT</th>
                <th style="background-color: #1e3a8a; color: white;">RETENTION</th>
                <th style="background-color: #1e3a8a; color: white;">OTHERS</th>
                <th style="background-color: #1e3a8a; color: white;">TOTAL</th>
                <th style="background-color: #1e3a8a; color: white;">REMARKS</th>
            </tr>
            ${selectedSalesAccount?.transactions?.map(t => `
                <tr>
                    <td>${t.sales_invoice_date || ''}</td>
                    <td>${t.sales_invoice_number || ''}</td>
                    <td>${t.account_name || ''}</td>
                    <td>${t.item_description || ''}</td>
                    <td>${t.quantity || ''}</td>
                    <td>${t.amount || ''}</td>
                    <td>${t.total_amount || ''}</td>
                    <td>${t.marketing_funds || ''}</td>
                    <td>${t.net_sales || ''}</td>
                    <td>${t.collection_receipt_date || ''}</td>
                    <td>${t.collection_receipt_no || ''}</td>
                    <td>${t.amount_collected || ''}</td>
                    <td>${t.wht_1_percent || ''}</td>
                    <td>${t.wht_5_percent || ''}</td>
                    <td>${t.retention || ''}</td>
                    <td>${t.others || ''}</td>
                    <td>${t.total || ''}</td>
                    <td>${t.remarks || ''}</td>
                </tr>
            `).join('') || ''}
             <tr class="header">
                <td colspan="6" style="background-color: #1e3a8a; color: white;">TOTAL</td>
                <td style="background-color: #1e3a8a; color: white;">${formatCurrency(selectedSalesAccount?.transactions?.reduce((sum, t) => sum + (parseFloat(t.total_amount)||0), 0) || 0)}</td>
                <td style="background-color: #1e3a8a; color: white;">${formatCurrency(selectedSalesAccount?.transactions?.reduce((sum, t) => sum + (parseFloat(t.marketing_funds)||0), 0) || 0)}</td>
                <td style="background-color: #1e3a8a; color: white;">${formatCurrency(selectedSalesAccount?.transactions?.reduce((sum, t) => sum + (parseFloat(t.net_sales)||0), 0) || 0)}</td>
                <td colspan="2" style="background-color: #1e3a8a; color: white;"></td>
                <td style="background-color: #1e3a8a; color: white;">${formatCurrency(selectedSalesAccount?.transactions?.reduce((sum, t) => sum + (parseFloat(t.amount_collected)||0), 0) || 0)}</td>
                <td style="background-color: #1e3a8a; color: white;">${formatCurrency(selectedSalesAccount?.transactions?.reduce((sum, t) => sum + (parseFloat(t.wht_1_percent)||0), 0) || 0)}</td>
                <td style="background-color: #1e3a8a; color: white;">${formatCurrency(selectedSalesAccount?.transactions?.reduce((sum, t) => sum + (parseFloat(t.wht_5_percent)||0), 0) || 0)}</td>
                <td style="background-color: #1e3a8a; color: white;">${formatCurrency(selectedSalesAccount?.transactions?.reduce((sum, t) => sum + (parseFloat(t.retention)||0), 0) || 0)}</td>
                <td style="background-color: #1e3a8a; color: white;">${formatCurrency(selectedSalesAccount?.transactions?.reduce((sum, t) => sum + (parseFloat(t.others)||0), 0) || 0)}</td>
                <td style="background-color: #1e3a8a; color: white;">${formatCurrency(selectedSalesAccount?.transactions?.reduce((sum, t) => sum + (parseFloat(t.total)||0), 0) || 0)}</td>
                <td style="background-color: #1e3a8a; color: white;"></td>
             </tr>
        </table>
      </body>
      </html>
    `;

    const blob = new Blob([html], { type: 'application/vnd.ms-excel' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${accountName}_Sales_Performance_Report.xls`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExportBluePrintExcel = () => {
    if (!selectedBluePrintAccount || !bluePrintRows) {
        toast.error('No blueprint data to export');
        return;
    }

    // Calculate totals
    const totalQty = bluePrintRows.reduce((sum, row) => sum + (parseFloat(row.quantity) || 0), 0);
    const totalUnitAmount = bluePrintRows.reduce((sum, row) => sum + (parseFloat(String(row.amount_per_qty).replace(/,/g, '')) || 0), 0);
    const totalAmount = bluePrintRows.reduce((sum, row) => sum + (parseFloat(String(row.total_amount).replace(/,/g, '')) || 0), 0);

    const tableHTML = `
      <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">
        <!--[if gte mso 9]>
        <xml>
        <x:ExcelWorkbook>
          <x:ExcelWorksheets>
            <x:ExcelWorksheet>
              <x:Name>Sheet1</x:Name>
              <x:WorksheetOptions>
                <x:DisplayGridlines/>
              </x:WorksheetOptions>
            </x:ExcelWorksheet>
          </x:ExcelWorksheets>
        </x:ExcelWorkbook>
        </xml>
        <![endif]-->
        <style>
            table { border-collapse: collapse; width: 100%; font-family: Arial, sans-serif; font-size: 11px; }
            th { background-color: #1e3a8a; color: white; border: 1px solid #1e3a8a; padding: 4px; text-align: center; vertical-align: middle; }
            td { border: 1px solid #e5e7eb; padding: 4px; text-align: center; vertical-align: middle; white-space: pre-wrap; }
            .header-title { font-size: 19px; font-weight: bold; text-align: center; margin-bottom: 10px; }
            .sub-title { font-size: 13px; color: #666; text-align: center; margin-bottom: 20px; }
            .total-row td { background-color: #1e3a8a; color: white; font-weight: bold; }
        </style>
      </head>
      <body>
        <div class="header-title">SALES BLUE PRINT 2026</div>
        <div class="sub-title">${selectedBluePrintAccount.account_name || ''} - Blue Print Details</div>
        <br/>
        <table>
          <thead>
            <tr>
              <th>Account name</th>
              <th>Account Details</th>
              <th>Machines</th>
              <th>Machine Category</th>
              <th>Quantity</th>
              <th>Amount per Qty.</th>
              <th>Total Amount</th>
              <th>Target Delivery Date</th>
              <th>Status</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            ${bluePrintRows.map(row => {
              const amount = parseFloat(String(row.amount_per_qty).replace(/,/g, '')) || 0;
              const total = parseFloat(String(row.total_amount).replace(/,/g, '')) || 0;
              return `
              <tr>
                <td>${row.account_name || ''}</td>
                <td>${row.account_details || ''}</td>
                <td>${row.machines || ''}</td>
                <td>${row.machine_category || ''}</td>
                <td>${row.quantity || ''}</td>
                <td>${amount.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</td>
                <td>${total.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</td>
                <td>${row.target_delivery_date || ''}</td>
                <td>${row.status || ''}</td>
                <td>${row.remarks || ''}</td>
              </tr>
            `}).join('')}
            <tr class="total-row" data-blueprint-summary="true">
              <td>${bluePrintRows.length}</td>
              <td colspan="3"></td>
              <td>${totalQty}</td>
              <td>${totalUnitAmount.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</td>
              <td>${totalAmount.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</td>
              <td colspan="3"></td>
            </tr>
          </tbody>
        </table>
      </body>
      </html>
    `;

    const blob = new Blob([tableHTML], { type: 'application/vnd.ms-excel' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `blue-print-${selectedBluePrintAccount.account_name || 'details'}.xls`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    toast.success('Excel exported successfully');
  };

  const handleAddFilter = () => {
    setExportFilters([...exportFilters, '']);
  };

  const handleOpenMachineSelection = (index) => {
    setCurrentFilterIndex(index);
    setIsMachineSelectionModalOpen(true);
  };

  const handleSelectMachine = (machine) => {
    const newFilters = [...exportFilters];
    newFilters[currentFilterIndex] = machine;
    setExportFilters(newFilters);
    setIsMachineSelectionModalOpen(false);
  };

  const handleRemoveFilter = (index) => {
    const newFilters = exportFilters.filter((_, i) => i !== index);
    setExportFilters(newFilters);
  };

  const handleExportFiltered = () => {
    const activeFilters = exportFilters.filter(f => f && f.trim() !== '');
    if (activeFilters.length === 0) {
        toast.error('Please select at least one machine to filter');
        return;
    }

    const filteredData = bluePrints.map(bp => {
        const filteredItems = (bp.items || []).filter(item => 
            activeFilters.includes(item.machines)
        );
        return { ...bp, items: filteredItems };
    }).filter(bp => bp.items.length > 0);

    if (filteredData.length === 0) {
        toast.error('No items found matching the selected filters');
        return;
    }

    handleExportAllBluePrintsExcel(filteredData);
    setIsExportModalOpen(false);
  };

  const handleExportAllBluePrintsExcel = (dataToExport = bluePrints) => {
    if (!dataToExport || dataToExport.length === 0) {
        toast.error('No blueprint data to export');
        return;
    }

    const tableHTML = `
      <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">
        <!--[if gte mso 9]>
        <xml>
        <x:ExcelWorkbook>
          <x:ExcelWorksheets>
            <x:ExcelWorksheet>
              <x:Name>Sheet1</x:Name>
              <x:WorksheetOptions>
                <x:DisplayGridlines/>
              </x:WorksheetOptions>
            </x:ExcelWorksheet>
          </x:ExcelWorksheets>
        </x:ExcelWorkbook>
        </xml>
        <![endif]-->
        <style>
            table { border-collapse: collapse; width: 100%; font-family: Arial, sans-serif; font-size: 11px; }
            th { background-color: #1e3a8a; color: white; border: 1px solid #1e3a8a; padding: 4px; text-align: center; vertical-align: middle; }
            td { border: 1px solid #e5e7eb; padding: 4px; text-align: center; vertical-align: middle; white-space: pre-wrap; }
            .header-title { font-size: 19px; font-weight: bold; text-align: center; margin-bottom: 10px; }
            .sub-title { font-size: 13px; color: #666; text-align: center; margin-bottom: 20px; }
            .account-header-row td { background-color: #e0e7ff; color: #1e3a8a; font-weight: bold; text-align: left; padding-left: 10px; }
            .total-row td { background-color: #1e3a8a; color: white; font-weight: bold; }
        </style>
      </head>
      <body>
        <div class="header-title">SALES BLUE PRINT 2026</div>
        <div class="sub-title">All Accounts Report</div>
        <br/>
        <table>
          <thead>
            <tr>
              <th>Account name</th>
              <th>Account Details</th>
              <th>Machines</th>
              <th>Machine Category</th>
              <th>Quantity</th>
              <th>Amount per Qty.</th>
              <th>Total Amount</th>
              <th>Target Delivery Date</th>
              <th>Status</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            ${dataToExport.map(bp => {
              const items = bp.items || [];
              const totalQty = items.reduce((sum, row) => sum + (parseFloat(row.quantity) || 0), 0);
              const totalUnitAmount = items.reduce((sum, row) => sum + (parseFloat(String(row.amount_per_qty).replace(/,/g, '')) || 0), 0);
              const totalAmount = items.reduce((sum, row) => sum + (parseFloat(String(row.total_amount).replace(/,/g, '')) || 0), 0);
              
              return `
              <tr class="account-header-row">
                <td colspan="10">${bp.account_name}</td>
              </tr>
              ${items.map(row => {
                const amount = parseFloat(String(row.amount_per_qty).replace(/,/g, '')) || 0;
                const total = parseFloat(String(row.total_amount).replace(/,/g, '')) || 0;
                return `
                <tr>
                  <td>${row.account_name || ''}</td>
                  <td>${row.account_details || ''}</td>
                  <td>${row.machines || ''}</td>
                  <td>${row.machine_category || ''}</td>
                  <td>${row.quantity || ''}</td>
                  <td>${amount.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</td>
                  <td>${total.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</td>
                  <td>${row.target_delivery_date || ''}</td>
                  <td>${row.status || ''}</td>
                  <td>${row.remarks || ''}</td>
                </tr>
              `}).join('')}
              <tr class="total-row" data-blueprint-summary="true">
                <td>${items.length}</td>
                <td colspan="3"></td>
                <td>${totalQty}</td>
                <td>${totalUnitAmount.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</td>
                <td>${totalAmount.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</td>
                <td colspan="3"></td>
              </tr>
              `;
            }).join('')}
          </tbody>
        </table>
      </body>
      </html>
    `;

    const blob = new Blob([tableHTML], { type: 'application/vnd.ms-excel' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `blue-print-all-accounts.xls`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    toast.success('All accounts exported to Excel successfully');
  };

  const handleImportBluePrintCSV = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
        const text = e.target.result;
        const lines = text.split(/\r?\n/).filter(line => line.trim());
        
        if (lines.length < 2) {
            toast.error('CSV file is empty or has no data rows');
            return;
        }

        const parseCSVLine = (line) => {
            const result = [];
            let current = '';
            let inQuotes = false;
            for (let i = 0; i < line.length; i++) {
                const ch = line[i];
                if (ch === '"') {
                    inQuotes = !inQuotes;
                    continue;
                }
                if (ch === ',' && !inQuotes) {
                    result.push(current);
                    current = '';
                } else {
                    current += ch;
                }
            }
            result.push(current);
            return result.map(v => v.trim());
        };

        const headers = parseCSVLine(lines[0]).map(h => h.toLowerCase().replace(/\s+/g, '_').replace(/\./g, ''));
        
        const newRows = [];
        for (let i = 1; i < lines.length; i++) {
            const values = parseCSVLine(lines[i]);
            if (values.length < headers.length) continue;

            const row = {};
            headers.forEach((header, index) => {
                let key = header;
                if (header.includes('account_name')) key = 'account_name';
                else if (header.includes('account_details')) key = 'account_details';
                else if (header.includes('machines')) key = 'machines';
                else if (header.includes('machine_category')) key = 'machine_category';
                else if (header.includes('quantity')) key = 'quantity';
                else if (header.includes('amount_per_qty')) key = 'amount_per_qty';
                else if (header.includes('total_amount')) key = 'total_amount';
                else if (header.includes('target_delivery_date')) key = 'target_delivery_date';
                else if (header.includes('status')) key = 'status';
                else if (header.includes('remarks')) key = 'remarks';
                
                let value = values[index];
                if (key === 'amount_per_qty' || key === 'total_amount') {
                    value = value.replace(/,/g, '');
                }
                
                row[key] = value;
            });
            newRows.push(row);
        }

        if (newRows.length > 0) {
            setBluePrintRows(newRows);
            toast.success(`Successfully imported ${newRows.length} rows`);
        } else {
            toast.error('No valid data found in CSV');
        }
        
        event.target.value = '';
    };
    reader.readAsText(file);
  };

  const handleExportBluePrintCSV = () => {
    if (!bluePrintRows || bluePrintRows.length === 0) {
        toast.error('No data to export');
        return;
    }

    const headers = ['Account Name', 'Account Details', 'Machines', 'Machine Category', 'Quantity', 'Amount per Qty.', 'Total Amount', 'Target Delivery Date', 'Status', 'Remarks'];
    const csvContent = [
        headers.join(','),
        ...bluePrintRows.map(row => [
            `"${(row.account_name || '').toString().replace(/"/g, '""')}"`,
            `"${(row.account_details || '').toString().replace(/"/g, '""')}"`,
            `"${(row.machines || '').toString().replace(/"/g, '""')}"`,
            `"${(row.machine_category || '').toString().replace(/"/g, '""')}"`,
            `"${(row.quantity || '').toString().replace(/"/g, '""')}"`,
            `"${(row.amount_per_qty || '').toString().replace(/"/g, '""')}"`,
            `"${(row.total_amount || '').toString().replace(/"/g, '""')}"`,
            `"${(row.target_delivery_date || '').toString().replace(/"/g, '""')}"`,
            `"${(row.status || '').toString().replace(/"/g, '""')}"`,
            `"${(row.remarks || '').toString().replace(/"/g, '""')}"`
        ].join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `blue-print-${selectedBluePrintAccount.account_name}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    toast.success('CSV exported successfully');
  };

  const handleExportBluePrintPDF = async () => {
    const element = document.getElementById('blueprint-export-area');
    if (!element) {
        toast.error('Export area not found');
        return;
    }

    // Create a clone to manipulate styles for full capture
    const clone = element.cloneNode(true);
    
    // 1. Compact the table cells (header and body)
    const allCells = clone.querySelectorAll('th, td');
    allCells.forEach(cell => {
        cell.style.padding = '4px 2px'; // Tighter padding
        cell.style.fontSize = '10px';   // Smaller font size
        cell.style.height = 'auto';     // Allow height to shrink
    });

    // 2. Copy values from original inputs to cloned inputs and replace them with formatted text divs
    const originalInputs = element.querySelectorAll('input, textarea, select');
    const clonedInputs = clone.querySelectorAll('input, textarea, select');

    for (let i = 0; i < originalInputs.length; i++) {
        const originalInput = originalInputs[i];
        const clonedInput = clonedInputs[i];
        
        // Create a div to replace the input
        const div = document.createElement('div');
        const computedStyle = window.getComputedStyle(originalInput);
        
        // Copy relevant styles but override for compactness
        div.style.width = '100%';
        div.style.minHeight = 'auto';
        div.style.padding = '2px'; // Reduced padding
        div.style.textAlign = computedStyle.textAlign;
        div.style.fontFamily = computedStyle.fontFamily;
        div.style.fontSize = '10px'; // Enforce smaller font
        div.style.fontWeight = computedStyle.fontWeight;
        div.style.color = computedStyle.color;
        div.style.lineHeight = '1.2'; // Tighter line height
        div.style.boxSizing = 'border-box';
        div.style.display = 'flex';
        div.style.alignItems = 'center';
        div.style.justifyContent = computedStyle.textAlign === 'center' ? 'center' : (computedStyle.textAlign === 'right' ? 'flex-end' : 'flex-start');
        
        // Handle content
        if (originalInput.tagName === 'SELECT') {
             div.innerText = originalInput.options[originalInput.selectedIndex]?.text || originalInput.value;
        } else if (originalInput.tagName === 'TEXTAREA') {
             div.innerText = originalInput.value;
             div.style.whiteSpace = 'pre-wrap';
             div.style.wordBreak = 'break-word';
        } else {
             div.innerText = originalInput.value;
        }

        if (clonedInput.parentNode) {
            clonedInput.parentNode.replaceChild(div, clonedInput);
        }
    }

    // 3. Remove the Actions column (header and body)
    // Remove header cell
    const ths = clone.querySelectorAll('thead th');
    if (ths.length > 0) {
        // Assuming Actions is the last column
        const lastTh = ths[ths.length - 1];
        if (lastTh.innerText.trim() === 'Actions' || lastTh.innerText.trim() === '') {
            lastTh.remove();
        }
    }
    // Remove body cells
    const rows = clone.querySelectorAll('tbody tr');
    rows.forEach(row => {
        const tds = row.querySelectorAll('td');
        const isSummaryRow = row.getAttribute('data-blueprint-summary') === 'true';
        if (isSummaryRow) {
             // Summary row: [row count] [blank colspan 3] [Qty] [Amount] [Total] [Empty colspan 4]
             // Adjust the trailing colspan because the Actions column is removed for PDF export.
             const lastCell = tds[tds.length - 1];
             if (lastCell.hasAttribute('colSpan')) {
                 const span = parseInt(lastCell.getAttribute('colSpan'));
                 if (span > 1) lastCell.setAttribute('colSpan', span - 1);
             }
        } else {
             // Data row: remove last cell
             if (tds.length > 0) {
                 tds[tds.length - 1].remove();
             }
        }
    });

    // 4. Hide ONLY the "Add Field" button
    const buttons = clone.querySelectorAll('button');
    buttons.forEach(btn => {
        if (btn.innerText.includes('Add Field')) {
            btn.style.display = 'none';
        }
    });

    // Prepare clone for capture
    clone.style.width = '1800px'; // Increased width for "zoomed out" effect
    clone.style.padding = '20px';
    clone.style.backgroundColor = '#ffffff';
    clone.style.position = 'fixed'; 
    clone.style.top = '0';
    clone.style.left = '0';
    clone.style.zIndex = '-9999'; 
    clone.style.transform = 'none'; 
    
    // Append to body
    document.body.appendChild(clone);

    try {
        const canvas = await html2canvas(clone, {
            scale: 2, 
            useCORS: true,
            logging: false,
            backgroundColor: '#ffffff',
            windowWidth: 1800,
            height: clone.offsetHeight,
            width: 1800
        });

        const imgData = canvas.toDataURL('image/jpeg', 0.95);
        const pdf = new jsPDF('landscape', 'mm', 'a4');
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        
        const imgProps = pdf.getImageProperties(imgData);
        const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;
        
        let heightLeft = imgHeight;
        let position = 0;
        
        pdf.addImage(imgData, 'JPEG', 0, position, pdfWidth, imgHeight);
        heightLeft -= pdfHeight;
        
        while (heightLeft > 0) {
            position = heightLeft - imgHeight;
            pdf.addPage();
            pdf.addImage(imgData, 'JPEG', 0, position, pdfWidth, imgHeight);
            heightLeft -= pdfHeight;
        }

        pdf.save(`blue-print-${selectedBluePrintAccount?.account_name || 'details'}.pdf`);
        toast.success('PDF exported successfully');
    } catch (error) {
        console.error('PDF Export Error:', error);
        toast.error('Failed to export PDF');
    } finally {
        // Cleanup
        document.body.removeChild(clone);
    }
  };

  const handleExportAllPDF = async () => {
    const doc = new jsPDF('l', 'mm', 'a4'); // Landscape A4
    const container = document.getElementById('all-reports-hidden-container');
    
    if (!container) {
      console.error("Hidden container not found");
      alert("Error: Hidden container for reports not found. Please try refreshing the page.");
      return;
    }

    const reportElements = container.querySelectorAll('.sales-report-instance');
    
    if (reportElements.length === 0) {
        console.warn("No sales report instances found.");
        alert("No sales reports to export.");
        return;
    }

    // Iterate through each report instance
    for (let i = 0; i < reportElements.length; i++) {
      const element = reportElements[i];
      
      try {
        // Capture the element using html2canvas
        // Using higher scale for better quality, but balancing performance
        const canvas = await html2canvas(element, {
          scale: 1.5, 
          useCORS: true,
          logging: false,
          backgroundColor: '#ffffff', // Ensure white background
          windowWidth: 2200 // Match the container width to ensure consistent rendering
        });

        const imgData = canvas.toDataURL('image/jpeg', 0.95); // Use JPEG with quality 0.95 for better compression than PNG
        
        // A4 landscape dimensions in mm
        const pageWidth = 297; 
        const pageHeight = 210;
        
        // Calculate image dimensions to fit the page while maintaining aspect ratio
        // We want it to fit within the page margins (optional, but good practice)
        const imgWidth = pageWidth;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        
        // If it's not the first page, add a new one
        if (i > 0) {
          doc.addPage();
        }

        // Add image to PDF
        // If image height > page height, we might need to handle it (scale down or split), 
        // but for now assuming one report fits one page or we scale to fit width
        doc.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);

      } catch (err) {
        console.error("Error capturing report for index " + i, err);
      }
    }

    doc.save('All_Sales_Performance_Reports.pdf');
  };

  const salesDepartmentToolsProps = {
    activeMenuItem,
    user,
    axiosInstance,
    employees,
    admins,
    salesAccounts,
    setSalesAccounts,
    selectedSalesAccount,
    setSelectedSalesAccount,
    showAddSalesDropdown,
    setShowAddSalesDropdown,
    targetAccount,
    setTargetAccount,
    targetAmount,
    setTargetAmount,
    isSetTargetDialogOpen,
    setIsSetTargetDialogOpen,
    handleExportAllPDF,
    handleExportPDF,
    handleExportExcel,
    handleTransactionChange,
    saveTransaction,
    handleManualSave,
    handleAddTransaction,
    handleDeleteTransaction,
    manualInputIndices,
    setEditingTransactionIndex,
    setFocusProductSelectionFilter,
    setIsProductSelectionModalOpen,
    focusProducts,
    setFocusProducts,
    focusProductFilter,
    setFocusProductFilter,
    isAddProductModalOpen,
    setIsAddProductModalOpen,
    isEditProductModalOpen,
    setIsEditProductModalOpen,
    editingProduct,
    setEditingProduct,
    newFocusProduct,
    setNewFocusProduct,
    csvInputRef,
    mapSearchTerm,
    setMapSearchTerm,
    mapMonthFilter,
    setMapMonthFilter,
    mapStatusFilter,
    setMapStatusFilter,
    handleExportMapExcel,
    handleExportMapPDF,
    handleExportMapCSV,
    handleImportMapCSV,
    showMapAccountModal,
    setShowMapAccountModal,
    mapAccountData,
    setMapAccountData,
    handleSaveMapAccount,
    filteredMapAccounts,
    editingAccountId,
    editFormData,
    setEditFormData,
    handleSaveEdit,
    handleCancelEdit,
    handleEditClick,
    handleDeleteMapAccount,
    bluePrints,
    selectedBluePrintAccount,
    setSelectedBluePrintAccount,
    bluePrintRows,
    setBluePrintRows,
    bluePrintSortMode,
    setBluePrintSortMode,
    handleDeleteBluePrint,
    isExportModalOpen,
    setIsExportModalOpen,
    exportFilters,
    handleOpenMachineSelection,
    handleRemoveFilter,
    handleAddFilter,
    handleExportFiltered,
    handleExportAllBluePrintsExcel,
    isMachineSelectionModalOpen,
    setIsMachineSelectionModalOpen,
    handleSelectMachine,
    handleExportBluePrintExcel,
    handleExportBluePrintPDF,
    handleExportBluePrintCSV,
    handleImportBluePrintCSV,
    handleSaveBluePrint,
    handleDeleteBluePrintRow,
    showMachineModal,
    setShowMachineModal,
    fetchFocusProducts,
    currentMachineRowIndex,
    setCurrentMachineRowIndex,
    machineSearchQuery,
    setMachineSearchQuery,
    isManualInputMode,
    setIsManualInputMode,
    manualMachineName,
    setManualMachineName,
    fetchBluePrints,
    setActiveMenuItem,
  };
  const salesDepartmentToolsMeta = getSalesDepartmentToolsMeta(activeMenuItem, selectedSalesAccount);

                                const renderEmployees = () => (
                                  <div className="h-full flex flex-col">
                                    {/* Fixed Header Section */}
                                    <div className="flex-shrink-0 mb-6">
                                      <div className="flex justify-between items-center mb-4">
                                        <Dialog open={isCreateDialogOpen} onOpenChange={setIsCreateDialogOpen}>
                                          <DialogTrigger asChild>
                                            <Button className="bg-indigo-600 hover:bg-indigo-700">
                                              <Plus className="h-4 w-4 mr-2" />
                                              Add Employee
                                            </Button>
                                          </DialogTrigger>
                                          <DialogContent>
                                            <DialogHeader>
                                              <DialogTitle>Add New Employee</DialogTitle>
                                            </DialogHeader>
                                            <form onSubmit={handleCreateEmployee} className="space-y-4">
                                              <div className="grid grid-cols-2 gap-4">
                                                <div>
                                                  <Label>Full Name</Label>
                                                  <Input
                                                    value={newEmployee.full_name}
                                                    onChange={(e) => setNewEmployee({...newEmployee, full_name: e.target.value})}
                                                    required
                                                  />
                                                </div>
                                                <div>
                                                  <Label>Employee ID</Label>
                                                  <Input
                                                    value={newEmployee.employee_id}
                                                    onChange={(e) => setNewEmployee({...newEmployee, employee_id: e.target.value})}
                                                  />
                                                </div>
                                              </div>
                                              
                                              <div>
                                                <Label>Email</Label>
                                                <Input
                                                  type="email"
                                                  value={newEmployee.email}
                                                  onChange={(e) => setNewEmployee({...newEmployee, email: e.target.value})}
                                                  required
                                                />
                                              </div>
                                              
                                              <div>
                                                <Label>Password</Label>
                                                <Input
                                                  type="password"
                                                  value={newEmployee.password}
                                                  onChange={(e) => setNewEmployee({...newEmployee, password: e.target.value})}
                                                  required
                                                />
                                              </div>
                                              
                                              <div className="grid grid-cols-3 gap-4">
                                                <div>
                                                  <Label>Branch</Label>
                                                  <Input
                                                    value={newEmployee.branch}
                                                    onChange={(e) => setNewEmployee({...newEmployee, branch: e.target.value})}
                                                  />
                                                </div>
                                                <div>
                                                  <Label>Position</Label>
                                                  <Input
                                                    value={newEmployee.position}
                                                    onChange={(e) => setNewEmployee({...newEmployee, position: e.target.value})}
                                                  />
                                                </div>
                                                <div>
                                                  <Label>Department</Label>
                                                  <Input
                                                    value={newEmployee.department}
                                                    onChange={(e) => setNewEmployee({...newEmployee, department: e.target.value})}
                                                  />
                                                </div>
                                              </div>
                                              
                                              {/* Government ID Numbers */}
                                              <div className="space-y-2">
                                                <Label className="text-sm font-semibold text-gray-700 dark:text-gray-100">Government ID Numbers</Label>
                                                <div className="grid grid-cols-2 gap-4">
                                                  <div>
                                                    <Label className="text-xs">TIN Number</Label>
                                                    <Input
                                                      placeholder="000-000-000-000"
                                                      value={newEmployee.tin_number}
                                                      onChange={(e) => setNewEmployee({...newEmployee, tin_number: e.target.value})}
                                                    />
                                                  </div>
                                                  <div>
                                                    <Label className="text-xs">SSS Number</Label>
                                                    <Input
                                                      placeholder="00-0000000-0"
                                                      value={newEmployee.sss_number}
                                                      onChange={(e) => setNewEmployee({...newEmployee, sss_number: e.target.value})}
                                                    />
                                                  </div>
                                                  <div>
                                                    <Label className="text-xs">PhilHealth Number</Label>
                                                    <Input
                                                      placeholder="00-000000000-0"
                                                      value={newEmployee.phic_number}
                                                      onChange={(e) => setNewEmployee({...newEmployee, phic_number: e.target.value})}
                                                    />
                                                  </div>
                                                  <div>
                                                    <Label className="text-xs">HDMF/Pag-IBIG Number</Label>
                                                    <Input
                                                      placeholder="0000-0000-0000"
                                                      value={newEmployee.hdmf_number}
                                                      onChange={(e) => setNewEmployee({...newEmployee, hdmf_number: e.target.value})}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                              
                                              <div className="flex justify-end space-x-2">
                                                <Button
                                                  type="button"
                                                  variant="outline"
                                                  onClick={() => setIsCreateDialogOpen(false)}
                                                >
                                                  Cancel
                                                </Button>
                                                <Button type="submit" className="bg-indigo-600 hover:bg-indigo-700">
                                                  Add Employee
                                                </Button>
                                              </div>
                                            </form>
                                          </DialogContent>
                                        </Dialog>
                                      </div>

                                      {/* Employee Search Box */}
                                      <div className="mb-4">
                                        <div className="relative max-w-md">
                                          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                            <svg className="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                            </svg>
                                          </div>
                                          <Input
                                            type="text"
                                            placeholder="Search employees by name, email, ID, branch, position, or department..."
                                            value={employeeSearchTerm}
                                            onChange={(e) => setEmployeeSearchTerm(e.target.value)}
                                            className="pl-10 pr-4 py-2 w-full border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                          />
                                          {employeeSearchTerm && (
                                            <button
                                              onClick={() => setEmployeeSearchTerm('')}
                                              className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 dark:text-gray-200"
                                            >
                                              <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                              </svg>
                                            </button>
                                          )}
                                        </div>
                                        {employeeSearchTerm && (
                                          <p className="text-sm text-gray-600 dark:text-gray-200 mt-2">
                                            Showing {getFilteredEmployees().length} of {employees.length} employees
                                          </p>
                                        )}
                                      </div>
                                    </div>

                                    {/* Fixed Header + Scrollable Table */}
                                    <div className="flex-1 min-h-0">
                                      <Card className="glass shadow-lg border-0 h-full flex flex-col">
                                        <CardHeader className="flex-shrink-0 pb-0">
                                          <CardTitle>Employee Directory</CardTitle>
                                          <CardDescription>
                                            Showing {getFilteredEmployees().length} of {employees.length} employees
                                          </CardDescription>
                                        </CardHeader>
                                        <CardContent className="flex-1 min-h-0 p-0 flex flex-col">
                                          {/* Fixed Table Header */}
                                          <div className="flex-shrink-0 border-b bg-gray-50">
                                            <table className="w-full table-fixed">
                                              <thead>
                                                <tr className="border-b border-gray-200">
                                                  <th className="text-left px-4 py-3 font-medium text-gray-900 dark:text-white bg-gray-50 w-[14%]">Name</th>
                                                  <th className="text-left px-4 py-3 font-medium text-gray-900 dark:text-white bg-gray-50 w-[18%]">Email</th>
                                                  <th className="text-left px-4 py-3 font-medium text-gray-900 dark:text-white bg-gray-50 w-[10%]">Employee ID</th>
                                                  <th className="text-left px-4 py-3 font-medium text-gray-900 dark:text-white bg-gray-50 w-[10%]">Branch</th>
                                                  <th className="text-left px-4 py-3 font-medium text-gray-900 dark:text-white bg-gray-50 w-[16%]">Position</th>
                                                  <th className="text-left px-4 py-3 font-medium text-gray-900 dark:text-white bg-gray-50 w-[12%]">Department</th>
                                                  <th className="text-left px-4 py-3 font-medium text-gray-900 dark:text-white bg-gray-50 w-[8%]">Status</th>
                                                  <th className="text-left px-4 py-3 font-medium text-gray-900 dark:text-white bg-gray-50 w-[12%]">Actions</th>
                                                </tr>
                                              </thead>
                                            </table>
                                          </div>
                                          
                                          {/* Scrollable Table Body */}
                                          <div className="flex-1 overflow-auto">
                                            <table className="w-full table-fixed border-collapse">
                                              <tbody>
                                                {getFilteredEmployees().length > 0 ? (
                                                  getFilteredEmployees().map((employee, index) => (
                                                    <tr key={employee.id} className={`${index % 2 === 0 ? 'bg-white bg-opacity-30' : 'bg-gray-50 bg-opacity-30'} hover:bg-indigo-50 dark:hover:bg-black hover:bg-opacity-50 dark:hover:bg-black transition-colors border-b border-gray-100`}>
                                                      <td className="px-4 py-4 whitespace-nowrap w-[14%]">
                                                        <div className="font-medium text-gray-900 dark:text-white truncate">{employee.full_name}</div>
                                                      </td>
                                                      <td className="px-4 py-4 whitespace-nowrap text-gray-600 dark:text-gray-200 w-[18%]">
                                                        <span className="truncate block">{employee.email}</span>
                                                      </td>
                                                      <td className="px-4 py-4 whitespace-nowrap text-gray-600 dark:text-gray-200 w-[10%]">
                                                        {employee.employee_id || 'N/A'}
                                                      </td>
                                                      <td className="px-4 py-4 whitespace-nowrap text-gray-600 dark:text-gray-200 w-[10%]">
                                                        <span className="truncate block">{employee.branch || 'N/A'}</span>
                                                      </td>
                                                      <td className="px-4 py-4 whitespace-nowrap text-gray-600 dark:text-gray-200 w-[16%]">
                                                        <span className="truncate block">{employee.position || 'N/A'}</span>
                                                      </td>
                                                      <td className="px-4 py-4 whitespace-nowrap text-gray-600 dark:text-gray-200 w-[12%]">
                                                        <span className="truncate block">{employee.department || 'N/A'}</span>
                                                      </td>
                                                      <td className="px-4 py-4 whitespace-nowrap w-[8%]">
                                                        <div className="flex items-center gap-2">
                                                          <Switch
                                                            data-testid={`employee-status-toggle-${employee.id}`}
                                                            checked={employee.is_active !== false}
                                                            onCheckedChange={(checked) => handleToggleEmployeeStatus(employee.id, checked)}
                                                            className={employee.is_active !== false ? 'data-[state=checked]:bg-green-500' : 'data-[state=unchecked]:bg-gray-300'}
                                                          />
                                                          <span className={`text-xs font-medium ${employee.is_active !== false ? 'text-green-600' : 'text-gray-500'}`}>
                                                            {employee.is_active !== false ? 'Active' : 'Inactive'}
                                                          </span>
                                                        </div>
                                                      </td>
                                                      <td className="px-4 py-4 whitespace-nowrap text-sm font-medium space-x-2 w-[12%]">
                                                        <Button
                                                          size="sm"
                                                          variant="ghost"
                                                          data-testid={`edit-employee-btn-${employee.id}`}
                                                          onClick={() => {
                                                            setSelectedEmployee(employee);
                                                            setIsEditDialogOpen(true);
                                                          }}
                                                        >
                                                          <Edit className="h-3 w-3" />
                                                        </Button>
                                                        <Button
                                                          size="sm"
                                                          variant="ghost"
                                                          data-testid={`delete-employee-btn-${employee.id}`}
                                                          onClick={() => handleDeleteEmployee(employee.id)}
                                                          className="text-red-600 hover:text-red-800"
                                                        >
                                                          <Trash2 className="h-3 w-3" />
                                                        </Button>
                                                      </td>
                                                    </tr>
                                                  ))
                                                ) : (
                                                  <tr>
                                                    <td colSpan="8" className="px-6 py-8 text-center">
                                                      <div className="flex flex-col items-center">
                                                        <Users className="h-12 w-12 text-gray-400 mb-4" />
                                                        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
                                                          {employeeSearchTerm ? 'No employees found' : 'No employees yet'}
                                                        </h3>
                                                        <p className="text-gray-500 dark:text-gray-300">
                                                          {employeeSearchTerm 
                                                            ? `No employees match "${employeeSearchTerm}". Try a different search term.`
                                                            : 'Get started by adding your first employee.'
                                                          }
                                                        </p>
                                                        {employeeSearchTerm && (
                                                          <Button
                                                            variant="outline"
                                                            onClick={() => setEmployeeSearchTerm('')}
                                                            className="mt-4"
                                                          >
                                                            Clear search
                                                          </Button>
                                                        )}
                                                      </div>
                                                    </td>
                                                  </tr>
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </CardContent>
                                      </Card>
                                    </div>

                                    {/* Edit Employee Dialog */}
                                    <Dialog open={isEditDialogOpen} onOpenChange={(open) => {
                                      setIsEditDialogOpen(open);
                                      if (!open) {
                                        setSelectedEmployee(null);
                                        setNewPassword('');
                                        setConfirmPassword('');
                                      }
                                    }}>
                                      <DialogContent>
                                        <DialogHeader>
                                          <DialogTitle>Edit Employee</DialogTitle>
                                        </DialogHeader>
                                        {selectedEmployee && (
                                          <form onSubmit={handleUpdateEmployee} className="space-y-4">
                                            <div className="grid grid-cols-2 gap-4">
                                              <div>
                                                <Label>Full Name</Label>
                                                <Input
                                                  value={selectedEmployee.full_name}
                                                  onChange={(e) => setSelectedEmployee({...selectedEmployee, full_name: e.target.value})}
                                                  required
                                                />
                                              </div>
                                              <div>
                                                <Label>Employee ID</Label>
                                                <Input
                                                  value={selectedEmployee.employee_id || ''}
                                                  onChange={(e) => setSelectedEmployee({...selectedEmployee, employee_id: e.target.value})}
                                                />
                                              </div>
                                            </div>
                                            
                                            <div>
                                              <Label>Email</Label>
                                              <Input
                                                type="email"
                                                value={selectedEmployee.email}
                                                onChange={(e) => setSelectedEmployee({...selectedEmployee, email: e.target.value})}
                                                required
                                              />
                                            </div>
                                            
                                            <div className="grid grid-cols-3 gap-4">
                                              <div>
                                                <Label>Branch</Label>
                                                <Input
                                                  value={selectedEmployee.branch || ''}
                                                  onChange={(e) => setSelectedEmployee({...selectedEmployee, branch: e.target.value})}
                                                />
                                              </div>
                                              <div>
                                                <Label>Position</Label>
                                                <Input
                                                  value={selectedEmployee.position || ''}
                                                  onChange={(e) => setSelectedEmployee({...selectedEmployee, position: e.target.value})}
                                                />
                                              </div>
                                              <div>
                                                <Label>Department</Label>
                                                <Input
                                                  value={selectedEmployee.department || ''}
                                                  onChange={(e) => setSelectedEmployee({...selectedEmployee, department: e.target.value})}
                                                />
                                              </div>
                                            </div>
                                            
                                            {/* Government ID Numbers */}
                                            <div className="space-y-2 border-t pt-4">
                                              <Label className="text-sm font-semibold text-gray-700 dark:text-gray-100">Government ID Numbers</Label>
                                              <div className="grid grid-cols-2 gap-4">
                                                <div>
                                                  <Label className="text-xs">TIN Number</Label>
                                                  <Input
                                                    placeholder="000-000-000-000"
                                                    value={selectedEmployee.tin_number || ''}
                                                    onChange={(e) => setSelectedEmployee({...selectedEmployee, tin_number: e.target.value})}
                                                  />
                                                </div>
                                                <div>
                                                  <Label className="text-xs">SSS Number</Label>
                                                  <Input
                                                    placeholder="00-0000000-0"
                                                    value={selectedEmployee.sss_number || ''}
                                                    onChange={(e) => setSelectedEmployee({...selectedEmployee, sss_number: e.target.value})}
                                                  />
                                                </div>
                                                <div>
                                                  <Label className="text-xs">PhilHealth Number</Label>
                                                  <Input
                                                    placeholder="00-000000000-0"
                                                    value={selectedEmployee.phic_number || ''}
                                                    onChange={(e) => setSelectedEmployee({...selectedEmployee, phic_number: e.target.value})}
                                                  />
                                                </div>
                                                <div>
                                                  <Label className="text-xs">HDMF/Pag-IBIG Number</Label>
                                                  <Input
                                                    placeholder="0000-0000-0000"
                                                    value={selectedEmployee.hdmf_number || ''}
                                                    onChange={(e) => setSelectedEmployee({...selectedEmployee, hdmf_number: e.target.value})}
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                            
                                            {/* Password Section */}
                                            <div className="border-t pt-4 mt-4">
                                              <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-100 mb-3">Change Password (Optional)</h3>
                                              <div className="grid grid-cols-2 gap-4">
                                                <div>
                                                  <Label>New Password</Label>
                                                  <Input
                                                    type="password"
                                                    value={newPassword}
                                                    onChange={(e) => setNewPassword(e.target.value)}
                                                    placeholder="Leave blank to keep current password"
                                                    minLength={6}
                                                  />
                                                </div>
                                                <div>
                                                  <Label>Confirm New Password</Label>
                                                  <Input
                                                    type="password"
                                                    value={confirmPassword}
                                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                                    placeholder="Confirm new password"
                                                    minLength={6}
                                                  />
                                                </div>
                                              </div>
                                              {newPassword && newPassword.length > 0 && newPassword.length < 6 && (
                                                <p className="text-red-500 text-xs mt-1">Password must be at least 6 characters long</p>
                                              )}
                                              {newPassword && confirmPassword && newPassword !== confirmPassword && (
                                                <p className="text-red-500 text-xs mt-1">Passwords do not match</p>
                                              )}
                                            </div>
                                            
                                            <div className="flex justify-end space-x-2">
                                              <Button
                                                type="button"
                                                variant="outline"
                                                onClick={() => {
                                                  setIsEditDialogOpen(false);
                                                  setSelectedEmployee(null);
                                                  setNewPassword('');
                                                  setConfirmPassword('');
                                                }}
                                              >
                                                Cancel
                                              </Button>
                                              <Button type="submit" className="bg-indigo-600 hover:bg-indigo-700">
                                                Save Changes
                                              </Button>
                                            </div>
                                          </form>
                                        )}
                                      </DialogContent>
                                    </Dialog>
                                  </div>
                                );

                                return (
                                  <>
                                  <div className="flex h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 relative">
                                    {/* Invisible Left Edge Hover Zone */}
                                    {activeMenuItem !== 'org-chart' && !isSidebarOpen && (
                                      <div 
                                        className="absolute left-0 top-0 bottom-0 w-4 z-50 bg-transparent"
                                        onMouseEnter={handleSidebarMouseEnter}
                                        onMouseLeave={() => {
                                          if (hoverTimeoutRef.current) {
                                            clearTimeout(hoverTimeoutRef.current);
                                            hoverTimeoutRef.current = null;
                                          }
                                        }}
                                      />
                                    )}
                                    {/* HRIS Side Menu */}
                                    <div 
                                      className={`${isSidebarOpen ? 'w-64' : 'w-0'} bg-white dark:bg-slate-900 shadow-xl border-r border-gray-200 dark:border-slate-800 transition-all duration-300 overflow-hidden relative z-40`}
                                      onMouseLeave={handleSidebarMouseLeave}
                                    >
                                      <div className="w-64 h-full relative flex flex-col">
                                      <div className="p-4 border-b border-gray-200 dark:border-slate-800">
                                        <div className="flex items-center gap-3">
                                          <img 
                                            src="https://customer-assets.emergentagent.com/job_hr-system-repair-1/artifacts/au3caisj_iSource%20LOGO.png"
                                            alt="iSOURCE Logo"
                                            className="h-64 w-auto object-contain"
                                          />

                                        </div>
                                      </div>

                                      <nav className="p-4 space-y-2 flex-1 overflow-y-auto pb-24">
                                        {/* Announcements */}
                                        {(user.permissions?.marketing_system_access || user.email === 'vinsimon23@gmail.com') && (
                                          <button
                                            onClick={() => handleSelectTool('marketing-announcements')}
                                            className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg text-left transition-colors ${
                                              activeMenuItem === 'marketing-announcements' 
                                                ? 'bg-amber-100 text-amber-900 font-semibold' 
                                                : 'text-gray-700 dark:text-gray-100 hover:bg-amber-50 dark:hover:bg-black'
                                            }`}
                                          >
                                            <BarChart3 className="h-4 w-4" />
                                            Announcements
                                          </button>
                                        )}
                                        {/* Attendance Dropdown - Show if user has attendance access (default true) */}
                                        {(user.permissions?.attendance_access !== false || user.email === 'vinsimon23@gmail.com') && (
                                          <div>
                                            <button
                                              onClick={() => setIsHRISOpen(!isHRISOpen)}
                                              className="w-full flex items-center justify-between gap-3 px-3 py-2 rounded-lg text-left transition-colors text-gray-700 dark:text-gray-100 hover:bg-blue-50 dark:hover:bg-black"
                                            >
                                              <div className="flex items-center gap-3">
                                                <Building2 className="h-4 w-4" />
                                                Attendance Monitoring System
                                              </div>
                                              {isHRISOpen ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
                                            </button>
                                            
                                            {isHRISOpen && (
                                              <div className="ml-6 mt-2 space-y-1">
                                                <button
                                                  onClick={() => handleSelectTool('dashboard')}
                                                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
                                                    activeMenuItem === 'dashboard' 
                                                      ? 'bg-blue-50 text-blue-600 border-l-2 border-blue-400' 
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  <Home className="h-3 w-3" />
                                                  Dashboard
                                                </button>
                                                <button
                                                  onClick={() => handleSelectTool('attendance')}
                                                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
                                                    activeMenuItem === 'attendance' 
                                                      ? 'bg-blue-50 text-blue-600 border-l-2 border-blue-400' 
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  <UserCheck className="h-3 w-3" />
                                                  Attendance
                                                </button>
                                                <button
                                                  onClick={() => handleSelectTool('reports')}
                                                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
                                                    activeMenuItem === 'reports' 
                                                      ? 'bg-blue-50 text-blue-600 border-l-2 border-blue-400' 
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  <BarChart3 className="h-3 w-3" />
                                                  Reports
                                                </button>
                                                <button
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    exportAllAttendanceToCSV();
                                                  }}
                                                  disabled={isExportingAllAttendance}
                                                  className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-all border-l-2 border-transparent hover:border-amber-400 bg-amber-50/50 dark:bg-amber-500/5 text-amber-700 dark:text-amber-400 hover:bg-amber-100 dark:hover:bg-amber-500/10 disabled:opacity-50 disabled:cursor-not-allowed"
                                                  title="Export all attendance records to CSV"
                                                >
                                                  {isExportingAllAttendance ? (
                                                    <Loader2 className="h-3 w-3 animate-spin" />
                                                  ) : (
                                                    <FileDown className="h-3 w-3" />
                                                  )}
                                                  {isExportingAllAttendance ? 'Exporting...' : 'Export'}
                                                </button>
                                                <button
                                                  onClick={() => handleSelectTool('schedules')}
                                                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
                                                    activeMenuItem === 'schedules' 
                                                      ? 'bg-blue-50 text-blue-600 border-l-2 border-blue-400' 
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  <CalendarCheck className="h-3 w-3" />
                                                  Schedules
                                                </button>
                                                <button
                                                  onClick={() => handleSelectTool('employees')}
                                                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
                                                    activeMenuItem === 'employees' 
                                                      ? 'bg-blue-50 text-blue-600 border-l-2 border-blue-400' 
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  <Users className="h-3 w-3" />
                                                  Employees
                                                </button>
                                              </div>
                                            )}
                                          </div>
                                        )}



                                        
                                        {/* HRIS Dropdown - Show only if user has HRIS access */}
                                        {(user.permissions?.hris_access || user.email === 'vinsimon23@gmail.com') && (
                                          <div>
                                            <button
                                              onClick={() => {
                                                const next = !isHumanResourcesInfoSystemOpen;
                                                setIsHumanResourcesInfoSystemOpen(next);
                                                if (next) {
                                                  setIsHRISOpen(false);
                                                  setIsNumoraOpen(false);
                                                  setIsPayrollOpen(false);
                                                  setIsCCPOpen(false);
                                                  setIsManagementPrintSystemOpen(false);
                                                  setIsMarketingSystemOpen(false);
                                                }
                                              }}
                                              className="w-full flex items-center justify-between gap-3 px-3 py-2 rounded-lg text-left transition-colors text-gray-700 dark:text-gray-100 hover:bg-blue-50 dark:hover:bg-black"
                                            >
                                              <div className="flex items-center gap-3">
                                                <Users className="h-4 w-4" />
                                                Human Resources Information System
                                              </div>
                                              {isHumanResourcesInfoSystemOpen ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
                                            </button>
                                            
                                            {isHumanResourcesInfoSystemOpen && (
                                              <div className="ml-6 mt-2 space-y-1">
                                                <button
                                                  onClick={() => handleSelectTool('hris-dashboard')}
                                                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
                                                    activeMenuItem === 'hris-dashboard' 
                                                      ? 'bg-blue-50 text-blue-600 border-l-2 border-blue-400' 
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  <Home className="h-3 w-3" />
                                                  Dashboard
                                                </button>
                                                <button
                                                  onClick={() => navigate('/application-hub')}
                                                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
                                                    activeMenuItem === 'hris-application-hub' 
                                                      ? 'bg-blue-50 text-blue-600 border-l-2 border-blue-400' 
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  <FileText className="h-3 w-3" />
                                                  Application Hub
                                                </button>
                                                <button
                                                  onClick={() => handleSelectTool('hris-candidates')}
                                                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
                                                    activeMenuItem === 'hris-candidates' 
                                                      ? 'bg-blue-50 text-blue-600 border-l-2 border-blue-400' 
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  <Users className="h-3 w-3" />
                                                  Candidates
                                                </button>
                                                <button
                                                  onClick={() => handleSelectTool('hris-employees-201')}
                                                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
                                                    activeMenuItem === 'hris-employees-201' 
                                                      ? 'bg-blue-50 text-blue-600 border-l-2 border-blue-400' 
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  <FileText className="h-3 w-3" />
                                                  Employees 201 Files
                                                </button>
                                              </div>
                                            )}
                                          </div>
                                        )}

                                        <NumoraSidebarSection
                                          user={user}
                                          isOpen={isNumoraOpen}
                                          setIsOpen={setIsNumoraOpen}
                                          activeMenuItem={activeMenuItem}
                                          handleSelectTool={handleSelectTool}
                                          closeOtherSections={() => {
                                            setIsHRISOpen(false);
                                            setIsHumanResourcesInfoSystemOpen(false);
                                            setIsPayrollOpen(false);
                                            setIsCCPOpen(false);
                                            setIsInventoryManagementSystemOpen(false);
                                            setIsManagementPrintSystemOpen(false);
                                            setIsMarketingSystemOpen(false);
                                            setIsServiceLifecycleManagementOpen(false);
                                            setIsProjectDetailsOpen(false);
                                          }}
                                        />

                                        {/* Payroll Dropdown - Show only if user has Payroll access or is super admin */}
                                        {(user.permissions?.payroll_access || user.email === 'vinsimon23@gmail.com') && (
                                          <div className="mt-2">
                                            <button
                                              onClick={() => setIsPayrollOpen(!isPayrollOpen)}
                                              className="w-full flex items-center justify-between gap-3 px-3 py-2 rounded-lg text-left transition-colors text-gray-700 dark:text-gray-100 hover:bg-emerald-50 dark:hover:bg-black"
                                            >
                                              <div className="flex items-center gap-3">
                                                <FileText className="h-4 w-4" />
                                                Payroll
                                              </div>
                                              {isPayrollOpen ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
                                            </button>
                                            
                                            {isPayrollOpen && (
                                              <div className="ml-6 mt-2 space-y-1">
                                                <button
                                                  onClick={() => handleSelectTool('payroll-dashboard')}
                                                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
                                                    activeMenuItem === 'payroll-dashboard' 
                                                      ? 'bg-emerald-50 text-emerald-600 border-l-2 border-emerald-400' 
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  <Home className="h-3 w-3" />
                                                  Dashboard
                                                </button>
                                                <button
                                                  onClick={() => handleSelectTool('employee-management')}
                                                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
                                                    activeMenuItem === 'employee-management' 
                                                      ? 'bg-emerald-50 text-emerald-600 border-l-2 border-emerald-400' 
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  <Users className="h-3 w-3" />
                                                  Employee Management
                                                </button>
                                                <button
                                                  onClick={() => handleSelectTool('payroll-loans')}
                                                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ml-4 ${
                                                    activeMenuItem === 'payroll-loans' 
                                                      ? 'bg-emerald-50 text-emerald-600 border-l-2 border-emerald-400' 
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  <DollarSign className="h-3 w-3" />
                                                  Loans
                                                </button>
                                                <button
                                                  onClick={() => handleSelectTool('payroll-attendance')}
                                                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
                                                    activeMenuItem === 'payroll-attendance' 
                                                      ? 'bg-emerald-50 text-emerald-600 border-l-2 border-emerald-400' 
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  <CalendarCheck className="h-3 w-3" />
                                                  Generate
                                                </button>
                                                <button
                                                  onClick={() => handleSelectTool('payroll-database')}
                                                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
                                                    activeMenuItem === 'payroll-database' 
                                                      ? 'bg-emerald-50 text-emerald-600 border-l-2 border-emerald-400' 
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  <FileText className="h-3 w-3" />
                                                  Payroll Records
                                                </button>
                                                <button
                                                  onClick={() => handleSelectTool('employee-running-status')}
                                                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
                                                    activeMenuItem === 'employee-running-status' 
                                                      ? 'bg-emerald-50 text-emerald-600 border-l-2 border-emerald-400' 
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  <BarChart3 className="h-3 w-3" />
                                                  Employee Running Status
                                                </button>
                                              </div>
                                            )}
                                          </div>
                                        )}


                                        {/* PCC Main Tab */}
                                        {(user.permissions?.ccp_access || user.email === 'vinsimon23@gmail.com') && (
                                          <div>
                                            <button
                                              onClick={async () => {
                                                const next = !isCCPOpen;
                                                setIsCCPOpen(next);
                                                if (next) {
                                                  setIsHRISOpen(false);
                                                  setIsHumanResourcesInfoSystemOpen(false);
                                                  setIsNumoraOpen(false);

                                                  setIsPayrollOpen(false);
                                                  setIsInventoryManagementSystemOpen(false);
                                                  setIsServiceLifecycleManagementOpen(false);
                                                  setIsManagementPrintSystemOpen(false);
                                                  setIsProjectDetailsOpen(false);
                                                  setIsMarketingSystemOpen(false);

// Pricing Template fetch removed
                                                }
                                              }}
                                              className={`w-full flex items-center justify-between px-4 py-3 text-left transition-colors ${
                                                isCCPOpen ? 'bg-pink-100 text-pink-900 font-semibold' : 'text-gray-700 dark:text-gray-100 hover:bg-pink-50 dark:hover:bg-black'
                                              }`}
                                              >
                                              <span className="flex items-center">
                                                <Settings className="h-5 w-5 mr-3" />
                                                PCC
                                                {isTargetUser && pendingApprovalsCount > 0 && (
                                                  <span className="ml-2 bg-blue-600 text-white text-xs font-bold px-2 py-0.5 rounded-full shadow-sm">
                                                    {pendingApprovalsCount}
                                                  </span>
                                                )}
                                                {isOamUser && exportReadyCount > 0 && (
                                                  <span className="ml-2 bg-green-600 text-white text-xs font-bold px-2 py-0.5 rounded-full shadow-sm">
                                                    {exportReadyCount}
                                                  </span>
                                                )}
                                              </span>
                                              {isCCPOpen ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
                                            </button>

                                            {/* PCC Submenu */}
                                            {isCCPOpen && (
                                              <div className="ml-8 space-y-1 mt-1">
{/* Pricing Template Removed */}
                                                <button
                                                  onClick={() => setActiveMenuItem('ccp-project-details')}
                                                  className={`w-full px-4 py-2 text-left text-sm transition-colors flex justify-between items-center ${
                                                    activeMenuItem === 'ccp-project-details'
                                                      ? 'bg-pink-50 text-pink-700 border-l-4 border-pink-500'
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  <span>Project Details</span>
                                                  {isDgmUser && pendingApprovalsCount > 0 && (
                                                    <span className="bg-blue-600 text-white text-xs font-bold px-2 py-0.5 rounded-full shadow-sm">
                                                      {pendingApprovalsCount}
                                                    </span>
                                                  )}
                                                </button>
                                                {((user.is_super_admin && !isDgmUser) || isCadfUser || isOamUser || isJcpUser || isMspUser || user.email === 'vinsimon23@gmail.com') && (
                                                  <button
                                                    onClick={() => setActiveMenuItem('ccp-project-computation')}
                                                    className={`w-full px-4 py-2 text-left text-sm transition-colors flex justify-between items-center ${
                                                      activeMenuItem === 'ccp-project-computation'
                                                        ? 'bg-pink-50 text-pink-700 border-l-4 border-pink-500'
                                                        : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                    }`}
                                                  >
                                                    <span>Project Computation</span>
                                                    {(isCadfUser || isOamUser || isJcpUser || isMspUser) && pendingApprovalsCount > 0 && (
                                                      <span className="bg-blue-600 text-white text-xs font-bold px-2 py-0.5 rounded-full shadow-sm">
                                                        {pendingApprovalsCount}
                                                      </span>
                                                    )}
                                                    {isOamUser && exportReadyCount > 0 && (
                                                      <span className="bg-green-600 text-white text-xs font-bold px-2 py-0.5 rounded-full shadow-sm ml-2">
                                                        {exportReadyCount}
                                                      </span>
                                                    )}
                                                  </button>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        )}



                                        {(user.permissions?.inventory_access || user.email === 'vinsimon23@gmail.com') && (
                                          <div className="mt-2">
                                            <button
                                              onClick={() => {
                                                const next = !isInventoryManagementSystemOpen;
                                                setIsInventoryManagementSystemOpen(next);
                                                if (next) {
                                                  setIsHRISOpen(false);
                                                  setIsHumanResourcesInfoSystemOpen(false);
                                                  setIsNumoraOpen(false);
                                                  setIsPayrollOpen(false);
                                                  setIsCCPOpen(false);
                                                  setIsServiceLifecycleManagementOpen(false);
                                                  setIsManagementPrintSystemOpen(false);
                                                  setIsProjectDetailsOpen(false);
                                                  setIsMarketingSystemOpen(false);
                                                }
                                              }}
                                              className="w-full flex items-center justify-between gap-3 px-3 py-2 rounded-lg text-left transition-colors text-gray-700 dark:text-gray-100 hover:bg-orange-50 dark:hover:bg-black"
                                            >
                                              <div className="flex items-center gap-3">
                                                <Archive className="h-4 w-4" />
                                                Inventory Management System
                                              </div>
                                              {isInventoryManagementSystemOpen ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
                                            </button>
                                            
                                            {isInventoryManagementSystemOpen && (
                                              <div className="ml-6 mt-2 space-y-1">
                                                <button
                                                  onClick={() => handleSelectTool('ims-dashboard')}
                                                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
                                                    activeMenuItem === 'ims-dashboard' 
                                                      ? 'bg-orange-50 text-orange-600 border-l-2 border-orange-400' 
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  <Home className="h-3 w-3" />
                                                  Dashboard
                                                </button>
                                                <button
                                                  onClick={() => handleSelectTool('ims-stock')}
                                                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
                                                    activeMenuItem === 'ims-stock' 
                                                      ? 'bg-orange-50 text-orange-600 border-l-2 border-orange-400' 
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  <Box className="h-3 w-3" />
                                                  Stock-In
                                                </button>
                                                <button
                                                  onClick={() => handleSelectTool('ims-stock-out')}
                                                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
                                                    activeMenuItem === 'ims-stock-out' 
                                                      ? 'bg-orange-50 text-orange-600 border-l-2 border-orange-400' 
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  <Package className="h-3 w-3" />
                                                  Stock-Out
                                                </button>
                                                <button
                                                  onClick={() => handleSelectTool('ims-stock-transfer')}
                                                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
                                                    activeMenuItem === 'ims-stock-transfer' 
                                                      ? 'bg-orange-50 text-orange-600 border-l-2 border-orange-400' 
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  <ArrowRightLeft className="h-3 w-3" />
                                                  Stock-Transfer
                                                </button>
                                                <button
                                                  onClick={() => handleSelectTool('ims-inventory')}
                                                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
                                                    activeMenuItem === 'ims-inventory' 
                                                      ? 'bg-orange-50 text-orange-600 border-l-2 border-orange-400' 
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  <Building className="h-3 w-3" />
                                                  Inventory
                                                </button>
                                                <button
                                                  onClick={() => handleSelectTool('ims-mif')}
                                                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
                                                    activeMenuItem === 'ims-mif' 
                                                      ? 'bg-orange-50 text-orange-600 border-l-2 border-orange-400' 
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  <Truck className="h-3 w-3" />
                                                  Machine in Field (MIF)
                                                </button>
                                                <button
                                                  onClick={() => handleSelectTool('ims-records')}
                                                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
                                                    activeMenuItem === 'ims-records' 
                                                      ? 'bg-orange-50 text-orange-600 border-l-2 border-orange-400' 
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  <ClipboardList className="h-3 w-3" />
                                                  Records
                                                </button>
                                                <button
                                                  onClick={() => handleSelectTool('ims-acquired-assets')}
                                                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
                                                    activeMenuItem === 'ims-acquired-assets' 
                                                      ? 'bg-orange-50 text-orange-600 border-l-2 border-orange-400' 
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  <Building className="h-3 w-3" />
                                                  Acquired Assets
                                                </button>
                                              </div>
                                            )}
                                          </div>
                                        )}

                                        {/* Service Lifecycle Management Main Tab */}
                                        {(user.permissions?.service_lifecycle_management_access || user.email === 'vinsimon23@gmail.com') && (
                                          <div>
                                            <button
                                              onClick={() => {
                                                const next = !isServiceLifecycleManagementOpen;
                                                setIsServiceLifecycleManagementOpen(next);
                                                if (next) {
                                                  setIsCCPOpen(false);
                                                  setIsHRISOpen(false);
                                                  setIsHumanResourcesInfoSystemOpen(false);
                                                  setIsNumoraOpen(false);
                                                  setIsPayrollOpen(false);
                                                  setIsInventoryManagementSystemOpen(false);
                                                  setIsManagementPrintSystemOpen(false);
                                                  setIsProjectDetailsOpen(false);
                                                  setIsMarketingSystemOpen(false);
                                                }
                                              }}
                                              className={`w-full flex items-center justify-between px-4 py-3 text-left transition-colors ${
                                                isServiceLifecycleManagementOpen ? 'bg-blue-100 text-blue-900 font-semibold' : 'text-gray-700 dark:text-gray-100 hover:bg-blue-50 dark:hover:bg-black'
                                              }`}
                                            >
                                              <span className="flex items-center">
                                                <ClipboardList className="h-5 w-5 mr-3" />
                                                Service Lifecycle Management
                                              </span>
                                              {isServiceLifecycleManagementOpen ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
                                            </button>

                                            {/* Service Lifecycle Management Submenu */}
                                            {isServiceLifecycleManagementOpen && (
                                              <div className="ml-8 space-y-1 mt-1">
                                                <button
                                                  onClick={() => setActiveMenuItem('service-lifecycle-dashboard')}
                                                  className={`w-full px-4 py-2 text-left text-sm transition-colors ${
                                                    activeMenuItem === 'service-lifecycle-dashboard'
                                                      ? 'bg-blue-50 text-blue-700 border-l-4 border-blue-500'
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  Dashboard
                                                </button>
                                                <button
                                                  onClick={() => setActiveMenuItem('service-lifecycle-fsr')}
                                                  className={`w-full px-4 py-2 text-left text-sm transition-colors ${
                                                    activeMenuItem === 'service-lifecycle-fsr'
                                                      ? 'bg-blue-50 text-blue-700 border-l-4 border-blue-500'
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  FSR
                                                </button>
                                                <button
                                                  onClick={() => setActiveMenuItem('service-lifecycle-quotation-request')}
                                                  className={`w-full px-4 py-2 text-left text-sm transition-colors ${
                                                    activeMenuItem === 'service-lifecycle-quotation-request'
                                                      ? 'bg-blue-50 text-blue-700 border-l-4 border-blue-500'
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  Quotation Request
                                                </button>
                                                <button
                                                  onClick={() => setActiveMenuItem('service-lifecycle-mif')}
                                                  className={`w-full px-4 py-2 text-left text-sm transition-colors ${
                                                    activeMenuItem === 'service-lifecycle-mif'
                                                      ? 'bg-blue-50 text-blue-700 border-l-4 border-blue-500'
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  Machine in Field (MIF)
                                                </button>
                                              </div>
                                            )}
                                          </div>
                                        )}

                                        {/* Management Print System Main Tab */}
                                        {(user.permissions?.management_print_system_access || user.email === 'vinsimon23@gmail.com') && (
                                          <div>
                                            <button
                                              onClick={() => {
                                                const next = !isManagementPrintSystemOpen;
                                                setIsManagementPrintSystemOpen(next);
                                                if (next) {
                                                  setIsHRISOpen(false);

                                                  setIsPayrollOpen(false);
                                                  setIsCCPOpen(false);

                                                }
                                              }}
                                              className={`w-full flex items-center justify-between px-4 py-3 text-left transition-colors ${
                                                activeMenuItem.startsWith('management-print-system') ? 'bg-violet-100 text-violet-900 font-semibold' : 'text-gray-700 dark:text-gray-100 hover:bg-violet-50 dark:hover:bg-black'
                                              }`}
                                              >
                                              <span className="flex items-center">
                                                <Printer className="h-5 w-5 mr-3" />
                                                Project Monitoring System
                                              </span>
                                              {isManagementPrintSystemOpen ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
                                            </button>

                                            {/* Project Monitoring System Submenu */}
                                            {isManagementPrintSystemOpen && (
                                              <div className="ml-8 space-y-1 mt-1">
                                                <button
                                                  onClick={() => setActiveMenuItem('management-print-system-dashboard')}
                                                  className={`w-full text-left px-4 py-2 text-sm transition-colors ${
                                                    activeMenuItem === 'management-print-system-dashboard'
                                                      ? 'bg-violet-50 text-violet-600 border-l-2 border-violet-400' 
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  Dashboard
                                                </button>
                                                <button
                                                  onClick={() => setActiveMenuItem('management-print-system-mps')}
                                                  className={`w-full text-left px-4 py-2 text-sm transition-colors ${
                                                    activeMenuItem === 'management-print-system-mps'
                                                      ? 'bg-violet-50 text-violet-600 border-l-2 border-violet-400' 
                                                      : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
                                                  }`}
                                                >
                                                  MPS
                                                </button>
                                              </div>
                                            )}
                                          </div>
                                        )}





                                        <SalesDepartmentToolsMenu
                                          user={user}
                                          isOpen={isProjectDetailsOpen}
                                          setIsOpen={setIsProjectDetailsOpen}
                                          activeMenuItem={activeMenuItem}
                                          handleSelectTool={handleSelectTool}
                                          closeOtherMenus={() => {
                                            setIsHRISOpen(false);
                                            setIsPayrollOpen(false);
                                            setIsCCPOpen(false);
                                            setIsManagementPrintSystemOpen(false);
                                            setIsMarketingSystemOpen(false);
                                          }}
                                        />

                                        {/* Settings Menu - Only visible to Super Admin */}
                                        {user.email === 'vinsimon23@gmail.com' && (
                                          <div className="mt-auto pt-4 border-t border-gray-200">
                                            <button
                                              onClick={() => setActiveMenuItem('settings')}
                                              className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg text-left transition-colors ${
                                                activeMenuItem === 'settings' 
                                                  ? 'bg-indigo-100 text-indigo-700 border-l-4 border-indigo-500' 
                                                  : 'text-gray-700 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-black'
                                              }`}
                                            >
                                              <Settings className="h-4 w-4" />
                                              Settings
                                            </button>
                                          </div>
                                        )}

                                      </nav>

                                      {/* User Info & Logout */}
                                      <div className="absolute bottom-0 left-0 right-0 w-64 border-t border-gray-200 dark:border-slate-800 bg-white dark:bg-slate-900">
                                        {/* Try New UI Entrypoint */}
                                        <div className="px-4 pt-4 pb-3">
                                          <Button
                                            onClick={() => navigate('/admin/new')}
                                            variant="outline"
                                            size="sm"
                                            className="w-full flex items-center justify-center gap-2 border-gradient-to-r from-accent-400 to-accent-500 text-accent-600 dark:text-accent-400 hover:bg-accent-50 dark:hover:bg-accent-900/20 border-dashed"
                                            style={{ borderImage: 'linear-gradient(to right, #facc15, #eab308) 1' }}
                                          >
                                            <span className="inline-block animate-pulse">&#10024;</span>
                                            <span className="font-medium text-sm">Try New UI</span>
                                            <ArrowRightLeft className="h-3.5 w-3.5" />
                                          </Button>
                                        </div>
                                        <div className="p-4 pt-3">
                                          <div className="flex items-center justify-between">
                                            <div>
                                              <p className="text-sm font-medium text-gray-900 dark:text-white dark:text-gray-100">{user.full_name}</p>
                                              <p className="text-xs text-gray-500 dark:text-gray-300 dark:text-gray-400">
                                                {user.is_super_admin ? 'Super Administrator' : 'Administrator'}
                                              </p>
                                            </div>
                                            <Button
                                              onClick={onLogout}
                                              variant="ghost"
                                              size="sm"
                                              className="text-gray-600 dark:text-gray-200 hover:text-gray-900 dark:text-white"
                                            >
                                              <LogOut className="h-4 w-4" />
                                            </Button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                    {/* Main Content Area */}
                                    <div className={`flex-1 overflow-hidden flex flex-col ${contentTheme.bg}`}>
                                      {/* Header */}
                                      <header className="bg-white dark:bg-slate-900 shadow-sm border-b border-gray-200 dark:border-slate-800 px-6 py-4 flex-shrink-0">
                                        <div className="flex items-center justify-between">
                                          <div className="flex items-center">
                                            <Button variant="ghost" size="icon" className="mr-4" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
                                              <Menu className="h-6 w-6" />
                                            </Button>
                                            <div>
                                            <h1 className="text-2xl font-bold text-gray-900 dark:text-white dark:text-gray-100">
                                              {activeMenuItem === 'org-chart' && 'Organizational Structure'}
                                              {activeMenuItem === 'dashboard' && 'Attendance Monitoring Dashboard'}
                                              {activeMenuItem === 'attendance' && 'Attendance History'}
                                              {activeMenuItem === 'reports' && 'Attendance Reports'}
                                              {activeMenuItem === 'schedules' && 'Employee Schedules'}
                                              {activeMenuItem === 'employees' && 'Employee Management'}
                                              {activeMenuItem === 'settings' && 'System Settings'}
                                              {activeMenuItem === 'payroll-dashboard' && 'Payroll Dashboard'}
                                              {activeMenuItem === 'new-employee' && 'New Employee Registration'}
                                              {activeMenuItem === 'employee-management' && 'Payroll Employee Management'}
                                              {activeMenuItem === 'payroll-loans' && 'Payroll Loans'}
                                              {activeMenuItem === 'payroll-attendance' && 'Generate Payroll Report'}
                                              {activeMenuItem === 'payslip' && 'Payslip Management'}
                                              {activeMenuItem === 'numora-sales-book' && 'Numora Sales Book'}
                                              {activeMenuItem === 'numora-cash-receipt-book' && 'Numora Cash Receipt Book'}
                                              {activeMenuItem === 'numora-accounts-payable-journal' && 'Numora Accounts Payable Journal'}
                                              {activeMenuItem === 'numora-cash-disbursement-book' && 'Numora Cash Disbursement Book'}
                                              {activeMenuItem === 'numora-journal-book' && 'Numora Journal Book'}
                                              
                                              {activeMenuItem === 'hris-dashboard' && 'HRIS Dashboard'}
                                              {activeMenuItem === 'hris-application-hub' && 'Application Hub'}
                                              {activeMenuItem === 'hris-candidates' && 'Candidates'}
                                              {activeMenuItem === 'hris-employees-201' && 'Employees 201 Files'}
                                              
                                              {activeMenuItem === 'ims-dashboard' && 'Inventory Dashboard'}
                                              {activeMenuItem === 'ims-machines' && 'Machines Inventory'}
                                              {activeMenuItem === 'ims-consumables' && 'Consumables Inventory'}
                                              {activeMenuItem === 'ims-spare-parts' && 'Spare Parts Inventory'}
                                              {activeMenuItem === 'ims-mif' && 'Machine in Field (MIF)'}
                                              {activeMenuItem === 'ims-others' && 'Other Inventory Items'}

                                              {activeMenuItem === 'project-details-focus-products' && 'Focus Products'}
                                              {activeMenuItem === 'ccp-project-details' && 'Project Details'}
                                              {activeMenuItem === 'service-lifecycle-dashboard' && 'Service Lifecycle Dashboard'}
                                              {activeMenuItem === 'service-lifecycle-fsr' && 'Field Service Report (FSR)'}
                                              {activeMenuItem === 'service-lifecycle-quotation-request' && 'Quotation Request'}
                                              {/* {activeMenuItem === 'ccp-project-computation' && 'Project Computation'} - Moved inside component */}
                                              {salesDepartmentToolsMeta?.title}
                                            </h1>
                                            <p className="text-gray-600 dark:text-gray-200 dark:text-gray-400">
                                              {activeMenuItem === 'org-chart' && 'iSource Asia Business Solutions Corporation - Redefining solutions... Empowering businesses'}
                                              {activeMenuItem === 'dashboard' && 'Monitor employee attendance and track daily activities'}
                                              {activeMenuItem === 'attendance' && 'Daily attendance snapshots'}
                                              {activeMenuItem === 'reports' && 'Generate and export attendance reports'}
                                              {activeMenuItem === 'schedules' && 'Manage employee work schedules'}
                                              {activeMenuItem === 'employees' && 'Manage employee information and profiles'}
                                              {activeMenuItem === 'settings' && 'Configure system settings and admin accounts'}
                                              {activeMenuItem === 'payroll-dashboard' && 'Overview of payroll system and employee management'}
                                              {activeMenuItem === 'new-employee' && 'Register existing HRIS employees for payroll'}
                                              {activeMenuItem === 'employee-management' && 'Manage payroll employee information'}
                                              {activeMenuItem === 'payroll-loans' && 'View and filter employee loan entries'}
                                              {activeMenuItem === 'payroll-attendance' && 'Generate attendance data and payslips with late and undertime tracking'}
                                              {activeMenuItem === 'payslip' && 'Generate and manage employee payslips'}
                                              {activeMenuItem === 'numora-sales-book' && 'Manage Numora sales book entries'}
                                              {activeMenuItem === 'numora-cash-receipt-book' && 'Manage Numora cash receipt book entries'}
                                              {activeMenuItem === 'numora-accounts-payable-journal' && 'Manage Numora accounts payable journal entries'}
                                              {activeMenuItem === 'numora-cash-disbursement-book' && 'Manage Numora cash disbursement book entries'}
                                              {activeMenuItem === 'numora-journal-book' && 'Manage Numora journal book entries'}
                                              
                                              {activeMenuItem === 'hris-dashboard' && 'Overview of Human Resources Information System'}
                                              {activeMenuItem === 'hris-application-hub' && 'Manage job applications'}
                                              {activeMenuItem === 'hris-candidates' && 'View and manage candidates'}
                                              {activeMenuItem === 'hris-employees-201' && 'Manage employee 201 files'}
                                              
                                              {activeMenuItem === 'ims-dashboard' && 'Overview of inventory status and metrics'}
                                              {activeMenuItem === 'ims-machines' && 'Manage machines inventory'}
                                              {activeMenuItem === 'ims-consumables' && 'Manage consumables inventory'}
                                              {activeMenuItem === 'ims-spare-parts' && 'Manage spare parts inventory'}
                                              {activeMenuItem === 'ims-mif' && 'Track machines deployed in the field'}
                                              {activeMenuItem === 'ims-others' && 'Manage other inventory items'}

                                              {salesDepartmentToolsMeta?.description}
                                              {activeMenuItem === 'ccp-project-details' && 'Manage project details and information'}
                                              {activeMenuItem === 'service-lifecycle-dashboard' && 'Service Lifecycle Management Dashboard'}
                                              {activeMenuItem === 'service-lifecycle-fsr' && 'Manage Field Service Reports'}
                                              {activeMenuItem === 'service-lifecycle-quotation-request' && 'Manage Quotation Requests'}
                                              {activeMenuItem === 'service-lifecycle-mif' && 'Machine in Field (MIF)'}
                                              {/* {activeMenuItem === 'ccp-project-computation' && (
                                        <ProjectComputation 
                                          axiosInstance={axiosInstance}
                                        />
                                      )} - Moved inside component */}
                                            </p>
                                            </div>
                                          </div>
                                          <div className="flex items-center space-x-4">
                                            <Button
                                              onClick={() => navigate('/admin/new')}
                                              variant="outline"
                                              size="sm"
                                              className="hidden sm:flex items-center gap-2 border-accent-300 text-accent-600 dark:text-accent-400 hover:bg-accent-50 dark:hover:bg-accent-900/20 dark:border-accent-600"
                                            >
                                              <span className="animate-pulse">&#10024;</span>
                                              <span className="font-medium">New Dashboard</span>
                                              <ArrowRightLeft className="h-3.5 w-3.5" />
                                            </Button>
                                            <Button
                                              variant="ghost"
                                              size="icon"
                                              onClick={() => setIsDarkMode(!isDarkMode)}
                                              className="mr-2"
                                            >
                                              {isDarkMode ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
                                            </Button>
                                            <span className="text-md text-green-500">
                                              {new Date().toLocaleString('en-US', { 
                                                timeZone: 'Asia/Taipei',
                                                weekday: 'long',
                                                year: 'numeric',
                                                month: 'long',
                                                day: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit'
                                              })} 
                                            </span>
                                          </div>
                                        </div>
                                      </header>

                                      {/* Content Area with proper height constraints */}
                                      <div className={`flex-1 min-h-0 overflow-y-auto p-6 rounded-xl border ${contentTheme.border} relative`}>
                                        {isLogoTransitionVisible && (
                                          <div className={`absolute inset-0 flex items-center justify-center bg-white transition-opacity duration-500 ease-in-out ${logoFadeVisible ? 'opacity-100' : 'opacity-0'}`} aria-live="polite">
                                            <img 
                                              src="https://customer-assets.emergentagent.com/job_hr-system-repair-1/artifacts/au3caisj_iSource%20LOGO.png" 
                                              alt="Loading"
                                              className="w-auto object-contain"
                                              style={{ height: '6rem', transform: `scale(${logoScaleUp ? 3 : 1})`, transition: 'transform 500ms ease-in-out' }}
                                            />
                                          </div>
                                        )}
                                        {!contentHiddenDuringTransition && (
                                        <div className={`transition-all duration-500 ease-in-out ${isContentEntering ? 'opacity-0 translate-y-2' : 'opacity-100 translate-y-0'}`}>
                                        {activeMenuItem === 'org-chart' && renderOrgChart()}
                                        {activeMenuItem === 'dashboard' && renderDashboard()}

                                        {activeMenuItem === 'attendance' && renderAttendanceByBranch()}
                                        {activeMenuItem === 'reports' && renderReports()}
                                        {activeMenuItem === 'schedules' && renderSchedules()}
                                        {activeMenuItem === 'employees' && renderEmployees()}
                                        {activeMenuItem === 'settings' && renderSettings()}
                                        {canAccessNumora && activeMenuItem === 'numora-sales-book' && <SalesBook />}
                                        {canAccessNumora && activeMenuItem === 'numora-cash-receipt-book' && <CashReceiptBook />}
                                        {canAccessNumora && activeMenuItem === 'numora-accounts-payable-journal' && <AccountsPayableJournal />}
                                        {canAccessNumora && activeMenuItem === 'numora-cash-disbursement-book' && <CashDisbursementBook />}
                                        {canAccessNumora && activeMenuItem === 'numora-journal-book' && <JournalBook />}
                                        {activeMenuItem === 'payroll-dashboard' && (
                                          <PayrollDashboardPage
                                            payrollStats={payrollStats}
                                            runningTotalPayrollDashboard={runningTotalPayrollDashboard}
                                            thisMonthPayroll={thisMonthPayroll}
                                            setActiveMenuItem={setActiveMenuItem}
                                          />
                                        )}
                                        {activeMenuItem === 'new-employee' && renderNewEmployee()}
                                        {activeMenuItem === 'employee-management' && renderEmployeeManagement()}
                                        {activeMenuItem === 'payroll-loans' && (
                                          <PayrollLoansPage
                                            loans={payrollLoans}
                                            isLoading={isLoadingPayrollLoans}
                                            filters={payrollLoansFilters}
                                            setFilters={setPayrollLoansFilters}
                                            branches={getUniqueBranches()}
                                            payrollEmployees={payrollEmployees}
                                            axiosInstance={axiosInstance}
                                            refreshLoans={fetchPayrollLoans}
                                            selectedLoanId={selectedPayrollLoanId}
                                            setSelectedLoanId={setSelectedPayrollLoanId}
                                          />
                                        )}
                                        {activeMenuItem === 'payroll-attendance' && (
                                          <PayrollGeneratePage
                                            generateTableTab={generateTableTab}
                                            setGenerateTableTab={setGenerateTableTab}
                                            payrollPeriod={payrollPeriod}
                                            setPayrollPeriod={setPayrollPeriod}
                                            mfAttendanceFilters={mfAttendanceFilters}
                                            setMfAttendanceFilters={setMfAttendanceFilters}
                                            payrollAttendanceFilters={payrollAttendanceFilters}
                                            setPayrollAttendanceFilters={setPayrollAttendanceFilters}
                                            holidays={holidays}
                                            setHolidays={setHolidays}
                                            generateBatchPayslips={generateBatchPayslips}
                                            isLoadingMfAttendance={isLoadingMfAttendance}
                                            isLoadingPayrollAttendance={isLoadingPayrollAttendance}
                                            isSavingPayrollBatch={isSavingPayrollBatch}
                                            saveAllPayrollPayslipByPeriod={saveAllPayrollPayslipByPeriod}
                                            generatedPayslips={generatedPayslips}
                                            setGeneratedPayslips={setGeneratedPayslips}
                                            setIsClearingMfAttendance={setIsClearingMfAttendance}
                                            setIsLoadingMfAttendance={setIsLoadingMfAttendance}
                                            setMfAttendanceData={setMfAttendanceData}
                                            setRawMfAttendanceData={setRawMfAttendanceData}
                                            setMfAttendanceAnalytics={setMfAttendanceAnalytics}
                                            setIsClearingPayrollAttendance={setIsClearingPayrollAttendance}
                                            setIsLoadingPayrollAttendance={setIsLoadingPayrollAttendance}
                                            setPayrollAttendanceData={setPayrollAttendanceData}
                                            setRawPayrollAttendanceData={setRawPayrollAttendanceData}
                                            setPayrollAttendanceAnalytics={setPayrollAttendanceAnalytics}
                                            setSelectedPayslipEmployee={setSelectedPayslipEmployee}
                                            isClearingMfAttendance={isClearingMfAttendance}
                                            isClearingPayrollAttendance={isClearingPayrollAttendance}
                                            setIsPayslipModalOpen={setIsPayslipModalOpen}
                                            fetchAndCalculatePayslipMf={fetchAndCalculatePayslipMf}
                                            fetchAndCalculatePayslip={fetchAndCalculatePayslip}
                                            computeDateRangeMonthCount={computeDateRangeMonthCount}
                                            normalizeDateRangeOrder={normalizeDateRangeOrder}
                                            selectedGeneratedPayslipEmployeeId={selectedGeneratedPayslipEmployeeId}
                                            selectedGeneratedPayslipRow={selectedGeneratedPayslipRow}
                                            handleGeneratedPayslipClick={handleGeneratedPayslipClick}
                                            isGeneratedPayslipSummaryOpen={isGeneratedPayslipSummaryOpen}
                                            setIsGeneratedPayslipSummaryOpen={setIsGeneratedPayslipSummaryOpen}
                                            selectedGeneratedPayslipEmployeeName={selectedGeneratedPayslipEmployeeName}
                                            renderPayslipCalculationSummary={renderPayslipCalculationSummary}
                                          />
                                        )}
                                        {activeMenuItem === 'payroll-database' && (
                                          <PayrollDatabasePage
                                            payrollRecords={payrollRecords}
                                            setPayrollRecords={setPayrollRecords}
                                            payrollEmployees={payrollEmployees}
                                            payrollLoans={payrollLoans}
                                            payrollDatabaseTab={payrollDatabaseTab}
                                            setPayrollDatabaseTab={setPayrollDatabaseTab}
                                            payrollDatabaseFilters={payrollDatabaseFilters}
                                            setPayrollDatabaseFilters={setPayrollDatabaseFilters}
                                            isLoadingPayrollRecords={isLoadingPayrollRecords}
                                            fetchPayrollRecords={fetchPayrollRecords}
                                            fetchPayrollPeriods={fetchPayrollPeriods}
                                            fetchPayrollRecordsByPeriod={fetchPayrollRecordsByPeriod}
                                            fetchAppSettings={fetchAppSettings}
                                            updateAppSettings={updateAppSettings}
                                            fetchMonthlyRecordsForEmployee={fetchMonthlyRecordsForEmployee}
                                            getUniqueBranches={getUniqueBranches}
                                            selectedPayrollRecordEmployeeKey={selectedPayrollRecordEmployeeKey}
                                            setSelectedPayrollRecordEmployeeKey={setSelectedPayrollRecordEmployeeKey}
                                            openPayslipModalForEdit={openPayslipModalForEdit}
                                            deletePayrollRecord={deletePayrollRecord}
                                            deletePayrollRecordsByPeriods={deletePayrollRecordsByPeriods}
                                            recalculatePayrollRecords={recalculatePayrollRecords}
                                            computeLiveAttendanceOverridesForRecord={async (record, { source } = {}) => {
                                              try {
                                                if (!record) return {};
                                                const src = (source === 'mf' || record?.deduction_settings?.mf_record === true) ? 'mf' : 'payroll';
                                                const sISO = String(record?.start_date || '').trim();
                                                const eISO = String(record?.end_date || '').trim();
                                                const empId = String(record?.employee_id || '').trim();
                                                if (!sISO || !eISO || !empId) return {};
                                                // Ensure ONE TRUE raw attendance data is loaded for this record's range
                                                const empName = String(record?.employee_name || empId);
                                                const filters = { name: empName, start_date: sISO, end_date: eISO };
                                                if (src === 'mf') {
                                                  try { await fetchMfAttendanceData(filters); } catch { /* noop */ }
                                                } else {
                                                  try { await fetchPayrollAttendanceData(filters); } catch { /* noop */ }
                                                }
                                                const rawData = src === 'mf' ? (rawMfAttendanceData || []) : (rawPayrollAttendanceData || []);
                                                const {
                                                  working_days, days_present, days_absent, half_days_present
                                                } = computeRawPresenceAbsenceForEmployee({
                                                  tab: src,
                                                  employeeId: empId,
                                                  startISO: sISO,
                                                  endISO: eISO,
                                                  rawAttendance: rawData,
                                                  peList: payrollEmployees || []
                                                });
                                                const dailyRate = parseFloat(record?.daily_rate) || 0;
                                                const halfMonth = (parseFloat(record?.half_month_salary) || 0);
                                                const lateMinutes = parseFloat(record?.minutes_late) || 0;
                                                const underMinutes = parseFloat(record?.minutes_undertime) || 0;
                                                const lateDed = parseFloat(record?.tardiness_deduction) || 0;
                                                const underDed = parseFloat(record?.undertime_deduction) || 0;
                                                const absenceDed = days_absent * dailyRate;
                                                const basicSal = Math.max(0, halfMonth - absenceDed - lateDed - underDed);
                                                const addIncomeArr = Array.isArray(record?.additional_income) ? record.additional_income : [];
                                                const addIncTotal = addIncomeArr.reduce((s, x) => (s + (parseFloat(x?.amount) || 0)), 0);
                                                let grossSal;
                                                if (src === 'mf') {
                                                  grossSal = basicSal + addIncTotal;
                                                } else {
                                                  const overtimeArr = Array.isArray(record?.overtime_pay) ? record.overtime_pay : [];
                                                  const overTotal = overtimeArr.reduce((s, x) => (s + (parseFloat(x?.amount) || 0)), 0);
                                                  grossSal = basicSal + overTotal + addIncTotal;
                                                }
                                                return {
                                                  working_days,
                                                  days_present,
                                                  days_absent,
                                                  half_days_present,
                                                  absence_deduction: absenceDed,
                                                  minutes_late: lateMinutes,
                                                  tardiness_deduction: lateDed,
                                                  minutes_undertime: underMinutes,
                                                  undertime_deduction: underDed,
                                                  half_month_salary: halfMonth,
                                                  basic_salary: basicSal,
                                                  gross_salary: grossSal,
                                                  additional_income_total: addIncTotal
                                                };
                                              } catch {
                                                return {};
                                              }
                                            }}
                                            normalizeExistingPayrollRecordsForTab={normalizeExistingPayrollRecordsForTab}
                                          />
                                        )}
                                        {activeMenuItem === 'employee-running-status' && renderEmployeeRunningStatus()}
{/* Pricing Template render call removed */}
                                        {activeMenuItem === 'ccp-project-details' && <ProjectDetails axiosInstance={axiosInstance} currentUser={user} />}
                                        {activeMenuItem === 'ccp-project-computation' && <ProjectComputation axiosInstance={axiosInstance} currentUser={user} />}
                                        {activeMenuItem === 'service-lifecycle-dashboard' && <ServiceLifecycleDashboard axiosInstance={axiosInstance} currentUser={user} />}
                                        {activeMenuItem === 'service-lifecycle-fsr' && <ServiceLifecycleFSR axiosInstance={axiosInstance} currentUser={user} />}
                                        {activeMenuItem === 'service-lifecycle-quotation-request' && <ServiceLifecycleQuotationRequest axiosInstance={axiosInstance} currentUser={user} />}
                                        {activeMenuItem === 'service-lifecycle-mif' && <MachineInField axiosInstance={axiosInstance} user={user} />}
                                        {activeMenuItem === 'management-print-system-dashboard' && rpZEAWYtiB6bJ16NuLbGCc6CZ6jJdKfb63()}
                                        {activeMenuItem === 'management-print-system-mps' && renderMPS()}
                                        
                                        {activeMenuItem === 'hris-dashboard' && <HRISDashboard />}
                                        {activeMenuItem === 'hris-candidates' && <Candidates axiosInstance={axiosInstance} />}
                                        {activeMenuItem === 'hris-employees-201' && <Employees201Files />}
                                        
                                        {activeMenuItem === 'ims-dashboard' && <IMSDashboard axiosInstance={axiosInstance} />}
                                        {activeMenuItem === 'ims-stock' && <StockIn axiosInstance={axiosInstance} />}
                                        {activeMenuItem === 'ims-stock-out' && <StockOut axiosInstance={axiosInstance} />}
                                      {activeMenuItem === 'ims-stock-transfer' && <StockTransfer axiosInstance={axiosInstance} />}
                                        {activeMenuItem === 'ims-inventory' && <Inventory axiosInstance={axiosInstance} />}
                                        {activeMenuItem === 'ims-machines' && <Machines />}
                                        {activeMenuItem === 'ims-consumables' && <Consumables />}
                                        {activeMenuItem === 'ims-spare-parts' && <SpareParts />}
                                        {activeMenuItem === 'ims-mif' && <MachineInField axiosInstance={axiosInstance} user={user} />}
                                        {activeMenuItem === 'ims-records' && <Records axiosInstance={axiosInstance} />}
                                      {activeMenuItem === 'ims-acquired-assets' && <AcquiredAssets axiosInstance={axiosInstance} />}

                                        {activeMenuItem === 'marketing-dashboard' && <MarketingDashboard />}
                                        {activeMenuItem === 'marketing-announcements' && <MarketingAnnouncements axiosInstance={axiosInstance} />}
                                        {isSalesDepartmentToolsRoute(activeMenuItem) && (
                                          <SalesDepartmentToolsContent {...salesDepartmentToolsProps} />
                                        )}
                                        </div>
                                        )}
                                      </div>
                                    </div>

                                    {/* Edit Attendance Dialog */}
                                    <Dialog open={isEditAttendanceDialogOpen} onOpenChange={setIsEditAttendanceDialogOpen}>
                                      <DialogContent>
                                        <DialogHeader>
                                          <DialogTitle>Edit Attendance Record</DialogTitle>
                                        </DialogHeader>
                                        {selectedAttendance && (
                                          <form onSubmit={handleUpdateAttendance} className="space-y-4">
                                            <div className="space-y-2">
                                              <Label>Employee</Label>
                                              <Input value={selectedAttendance.user_name} disabled />
                                            </div>
                                            
                                            {user.is_super_admin ? (
                                              <>
                                                <div className="space-y-2">
                                                  <Label>Date</Label>
                                                  <Input 
                                                    type="date"
                                                    value={selectedAttendance.editDate || ''}
                                                    onChange={(e) => setSelectedAttendance({
                                                      ...selectedAttendance, 
                                                      editDate: e.target.value
                                                    })}
                                                  />
                                                </div>
                                                
                                                <div className="space-y-2">
                                                  <Label>Time</Label>
                                                  <Input 
                                                    type="time"
                                                    step="1"
                                                    value={selectedAttendance.editTime || ''}
                                                    onChange={(e) => setSelectedAttendance({
                                                      ...selectedAttendance, 
                                                      editTime: e.target.value
                                                    })}
                                                  />
                                                </div>
                                              </>
                                            ) : (
                                              <div className="space-y-2">
                                                <Label>Date & Time</Label>
                                                <Input
                                                  value={formatDateFromBackend(selectedAttendance.timestamp) + ' ' + formatTimestampFromBackend(selectedAttendance.timestamp)}
                                                  disabled
                                                />
                                              </div>
                                            )}
                                            
                                            <div className="space-y-2">
                                              <Label>Type</Label>
                                              <Select
                                                value={selectedAttendance.type}
                                                onValueChange={(value) => setSelectedAttendance({...selectedAttendance, type: value})}
                                              >
                                                <SelectTrigger>
                                                  <SelectValue />
                                                </SelectTrigger>
                                                <SelectContent>
                                                  <SelectItem value="time_in">Time In</SelectItem>
                                                  <SelectItem value="time_out">Time Out</SelectItem>
                                                </SelectContent>
                                              </Select>
                                            </div>
                                            
                                            <div className="space-y-2">
                                              <Label>Comment</Label>
                                              <Textarea
                                                value={selectedAttendance.comment || ''}
                                                onChange={(e) => setSelectedAttendance({...selectedAttendance, comment: e.target.value})}
                                                placeholder="Add a comment..."
                                              />
                                            </div>
                                            
                                            <div className="flex justify-end space-x-2">
                                              <Button
                                                type="button"
                                                variant="outline"
                                                onClick={() => setIsEditAttendanceDialogOpen(false)}
                                              >
                                                Cancel
                                              </Button>
                                              <Button type="submit" className="bg-indigo-600 hover:bg-indigo-700">
                                                Update Record
                                              </Button>
                                            </div>
                                          </form>
                                        )}
                                      </DialogContent>
                                    </Dialog>

                                    {/* Photo Modal */}
                                    <PhotoModal 
                                      isOpen={isPhotoModalOpen}
                                      onClose={() => {
                                        setIsPhotoModalOpen(false);
                                        setSelectedPhotoRecord(null);
                                      }}
                                      record={selectedPhotoRecord}
                                    />

                                    {/* Comment Details Modal */}
                                    <Dialog open={isCommentModalOpen} onOpenChange={setIsCommentModalOpen}>
                                      <DialogContent className="max-w-2xl">
                                        <DialogHeader>
                                          <DialogTitle>Comment Details</DialogTitle>
                                        </DialogHeader>
                                        {selectedCommentRecord && (
                                          <div className="space-y-4">
                                            <div className="bg-gray-50 p-4 rounded-lg">
                                              <div className="grid grid-cols-2 gap-4">
                                                <div>
                                                  <span className="text-sm font-medium text-gray-600 dark:text-gray-200">Employee:</span>
                                                  <p className="text-sm text-gray-900 dark:text-white">{selectedCommentRecord.user_name}</p>
                                                </div>
                                                <div>
                                                  <span className="text-sm font-medium text-gray-600 dark:text-gray-200">Date & Time:</span>
                                                  <p className="text-sm text-gray-900 dark:text-white">
                                                    {formatDateFromBackend(selectedCommentRecord.timestamp)} at {formatTimestampFromBackend(selectedCommentRecord.timestamp)}
                                                  </p>
                                                </div>
                                                <div>
                                                  <span className="text-sm font-medium text-gray-600 dark:text-gray-200">Type:</span>
                                                  <p className="text-sm text-gray-900 dark:text-white">{selectedCommentRecord.type.replace('_', ' ').toUpperCase()}</p>
                                                </div>
                                                <div>
                                                  <span className="text-sm font-medium text-gray-600 dark:text-gray-200">Status:</span>
                                                  <p className="text-sm text-gray-900 dark:text-white">{selectedCommentRecord.status?.toUpperCase() || 'N/A'}</p>
                                                </div>
                                              </div>
                                            </div>
                                            
                                            <div>
                                              <span className="text-sm font-medium text-gray-600 dark:text-gray-200">Full Comment:</span>
                                              <div className="mt-2 p-4 bg-white border border-gray-200 rounded-lg">
                                                <p className="text-sm text-gray-900 dark:text-white whitespace-pre-wrap">
                                                  {selectedCommentRecord.comment || 'No comment provided'}
                                                </p>
                                              </div>
                                            </div>

                                            {selectedCommentRecord.location && (
                                              <div>
                                                <span className="text-sm font-medium text-gray-600 dark:text-gray-200">Location Details:</span>
                                                <div className="mt-2 p-4 bg-white border border-gray-200 rounded-lg">
                                                  <p className="text-sm text-gray-900 dark:text-white">
                                                    <strong>Address:</strong> {selectedCommentRecord.location.address || 'Unknown Address'}
                                                  </p>
                                                  {selectedCommentRecord.location.latitude && selectedCommentRecord.location.longitude && (
                                                    <p className="text-sm text-gray-600 dark:text-gray-200 mt-1">
                                                      <strong>Coordinates:</strong> {selectedCommentRecord.location.latitude.toFixed(6)}, {selectedCommentRecord.location.longitude.toFixed(6)}
                                                    </p>
                                                  )}
                                                </div>
                                              </div>
                                            )}

                                            <div className="flex justify-end">
                                              <Button 
                                                onClick={() => setIsCommentModalOpen(false)}
                                                variant="outline"
                                              >
                                                Close
                                              </Button>
                                            </div>
                                          </div>
                                        )}
                                      </DialogContent>
                                    </Dialog>

                                    {/* Edit Payroll Employee Dialog */}
                                    <Dialog open={isEditPayrollDialogOpen} onOpenChange={setIsEditPayrollDialogOpen}>
                                      <DialogContent className="max-w-2xl max-h-[90vh] overflow-auto">
                                        <DialogHeader>
                                          <DialogTitle className="text-xl font-bold text-indigo-700">
                                            Edit Payroll Employee
                                          </DialogTitle>
                                        </DialogHeader>
                                        {editingPayrollEmployee && (
                                          <form onSubmit={handleUpdatePayrollEmployee} className="space-y-6">
                                            {/* Employee Info (Read-only) */}
                                            <div className="bg-gray-50 p-4 rounded-lg">
                                              <h3 className="font-semibold text-gray-800 dark:text-white mb-2">Employee Information</h3>
                                              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                                                <div>
                                                  <span className="font-medium text-gray-600 dark:text-gray-200">Name:</span> {editingPayrollEmployee.full_name}
                                                </div>
                                                <div>
                                                  <span className="font-medium text-gray-600 dark:text-gray-200">Email:</span> {editingPayrollEmployee.email}
                                                </div>
                                                <div>
                                                  <span className="font-medium text-gray-600 dark:text-gray-200">Branch:</span> {editingPayrollEmployee.branch}
                                                </div>
                                                <div>
                                                  <span className="font-medium text-gray-600 dark:text-gray-200">Position:</span> {editingPayrollEmployee.position}
                                                </div>
                                              </div>
                                            </div>

                                            {/* Salary Information */}
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                              <div>
                                                <Label htmlFor="edit-salary">Monthly Salary (&#8369;)</Label>
                                                <Input
                                                  id="edit-salary"
                                                  type="number"
                                                  step="0.01"
                                                  value={payrollData.salary}
                                                  onChange={(e) => setPayrollData({...payrollData, salary: e.target.value})}
                                                  placeholder="Enter monthly salary"
                                                  required
                                                />
                                              </div>
                                              <div>
                                                <Label htmlFor="edit-leave-credits">Leave Credits</Label>
                                                <Input
                                                  id="edit-leave-credits"
                                                  type="number"
                                                  value={payrollData.leave_credits}
                                                  onChange={(e) => setPayrollData({...payrollData, leave_credits: e.target.value})}
                                                  placeholder="Enter leave credits"
                                                />
                                              </div>
                                              <div>
                                                <Label htmlFor="edit-tin">TIN Number</Label>
                                                <Input
                                                  id="edit-tin"
                                                  value={payrollData.tin_number}
                                                  onChange={(e) => setPayrollData({...payrollData, tin_number: e.target.value})}
                                                  placeholder="Enter TIN"
                                                />
                                              </div>
                                              <div>
                                                <Label htmlFor="edit-sssnum">SSS Number</Label>
                                                <Input
                                                  id="edit-sssnum"
                                                  value={payrollData.sss_number}
                                                  onChange={(e) => setPayrollData({...payrollData, sss_number: e.target.value})}
                                                  placeholder="Enter SSS"
                                                />
                                              </div>
                                              <div>
                                                <Label htmlFor="edit-phic">PhilHealth Number</Label>
                                                <Input
                                                  id="edit-phic"
                                                  value={payrollData.phic_number}
                                                  onChange={(e) => setPayrollData({...payrollData, phic_number: e.target.value})}
                                                  placeholder="Enter PhilHealth"
                                                />
                                              </div>
                                              <div>
                                                <Label htmlFor="edit-hdmf">Pag-IBIG Number</Label>
                                                <Input
                                                  id="edit-hdmf"
                                                  value={payrollData.hdmf_number}
                                                  onChange={(e) => setPayrollData({...payrollData, hdmf_number: e.target.value})}
                                                  placeholder="Enter Pag-IBIG"
                                                />
                                              </div>
                                            </div>

                                            {/* Allowances */}
                                            <div>
                                              <Label className="text-base font-semibold">Allowances</Label>
                                              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
                                                <div>
                                                  <Label htmlFor="edit-mf">MF Allowance (&#8369;)</Label>
                                                  <Input
                                                    id="edit-mf"
                                                    type="number"
                                                    step="0.01"
                                                    value={payrollData.allowances.mf}
                                                    onChange={(e) => setPayrollData({
                                                      ...payrollData, 
                                                      allowances: {...payrollData.allowances, mf: e.target.value}
                                                    })}
                                                    placeholder="0.00"
                                                  />
                                                </div>
                                                <div>
                                                  <Label htmlFor="edit-gas">Gas Allowance (&#8369;)</Label>
                                                  <Input
                                                    id="edit-gas"
                                                    type="number"
                                                    step="0.01"
                                                    value={payrollData.allowances.gas_allowance}
                                                    onChange={(e) => setPayrollData({
                                                      ...payrollData, 
                                                      allowances: {...payrollData.allowances, gas_allowance: e.target.value}
                                                    })}
                                                    placeholder="0.00"
                                                  />
                                                </div>
                                                <div>
                                                  <Label htmlFor="edit-load">Load Allowance (&#8369;)</Label>
                                                  <Input
                                                    id="edit-load"
                                                    type="number"
                                                    step="0.01"
                                                    value={payrollData.allowances.load_allowance}
                                                    onChange={(e) => setPayrollData({
                                                      ...payrollData, 
                                                      allowances: {...payrollData.allowances, load_allowance: e.target.value}
                                                    })}
                                                    placeholder="0.00"
                                                  />
                                                </div>
                                                <div>
                                                  <Label htmlFor="edit-housing">Housing Allowance (&#8369;)</Label>
                                                  <Input
                                                    id="edit-housing"
                                                    type="number"
                                                    step="0.01"
                                                    value={payrollData.allowances.housing_allowance}
                                                    onChange={(e) => setPayrollData({
                                                      ...payrollData, 
                                                      allowances: {...payrollData.allowances, housing_allowance: e.target.value}
                                                    })}
                                                    placeholder="0.00"
                                                  />
                                                </div>
                                              </div>
                                            </div>

                                            {/* Deductions */}
                                            <div>
                                              <Label className="text-base font-semibold">Government Deductions</Label>
                                              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2">
                                                {/* SSS */}
                                                <div className="flex items-center space-x-3">
                                                  <Switch
                                                    id="edit-sss"
                                                    checked={payrollData.deductions.sss}
                                                    onCheckedChange={(val) => setPayrollData({
                                                      ...payrollData,
                                                      deductions: { ...payrollData.deductions, sss: !!val }
                                                    })}
                                                  />
                                                  <Label htmlFor="edit-sss">SSS</Label>
                                                </div>
                                                {/* PhilHealth */}
                                                <div className="flex items-center space-x-3">
                                                  <Switch
                                                    id="edit-phic"
                                                    checked={payrollData.deductions.phic}
                                                    onCheckedChange={(val) => setPayrollData({
                                                      ...payrollData,
                                                      deductions: { ...payrollData.deductions, phic: !!val }
                                                    })}
                                                  />
                                                  <Label htmlFor="edit-phic">PhilHealth</Label>
                                                </div>
                                                {/* HDMF */}
                                                <div className="flex items-center space-x-3">
                                                  <Switch
                                                    id="edit-hdmf"
                                                    checked={payrollData.deductions.hdmf}
                                                    onCheckedChange={(val) => setPayrollData({
                                                      ...payrollData,
                                                      deductions: { ...payrollData.deductions, hdmf: !!val }
                                                    })}
                                                  />
                                                  <Label htmlFor="edit-hdmf">HDMF (Pag-IBIG)</Label>
                                                  <div className="ml-4 flex items-center space-x-2">
                                                    <Label className="text-sm text-purple-700">Additional (&#8369;)</Label>
                                                    <Input
                                                      type="number"
                                                      step="0.01"
                                                      placeholder="0.00"
                                                      value={payrollData.deductions.hdmf_additional}
                                                      onChange={(e) => setPayrollData({
                                                        ...payrollData,
                                                        deductions: { ...payrollData.deductions, hdmf_additional: e.target.value }
                                                      })}
                                                      className="w-28"
                                                      disabled={!payrollData.deductions.hdmf}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>

                                            {/* Tax and Minimum Wage Toggles */}
                                            <div className="flex items-center space-x-8 pt-6">
                                              {/* Tax Toggle */}
                                              <div className="flex items-center space-x-3">
                                                <Switch
                                                  id="edit-tax-enabled"
                                                  checked={payrollData.tax_enabled}
                                                  disabled={payrollData.is_minimum_wage}
                                                  onCheckedChange={(val) => setPayrollData({
                                                    ...payrollData,
                                                    tax_enabled: !!val
                                                  })}
                                                />
                                                <Label htmlFor="edit-tax-enabled" className={payrollData.is_minimum_wage ? 'text-gray-400' : ''}>
                                                  Tax Enabled
                                                </Label>
                                              </div>

                                              {/* Minimum Wage Toggle */}
                                              <div className="flex items-center space-x-3">
                                                <Switch
                                                  id="edit-minimum-wage"
                                                  checked={payrollData.is_minimum_wage}
                                                  onCheckedChange={(val) => setPayrollData({
                                                    ...payrollData,
                                                    is_minimum_wage: !!val,
                                                    tax_enabled: !!val ? false : true
                                                  })}
                                                />
                                                <Label htmlFor="edit-minimum-wage">Minimum Wage</Label>
                                              </div>
                                            </div>

                                            {/* Form Actions */}
                                            <div className="flex justify-end space-x-2 pt-4">
                                              <Button 
                                                type="button" 
                                                variant="outline" 
                                                onClick={() => {
                                                  setIsEditPayrollDialogOpen(false);
                                                  setEditingPayrollEmployee(null);
                                                }}
                                              >
                                                Cancel
                                              </Button>
                                              <Button type="submit" className="bg-indigo-600 hover:bg-indigo-700">
                                                Update Employee
                                              </Button>
                                            </div>
                                          </form>
                                        )}
                                      </DialogContent>
                                    </Dialog>

                                    {/* SSS Information Modal */}
                                    <Dialog open={showSSSInfoModal} onOpenChange={setShowSSSInfoModal}>
                                      <DialogContent className="max-w-4xl max-h-[90vh] overflow-auto">
                                        <DialogHeader>
                                          <DialogTitle className="text-xl font-bold text-blue-700">
                                            SSS Deduction Brackets (2025)
                                          </DialogTitle>
                                        </DialogHeader>
                                        <div className="space-y-4">
                                          <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                                            <h3 className="font-semibold text-blue-800 mb-3">Monthly SSS Deduction (Employee Share):</h3>
                                            <p className="text-sm text-blue-700 mb-4">
                                              SSS deduction is based on salary brackets. Find your salary range below to see your monthly contribution.
                                            </p>
                                            
                                            {/* SSS Brackets Table */}
                                            <div className="bg-white rounded-lg border border-blue-200 overflow-hidden">
                                              <table className="w-full text-sm">
                                                <thead className="bg-blue-100">
                                                  <tr>
                                                    <th className="px-4 py-3 text-left text-blue-800 font-semibold">Salary Range</th>
                                                    <th className="px-4 py-3 text-center text-blue-800 font-semibold">Employee Deduction</th>
                                                  </tr>
                                                </thead>
                                                <tbody className="divide-y divide-blue-100">
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">Below &#8369;5,250</td><td className="px-4 py-2 text-center font-medium">&#8369;250</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;5,250 - &#8369;5,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;275</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;5,750 - &#8369;6,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;300</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;6,250 - &#8369;6,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;325</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;6,750 - &#8369;7,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;350</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;7,250 - &#8369;7,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;375</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;7,750 - &#8369;8,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;400</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;8,250 - &#8369;8,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;425</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;8,750 - &#8369;9,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;450</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;9,250 - &#8369;9,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;475</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;9,750 - &#8369;10,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;500</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;10,250 - &#8369;10,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;525</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;10,750 - &#8369;11,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;550</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;11,250 - &#8369;11,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;575</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;11,750 - &#8369;12,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;600</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;12,250 - &#8369;12,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;625</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;12,750 - &#8369;13,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;650</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;13,250 - &#8369;13,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;675</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;13,750 - &#8369;14,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;700</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;14,250 - &#8369;14,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;725</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;14,750 - &#8369;15,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;750</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;15,250 - &#8369;15,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;775</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;15,750 - &#8369;16,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;800</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;16,250 - &#8369;16,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;825</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;16,750 - &#8369;17,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;850</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;17,250 - &#8369;17,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;875</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;17,750 - &#8369;18,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;900</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;18,250 - &#8369;18,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;925</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;18,750 - &#8369;19,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;950</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;19,250 - &#8369;19,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;975</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;19,750 - &#8369;20,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,000</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;20,250 - &#8369;20,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,025</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;20,750 - &#8369;21,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,050</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;21,250 - &#8369;21,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,075</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;21,750 - &#8369;22,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,100</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;22,250 - &#8369;22,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,125</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;22,750 - &#8369;23,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,150</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;23,250 - &#8369;23,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,175</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;23,750 - &#8369;24,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,200</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;24,250 - &#8369;24,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,225</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;24,750 - &#8369;25,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,250</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;25,250 - &#8369;25,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,275</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;25,750 - &#8369;26,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,300</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;26,250 - &#8369;26,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,325</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;26,750 - &#8369;27,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,350</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;27,250 - &#8369;27,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,375</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;27,750 - &#8369;28,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,400</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;28,250 - &#8369;28,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,425</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;28,750 - &#8369;29,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,450</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;29,250 - &#8369;29,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,475</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;29,750 - &#8369;30,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,500</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;30,250 - &#8369;30,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,525</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;30,750 - &#8369;31,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,550</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;31,250 - &#8369;31,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,575</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;31,750 - &#8369;32,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,600</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;32,250 - &#8369;32,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,625</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;32,750 - &#8369;33,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,650</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;33,250 - &#8369;33,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,675</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;33,750 - &#8369;34,249.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,700</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black"><td className="px-4 py-2">&#8369;34,250 - &#8369;34,749.99</td><td className="px-4 py-2 text-center font-medium">&#8369;1,725</td></tr>
                                                  <tr className="hover:bg-blue-50 dark:hover:bg-black bg-blue-200"><td className="px-4 py-2 font-semibold">&#8369;34,750 and above</td><td className="px-4 py-2 text-center font-bold">&#8369;1,750</td></tr>
                                                </tbody>
                                              </table>
                                            </div>
                                            
                                            <p className="text-xs text-blue-600 mt-3 italic">
                                              * SSS deduction is applied monthly only when "SSS" is enabled
                                            </p>
                                            <p className="text-xs text-blue-600 mt-1 italic">
                                              * Deduction amount is based on gross salary (before other deductions)
                                            </p>
                                          </div>
                                        </div>
                                      </DialogContent>
                                    </Dialog>

                                    {/* PhilHealth Information Modal */}
                                    <Dialog open={showPhilHealthInfoModal} onOpenChange={setShowPhilHealthInfoModal}>
                                      <DialogContent className="max-w-2xl">
                                        <DialogHeader>
                                          <DialogTitle className="text-xl font-bold text-red-700">
                                            PhilHealth Deduction Formula
                                          </DialogTitle>
                                        </DialogHeader>
                                        <div className="space-y-4">
                                          <div className="bg-red-50 p-4 rounded-lg border border-red-200">
                                            <h3 className="font-semibold text-red-800 mb-3">Monthly PhilHealth Deduction:</h3>
                                            <div className="space-y-3">
                                              <div className="bg-white p-3 rounded border border-red-200">
                                                <p className="text-lg font-medium text-red-800 mb-2">Formula:</p>
                                                <p className="text-2xl font-bold text-red-900 text-center bg-red-100 p-3 rounded">
                                                  (Monthly Salary &#215; 5%) &#247; 2
                                                </p>
                                              </div>
                                              <div className="text-sm text-red-700">
                                                <p className="mb-2"><strong>Explanation:</strong></p>
                                                <ul className="list-disc pl-5 space-y-1">
                                                  <li>PhilHealth contribution is 5% of monthly basic salary</li>
                                                  <li>Employee pays half (50%) of the total contribution</li>
                                                  <li>Employer pays the other half (50%)</li>
                                                  <li>Therefore: Employee Deduction = (Monthly Salary &#215; 5%) &#247; 2</li>
                                                  <li className="font-semibold text-red-800">Deducted only on the 15th payroll (first half of the month)</li>
                                                </ul>
                                              </div>
                                              <div className="bg-red-100 p-3 rounded border border-red-300">
                                                <p className="text-sm text-red-800"><strong>Example:</strong></p>
                                                <p className="text-sm text-red-700">If monthly salary = &#8369;30,000:</p>
                                                <p className="text-sm text-red-700">PhilHealth deduction = (&#8369;30,000 &#215; 5%) &#247; 2 = &#8369;750</p>
                                                <p className="text-sm text-red-700 mt-1 italic">This &#8369;750 is deducted only on the 15th payroll</p>
                                              </div>
                                            </div>
                                            <p className="text-xs text-red-600 mt-3 italic">
                                              * Deduction is applied once per month (15th payroll only) when "PhilHealth" is enabled
                                            </p>
                                          </div>
                                        </div>
                                      </DialogContent>
                                    </Dialog>

                                    {/* HDMF (Pag-IBIG) Information Modal */}
                                    <Dialog open={showHDMFInfoModal} onOpenChange={setShowHDMFInfoModal}>
                                      <DialogContent className="max-w-2xl">
                                        <DialogHeader>
                                          <DialogTitle className="text-xl font-bold text-purple-700">
                                            HDMF (Pag-IBIG) Deduction Information
                                          </DialogTitle>
                                        </DialogHeader>
                                        <div className="space-y-4">
                                          <div className="bg-purple-50 p-4 rounded-lg border border-purple-200">
                                            <h3 className="font-semibold text-purple-800 mb-3">Monthly HDMF Deduction:</h3>
                                            <div className="space-y-3">
                                              <div className="bg-white p-3 rounded border border-purple-200">
                                                <p className="text-lg font-medium text-purple-800 mb-2">Fixed Rate:</p>
                                                <p className="text-4xl font-bold text-purple-900 text-center bg-purple-100 p-4 rounded">
                                                  &#8369;200
                                                </p>
                                              </div>
                                              <div className="text-sm text-purple-700">
                                                <p className="mb-2"><strong>HDMF (Home Development Mutual Fund) Details:</strong></p>
                                                <ul className="list-disc pl-5 space-y-1">
                                                  <li>Also known as Pag-IBIG Fund</li>
                                                  <li>Fixed monthly contribution of &#8369;200 for employees</li>
                                                  <li>Employer also contributes &#8369;200 monthly</li>
                                                  <li>Used for housing loans, savings, and other benefits</li>
                                                </ul>
                                              </div>
                                              <div className="bg-purple-100 p-3 rounded border border-purple-300">
                                                <p className="text-sm text-purple-800"><strong>Note:</strong></p>
                                                <p className="text-sm text-purple-700">This is a standard fixed rate regardless of salary amount</p>
                                              </div>
                                            </div>
                                            <p className="text-xs text-purple-600 mt-3 italic">
                                              * Deduction is applied monthly only when "HDMF (Pag-IBIG)" is enabled
                                            </p>
                                          </div>
                                        </div>
                                      </DialogContent>
                                    </Dialog>

                                    {/* Tax Information Modal */}
                                    <Dialog open={showTaxInfoModal} onOpenChange={setShowTaxInfoModal}>
                                      <DialogContent className="max-w-4xl max-h-[90vh] overflow-auto">
                                        <DialogHeader>
                                          <DialogTitle className="text-xl font-bold text-blue-700">
                                            BIR Withholding Tax Table (Effective January 1, 2023)
                                          </DialogTitle>
                                        </DialogHeader>
                                        <div className="space-y-4">
                                          {/* Tax Rules Description */}
                                          <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                                            <h3 className="font-semibold text-blue-800 mb-3">Monthly Tax Deduction Formula:</h3>
                                            <div className="space-y-2 text-sm text-blue-700">
                                              <div className="flex justify-between">
                                                <span className="font-medium">&#8369;20,833 and below:</span>
                                                <span>0% tax</span>
                                              </div>
                                              <div className="flex justify-between">
                                                <span className="font-medium">&#8369;20,834 - &#8369;33,332:</span>
                                                <span>(amount - &#8369;20,833) &#215; 15%</span>
                                              </div>
                                              <div className="flex justify-between">
                                                <span className="font-medium">&#8369;33,333 - &#8369;66,666:</span>
                                                <span>(amount - &#8369;33,333) &#215; 20% + &#8369;1,875</span>
                                              </div>
                                              <div className="flex justify-between">
                                                <span className="font-medium">&#8369;66,667 - &#8369;166,666:</span>
                                                <span>(amount - &#8369;66,667) &#215; 25% + &#8369;8,541.80</span>
                                              </div>
                                              <div className="flex justify-between">
                                                <span className="font-medium">&#8369;166,667 - &#8369;666,666:</span>
                                                <span>(amount - &#8369;166,667) &#215; 30% + &#8369;33,541.80</span>
                                              </div>
                                              <div className="flex justify-between">
                                                <span className="font-medium">&#8369;666,667 and above:</span>
                                                <span>(amount - &#8369;666,667) &#215; 35% + &#8369;183,541.80</span>
                                              </div>
                                            </div>
                                            <p className="text-xs text-blue-600 mt-3 italic">
                                              * Tax deduction is applied monthly only when "Tax Enabled" is activated
                                            </p>
                                          </div>
                                          
                                          {/* BIR Tax Table Image */}
                                          <div className="bg-white border border-gray-200 rounded-lg p-4">
                                            <h4 className="font-semibold text-gray-800 dark:text-white mb-3">Official BIR Withholding Tax Table:</h4>
                                            <div className="flex justify-center max-h-[70vh] overflow-auto">
                                              <img 
                                                src="https://customer-assets.emergentagent.com/job_attendancesuite/artifacts/7cdveomq_BIR-Withholding-Tax-Table-effective-January-1-2023-2048x1054.png"
                                                alt="BIR Withholding Tax Table"
                                                className="max-w-full h-auto rounded-lg shadow-md"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </DialogContent>
                                    </Dialog>

                                    {/* Payslip Modal */}
                                    <Dialog open={isPayslipModalOpen} onOpenChange={(open) => {
                                      setIsPayslipModalOpen(open);
                                      if (!open) {
                                        // Reset states when closing
                                        setAdditionalIncome([]);
                                        setAdditionalDeductions([]);
                                        setOtHours(0);
                                        setHolidayHours(0);
                                        setIsEditingPayslipRecord(false);
                                        setEditingPayslipRecordMeta(null);
                                      }
                                    }}>
                                      <DialogContent className="max-w-5xl max-h-[95vh] overflow-auto">
                                        <DialogHeader>
                                          <DialogTitle className="text-xl font-bold text-indigo-700">
                                            {generateTableTab === 'mf' ? 'MF Payslip' : 'Employee Payslip'}
                                          </DialogTitle>
                                        </DialogHeader>
                                        
                                        {((generateTableTab === 'mf' ? mfAttendanceFilters.name : payrollAttendanceFilters.name)) && (generateTableTab === 'mf' ? mfSelectedPayslipEmployee : selectedPayslipEmployee) ? (
                                          <div className="space-y-4">
                                            {/* Payroll Period Input */}
                                            <Card className="bg-blue-50 border-blue-200">
                                              <CardContent className="p-4">
                                                <Label className="text-sm font-medium text-blue-800">Payroll Period</Label>
                                                <Input
                                                  placeholder="e.g., 1st Half of January 2025"
                                                  value={payrollPeriod}
                                                  onChange={(e) => setPayrollPeriod(e.target.value)}
                                                  className="mt-2"
                                                />
                                              </CardContent>
                                            </Card>

                                            {/* Payslip Content - Print/Export Ready */}
                                            <div id="payslip-content">
                                              {(() => {
                                                const activeFilters = generateTableTab === 'mf' ? mfAttendanceFilters : payrollAttendanceFilters;
                                                const activeEmployee = generateTableTab === 'mf' ? mfSelectedPayslipEmployee : selectedPayslipEmployee;
                                                const previewGenRow = getGeneratedPayslipRowForSelection(
                                                  generateTableTab,
                                                  selectedGeneratedPayslipEmployeeId,
                                                  activeFilters?.start_date,
                                                  activeFilters?.end_date
                                                );

                                                let dialogRawDaysPresent = 0;
                                                let dialogRawDaysAbsent = 0;
                                                let dialogRawHalfDaysPresent = 0;
                                                let dialogEmployeeWorkingDays = 0;
                                                if (!isEditingPayslipRecord) {
                                                  try {
                                                    const normalizeId = (v) => {
                                                      const raw = String(v ?? '').trim();
                                                      if (!raw) return '';
                                                      if (/^\d+$/.test(raw)) return raw.replace(/^0+(?=\d)/, '');
                                                      return raw;
                                                    };
                                                    const vr = validateDateRangeTaipei(activeFilters?.start_date, activeFilters?.end_date);
                                                    const startISO = vr.ok ? vr.startISO : String(activeFilters?.start_date || '').trim();
                                                    const endISO = vr.ok ? vr.endISO : String(activeFilters?.end_date || '').trim();
                                                    const selectedId = normalizeId(selectedGeneratedPayslipEmployeeId)
                                                      || normalizeId(activeEmployee?.employee_id)
                                                      || normalizeId(activeEmployee?.id);
                                                    if (selectedId && startISO && endISO) {
                                                      let isSixDay = false;
                                                      let foundPe = null;
                                                      if (previewGenRow) {
                                                        const basis = previewGenRow.daily_rate_formula || previewGenRow.rate_formula || previewGenRow.dailyRateFormula;
                                                        if (String(basis) === '313' || basis === 313) isSixDay = true;
                                                        if (previewGenRow.employee_id) {
                                                          foundPe = payrollEmployees.find((pe) =>
                                                            normalizeId(pe?.employee_id) === normalizeId(previewGenRow.employee_id)
                                                          );
                                                        }
                                                      }
                                                      if (!foundPe) {
                                                        foundPe = payrollEmployees.find((pe) =>
                                                          normalizeId(pe?.employee_id) === selectedId
                                                        );
                                                      }
                                                      if (!foundPe && activeEmployee) {
                                                        const basis = activeEmployee.daily_rate_formula || activeEmployee.rate_formula || activeEmployee.dailyRateFormula;
                                                        if (String(basis) === '313' || basis === 313) isSixDay = true;
                                                      } else if (foundPe) {
                                                        const basis = foundPe.daily_rate_formula || foundPe.rate_formula || foundPe.dailyRateFormula;
                                                        if (String(basis) === '313' || basis === 313) isSixDay = true;
                                                      }
                                                      const s = new Date(startISO + 'T00:00:00+08:00');
                                                      const e = new Date(endISO + 'T00:00:00+08:00');
                                                      let dw = new Date(s);
                                                      while (dw <= e) {
                                                        const dow = taipeiDayOfWeek(dw);
                                                        if (isSixDay ? (dow !== 0) : (dow !== 0 && dow !== 6)) dialogEmployeeWorkingDays++;
                                                        dw = addDays(dw, 1);
                                                      }
                                                      const sExt = addDays(new Date(startISO + 'T00:00:00+08:00'), -3);
                                                      const eExt = addDays(new Date(endISO + 'T00:00:00+08:00'), 3);
                                                      const sExtISO = isoDateTaipei(sExt);
                                                      const eExtISO = isoDateTaipei(eExt);

                                                      const oneTrueRaw = generateTableTab === 'mf'
                                                        ? (rawMfAttendanceData || [])
                                                        : (rawPayrollAttendanceData || []);
                                                      const empRawRecords = oneTrueRaw.filter((r) => {
                                                        if (!r) return false;
                                                        const rid = normalizeId(r.user_id);
                                                        if (rid !== selectedId) return false;
                                                        const t = String(r?.type || '').toLowerCase().trim();
                                                        if (t !== 'time_in' && t !== 'time_out') return false;
                                                        let dateISO;
                                                        try { dateISO = toTaipeiISODate(r.timestamp); } catch { return false; }
                                                        return !!dateISO && dateISO >= sExtISO && dateISO <= eExtISO;
                                                      });

                                                      const baseCredit = {};
                                                      {
                                                        const { perEmployeeDates } = aggregateFirstLastMinutes(empRawRecords, { startISO: sExtISO, endISO: eExtISO });
                                                        const employeeDates = perEmployeeDates[selectedId] || {};
                                                        let cur = new Date(sExt);
                                                        while (cur <= eExt) {
                                                          if (isWorkingDayForBasis(cur, isSixDay)) {
                                                            const iso = isoDateTaipei(cur);
                                                            const day = employeeDates?.[iso];
                                                            const hasIn = !!day?.has_time_in;
                                                            const hasOut = !!day?.has_time_out;
                                                            const hd = day ? detectHalfDayStatus(day.first_in, day.last_out) : null;
                                                            const isHalf = !!(hd && hd.isHalfDay);
                                                            let c = 0;
                                                            if (hasIn && hasOut && !isHalf) c = 1;
                                                            else if (hasIn || hasOut || isHalf) c = 0.5;
                                                            baseCredit[iso] = c;
                                                          }
                                                          cur = addDays(cur, 1);
                                                        }
                                                      }

                                                      if (isSixDay) {
                                                        let satCur = new Date(s);
                                                        while (satCur <= e) {
                                                          if (taipeiDayOfWeek(satCur) === 6) {
                                                            const satISO = isoDateTaipei(satCur);
                                                            const key = `${selectedId}_${satISO}`;
                                                            const override = saturdayOverrides?.[key];
                                                            const rawCreditSat = typeof baseCredit[satISO] === 'number' ? baseCredit[satISO] : 0;
                                                            let prevPresent = false;
                                                            for (let off = 1; off <= 3; off++) {
                                                              const dCheck = addDays(satCur, -off);
                                                              if (dCheck < sExt) break;
                                                              if (!isWorkingDayForBasis(dCheck, isSixDay)) continue;
                                                              const isoCheck = isoDateTaipei(dCheck);
                                                              if ((typeof baseCredit[isoCheck] === 'number' ? baseCredit[isoCheck] : 0) > 0) {
                                                                prevPresent = true; break;
                                                              }
                                                            }
                                                            let nextPresent = false;
                                                            for (let off = 1; off <= 3; off++) {
                                                              const dCheck = addDays(satCur, off);
                                                              if (dCheck > eExt) break;
                                                              if (!isWorkingDayForBasis(dCheck, isSixDay)) continue;
                                                              const isoCheck = isoDateTaipei(dCheck);
                                                              if ((typeof baseCredit[isoCheck] === 'number' ? baseCredit[isoCheck] : 0) > 0) {
                                                                nextPresent = true; break;
                                                              }
                                                            }
                                                            const eligible = prevPresent && nextPresent;
                                                            baseCredit[satISO] = resolveSaturdayCredit({
                                                              rawCredit: rawCreditSat,
                                                              eligible,
                                                              override
                                                            });
                                                          }
                                                          satCur = addDays(satCur, 1);
                                                        }
                                                      }

                                                      Object.entries(baseCredit).forEach(([iso, credit]) => {
                                                        if (iso < startISO || iso > endISO) return;
                                                        if (credit === 1) dialogRawDaysPresent += 1;
                                                        else if (credit === 0.5) {
                                                          dialogRawDaysPresent += 0.5;
                                                          dialogRawHalfDaysPresent += 1;
                                                        }
                                                      });
                                                      dialogRawDaysAbsent = Math.max(0, dialogEmployeeWorkingDays - dialogRawDaysPresent);
                                                    }
                                                  } catch (e) {
                                                    dialogRawDaysPresent = 0;
                                                    dialogRawDaysAbsent = 0;
                                                    dialogRawHalfDaysPresent = 0;
                                                    dialogEmployeeWorkingDays = 0;
                                                  }
                                                }

                                                const basePreviewAnalytics = generateTableTab === 'mf' ? mfAttendanceAnalytics : payrollAttendanceAnalytics;
                                                const editSnapshot = editingPayslipRecordMeta?.fullRecord || editingPayslipRecordMeta?.recordSnapshot || null;
                                                const previewSummaryAnalytics = isEditingPayslipRecord && editSnapshot ? {
                                                  ...(basePreviewAnalytics || {}),
                                                  working_days: (parseFloat(editSnapshot?.days_absent) || 0) + (parseFloat(editSnapshot?.days_present) || 0),
                                                  days_present: parseFloat(editSnapshot?.days_present) || 0,
                                                  days_absent: parseFloat(editSnapshot?.days_absent) || 0,
                                                  half_days_present: parseFloat(editSnapshot?.half_days_present) || 0,
                                                  total_minutes_late: parseFloat(editSnapshot?.minutes_late) || 0,
                                                  total_minutes_undertime: parseFloat(editSnapshot?.minutes_undertime) || 0,
                                                  daily_rate: parseFloat(editSnapshot?.daily_rate) || basePreviewAnalytics?.daily_rate || 0,
                                                  total_gross_pay: Number.isFinite(parseFloat(editSnapshot?.gross_salary))
                                                    ? parseFloat(editSnapshot.gross_salary)
                                                    : (basePreviewAnalytics?.total_gross_pay || 0)
                                                } : (previewGenRow ? {
                                                  ...basePreviewAnalytics,
                                                  working_days: dialogEmployeeWorkingDays || (basePreviewAnalytics?.working_days || 0),
                                                  days_present: dialogRawDaysPresent,
                                                  days_absent: dialogRawDaysAbsent,
                                                  half_days_present: dialogRawHalfDaysPresent,
                                                  total_minutes_late: parseFloat(previewGenRow.minutes_late) || (basePreviewAnalytics?.total_minutes_late) || 0,
                                                  total_minutes_undertime: parseFloat(previewGenRow.minutes_undertime) || (basePreviewAnalytics?.total_minutes_undertime) || 0,
                                                  daily_rate: parseFloat(previewGenRow.daily_rate) || basePreviewAnalytics?.daily_rate || 0,
                                                  total_gross_pay: Number.isFinite(parseFloat(previewGenRow.gross_salary)) ? parseFloat(previewGenRow.gross_salary) : (basePreviewAnalytics?.total_gross_pay || 0)
                                                } : {
                                                  ...(basePreviewAnalytics || {}),
                                                  working_days: dialogEmployeeWorkingDays || (basePreviewAnalytics?.working_days || 0),
                                                  days_present: dialogRawDaysPresent,
                                                  days_absent: dialogRawDaysAbsent,
                                                  half_days_present: dialogRawHalfDaysPresent
                                                });
                                                const holidayList = (() => {
                                                  const range = activeFilters || {};
                                                  const vr = validateDateRangeTaipei(range.start_date, range.end_date);
                                                  if (isEditingPayslipRecord && Array.isArray(editingPayslipRecordMeta?.holidays)) {
                                                    return editingPayslipRecordMeta.holidays;
                                                  }
                                                  return vr.ok
                                                    ? sanitizeHolidayRows(holidays).filter((h) => h.date >= vr.startISO && h.date <= vr.endISO)
                                                    : [];
                                                })();
                                                const buildAmountItems = (items, dailyRateToUse) => {
                                                  const minuteRate = dailyRateToUse / 8 / 60;
                                                  return (Array.isArray(items) ? items : []).map((item) => {
                                                    const unit = item.unit || 'minutes';
                                                    let amount = 0;
                                                    if (unit === 'amount') amount = parseFloat(item.amount) || 0;
                                                    else if (unit === 'days') amount = (parseFloat(item.days) || 0) * dailyRateToUse;
                                                    else amount = minuteRate * (parseFloat(item.minutes) || 0);
                                                    return { ...item, amount };
                                                  });
                                                };

                                                if (isEditingPayslipRecord && editSnapshot) {
                                                  const editSavedTiles = editSnapshot?.tiles || {};
                                                  const editSavedIncome = editSavedTiles?.income_breakdown || {};
                                                  const editSavedDed = editSavedTiles?.deductions || {};
                                                  const editSavedNet = editSavedTiles?.net_pay || {};
                                                  const editedLoanCycles = Array.isArray(editingPayslipRecordMeta?.loanCycles) ? editingPayslipRecordMeta.loanCycles : (Array.isArray(editSnapshot?.deduction_settings?.loan_cycles) ? editSnapshot.deduction_settings.loan_cycles : []);
                                                  const numVal = (v) => {
                                                    if (v === undefined || v === null || Number.isNaN(v)) return null;
                                                    if (typeof v === 'number') return Number.isFinite(v) ? v : null;
                                                    const p = parseFloat(String(v).replace(/,/g, '').trim());
                                                    return Number.isFinite(p) ? p : null;
                                                  };
                                                  const overrideOr = (editVal, snapVal, def) => {
                                                    const e = numVal(editVal);
                                                    if (e !== null) return e;
                                                    const s = numVal(snapVal);
                                                    if (s !== null) return s;
                                                    const d = numVal(def);
                                                    return d !== null ? d : 0;
                                                  };
                                                  const isMf = generateTableTab === 'mf';
                                                  const localLoanN = (v) => {
                                                    if (v === null || v === undefined) return 0;
                                                    if (typeof v === 'number') return Number.isFinite(v) ? v : 0;
                                                    const p = parseFloat(String(v).replace(/,/g, '').trim());
                                                    return Number.isFinite(p) ? p : 0;
                                                  };
                                                  const localLoanRowAmount = (row) => localLoanN(row?.deducted_amount ?? row?.scheduled_amount ?? row?.deduct_per_cutoff ?? row?.amount);
                                                  const activeSelectionMap = isMf ? (mfLoanDeductionSelections || {}) : (loanDeductionSelections || {});
                                                  const editLoanRows = editedLoanCycles
                                                    .filter((cycle) => {
                                                      const status = String(cycle?.cycle_status || '').trim().toLowerCase();
                                                      if (status === 'skipped') return false;
                                                      const lid = String(cycle?.loan_id || '').trim();
                                                      if (lid && activeSelectionMap[lid] === false) return false;
                                                      return true;
                                                    })
                                                    .map((cycle) => ({
                                                      ...cycle,
                                                      isSelected: (() => {
                                                        const lid = String(cycle?.loan_id || '').trim();
                                                        if (lid && activeSelectionMap[lid] === false) return false;
                                                        return true;
                                                      })()
                                                    }));
                                                  const editLoanFormTypes = editLoanRows
                                                    .map((row) => String(row?.loan_label || row?.loan_subtype || row?.title || row?.description || '').trim())
                                                    .filter(Boolean);
                                                  const editLoanDeductionPerCutoffTotal = editLoanRows.reduce((s, r) => s + localLoanRowAmount(r), 0);
                                                  const editLoanSummary = { rows: editLoanRows, loanDeductionPerCutoffTotal: editLoanDeductionPerCutoffTotal, loanFormTypes: editLoanFormTypes };

                                                  const dailyRateToUse = overrideOr(null, editSnapshot?.daily_rate, 0);
                                                  const incomeItems = buildAmountItems(additionalIncome, dailyRateToUse);
                                                  const deductionItems = buildAmountItems(additionalDeductions, dailyRateToUse);
                                                  const otAmount = (dailyRateToUse / 8) * 1.25 * (parseFloat(otHours) || 0);
                                                  const holidayAmount = (dailyRateToUse / 8) * 1.3 * (parseFloat(holidayHours) || 0);
                                                  const mfLoanCyclesLocal = isMf ? editedLoanCycles : [];
                                                  const payrollLoanCyclesLocal = !isMf ? editedLoanCycles : [];

                                                  const snapshotSavedCycles = Array.isArray(editingPayslipRecordMeta?.loanCycles)
                                                    ? editingPayslipRecordMeta.loanCycles
                                                    : (Array.isArray(editSnapshot?.deduction_settings?.loan_cycles) ? editSnapshot.deduction_settings.loan_cycles : []);
                                                  const snapshotHolidaysArr = Array.isArray(editingPayslipRecordMeta?.holidays)
                                                    ? editingPayslipRecordMeta.holidays
                                                    : (Array.isArray(editSnapshot?.holidays) ? editSnapshot.holidays : holidayList);

                                                  const result = computeEditPayrollSaveSnapshot({
                                                    source: isMf ? 'mf' : 'payroll',
                                                    snapshot: editSnapshot,
                                                    holidaysArr: snapshotHolidaysArr,
                                                    payslipDeductions: { ...payslipDeductions },
                                                    additionalIncomeFormItems: additionalIncome,
                                                    additionalDeductionsFormItems: additionalDeductions,
                                                    overtimePayFormItems: overtimePay,
                                                    otHours,
                                                    holidayHours,
                                                    loanSelectionMap: isMf ? { ...mfLoanDeductionSelections } : { ...loanDeductionSelections },
                                                    savedLoanCycles: snapshotSavedCycles,
                                                    payrollEmployeeData,
                                                    isGeneratedLoanDeductionItemFn: isGeneratedLoanDeductionItem
                                                  });

                                                  const tl = result.topLevelFields;
                                                  const previewLoanRows = result.loanPreviewSummaryRows || [];
                                                  const previewLoanFormTypes = previewLoanRows
                                                    .map((row) => String(row?.loan_label || row?.loan_subtype || '').trim())
                                                    .filter(Boolean);
                                                  const localPreviewLoanAmount = (r) => Number(r?.deducted_amount ?? r?.scheduled_amount ?? 0) || 0;
                                                  const previewLoanDeductionTotal = previewLoanRows.reduce((s, r) => s + localPreviewLoanAmount(r), 0);
                                                  const previewLoanSummary = {
                                                    rows: previewLoanRows,
                                                    loanDeductionPerCutoffTotal: previewLoanDeductionTotal,
                                                    loanFormTypes: previewLoanFormTypes
                                                  };
                                                  const previewIncomeHalfMonth = result?.breakdown?.income?.half_month_salary || tl.halfMonthSalaryInternal || tl.half_month_salary || 0;
                                                  const previewRecord = {
                                                    ...editSnapshot,
                                                    employee_name: activeEmployee?.full_name || editSnapshot?.employee_name || 'N/A',
                                                    payroll_period: payrollPeriod || editSnapshot?.payroll_period || 'Not specified',
                                                    holidays: holidayList,
                                                    half_month_salary: tl.half_month_salary,
                                                    daily_rate: tl.daily_rate,
                                                    hourly_rate: tl.hourly_rate,
                                                    working_days: tl.working_days,
                                                    days_present: tl.days_present,
                                                    days_absent: previewSummaryAnalytics.days_absent,
                                                    half_days_present: tl.half_days_present,
                                                    absence_deduction: tl.absence_deduction,
                                                    minutes_late: previewSummaryAnalytics.total_minutes_late,
                                                    minutes_undertime: previewSummaryAnalytics.total_minutes_undertime,
                                                    tardiness_deduction: tl.tardiness_deduction,
                                                    undertime_deduction: tl.undertime_deduction,
                                                    basic_salary: tl.basic_salary,
                                                    overtime_pay: tl.overtime_pay,
                                                    ot_hours: tl.ot_hours,
                                                    ot_pay_amount: tl.ot_pay_amount,
                                                    holiday_hours: tl.holiday_hours,
                                                    holiday_pay_amount: tl.holiday_pay_amount,
                                                    holidays_count: tl.holidays_count,
                                                    additional_income: tl.additional_income,
                                                    gross_salary: tl.gross_salary,
                                                    sss_contribution: tl.sss_contribution,
                                                    hdmf_contribution: tl.hdmf_contribution,
                                                    philhealth_contribution: tl.philhealth_contribution,
                                                    withholding_tax: tl.withholding_tax,
                                                    additional_deductions: tl.additional_deductions,
                                                    total_deductions: tl.total_deductions,
                                                    net_pay: tl.net_pay,
                                                    loan_breakdown: tl.loan_breakdown,
                                                    tiles: tl.tiles,
                                                    deduction_settings: {
                                                      ...(editSnapshot?.deduction_settings || {}),
                                                      ...(payslipDeductions || {}),
                                                      ...(isMf ? { mf_record: true } : {}),
                                                      sss: !!payslipDeductions?.sss,
                                                      phic: !!payslipDeductions?.phic,
                                                      hdmf: !!payslipDeductions?.hdmf,
                                                      tax: !!payslipDeductions?.tax,
                                                      loan_cycles: result.loanCycles,
                                                      loan_breakdown: result.loanBreakdown,
                                                      breakdown: {
                                                        income: {
                                                          ...(result?.breakdown?.income || {}),
                                                          half_month_salary: previewIncomeHalfMonth
                                                        },
                                                        deductions: result?.breakdown?.deductions || {},
                                                        net_pay_breakdown: (result?.tiles?.net_pay) || {},
                                                        summary: result?.breakdown?.summary || {}
                                                      },
                                                      is_minimum_wage: (editSnapshot?.deduction_settings?.is_minimum_wage === true) || (payrollEmployeeData?.is_minimum_wage === true)
                                                    }
                                                  };

                                                  if (isMf) {
                                                    return (
                                                      <SavedMfPayslipView
                                                        record={previewRecord}
                                                        loanSummary={previewLoanSummary}
                                                      />
                                                    );
                                                  }
                                                  return (
                                                    <SavedPayrollPayslipView
                                                      record={previewRecord}
                                                      loanSummary={previewLoanSummary}
                                                    />
                                                  );
                                                }

                                                if (generateTableTab === 'mf') {
                                                  const mfAmount = (parseFloat(payrollEmployeeData?.allowances?.mf) || 0)
                                                    + (parseFloat(payrollEmployeeData?.allowances?.gas_allowance) || 0)
                                                    + (parseFloat(payrollEmployeeData?.allowances?.load_allowance) || 0)
                                                    + (parseFloat(payrollEmployeeData?.allowances?.housing_allowance) || 0);
                                                  const dailyRateToUse = calculatedMfPayslip.dailyRate || 0;
                                                  const incomeItems = buildAmountItems(additionalIncome, dailyRateToUse);
                                                  const deductionItems = buildAmountItems(additionalDeductions, dailyRateToUse);
                                                  const absenceDeduction = (previewSummaryAnalytics.days_absent || 0) * dailyRateToUse;
                                                  const minuteRateMf = dailyRateToUse / 8 / 60;
                                                  const tardinessDeduction = (previewSummaryAnalytics.total_minutes_late || 0) * minuteRateMf;
                                                  const undertimeDeduction = (previewSummaryAnalytics.total_minutes_undertime || 0) * minuteRateMf;
                                                  const baseGrossMf = Math.max(0, mfAmount - absenceDeduction - tardinessDeduction - undertimeDeduction);
                                                  const additionalIncomeTotal = incomeItems.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
                                                  const { loanCycles, loanDeductionItems } = buildSelectedMfLoanEntries({
                                                    record: {
                                                      start_date: activeFilters?.start_date,
                                                      end_date: activeFilters?.end_date
                                                    }
                                                  });
                                                  const allDeductionItems = [...deductionItems, ...loanDeductionItems];
                                                  const additionalDeductionTotal = allDeductionItems.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
                                                  const previewRecord = {
                                                    employee_name: activeEmployee?.full_name || 'N/A',
                                                    employee_email: activeEmployee?.email || payrollEmployeeData?.email || '',
                                                    branch: (activeEmployee?.branch || payrollEmployeeData?.branch) || 'N/A',
                                                    sss_number: payrollEmployeeData?.sss_number || 'N/A',
                                                    tin_number: payrollEmployeeData?.tin_number || 'N/A',
                                                    phic_number: payrollEmployeeData?.phic_number || 'N/A',
                                                    hdmf_number: payrollEmployeeData?.hdmf_number || 'N/A',
                                                    payroll_period: payrollPeriod || 'Not specified',
                                                    start_date: activeFilters?.start_date,
                                                    end_date: activeFilters?.end_date,
                                                    days_absent: previewSummaryAnalytics.days_absent || 0,
                                                    minutes_late: previewSummaryAnalytics.total_minutes_late || 0,
                                                    minutes_undertime: previewSummaryAnalytics.total_minutes_undertime || 0,
                                                    absence_deduction: absenceDeduction,
                                                    tardiness_deduction: tardinessDeduction,
                                                    undertime_deduction: undertimeDeduction,
                                                    basic_salary: baseGrossMf,
                                                    additional_income: incomeItems,
                                                    additional_deductions: allDeductionItems,
                                                    holidays: holidayList,
                                                    deduction_settings: {
                                                      ...(payslipDeductions || {}),
                                                      mf_record: true,
                                                      loan_cycles: loanCycles,
                                                      breakdown: {
                                                        income: {
                                                          half_month_salary: mfAmount,
                                                          items: incomeItems,
                                                          total: additionalIncomeTotal
                                                        },
                                                        deductions: {
                                                          absence: absenceDeduction,
                                                          tardiness: tardinessDeduction,
                                                          undertime: undertimeDeduction,
                                                          items: allDeductionItems,
                                                          total: additionalDeductionTotal
                                                        },
                                                        summary: {
                                                          basic_salary: baseGrossMf,
                                                          total_deductions: additionalDeductionTotal
                                                        }
                                                      }
                                                    }
                                                  };

                                                  return (
                                                    <SavedMfPayslipView
                                                      record={previewRecord}
                                                      loanSummary={mfLoanSummary}
                                                    />
                                                  );
                                                }

                                                const dailyRateToUse = calculatedPayslip.dailyRate || 0;
                                                const incomeItems = buildAmountItems(additionalIncome, dailyRateToUse);
                                                const deductionItems = buildAmountItems(additionalDeductions, dailyRateToUse);
                                                const additionalIncomeTotal = incomeItems.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
                                                const additionalDeductionTotal = deductionItems.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
                                                const grossSalary = ((calculatedPayslip.basicSalary / 2)
                                                  - ((previewSummaryAnalytics.days_absent || 0) * dailyRateToUse)
                                                  - (calculatedPayslip.deductions?.late || 0)
                                                  - (calculatedPayslip.deductions?.undertime || 0))
                                                  + additionalIncomeTotal;
                                                const displayedSss = payslipDeductions.sss ? (calculatedPayslip.deductions?.sss || 0) : 0;
                                                const displayedTax = payslipDeductions.tax ? (calculatedPayslip.deductions?.tax || 0) : 0;
                                                const displayTotalDeductions = displayedSss
                                                  + (payslipDeductions.hdmf ? (calculatedPayslip.deductions?.hdmf || 0) : 0)
                                                  + (payslipDeductions.phic ? (calculatedPayslip.deductions?.phic || 0) : 0)
                                                  + displayedTax
                                                  + additionalDeductionTotal;
                                                const otAmount = (dailyRateToUse / 8) * 1.25 * otHours;
                                                const holidayAmount = (dailyRateToUse / 8) * 1.3 * holidayHours;
                                                const loanDeduction = Number(payrollLoanSummary?.loanDeductionPerCutoffTotal) || 0;
                                                const displayNetPay = Math.max(
                                                  0,
                                                  grossSalary
                                                    + otAmount
                                                    + holidayAmount
                                                    - displayTotalDeductions
                                                    - loanDeduction
                                                );
                                                const previewRecord = {
                                                  employee_name: activeEmployee?.full_name || 'N/A',
                                                  employee_email: activeEmployee?.email || payrollEmployeeData?.email || '',
                                                  branch: (activeEmployee?.branch || payrollEmployeeData?.branch) || 'N/A',
                                                  sss_number: payrollEmployeeData?.sss_number || 'N/A',
                                                  tin_number: payrollEmployeeData?.tin_number || 'N/A',
                                                  phic_number: payrollEmployeeData?.phic_number || 'N/A',
                                                  hdmf_number: payrollEmployeeData?.hdmf_number || 'N/A',
                                                  payroll_period: payrollPeriod || 'Not specified',
                                                  start_date: activeFilters?.start_date,
                                                  end_date: activeFilters?.end_date,
                                                  half_month_salary: (calculatedPayslip.basicSalary / 2),
                                                  days_absent: previewSummaryAnalytics.days_absent || 0,
                                                  minutes_late: previewSummaryAnalytics.total_minutes_late || 0,
                                                  minutes_undertime: previewSummaryAnalytics.total_minutes_undertime || 0,
                                                  absence_deduction: (previewSummaryAnalytics.days_absent || 0) * dailyRateToUse,
                                                  tardiness_deduction: calculatedPayslip.deductions?.late || 0,
                                                  undertime_deduction: calculatedPayslip.deductions?.undertime || 0,
                                                  gross_salary: grossSalary,
                                                  sss_contribution: displayedSss,
                                                  hdmf_contribution: payslipDeductions.hdmf ? (calculatedPayslip.deductions?.hdmf || 0) : 0,
                                                  philhealth_contribution: payslipDeductions.phic ? (calculatedPayslip.deductions?.phic || 0) : 0,
                                                  withholding_tax: displayedTax,
                                                  total_deductions: displayTotalDeductions,
                                                  net_pay: displayNetPay,
                                                  ot_pay_amount: otAmount,
                                                  holiday_pay_amount: holidayAmount,
                                                  ot_hours: otHours,
                                                  holiday_hours: holidayHours,
                                                  additional_income: incomeItems,
                                                  additional_deductions: deductionItems,
                                                  holidays: holidayList,
                                                  deduction_settings: {
                                                    ...(payslipDeductions || {}),
                                                    sss: !!payslipDeductions.sss,
                                                    phic: !!payslipDeductions.phic,
                                                    hdmf: !!payslipDeductions.hdmf,
                                                    tax: !!payslipDeductions.tax,
                                                    is_minimum_wage: payrollEmployeeData?.is_minimum_wage === true
                                                  }
                                                };

                                                return (
                                                  <SavedPayrollPayslipView
                                                    record={previewRecord}
                                                    displayedSss={displayedSss}
                                                    displayedTax={displayedTax}
                                                    displayTotalDeductions={displayTotalDeductions}
                                                    displayNetPay={displayNetPay}
                                                    loanSummary={payrollLoanSummary}
                                                  />
                                                );
                                              })()}
                                            </div>

                                            {/* Controls Section - Not Printed */}
                                            <div className="print:hidden space-y-4">
                                              <>
                                                {/* Deduction Toggles */}
                                                <Card className="bg-gray-50">
                                                  <CardHeader>
                                                    <CardTitle className="text-sm">Government Deduction Settings</CardTitle>
                                                  </CardHeader>
                                                  <CardContent className="space-y-4">
                                                    {generateTableTab !== 'mf' && (
                                                      <div className="grid grid-cols-4 gap-4">
                                                        {['sss', 'phic', 'hdmf', 'tax'].map((key) => (
                                                          <div key={key} className="flex items-center space-x-3">
                                                            <Switch
                                                              id={`payslip-${key}`}
                                                              checked={!!payslipDeductions[key]}
                                                              disabled={key === 'tax' && payrollEmployeeData?.is_minimum_wage}
                                                              onCheckedChange={(val) => {
                                                                const next = { ...payslipDeductions, [key]: !!val };
                                                                setPayslipDeductions(next);
                                                                if (isEditingPayslipRecord) {
                                                                  applyPayslipEditModeDeductions(next);
                                                                } else {
                                                                  setTimeout(recalculateDeductions, 100);
                                                                }
                                                              }}
                                                            />
                                                            <Label htmlFor={`payslip-${key}`}>{key.toUpperCase()}</Label>
                                                          </div>
                                                        ))}
                                                      </div>
                                                    )}
                                                    <div className="border-t pt-4">
                                                      <div className="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
                                                        Loan Deduction Settings
                                                      </div>
                                                      {(generateTableTab === 'mf' ? mfLoanSummary.rows.length === 0 : applicablePayrollPayslipLoans.length === 0) ? (
                                                        <div className="text-sm text-gray-500">
                                                          {generateTableTab === 'mf'
                                                            ? 'No existing MF loans for the selected employee and cut-off.'
                                                            : 'No existing payroll loans for the selected employee and cut-off.'}
                                                        </div>
                                                      ) : (
                                                        <div className="space-y-3">
                                                          {(generateTableTab === 'mf' ? mfLoanSummary.rows : payrollLoanSummary.rows).map((loan) => {
                                                            const loanId = String(loan?.id || '').trim();
                                                            const amountLabel = Number(loan?.scheduled_amount || 0).toLocaleString(undefined, {
                                                              minimumFractionDigits: 2,
                                                              maximumFractionDigits: 2
                                                            });
                                                            return (
                                                              <div key={loanId} className="flex items-center justify-between gap-4 rounded-md border border-gray-200 bg-white px-3 py-2">
                                                                <div className="min-w-0">
                                                                  <div className="text-sm font-medium text-gray-800 truncate">
                                                                    {formatLoanTypeLabel(loan)}
                                                                  </div>
                                                                  <div className="text-xs text-gray-500">
                                                                    Scheduled Deduction: Php {amountLabel}
                                                                  </div>
                                                                </div>
                                                                <div className="flex items-center gap-3">
                                                                  <Label htmlFor={`payslip-loan-${loanId}`} className="text-xs text-gray-600">
                                                                    {loan.isSelected !== false ? 'Enabled' : 'Skipped'}
                                                                  </Label>
                                                                  <Switch
                                                                    id={`payslip-loan-${loanId}`}
                                                                    checked={loan.isSelected !== false}
                                                                    onCheckedChange={(val) => {
                                                                      const nextValue = !!val;
                                                                      if (generateTableTab === 'mf') {
                                                                        setMfLoanDeductionSelections((prev) => ({
                                                                          ...prev,
                                                                          [loanId]: nextValue
                                                                        }));
                                                                      } else {
                                                                        setLoanDeductionSelections((prev) => ({
                                                                          ...prev,
                                                                          [loanId]: nextValue
                                                                        }));
                                                                      }
                                                                    }}
                                                                  />
                                                                </div>
                                                              </div>
                                                            );
                                                          })}
                                                        </div>
                                                      )}
                                                    </div>
                                                  </CardContent>
                                                </Card>
                                              </>

                                              {/* OT & Holiday Pay Management */}
                                              <Card className="bg-yellow-50 mb-4">
                                                <CardHeader>
                                                  <CardTitle className="text-sm text-yellow-800">OT & Holiday Pay Settings</CardTitle>
                                                </CardHeader>
                                                <CardContent className="grid grid-cols-2 gap-4">
                                                  <div>
                                                    <Label className="text-xs font-medium text-yellow-800">OT Hours</Label>
                                                    <Input
                                                      type="number"
                                                      placeholder="0"
                                                      value={otHours}
                                                      onChange={(e) => setOtHours(parseFloat(e.target.value) || 0)}
                                                      className="mt-1"
                                                    />
                                                  </div>
                                                  <div>
                                                    <Label className="text-xs font-medium text-yellow-800">Holiday Hours</Label>
                                                    <Input
                                                      type="number"
                                                      placeholder="0"
                                                      value={holidayHours}
                                                      onChange={(e) => setHolidayHours(parseFloat(e.target.value) || 0)}
                                                      className="mt-1"
                                                    />
                                                  </div>
                                                </CardContent>
                                              </Card>

                                              {/* Additional Income Management */}
                                              <Card className="bg-green-50">
                                                <CardHeader>
                                                <CardTitle className="text-sm text-green-800">Additional Income</CardTitle>
                                                </CardHeader>
                                                <CardContent className="space-y-3">
                                                  {additionalIncome.map((income) => (
                                                    <div key={income.id} className="flex gap-2">
                                                      <Input
                                                        placeholder="Title"
                                                        value={income.title}
                                                        onChange={(e) => updateAdditionalIncome(income.id, 'title', e.target.value)}
                                                        className="flex-1"
                                                      />
                                                      <Select
                                                        value={income.unit || 'minutes'}
                                                        onValueChange={(v) => updateAdditionalIncome(income.id, 'unit', v)}
                                                      >
                                                        <SelectTrigger className="w-32">
                                                          <SelectValue placeholder="Unit" />
                                                        </SelectTrigger>
                                                        <SelectContent>
                                                          <SelectItem value="amount">Amount</SelectItem>
                                                          <SelectItem value="minutes">Minutes</SelectItem>
                                                          <SelectItem value="days">Days</SelectItem>
                                                        </SelectContent>
                                                      </Select>
                                                      {(income.unit || 'minutes') === 'amount' && (
                                                        <Input type="number" placeholder="Amount" value={income.amount || 0} onChange={(e) => updateAdditionalIncome(income.id, 'amount', e.target.value)} className="w-32" />
                                                      )}
                                                      {(income.unit || 'minutes') === 'minutes' && (
                                                        <Input type="number" placeholder="Minutes" value={income.minutes || 0} onChange={(e) => updateAdditionalIncome(income.id, 'minutes', e.target.value)} className="w-32" />
                                                      )}
                                                      {(income.unit || 'minutes') === 'days' && (
                                                        <Input type="number" placeholder="Days" value={income.days || 0} onChange={(e) => updateAdditionalIncome(income.id, 'days', e.target.value)} className="w-32" />
                                                      )}
                                                      <Button
                                                        type="button"
                                                        variant="destructive"
                                                        size="sm"
                                                        onClick={() => removeAdditionalIncome(income.id)}
                                                      >
                                                        <Trash2 className="h-4 w-4" />
                                                      </Button>
                                                    </div>
                                                  ))}
                                                  <Button
                                                    type="button"
                                                    variant="outline"
                                                    onClick={addAdditionalIncome}
                                                    className="w-full border-green-300 text-green-700 hover:bg-green-100"
                                                  >
                                                    <Plus className="h-4 w-4 mr-2" />
                                                    Add Additional Income
                                                  </Button>
                                                </CardContent>
                                              </Card>

                                              {/* Additional Deductions Management */}
                                              <Card className="bg-red-50">
                                                <CardHeader>
                                                <CardTitle className="text-sm text-red-800">Additional Deductions</CardTitle>
                                                </CardHeader>
                                                <CardContent className="space-y-3">
                                                  {additionalDeductions.map((deduction) => (
                                                    <div key={deduction.id} className="flex gap-2">
                                                      <Input
                                                        placeholder="Title"
                                                        value={deduction.title}
                                                        onChange={(e) => updateAdditionalDeduction(deduction.id, 'title', e.target.value)}
                                                        className="flex-1"
                                                      />
                                                      <Select
                                                        value={deduction.unit || 'minutes'}
                                                        onValueChange={(v) => updateAdditionalDeduction(deduction.id, 'unit', v)}
                                                      >
                                                        <SelectTrigger className="w-32">
                                                          <SelectValue placeholder="Unit" />
                                                        </SelectTrigger>
                                                        <SelectContent>
                                                          <SelectItem value="amount">Amount</SelectItem>
                                                          <SelectItem value="minutes">Minutes</SelectItem>
                                                          <SelectItem value="days">Days</SelectItem>
                                                        </SelectContent>
                                                      </Select>
                                                      {(deduction.unit || 'minutes') === 'amount' && (
                                                        <Input type="number" placeholder="Amount" value={deduction.amount || 0} onChange={(e) => updateAdditionalDeduction(deduction.id, 'amount', e.target.value)} className="w-32" />
                                                      )}
                                                      {(deduction.unit || 'minutes') === 'minutes' && (
                                                        <Input type="number" placeholder="Minutes" value={deduction.minutes || 0} onChange={(e) => updateAdditionalDeduction(deduction.id, 'minutes', e.target.value)} className="w-32" />
                                                      )}
                                                      {(deduction.unit || 'minutes') === 'days' && (
                                                        <Input type="number" placeholder="Days" value={deduction.days || 0} onChange={(e) => updateAdditionalDeduction(deduction.id, 'days', e.target.value)} className="w-32" />
                                                      )}
                                                      <Button
                                                        type="button"
                                                        variant="destructive"
                                                        size="sm"
                                                        onClick={() => removeAdditionalDeduction(deduction.id)}
                                                      >
                                                        <Trash2 className="h-4 w-4" />
                                                      </Button>
                                                    </div>
                                                  ))}
                                                  <Button
                                                    type="button"
                                                    variant="outline"
                                                    onClick={addAdditionalDeduction}
                                                    className="w-full border-red-300 text-red-700 hover:bg-red-100"
                                                  >
                                                    <Plus className="h-4 w-4 mr-2" />
                                                    Add Additional Deduction
                                                  </Button>
                                                </CardContent>
                                              </Card>

                                              {/* Action Buttons */}
                                              <div className="flex justify-end space-x-2 pt-4">
                                                <Button 
                                                  onClick={async () => {
                                                    let ok = false;
                                                    if (isEditingPayslipRecord) {
                                                      if (editingPayslipRecordMeta?.source === 'mf') {
                                                        ok = await updateMfPayrollRecord();
                                                      } else {
                                                        ok = await updatePayrollRecord();
                                                      }
                                                    } else {
                                                      if (generateTableTab === 'mf') {
                                                        ok = await saveMfPayrollRecord();
                                                      } else {
                                                        ok = await savePayrollRecord();
                                                      }
                                                    }
                                                    if (ok) setIsPayslipModalOpen(false);
                                                  }}
                                                  className="bg-green-600 hover:bg-green-700"
                                                >
                                                  <Save className="h-4 w-4 mr-2" />
                                                  {isEditingPayslipRecord ? 'Update' : 'Save'}
                                                </Button>
                                              </div>
                                            </div>
                                          </div>
                                        ) : (
                                          <div className="text-center py-12">
                                            <FileText className="h-16 w-16 text-gray-400 mx-auto mb-4" />
                                            <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">No Employee Selected</h3>
                                            <p className="text-gray-500 dark:text-gray-300">Please enter an employee name or ID in the filters to generate a payslip.</p>
                                          </div>
                                        )}
                                      </DialogContent>
                                    </Dialog>

                                    {/* New Employee Modal */}
                                    <Dialog open={isNewEmployeeModalOpen} onOpenChange={setIsNewEmployeeModalOpen}>
                                      <DialogContent className="max-w-4xl max-h-[90vh] overflow-auto">
                                        <DialogHeader>
                                          <DialogTitle className="text-xl font-bold text-indigo-700">
                                            Register New Employee
                                          </DialogTitle>
                                        </DialogHeader>
                                        
                                        <div className="space-y-6">
                                          {/* Employee Search */}
                                          <Card className="glass shadow-lg border-0">
                                            <CardHeader>
                                              <CardTitle>Search iSource Employee</CardTitle>
                                            </CardHeader>
                                            <CardContent className="space-y-4">
                                              <div>
                                                <Label>Search Employee</Label>
                                                <Input
                                                  placeholder="Search by name or employee ID..."
                                                  value={searchEmployeeQuery}
                                                  onChange={(e) => setSearchEmployeeQuery(e.target.value)}
                                                />
                                              </div>
                                              
                                              {searchEmployeeQuery && (
                                                <div className="space-y-2">
                                                  <Label>Search Results</Label>
                                                  <div className="max-h-40 overflow-y-auto border rounded-lg">
                                                    {filteredHRISEmployees
                                                      .filter(emp => !payrollEmployees.some(pe => pe.employee_id === emp.id))
                                                      .map(employee => (
                                                        <div
                                                          key={employee.id}
                                                          onClick={() => setSelectedHRISEmployee(employee)}
                                                          className={`p-3 cursor-pointer hover:bg-gray-50 dark:hover:bg-black border-b ${
                                                            selectedHRISEmployee?.id === employee.id ? 'bg-indigo-50' : ''
                                                          }`}
                                                        >
                                                          <div className="font-medium">{employee.full_name}</div>
                                                          <div className="text-sm text-gray-500 dark:text-gray-300">
                                                            ID: {employee.employee_id} | {employee.email} | {employee.branch}
                                                          </div>
                                                        </div>
                                                      ))
                                                    }
                                                  </div>
                                                </div>
                                              )}
                                            </CardContent>
                                          </Card>

                                          {/* Selected Employee Details */}
                                          {selectedHRISEmployee && (
                                            <Card className="glass shadow-lg border-0 bg-indigo-50 border-indigo-200">
                                              <CardHeader>
                                                <CardTitle className="text-indigo-800">Selected Employee</CardTitle>
                                              </CardHeader>
                                              <CardContent>
                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                                                  <div>
                                                    <span className="font-medium text-indigo-700">Name:</span> {selectedHRISEmployee.full_name}
                                                  </div>
                                                  <div>
                                                    <span className="font-medium text-indigo-700">ID:</span> {selectedHRISEmployee.employee_id}
                                                  </div>
                                                  <div>
                                                    <span className="font-medium text-indigo-700">Email:</span> {selectedHRISEmployee.email}
                                                  </div>
                                                  <div>
                                                    <span className="font-medium text-indigo-700">Branch:</span> {selectedHRISEmployee.branch}
                                                  </div>
                                                </div>
                                              </CardContent>
                                            </Card>
                                          )}

                                          {/* Payroll Information Form */}
                                          {selectedHRISEmployee && (
                                            <Card className="glass shadow-lg border-0">
                                              <CardHeader>
                                                <CardTitle>Payroll Information</CardTitle>
                                              </CardHeader>
                                              <CardContent className="space-y-6">
                                                {/* Salary Package */}
                                                <div className="space-y-4">
                                                  <div className="grid grid-cols-1 gap-4">
                                                    <div>
                                                      <Label>Salary Package</Label>
                                                      <Input
                                                        type="number"
                                                        placeholder="Enter salary amount"
                                                        value={payrollData.salary}
                                                        onChange={(e) => {
                                                          setPayrollData({...payrollData, salary: e.target.value});
                                                          // Reset daily rate calculation when salary changes
                                                          setDailyRateFormula(null);
                                                          setCalculatedDailyRate(0);
                                                        }}
                                                      />
                                                    </div>
                                                  </div>
                                                  
                                                  {/* Daily Rate Calculation and Controls */}
                                                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
                                                    {/* Minimum Wage Toggle */}
                                                    <div className="flex items-center space-x-3">
                                                      <div className="relative">
                                                        <input
                                                          type="checkbox"
                                                          id="minimum-wage"
                                                          checked={payrollData.is_minimum_wage}
                                                          onChange={(e) => setPayrollData({
                                                            ...payrollData, 
                                                            is_minimum_wage: e.target.checked,
                                                            tax_enabled: e.target.checked ? false : true
                                                          })}
                                                          className="sr-only"
                                                        />
                                                        <label
                                                          htmlFor="minimum-wage"
                                                          className={`flex items-center justify-center w-6 h-6 rounded-full border-2 cursor-pointer transition-all duration-200 ${
                                                            payrollData.is_minimum_wage 
                                                              ? 'border-orange-500 bg-orange-500' 
                                                              : 'border-gray-300 bg-white hover:border-orange-400'
                                                          }`}
                                                        >
                                                          {payrollData.is_minimum_wage && (
                                                            <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                                                              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                            </svg>
                                                          )}
                                                        </label>
                                                      </div>
                                                      <Label htmlFor="minimum-wage" className="cursor-pointer">Minimum Wage</Label>
                                                    </div>

                                                    {/* Daily Rate Formula Buttons */}
                                                    <div className="flex items-center space-x-4">
                                                      <Label className="text-sm text-gray-600 dark:text-gray-200">Daily Rate Formula:</Label>
                                                      
                                                      {/* 313 Formula Button */}
                                                      <div className="flex items-center space-x-2">
                                                        <button
                                                          type="button"
                                                          onClick={() => calculateDailyRate('313')}
                                                          className={`flex items-center justify-center w-8 h-8 rounded-full border-2 cursor-pointer transition-all duration-200 text-sm font-semibold ${
                                                            dailyRateFormula === '313'
                                                              ? 'border-blue-500 bg-blue-500 text-white' 
                                                              : 'border-gray-300 bg-white text-gray-700 dark:text-gray-100 hover:border-blue-400 hover:bg-blue-50 dark:hover:bg-black'
                                                          }`}
                                                          title="Calculate daily rate using 313 formula: (salary \u00d7 12) \u00f7 313"
                                                        >
                                                          313
                                                        </button>
                                                      </div>
                                                      
                                                      {/* 261 Formula Button */}
                                                      <div className="flex items-center space-x-2">
                                                        <button
                                                          type="button"
                                                          onClick={() => calculateDailyRate('261')}
                                                          className={`flex items-center justify-center w-8 h-8 rounded-full border-2 cursor-pointer transition-all duration-200 text-sm font-semibold ${
                                                            dailyRateFormula === '261'
                                                              ? 'border-green-500 bg-green-500 text-white' 
                                                              : 'border-gray-300 bg-white text-gray-700 dark:text-gray-100 hover:border-green-400 hover:bg-green-50 dark:hover:bg-black'
                                                          }`}
                                                          title="Calculate daily rate using 261 formula: (salary \u00d7 12) \u00f7 261"
                                                        >
                                                          261
                                                        </button>
                                                      </div>
                                                    </div>

                                                    {/* Daily Rate Display */}
                                                    <div className="flex items-center space-x-2">
                                                      <Label className="text-sm text-gray-600 dark:text-gray-200">Daily Rate:</Label>
                                                      <div className={`px-3 py-1 rounded-lg border text-sm font-medium ${
                                                        calculatedDailyRate > 0 
                                                          ? 'bg-indigo-50 border-indigo-200 text-indigo-700' 
                                                          : 'bg-gray-50 border-gray-200 text-gray-500 dark:text-gray-300'
                                                      }`}>
                                                        {calculatedDailyRate > 0 ? `\u20b1${calculatedDailyRate.toFixed(2)}` : 'Not calculated'}
                                                        {dailyRateFormula && (
                                                          <span className="ml-1 text-xs">({dailyRateFormula})</span>
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                {/* Leave Credits */}
                                                <div>
                                                  <Label>Leave Credits</Label>
                                                  <Input
                                                    type="number"
                                                    placeholder="Enter leave credits"
                                                    value={payrollData.leave_credits}
                                                    onChange={(e) => setPayrollData({...payrollData, leave_credits: e.target.value})}
                                                  />
                                                </div>

                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                  <div>
                                                    <Label>TIN Number</Label>
                                                    <Input
                                                      placeholder="Enter TIN"
                                                      value={payrollData.tin_number}
                                                      onChange={(e) => setPayrollData({ ...payrollData, tin_number: e.target.value })}
                                                    />
                                                  </div>
                                                  <div>
                                                    <Label>SSS Number</Label>
                                                    <Input
                                                      placeholder="Enter SSS"
                                                      value={payrollData.sss_number}
                                                      onChange={(e) => setPayrollData({ ...payrollData, sss_number: e.target.value })}
                                                    />
                                                  </div>
                                                  <div>
                                                    <Label>PhilHealth Number</Label>
                                                    <Input
                                                      placeholder="Enter PhilHealth"
                                                      value={payrollData.phic_number}
                                                      onChange={(e) => setPayrollData({ ...payrollData, phic_number: e.target.value })}
                                                    />
                                                  </div>
                                                  <div>
                                                    <Label>Pag-IBIG Number</Label>
                                                    <Input
                                                      placeholder="Enter Pag-IBIG"
                                                      value={payrollData.hdmf_number}
                                                      onChange={(e) => setPayrollData({ ...payrollData, hdmf_number: e.target.value })}
                                                    />
                                                  </div>
                                                </div>

                                                {/* Allowances */}
                                                <div>
                                                  <Label className="text-base font-semibold">Allowances</Label>
                                                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
                                                    <div>
                                                      <Label>MF Allowance</Label>
                                                      <Input
                                                        type="number"
                                                        placeholder="0.00"
                                                        value={payrollData.allowances.mf}
                                                        onChange={(e) => setPayrollData({
                                                          ...payrollData, 
                                                          allowances: {...payrollData.allowances, mf: e.target.value}
                                                        })}
                                                      />
                                                    </div>
                                                    <div>
                                                      <Label>Gas Allowance</Label>
                                                      <Input
                                                        type="number"
                                                        placeholder="0.00"
                                                        value={payrollData.allowances.gas_allowance}
                                                        onChange={(e) => setPayrollData({
                                                          ...payrollData, 
                                                          allowances: {...payrollData.allowances, gas_allowance: e.target.value}
                                                        })}
                                                      />
                                                    </div>
                                                    <div>
                                                      <Label>Load Allowance</Label>
                                                      <Input
                                                        type="number"
                                                        placeholder="0.00"
                                                        value={payrollData.allowances.load_allowance}
                                                        onChange={(e) => setPayrollData({
                                                          ...payrollData, 
                                                          allowances: {...payrollData.allowances, load_allowance: e.target.value}
                                                        })}
                                                      />
                                                    </div>
                                                    <div>
                                                      <Label>Housing Allowance</Label>
                                                      <Input
                                                        type="number"
                                                        placeholder="0.00"
                                                        value={payrollData.allowances.housing_allowance}
                                                        onChange={(e) => setPayrollData({
                                                          ...payrollData, 
                                                          allowances: {...payrollData.allowances, housing_allowance: e.target.value}
                                                        })}
                                                      />
                                                    </div>
                                                  </div>
                                                </div>

                                                {/* Government Deductions */}
                                                <div>
                                                  <Label className="text-base font-semibold">Government Deductions</Label>
                                                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2">
                                                    {/* Tax */}
                                                    <div className="flex items-center space-x-3">
                                                      <Switch
                                                        id="tax-enabled"
                                                        checked={payrollData.tax_enabled && !payrollData.is_minimum_wage}
                                                        disabled={payrollData.is_minimum_wage}
                                                        onCheckedChange={(val) => setPayrollData({
                                                          ...payrollData,
                                                          tax_enabled: !!val
                                                        })}
                                                      />
                                                      <Label htmlFor="tax-enabled">Tax {payrollData.is_minimum_wage && '(Auto-disabled)'}</Label>
                                                    </div>
                                                    {/* SSS */}
                                                    <div className="flex items-center space-x-3">
                                                      <Switch
                                                        id="sss"
                                                        checked={payrollData.deductions.sss}
                                                        onCheckedChange={(val) => setPayrollData({
                                                          ...payrollData,
                                                          deductions: { ...payrollData.deductions, sss: !!val }
                                                        })}
                                                      />
                                                      <Label htmlFor="sss">SSS</Label>
                                                    </div>
                                                    {/* PhilHealth */}
                                                    <div className="flex items-center space-x-3">
                                                      <Switch
                                                        id="phic"
                                                        checked={payrollData.deductions.phic}
                                                        onCheckedChange={(val) => setPayrollData({
                                                          ...payrollData,
                                                          deductions: { ...payrollData.deductions, phic: !!val }
                                                        })}
                                                      />
                                                      <Label htmlFor="phic">PhilHealth</Label>
                                                    </div>
                                                    {/* HDMF */}
                                                    <div className="flex items-center space-x-3">
                                                      <Switch
                                                        id="hdmf"
                                                        checked={payrollData.deductions.hdmf}
                                                        onCheckedChange={(val) => setPayrollData({
                                                          ...payrollData,
                                                          deductions: { ...payrollData.deductions, hdmf: !!val }
                                                        })}
                                                      />
                                                      <Label htmlFor="hdmf">HDMF (Pag-IBIG)</Label>
                                                      <div className="ml-4 flex items-center space-x-2">
                                                        <Label className="text-sm text-purple-700">Additional (&#8369;)</Label>
                                                        <Input
                                                          type="number"
                                                          step="0.01"
                                                          placeholder="0.00"
                                                          value={payrollData.deductions.hdmf_additional}
                                                          onChange={(e) => setPayrollData({
                                                            ...payrollData,
                                                            deductions: { ...payrollData.deductions, hdmf_additional: e.target.value }
                                                          })}
                                                          className="w-28"
                                                          disabled={!payrollData.deductions.hdmf}
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </CardContent>
                                            </Card>
                                          )}

                                          {/* Action Buttons */}
                                          <div className="flex justify-end space-x-2 pt-4">
                                            <Button 
                                              variant="outline"
                                              onClick={() => {
                                                setIsNewEmployeeModalOpen(false);
                                                setSelectedHRISEmployee(null);
                                                setSearchEmployeeQuery('');
                                                setDailyRateFormula(null);
                                              setCalculatedDailyRate(0);
                                              setPayrollData({
                                                employee_id: '',
                                                salary: '',
                                                is_minimum_wage: false,
                                                tax_enabled: true,
                                                leave_credits: '',
                                                tin_number: '',
                                                sss_number: '',
                                                phic_number: '',
                                                hdmf_number: '',
                                                allowances: { mf: '', gas_allowance: '', load_allowance: '', housing_allowance: '' },
                                                deductions: { sss: false, phic: false, hdmf: false, hdmf_additional: '' }
                                              });
                                              }}
                                            >
                                              Cancel
                                            </Button>
                                            <Button 
                                              onClick={handleCreatePayrollEmployee}
                                              disabled={!selectedHRISEmployee || !payrollData.salary}
                                              className="bg-indigo-600 hover:bg-indigo-700"
                                            >
                                              Register Employee
                                            </Button>
                                          </div>
                                        </div>
                                      </DialogContent>
                                    </Dialog>

                                    {/* Attendance Modal - Shows list of Present or Absent employees */}
                                    <Dialog open={isAttendanceModalOpen} onOpenChange={setIsAttendanceModalOpen}>
                                      <DialogContent className="max-w-3xl max-h-[80vh] overflow-auto">
                                        <DialogHeader>
                                          <DialogTitle className="text-xl font-bold">
                                            {attendanceModalType === 'present' ? (
                                              <span className="flex items-center gap-2 text-green-700">
                                                <UserCheck className="h-6 w-6" />
                                                On Duty Employees ({attendanceModalEmployees.length})
                                              </span>
                                            ) : (
                                              <span className="flex items-center gap-2 text-gray-700 dark:text-gray-100">
                                                <Users className="h-6 w-6" />
                                                Absent Employees ({attendanceModalEmployees.length})
                                              </span>
                                            )}
                                          </DialogTitle>
                                        </DialogHeader>

                                        <div className="mt-4">
                                          {attendanceModalEmployees.length === 0 ? (
                                            <div className="text-center py-12">
                                              <p className="text-gray-500 dark:text-gray-300">
                                                {attendanceModalType === 'present' 
                                                  ? 'No employees are currently on duty' 
                                                  : 'No employees are absent today'}
                                              </p>
                                            </div>
                                          ) : (
                                            <div className="space-y-3">
                                              {attendanceModalEmployees.map((employee, index) => {
                                                // Get today's attendance records for this employee
                                                const today = new Date().toDateString();
                                                const todayRecords = attendance.filter(record => {
                                                  const recordDate = new Date(record.timestamp).toDateString();
                                                  return record.user_id === employee.id && recordDate === today;
                                                });
                                                const timeInRecord = todayRecords.find(r => r.type === 'time_in');
                                                const timeOutRecord = todayRecords.find(r => r.type === 'time_out');
                                                
                                                return (
                                                  <Card key={employee.id} className={`${
                                                    attendanceModalType === 'present' 
                                                      ? 'border-l-4 border-green-500 bg-green-50' 
                                                      : 'border-l-4 border-gray-400 bg-gray-50'
                                                  }`}>
                                                    <CardContent className="p-4">
                                                      <div className="flex justify-between items-start">
                                                        <div className="flex-1">
                                                          <div className="flex items-center gap-2 mb-2">
                                                            <span className="text-sm font-bold text-gray-700 dark:text-gray-100">
                                                              {index + 1}.
                                                            </span>
                                                            <h3 className="font-semibold text-gray-900 dark:text-white">
                                                              {employee.full_name}
                                                            </h3>
                                                          </div>
                                                          <div className="grid grid-cols-2 gap-2 text-sm text-gray-600 dark:text-gray-200">
                                                            <div>
                                                              <span className="font-medium">Employee ID:</span> {employee.employee_id || 'N/A'}
                                                            </div>
                                                            <div>
                                                              <span className="font-medium">Email:</span> {employee.email}
                                                            </div>
                                                            <div>
                                                              <span className="font-medium">Branch:</span> {employee.branch || 'N/A'}
                                                            </div>
                                                            <div>
                                                              <span className="font-medium">Position:</span> {employee.position || 'N/A'}
                                                            </div>
                                                            <div>
                                                              <span className="font-medium">Department:</span> {employee.department || 'N/A'}
                                                            </div>
                                                          </div>
                                                        </div>
                                                        
                                                        {attendanceModalType === 'present' && (
                                                          <div className="text-right ml-4">
                                                            <div className="text-xs text-gray-600 dark:text-gray-200 mb-1">Time In</div>
                                                            <div className="text-sm font-bold text-green-700">
                                                              {timeInRecord 
                                                                ? new Date(timeInRecord.timestamp).toLocaleTimeString('en-US', {
                                                                    hour: '2-digit',
                                                                    minute: '2-digit',
                                                                    hour12: true
                                                                  })
                                                                : 'N/A'}
                                                            </div>
                                                            {timeOutRecord && (
                                                              <>
                                                                <div className="text-xs text-gray-600 dark:text-gray-200 mt-2 mb-1">Time Out</div>
                                                                <div className="text-sm font-bold text-blue-700">
                                                                  {new Date(timeOutRecord.timestamp).toLocaleTimeString('en-US', {
                                                                    hour: '2-digit',
                                                                    minute: '2-digit',
                                                                    hour12: true
                                                                  })}
                                                                </div>
                                                              </>
                                                            )}
                                                          </div>
                                                        )}
                                                      </div>
                                                    </CardContent>
                                                  </Card>
                                                );
                                              })}
                                            </div>
                                          )}
                                        </div>

                                        <div className="flex justify-end mt-4 pt-4 border-t">
                                          <Button onClick={() => setIsAttendanceModalOpen(false)}>
                                            Close
                                          </Button>
                                        </div>
                                      </DialogContent>
                                    </Dialog>
                                  </div>

{/* Pricing Template Modal Removed */}

                                  {(() => {
                                    // Use MF data when on MF tab, otherwise use Payroll data
                                    const isMfTab = generateTableTab === 'mf';
                                    const activeFilters = isMfTab ? mfAttendanceFilters : payrollAttendanceFilters;
                                    const activeData = isMfTab ? mfAttendanceData : payrollAttendanceData;
                                    const activeSelectedEmployee = isMfTab ? mfSelectedPayslipEmployee : selectedPayslipEmployee;
                                    
                                    const calendarEmployee = (() => {
                                      const sel = activeSelectedEmployee ? (payrollEmployees.find(emp => emp.employee_id === (activeSelectedEmployee.employee_id || activeSelectedEmployee.id)) || null) : null;
                                      if (sel) return sel;
                                      if (activeFilters.name) {
                                        const byName = payrollEmployees.find(emp => emp.full_name?.toLowerCase().includes(activeFilters.name.toLowerCase()) || String(emp.employee_id || '').toLowerCase().includes(activeFilters.name.toLowerCase()));
                                        if (byName) return byName;
                                      }
                                      return null;
                                    })();
                                    const basisForCalendar = calendarEmployee ? (calendarEmployee.daily_rate_formula || calendarEmployee.rate_formula || calendarEmployee.dailyRateFormula) : null;
                                    const calendarWorkweek = (String(basisForCalendar) === '313' || basisForCalendar === 313) ? [1,2,3,4,5,6] : [1,2,3,4,5];
                                    const calendarAttendanceRecords = (() => {
                                      const id = calendarEmployee?.employee_id;
                                      if (id) return (activeData || []).filter(r => String(r.user_id) === String(id));
                                      return activeData || [];
                                    })();
                                    const calendarSets = (() => {
                                      const hasRange = Boolean(activeFilters.start_date) && Boolean(activeFilters.end_date);
                                      if (!hasRange) return { presentDates: [], halfDates: [], absentDates: [] };
                                      const sNorm = normalizeToISODateTaipei(activeFilters.start_date);
                                      const eNorm = normalizeToISODateTaipei(activeFilters.end_date);
                                      let startISO, endISO;
                                      if (sNorm.ok && eNorm.ok) {
                                        startISO = sNorm.value;
                                        endISO = eNorm.value;
                                      } else {
                                        const vr = validateDateRangeTaipei(activeFilters.start_date, activeFilters.end_date);
                                        if (!vr.ok) return { presentDates: [], halfDates: [], absentDates: [] };
                                        startISO = vr.startISO;
                                        endISO = vr.endISO;
                                      }
                                      const presentItems = computePayrollDetailItems('present');
                                      const absentItems = computePayrollDetailItems('absent');
                                      // Choose a target employee to align sets with calendar rows:
                                      // Preference: selectedPayslipEmployee -> name filter -> unique user_id in calendar records
                                      const candidateId = calendarEmployee?.employee_id;
                                      const candidateName = (calendarEmployee?.full_name || '').toLowerCase();
                                      const uniqueIds = new Set((calendarAttendanceRecords || []).map(r => String(r.user_id)));
                                      const singleId = uniqueIds.size === 1 ? Array.from(uniqueIds)[0] : null;
                                      const targetId = candidateId || singleId;
                                      const matchItem = (it) => {
                                        const itId = String(it.employee_id || '');
                                        const itName = String(it.name || '').toLowerCase();
                                        return (targetId && itId === String(targetId)) || (candidateName && itName === candidateName);
                                      };
                                      const pItems = (targetId || candidateName) ? presentItems.filter(matchItem) : presentItems;
                                      const aItems = (targetId || candidateName) ? absentItems.filter(matchItem) : absentItems;
                                      const presentDates = new Set();
                                      const halfDates = new Set();
                                      const absentDates = new Set();
                                      pItems.forEach(it => {
                                        if (it.day_value === 1 && !it.is_half_day) presentDates.add(it.date);
                                        else if (it.day_value === 0.5 || it.is_half_day) halfDates.add(it.date);
                                        
                                        // Handle System Present
                                        if (String(it.system_status || '').includes('System Present')) {
                                          presentDates.add(it.date);
                                        }
                                        
                                        // Handle Saturday Overrides for Calendar
                                        const overrideKey = `${it.employee_id || it.user_id}_${it.date}`;
                                        const override = saturdayOverrides[overrideKey];
                                        if (override === 'present') {
                                          presentDates.add(it.date);
                                          absentDates.delete(it.date); // Ensure it's not marked absent
                                        }
                                      });
                                      aItems.forEach(it => { 
                                        // Respect override for absent items too
                                        const overrideKey = `${it.employee_id || it.user_id}_${it.date}`;
                                        const override = saturdayOverrides[overrideKey];
                                        if (override === 'present') {
                                           presentDates.add(it.date);
                                        } else {
                                           absentDates.add(it.date);
                                        }
                                      });

                                      // Apply Saturday rule directly for Calendar View:
                                      // If Fri and Mon have any presence (full or half), Sat becomes System Present.
                                      // Uses buffer-fetched records (-2/+2) but does not affect late/undertime.
                                      const isSixDay = (String(basisForCalendar) === '313' || basisForCalendar === 313);
                                      const empKey = targetId ? String(targetId) : null;
                                      if (isSixDay) {
                                        const activityByISO = new Set();
                                        (calendarAttendanceRecords || []).forEach((r) => {
                                          try {
                                            const t = String(r?.type || '').toLowerCase().trim();
                                            if (t !== 'time_in' && t !== 'time_out') return;
                                            const iso = r?.timestamp ? toTaipeiISODate(r.timestamp) : null;
                                            if (iso) activityByISO.add(iso);
                                          } catch { /* noop */ }
                                        });
                                        const hasPresence = (iso) => presentDates.has(iso) || halfDates.has(iso) || activityByISO.has(iso);
                                        const startD = new Date(startISO + 'T00:00:00+08:00');
                                        const endD = new Date(endISO + 'T00:00:00+08:00');
                                        if (!isNaN(startD) && !isNaN(endD)) {
                                          let d = new Date(startD);
                                          while (d <= endD) {
                                            if (taipeiDayOfWeek(d) === 6) {
                                              const satISO = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
                                              const override = empKey ? saturdayOverrides?.[`${empKey}_${satISO}`] : undefined;
                                              if (override === 'present') {
                                                presentDates.add(satISO);
                                                halfDates.delete(satISO);
                                                absentDates.delete(satISO);
                                              } else if (override === 'absent' && !activityByISO.has(satISO)) {
                                                presentDates.delete(satISO);
                                                halfDates.delete(satISO);
                                                absentDates.add(satISO);
                                              } else if (activityByISO.has(satISO)) {
                                                presentDates.add(satISO);
                                                halfDates.delete(satISO);
                                                absentDates.delete(satISO);
                                              } else if (!activityByISO.has(satISO)) {
                                                const fri = new Date(d);
                                                fri.setDate(fri.getDate() - 1);
                                                const mon = new Date(d);
                                                mon.setDate(mon.getDate() + 2);
                                                const friISO = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' }).format(fri);
                                                const monISO = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' }).format(mon);
                                                if (hasPresence(friISO) && hasPresence(monISO)) {
                                                  presentDates.add(satISO);
                                                  halfDates.delete(satISO);
                                                  absentDates.delete(satISO);
                                                } else {
                                                  presentDates.delete(satISO);
                                                  halfDates.delete(satISO);
                                                  absentDates.add(satISO);
                                                }
                                              }
                                            }
                                            d.setDate(d.getDate() + 1);
                                          }
                                        }
                                      }
                                      return { presentDates: Array.from(presentDates), halfDates: Array.from(halfDates), absentDates: Array.from(absentDates) };
                                    })();
                                    const calendarHolidayDates = (() => {
                                      const hasRange = Boolean(activeFilters.start_date) && Boolean(activeFilters.end_date);
                                      if (!hasRange) return [];
                                      const sNorm = normalizeToISODateTaipei(activeFilters.start_date);
                                      const eNorm = normalizeToISODateTaipei(activeFilters.end_date);
                                      let startISO, endISO;
                                      if (sNorm.ok && eNorm.ok) {
                                        startISO = sNorm.value;
                                        endISO = eNorm.value;
                                      } else {
                                        const vr = validateDateRangeTaipei(activeFilters.start_date, activeFilters.end_date);
                                        if (!vr.ok) return [];
                                        startISO = vr.startISO;
                                        endISO = vr.endISO;
                                      }
                                      const isSixDay = (String(basisForCalendar) === '313' || basisForCalendar === 313);
                                      const empId = calendarEmployee?.employee_id;
                                      const hols = sanitizeHolidayRows(holidays).filter((h) => h.date >= startISO && h.date <= endISO);
                                      const out = [];
                                      hols.forEach((h) => {
                                        const dObj = new Date(h.date + 'T00:00:00+08:00');
                                        if (isNaN(dObj)) return;
                                        if (!isWorkingDayForBasis(dObj, isSixDay)) return;
                                        if (empId && isSixDay && taipeiDayOfWeek(dObj) === 6) {
                                          const override = saturdayOverrides?.[`${empId}_${h.date}`];
                                          if (override === 'absent') return;
                                        }
                                        out.push(h.date);
                                      });
                                      return Array.from(new Set(out));
                                    })();
                                    return (
                                  <CalendarViewModal
                                    open={isCalendarViewOpen}
                                    onOpenChange={setIsCalendarViewOpen}
                                    month={calendarViewMonth}
                                    year={calendarViewYear}
                                    onMonthYearChange={({ month, year }) => { setCalendarViewMonth(month); setCalendarViewYear(year); }}
                                    attendanceRecords={calendarAttendanceRecords}
                                    startDate={activeFilters.start_date}
                                    endDate={activeFilters.end_date}
                                    onRefresh={isMfTab ? fetchMfAttendanceData : fetchPayrollAttendanceData}
                                    loading={isMfTab ? isLoadingMfAttendance : isLoadingPayrollAttendance}
                                    workweek={calendarWorkweek}
                                    presentDates={calendarSets.presentDates}
                                    halfDates={calendarSets.halfDates}
                                    absentDates={calendarSets.absentDates}
                                    holidayDates={calendarHolidayDates}
                                    onFetchDateDetails={async (dateISO) => {
                                      try {
                                        const params = new URLSearchParams({ start_date: dateISO, end_date: dateISO });
                                        const response = await axiosInstance.get(`/attendance?${params.toString()}`);
                                        const records = (response.data || []).filter(r => {
                                          const id = calendarEmployee?.employee_id;
                                          return id ? String(r.user_id) === String(id) : true;
                                        });
                                        const byUser = new Map();
                                        records.forEach(r => {
                                          let ts = r.timestamp;
                                          // Ensure timestamp is treated as UTC if it doesn't have timezone info
                                          if (ts && typeof ts === 'string' && !ts.endsWith('Z') && !ts.includes('+')) {
                                            ts += 'Z';
                                          }
                                          
                                          const arr = byUser.get(r.user_id) || { tin: null, tout: null, branch: null };
                                          if (r.type === 'time_in') arr.tin = (!arr.tin || new Date(ts) < new Date(arr.tin)) ? ts : arr.tin;
                                          if (r.type === 'time_out') arr.tout = (!arr.tout || new Date(ts) > new Date(arr.tout)) ? ts : arr.tout;
                                          arr.branch = arr.branch || (employees.find(e => e.id === r.user_id)?.branch || null);
                                          byUser.set(r.user_id, arr);
                                        });
                                        const details = Array.from(byUser.entries()).map(([user_id, v]) => {
                                          const emp = employees.find(e => e.id === user_id) || employees.find(e => e.employee_id === user_id);
                                          const scheduleId = emp?.schedule_id;
                                          const branchSchedule = schedules.find(s => String(s.id) === String(scheduleId));
                                          const fmt = (ts) => ts ? new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Taipei', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true }).format(new Date(ts)) : null;
                                            return {
                                              user_id,
                                              user_name: emp?.full_name || emp?.name || 'Unknown',
                                              position: emp?.position || 'N/A',
                                              department: emp?.department || emp?.branch || 'N/A',
                                              first_time_in: fmt(v.tin),
                                              last_time_out: fmt(v.tout),
                                              schedule_start: branchSchedule?.start_time ? formatHM12(branchSchedule.start_time) : 'N/A',
                                              schedule_end: branchSchedule?.end_time ? formatHM12(branchSchedule.end_time) : 'N/A',
                                              events: [],
                                            };
                                        });
                                        return details;
                                      } catch (err) {
                                        return [];
                                      }
                                    }}
                                    onApplyDateFilter={(dateISO) => {
                                      setIsCalendarViewOpen(false);
                                      if (isMfTab) {
                                        setIsLoadingMfAttendance(true);
                                        setMfAttendanceFilters({ ...mfAttendanceFilters, start_date: dateISO, end_date: dateISO });
                                        fetchMfAttendanceData().finally(() => setIsLoadingMfAttendance(false));
                                      } else {
                                        setIsLoadingPayrollAttendance(true);
                                        setPayrollAttendanceFilters({ ...payrollAttendanceFilters, start_date: dateISO, end_date: dateISO });
                                        fetchPayrollAttendanceData().finally(() => setIsLoadingPayrollAttendance(false));
                                      }
                                    }}
                                    onClearDateFilter={() => {
                                      if (isMfTab) {
                                        setMfAttendanceFilters({ ...mfAttendanceFilters, start_date: '', end_date: '' });
                                        setMfAttendanceData([]);
                                        setRawMfAttendanceData([]);
                                      } else {
                                        setPayrollAttendanceFilters({ ...payrollAttendanceFilters, start_date: '', end_date: '' });
                                        setPayrollAttendanceData([]);
                                        setRawPayrollAttendanceData([]);
                                      }
                                    }}
                                  />);
                                  })()}

                                  {/* Payroll Attendance Detail Modal for Generate tab */}
                                  <Dialog open={isPayrollDetailModalOpen} onOpenChange={setIsPayrollDetailModalOpen}>
                                    <DialogContent className="sm:max-w-[1200px] w-[95vw] max-h-[85vh] overflow-y-auto overflow-x-hidden flex flex-col">
                                      <DialogHeader>
                                        <div className="flex items-start justify-between gap-4">
                                          <div>
                                            <DialogTitle>
                                              {payrollDetailType === 'present' && 'Present Days'}
                                              {payrollDetailType === 'absent' && 'Absent Days'}
                                              {payrollDetailType === 'late' && 'Late Records'}
                                              {payrollDetailType === 'undertime' && 'Undertime Records'}
                                              {payrollDetailType === 'all' && 'Detailed Attendance Records'}
                                            </DialogTitle>
                                            <DialogDescription>
                                              {(() => {
                                                const activeFilters = detailTableTab === 'mf' ? mfAttendanceFilters : payrollAttendanceFilters;
                                                const rawData = detailTableTab === 'mf' ? rawMfAttendanceData : rawPayrollAttendanceData;
                                                const s = normalizeToISODateTaipei(activeFilters.start_date);
                                                const e = normalizeToISODateTaipei(activeFilters.end_date);
                                                
                                                // Filter data for display stats to match selected range
                                                const activeData = rawData.filter(r => {
                                                    const d = r.timestamp ? toTaipeiISODate(r.timestamp) : null;
                                                    if (!d) return false;
                                                    if (s.ok && d < s.value) return false;
                                                    if (e.ok && d > e.value) return false;
                                                    return true;
                                                });

                                                const sDisp = s.ok ? toTaipeiMDYDate(new Date(s.value + 'T00:00:00+08:00')) : activeFilters.start_date;
                                                const eDisp = e.ok ? toTaipeiMDYDate(new Date(e.value + 'T00:00:00+08:00')) : activeFilters.end_date;
                                                const dateSet = new Set();
                                                activeData.forEach(r => { const d = r.timestamp ? toTaipeiISODate(r.timestamp) : null; if (d) dateSet.add(d); });
                                                return `${sDisp} to ${eDisp} \u2022 Records: ${activeData.length} \u2022 Dates: ${dateSet.size}`;
                                              })()}
                                            </DialogDescription>
                                          </div>
                                          {payrollDetailType === 'all' && (
                                            <Tabs value={detailTableTab} onValueChange={setDetailTableTab}>
                                              <TabsList className="justify-end">
                                                <TabsTrigger value="payroll">Payroll</TabsTrigger>
                                                <TabsTrigger value="mf">MF</TabsTrigger>
                                              </TabsList>
                                            </Tabs>
                                          )}
                                        </div>
                                      </DialogHeader>
                                      {payrollDetailType === 'all' ? (
                                        detailTableTab === 'payroll' ? (
                                          <div className="max-h-[75vh] overflow-y-auto mt-2 space-y-4">
                                            {(() => {
                                              const groups = new Map();
                                              const range = (() => {
                                                const sNorm = normalizeToISODateTaipei(payrollAttendanceFilters.start_date);
                                                const eNorm = normalizeToISODateTaipei(payrollAttendanceFilters.end_date);
                                                if (sNorm.ok && eNorm.ok) return { ok: true, startISO: sNorm.value, endISO: eNorm.value };
                                                const vr = validateDateRangeTaipei(payrollAttendanceFilters.start_date, payrollAttendanceFilters.end_date);
                                                if (vr.ok) return { ok: true, startISO: vr.startISO, endISO: vr.endISO };
                                                return { ok: false, startISO: null, endISO: null };
                                              })();

                                              const employeeDatesById = (() => {
                                                const out = {};
                                                rawPayrollAttendanceData.forEach((r) => {
                                                  const iso = r?.timestamp ? toTaipeiISODate(r.timestamp) : null;
                                                  if (!iso) return;
                                                  const empId = r?.user_id;
                                                  if (!empId) return;
                                                  if (!out[empId]) out[empId] = {};
                                                  const day = out[empId][iso] || {
                                                    has_time_in: false,
                                                    has_time_out: false,
                                                    is_half_day: false,
                                                    time_in_timestamp: null,
                                                    time_out_timestamp: null
                                                  };
                                                  if (r.type === 'time_in') {
                                                    day.has_time_in = true;
                                                    if (!day.time_in_timestamp || new Date(normalizeTs(r.timestamp)) < new Date(normalizeTs(day.time_in_timestamp))) {
                                                      day.time_in_timestamp = r.timestamp;
                                                    }
                                                  }
                                                  if (r.type === 'time_out') {
                                                    day.has_time_out = true;
                                                    if (!day.time_out_timestamp || new Date(normalizeTs(r.timestamp)) > new Date(normalizeTs(day.time_out_timestamp))) {
                                                      day.time_out_timestamp = r.timestamp;
                                                    }
                                                  }
                                                  out[empId][iso] = day;
                                                });
                                                Object.values(out).forEach((dates) => {
                                                  Object.values(dates).forEach((day) => {
                                                    const half = detectHalfDayStatus(day.time_in_timestamp, day.time_out_timestamp);
                                                    day.is_half_day = !!half?.isHalfDay;
                                                  });
                                                });
                                                return out;
                                              })();

                                              const rawCreditFor = (empId, iso) => {
                                                const day = employeeDatesById?.[empId]?.[iso];
                                                const hasIn = !!day?.has_time_in;
                                                const hasOut = !!day?.has_time_out;
                                                const isHalf = !!day?.is_half_day;
                                                if (hasIn && hasOut && !isHalf) return 1;
                                                if (hasIn || hasOut || isHalf) return 0.5;
                                                return 0;
                                              };

                                              const creditsCache = new Map();
                                              const getCredits = (empId, isSixDay) => {
                                                if (!range.ok) return {};
                                                const key = String(empId);
                                                if (creditsCache.has(key)) return creditsCache.get(key);
                                                const credits = computeEmployeeDayCreditsWithOverrides({
                                                  startISO: range.startISO,
                                                  endISO: range.endISO,
                                                  isSixDay,
                                                  employeeId: empId,
                                                  employeeDates: employeeDatesById?.[empId] || {},
                                                  holidayRows: holidays,
                                                  saturdayOverrides
                                                });
                                                creditsCache.set(key, credits || {});
                                                return credits || {};
                                              };

                                              const isPresentAdj = (empId, iso, isSixDay) => {
                                                const credits = getCredits(empId, isSixDay);
                                                const v = credits?.[iso];
                                                if (typeof v === 'number') return v > 0;
                                                return rawCreditFor(empId, iso) > 0;
                                              };
                                              const effectiveCreditFor = (empId, iso, isSixDay) => {
                                                const credits = getCredits(empId, isSixDay);
                                                const v = credits?.[iso];
                                                if (typeof v === 'number') return v;
                                                return rawCreditFor(empId, iso);
                                              };

                                              rawPayrollAttendanceData.forEach(r => {
                                                const d = r.timestamp ? toTaipeiISODate(r.timestamp) : null;
                                                if (!d) return;

                                                // Only show working days for the employee based on Daily Rate Formula
                                                const emp = payrollEmployees.find(e => String(e.employee_id) === String(r.user_id));
                                                if (emp) {
                                                  const basis = emp.daily_rate_formula || emp.rate_formula || emp.dailyRateFormula;
                                                  const is313 = String(basis) === '313' || basis === 313;
                                                  const is261 = String(basis) === '261' || basis === 261;
                                                  
                                                  const dObj = new Date(d + 'T00:00:00+08:00');
                                                  const dayOfWeek = taipeiDayOfWeek(dObj); // 0 is Sunday, 6 is Saturday
                                                  
                                                  if (is313 && dayOfWeek === 0) return; // 313 works Mon-Sat, exclude Sun
                                                  if (is261 && (dayOfWeek === 0 || dayOfWeek === 6)) return; // 261 works Mon-Fri, exclude Sat, Sun
                                                }
                                                
                                                // Only display records within the user-selected date range
                                                if (range.ok && (d < range.startISO || d > range.endISO)) return;

                                                if (!groups.has(d)) groups.set(d, []);
                                                groups.set(d, [...groups.get(d), r]);
                                              });

                                              // Filter records to keep only First Time-In and Last Time-Out per employee per day
                                              for (const [date, records] of groups.entries()) {
                                                const employeeMap = new Map();
                                                records.forEach(r => {
                                                  if (!employeeMap.has(r.user_id)) employeeMap.set(r.user_id, []);
                                                  employeeMap.get(r.user_id).push(r);
                                                });

                                                const filteredRecords = [];
                                                for (const [userId, empRecords] of employeeMap.entries()) {
                                                  const toMs = (t) => {
                                                    try { return new Date(normalizeTs(t)).getTime(); } catch { return 0; }
                                                  };
                                                  const timeIns = empRecords.filter(r => r.type === 'time_in').sort((a, b) => toMs(a.timestamp) - toMs(b.timestamp));
                                                  const timeOuts = empRecords.filter(r => r.type === 'time_out').sort((a, b) => toMs(b.timestamp) - toMs(a.timestamp)); // Latest first

                                                  if (timeIns.length > 0) filteredRecords.push(timeIns[0]);
                                                  if (timeOuts.length > 0) filteredRecords.push(timeOuts[0]);
                                                  
                                                  // Keep other record types if any (e.g. system generated if they existed, though unlikely here)
                                                  const others = empRecords.filter(r => r.type !== 'time_in' && r.type !== 'time_out');
                                                  filteredRecords.push(...others);
                                                }
                                                groups.set(date, filteredRecords);
                                              }

                                              // Ensure Saturday dates appear even when there are no records, for 313 employees
                                              (() => {
                                                const filtered313 = payrollEmployees.filter(p => {
                                                  const basis = p?.daily_rate_formula || p?.rate_formula || p?.dailyRateFormula;
                                                  const isSixDay = String(basis) === '313' || basis === 313;
                                                  if (!isSixDay) return false;
                                                  const nameFilter = (payrollAttendanceFilters.name || '').toLowerCase();
                                                  const matchesName = !nameFilter || (p.full_name || '').toLowerCase().includes(nameFilter) || String(p.employee_id || '').toLowerCase().includes(nameFilter);
                                                  const matchesBranch = payrollAttendanceFilters.branch === 'all' || p.branch === payrollAttendanceFilters.branch;
                                                  return matchesName && matchesBranch;
                                                });
                                                if (range.ok && filtered313.length > 0) {
                                                  const start = new Date(range.startISO + 'T00:00:00+08:00');
                                                  const end = new Date(range.endISO + 'T00:00:00+08:00');
                                                  let d = new Date(start);
                                                  while (d <= end) {
                                                    if (taipeiDayOfWeek(d) === 6) {
                                                      const iso = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
                                                      if (!groups.has(iso)) groups.set(iso, []);
                                                    }
                                                    d.setDate(d.getDate() + 1);
                                                  }
                                                }
                                              })();
                                              const dates = Array.from(groups.keys()).sort((a,b) => new Date(a) - new Date(b));
                                              return dates.map(dateStr => (
                                                <div key={dateStr} className="bg-white rounded-lg border border-gray-200 shadow-sm">
                                                  <div className="px-4 py-2 border-b bg-gray-50">
                                                    <h3 className="text-sm font-semibold text-gray-900 dark:text-white">{toTaipeiMDYDate(new Date(dateStr + 'T00:00:00+08:00'))}</h3>
                                                  </div>
                                                  <div className="p-2">
                                                    {(() => {
                                                      const dObj = new Date(dateStr + 'T00:00:00+08:00');
                                                      const isSat = taipeiDayOfWeek(dObj) === 6;
                                                      if (!isSat) return null;
                                                      const nameFilter = (payrollAttendanceFilters.name || '').toLowerCase();
                                                      const filtered313 = payrollEmployees.filter(p => {
                                                        const basis = p?.daily_rate_formula || p?.rate_formula || p?.dailyRateFormula;
                                                        const isSixDay = String(basis) === '313' || basis === 313;
                                                        if (!isSixDay) return false;
                                                        const matchesName = !nameFilter || (p.full_name || '').toLowerCase().includes(nameFilter) || String(p.employee_id || '').toLowerCase().includes(nameFilter);
                                                        const matchesBranch = payrollAttendanceFilters.branch === 'all' || p.branch === payrollAttendanceFilters.branch;
                                                        return matchesName && matchesBranch;
                                                      });
                                                      const friISO = (() => { const dd = new Date(dateStr + 'T00:00:00+08:00'); dd.setDate(dd.getDate() - 1); return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' }).format(dd); })();
                                                      const monISO = (() => { const dd = new Date(dateStr + 'T00:00:00+08:00'); dd.setDate(dd.getDate() + 2); return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' }).format(dd); })();
                                                      const systemRows = [];
                                                      filtered313.forEach(pe => {
                                                        const rows = (groups.get(dateStr) || []).filter(r => String(r.user_id) === String(pe?.employee_id));
                                                        const rawSatCredit = rawCreditFor(pe?.employee_id, dateStr);
                                                        const rawSatAny = hasPositiveDayCredit(rawSatCredit);
                                                        const satCredit = effectiveCreditFor(pe?.employee_id, dateStr, true);
                                                        const satAny = hasPositiveDayCredit(satCredit);
                                                        
                                                        // Check for override
                                                        const overrideKey = `${pe?.employee_id}_${dateStr}`;
                                                        const override = saturdayOverrides[overrideKey];
                                                        
                                                        let autoStatus;
                                                        const friPresent = isPresentAdj(pe?.employee_id, friISO, true);
                                                        const monPresent = isPresentAdj(pe?.employee_id, monISO, true);
                                                        const eligible = Boolean(friPresent) && Boolean(monPresent);
                                                        if (rawSatAny) autoStatus = 'System Present';
                                                        else if (override === 'absent') autoStatus = 'System Absent';
                                                        else if (satAny) autoStatus = 'System Present';
                                                        else if (!eligible) autoStatus = 'System Absent';
                                                        else autoStatus = 'System Present';

                                                        systemRows.push({
                                                          user_id: pe?.employee_id,
                                                          user_name: pe?.full_name,
                                                          type: 'system',
                                                          timestamp: null,
                                                          status: autoStatus,
                                                          late_minutes: 0,
                                                          undertime_minutes: 0
                                                        });
                                                      });
                                                      if (systemRows.length === 0) return null;
                                                      groups.set(dateStr, [...systemRows, ...(groups.get(dateStr) || [])]);
                                                      return null;
                                                    })()}
                                                    <table className="w-full table-fixed">
                                                      <thead>
                                                        <tr className="text-xs text-gray-600 dark:text-gray-200">
                                                          <th className="p-2 text-left w-1/4">Employee</th>
                                                          <th className="p-2 text-left w-1/6">Type</th>
                                                          <th className="p-2 text-left w-1/6">Time (GMT+8)</th>
                                                          <th className="p-2 text-left w-1/6">Schedule</th>
                                                          <th className="p-2 text-left w-1/6">Status</th>
                                                          <th className="p-2 text-center w-1/12">Late</th>
                                                          <th className="p-2 text-center w-1/12">Undertime</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        {groups.get(dateStr).map((record, idx) => {
                                                          const recordTime = record.timestamp ? formatTimeHHMMFromBackend(record.timestamp) : 'N/A';
                                                          const employee = payrollEmployees.find(emp => String(emp.employee_id) === String(record.user_id));
                                                          const hrisEmployee = employees.find(e => String(e.id) === String(record.user_id) || String(e.employee_id) === String(record.user_id));
                                                          const scheduleId = hrisEmployee?.schedule_id;
                                                          const branchSchedule = schedules.find(s => String(s.id) === String(scheduleId));
                                                          const scheduleText = branchSchedule ? `${formatHM12(branchSchedule.start_time)} - ${formatHM12(branchSchedule.end_time)}` : 'No schedule';
                                                          
                                                          // Check for half-day status
                                                          let halfDayTag = '';
                                                          if (record.type === 'time_in' || record.type === 'time_out') {
                                                            // Get all records for this employee on this date
                                                            const empRecords = groups.get(dateStr).filter(r => String(r.user_id) === String(record.user_id));
                                                            const toMs = (t) => {
                                                              try { return new Date(normalizeTs(t)).getTime(); } catch { return 0; }
                                                            };
                                                            const timeInRecords = empRecords.filter(r => r.type === 'time_in').sort((a,b) => toMs(a.timestamp) - toMs(b.timestamp));
                                                            const timeOutRecords = empRecords.filter(r => r.type === 'time_out').sort((a,b) => toMs(b.timestamp) - toMs(a.timestamp));
                                                            const timeInRecord = timeInRecords[0];
                                                            const timeOutRecord = timeOutRecords[0];
                                                            const halfDayStatus = detectHalfDayStatus(timeInRecord?.timestamp, timeOutRecord?.timestamp);
                                                            if (halfDayStatus.isHalfDay) {
                                                              halfDayTag = halfDayStatus.reason;
                                                            }
                                                          }

                                                          const overrideKey = `${record.user_id}_${dateStr}`;
                                                          const saturdayOverride = saturdayOverrides?.[overrideKey];
                                                          const dObj = new Date(`${dateStr}T00:00:00+08:00`);
                                                          const isSaturday = taipeiDayOfWeek(dObj) === 6;
                                                          const isSystemSaturday = record.type === 'system' && isSaturday;
                                                          const rawSaturdayCredit = rawCreditFor(record.user_id, dateStr);
                                                          const hasRawSaturdayActivity = hasPositiveDayCredit(rawSaturdayCredit);
                                                          const saturdayCredit = hasPositiveDayCredit(effectiveCreditFor(record.user_id, dateStr, true));
                                                          const friISO = (() => {
                                                            const dd = new Date(`${dateStr}T00:00:00+08:00`);
                                                            dd.setDate(dd.getDate() - 1);
                                                            return new Intl.DateTimeFormat('en-CA', {
                                                              timeZone: 'Asia/Taipei',
                                                              year: 'numeric',
                                                              month: '2-digit',
                                                              day: '2-digit',
                                                            }).format(dd);
                                                          })();
                                                          const monISO = (() => {
                                                            const dd = new Date(`${dateStr}T00:00:00+08:00`);
                                                            dd.setDate(dd.getDate() + 2);
                                                            return new Intl.DateTimeFormat('en-CA', {
                                                              timeZone: 'Asia/Taipei',
                                                              year: 'numeric',
                                                              month: '2-digit',
                                                              day: '2-digit',
                                                            }).format(dd);
                                                          })();
                                                          const isSaturdayEligible =
                                                            typeof isPresentAdj === 'function' &&
                                                            Boolean(isPresentAdj(record.user_id, friISO, true)) &&
                                                            Boolean(isPresentAdj(record.user_id, monISO, true));

                                                          const statusBadgeClass = (() => {
                                                            if (record.type !== 'system') {
                                                              if (record.status === 'on_time') return 'bg-green-100 text-green-800';
                                                              if (record.status === 'late') return 'bg-orange-100 text-orange-800';
                                                              if (record.status === 'undertime') return 'bg-purple-100 text-purple-800';
                                                              if (record.status === 'absent') return 'bg-red-100 text-red-800';
                                                              return 'bg-gray-100 text-gray-800 dark:text-white';
                                                            }

                                                            if (!isSaturday) {
                                                              return String(record.status || '').includes('Present')
                                                                ? 'bg-green-100 text-green-800'
                                                                : 'bg-red-100 text-red-800';
                                                            }

                                                            if (hasRawSaturdayActivity) return 'bg-green-100 text-green-800';
                                                            if (saturdayOverride === 'absent') return 'bg-red-100 text-red-800';
                                                            if (saturdayCredit) return 'bg-green-100 text-green-800';
                                                            if (!isSaturdayEligible) return 'bg-red-100 text-red-800';
                                                            return 'bg-green-100 text-green-800';
                                                          })();

                                                          const statusBadgeLabel = (() => {
                                                            if (record.type !== 'system') {
                                                              return record.status === 'absent' ? 'ABSENT' : (record.status || 'Normal');
                                                            }

                                                            if (!isSaturday) return record.status || 'System';
                                                            if (hasRawSaturdayActivity) return 'System Present';
                                                            if (saturdayOverride === 'absent') return 'System Absent';
                                                            if (saturdayCredit) return 'System Present';
                                                            if (!isSaturdayEligible) return 'System Absent';
                                                            return 'System Present';
                                                          })();

                                                          const isSaturdayToggleChecked = (() => {
                                                            if (!isSystemSaturday) return String(record.status || '').includes('Present');
                                                            if (hasRawSaturdayActivity) return true;
                                                            if (saturdayOverride === 'absent') return false;
                                                            if (saturdayOverride === 'present') return true;
                                                            if (saturdayCredit) return true;
                                                            return isSaturdayEligible;
                                                          })();

                                                          return (
                                                            <tr key={`${record.user_id}-${record.timestamp}-${idx}`} className="border-t">
                                                              <td className="p-2">
                                                                <div className="text-sm font-medium text-gray-900 dark:text-white">{record.user_name}</div>
                                                                <div className="text-xs text-gray-500 dark:text-gray-300">{record.user_id}</div>
                                                              </td>
                                                              <td className="p-2">
                                                                <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                                                                  record.type === 'time_in' ? 'bg-green-100 text-green-800'
                                                                  : record.type === 'time_out' ? 'bg-blue-100 text-blue-800'
                                                                  : 'bg-teal-100 text-teal-800'
                                                                }`}>{record.type === 'time_in' ? 'Time In' : record.type === 'time_out' ? 'Time Out' : 'System'}</span>
                                                              </td>
                                                              <td className="p-2 text-gray-700 dark:text-gray-100">{record.type === 'system' ? '-' : recordTime}</td>
                                                              <td className="p-2 text-xs text-gray-500 dark:text-gray-300">{record.type === 'system' ? '-' : scheduleText}</td>
                                                              <td className="p-2">
                                                                {halfDayTag ? (
                                                                  <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-yellow-100 text-yellow-800">
                                                                    {halfDayTag}
                                                                  </span>
                                                                ) : (
                                                                  <div className="flex items-center gap-2">
                                                                    {record.status === 'absent' && (
                                                                      <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-800">
                                                                        SYSTEM TAG
                                                                      </span>
                                                                    )}
                                                                    <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${statusBadgeClass}`}>{statusBadgeLabel}</span>
                                                                    {isSystemSaturday && (
                                                                      <Switch 
                                                                        checked={isSaturdayToggleChecked}
                                                                        onCheckedChange={(checked) => handleSaturdayToggle(record.user_id, dateStr, checked)}
                                                                        disabled={hasRawSaturdayActivity}
                                                                        className="scale-75"
                                                                      />
                                                                    )}
                                                                  </div>
                                                                )}
                                                              </td>
                                                              <td className="p-2 text-center">{record.type === 'system' ? (<span className="text-gray-400">-</span>) : record.late_minutes > 0 ? (<span className="text-orange-600 font-medium">{record.late_minutes}</span>) : (<span className="text-gray-400">-</span>)}</td>
                                                              <td className="p-2 text-center">{record.type === 'system' ? (<span className="text-gray-400">-</span>) : record.undertime_minutes > 0 ? (<span className="text-purple-600 font-medium">{record.undertime_minutes}</span>) : (<span className="text-gray-400">-</span>)}</td>
                                                            </tr>
                                                          );
                                                        })}
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              ));
                                            })()}
                                          </div>
                                        ) : (
                                          <div className="space-y-4">
                                            <Card className="bg-blue-50 border-blue-200">
                                              <CardContent className="py-3">
                                                <div className="flex items-center justify-between">
                                                  <div className="text-sm font-semibold text-blue-800">MF Amount</div>
                                                  <div className="text-lg font-bold text-blue-900">
                                                    {(() => {
                                                      const mf = parseFloat(payrollEmployeeData?.allowances?.mf) || 0;
                                                      return mf > 0 ? `\u20b1${mf.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : 'N/A';
                                                    })()}
                                                  </div>
                                                </div>
                                              </CardContent>
                                            </Card>
                                                  <Card className="hidden">
                                              <CardContent>
                                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
                                                  <div>
                                                    <Label>Employee Name or ID#</Label>
                                                    <Input
                                                      placeholder="Enter employee name or ID"
                                                      value={payrollAttendanceFilters.name}
                                                      onChange={(e) => setPayrollAttendanceFilters({ ...payrollAttendanceFilters, name: e.target.value })}
                                                    />
                                                  </div>
                                                  <div>
                                                    <Label>Start Date</Label>
                                                    <Input
                                                      type="date"
                                                      value={payrollAttendanceFilters.start_date || ''}
                                                      onChange={(e) => {
                                                        const val = e.target.value;
                                                        setPayrollAttendanceFilters(prev => ({
                                                          ...prev,
                                                          start_date: val,
                                                          end_date: prev.end_date || val
                                                        }));
                                                      }}
                                                    />
                                                  </div>
                                                  <div>
                                                    <Label>End Date</Label>
                                                    <Input
                                                      type="date"
                                                      value={payrollAttendanceFilters.end_date || ''}
                                                      onChange={(e) => {
                                                        const val = e.target.value;
                                                        setPayrollAttendanceFilters(prev => ({
                                                          ...prev,
                                                          end_date: val,
                                                          start_date: prev.start_date || val
                                                        }));
                                                      }}
                                                    />
                                                  </div>
                                                  <div>
                                                    <Label>Branch</Label>
                                                    <Select
                                                      value={payrollAttendanceFilters.branch}
                                                      onValueChange={(value) => setPayrollAttendanceFilters({ ...payrollAttendanceFilters, branch: value })}
                                                    >
                                                      <SelectTrigger>
                                                        <SelectValue placeholder="Select branch" />
                                                      </SelectTrigger>
                                                      <SelectContent>
                                                        <SelectItem value="all">All Branches</SelectItem>
                                                        {getUniqueBranches().map(branch => (
                                                          <SelectItem key={branch} value={branch}>{branch}</SelectItem>
                                                        ))}
                                                      </SelectContent>
                                                    </Select>
                                                  </div>
                                                </div>
                                                <div className="flex space-x-2 mt-3">
                                                  <Button onClick={fetchPayrollAttendanceData} disabled={isLoadingPayrollAttendance} className="bg-indigo-600 hover:bg-indigo-700">
                                                    {isLoadingPayrollAttendance ? 'Loading...' : 'Apply Filters'}
                                                  </Button>
                                                  <Button
                                                    variant="outline"
                                                    onClick={async () => {
                                                      setIsClearingPayrollAttendance(true);
                                                      setIsLoadingPayrollAttendance(true);
                                                      setPayrollAttendanceFilters({ name: '', start_date: '', end_date: '', type: 'all', branch: 'all' });
                                                      setPayrollAttendanceData([]);
                                                      setRawPayrollAttendanceData([]);
                                                      setPayrollAttendanceAnalytics({ total_employees: 0, days_present: 0, days_absent: 0, half_days_present: 0, total_minutes_late: 0, total_minutes_undertime: 0, working_days: 0, total_gross_pay: 0, daily_rate: 0, holidays_count: 0 });
                                                      setSelectedPayslipEmployee && setSelectedPayslipEmployee(null);
                                                      await new Promise((r) => setTimeout(r, 250));
                                                      setIsLoadingPayrollAttendance(false);
                                                      setIsClearingPayrollAttendance(false);
                                                    }}
                                                  >
                                                    {isClearingPayrollAttendance ? 'Clearing\u2026' : 'Clear'}
                                                  </Button>
                                                </div>
                                              </CardContent>
                                            </Card>
                                            <div className="max-h-[60vh] overflow-y-auto mt-1 space-y-4">
                                              {(() => {
                                                const groups = new Map();
                                                const range = (() => {
                                                  const sNorm = normalizeToISODateTaipei(mfAttendanceFilters.start_date);
                                                  const eNorm = normalizeToISODateTaipei(mfAttendanceFilters.end_date);
                                                  if (sNorm.ok && eNorm.ok) return { ok: true, startISO: sNorm.value, endISO: eNorm.value };
                                                  const vr = validateDateRangeTaipei(mfAttendanceFilters.start_date, mfAttendanceFilters.end_date);
                                                  if (vr.ok) return { ok: true, startISO: vr.startISO, endISO: vr.endISO };
                                                  return { ok: false, startISO: null, endISO: null };
                                                })();

                                                const employeeDatesById = (() => {
                                                  const out = {};
                                                  rawMfAttendanceData.forEach((r) => {
                                                    const iso = r?.timestamp ? toTaipeiISODate(r.timestamp) : null;
                                                    if (!iso) return;
                                                    const empId = r?.user_id;
                                                    if (!empId) return;
                                                    if (!out[empId]) out[empId] = {};
                                                    const day = out[empId][iso] || {
                                                      has_time_in: false,
                                                      has_time_out: false,
                                                      is_half_day: false,
                                                      time_in_timestamp: null,
                                                      time_out_timestamp: null
                                                    };
                                                    if (r.type === 'time_in') {
                                                      day.has_time_in = true;
                                                      if (!day.time_in_timestamp || new Date(normalizeTs(r.timestamp)) < new Date(normalizeTs(day.time_in_timestamp))) {
                                                        day.time_in_timestamp = r.timestamp;
                                                      }
                                                    }
                                                    if (r.type === 'time_out') {
                                                      day.has_time_out = true;
                                                      if (!day.time_out_timestamp || new Date(normalizeTs(r.timestamp)) > new Date(normalizeTs(day.time_out_timestamp))) {
                                                        day.time_out_timestamp = r.timestamp;
                                                      }
                                                    }
                                                    out[empId][iso] = day;
                                                  });
                                                  Object.values(out).forEach((dates) => {
                                                    Object.values(dates).forEach((day) => {
                                                      const half = detectHalfDayStatus(day.time_in_timestamp, day.time_out_timestamp);
                                                      day.is_half_day = !!half?.isHalfDay;
                                                    });
                                                  });
                                                  return out;
                                                })();

                                                const rawCreditFor = (empId, iso) => {
                                                  const day = employeeDatesById?.[empId]?.[iso];
                                                  const hasIn = !!day?.has_time_in;
                                                  const hasOut = !!day?.has_time_out;
                                                  const isHalf = !!day?.is_half_day;
                                                  if (hasIn && hasOut && !isHalf) return 1;
                                                  if (hasIn || hasOut || isHalf) return 0.5;
                                                  return 0;
                                                };

                                                const creditsCache = new Map();
                                                const getCredits = (empId, isSixDay) => {
                                                  if (!range.ok) return {};
                                                  const key = String(empId);
                                                  if (creditsCache.has(key)) return creditsCache.get(key);
                                                  const credits = computeEmployeeDayCreditsWithOverrides({
                                                    startISO: range.startISO,
                                                    endISO: range.endISO,
                                                    isSixDay,
                                                    employeeId: empId,
                                                    employeeDates: employeeDatesById?.[empId] || {},
                                                    holidayRows: holidays,
                                                    saturdayOverrides
                                                  });
                                                  creditsCache.set(key, credits || {});
                                                  return credits || {};
                                                };

                                                const isPresentAdj = (empId, iso, isSixDay) => {
                                                  const credits = getCredits(empId, isSixDay);
                                                  const v = credits?.[iso];
                                                  if (typeof v === 'number') return v > 0;
                                                  return rawCreditFor(empId, iso) > 0;
                                                };
                                                const effectiveCreditFor = (empId, iso, isSixDay) => {
                                                  const credits = getCredits(empId, isSixDay);
                                                  const v = credits?.[iso];
                                                  if (typeof v === 'number') return v;
                                                  return rawCreditFor(empId, iso);
                                                };

                                                rawMfAttendanceData.forEach(r => {
                                                  const d = r.timestamp ? toTaipeiISODate(r.timestamp) : null;
                                                  if (!d) return;

                                                  // Only show working days for the employee based on Daily Rate Formula
                                                  const emp = payrollEmployees.find(e => String(e.employee_id) === String(r.user_id));
                                                  if (emp) {
                                                    const basis = emp.daily_rate_formula || emp.rate_formula || emp.dailyRateFormula;
                                                    const is313 = String(basis) === '313' || basis === 313;
                                                    const is261 = String(basis) === '261' || basis === 261;
                                                    
                                                    const dObj = new Date(d + 'T00:00:00+08:00');
                                                    const dayOfWeek = taipeiDayOfWeek(dObj);
                                                    
                                                    if (is313 && dayOfWeek === 0) return; // 313 works Mon-Sat, exclude Sun
                                                    if (is261 && (dayOfWeek === 0 || dayOfWeek === 6)) return; // 261 works Mon-Fri, exclude Sat, Sun
                                                  }
                                                  
                                                  // Only display records within the user-selected date range
                                                  if (range.ok && (d < range.startISO || d > range.endISO)) return;
                                                  
                                                  if (!groups.has(d)) groups.set(d, []);
                                                  groups.set(d, [...groups.get(d), r]);
                                                });
                                                
                                                // Filter records to keep only First Time-In and Last Time-Out per employee per day (MF Tab)
                                                for (const [date, records] of groups.entries()) {
                                                  const employeeMap = new Map();
                                                  records.forEach(r => {
                                                    if (!employeeMap.has(r.user_id)) employeeMap.set(r.user_id, []);
                                                    employeeMap.get(r.user_id).push(r);
                                                  });

                                                  const filteredRecords = [];
                                                  for (const [userId, empRecords] of employeeMap.entries()) {
                                                    const toMs = (t) => {
                                                      try { return new Date(normalizeTs(t)).getTime(); } catch { return 0; }
                                                    };
                                                    const timeIns = empRecords.filter(r => r.type === 'time_in').sort((a, b) => toMs(a.timestamp) - toMs(b.timestamp));
                                                    const timeOuts = empRecords.filter(r => r.type === 'time_out').sort((a, b) => toMs(b.timestamp) - toMs(a.timestamp)); // Latest first

                                                    if (timeIns.length > 0) filteredRecords.push(timeIns[0]);
                                                    if (timeOuts.length > 0) filteredRecords.push(timeOuts[0]);
                                                    
                                                    const others = empRecords.filter(r => r.type !== 'time_in' && r.type !== 'time_out');
                                                    filteredRecords.push(...others);
                                                  }
                                                  groups.set(date, filteredRecords);
                                                }

                                                // Ensure Saturday dates appear even when there are no records, for 313 employees (MF Tab)
                                                (() => {
                                                  const filtered313 = payrollEmployees.filter(p => {
                                                    const basis = p?.daily_rate_formula || p?.rate_formula || p?.dailyRateFormula;
                                                    const isSixDay = String(basis) === '313' || basis === 313;
                                                    if (!isSixDay) return false;
                                                    const nameFilter = (mfAttendanceFilters.name || '').toLowerCase();
                                                    const matchesName = !nameFilter || (p.full_name || '').toLowerCase().includes(nameFilter) || String(p.employee_id || '').toLowerCase().includes(nameFilter);
                                                    const matchesBranch = mfAttendanceFilters.branch === 'all' || p.branch === mfAttendanceFilters.branch;
                                                    return matchesName && matchesBranch;
                                                  });

                                                  if (range.ok && filtered313.length > 0) {
                                                    const start = new Date(range.startISO + 'T00:00:00+08:00');
                                                    const end = new Date(range.endISO + 'T00:00:00+08:00');
                                                    let d = new Date(start);
                                                    while (d <= end) {
                                                      if (taipeiDayOfWeek(d) === 6) {
                                                        const iso = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
                                                        if (!groups.has(iso)) groups.set(iso, []);
                                                      }
                                                      d.setDate(d.getDate() + 1);
                                                    }
                                                  }
                                                })();

                                                const dates = Array.from(groups.keys()).sort((a,b) => new Date(a) - new Date(b));
                                                return dates.map(dateStr => (
                                                  <div key={dateStr} className="bg-white rounded-lg border border-gray-200 shadow-sm">
                                                    <div className="px-4 py-2 border-b bg-gray-50">
                                                      <h3 className="text-sm font-semibold text-gray-900 dark:text-white">{toTaipeiMDYDate(new Date(dateStr + 'T00:00:00+08:00'))}</h3>
                                                    </div>
                                                    <div className="p-2">
                                                      {(() => {
                                                        const dObj = new Date(dateStr + 'T00:00:00+08:00');
                                                        const isSat = taipeiDayOfWeek(dObj) === 6;
                                                        if (!isSat) return null;
                                                        const nameFilter = (mfAttendanceFilters.name || '').toLowerCase();
                                                        const filtered313 = payrollEmployees.filter(p => {
                                                          const basis = p?.daily_rate_formula || p?.rate_formula || p?.dailyRateFormula;
                                                          const isSixDay = String(basis) === '313' || basis === 313;
                                                          if (!isSixDay) return false;
                                                          const matchesName = !nameFilter || (p.full_name || '').toLowerCase().includes(nameFilter) || String(p.employee_id || '').toLowerCase().includes(nameFilter);
                                                          const matchesBranch = mfAttendanceFilters.branch === 'all' || p.branch === mfAttendanceFilters.branch;
                                                          return matchesName && matchesBranch;
                                                        });
                                                        
                                                        const friISO = (() => { const dd = new Date(dateStr + 'T00:00:00+08:00'); dd.setDate(dd.getDate() - 1); return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' }).format(dd); })();
                                                        const monISO = (() => { const dd = new Date(dateStr + 'T00:00:00+08:00'); dd.setDate(dd.getDate() + 2); return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' }).format(dd); })();
                                                        
                                                        const systemRows = [];
                                                        filtered313.forEach(pe => {
                                                          const rows = (groups.get(dateStr) || []).filter(r => String(r.user_id) === String(pe?.employee_id));
                                                          const satCredit = effectiveCreditFor(pe?.employee_id, dateStr, true);
                                                          const satAny = hasPositiveDayCredit(satCredit);
                                                          
                                                          // Check for override
                                                          const overrideKey = `${pe?.employee_id}_${dateStr}`;
                                                          const override = saturdayOverrides[overrideKey];
                                                          
                                                          let autoStatus;
                                                          const friPresent = isPresentAdj(pe?.employee_id, friISO, true);
                                                          const monPresent = isPresentAdj(pe?.employee_id, monISO, true);
                                                          const eligible = Boolean(friPresent) && Boolean(monPresent);
                                                          const rawSatAny = hasPositiveDayCredit(rawCreditFor(pe?.employee_id, dateStr));
                                                          if (rawSatAny) autoStatus = 'System Present';
                                                          else if (override === 'absent') autoStatus = 'System Absent';
                                                          else if (satAny) autoStatus = 'System Present';
                                                          else if (!eligible) autoStatus = 'System Absent';
                                                          else autoStatus = 'System Present';
                                                          
                                                          systemRows.push({
                                                            user_id: pe?.employee_id,
                                                            user_name: pe?.full_name,
                                                            type: 'system',
                                                            timestamp: null,
                                                            status: autoStatus,
                                                            late_minutes: 0,
                                                            undertime_minutes: 0
                                                          });
                                                        });
                                                        
                                                        if (systemRows.length === 0) return null;
                                                        groups.set(dateStr, [...systemRows, ...(groups.get(dateStr) || [])]);
                                                        return null;
                                                      })()}
                                                      <table className="w-full table-fixed">
                                                        <thead>
                                                          <tr className="text-xs text-gray-600 dark:text-gray-200">
                                                            <th className="p-2 text-left w-1/4">Employee</th>
                                                            <th className="p-2 text-left w-1/6">Type</th>
                                                            <th className="p-2 text-left w-1/6">Time (GMT+8)</th>
                                                            <th className="p-2 text-left w-1/6">Schedule</th>
                                                            <th className="p-2 text-left w-1/6">Status</th>
                                                            <th className="p-2 text-center w-1/12">Late</th>
                                                            <th className="p-2 text-center w-1/12">Undertime</th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          {groups.get(dateStr).map((record, idx) => {
                                                            const recordTime = record.timestamp ? formatTimeHHMMFromBackend(record.timestamp) : 'N/A';
                                                            const hrisEmployee = employees.find(e => String(e.id) === String(record.user_id) || String(e.employee_id) === String(record.user_id));
                                                            const scheduleId = hrisEmployee?.schedule_id;
                                                            const branchSchedule = schedules.find(s => String(s.id) === String(scheduleId));
                                                            const scheduleText = branchSchedule ? `${formatHM12(branchSchedule.start_time)} - ${formatHM12(branchSchedule.end_time)}` : 'No schedule';
                                                            
                                                            // Check for half-day status
                                                            let halfDayTag = '';
                                                            if (record.type === 'time_in' || record.type === 'time_out') {
                                                              const empRecords = groups.get(dateStr).filter(r => String(r.user_id) === String(record.user_id));
                                                              const toMs = (t) => {
                                                                try { return new Date(normalizeTs(t)).getTime(); } catch { return 0; }
                                                              };
                                                              const timeInRecords = empRecords.filter(r => r.type === 'time_in').sort((a,b) => toMs(a.timestamp) - toMs(b.timestamp));
                                                              const timeOutRecords = empRecords.filter(r => r.type === 'time_out').sort((a,b) => toMs(b.timestamp) - toMs(a.timestamp));
                                                              const timeInRecord = timeInRecords[0];
                                                              const timeOutRecord = timeOutRecords[0];
                                                              const halfDayStatus = detectHalfDayStatus(timeInRecord?.timestamp, timeOutRecord?.timestamp);
                                                              if (halfDayStatus.isHalfDay) {
                                                                halfDayTag = halfDayStatus.reason;
                                                              }
                                                            }
                                                            
                                                            return (
                                                              <tr key={`${record.user_id}-${record.timestamp}-${idx}`} className="border-t">
                                                                <td className="p-2">
                                                                  <div className="text-sm font-medium text-gray-900 dark:text-white">{record.user_name}</div>
                                                                  <div className="text-xs text-gray-500 dark:text-gray-300">{record.user_id}</div>
                                                                </td>
                                                                <td className="p-2">
                                                                  <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${record.type === 'time_in' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`}>{record.type === 'time_in' ? 'Time In' : 'Time Out'}</span>
                                                                </td>
                                                                <td className="p-2 text-gray-700 dark:text-gray-100">{recordTime}</td>
                                                                <td className="p-2 text-xs text-gray-500 dark:text-gray-300">{scheduleText}</td>
                                                                <td className="p-2">
                                                                  {halfDayTag ? (
                                                                    <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-yellow-100 text-yellow-800">
                                                                      {halfDayTag}
                                                                    </span>
                                                                  ) : (
                                                                    <div className="flex items-center gap-2">
                                                                      <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                                                                        record.type === 'system'
                                                                          ? (() => {
                                                                              const overrideKey = `${record.user_id}_${dateStr}`;
                                                                              const override = saturdayOverrides?.[overrideKey];
                                                                              const dObj = new Date(dateStr + 'T00:00:00+08:00');
                                                                              const isSat = taipeiDayOfWeek(dObj) === 6;
                                                                              if (!isSat) return String(record.status || '').includes('Present') ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800';
                                                                              const rawSatAny = hasPositiveDayCredit(rawCreditFor(record.user_id, dateStr));
                                                                              const satAny = hasPositiveDayCredit(effectiveCreditFor(record.user_id, dateStr, true));
                                                                              if (rawSatAny) return 'bg-green-100 text-green-800';
                                                                              if (override === 'absent') return 'bg-red-100 text-red-800';
                                                                              if (satAny) return 'bg-green-100 text-green-800';
                                                                              const friISO = (() => { const dd = new Date(dateStr + 'T00:00:00+08:00'); dd.setDate(dd.getDate() - 1); return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' }).format(dd); })();
                                                                              const monISO = (() => { const dd = new Date(dateStr + 'T00:00:00+08:00'); dd.setDate(dd.getDate() + 2); return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' }).format(dd); })();
                                                                              const eligible = typeof isPresentAdj === 'function' && Boolean(isPresentAdj(record.user_id, friISO, true)) && Boolean(isPresentAdj(record.user_id, monISO, true));
                                                                              if (!eligible) return 'bg-red-100 text-red-800';
                                                                              return 'bg-green-100 text-green-800';
                                                                            })()
                                                                          : record.status === 'on_time' ? 'bg-green-100 text-green-800'
                                                                            : record.status === 'late' ? 'bg-orange-100 text-orange-800'
                                                                            : record.status === 'undertime' ? 'bg-purple-100 text-purple-800'
                                                                            : 'bg-gray-100 text-gray-800 dark:text-white'
                                                                      }`}>{(() => {
                                                                        if (record.type !== 'system') return record.status || 'Normal';
                                                                        const overrideKey = `${record.user_id}_${dateStr}`;
                                                                        const override = saturdayOverrides?.[overrideKey];
                                                                        const dObj = new Date(dateStr + 'T00:00:00+08:00');
                                                                        const isSat = taipeiDayOfWeek(dObj) === 6;
                                                                        if (!isSat) return record.status || 'System';
                                                                        const rawSatAny = hasPositiveDayCredit(rawCreditFor(record.user_id, dateStr));
                                                                        const satAny = hasPositiveDayCredit(effectiveCreditFor(record.user_id, dateStr, true));
                                                                        if (rawSatAny) return 'System Present';
                                                                        if (override === 'absent') return 'System Absent';
                                                                        if (satAny) return 'System Present';
                                                                        const friISO = (() => { const dd = new Date(dateStr + 'T00:00:00+08:00'); dd.setDate(dd.getDate() - 1); return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' }).format(dd); })();
                                                                        const monISO = (() => { const dd = new Date(dateStr + 'T00:00:00+08:00'); dd.setDate(dd.getDate() + 2); return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' }).format(dd); })();
                                                                        const eligible = typeof isPresentAdj === 'function' && Boolean(isPresentAdj(record.user_id, friISO, true)) && Boolean(isPresentAdj(record.user_id, monISO, true));
                                                                        if (!eligible) return 'System Absent';
                                                                        if (override === 'absent') return 'System Absent';
                                                                        return 'System Present';
                                                                      })()}</span>
                                                                      {record.type === 'system' && (() => {
                                                                        const dObj = new Date(dateStr + 'T00:00:00+08:00');
                                                                        return taipeiDayOfWeek(dObj) === 6;
                                                                      })() && (
                                                                        <Switch 
                                                                          checked={(() => {
                                                                            const overrideKey = `${record.user_id}_${dateStr}`;
                                                                            const override = saturdayOverrides?.[overrideKey];
                                                                            const dObj = new Date(dateStr + 'T00:00:00+08:00');
                                                                            const isSat = taipeiDayOfWeek(dObj) === 6;
                                                                            if (!isSat) return String(record.status).includes('Present');
                                                                            const rawSatAny = hasPositiveDayCredit(rawCreditFor(record.user_id, dateStr));
                                                                            const satAny = hasPositiveDayCredit(effectiveCreditFor(record.user_id, dateStr, true));
                                                                            if (rawSatAny) return true;
                                                                            if (override === 'absent') return false;
                                                                            if (override === 'present') return true;
                                                                            if (satAny) return true;
                                                                            const friISO = (() => { const dd = new Date(dateStr + 'T00:00:00+08:00'); dd.setDate(dd.getDate() - 1); return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' }).format(dd); })();
                                                                            const monISO = (() => { const dd = new Date(dateStr + 'T00:00:00+08:00'); dd.setDate(dd.getDate() + 2); return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' }).format(dd); })();
                                                                            const eligible = typeof isPresentAdj === 'function' && Boolean(isPresentAdj(record.user_id, friISO, true)) && Boolean(isPresentAdj(record.user_id, monISO, true));
                                                                            if (!eligible) return false;
                                                                            return true;
                                                                          })()}
                                                                          disabled={(() => {
                                                                            const dObj = new Date(dateStr + 'T00:00:00+08:00');
                                                                            const isSat = taipeiDayOfWeek(dObj) === 6;
                                                                            if (!isSat) return false;
                                                                            const rawSatAny = hasPositiveDayCredit(rawCreditFor(record.user_id, dateStr));
                                                                            if (rawSatAny) return true;
                                                                            const friISO = (() => { const dd = new Date(dateStr + 'T00:00:00+08:00'); dd.setDate(dd.getDate() - 1); return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' }).format(dd); })();
                                                                            const monISO = (() => { const dd = new Date(dateStr + 'T00:00:00+08:00'); dd.setDate(dd.getDate() + 2); return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit' }).format(dd); })();
                                                                            const eligible = typeof isPresentAdj === 'function' && Boolean(isPresentAdj(record.user_id, friISO, true)) && Boolean(isPresentAdj(record.user_id, monISO, true));
                                                                            return !eligible;
                                                                          })()}
                                                                          onCheckedChange={(checked) => handleSaturdayToggle(record.user_id, dateStr, checked)}
                                                                          className="scale-75"
                                                                        />
                                                                      )}
                                                                    </div>
                                                                  )}
                                                                </td>
                                                                <td className="p-2 text-center">{record.late_minutes > 0 ? (<span className="text-orange-600 font-medium">{record.late_minutes}</span>) : (<span className="text-gray-400">-</span>)}</td>
                                                                <td className="p-2 text-center">{record.undertime_minutes > 0 ? (<span className="text-purple-600 font-medium">{record.undertime_minutes}</span>) : (<span className="text-gray-400">-</span>)}</td>
                                                              </tr>
                                                            );
                                                          })}
                                                        </tbody>
                                                      </table>
                                                    </div>
                                                  </div>
                                                ));
                                              })()}
                                            </div>
                                          </div>
                                        )
                                      ) : (
                                        <div className="space-y-3 overflow-y-auto pr-2">
                                          {payrollDetailType === 'present' && (() => {
                                            const items = payrollDetailItems || [];
                                            const fullDays = items.reduce((acc, it) => acc + (it.day_value === 1 ? 1 : 0), 0);
                                            const halfDays = items.reduce((acc, it) => acc + (it.day_value === 0.5 ? 1 : 0), 0);
                                            const total = (fullDays + halfDays * 0.5).toFixed(2);
                                            return (
                                              <div className="flex items-center justify-between p-3 rounded-lg bg-green-50 border border-green-200">
                                                <div className="flex items-center gap-3">
                                                  <div className="text-sm font-semibold text-green-900">Total Present Days: {total}</div>
                                                  <div className="text-xs text-green-800">Full Days: {fullDays.toFixed(2)}</div>
                                                  <div className="text-xs text-green-800">Half Days: {halfDays.toFixed(2)}</div>
                                                </div>
                                                <TooltipProvider>
                                                  <Tooltip>
                                                    <TooltipTrigger asChild>
                                                      <button className="inline-flex items-center text-xs text-gray-600 dark:text-gray-200 hover:text-gray-900 dark:text-white">
                                                        <HelpCircle className="h-4 w-4 mr-1" />
                                                        How it&#8217;s calculated
                                                      </button>
                                                    </TooltipTrigger>
                                                    <TooltipContent>
                                                      1 day: same-date time-out after time-in. 0.5 day: date has time-in only.
                                                    </TooltipContent>
                                                  </Tooltip>
                                                </TooltipProvider>
                                              </div>
                                            );
                                          })()}
                                          {payrollDetailItems.length === 0 ? (
                                            <p className="text-sm text-gray-500 dark:text-gray-300">No records to display for this selection.</p>
                                          ) : (
                                            payrollDetailItems.map((item, idx) => (
                                              <div key={idx} className="p-4 rounded-lg border bg-white">
                                                <div className="flex justify-between">
                                                  <div>
                                                    <p className="text-sm font-semibold text-gray-900 dark:text-white">{item.name}</p>
                                                    <p className="text-xs text-gray-600 dark:text-gray-200">{item.employee_id} &#8226; {item.branch}</p>
                                                  </div>
                                                  <div className="text-right">
                                                    {(item.first_time_in || item.last_time_out) && (
                                                      <span className="inline-flex items-center px-2 py-1 rounded-full bg-indigo-100 text-indigo-700 text-xs font-semibold">
                                                        {item.first_time_in ? formatTimeHHMMFromBackend(item.first_time_in) : formatTimeHHMMFromBackend(item.last_time_out)}
                                                      </span>
                                                    )}
                                                    <p className="text-xs text-gray-500 dark:text-gray-300 mt-1">{item.date}{payrollDetailType === 'present' && item.day_value === 0.5 ? ' (.5)' : ''}</p>
                                                    {payrollDetailType === 'present' && item.system_status && (
                                                      <span className="inline-flex items-center px-2 py-1 rounded-full bg-green-100 text-green-800 text-xs font-semibold mt-1">
                                                        {item.system_status}
                                                      </span>
                                                    )}
                                                  </div>
                                                </div>
                                                <div className="grid grid-cols-2 gap-2 mt-2 text-xs">
                                                  {payrollDetailType === 'present' && (
                                                    <>
                                                      <div><span className="text-gray-500 dark:text-gray-300">First Time In:</span> <span className="font-medium">{item.first_time_in ? formatTimeHHMMFromBackend(item.first_time_in) : '\u2014'}</span></div>
                                                      <div><span className="text-gray-500 dark:text-gray-300">Last Time Out:</span> <span className="font-medium">{item.last_time_out ? formatTimeHHMMFromBackend(item.last_time_out) : '\u2014'}</span></div>
                                                      <div><span className="text-gray-500 dark:text-gray-300">Schedule Start:</span> <span className="font-medium">{item.schedule_start ? formatHM12(item.schedule_start) : 'N/A'}</span></div>
                                                      <div><span className="text-gray-500 dark:text-gray-300">Schedule End:</span> <span className="font-medium">{item.schedule_end ? formatHM12(item.schedule_end) : 'N/A'}</span></div>
                                                      {item.minutes_late > 0 && (<div className="text-red-600">Minutes Late: {item.minutes_late}</div>)}
                                                      {item.system_status && (<div><span className={`inline-flex px-2 py-1 rounded-full text-xs font-semibold ${String(item.system_status).includes('Present') ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>{item.system_status}</span></div>)}
                                                    </>
                                                  )}
                                                  {payrollDetailType === 'absent' && (
                                                    <>
                                                      <div>
                                                        <span className="text-gray-500 dark:text-gray-300">Absent Date:</span>
                                                        <span className="font-medium">{item.date}{item.day_value === 0.5 ? ' (.5)' : ''}</span>
                                                      </div>
                                                      {item.day_value === 0.5 ? (
                                                        <div>
                                                          <span className="text-gray-500 dark:text-gray-300">First Time In:</span>
                                                          <span className="font-medium">{formatTimeHHMMFromBackend(item.first_time_in)}</span>
                                                        </div>
                                                      ) : (
                                                        <div className="text-gray-500 dark:text-gray-300">No attendance recorded</div>
                                                      )}
                                                      {item.system_status && (<div><span className={`inline-flex px-2 py-1 rounded-full text-xs font-semibold ${String(item.system_status).includes('Present') ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>{item.system_status}</span></div>)}
                                                    </>
                                                  )}
                                                  {payrollDetailType === 'late' && (
                                                    <>
                                                      <div><span className="text-gray-500 dark:text-gray-300">First Time In:</span> <span className="font-medium">{formatTimeHHMMFromBackend(item.first_time_in)}</span></div>
                                                      <div><span className="text-gray-500 dark:text-gray-300">Schedule Start:</span> <span className="font-medium">{item.schedule_start ? formatHM12(item.schedule_start) : 'N/A'}</span></div>
                                                      <div className="text-orange-600">Minutes Late: {item.minutes_late}</div>
                                                    </>
                                                  )}
                                                  {payrollDetailType === 'undertime' && (
                                                    <>
                                                      <div><span className="text-gray-500 dark:text-gray-300">Last Time Out:</span> <span className="font-medium">{formatTimeHHMMFromBackend(item.last_time_out)}</span></div>
                                                      <div><span className="text-gray-500 dark:text-gray-300">Schedule End:</span> <span className="font-medium">{item.schedule_end ? formatHM12(item.schedule_end) : 'N/A'}</span></div>
                                                      <div className="text-purple-600">Minutes Undertime: {item.minutes_undertime}</div>
                                                    </>
                                                  )}
                                                </div>
                                              </div>
                                            ))
                                          )}
                                        </div>
                                      )}
                                      <DialogFooter>
                                        <Button variant="outline" onClick={() => setIsPayrollDetailModalOpen(false)}>Close</Button>
                                      </DialogFooter>
                                    </DialogContent>
                                  </Dialog>

                                  {/* Machine History Repair Modal */}
                                  <Dialog open={isMHRModalOpen} onOpenChange={setIsMHRModalOpen}>
                                    <DialogContent className="max-w-5xl max-h-[95vh] overflow-y-auto">
                                      <DialogHeader>
                                        <DialogTitle>Machine History Repair - {selectedMachineForMHR?.model}</DialogTitle>
                                        <DialogDescription>
                                          Manage repair history for machine S/N: {selectedMachineForMHR?.serialNumber}
                                        </DialogDescription>
                                      </DialogHeader>
                                      
                                      <div className="space-y-6">
                                        {/* Export Buttons */}
                                        <div className="flex justify-end gap-2">
                                          <Button
                                            variant="outline"
                                            onClick={() => exportMHRToCSV()}
                                            className="flex items-center gap-2"
                                          >
                                            <Download className="h-4 w-4" />
                                            Export CSV
                                          </Button>
                                          <Button
                                            variant="outline"
                                            onClick={() => exportMHRToPDF()}
                                            className="flex items-center gap-2"
                                          >
                                            <FileText className="h-4 w-4" />
                                            Export PDF
                                          </Button>
                                        </div>

                                        {/* Repair Form */}
                                        <Card className="border-2 border-indigo-200">
                                          <CardHeader>
                                            <CardTitle className="text-lg">
                                              {editingRepair ? 'Edit Repair Record' : 'New Repair Record'}
                                            </CardTitle>
                                          </CardHeader>
                                          <CardContent className="space-y-4">
                                            {/* Ticket Number Display (if editing) */}
                                            {editingRepair && editingRepair.ticketNumber && (
                                              <div className="bg-indigo-50 p-3 rounded-lg border border-indigo-200">
                                                <Label className="text-sm font-medium text-indigo-900">Ticket Number</Label>
                                                <p className="text-lg font-bold text-indigo-600 mt-1">{editingRepair.ticketNumber}</p>
                                              </div>
                                            )}
                                            
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                              <div>
                                                <Label>Diagnosed Damage</Label>
                                                <Textarea
                                                  value={machineRepair.diagnosedDamage}
                                                  onChange={(e) => setMachineRepair({...machineRepair, diagnosedDamage: e.target.value})}
                                                  placeholder="Describe the diagnosed damage"
                                                  className="mt-1"
                                                />
                                              </div>
                                              <div>
                                                <Label>Diagnosis Date</Label>
                                                <Input
                                                  type="date"
                                                  value={machineRepair.diagnosedDate}
                                                  onChange={(e) => setMachineRepair({...machineRepair, diagnosedDate: e.target.value})}
                                                  className="mt-1"
                                                />
                                              </div>
                                            </div>

                                            <div>
                                              <div className="flex justify-between items-center mb-2">
                                                <Label>Damaged Parts</Label>
                                                <Button size="sm" onClick={addDamagedPart} className="h-7">
                                                  <Plus className="h-3 w-3 mr-1" />
                                                  Add Part
                                                </Button>
                                              </div>
                                              {machineRepair.damagedParts.map((part, index) => (
                                                <div key={index} className="flex gap-2 mb-2">
                                                  <Input
                                                    value={part}
                                                    onChange={(e) => updateDamagedPart(index, e.target.value)}
                                                    placeholder="Enter damaged part"
                                                    className="flex-1"
                                                  />
                                                  {machineRepair.damagedParts.length > 1 && (
                                                    <Button 
                                                      size="sm" 
                                                      variant="outline" 
                                                      onClick={() => removeDamagedPart(index)}
                                                      className="h-10 px-2"
                                                    >
                                                      <Trash2 className="h-4 w-4" />
                                                    </Button>
                                                  )}
                                                </div>
                                              ))}
                                              <Input
                                                type="date"
                                                value={machineRepair.damagedPartsDate}
                                                onChange={(e) => setMachineRepair({...machineRepair, damagedPartsDate: e.target.value})}
                                                className="mt-2"
                                                placeholder="Parts identification date"
                                              />
                                            </div>

                                            <div>
                                              <div className="flex justify-between items-center mb-2">
                                                <Label>Parts Requested</Label>
                                                <Button size="sm" onClick={addPartsRequested} className="h-7">
                                                  <Plus className="h-3 w-3 mr-1" />
                                                  Add Part
                                                </Button>
                                              </div>
                                              {machineRepair.partsRequested.map((part, index) => (
                                                <div key={index} className="flex gap-2 mb-2">
                                                  <Input
                                                    value={part}
                                                    onChange={(e) => updatePartsRequested(index, e.target.value)}
                                                    placeholder="Enter requested part"
                                                    className="flex-1"
                                                  />
                                                  {machineRepair.partsRequested.length > 1 && (
                                                    <Button 
                                                      size="sm" 
                                                      variant="outline" 
                                                      onClick={() => removePartsRequested(index)}
                                                      className="h-10 px-2"
                                                    >
                                                      <Trash2 className="h-4 w-4" />
                                                    </Button>
                                                  )}
                                                </div>
                                              ))}
                                              <Input
                                                type="date"
                                                value={machineRepair.partsRequestedDate}
                                                onChange={(e) => setMachineRepair({...machineRepair, partsRequestedDate: e.target.value})}
                                                className="mt-2"
                                                placeholder="Parts request date"
                                              />
                                            </div>

                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                              <div>
                                                <Label>Parts Received Date</Label>
                                                <Input
                                                  type="date"
                                                  value={machineRepair.partsReceivedDate}
                                                  onChange={(e) => setMachineRepair({...machineRepair, partsReceivedDate: e.target.value})}
                                                  className="mt-1"
                                                />
                                              </div>
                                              <div>
                                                <Label>Repair Completed Date</Label>
                                                <Input
                                                  type="date"
                                                  value={machineRepair.repairCompletedDate}
                                                  onChange={(e) => setMachineRepair({...machineRepair, repairCompletedDate: e.target.value})}
                                                  className="mt-1"
                                                />
                                              </div>
                                            </div>

                                            <div className="flex justify-end gap-2 pt-4">
                                              <Button
                                                variant="outline"
                                                onClick={() => {
                                                  setEditingRepair(null);
                                                  setMachineRepair({
                                                    diagnosedDamage: '',
                                                    diagnosedDate: '',
                                                    damagedParts: [''],
                                                    damagedPartsDate: '',
                                                    partsRequested: [''],
                                                    partsRequestedDate: '',
                                                    partsReceivedDate: '',
                                                    repairCompletedDate: ''
                                                  });
                                                }}
                                              >
                                                Reset Form
                                              </Button>
                                              <Button onClick={saveMachineRepair} className="bg-indigo-600 hover:bg-indigo-700">
                                                {editingRepair ? 'Update Repair' : 'Save Repair'}
                                              </Button>
                                            </div>
                                          </CardContent>
                                        </Card>

                                        {/* Repair History List */}
                                        <Card>
                                          <CardHeader>
                                            <CardTitle className="text-lg">Repair History</CardTitle>
                                          </CardHeader>
                                          <CardContent>
                                            {selectedMachineForMHR?.repairs && Array.isArray(selectedMachineForMHR.repairs) && selectedMachineForMHR.repairs.length > 0 ? (
                                              <div className="space-y-4">
                                                {selectedMachineForMHR.repairs.map((repair) => (
                                                  <div key={repair.id} className="border rounded-lg p-4 hover:bg-gray-50 dark:hover:bg-black">
                                                    <div className="flex justify-between items-start mb-3">
                                                      <div className="flex-1">
                                                        {repair.ticketNumber && (
                                                          <div className="inline-block bg-indigo-100 text-indigo-800 text-xs font-semibold px-2 py-1 rounded mb-2">
                                                            {repair.ticketNumber}
                                                          </div>
                                                        )}
                                                        <h4 className="font-medium text-gray-900 dark:text-white">
                                                          {repair.diagnosedDamage || 'No damage description'}
                                                        </h4>
                                                        <p className="text-sm text-gray-500 dark:text-gray-300">
                                                          Diagnosed: {repair.diagnosedDate ? new Date(repair.diagnosedDate).toLocaleDateString() : 'Not set'}
                                                        </p>
                                                      </div>
                                                      <div className="flex gap-2">
                                                        <Button
                                                          size="sm"
                                                          variant="outline"
                                                          onClick={() => editRepair(repair)}
                                                        >
                                                          <Edit className="h-3 w-3 mr-1" />
                                                          Edit
                                                        </Button>
                                                        <Button
                                                          size="sm"
                                                          variant="outline"
                                                          onClick={() => deleteRepair(repair.id)}
                                                          className="text-red-600 hover:text-red-800"
                                                        >
                                                          <Trash2 className="h-3 w-3 mr-1" />
                                                          Delete
                                                        </Button>
                                                      </div>
                                                    </div>
                                                    
                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                                                      <div>
                                                        <span className="font-medium">Damaged Parts:</span>
                                                        <p className="text-gray-600 dark:text-gray-200">
                                                          {repair.damagedParts?.filter(p => p.trim()).join(', ') || 'Not specified'}
                                                        </p>
                                                      </div>
                                                      <div>
                                                        <span className="font-medium">Parts Requested:</span>
                                                        <p className="text-gray-600 dark:text-gray-200">
                                                          {repair.partsRequested?.filter(p => p.trim()).join(', ') || 'Not specified'}
                                                        </p>
                                                      </div>
                                                      <div>
                                                        <span className="font-medium">Parts Received:</span>
                                                        <p className="text-gray-600 dark:text-gray-200">
                                                          {repair.partsReceivedDate ? new Date(repair.partsReceivedDate).toLocaleDateString() : 'Pending'}
                                                        </p>
                                                      </div>
                                                      <div>
                                                        <span className="font-medium">Repair Completed:</span>
                                                        <p className="text-gray-600 dark:text-gray-200">
                                                          {repair.repairCompletedDate ? new Date(repair.repairCompletedDate).toLocaleDateString() : 'Pending'}
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                ))}
                                              </div>
                                            ) : (
                                              <div className="text-center py-8 text-gray-500 dark:text-gray-300">
                                                No repair history found. Create the first repair record above.
                                              </div>
                                            )}
                                          </CardContent>
                                        </Card>
                                      </div>
                                    </DialogContent>
                                  </Dialog>

                                  {/* Reading Records Modal */}
                                  <Dialog open={isRRModalOpen} onOpenChange={setIsRRModalOpen}>
                                    <DialogContent className="max-w-6xl max-h-[95vh] overflow-y-auto">
                                      <DialogHeader>
                                        <DialogTitle>Reading Records - {selectedMachineForRR?.model}</DialogTitle>
                                        <DialogDescription>
                                          View and edit meter reading records for machine S/N: {selectedMachineForRR?.serialNumber}
                                        </DialogDescription>
                                      </DialogHeader>
                                      
                                      <div className="space-y-4">
                                        {/* Export Buttons */}
                                        <div className="flex justify-end gap-2">
                                          <Button
                                            variant="outline"
                                            onClick={() => exportMeterReadingsToCSV()}
                                            className="flex items-center gap-2"
                                          >
                                            <Download className="h-4 w-4" />
                                            Export CSV
                                          </Button>
                                          <Button
                                            variant="outline"
                                            onClick={() => exportMeterReadingsToPDF()}
                                            className="flex items-center gap-2"
                                          >
                                            <FileText className="h-4 w-4" />
                                            Export PDF
                                          </Button>
                                        </div>

                                        {selectedMachineForRR?.meterReadings && Array.isArray(selectedMachineForRR.meterReadings) && selectedMachineForRR.meterReadings.length > 0 ? (
                                          <div id="rr-table-content" className="border border-gray-200 rounded-lg overflow-hidden" style={{ fontFamily: 'Tahoma, sans-serif', fontSize: '10px' }}>
                                            <table className="min-w-full divide-y divide-gray-200">
                                              <thead className="bg-gray-50">
                                                <tr>
                                                  <th className="px-4 py-3 text-left align-middle text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Date</th>
                                                  <th className="px-4 py-3 text-left align-middle text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">BS Number</th>
                                                  <th className="px-4 py-3 text-left align-middle text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Readings Count</th>
                                                  <th className="px-4 py-3 text-right align-middle text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Total Amount</th>
                                                  <th className="px-4 py-3 text-center align-middle text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Actions</th>
                                                </tr>
                                              </thead>
                                              <tbody className="bg-white divide-y divide-gray-200">
                                                {(() => {
                                                  // Group readings by date
                                                  const groupedByDate = {};
                                                  selectedMachineForRR.meterReadings.forEach(reading => {
                                                    const date = reading.presentDate ? new Date(reading.presentDate).toLocaleDateString() : '--/--/--';
                                                    if (!groupedByDate[date]) {
                                                      groupedByDate[date] = [];
                                                    }
                                                    groupedByDate[date].push(reading);
                                                  });

                                                  return Object.entries(groupedByDate).map(([date, readings]) => {
                                                    // Calculate total amount for this date
                                                    const totalAmount = readings.reduce((sum, r) => sum + (r.amount || 0), 0);
                                                    // Get BS Number (all readings in a batch should have the same BS number)
                                                    const bsNumber = readings.find(r => r.bsNumber)?.bsNumber || '-';
                                                    
                                                    return (
                                                    <tr key={date} className="hover:bg-gray-50 dark:hover:bg-black cursor-pointer">
                                                      <td className="px-4 py-3 text-sm align-middle text-gray-900 dark:text-white font-medium">{date}</td>
                                                      <td className="px-4 py-3 text-sm align-middle text-gray-700 dark:text-gray-100 font-medium">
                                                        {bsNumber !== '-' ? (
                                                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                                            {bsNumber}
                                                          </span>
                                                        ) : (
                                                          <span className="text-gray-400">-</span>
                                                        )}
                                                      </td>
                                                      <td className="px-4 py-3 text-sm align-middle text-gray-600 dark:text-gray-200">
                                                        {readings.length} reading{readings.length > 1 ? 's' : ''} ({readings.map(r => r.type).join(', ')})
                                                      </td>
                                                      <td className="px-4 py-3 text-sm align-middle text-right font-semibold text-green-600">
                                                        &#8369;{totalAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                      </td>
                                                      <td className="px-4 py-3 text-center">
                                                        <Button
                                                          size="sm"
                                                          variant="outline"
                                                          onClick={() => {
                                                            setSelectedBatchReadings(readings);
                                                            setIsBatchReadingModalOpen(true);
                                                          }}
                                                        >
                                                          <FileText className="h-3 w-3 mr-1" />
                                                          View Batch
                                                        </Button>
                                                      </td>
                                                    </tr>
                                                    );
                                                  });
                                                })()}
                                              </tbody>
                                            </table>
                                          </div>
                                        ) : (
                                          <div className="text-center py-12 bg-gray-50 rounded-lg">
                                            <FileText className="h-12 w-12 text-gray-400 mx-auto mb-3" />
                                            <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-1">No Reading Records</h3>
                                            <p className="text-gray-500 dark:text-gray-300">No meter readings have been recorded for this machine yet.</p>
                                          </div>
                                        )}
                                      </div>
                                    </DialogContent>
                                  </Dialog>

                                  {/* Edit Reading Modal - Separate Full Modal */}
                                  <Dialog open={isEditReadingModalOpen} onOpenChange={setIsEditReadingModalOpen}>
                                    <DialogContent className="max-w-7xl max-h-[90vh] overflow-y-auto">
                                      <DialogHeader>
                                        <DialogTitle>Edit Meter Reading - {selectedMachineForRR?.model}</DialogTitle>
                                        <DialogDescription>
                                          Edit reading for {editingReading?.type} - Machine S/N: {selectedMachineForRR?.serialNumber}
                                        </DialogDescription>
                                      </DialogHeader>
                                      
                                      <div className="space-y-6">
                                        {/* Meter Reading Form - Table Format with Total */}
                                        <div className="flex gap-4">
                                          {/* Meter Reading Table */}
                                          <div className="border border-gray-300 rounded-lg overflow-hidden flex-1">
                                            {/* Header Row */}
                                            <div className="bg-gray-100 grid border-b border-gray-300" style={{gridTemplateColumns: '100px 120px 180px 100px 120px 100px 120px 100px 120px'}}>
                                            <div className="px-3 py-2 text-center border-r border-gray-300">
                                              <div className="text-xs font-medium text-gray-700 dark:text-gray-100">Type</div>
                                            </div>
                                            <div className="px-3 py-2 text-center border-r border-gray-300">
                                              <div className="text-xs font-medium text-gray-700 dark:text-gray-100 mb-1">Previous Reading</div>
                                              <div className="text-xs text-gray-500 dark:text-gray-300">Date</div>
                                            </div>
                                            <div className="px-3 py-2 text-center border-r border-gray-300">
                                              <div className="text-xs font-medium text-gray-700 dark:text-gray-100 mb-1">Present Reading</div>
                                              <div className="text-xs text-gray-500 dark:text-gray-300">Date</div>
                                            </div>
                                            <div className="px-3 py-2 text-center border-r border-gray-300">
                                              <div className="text-xs font-medium text-gray-700 dark:text-gray-100">Multiplier</div>
                                            </div>
                                            <div className="px-3 py-2 text-center border-r border-gray-300">
                                              <div className="text-xs font-medium text-gray-700 dark:text-gray-100">Total Consumption</div>
                                            </div>
                                            <div className="px-3 py-2 text-center border-r border-gray-300">
                                              <div className="text-xs font-medium text-gray-700 dark:text-gray-100">Spoilage %</div>
                                            </div>
                                            <div className="px-3 py-2 text-center border-r border-gray-300">
                                              <div className="text-xs font-medium text-gray-700 dark:text-gray-100">Spoilage Amount</div>
                                            </div>
                                            <div className="px-3 py-2 text-center border-r border-gray-300">
                                              <div className="text-xs font-medium text-gray-700 dark:text-gray-100">Rate (&#8369;)</div>
                                            </div>
                                            <div className="px-3 py-2 text-center">
                                              <div className="text-xs font-medium text-gray-700 dark:text-gray-100">Amount (&#8369;)</div>
                                            </div>
                                          </div>
                                          
                                          {renderEditingReadingRow()}
                                          </div>
                                          
                                          {/* Total Amount Section - Vertical Display */}
                                          <div className="border-l-4 border-indigo-600 bg-indigo-50 rounded-lg p-6 flex flex-col justify-center items-center min-w-[200px]">
                                            <div className="text-center">
                                              <div className="text-sm font-medium text-indigo-900 mb-2">TOTAL AMOUNT</div>
                                              <div className="text-4xl font-bold text-indigo-600">
                                                {editingReading && (() => {
                                                  const calculations = calculateMeterReadingValues(meterReading);
                                                  return `\u20b1${(calculations[editingReading.type]?.amount || 0).toFixed(2)}`;
                                                })()}
                                              </div>
                                              <div className="text-xs text-indigo-700 mt-2">{editingReading?.type}</div>
                                            </div>
                                          </div>
                                        </div>
                                        
                                        <div className="flex justify-end gap-2">
                                          <Button
                                            variant="outline"
                                            onClick={() => {
                                              setEditingReading(null);
                                              setIsEditReadingModalOpen(false);
                                              // Reset meter reading to default structure
                                              const meterTypes = ['Mono Small', 'Mono Large', 'Colored Small', 'Colored Large'];
                                              const resetReading = {};
                                              meterTypes.forEach(type => {
                                                resetReading[type] = {
                                                  previousReading: 0,
                                                  previousDate: '',
                                                  presentReading: '',
                                                  presentDate: '',
                                                  spoilageTolerance: 0,
                                                  rate: 0
                                                };
                                              });
                                              setMeterReading(resetReading);
                                            }}
                                          >
                                            Cancel
                                          </Button>
                                          <Button onClick={() => {
                                            updateMeterReading();
                                            setIsEditReadingModalOpen(false);
                                          }} className="bg-blue-600 hover:bg-blue-700">
                                            Update Reading
                                          </Button>
                                        </div>
                                      </div>
                                    </DialogContent>
                                  </Dialog>

                                  {/* Batch Reading Modal - View Multiple Readings for Same Date */}
                                  <Dialog open={isBatchReadingModalOpen} onOpenChange={setIsBatchReadingModalOpen}>
                                    <DialogContent className="max-w-7xl max-h-[90vh] overflow-y-auto">
                                      <DialogHeader>
                                        <DialogTitle>
                                          Batch Reading Records - {selectedBatchReadings.length > 0 ? new Date(selectedBatchReadings[0].presentDate).toLocaleDateString() : ''}
                                        </DialogTitle>
                                        <DialogDescription>
                                          All meter readings recorded on this date
                                        </DialogDescription>
                                      </DialogHeader>
                                      
                                      <div className="space-y-6">
                                        {/* Meter Reading Form - Table Format showing all readings with Total */}
                                        <div className="flex gap-4">
                                          {/* Meter Reading Table */}
                                          <div className="border border-gray-300 rounded-lg overflow-hidden flex-1">
                                            {/* Header Row */}
                                            <div className="bg-gray-100 grid border-b border-gray-300" style={{gridTemplateColumns: '100px 120px 180px 100px 120px 100px 120px 100px 120px'}}>
                                            <div className="px-3 py-2 text-center border-r border-gray-300">
                                              <div className="text-xs font-medium text-gray-700 dark:text-gray-100">Type</div>
                                            </div>
                                            <div className="px-3 py-2 text-center border-r border-gray-300">
                                              <div className="text-xs font-medium text-gray-700 dark:text-gray-100 mb-1">Previous Reading</div>
                                              <div className="text-xs text-gray-500 dark:text-gray-300">Date</div>
                                            </div>
                                            <div className="px-3 py-2 text-center border-r border-gray-300">
                                              <div className="text-xs font-medium text-gray-700 dark:text-gray-100 mb-1">Present Reading</div>
                                              <div className="text-xs text-gray-500 dark:text-gray-300">Date</div>
                                            </div>
                                            <div className="px-3 py-2 text-center border-r border-gray-300">
                                              <div className="text-xs font-medium text-gray-700 dark:text-gray-100">Multiplier</div>
                                            </div>
                                            <div className="px-3 py-2 text-center border-r border-gray-300">
                                              <div className="text-xs font-medium text-gray-700 dark:text-gray-100">Total Consumption</div>
                                            </div>
                                            <div className="px-3 py-2 text-center border-r border-gray-300">
                                              <div className="text-xs font-medium text-gray-700 dark:text-gray-100">Spoilage %</div>
                                            </div>
                                            <div className="px-3 py-2 text-center border-r border-gray-300">
                                              <div className="text-xs font-medium text-gray-700 dark:text-gray-100">Spoilage Amount</div>
                                            </div>
                                            <div className="px-3 py-2 text-center border-r border-gray-300">
                                              <div className="text-xs font-medium text-gray-700 dark:text-gray-100">Rate (&#8369;)</div>
                                            </div>
                                            <div className="px-3 py-2 text-center">
                                              <div className="text-xs font-medium text-gray-700 dark:text-gray-100">Amount (&#8369;)</div>
                                            </div>
                                          </div>
                                          
                                          {/* Data Rows - One for each reading */}
                                          {selectedBatchReadings.map((reading, index) => {
                                            const editedData = editableBatchReadings[reading.id] || {};
                                            const presentReading = editedData.presentReading !== undefined ? editedData.presentReading : reading.presentReading;
                                            const presentDate = editedData.presentDate !== undefined ? editedData.presentDate : reading.presentDate;
                                            const multiplier = editedData.multiplier !== undefined ? editedData.multiplier : (reading.multiplier || 1);
                                            const spoilageTolerance = editedData.spoilageTolerance !== undefined ? editedData.spoilageTolerance : reading.spoilageTolerance;
                                            const rate = editedData.rate !== undefined ? editedData.rate : reading.rate;
                                            
                                            // Calculate values with multiplier
                                            const baseConsumption = presentReading - reading.previousReading;
                                            const totalConsumption = baseConsumption * parseFloat(multiplier || 1);
                                            const spoilage = (totalConsumption * spoilageTolerance) / 100;
                                            const netConsumption = totalConsumption - spoilage;
                                            const amount = netConsumption * rate;
                                            
                                            return (
                                            <div key={reading.id} className={`grid min-h-[80px] items-center border-b border-gray-200 ${index % 2 === 1 ? 'bg-gray-50' : 'bg-white'}`} style={{gridTemplateColumns: '100px 120px 180px 100px 120px 100px 120px 100px 120px'}}>
                                              {/* Type Label */}
                                              <div className="px-3 py-4 border-r border-gray-300 text-center">
                                                <div className="text-sm font-medium text-gray-900 dark:text-white">{reading.type}</div>
                                              </div>
                                              
                                              {/* Previous Reading & Date */}
                                              <div className="px-3 py-4 border-r border-gray-300 text-center">
                                                <div className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                                                  {reading.previousReading || 0}
                                                </div>
                                                <div className="text-xs text-gray-500 dark:text-gray-300">
                                                  {reading.previousDate ? new Date(reading.previousDate).toLocaleDateString() : '--/--/--'}
                                                </div>
                                              </div>
                                              
                                              {/* Present Reading & Date */}
                                              <div className="px-3 py-4 border-r border-gray-300 space-y-2">
                                                {isBatchEditMode ? (
                                                  <>
                                                    <Input
                                                      type="number"
                                                      value={presentReading || ''}
                                                      onChange={(e) => setEditableBatchReadings({
                                                        ...editableBatchReadings,
                                                        [reading.id]: {
                                                          ...editableBatchReadings[reading.id],
                                                          presentReading: e.target.value
                                                        }
                                                      })}
                                                      className="text-center text-lg font-semibold w-full"
                                                    />
                                                    <Input
                                                      type="date"
                                                      value={presentDate || ''}
                                                      onChange={(e) => setEditableBatchReadings({
                                                        ...editableBatchReadings,
                                                        [reading.id]: {
                                                          ...editableBatchReadings[reading.id],
                                                          presentDate: e.target.value
                                                        }
                                                      })}
                                                      className="text-center text-xs w-full"
                                                    />
                                                  </>
                                                ) : (
                                                  <>
                                                    <div className="text-lg font-semibold text-blue-600 mb-2">
                                                      {presentReading || 0}
                                                    </div>
                                                    <div className="text-xs text-gray-500 dark:text-gray-300">
                                                      {presentDate ? new Date(presentDate).toLocaleDateString() : '--/--/--'}
                                                    </div>
                                                  </>
                                                )}
                                              </div>
                                              
                                              {/* Multiplier */}
                                              <div className="px-3 py-4 border-r border-gray-300 text-center">
                                                {isBatchEditMode ? (
                                                  <Input
                                                    type="number"
                                                    value={multiplier || 1}
                                                    onChange={(e) => setEditableBatchReadings({
                                                      ...editableBatchReadings,
                                                      [reading.id]: {
                                                        ...editableBatchReadings[reading.id],
                                                        multiplier: e.target.value || 1
                                                      }
                                                    })}
                                                    className="text-center"
                                                    min="0"
                                                    step="0.01"
                                                    placeholder="1"
                                                  />
                                                ) : (
                                                  <div className="text-sm text-gray-900 dark:text-white">
                                                    {multiplier || 1}
                                                  </div>
                                                )}
                                              </div>
                                              
                                              {/* Total Consumption */}
                                              <div className="px-3 py-4 border-r border-gray-300 text-center">
                                                <div className="text-lg font-semibold text-blue-600">
                                                  {totalConsumption.toFixed(2)}
                                                </div>
                                              </div>
                                              
                                              {/* Spoilage % */}
                                              <div className="px-3 py-4 border-r border-gray-300 text-center">
                                                {isBatchEditMode ? (
                                                  <Input
                                                    type="number"
                                                    value={spoilageTolerance || 0}
                                                    onChange={(e) => setEditableBatchReadings({
                                                      ...editableBatchReadings,
                                                      [reading.id]: {
                                                        ...editableBatchReadings[reading.id],
                                                        spoilageTolerance: e.target.value
                                                      }
                                                    })}
                                                    className="text-center"
                                                    min="0"
                                                    max="100"
                                                  />
                                                ) : (
                                                  <div className="text-sm text-gray-900 dark:text-white">
                                                    {spoilageTolerance || 0}%
                                                  </div>
                                                )}
                                              </div>
                                              
                                              {/* Spoilage Amount */}
                                              <div className="px-3 py-4 border-r border-gray-300 text-center">
                                                <div className="text-lg font-semibold text-orange-600">
                                                  {spoilage.toFixed(2)}
                                                </div>
                                              </div>
                                              
                                              {/* Rate */}
                                              <div className="px-3 py-4 border-r border-gray-300 text-center">
                                                {isBatchEditMode ? (
                                                  <Input
                                                    type="number"
                                                    value={rate || 0}
                                                    onChange={(e) => setEditableBatchReadings({
                                                      ...editableBatchReadings,
                                                      [reading.id]: {
                                                        ...editableBatchReadings[reading.id],
                                                        rate: e.target.value
                                                      }
                                                    })}
                                                    className="text-center"
                                                    min="0"
                                                    step="0.01"
                                                  />
                                                ) : (
                                                  <div className="text-sm text-gray-900 dark:text-white">
                                                    &#8369;{rate || 0}
                                                  </div>
                                                )}
                                              </div>
                                              
                                              {/* Amount */}
                                              <div className="px-3 py-4 text-center">
                                                <div className="text-lg font-bold text-green-600">
                                                  &#8369;{amount.toFixed(2)}
                                                </div>
                                              </div>
                                            </div>
                                          );
                                          })}
                                          </div>
                                          
                                          {/* Total Amount Section - Vertical Display */}
                                          <div className="border-l-4 border-indigo-600 bg-indigo-50 rounded-lg p-6 flex flex-col justify-center items-center min-w-[200px]">
                                            <div className="text-center">
                                              <div className="text-sm font-medium text-indigo-900 mb-2">TOTAL AMOUNT</div>
                                              <div className="text-4xl font-bold text-indigo-600">
                                                &#8369;{(() => {
                                                  return selectedBatchReadings.reduce((sum, reading) => {
                                                    const editedData = editableBatchReadings[reading.id] || {};
                                                    const presentReading = editedData.presentReading !== undefined ? editedData.presentReading : reading.presentReading;
                                                    const multiplier = editedData.multiplier !== undefined ? editedData.multiplier : (reading.multiplier || 1);
                                                    const spoilageTolerance = editedData.spoilageTolerance !== undefined ? editedData.spoilageTolerance : reading.spoilageTolerance;
                                                    const rate = editedData.rate !== undefined ? editedData.rate : reading.rate;
                                                    const baseConsumption = presentReading - reading.previousReading;
                                                    const totalConsumption = baseConsumption * parseFloat(multiplier || 1);
                                                    const spoilage = (totalConsumption * spoilageTolerance) / 100;
                                                    const netConsumption = totalConsumption - spoilage;
                                                    const amount = netConsumption * rate;
                                                    return sum + amount;
                                                  }, 0).toFixed(2);
                                                })()}
                                              </div>
                                              <div className="text-xs text-indigo-700 mt-2">All Readings</div>
                                            </div>
                                          </div>
                                        </div>
                                        
                                        <div className="flex justify-between items-center mt-4">
                                          <div className="text-sm text-gray-600 dark:text-gray-200">
                                            Machine: {selectedMachineForRR?.model} (S/N: {selectedMachineForRR?.serialNumber}) | 
                                            Total {selectedBatchReadings.length} reading{selectedBatchReadings.length > 1 ? 's' : ''} on this date
                                          </div>
                                          <div className="flex gap-2">
                                            {!isBatchEditMode ? (
                                              <>
                                                <Button
                                                  variant="outline"
                                                  onClick={() => {
                                                    // Export batch readings to CSV
                                                    const headers = ['Machine Model', 'Serial Number', 'Date', 'Type', 'Previous Reading', 'Present Reading', 'Consumption', 'Spoilage', 'Rate (\u20b1)', 'Amount (\u20b1)'];
                                                    const rows = selectedBatchReadings.map(reading => [
                                                      selectedMachineForRR.model || 'N/A',
                                                      selectedMachineForRR.serialNumber || 'N/A',
                                                      reading.presentDate ? new Date(reading.presentDate).toLocaleDateString() : '--/--/--',
                                                      reading.type,
                                                      reading.previousReading || 0,
                                                      reading.presentReading || 0,
                                                      reading.totalConsumption?.toFixed(2) || '0.00',
                                                      `${reading.spoilage?.toFixed(2) || '0.00'} (${reading.spoilageTolerance}%)`,
                                                      reading.rate || 0,
                                                      reading.amount?.toFixed(2) || '0.00'
                                                    ]);
                                                    
                                                    const csvContent = [
                                                      headers.join(','),
                                                      ...rows.map(row => row.join(','))
                                                    ].join('\n');
                                                    
                                                    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                                                    const link = document.createElement('a');
                                                    const url = URL.createObjectURL(blob);
                                                    link.setAttribute('href', url);
                                                    const date = selectedBatchReadings[0]?.presentDate ? new Date(selectedBatchReadings[0].presentDate).toISOString().split('T')[0] : 'batch';
                                                    link.setAttribute('download', `batch_readings_${selectedMachineForRR.model}_${date}.csv`);
                                                    link.style.visibility = 'hidden';
                                                    document.body.appendChild(link);
                                                    link.click();
                                                    document.body.removeChild(link);
                                                    toast.success('Batch readings exported to CSV!');
                                                  }}
                                                  className="flex items-center gap-2"
                                                >
                                                  <Download className="h-4 w-4" />
                                                  Export CSV
                                                </Button>
                                                <Button
                                                  variant="outline"
                                                  onClick={() => setIsBatchEditMode(true)}
                                                >
                                                  <Edit className="h-4 w-4 mr-1" />
                                                  Edit
                                                </Button>
                                                <Button
                                                  variant="outline"
                                                  onClick={() => {
                                                    setSelectedBatchReadings([]);
                                                    setIsBatchReadingModalOpen(false);
                                                    setEditableBatchReadings({});
                                                  }}
                                                >
                                                  Close
                                                </Button>
                                              </>
                                            ) : (
                                              <>
                                                <Button
                                                  variant="outline"
                                                  onClick={() => {
                                                    setIsBatchEditMode(false);
                                                    setEditableBatchReadings({});
                                                  }}
                                                >
                                                  Cancel
                                                </Button>
                                                <Button
                                                  onClick={saveBatchReadings}
                                                  className="bg-blue-600 hover:bg-blue-700"
                                                >
                                                  <Save className="h-4 w-4 mr-1" />
                                                  Save
                                                </Button>
                                              </>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </DialogContent>
                                  </Dialog>

                                  {/* Billing Modal */}
                                  <Dialog open={isBillingModalOpen} onOpenChange={setIsBillingModalOpen}>
                                    <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
                                      <DialogHeader>
                                        <DialogTitle>Latest Meter Reading - {selectedMachineForBilling?.model}</DialogTitle>
                                        <DialogDescription>
                                          Department: {selectedMachineForBilling?.departmentName} | Machine S/N: {selectedMachineForBilling?.serialNumber}
                                        </DialogDescription>
                                      </DialogHeader>

                                      <div className="space-y-4">
                                        {/* Latest Reading Table */}
                                        {!allReadingsForBilling || allReadingsForBilling.length === 0 ? (
                                          <div className="text-center py-8">
                                            <p className="text-gray-500 dark:text-gray-300">No meter reading available for this machine.</p>
                                          </div>
                                        ) : (
                                          <>
                                            <div className="border border-gray-300 rounded-lg overflow-hidden">
                                              <div className="bg-gray-100 px-4 py-2">
                                                <h3 className="font-semibold text-gray-900 dark:text-white">All Readings from Batch ({allReadingsForBilling.length} readings)</h3>
                                              </div>
                                              <div className="overflow-x-auto">
                                                <table className="w-full">
                                                  <thead className="bg-gray-50">
                                                    <tr>
                                                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-100">Type</th>
                                                      <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 dark:text-gray-100">Previous</th>
                                                      <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 dark:text-gray-100">Present</th>
                                                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-100">Date</th>
                                                      <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 dark:text-gray-100">Consumption</th>
                                                      <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 dark:text-gray-100">Spoilage %</th>
                                                      <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 dark:text-gray-100">Rate</th>
                                                      <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 dark:text-gray-100">Amount</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody className="bg-white">
                                                    {allReadingsForBilling.map((reading, index) => (
                                                      <tr key={reading.id} className={index % 2 === 0 ? 'border-t' : 'border-t bg-gray-50'}>
                                                        <td className="px-4 py-3 text-sm font-medium text-gray-900 dark:text-white">{reading.type}</td>
                                                        <td className="px-4 py-3 text-sm text-right text-gray-600 dark:text-gray-200">{reading.previousReading.toLocaleString()}</td>
                                                        <td className="px-4 py-3 text-sm text-right font-medium text-gray-900 dark:text-white">{reading.presentReading.toLocaleString()}</td>
                                                        <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-200">
                                                          {new Date(reading.presentDate).toLocaleDateString()}
                                                        </td>
                                                        <td className="px-4 py-3 text-sm text-right text-gray-900 dark:text-white">{reading.totalConsumption?.toLocaleString()}</td>
                                                        <td className="px-4 py-3 text-sm text-right text-gray-600 dark:text-gray-200">{reading.spoilageTolerance}%</td>
                                                        <td className="px-4 py-3 text-sm text-right text-gray-600 dark:text-gray-200">&#8369;{reading.rate?.toFixed(2)}</td>
                                                        <td className="px-4 py-3 text-sm text-right font-bold text-green-600">&#8369;{reading.amount?.toFixed(2)}</td>
                                                      </tr>
                                                    ))}
                                                  </tbody>
                                                  <tfoot className="bg-green-50">
                                                    <tr>
                                                      <td colSpan="7" className="px-4 py-3 text-right font-bold text-gray-800 dark:text-white">
                                                        Total Amount:
                                                      </td>
                                                      <td className="px-4 py-3 text-right font-bold text-xl text-green-600">
                                                        &#8369;{allReadingsForBilling.reduce((sum, r) => sum + (r.amount || 0), 0).toFixed(2)}
                                                      </td>
                                                    </tr>
                                                  </tfoot>
                                                </table>
                                              </div>
                                            </div>

                                            {/* Billing Info */}
                                            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 space-y-4">
                                              <div className="grid grid-cols-2 gap-4">
                                                <div>
                                                  <label className="text-sm font-medium text-gray-700 dark:text-gray-100">Next Billing Number</label>
                                                  <p className="text-lg font-mono font-bold text-blue-600">
                                                    {String((selectedMachineForBilling?.billingCounter || 0) + 1).padStart(3, '0')}
                                                  </p>
                                                </div>
                                                <div>
                                                  <label className="text-sm font-medium text-gray-700 dark:text-gray-100">BS No.</label>
                                                  <p className="text-lg font-bold text-blue-600">
                                                    {selectedProject?.billingStatementCode || 'N/A'}-{String((selectedMachineForBilling?.billingCounter || 0) + 1).padStart(3, '0')}
                                                  </p>
                                                </div>
                                              </div>
                                              
                                              <div>
                                                <label className="text-sm font-medium text-gray-700 dark:text-gray-100">Attention</label>
                                                <Input
                                                  type="text"
                                                  value={billingAttention}
                                                  onChange={(e) => setBillingAttention(e.target.value)}
                                                  placeholder="Enter attention name"
                                                  className="mt-1"
                                                />
                                              </div>
                                              
                                              <div>
                                                <label className="text-sm font-medium text-gray-700 dark:text-gray-100">Note</label>
                                                <textarea
                                                  value={billingNote}
                                                  onChange={(e) => setBillingNote(e.target.value)}
                                                  placeholder="Enter billing note"
                                                  rows="3"
                                                  className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                />
                                              </div>
                                              
                                              {selectedMachineForBilling?.billingCounter > 0 && (
                                                <div className="pt-3 border-t border-blue-300">
                                                  <label className="text-xs font-medium text-gray-600 dark:text-gray-200">Billing History Range</label>
                                                  <p className="text-sm font-semibold text-gray-700 dark:text-gray-100 mt-1">
                                                    {String(1).padStart(5, '0')} - {String(selectedMachineForBilling.billingCounter).padStart(5, '0')}
                                                    <span className="text-xs text-gray-500 dark:text-gray-300 ml-2">({selectedMachineForBilling.billingCounter} bills generated)</span>
                                                  </p>
                                                </div>
                                              )}
                                            </div>
                                          </>
                                        )}

                                        <div className="flex justify-end gap-2 pt-4 border-t">
                                          <Button
                                            variant="outline"
                                            onClick={() => setIsBillingModalOpen(false)}
                                          >
                                            Close
                                          </Button>
                                          <Button
                                            onClick={() => {
                                              if (!selectedMachineForBilling?.latestReading) {
                                                toast.error('No reading available');
                                                return;
                                              }
                                              setIsBillingPreviewOpen(true);
                                            }}
                                            className="bg-green-600 hover:bg-green-700"
                                          >
                                            <FileText className="h-4 w-4 mr-1" />
                                            Generate Bill
                                          </Button>
                                        </div>
                                      </div>
                                    </DialogContent>
                                  </Dialog>

                                  {/* Billing Preview Modal */}
                                  <Dialog open={isBillingPreviewOpen} onOpenChange={setIsBillingPreviewOpen}>
                                    <DialogContent className="max-w-5xl max-h-[90vh] overflow-y-auto">
                                      <DialogHeader>
                                        <DialogTitle>Billing Statement Preview</DialogTitle>
                                      </DialogHeader>

                                      <div id="billing-preview-content" className="bg-white p-6" style={{ fontFamily: 'Tahoma, sans-serif' }}>
                                        {selectedMachineForBilling?.latestReading && (
                                          <>
                                            {/* Header with Logo */}
                                            <div className="flex items-start mb-3">
                                              <div style={{width: '80px', height: '80px', marginRight: '12px'}}>
                                                
                                                {selectedProject?.logoDataUrl ? (
                                                  <img
                                                    src={selectedProject.logoDataUrl}
                                                    alt="Company Logo"
                                                    style={{width: '100%', height: '100%', objectFit: 'contain'}}
                                                  />
                                                ) : (
                                                  <div className="w-full h-full flex items-center justify-center text-[10px] text-gray-500 dark:text-gray-300">Logo</div>
                                                )}
                                              </div>
                                              <div className="flex-1">
                                                <div className="font-bold" style={{fontSize: '12px', lineHeight: '1.3'}}>ISOURCE ASIA BUSINESS SOLUTIONS CORPORATION</div>
                                                <div style={{fontSize: '9px', lineHeight: '1.4', marginTop: '2px'}}>
                                                  Imelda Bldg, 497-B Calbayog Street,<br />
                                                  Brgy. Highway Hills, Mandaluyong City<br />
                                                  VAT Reg. TIN: 010-611-699-000
                                                </div>
                                              </div>
                                              <div className="text-right" style={{minWidth: '180px'}}>
                                                <div className="font-bold" style={{fontSize: '12px'}}>BILLING STATEMENT</div>
                                                <div style={{fontSize: '10px', marginTop: '2px'}}>{billingHeaderTag}</div>
                                              </div>
                                            </div>


                                            {/* Info Section */}
                                            <div className="mb-3" style={{fontSize: '9px'}}>
                                              <div className="grid grid-cols-2 gap-x-8 gap-y-1">
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Bill To:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{selectedProject?.accountName || ''}</span>
                                                </div>
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Billing Date:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{new Date().toLocaleDateString()}</span>
                                                </div>
                                                
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Address:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{selectedProject?.companyAddress || ''}</span>
                                                </div>
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Billing Number:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5 font-semibold">
                                                    {selectedProject?.billingStatementCode || 'N/A'}-{String((selectedMachineForBilling.billingCounter || 0) + 1).padStart(3, '0')}
                                                  </span>
                                                </div>
                                                
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Department:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{selectedMachineForBilling.departmentName || ''}</span>
                                                </div>
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Printer Unit:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{selectedMachineForBilling.model}</span>
                                                </div>
                                                
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Attention:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{billingAttention || ''}</span>
                                                </div>
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Serial No.:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{selectedMachineForBilling.serialNumber}</span>
                                                </div>
                                              </div>
                                            </div>

                                            {/* Billing Table */}
                                            <div className="my-3">
                                              <div className="bg-gray-400 text-center font-bold py-1 border border-black" style={{fontSize: '9px'}}>
                                                BILLING CHARGES FOR THE MONTH OF {allReadingsForBilling && allReadingsForBilling.length > 0 ? new Date(allReadingsForBilling[0].presentDate).toLocaleDateString('en-US', { month: 'long' }).toUpperCase() : ''}
                                              </div>
                                              <table className="w-full border-collapse border border-black" style={{fontSize: '8px'}}>
                                                <thead>
                                                  <tr className="bg-gray-300">
                                                    <th className="border border-black p-1 font-bold text-left"><div style={{display:'flex',alignItems:'center',height:'100%'}}>Particulars</div></th>
                                                    <th className="border border-black p-1 font-bold text-center"><div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100%'}}>Present Meter<br/>Reading</div></th>
                                                    <th className="border border-black p-1 font-bold text-center"><div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100%'}}>Previous Meter<br/>Reading</div></th>
                                                    <th className="border border-black p-1 font-bold text-center"><div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100%'}}>Total<br/>Consumption</div></th>
                                                    <th className="border border-black p-1 font-bold text-center"><div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100%'}}>%<br/>Spoilage</div></th>
                                                    <th className="border border-black p-1 font-bold text-right"><div style={{display:'flex',alignItems:'center',justifyContent:'flex-end',height:'100%'}}>Price per<br/>copy/print</div></th>
                                                    <th className="border border-black p-1 font-bold text-right"><div style={{display:'flex',alignItems:'center',justifyContent:'flex-end',height:'100%'}}>AMOUNT</div></th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {allReadingsForBilling && allReadingsForBilling.map((reading, index) => (
                                                    <tr key={index}>
                                                      <td className="border border-black p-1"><div style={{display:'flex',alignItems:'center',height:'100%'}}>{reading.type}</div></td>
                                                      <td className="border border-black p-1"><div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100%'}}>{reading.presentReading.toLocaleString()}</div></td>
                                                      <td className="border border-black p-1"><div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100%'}}>{reading.previousReading.toLocaleString()}</div></td>
                                                      <td className="border border-black p-1"><div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100%'}}>{(reading.totalConsumption || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div></td>
                                                      <td className="border border-black p-1"><div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100%'}}>{(reading.spoilageTolerance || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div></td>
                                                      <td className="border border-black p-1"><div style={{display:'flex',alignItems:'center',justifyContent:'flex-end',height:'100%'}}>{(reading.rate || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div></td>
                                                      <td className="border border-black p-1"><div style={{display:'flex',alignItems:'center',justifyContent:'flex-end',height:'100%'}} className="font-semibold">{(reading.amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div></td>
                                                    </tr>
                                                  ))}
                                                  <tr className="bg-gray-200">
                                                    <td colSpan="6" className="border border-black p-1 text-right font-bold" style={{ verticalAlign: 'middle' }}>TOTAL</td>
                                                    <td className="border border-black p-1 text-right font-bold" style={{ verticalAlign: 'middle' }}>
                                                      {allReadingsForBilling && allReadingsForBilling.reduce((sum, r) => sum + (r.amount || 0), 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>

                                            {/* Note Section */}
                                            <div className="border border-black p-2 mb-3" style={{fontSize: '9px'}}>
                                              <div className="font-bold mb-1">Note:</div>
                                              <div className="min-h-[40px] whitespace-pre-wrap">{billingNote || ''}</div>
                                            </div>

                                            {/* Signatures */}
                                            <div className="grid grid-cols-4 gap-0.5">
                                              <div className="border border-black p-3 text-center" style={{fontSize: '8px'}}>
                                                <div className="h-8"></div>
                                                <div className="font-bold border-t border-black pt-1 mt-2">PREPARED BY:</div>
                                                <div className="mt-1">ELLA MAE LAXAMANA</div>
                                              </div>
                                              <div className="border border-black p-3 text-center" style={{fontSize: '8px'}}>
                                                <div className="h-8"></div>
                                                <div className="font-bold border-t border-black pt-1 mt-2">REVIEWED BY:</div>
                                                <div className="mt-1">LOIDA MACEDA</div>
                                              </div>
                                              <div className="border border-black p-3 text-center" style={{fontSize: '8px'}}>
                                                <div className="h-8"></div>
                                                <div className="font-bold border-t border-black pt-1 mt-2">ACCOUNT IN CHARGE:</div>
                                                <div className="mt-1">PAUL RYAN CARINGAL</div>
                                              </div>
                                              <div className="border border-black p-3 text-center" style={{fontSize: '8px'}}>
                                                <div className="h-8"></div>
                                                <div className="font-bold border-t border-black pt-1 mt-2">APPROVED BY:</div>
                                                <div className="mt-1">{(selectedProject?.contactPersons && selectedProject.contactPersons.filter(p => p).length > 0) ? selectedProject.contactPersons.filter(p => p)[0] : ''}</div>
                                              </div>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                      <div className="flex justify-end gap-2 mt-4">
                                        <Button
                                          variant="outline"
                                          onClick={() => setIsBillingPreviewOpen(false)}
                                        >
                                          Cancel
                                        </Button>
                                        <Button
                                          onClick={async () => {
                                            try {
                                              // Increment billing counter for this machine
                                              const response = await axiosInstance.post(`/machines/${selectedMachineForBilling.id}/increment-billing-counter`);
                                              const newBillingNumber = response.data.billingCounter;
                                              
                                              const reading = selectedMachineForBilling.latestReading;
                                              const billingCode = selectedProject?.billingStatementCode || 'N/A';
                                              const bsNumber = `${billingCode}-${String(newBillingNumber).padStart(3, '0')}`;
                                              const exportTag = `${new Date().toISOString().slice(0,7)}-${billingCode}${String(newBillingNumber).padStart(3,'0')}`;
                                              
                                              // Save export record with date, attention, and note
                                              // Pass all reading IDs from the batch
                                              const readingIds = allReadingsForBilling?.map(r => r.id) || [selectedMachineForBilling.latestReading.id];
                                              await axiosInstance.post(`/machines/${selectedMachineForBilling.id}/billing-exports`, {
                                                bsNumber: bsNumber,
                                                exportDate: new Date().toISOString(),
                                                billingCounter: newBillingNumber,
                                                readingIds: readingIds,
                                                attention: billingAttention,
                                                note: billingNote
                                              });
                                              
                                              // Import html2pdf library
                                              const html2pdf = (await import('html2pdf.js')).default;
                                              
                                              // Get the content element
                                              const element = document.getElementById('billing-preview-content');
                                              setBillingHeaderTag(exportTag);
                                              await new Promise(r => setTimeout(r, 100));
                                              
                                              // Configure PDF options
                                              const opt = {
                                                margin: [10, 10, 10, 10],
                                                filename: `Billing-${bsNumber}.pdf`,
                                                image: { type: 'jpeg', quality: 1 },
                                                html2canvas: { 
                                                  scale: 3,
                                                  useCORS: true,
                                                  allowTaint: true,
                                                  logging: false,
                                                  letterRendering: true,
                                                  foreignObjectRendering: false
                                                },
                                                jsPDF: { 
                                                  unit: 'mm', 
                                                  format: 'a4', 
                                                  orientation: 'portrait',
                                                  compress: false
                                                }
                                              };
                                              
                                              // Generate and download PDF
                                              await html2pdf().set(opt).from(element).save();
                                              setBillingHeaderTag('');
                                              
                                              toast.success(`Bill exported! BS No: ${bsNumber}`);
                                              setIsExportDisabled(true); // Disable the button after export
                                              
                                              // Refresh departments to get updated billing counter and billing exports
                                              if (selectedProject?.id) {
                                                await fetchProjectDepartments(selectedProject.id);
                                                await fetchBillingExports(selectedProject.id);
                                              }
                                              
                                              // Close modals after a short delay
                                              setTimeout(() => {
                                                setIsBillingPreviewOpen(false);
                                                setIsBillingModalOpen(false);
                                                setIsExportDisabled(false); // Reset for next use
                                                setBillingAttention(''); // Clear attention
                                                setBillingNote(''); // Clear note
                                              }, 2000);
                                            } catch (error) {
                                              console.error('Error exporting bill:', error);
                                              toast.error('Failed to export bill');
                                            }
                                          }}
                                          disabled={isExportDisabled}
                                          className={`bg-blue-600 hover:bg-blue-700 ${isExportDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                                        >
                                          <FileText className="h-4 w-4 mr-1" />
                                          {isExportDisabled ? 'Exported' : 'Export PDF'}
                                        </Button>
                                      </div>
                                    </DialogContent>
                                  </Dialog>

                                  {/* Billing History Preview Modal (Editable with Delete) */}
                                  <Dialog open={isHistoryPreviewOpen} onOpenChange={setIsHistoryPreviewOpen}>
                                    <DialogContent className="max-w-5xl max-h-[90vh] overflow-y-auto">
                                      <DialogHeader>
                                        <DialogTitle>Billing Statement - {selectedHistoryExport?.bsNumber}</DialogTitle>
                                      </DialogHeader>
                                      {selectedHistoryExport && (
                                        <>
                                          <div className="p-6 bg-white">
                                            <div className="text-sm text-gray-600 dark:text-gray-200 mb-4 text-right">
                                              Exported on: {selectedHistoryExport.exportDate ? new Date(selectedHistoryExport.exportDate).toLocaleDateString() : 'N/A'}
                                            </div>

                                            {/* Meter Reading Details */}
                                            {selectedMeterReadings && selectedMeterReadings.length > 0 ? (
                                              <div className="border-2 border-blue-500 rounded-lg p-6 bg-white">
                                                <h3 className="text-center font-bold mb-6 text-lg text-blue-800 border-b-2 border-blue-300 pb-2">
                                                  METER READING DETAILS
                                                </h3>
                                                
                                                {/* Basic Info */}
                                                <div className="mb-6 bg-gray-50 p-4 rounded-lg">
                                                  <h4 className="font-semibold text-gray-800 dark:text-white mb-3 text-sm uppercase tracking-wide">Basic Information</h4>
                                                  <div className="grid grid-cols-2 gap-4">
                                                    <div>
                                                      <span className="text-xs text-gray-600 dark:text-gray-200 block mb-1">BS Number</span>
                                                      <span className="text-sm font-medium text-gray-900 dark:text-white">{selectedHistoryExport.bsNumber}</span>
                                                    </div>
                                                    <div>
                                                      <span className="text-xs text-gray-600 dark:text-gray-200 block mb-1">Department</span>
                                                      <span className="text-sm font-medium text-gray-900 dark:text-white">{selectedHistoryExport.departmentName || 'N/A'}</span>
                                                    </div>
                                                    <div>
                                                      <span className="text-xs text-gray-600 dark:text-gray-200 block mb-1">Machine</span>
                                                      <span className="text-sm font-medium text-gray-900 dark:text-white">{selectedHistoryExport.machineModel || 'N/A'}</span>
                                                    </div>
                                                    <div>
                                                      <span className="text-xs text-gray-600 dark:text-gray-200 block mb-1">Serial Number</span>
                                                      <span className="text-sm font-medium text-gray-900 dark:text-white">{selectedHistoryExport.machineSerial || 'N/A'}</span>
                                                    </div>
                                                    <div>
                                                      <span className="text-xs text-gray-600 dark:text-gray-200 block mb-1">Date</span>
                                                      <span className="text-sm font-medium text-gray-900 dark:text-white">
                                                        {selectedMeterReadings[0].presentDate ? new Date(selectedMeterReadings[0].presentDate).toLocaleDateString() : 'N/A'}
                                                      </span>
                                                    </div>
                                                    <div>
                                                      <span className="text-xs text-gray-600 dark:text-gray-200 block mb-1">Total Readings</span>
                                                      <span className="text-sm font-medium text-gray-900 dark:text-white">{selectedMeterReadings.length}</span>
                                                    </div>
                                                  </div>
                                                </div>

                                                {/* Meter Readings Table */}
                                                <div className="mb-6">
                                                  <h4 className="font-semibold text-gray-800 dark:text-white mb-3 text-sm uppercase tracking-wide">All Meter Readings</h4>
                                                  <div className="overflow-x-auto">
                                                    <table className="min-w-full border-collapse border border-gray-300">
                                                      <thead className="bg-blue-100">
                                                        <tr>
                                                          <th className="border border-gray-300 px-3 py-2 text-left text-xs font-semibold text-gray-700 dark:text-gray-100">Type</th>
                                                          <th className="border border-gray-300 px-3 py-2 text-right text-xs font-semibold text-gray-700 dark:text-gray-100">Previous Reading</th>
                                                          <th className="border border-gray-300 px-3 py-2 text-right text-xs font-semibold text-gray-700 dark:text-gray-100">Present Reading</th>
                                                          <th className="border border-gray-300 px-3 py-2 text-right text-xs font-semibold text-gray-700 dark:text-gray-100">Consumption</th>
                                                          <th className="border border-gray-300 px-3 py-2 text-right text-xs font-semibold text-gray-700 dark:text-gray-100">Spoilage %</th>
                                                          <th className="border border-gray-300 px-3 py-2 text-right text-xs font-semibold text-gray-700 dark:text-gray-100">Rate</th>
                                                          <th className="border border-gray-300 px-3 py-2 text-right text-xs font-semibold text-gray-700 dark:text-gray-100">Amount</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody className="bg-white">
                                                        {selectedMeterReadings.map((reading, index) => (
                                                          <tr key={reading.id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                                                            <td className="border border-gray-300 px-3 py-2 text-sm font-medium text-gray-900 dark:text-white">
                                                              {reading.type}
                                                            </td>
                                                            <td className="border border-gray-300 px-3 py-2 text-sm text-right text-gray-900 dark:text-white">
                                                              {reading.previousReading.toLocaleString()}
                                                            </td>
                                                            <td className="border border-gray-300 px-3 py-2 text-sm text-right font-semibold text-green-600">
                                                              {reading.presentReading.toLocaleString()}
                                                            </td>
                                                            <td className="border border-gray-300 px-3 py-2 text-sm text-right font-semibold text-blue-600">
                                                              {reading.totalConsumption.toLocaleString()}
                                                            </td>
                                                            <td className="border border-gray-300 px-3 py-2 text-sm text-right text-amber-600">
                                                              {(reading.spoilageTolerance || 0).toFixed(2)}%
                                                            </td>
                                                            <td className="border border-gray-300 px-3 py-2 text-sm text-right text-gray-900 dark:text-white">
                                                              &#8369;{(reading.rate || 0).toFixed(2)}
                                                            </td>
                                                            <td className="border border-gray-300 px-3 py-2 text-sm text-right font-bold text-green-700">
                                                              &#8369;{(reading.amount || 0).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                            </td>
                                                          </tr>
                                                        ))}
                                                      </tbody>
                                                      <tfoot className="bg-green-50">
                                                        <tr>
                                                          <td colSpan="6" className="border border-gray-300 px-3 py-3 text-right font-bold text-gray-800 dark:text-white">
                                                            Total Amount:
                                                          </td>
                                                          <td className="border border-gray-300 px-3 py-3 text-right font-bold text-xl text-green-600">
                                                            &#8369;{selectedMeterReadings.reduce((sum, r) => sum + (r.amount || 0), 0).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                          </td>
                                                        </tr>
                                                      </tfoot>
                                                    </table>
                                                  </div>
                                                </div>
                                              </div>
                                            ) : (
                                              <div className="border-2 border-gray-300 rounded-lg p-6 bg-gray-50 text-center">
                                                <p className="text-gray-500 dark:text-gray-300">No meter reading data available for this billing export.</p>
                                                <p className="text-sm text-gray-400 mt-2">The meter reading may have been deleted or was not linked during export.</p>
                                              </div>
                                            )}
                                            
                                            {/* Show note if exists */}
                                            {selectedHistoryExport.note && (
                                              <div className="border border-gray-300 p-3 mt-4 rounded-md bg-yellow-50 text-sm">
                                                <strong className="text-gray-700 dark:text-gray-100">Note:</strong> <span className="text-gray-600 dark:text-gray-200">{selectedHistoryExport.note}</span>
                                              </div>
                                            )}
                                          </div>
                                        </>
                                      )}
                                      <div className="flex justify-between gap-2 mt-4">
                                        <Button
                                          variant="destructive"
                                          onClick={async () => {
                                            const confirmed = await confirmDialog({
                                                title: "Delete Billing Export",
                                                description: "Are you sure you want to delete this billing export? This action cannot be undone.",
                                                variant: "destructive"
                                            });
                                            if (confirmed) {
                                              try {
                                                await axiosInstance.delete(`/billing-exports/${selectedHistoryExport.id}`);
                                                toast({
                                                  title: 'Success',
                                                  description: 'Billing export deleted successfully',
                                                });
                                                setIsHistoryPreviewOpen(false);
                                                await fetchBillingExports(selectedProject.id); // Refresh the list
                                              } catch (error) {
                                                console.error('Error deleting billing export:', error);
                                                toast({
                                                  title: 'Error',
                                                  description: 'Failed to delete billing export',
                                                  variant: 'destructive',
                                                });
                                              }
                                            }
                                          }}
                                        >
                                          <Trash2 className="h-4 w-4 mr-1" />
                                          Delete
                                        </Button>
                                        <div className="flex gap-2">
                                          <Button
                                            variant="outline"
                                            onClick={() => setIsHistoryPreviewOpen(false)}
                                          >
                                            Cancel
                                          </Button>
                                          <Button
                                            onClick={async () => {
                                              try {
                                                await axiosInstance.put(`/billing-exports/${selectedHistoryExport.id}`, {
                                                  attention: selectedHistoryExport.attention,
                                                  note: selectedHistoryExport.note,
                                                });
                                                toast({
                                                  title: 'Success',
                                                  description: 'Billing export updated successfully',
                                                });
                                                setIsHistoryPreviewOpen(false);
                                                await fetchBillingExports(selectedProject.id); // Refresh the list
                                              } catch (error) {
                                                console.error('Error updating billing export:', error);
                                                toast({
                                                  title: 'Error',
                                                  description: 'Failed to update billing export',
                                                  variant: 'destructive',
                                                });
                                              }
                                            }}
                                          >
                                            <Save className="h-4 w-4 mr-1" />
                                            Save Changes
                                          </Button>
                                        </div>
                                      </div>
                                    </DialogContent>
                                  </Dialog>

                                  {/* Billing Statement Preview from History Modal */}
                                  <Dialog open={isBillingStatementPreviewOpen} onOpenChange={setIsBillingStatementPreviewOpen}>
                                    <DialogContent className="max-w-5xl max-h-[90vh] overflow-y-auto">
                                      <DialogHeader>
                                        <DialogTitle>Billing Statement Preview</DialogTitle>
                                      </DialogHeader>

                                      <div id="billing-preview-content" className="bg-white p-6 font-sans">
                                        {selectedMachineForBilling?.latestReading && (
                                          <>
                                            {/* Header with Logo */}
                                            <div className="flex items-start mb-3">
                                              <div style={{width: '80px', height: '80px', marginRight: '12px'}}>
                                                {/*
                                                  src="data:image/jpeg;base64,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"
                                                  alt="iSource Logo"
                                                  style={{width: '100%', height: '100%', objectFit: 'contain'}}
                                                */}
                                                {selectedProject?.logoDataUrl ? (
                                                  <img
                                                    src={selectedProject.logoDataUrl}
                                                    alt="Company Logo"
                                                    style={{width: '100%', height: '100%', objectFit: 'contain'}}
                                                  />
                                                ) : (
                                                  <div className="w-full h-full flex items-center justify-center text-[10px] text-gray-500 dark:text-gray-300">Logo</div>
                                                )}
                                              </div>
                                              <div className="flex-1">
                                                <div className="font-bold" style={{fontSize: '12px', lineHeight: '1.3'}}>ISOURCE ASIA BUSINESS SOLUTIONS CORPORATION</div>
                                                <div style={{fontSize: '9px', lineHeight: '1.4', marginTop: '2px'}}>
                                                  Imelda Bldg, 497-B Calbayog Street,<br />
                                                  Brgy. Highway Hills, Mandaluyong City<br />
                                                  VAT Reg. TIN: 010-611-699-000
                                                </div>
                                              </div>
                                            </div>

                                            <div className="text-center font-bold mb-3" style={{fontSize: '14px'}}>BILLING STATEMENT</div>

                                            {/* Info Section */}
                                            <div className="mb-3" style={{fontSize: '9px'}}>
                                              <div className="grid grid-cols-2 gap-x-8 gap-y-1">
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Bill To:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{selectedProject?.accountName || ''}</span>
                                                </div>
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Billing Date:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{billingStatementData?.exportRecord?.exportDate ? new Date(billingStatementData.exportRecord.exportDate).toLocaleDateString() : ''}</span>
                                                </div>
                                                
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Address:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{selectedProject?.companyAddress || ''}</span>
                                                </div>
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Billing Number:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5 font-semibold">
                                                    {billingStatementData?.exportRecord?.bsNumber || ''}
                                                  </span>
                                                </div>
                                                
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Department:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{billingStatementData?.exportRecord?.departmentName || ''}</span>
                                                </div>
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Printer Unit:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{billingStatementData?.exportRecord?.machineModel || ''}</span>
                                                </div>
                                                
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Attention:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{billingStatementData?.exportRecord?.attention || ''}</span>
                                                </div>
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Serial No.:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{billingStatementData?.exportRecord?.machineSerial || ''}</span>
                                                </div>
                                              </div>
                                            </div>

                                            {/* Billing Table */}
                                            <div className="my-3">
                                              <div className="bg-gray-400 text-center font-bold py-1 border border-black" style={{fontSize: '9px'}}>
                                                BILLING CHARGES FOR THE MONTH OF {billingStatementData?.readings && billingStatementData.readings.length > 0 ? new Date(billingStatementData.readings[0].presentDate).toLocaleDateString('en-US', { month: 'long' }).toUpperCase() : ''}
                                              </div>
                                              <table className="w-full border-collapse border border-black" style={{fontSize: '8px'}}>
                                                <thead>
                                                  <tr className="bg-gray-300">
                                                    <th className="border border-black p-1 font-bold text-left"><div style={{display:'flex',alignItems:'center',height:'100%'}}>Particulars</div></th>
                                                    <th className="border border-black p-1 font-bold text-center"><div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100%'}}>Present Meter<br/>Reading</div></th>
                                                    <th className="border border-black p-1 font-bold text-center"><div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100%'}}>Previous Meter<br/>Reading</div></th>
                                                    <th className="border border-black p-1 font-bold text-center"><div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100%'}}>Total<br/>Consumption</div></th>
                                                    <th className="border border-black p-1 font-bold text-center"><div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100%'}}>%<br/>Spoilage</div></th>
                                                    <th className="border border-black p-1 font-bold text-right"><div style={{display:'flex',alignItems:'center',justifyContent:'flex-end',height:'100%'}}>Price per<br/>copy/print</div></th>
                                                    <th className="border border-black p-1 font-bold text-right"><div style={{display:'flex',alignItems:'center',justifyContent:'flex-end',height:'100%'}}>AMOUNT</div></th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {billingStatementData?.readings && billingStatementData.readings.map((reading, index) => (
                                                    <tr key={index}>
                                                      <td className="border border-black p-1">{reading.type}</td>
                                                      <td className="border border-black p-1 text-center">{reading.presentReading.toLocaleString()}</td>
                                                      <td className="border border-black p-1 text-center">{reading.previousReading.toLocaleString()}</td>
                                                      <td className="border border-black p-1 text-center">{(reading.totalConsumption || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                      <td className="border border-black p-1 text-center">{(reading.spoilageTolerance || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                      <td className="border border-black p-1 text-center">{(reading.rate || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                      <td className="border border-black p-1 text-center font-semibold">{(reading.amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                    </tr>
                                                  ))}
                                                  <tr className="bg-gray-200">
                                                    <td colSpan="6" className="border border-black p-1 text-right font-bold">TOTAL</td>
                                                    <td className="border border-black p-1 text-right font-bold">
                                                      {billingStatementData?.readings && billingStatementData.readings.reduce((sum, r) => sum + (r.amount || 0), 0).toFixed(2)}
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>

                                            {/* Note Section */}
                                            <div className="border border-black p-2 mb-3" style={{fontSize: '9px'}}>
                                              <div className="font-bold mb-1">Note:</div>
                                              <div className="min-h-[40px] whitespace-pre-wrap">{billingStatementData?.exportRecord?.note || ''}</div>
                                            </div>

                                            {/* Signatures */}
                                            <div className="grid grid-cols-4 gap-0.5">
                                              <div className="border border-black p-3 text-center" style={{fontSize: '8px'}}>
                                                <div className="h-8"></div>
                                                <div className="font-bold border-t border-black pt-1 mt-2">PREPARED BY:</div>
                                                <div className="mt-1">ELLA MAE LAXAMANA</div>
                                              </div>
                                              <div className="border border-black p-3 text-center" style={{fontSize: '8px'}}>
                                                <div className="h-8"></div>
                                                <div className="font-bold border-t border-black pt-1 mt-2">REVIEWED BY:</div>
                                                <div className="mt-1">LOIDA MACEDA</div>
                                              </div>
                                              <div className="border border-black p-3 text-center" style={{fontSize: '8px'}}>
                                                <div className="h-8"></div>
                                                <div className="font-bold border-t border-black pt-1 mt-2">ACCOUNT IN CHARGE:</div>
                                                <div className="mt-1">PAUL RYAN CARINGAL</div>
                                              </div>
                                              <div className="border border-black p-3 text-center" style={{fontSize: '8px'}}>
                                                <div className="h-8"></div>
                                                <div className="font-bold border-t border-black pt-1 mt-2">APPROVED BY:</div>
                                                <div className="mt-1">{(selectedProject?.contactPersons && selectedProject.contactPersons.filter(p => p).length > 0) ? selectedProject.contactPersons.filter(p => p)[0] : ''}</div>
                                              </div>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                      <div className="flex justify-end gap-2 mt-4">
                                        <Button
                                          variant="outline"
                                          onClick={() => setIsBillingStatementPreviewOpen(false)}
                                        >
                                          Close
                                        </Button>
                                        <Button
                                          onClick={async () => {
                                            try {
                                              // Import html2pdf library
                                              const html2pdf = (await import('html2pdf.js')).default;
                                              
                                              // Get the content element
                                              const element = document.getElementById('billing-statement-history-preview-content');
                                              
                                              // Configure PDF options
                                              const opt = {
                                                margin: [10, 10, 10, 10],
                                                filename: `Billing-${billingStatementData?.exportRecord?.bsNumber || 'Statement'}.pdf`,
                                                image: { type: 'jpeg', quality: 1 },
                                                html2canvas: { 
                                                  scale: 3,
                                                  useCORS: true,
                                                  allowTaint: true,
                                                  logging: false,
                                                  letterRendering: true,
                                                  foreignObjectRendering: false
                                                },
                                                jsPDF: { 
                                                  unit: 'mm', 
                                                  format: 'a4', 
                                                  orientation: 'portrait',
                                                  compress: false
                                                }
                                              };
                                              
                                              // Generate and download PDF
                                              await html2pdf().set(opt).from(element).save();
                                              
                                              toast.success('PDF exported successfully!');
                                            } catch (error) {
                                              console.error('Error exporting PDF:', error);
                                              toast.error('Failed to export PDF');
                                            }
                                          }}
                                          className="bg-blue-600 hover:bg-blue-700"
                                        >
                                          <FileText className="h-4 w-4 mr-1" />
                                          Export PDF
                                        </Button>
                                      </div>
                                    </DialogContent>
                                  </Dialog>

                                  {/* SI Preview Modal */}
                                  <Dialog open={isSIPreviewOpen} onOpenChange={setIsSIPreviewOpen}>
                                    <DialogContent className="max-w-6xl max-h-[90vh] overflow-y-auto">
                                      <DialogHeader>
                                        <DialogTitle>Sales Invoice - {selectedSIData?.machine?.model}</DialogTitle>
                                      </DialogHeader>

                                      {selectedSIData && (
                                        <div className="space-y-4">
                                          {/* Machine and Department Info */}
                                          <div className="bg-gray-50 p-4 rounded-lg">
                                            <div className="grid grid-cols-2 gap-4 text-sm">
                                              <div>
                                                <span className="font-semibold">Machine:</span> {selectedSIData.machine.model}
                                              </div>
                                              <div>
                                                <span className="font-semibold">Serial Number:</span> {selectedSIData.machine.serialNumber}
                                              </div>
                                              <div>
                                                <span className="font-semibold">Department:</span> {selectedSIData.department.name}
                                              </div>
                                              <div>
                                                <span className="font-semibold">BS Number:</span> {selectedSIData.exportRecord.bsNumber}
                                              </div>
                                            </div>
                                          </div>

                                          {/* PDF Viewer */}
                                          {selectedSIData.exportRecord?.approvedBillingStatementUrl && (
                                            <div className="border rounded-lg overflow-hidden">
                                              <div className="bg-gray-100 p-2 text-sm font-semibold">
                                                Approved Billing Statement
                                              </div>
                                              <div className="h-[500px]">
                                                <iframe
                                                  src={selectedSIData.exportRecord.approvedBillingStatementUrl.replace('/view', '/preview')}
                                                  className="w-full h-full"
                                                  title="Billing Statement PDF"
                                                />
                                              </div>
                                            </div>
                                          )}

                                          {/* Sales Invoice Preview Content (Hidden, for PDF generation) */}
                                          <div id="sales-invoice-preview-content-alt" className="bg-white p-6" style={{display: 'none', fontFamily: 'Tahoma, sans-serif'}}>
                                            {/* Header with Logo */}
                                            <div className="flex items-start mb-3">
                                              <div style={{width: '80px', height: '80px', marginRight: '12px'}}>
                                                <img 
                                                  src="https://customer-assets.emergentagent.com/job_hr-system-repair-1/artifacts/au3caisj_iSource%20LOGO.png"
                                                  alt="iSource Logo"
                                                  style={{width: '100%', height: '100%', objectFit: 'contain'}}
                                                />
                                              </div>
                                              <div className="flex-1">
                                                <div className="font-bold" style={{fontSize: '12px', lineHeight: '1.3'}}>ISOURCE ASIA BUSINESS SOLUTIONS CORPORATION</div>
                                                <div style={{fontSize: '9px', lineHeight: '1.4', marginTop: '2px'}}>
                                                  Imelda Bldg, 497-B Calbayog Street,<br />
                                                  Brgy. Highway Hills, Mandaluyong City<br />
                                                  VAT Reg. TIN: 010-611-699-000
                                                </div>
                                              </div>
                                            </div>

                                            <div className="text-center font-bold mb-3" style={{fontSize: '14px'}}>SALES INVOICE</div>

                                            {/* Info Section */}
                                            <div className="mb-3" style={{fontSize: '9px'}}>
                                              <div className="grid grid-cols-2 gap-x-8 gap-y-1">
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Bill To:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{selectedProject?.accountName || ''}</span>
                                                </div>
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Invoice Date:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{selectedSIData?.exportRecord?.exportDate ? new Date(selectedSIData.exportRecord.exportDate).toLocaleDateString() : ''}</span>
                                                </div>
                                                
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Address:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{selectedProject?.companyAddress || ''}</span>
                                                </div>
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Invoice Number:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5 font-semibold">
                                                    SI-{selectedSIData?.exportRecord?.bsNumber || ''}
                                                  </span>
                                                </div>
                                                
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Department:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{selectedSIData?.exportRecord?.departmentName || ''}</span>
                                                </div>
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Printer Unit:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{selectedSIData?.exportRecord?.machineModel || ''}</span>
                                                </div>
                                                
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Attention:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{selectedSIData?.exportRecord?.attention || ''}</span>
                                                </div>
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Serial No.:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{selectedSIData?.exportRecord?.machineSerial || ''}</span>
                                                </div>
                                              </div>
                                            </div>

                                            {/* Invoice Table */}
                                            <div className="my-3">
                                              <div className="bg-gray-400 text-center font-bold py-1 border border-black" style={{fontSize: '9px'}}>
                                                INVOICE CHARGES FOR THE MONTH OF {selectedSIData?.readings && selectedSIData.readings.length > 0 ? new Date(selectedSIData.readings[0].presentDate).toLocaleDateString('en-US', { month: 'long' }).toUpperCase() : ''}
                                              </div>
                                              <table className="w-full border-collapse border border-black" style={{fontSize: '8px'}}>
                                                <thead>
                                                  <tr className="bg-gray-300">
                                                    <th className="border border-black p-1 font-bold text-left">Particulars</th>
                                                    <th className="border border-black p-1 font-bold text-center">Present Meter<br/>Reading</th>
                                                    <th className="border border-black p-1 font-bold text-center">Previous Meter<br/>Reading</th>
                                                    <th className="border border-black p-1 font-bold text-center">Total<br/>Consumption</th>
                                                    <th className="border border-black p-1 font-bold text-center">%<br/>Spoilage</th>
                                                    <th className="border border-black p-1 font-bold text-center">Price per<br/>copy/print</th>
                                                    <th className="border border-black p-1 font-bold text-center">AMOUNT</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {selectedSIData?.readings && selectedSIData.readings.map((reading, index) => (
                                                    <tr key={index}>
                                                      <td className="border border-black p-1"><div style={{display:'flex',alignItems:'center',height:'100%'}}>{reading.type}</div></td>
                                                      <td className="border border-black p-1"><div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100%'}}>{reading.presentReading.toLocaleString()}</div></td>
                                                      <td className="border border-black p-1"><div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100%'}}>{reading.previousReading.toLocaleString()}</div></td>
                                                      <td className="border border-black p-1"><div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100%'}}>{(reading.totalConsumption || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div></td>
                                                      <td className="border border-black p-1"><div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100%'}}>{(reading.spoilageTolerance || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div></td>
                                                      <td className="border border-black p-1"><div style={{display:'flex',alignItems:'center',justifyContent:'flex-end',height:'100%'}}>{(reading.rate || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div></td>
                                                      <td className="border border-black p-1"><div style={{display:'flex',alignItems:'center',justifyContent:'flex-end',height:'100%'}} className="font-semibold">{(reading.amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div></td>
                                                    </tr>
                                                  ))}
                                                  <tr className="bg-gray-200">
                                                    <td colSpan="6" className="border border-black p-1 text-right font-bold" style={{ verticalAlign: 'middle' }}>TOTAL</td>
                                                    <td className="border border-black p-1 text-right font-bold" style={{ verticalAlign: 'middle' }}>
                                                      {selectedSIData?.readings && selectedSIData.readings.reduce((sum, r) => sum + (r.amount || 0), 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>

                                            {/* Note Section */}
                                            <div className="border border-black p-2 mb-3" style={{fontSize: '9px'}}>
                                              <div className="font-bold mb-1">Note:</div>
                                              <div className="min-h-[40px] whitespace-pre-wrap">{selectedSIData?.exportRecord?.note || ''}</div>
                                            </div>

                                            {/* Signatures */}
                                            <div className="grid grid-cols-4 gap-0.5">
                                              <div className="border border-black p-3 text-center" style={{fontSize: '8px'}}>
                                                <div className="h-8"></div>
                                                <div className="font-bold border-t border-black pt-1 mt-2">PREPARED BY:</div>
                                              </div>
                                              <div className="border border-black p-3 text-center" style={{fontSize: '8px'}}>
                                                <div className="h-8"></div>
                                                <div className="font-bold border-t border-black pt-1 mt-2">REVIEWED BY:</div>
                                              </div>
                                              <div className="border border-black p-3 text-center" style={{fontSize: '8px'}}>
                                                <div className="h-8"></div>
                                                <div className="font-bold border-t border-black pt-1 mt-2">ACCOUNT IN CHARGE:</div>
                                              </div>
                                              <div className="border border-black p-3 text-center" style={{fontSize: '8px'}}>
                                                <div className="h-8"></div>
                                                <div className="font-bold border-t border-black pt-1 mt-2">APPROVED BY:</div>
                                              </div>
                                            </div>
                                          </div>


                                          <div id="sales-invoice-preview-content" className="bg-white p-6" style={{display: 'none', fontFamily: 'Tahoma, sans-serif'}}>
                                            <div className="flex items-start mb-3">
                                              <div style={{width: '80px', height: '80px', marginRight: '12px'}}>
                                                <img 
                                                  src="https://customer-assets.emergentagent.com/job_hr-system-repair-1/artifacts/au3caisj_iSource%20LOGO.png"
                                                  alt="iSource Logo"
                                                  style={{width: '100%', height: '100%', objectFit: 'contain'}}
                                                />
                                              </div>
                                              <div className="flex-1">
                                                <div className="font-bold" style={{fontSize: '12px', lineHeight: '1.3'}}>ISOURCE ASIA BUSINESS SOLUTIONS CORPORATION</div>
                                                <div style={{fontSize: '9px', lineHeight: '1.4', marginTop: '2px'}}>
                                                  Imelda Bldg, 497-B Calbayog Street,<br />
                                                  Brgy. Highway Hills, Mandaluyong City<br />
                                                  VAT Reg. TIN: 010-611-699-000
                                                </div>
                                              </div>
                                            </div>
                                            <div className="text-center font-bold mb-3" style={{fontSize: '14px'}}>SALES INVOICE</div>
                                            <div className="mb-3" style={{fontSize: '9px'}}>
                                              <div className="grid grid-cols-2 gap-x-8 gap-y-1">
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Bill To:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{selectedProject?.accountName || ''}</span>
                                                </div>
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Invoice Date:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{selectedSIData?.exportRecord?.exportDate ? new Date(selectedSIData.exportRecord.exportDate).toLocaleDateString() : ''}</span>
                                                </div>
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Address:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{selectedProject?.companyAddress || ''}</span>
                                                </div>
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Invoice Number:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5 font-semibold">
                                                    SI-{selectedSIData?.exportRecord?.bsNumber || ''}
                                                  </span>
                                                </div>
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Department:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{selectedSIData?.exportRecord?.departmentName || ''}</span>
                                                </div>
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Printer Unit:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{selectedSIData?.exportRecord?.machineModel || ''}</span>
                                                </div>
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Attention:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{selectedSIData?.exportRecord?.attention || ''}</span>
                                                </div>
                                                <div className="flex items-center">
                                                  <span className="font-semibold mr-1">Serial No.:</span>
                                                  <span className="flex-1 border-b border-black pb-0.5">{selectedSIData?.exportRecord?.machineSerial || ''}</span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          {/* Action Buttons */}
                                          <div className="flex justify-end gap-2 mt-4">
                                            <Button
                                              variant="outline"
                                              onClick={() => {
                                                setIsSIPreviewOpen(false);
                                                setSelectedSIData(null);
                                              }}
                                            >
                                              Close
                                            </Button>
                                            <Button
                                              onClick={async () => {
                                                try {
                                                  console.log('=== Generate Sales Invoice Clicked ===');
                                                  console.log('selectedSIData:', selectedSIData);
                                                  console.log('readings count:', selectedSIData?.readings?.length || 0);
                                                  console.log('readings data:', selectedSIData?.readings);
                                                  
                                                  // Validate that we have readings
                                                  if (!selectedSIData?.readings || selectedSIData.readings.length === 0) {
                                                    toast.error('No meter readings found for this billing statement');
                                                    return;
                                                  }
                                                  
                                                  // Import html2pdf library
                                                  const html2pdf = (await import('html2pdf.js')).default;
                                                  
                                                  // Get the content element
                                                  const element = document.getElementById('sales-invoice-preview-content');
                                                  
                                                  if (!element) {
                                                    console.error('Sales invoice preview element not found');
                                                    toast.error('Failed to find PDF template');
                                                    return;
                                                  }
                                                  
                                                  // Generate SI Number (format: SI-BSNUMBER)
                                                  const siNumber = `SI-${selectedSIData.exportRecord.bsNumber}`;
                                                  const currentDate = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
                                                  const filename = `${siNumber} - ${currentDate}.pdf`;
                                                  
                                                  // Calculate total amount from readings
                                                  const totalAmount = selectedSIData.readings.reduce((sum, r) => sum + (r.amount || 0), 0);
                                                  
                                                  console.log('Total Amount:', totalAmount);
                                                  console.log('SI Number:', siNumber);
                                                  console.log('Filename:', filename);
                                                  
                                                  // Show loading toast
                                                  toast.info('Generating Sales Invoice...');
                                                  
                                                  // Temporarily show the element for PDF generation
                                                  element.style.display = 'block';
                                                  
                                                  // Configure PDF options
                                                  const opt = {
                                                    margin: [10, 10, 10, 10],
                                                    filename: filename,
                                                    image: { type: 'jpeg', quality: 1 },
                                                    html2canvas: { 
                                                      scale: 3,
                                                      useCORS: true,
                                                      allowTaint: true,
                                                      logging: false,
                                                      letterRendering: true,
                                                      foreignObjectRendering: false
                                                    },
                                                    jsPDF: { 
                                                      unit: 'mm', 
                                                      format: 'a4', 
                                                      orientation: 'portrait',
                                                      compress: false
                                                    }
                                                  };
                                                  
                                                  // Generate PDF as blob
                                                  const pdf = html2pdf().set(opt).from(element);
                                                  const pdfBlob = await pdf.output('blob');
                                                  
                                                  // Hide the element again
                                                  element.style.display = 'none';
                                                  
                                                  // Download PDF locally
                                                  const link = document.createElement('a');
                                                  link.href = URL.createObjectURL(pdfBlob);
                                                  link.download = filename;
                                                  link.click();
                                                  URL.revokeObjectURL(link.href);
                                                  
                                                  // Create SI record in backend
                                                  toast.info('Saving to database...');
                                                  const siData = {
                                                    project_id: selectedProject.id,
                                                    machine_id: selectedSIData.machine.id,
                                                    department_id: selectedSIData.department.id,
                                                    bsNumber: selectedSIData.exportRecord.bsNumber,
                                                    siNumber: siNumber,
                                                    invoiceDate: new Date().toISOString(),
                                                    machineModel: selectedSIData.machine.model,
                                                    machineSerial: selectedSIData.machine.serialNumber,
                                                    departmentName: selectedSIData.department.name,
                                                    totalAmount: totalAmount,
                                                    readings: selectedSIData.readings
                                                  };
                                                  
                                                  const createResponse = await axiosInstance.post('/sales-invoices', siData);
                                                  const invoiceId = createResponse.data.id;
                                                  
                                                  // Upload PDF to Google Drive
                                                  toast.info('Uploading to Google Drive...');
                                                  const formData = new FormData();
                                                  formData.append('file', pdfBlob, filename);
                                                  
                                                  await axiosInstance.post(`/sales-invoices/${invoiceId}/upload-pdf`, formData, {
                                                    headers: {
                                                      'Content-Type': 'multipart/form-data'
                                                    }
                                                  });
                                                  
                                                  // Refresh SI history list
                                                  await fetchSalesInvoices(selectedProject.id);
                                                  
                                                  toast.success('Sales Invoice generated and saved successfully!');
                                                  
                                                  // Close modal
                                                  setIsSIPreviewOpen(false);
                                                  setSelectedSIData(null);
                                                  
                                                } catch (error) {
                                                  console.error('Error generating Sales Invoice:', error);
                                                  toast.error('Failed to generate Sales Invoice: ' + (error?.message || 'Unknown error'));
                                                }
                                              }}
                                              className="bg-green-600 hover:bg-green-700"
                                            >
                                              <FileText className="h-4 w-4 mr-1" />
                                              Generate Sales Invoice
                                            </Button>
                                          </div>
                                        </div>
                                      )}
                                    </DialogContent>
                                  </Dialog>

                                  {/* SI File Preview Modal */}
                                  <Dialog open={isSIFilePreviewOpen} onOpenChange={setIsSIFilePreviewOpen}>
                                    <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
                                      <DialogHeader>
                                        <DialogTitle>Sales Invoice - {selectedSIFileData?.siNumber}</DialogTitle>
                                      </DialogHeader>

                                      {selectedSIFileData && (
                                        <div className="space-y-4">
                                          {/* Invoice Details */}
                                          <div className="bg-gray-50 p-4 rounded-lg grid grid-cols-2 gap-4 text-sm">
                                            <div><span className="font-semibold">SI Number:</span> {selectedSIFileData.siNumber}</div>
                                            <div><span className="font-semibold">BS Number:</span> {selectedSIFileData.bsNumber}</div>
                                            <div><span className="font-semibold">Department:</span> {selectedSIFileData.departmentName}</div>
                                            <div><span className="font-semibold">Machine:</span> {selectedSIFileData.machineModel}</div>
                                            <div><span className="font-semibold">Serial Number:</span> {selectedSIFileData.machineSerial}</div>
                                            <div><span className="font-semibold">Date:</span> {selectedSIFileData.invoiceDate ? new Date(selectedSIFileData.invoiceDate).toLocaleDateString() : 'N/A'}</div>
                                            <div className="col-span-2"><span className="font-semibold">Total Amount:</span> <span className="text-green-600 font-bold">&#8369;{(selectedSIFileData.totalAmount || 0).toFixed(2)}</span></div>
                                          </div>

                                          {/* PDF Preview */}
                                          {selectedSIFileData.pdfUrl && (
                                            <div className="border rounded-lg overflow-hidden">
                                              <div className="bg-gray-100 p-2 text-sm font-semibold flex items-center justify-between">
                                                <span>Sales Invoice PDF</span>
                                                <a
                                                  href={selectedSIFileData.pdfUrl}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  className="text-blue-600 hover:text-blue-800 text-xs"
                                                >
                                                  Open in new tab
                                                </a>
                                              </div>
                                              <div className="h-[500px]">
                                                <iframe
                                                  src={selectedSIFileData.pdfUrl.replace('/view', '/preview')}
                                                  className="w-full h-full"
                                                  title="Sales Invoice PDF"
                                                />
                                              </div>
                                            </div>
                                          )}

                                          {/* Action Buttons */}
                                          <div className="flex justify-end gap-2">
                                            <Button
                                              variant="outline"
                                              onClick={() => {
                                                setIsSIFilePreviewOpen(false);
                                                setSelectedSIFileData(null);
                                              }}
                                            >
                                              Close
                                            </Button>
                                            {selectedSIFileData.pdfUrl && (
                                              <Button
                                                onClick={() => {
                                                  // Download the PDF
                                                  const link = document.createElement('a');
                                                  link.href = selectedSIFileData.pdfUrl.replace('/view', '/uc?export=download');
                                                  link.download = `${selectedSIFileData.siNumber}.pdf`;
                                                  link.target = '_blank';
                                                  link.click();
                                                  toast.success('Download started!');
                                                }}
                                                className="bg-blue-600 hover:bg-blue-700"
                                              >
                                                <Download className="h-4 w-4 mr-1" />
                                                Download
                                              </Button>
                                            )}
                                          </div>
                                        </div>
                                      )}
                                    </DialogContent>
                                  </Dialog>

                                  {/* Collection Modal - Mark as Paid/Pending */}
                                  <Dialog open={isCollectionModalOpen} onOpenChange={setIsCollectionModalOpen}>
                                    <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
                                      <DialogHeader>
                                        <DialogTitle>Collection - {selectedCollectionMachine?.salesInvoice?.siNumber}</DialogTitle>
                                      </DialogHeader>

                                      {selectedCollectionMachine && (
                                        <div className="space-y-4">
                                          {/* Collection Details */}
                                          <div className="bg-gray-50 p-4 rounded-lg grid grid-cols-2 gap-4 text-sm">
                                            <div><span className="font-semibold">SI Number:</span> {selectedCollectionMachine.salesInvoice.siNumber}</div>
                                            <div><span className="font-semibold">BS Number:</span> {selectedCollectionMachine.salesInvoice.bsNumber}</div>
                                            <div><span className="font-semibold">Department:</span> {selectedCollectionMachine.department.name}</div>
                                            <div><span className="font-semibold">Machine:</span> {selectedCollectionMachine.machine.model}</div>
                                            <div><span className="font-semibold">Serial Number:</span> {selectedCollectionMachine.machine.serialNumber}</div>
                                            <div><span className="font-semibold">Invoice Date:</span> {selectedCollectionMachine.salesInvoice.invoiceDate ? new Date(selectedCollectionMachine.salesInvoice.invoiceDate).toLocaleDateString() : 'N/A'}</div>
                                            <div className="col-span-2"><span className="font-semibold">Total Amount:</span> <span className="text-green-600 font-bold">&#8369;{(selectedCollectionMachine.salesInvoice.totalAmount || 0).toFixed(2)}</span></div>
                                          </div>

                                          {/* PDF Preview */}
                                          {selectedCollectionMachine.salesInvoice.pdfUrl && (
                                            <div className="border rounded-lg overflow-hidden">
                                              <div className="bg-gray-100 p-2 text-sm font-semibold">Sales Invoice PDF</div>
                                              <div className="h-[400px]">
                                                <iframe
                                                  src={selectedCollectionMachine.salesInvoice.pdfUrl.replace('/view', '/preview')}
                                                  className="w-full h-full"
                                                  title="Sales Invoice PDF"
                                                />
                                              </div>
                                            </div>
                                          )}

                                          {/* Action Buttons - Paid/Pending */}
                                          <div className="flex justify-end gap-3 pt-4 border-t">
                                            <Button
                                              variant="outline"
                                              onClick={() => {
                                                setIsCollectionModalOpen(false);
                                                setSelectedCollectionMachine(null);
                                              }}
                                            >
                                              Cancel
                                            </Button>
                                            <Button
                                              onClick={async () => {
                                                try {
                                                  toast.info('Saving as Pending...');
                                                  const collectionData = {
                                                    project_id: selectedProject.id,
                                                    machine_id: selectedCollectionMachine.machine.id,
                                                    department_id: selectedCollectionMachine.department.id,
                                                    si_id: selectedCollectionMachine.salesInvoice.id,
                                                    siNumber: selectedCollectionMachine.salesInvoice.siNumber,
                                                    bsNumber: selectedCollectionMachine.salesInvoice.bsNumber,
                                                    status: 'pending',
                                                    collectionDate: new Date().toISOString(),
                                                    machineModel: selectedCollectionMachine.machine.model,
                                                    machineSerial: selectedCollectionMachine.machine.serialNumber,
                                                    departmentName: selectedCollectionMachine.department.name,
                                                    totalAmount: selectedCollectionMachine.salesInvoice.totalAmount,
                                                    pdfUrl: selectedCollectionMachine.salesInvoice.pdfUrl
                                                  };
                                                  
                                                  await axiosInstance.post('/collections', collectionData);
                                                  await fetchCollections(selectedProject.id);
                                                  
                                                  toast.success('Collection saved as Pending!');
                                                  setIsCollectionModalOpen(false);
                                                  setSelectedCollectionMachine(null);
                                                } catch (error) {
                                                  console.error('Error saving collection:', error);
                                                  toast.error('Failed to save collection');
                                                }
                                              }}
                                              className="bg-yellow-600 hover:bg-yellow-700"
                                            >
                                              Mark as Pending
                                            </Button>
                                            <Button
                                              onClick={async () => {
                                                try {
                                                  toast.info('Saving as Paid...');
                                                  const collectionData = {
                                                    project_id: selectedProject.id,
                                                    machine_id: selectedCollectionMachine.machine.id,
                                                    department_id: selectedCollectionMachine.department.id,
                                                    si_id: selectedCollectionMachine.salesInvoice.id,
                                                    siNumber: selectedCollectionMachine.salesInvoice.siNumber,
                                                    bsNumber: selectedCollectionMachine.salesInvoice.bsNumber,
                                                    status: 'paid',
                                                    collectionDate: new Date().toISOString(),
                                                    machineModel: selectedCollectionMachine.machine.model,
                                                    machineSerial: selectedCollectionMachine.machine.serialNumber,
                                                    departmentName: selectedCollectionMachine.department.name,
                                                    totalAmount: selectedCollectionMachine.salesInvoice.totalAmount,
                                                    pdfUrl: selectedCollectionMachine.salesInvoice.pdfUrl
                                                  };
                                                  
                                                  await axiosInstance.post('/collections', collectionData);
                                                  await fetchCollections(selectedProject.id);
                                                  
                                                  toast.success('Collection saved as Paid!');
                                                  setIsCollectionModalOpen(false);
                                                  setSelectedCollectionMachine(null);
                                                } catch (error) {
                                                  console.error('Error saving collection:', error);
                                                  toast.error('Failed to save collection');
                                                }
                                              }}
                                              className="bg-green-600 hover:bg-green-700"
                                            >
                                              Mark as Paid
                                            </Button>
                                          </div>
                                        </div>
                                      )}
                                    </DialogContent>
                                  </Dialog>

                                  {/* Consolidated Sales Invoice Modal - List of Pending Machines */}
                                  <Dialog open={isConsolidatedSIModalOpen} onOpenChange={setIsConsolidatedSIModalOpen}>
                                    <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
                                      <DialogHeader>
                                        <DialogTitle>Recent Billing</DialogTitle>
                                        <DialogDescription>
                                          Latest billing statements from all machines
                                        </DialogDescription>
                                      </DialogHeader>

                                      <div className="space-y-4">
                                        {/* List of recent billing */}
                                        <div className="max-h-[400px] overflow-y-auto border border-gray-200 rounded-lg">
                                          <table className="min-w-full divide-y divide-gray-200">
                                            <thead className="bg-gray-50 sticky top-0">
                                              <tr>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">BS Number</th>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Date Exported</th>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Machine</th>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Department</th>
                                              </tr>
                                            </thead>
                                            <tbody className="bg-white divide-y divide-gray-200">
                                              {pendingSIMachines.map((item, index) => (
                                                <tr key={index} className="hover:bg-gray-50 dark:hover:bg-black">
                                                  <td className="px-4 py-3 text-sm font-semibold text-indigo-600">{item.export.bsNumber}</td>
                                                  <td className="px-4 py-3 text-sm text-gray-900 dark:text-white">
                                                    {item.export.exportDate ? new Date(item.export.exportDate).toLocaleDateString() : 'N/A'}
                                                  </td>
                                                  <td className="px-4 py-3 text-sm text-gray-900 dark:text-white">
                                                    {item.machine.model} ({item.machine.serialNumber})
                                                  </td>
                                                  <td className="px-4 py-3 text-sm text-gray-900 dark:text-white">{item.department.name}</td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>
                                        </div>

                                        {/* Export Button */}
                                        <div className="flex justify-end gap-3">
                                          <Button
                                            variant="outline"
                                            onClick={() => setIsConsolidatedSIModalOpen(false)}
                                          >
                                            Close
                                          </Button>
                                          <Button
                                            onClick={async () => {
                                              try {
                                                toast.info('Generating consolidated PDF...');
                                                
                                                const html2pdf = (await import('html2pdf.js')).default;
                                                
                                                // Build consolidated HTML content with all machines
                                                let consolidatedHTML = `
                                                  <div style="padding: 30px; font-family: Tahoma, sans-serif; font-size: 10px; text-align: center;">
                                                    <!-- Header (Same as Sales Invoice) -->
                                                    <div style="display: flex; align-items: start; margin-bottom: 20px;">
                                                      <div style="width: 80px; height: 80px; margin-right: 12px;">
                                                        <img 
                                                          src="https://customer-assets.emergentagent.com/job_hr-system-repair-1/artifacts/au3caisj_iSource%20LOGO.png"
                                                          alt="iSource Logo"
                                                          style="width: 100%; height: 100%; object-fit: contain;"
                                                        />
                                                      </div>
                                                      <div style="flex: 1;">
                                                        <div style="font-weight: bold; font-size: 12px; line-height: 1.3;">ISOURCE ASIA BUSINESS SOLUTIONS CORPORATION</div>
                                                        <div style="font-size: 9px; line-height: 1.4; margin-top: 2px;">
                                                          Imelda Bldg, 497-B Calbayog Street,<br />
                                                          Brgy. Highway Hills, Mandaluyong City<br />
                                                          VAT Reg. TIN: 010-611-699-000
                                                        </div>
                                                      </div>
                                                    </div>
                                                    
                                                    <div style="text-align: center; font-weight: bold; margin-bottom: 20px; font-size: 14px;">CONSOLIDATED BILLING REPORT.</div>
                                                    
                                                    <div style="margin-bottom: 15px; font-size: 9px;">
                                                      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px;">
                                                        <div>
                                                          <span style="font-weight: 600;">Bill To:</span> ${selectedProject?.accountName || ''}
                                                        </div>
                                                        <div>
                                                          <span style="font-weight: 600;">Report Date:</span> ${new Date().toLocaleDateString()}
                                                        </div>
                                                        <div>
                                                          <span style="font-weight: 600;">Address:</span> ${selectedProject?.companyAddress || ''}
                                                        </div>
                                                        <div>
                                                          <span style="font-weight: 600;">Total Machines:</span> ${pendingSIMachines.length}
                                                        </div>
                                                      </div>
                                                    </div>
                                                `;
                                                
                                                // Add each machine's data
                                                for (let i = 0; i < pendingSIMachines.length; i++) {
                                                  const item = pendingSIMachines[i];
                                                  const totalAmount = item.readings.reduce((sum, r) => sum + (r.amount || 0), 0);
                                                  
                                                  consolidatedHTML += `
                                                    <!-- Machine Section -->
                                                    <div style="margin-top: 25px; page-break-inside: avoid;">
                                                      <div style="background-color: #E7E6E6; padding: 8px; margin-bottom: 10px; font-size: 10px; font-weight: bold;">
                                                        Machine: ${item.machine.model} | S/N: ${item.machine.serialNumber} | Department: ${item.department.name}
                                                      </div>
                                                      
                                                      <div style="background-color: #D9E1F2; padding: 6px; text-align: center; font-size: 9px; font-weight: bold; margin-bottom: 5px;">
                                                        BS NUMBER: ${item.export.bsNumber} | Date Exported: ${item.export.exportDate ? new Date(item.export.exportDate).toLocaleDateString() : 'N/A'}
                                                      </div>
                                                      
                                                      <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px; font-size: 8px;">
                                                        <thead>
                                                          <tr style="background-color: #F2F2F2;">
                                                            <th style="border: 1px solid #000; padding: 6px; text-align: left; vertical-align: middle;">Particulars</th>
                                                            <th style="border: 1px solid #000; padding: 6px; text-align: center; vertical-align: middle;">Present<br/>Reading</th>
                                                            <th style="border: 1px solid #000; padding: 6px; text-align: center; vertical-align: middle;">Previous<br/>Reading</th>
                                                            <th style="border: 1px solid #000; padding: 6px; text-align: center; vertical-align: middle;">Total<br/>Consumption</th>
                                                            <th style="border: 1px solid #000; padding: 6px; text-align: center; vertical-align: middle;">% Spoilage</th>
                                                            <th style="border: 1px solid #000; padding: 6px; text-align: right; vertical-align: middle;">Rate</th>
                                                            <th style="border: 1px solid #000; padding: 6px; text-align: right; vertical-align: middle;">Amount</th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          ${item.readings.map(reading => `
                                                            <tr>
                                                              <td style="border: 1px solid #000; padding: 4px;">${reading.type}</td>
                                                              <td style="border: 1px solid #000; padding: 4px; text-align: center;">${reading.presentReading?.toLocaleString() || 0}</td>
                                                              <td style="border: 1px solid #000; padding: 4px; text-align: center;">${reading.previousReading?.toLocaleString() || 0}</td>
                                                              <td style="border: 1px solid #000; padding: 4px; text-align: center;">${reading.totalConsumption?.toFixed(2) || 0}</td>
                                                              <td style="border: 1px solid #000; padding: 4px; text-align: center;">${reading.spoilageTolerance?.toFixed(2) || 0}%</td>
                                                              <td style="border: 1px solid #000; padding: 4px; text-align: center;">&#8369;${(reading.rate || 0).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</td>
                                                              <td style="border: 1px solid #000; padding: 4px; text-align: center; font-weight: bold;">&#8369;${(reading.amount || 0).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</td>
                                                            </tr>
                                                          `).join('')}
                                                        </tbody>
                                                        <tfoot>
                                                          <tr style="background-color: #F2F2F2; font-weight: bold;">
                                                            <td colspan="6" style="border: 1px solid #000; padding: 6px; text-align: right; vertical-align: middle;">Machine Total:</td>
                                                            <td style="border: 1px solid #000; padding: 6px; text-align: right; vertical-align: middle;">&#8369;${totalAmount.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</td>
                                                          </tr>
                                                        </tfoot>
                                                      </table>
                                                    </div>
                                                  `;
                                                }
                                                
                                                // Add grand total
                                                const grandTotal = pendingSIMachines.reduce((sum, item) => 
                                                  sum + item.readings.reduce((s, r) => s + (r.amount || 0), 0), 0
                                                );
                                                
                                                consolidatedHTML += `
                                                    <!-- Grand Total -->
                                                    <div style="margin-top: 30px; background-color: #4472C4; color: white; padding: 10px; text-align: center; font-size: 12px; font-weight: bold;">
                                                      GRAND TOTAL: &#8369;${grandTotal.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                    </div>
                                                    
                                                    <!-- Footer -->
                                                    <div style="display: flex; justify-content: space-between; margin-top: 40px; font-size: 9px;">
                                                      <div style="text-align: center; flex: 1;">
                                                        <div style="border-top: 1px solid #000; margin: 0 10px; padding-top: 5px;">
                                                          <p style="margin: 0; font-weight: bold;">PREPARED BY:</p>
                                                          <p style="margin: 0;">ELLA MAE LAXAMANA</p>
                                                        </div>
                                                      </div>
                                                      <div style="text-align: center; flex: 1;">
                                                        <div style="border-top: 1px solid #000; margin: 0 10px; padding-top: 5px;">
                                                          <p style="margin: 0; font-weight: bold;">REVIEWED BY:</p>
                                                          <p style="margin: 0;">LOIDA MACEDA</p>
                                                        </div>
                                                      </div>
                                                      <div style="text-align: center; flex: 1;">
                                                        <div style="border-top: 1px solid #000; margin: 0 10px; padding-top: 5px;">
                                                          <p style="margin: 0; font-weight: bold;">ACCOUNT IN CHARGE:</p>
                                                          <p style="margin: 0;">PAUL RYAN CARINGAL</p>
                                                        </div>
                                                      </div>
                                                      <div style="text-align: center; flex: 1;">
                                                        <div style="border-top: 1px solid #000; margin: 0 10px; padding-top: 5px;">
                                                          <p style="margin: 0; font-weight: bold;">APPROVED BY:</p>
                                                          <p style="margin: 0;">${(selectedProject?.contactPersons && selectedProject.contactPersons.filter(p => p).length > 0) ? selectedProject.contactPersons.filter(p => p)[0] : ''}</p>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                `;
                                                
                                                // Create temporary element
                                                const tempDiv = document.createElement('div');
                                                tempDiv.innerHTML = consolidatedHTML;
                                                tempDiv.style.position = 'absolute';
                                                tempDiv.style.left = '-9999px';
                                                tempDiv.style.top = '0';
                                                document.body.appendChild(tempDiv);
                                                
                                                // Wait for DOM to render
                                                await new Promise(resolve => setTimeout(resolve, 200));
                                                
                                                // Get the first child element
                                                const element = tempDiv.querySelector('div');
                                                
                                                if (!element) {
                                                  document.body.removeChild(tempDiv);
                                                  throw new Error('Failed to create PDF content element');
                                                }
                                                
                                                const opt = {
                                                  margin: [10, 10, 10, 10],
                                                  filename: `Consolidated_Billing_Report_${new Date().toISOString().split('T')[0]}.pdf`,
                                                  image: { type: 'jpeg', quality: 0.95 },
                                                  html2canvas: { 
                                                    scale: 2, 
                                                    useCORS: true, 
                                                    logging: false,
                                                    letterRendering: true,
                                                    allowTaint: false
                                                  },
                                                  jsPDF: { 
                                                    unit: 'mm', 
                                                    format: 'a4', 
                                                    orientation: 'portrait',
                                                    compress: true
                                                  },
                                                  pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
                                                };
                                                
                                                // Generate PDF as blob instead of downloading
                                                const pdfBlob = await html2pdf().set(opt).from(element).output('blob');
                                                
                                                // Cleanup
                                                document.body.removeChild(tempDiv);
                                                
                                                // Create filename
                                                const filename = `Consolidated_Billing_Report_${new Date().toISOString().split('T')[0]}.pdf`;
                                                
                                                // Create FormData for upload
                                                const formData = new FormData();
                                                formData.append('file', pdfBlob, filename);
                                                formData.append('project_id', selectedProject.id);
                                                formData.append('total_amount', grandTotal);
                                                formData.append('machine_count', pendingSIMachines.length);
                                                
                                                // Upload to backend (which uploads to Google Drive and creates collection record)
                                                toast.info('Uploading to Google Drive...');
                                                const uploadResponse = await axiosInstance.post('/consolidated-billing-reports/upload', formData, {
                                                  headers: {
                                                    'Content-Type': 'multipart/form-data'
                                                  }
                                                });
                                                
                                                // Also download the PDF for user
                                                const link = document.createElement('a');
                                                link.href = URL.createObjectURL(pdfBlob);
                                                link.download = filename;
                                                link.click();
                                                URL.revokeObjectURL(link.href);
                                                
                                                toast.success(`Consolidated Billing Report ${uploadResponse.data.cbrNumber} generated and uploaded successfully!`);
                                                setIsConsolidatedSIModalOpen(false);
                                                
                                                // Refresh data if needed
                                                if (fetchCollections) {
                                                  await fetchCollections();
                                                }
                                                
                                              } catch (error) {
                                                console.error('Error generating consolidated PDF:', error);
                                                toast.error('Failed to generate PDF: ' + (error?.message || 'Unknown error'));
                                              }
                                            }}
                                            className="bg-indigo-600 hover:bg-indigo-700"
                                          >
                                            <FileText className="h-4 w-4 mr-2" />
                                            Export PDF
                                          </Button>
                                        </div>
                                      </div>
                                    </DialogContent>
                                  </Dialog>

                                  {/* Filter Export Modal */}
                                  <Dialog open={isFilterExportModalOpen} onOpenChange={setIsFilterExportModalOpen}>
                                    <DialogContent className="max-w-3xl">
                                      <DialogHeader>
                                        <DialogTitle>Filter & Export Meter Readings</DialogTitle>
                                        <DialogDescription>
                                          Apply filters to search for specific meter readings, repair records, or machines
                                        </DialogDescription>
                                      </DialogHeader>

                                      <div className="space-y-4">
                                        {/* Filter Fields */}
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                          {/* Department Filter */}
                                          <div>
                                            <Label htmlFor="filter-department">Department</Label>
                                            <select
                                              id="filter-department"
                                              className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                              value={filterParams.department}
                                              onChange={(e) => setFilterParams({...filterParams, department: e.target.value})}
                                            >
                                              <option value="">All Departments</option>
                                              {departments.map(dept => (
                                                <option key={dept.id} value={dept.name}>{dept.name}</option>
                                              ))}
                                            </select>
                                          </div>

                                          {/* Machine Filter */}
                                          <div>
                                            <Label htmlFor="filter-machine">Machine Model</Label>
                                            <select
                                              id="filter-machine"
                                              className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                              value={filterParams.machine}
                                              onChange={(e) => setFilterParams({...filterParams, machine: e.target.value})}
                                            >
                                              <option value="">All Machines</option>
                                              {/* Only show machines from selected department if department is selected */}
                                              {(filterParams.department 
                                                ? departments.filter(dept => dept.name === filterParams.department).flatMap(dept => dept.machines || [])
                                                : departments.flatMap(dept => dept.machines || [])
                                              ).map(machine => (
                                                <option key={machine.id} value={machine.model}>{machine.model}</option>
                                              ))}
                                            </select>
                                          </div>

                                          {/* Serial Number Filter */}
                                          <div>
                                            <Label htmlFor="filter-serial">Serial Number</Label>
                                            <Input
                                              id="filter-serial"
                                              type="text"
                                              placeholder="Enter serial number"
                                              value={filterParams.serial}
                                              onChange={(e) => setFilterParams({...filterParams, serial: e.target.value})}
                                            />
                                          </div>

                                          {/* Date Filter */}
                                          <div>
                                            <Label htmlFor="filter-date">Date</Label>
                                            <Input
                                              id="filter-date"
                                              type="date"
                                              value={filterParams.date}
                                              onChange={(e) => setFilterParams({...filterParams, date: e.target.value})}
                                            />
                                          </div>

                                          {/* Ticket Number Filter */}
                                          <div>
                                            <Label htmlFor="filter-ticket">Ticket Number</Label>
                                            <Input
                                              id="filter-ticket"
                                              type="text"
                                              placeholder="e.g., TKT-0001"
                                              value={filterParams.ticketNumber}
                                              onChange={(e) => setFilterParams({...filterParams, ticketNumber: e.target.value})}
                                            />
                                          </div>
                                        </div>

                                        {/* Apply Filter Button */}
                                        <div className="flex justify-center">
                                          <Button
                                            onClick={async () => {
                                              try {
                                                toast.info('Applying filters...');
                                                
                                                let filtered = [];
                                                
                                                // RULE 1: Ticket number search - ignore all other filters
                                                if (filterParams.ticketNumber) {
                                                  for (const dept of departments) {
                                                    if (dept.machines) {
                                                      for (const machine of dept.machines) {
                                                        const repairsResponse = await axiosInstance.get(`/machines/${machine.id}/repairs`);
                                                        let repairs = repairsResponse?.data || [];
                                                        repairs = repairs.filter(r => r.ticketNumber && r.ticketNumber.toLowerCase().includes(filterParams.ticketNumber.toLowerCase()));
                                                        
                                                        if (repairs.length > 0) {
                                                          filtered.push({
                                                            department: dept.name,
                                                            machine: machine,
                                                            readings: [],
                                                            repairs: repairs
                                                          });
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                                // RULE 2: Serial number search - ignore department and machine filters
                                                else if (filterParams.serial) {
                                                  for (const dept of departments) {
                                                    if (dept.machines) {
                                                      for (const machine of dept.machines) {
                                                        if (machine.serialNumber && machine.serialNumber.toLowerCase().includes(filterParams.serial.toLowerCase())) {
                                                          const readingsResponse = await axiosInstance.get(`/machines/${machine.id}/meter-readings`);
                                                          let readings = readingsResponse?.data || [];
                                                          
                                                          // Apply date filter if specified
                                                          if (filterParams.date) {
                                                            readings = readings.filter(r => r.presentDate === filterParams.date);
                                                          }
                                                          
                                                          const repairsResponse = await axiosInstance.get(`/machines/${machine.id}/repairs`);
                                                          const repairs = repairsResponse?.data || [];
                                                          
                                                          if (readings.length > 0 || repairs.length > 0) {
                                                            filtered.push({
                                                              department: dept.name,
                                                              machine: machine,
                                                              readings: readings,
                                                              repairs: repairs
                                                            });
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                                // RULE 3: Date search with hierarchical department/machine logic
                                                else if (filterParams.date) {
                                                  for (const dept of departments) {
                                                    // Skip if department filter is set and doesn't match
                                                    if (filterParams.department && dept.name !== filterParams.department) continue;
                                                    
                                                    if (dept.machines) {
                                                      for (const machine of dept.machines) {
                                                        // Skip if machine filter is set and doesn't match
                                                        if (filterParams.machine && machine.model !== filterParams.machine) continue;
                                                        
                                                        const readingsResponse = await axiosInstance.get(`/machines/${machine.id}/meter-readings`);
                                                        let readings = readingsResponse?.data || [];
                                                        readings = readings.filter(r => r.presentDate === filterParams.date);
                                                        
                                                        if (readings.length > 0) {
                                                          filtered.push({
                                                            department: dept.name,
                                                            machine: machine,
                                                            readings: readings,
                                                            repairs: []
                                                          });
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                                // RULE 4: Department and/or Machine filter only (no date)
                                                else {
                                                  for (const dept of departments) {
                                                    if (filterParams.department && dept.name !== filterParams.department) continue;
                                                    
                                                    if (dept.machines) {
                                                      for (const machine of dept.machines) {
                                                        if (filterParams.machine && machine.model !== filterParams.machine) continue;
                                                        
                                                        const readingsResponse = await axiosInstance.get(`/machines/${machine.id}/meter-readings`);
                                                        const readings = readingsResponse?.data || [];
                                                        
                                                        const repairsResponse = await axiosInstance.get(`/machines/${machine.id}/repairs`);
                                                        const repairs = repairsResponse?.data || [];
                                                        
                                                        if (readings.length > 0 || repairs.length > 0) {
                                                          filtered.push({
                                                            department: dept.name,
                                                            machine: machine,
                                                            readings: readings,
                                                            repairs: repairs
                                                          });
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                                
                                                setFilteredData(filtered);
                                                toast.success(`Found ${filtered.length} result(s)`);
                                                
                                              } catch (error) {
                                                console.error('Error applying filters:', error);
                                                toast.error('Failed to apply filters');
                                              }
                                            }}
                                            className="bg-indigo-600 hover:bg-indigo-700"
                                          >
                                            <Filter className="h-4 w-4 mr-2" />
                                            Apply Filters
                                          </Button>
                                        </div>

                                        {/* Results Display */}
                                        {filteredData.length > 0 && (
                                          <div className="border border-gray-200 rounded-lg p-4 bg-gray-50">
                                            <h3 className="font-semibold text-gray-900 dark:text-white mb-2">Filtered Results: {filteredData.length} item(s)</h3>
                                            <div className="max-h-60 overflow-y-auto space-y-2">
                                              {filteredData.map((item, idx) => (
                                                <div key={idx} className="bg-white p-3 rounded border border-gray-200">
                                                  <p className="text-sm"><strong>Department:</strong> {item.department}</p>
                                                  <p className="text-sm"><strong>Machine:</strong> {item.machine.model} (S/N: {item.machine.serialNumber})</p>
                                                  <p className="text-sm"><strong>Readings:</strong> {item.readings.length}</p>
                                                  <p className="text-sm"><strong>Repairs:</strong> {item.repairs.length}</p>
                                                </div>
                                              ))}
                                            </div>
                                          </div>
                                        )}

                                        {/* Export Buttons */}
                                        <div className="flex gap-3 justify-end pt-4 border-t border-gray-200">
                                          <Button
                                            variant="outline"
                                            onClick={() => {
                                              setIsFilterExportModalOpen(false);
                                              setFilterParams({department: '', machine: '', serial: '', date: '', ticketNumber: ''});
                                              setFilteredData([]);
                                            }}
                                          >
                                            Cancel
                                          </Button>
                                          <Button
                                            onClick={() => {
                                              if (filteredData.length === 0) {
                                                toast.error('No data to export. Please apply filters first.');
                                                return;
                                              }
                                              
                                              // Export CSV
                                              let csvContent = 'Department,Machine Model,Serial Number,Date,Type,Previous Reading,Present Reading,Total Consumption,Rate,Amount,Ticket Number,Diagnosed Damage\n';
                                              
                                              filteredData.forEach(item => {
                                                item.readings.forEach(reading => {
                                                  csvContent += `"${item.department}","${item.machine.model}","${item.machine.serialNumber}","${reading.presentDate}","${reading.type}","${reading.previousReading}","${reading.presentReading}","${reading.totalConsumption}","${reading.rate}","${reading.amount}","",""\n`;
                                                });
                                                
                                                item.repairs.forEach(repair => {
                                                  csvContent += `"${item.department}","${item.machine.model}","${item.machine.serialNumber}","${repair.diagnosedDate || ''}","Repair","","","","","","${repair.ticketNumber || ''}","${repair.diagnosedDamage || ''}"\n`;
                                                });
                                              });
                                              
                                              const blob = new Blob([csvContent], { type: 'text/csv' });
                                              const url = URL.createObjectURL(blob);
                                              const link = document.createElement('a');
                                              link.href = url;
                                              link.download = `filtered-export-${new Date().toISOString().split('T')[0]}.csv`;
                                              link.click();
                                              URL.revokeObjectURL(url);
                                              
                                              toast.success('CSV exported successfully!');
                                            }}
                                            variant="outline"
                                            className="flex items-center gap-2"
                                          >
                                            <Download className="h-4 w-4" />
                                            Export CSV
                                          </Button>
                                          <Button
                                            onClick={async () => {
                                              if (filteredData.length === 0) {
                                                toast.error('No data to export. Please apply filters first.');
                                                return;
                                              }
                                              
                                              try {
                                                toast.info('Generating PDF...');
                                                const html2pdf = (await import('html2pdf.js')).default;
                                                
                                                // Create a proper billing statement for each machine with meter readings
                                                let pdfPages = [];
                                                
                                                filteredData.forEach(item => {
                                                  if (item.readings && item.readings.length > 0) {
                                                    // Calculate total amount
                                                    const totalAmount = item.readings.reduce((sum, r) => sum + (r.amount || 0), 0);
                                                    
                                                    const pageHtml = `
                                                      <div style="padding: 30px; font-family: Arial, sans-serif; page-break-after: always;">
                                                        <!-- Header -->
                                                        <div style="text-align: center; margin-bottom: 25px;">
                                                          <h1 style="margin: 0 0 5px 0; font-size: 20px; font-weight: bold; letter-spacing: 1px;">BILLING STATEMENT</h1>
                                                          <div style="margin-top: 10px; font-size: 11px; line-height: 1.5;">
                                                            <div style="font-weight: bold;">iSOURCE ASIA BUSINESS SOLUTIONS CORPORATION</div>
                                                            <div>Imelda Bldg, 497-B Calbayog Street,</div>
                                                            <div>Brgy. Highway Hills, Mandaluyong City</div>
                                                            <div style="margin-top: 5px;">VAT Reg. TIN: 010-611-699-000</div>
                                                          </div>
                                                        </div>
                                                        
                                                        <!-- Billing Information -->
                                                        <div style="margin-bottom: 20px; display: flex; justify-content: space-between;">
                                                          <div style="flex: 1; font-size: 11px; line-height: 1.8;">
                                                            <div><strong>Bill To:</strong> ___________________________________</div>
                                                            <div><strong>Address:</strong> ___________________________________</div>
                                                            <div><strong>Department:</strong> ${item.department || 'N/A'}</div>
                                                            <div><strong>Attention:</strong> ___________________________________</div>
                                                          </div>
                                                          <div style="flex: 1; font-size: 11px; line-height: 1.8; text-align: right;">
                                                            <div><strong>Billing Date:</strong> ${new Date().toLocaleDateString()}</div>
                                                            <div><strong>Billing Number:</strong> _______________</div>
                                                            <div><strong>Printer Unit:</strong> ${item.machine?.model || 'N/A'}</div>
                                                            <div><strong>Serial No.:</strong> ${item.machine?.serialNumber || 'N/A'}</div>
                                                          </div>
                                                        </div>
                                                        
                                                        <!-- Billing Charges Header -->
                                                        <div style="background-color: #E7E6E6; padding: 8px; text-align: center; font-size: 12px; font-weight: bold; margin-bottom: 10px;">
                                                          BILLING CHARGES FOR THE MONTH OF ${new Date().toLocaleString('default', { month: 'LONG' }).toUpperCase()}
                                                        </div>
                                                        
                                                        <!-- Billing Table -->
                                                        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px; font-size: 10px;">
                                                          <thead>
                                                            <tr style="background-color: #F2F2F2;">
                                                              <th style="border: 1px solid #000; padding: 8px; text-align: left; font-weight: bold;">Particulars</th>
                                                              <th style="border: 1px solid #000; padding: 8px; text-align: center; font-weight: bold;">Present Meter<br/>Reading</th>
                                                              <th style="border: 1px solid #000; padding: 8px; text-align: center; font-weight: bold;">Previous Meter<br/>Reading</th>
                                                              <th style="border: 1px solid #000; padding: 8px; text-align: center; font-weight: bold;">Total<br/>Consumption</th>
                                                              <th style="border: 1px solid #000; padding: 8px; text-align: center; font-weight: bold;">% Spoilage</th>
                                                              <th style="border: 1px solid #000; padding: 8px; text-align: center; font-weight: bold;">Price per copy/<br/>print</th>
                                                              <th style="border: 1px solid #000; padding: 8px; text-align: center; font-weight: bold;">AMOUNT</th>
                                                            </tr>
                                                          </thead>
                                                          <tbody>
                                                            ${item.readings.map(r => `
                                                              <tr>
                                                                <td style="border: 1px solid #000; padding: 8px;">${r.type || 'N/A'}</td>
                                                                <td style="border: 1px solid #000; padding: 8px; text-align: right;">${(r.presentReading || 0).toLocaleString()}</td>
                                                                <td style="border: 1px solid #000; padding: 8px; text-align: right;">${(r.previousReading || 0).toLocaleString()}</td>
                                                                <td style="border: 1px solid #000; padding: 8px; text-align: right;">${(r.totalConsumption || 0).toLocaleString()}</td>
                                                                <td style="border: 1px solid #000; padding: 8px; text-align: center;">${r.spoilageTolerance || 0}%</td>
                                                                <td style="border: 1px solid #000; padding: 8px; text-align: right;">&#8369;${(r.rate || 0).toFixed(2)}</td>
                                                                <td style="border: 1px solid #000; padding: 8px; text-align: right; font-weight: bold;">&#8369;${(r.amount || 0).toFixed(2)}</td>
                                                              </tr>
                                                            `).join('')}
                                                            ${item.readings.length < 4 ? Array(4 - item.readings.length).fill('').map(() => `
                                                              <tr>
                                                                <td style="border: 1px solid #000; padding: 8px; height: 35px;">&nbsp;</td>
                                                                <td style="border: 1px solid #000; padding: 8px;">&nbsp;</td>
                                                                <td style="border: 1px solid #000; padding: 8px;">&nbsp;</td>
                                                                <td style="border: 1px solid #000; padding: 8px;">&nbsp;</td>
                                                                <td style="border: 1px solid #000; padding: 8px;">&nbsp;</td>
                                                                <td style="border: 1px solid #000; padding: 8px;">&nbsp;</td>
                                                                <td style="border: 1px solid #000; padding: 8px;">&nbsp;</td>
                                                              </tr>
                                                            `).join('') : ''}
                                                          </tbody>
                                                          <tfoot>
                                                            <tr>
                                                              <td colspan="6" style="border: 1px solid #000; padding: 8px; text-align: right; font-weight: bold; font-size: 12px;">TOTAL</td>
                                                              <td style="border: 1px solid #000; padding: 8px; text-align: right; font-weight: bold; font-size: 12px;">&#8369;${totalAmount.toFixed(2)}</td>
                                                            </tr>
                                                          </tfoot>
                                                        </table>
                                                        
                                                        <!-- Note Section -->
                                                        <div style="margin-bottom: 25px;">
                                                          <div style="font-size: 11px; font-weight: bold; margin-bottom: 5px;">Note:</div>
                                                          <div style="border: 1px solid #000; padding: 10px; min-height: 60px; font-size: 10px;">
                                                            ${item.readings.length > 0 && item.readings[0].presentDate ? `Billing period covering readings dated ${item.readings[0].presentDate}` : ''}
                                                          </div>
                                                        </div>
                                                        
                                                        <!-- Footer Approvals -->
                                                        <div style="display: flex; justify-content: space-between; font-size: 10px; margin-top: 30px;">
                                                          <div style="flex: 1; text-align: center; margin: 0 5px;">
                                                            <div style="font-weight: bold; margin-bottom: 30px;">PREPARED BY:</div>
                                                            <div style="border-top: 1px solid #000; padding-top: 5px; margin: 0 10px;">Signature / Date</div>
                                                          </div>
                                                          <div style="flex: 1; text-align: center; margin: 0 5px;">
                                                            <div style="font-weight: bold; margin-bottom: 30px;">CHECKED BY:</div>
                                                            <div style="border-top: 1px solid #000; padding-top: 5px; margin: 0 10px;">Signature / Date</div>
                                                          </div>
                                                          <div style="flex: 1; text-align: center; margin: 0 5px;">
                                                            <div style="font-weight: bold; margin-bottom: 30px;">ACCOUNT IN CHARGE:</div>
                                                            <div style="border-top: 1px solid #000; padding-top: 5px; margin: 0 10px;">Signature / Date</div>
                                                          </div>
                                                          <div style="flex: 1; text-align: center; margin: 0 5px;">
                                                            <div style="font-weight: bold; margin-bottom: 30px;">APPROVED BY:</div>
                                                            <div style="border-top: 1px solid #000; padding-top: 5px; margin: 0 10px;">Signature / Date</div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    `;
                                                    pdfPages.push(pageHtml);
                                                  }
                                                });
                                                
                                                if (pdfPages.length === 0) {
                                                  toast.error('No meter readings found in filtered data to export.');
                                                  return;
                                                }
                                                
                                                // Combine all pages
                                                const fullHtml = `
                                                  <div id="billing-export-content">
                                                    ${pdfPages.join('')}
                                                  </div>
                                                `;
                                                
                                                // Create temporary element
                                                const tempDiv = document.createElement('div');
                                                tempDiv.innerHTML = fullHtml;
                                                tempDiv.style.position = 'absolute';
                                                tempDiv.style.left = '-9999px';
                                                tempDiv.style.top = '0';
                                                document.body.appendChild(tempDiv);
                                                
                                                // Wait for DOM to be ready
                                                await new Promise(resolve => setTimeout(resolve, 100));
                                                
                                                const element = tempDiv.querySelector('#billing-export-content');
                                                
                                                if (!element) {
                                                  document.body.removeChild(tempDiv);
                                                  toast.error('Failed to create PDF content');
                                                  return;
                                                }
                                                
                                                const opt = {
                                                  margin: [10, 10, 10, 10],
                                                  filename: `Billing_Statement_${selectedProject?.name?.replace(/[^a-zA-Z0-9]/g, '_') || 'Export'}_${new Date().toISOString().split('T')[0]}.pdf`,
                                                  image: { type: 'jpeg', quality: 0.95 },
                                                  html2canvas: { 
                                                    scale: 2, 
                                                    useCORS: true, 
                                                    logging: false,
                                                    letterRendering: true,
                                                    allowTaint: false
                                                  },
                                                  jsPDF: { 
                                                    unit: 'mm', 
                                                    format: 'a4', 
                                                    orientation: 'portrait',
                                                    compress: true
                                                  },
                                                  pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
                                                };
                                                
                                                await html2pdf().set(opt).from(element).save();
                                                
                                                // Cleanup
                                                document.body.removeChild(tempDiv);
                                                
                                                toast.success(`PDF exported successfully! (${pdfPages.length} page(s))`);
                                              } catch (error) {
                                                console.error('Error exporting PDF:', error);
                                                toast.error('Failed to export PDF: ' + error.message);
                                              }
                                            }}
                                            className="bg-indigo-600 hover:bg-indigo-700 flex items-center gap-2"
                                          >
                                            <FileText className="h-4 w-4" />
                                            Export PDF
                                          </Button>
                                        </div>
                                      </div>
                                    </DialogContent>
                                  </Dialog>

                                  {/* Billing Records Modal (without export buttons) */}
                                  <Dialog open={isBillingRecordsModalOpen} onOpenChange={setIsBillingRecordsModalOpen}>
                                    <DialogContent className="max-w-4xl max-h-[90vh]">
                                      <DialogHeader>
                                        <DialogTitle>Reading Records - {selectedMachineForBillingRecords?.model}</DialogTitle>
                                        <DialogDescription>
                                          View and edit meter reading records for machine S/N: {selectedMachineForBillingRecords?.serialNumber}
                                        </DialogDescription>
                                      </DialogHeader>

                                      <div className="overflow-y-auto max-h-[70vh]">
                                        {billingRecordsData.length === 0 ? (
                                          <div className="text-center py-8 text-gray-500 dark:text-gray-300">
                                            <FileText className="h-12 w-12 mx-auto mb-3 text-gray-400" />
                                            <p>No reading records available for this machine</p>
                                          </div>
                                        ) : (
                                          <table className="w-full">
                                            <thead className="bg-gray-50 sticky top-0">
                                              <tr>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">DATE</th>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">READINGS COUNT</th>
                                                <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">TOTAL AMOUNT</th>
                                                <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">ACTIONS</th>
                                              </tr>
                                            </thead>
                                            <tbody className="bg-white divide-y divide-gray-200">
                                              {billingRecordsData.map((record, index) => (
                                                <tr key={index} className="hover:bg-gray-50 dark:hover:bg-black">
                                                  <td className="px-4 py-4 text-sm text-gray-900 dark:text-white">
                                                    {new Date(record.date).toLocaleDateString()}
                                                  </td>
                                                  <td className="px-4 py-4 text-sm text-gray-600 dark:text-gray-200">
                                                    {record.readingsCount} readings ({record.readingTypes.join(', ')})
                                                  </td>
                                                  <td className="px-4 py-4 text-sm text-right font-semibold text-green-600">
                                                    &#8369;{record.totalAmount.toFixed(2)}
                                                  </td>
                                                  <td className="px-4 py-4 text-sm text-center">
                                                    <Button
                                                      onClick={async () => {
                                                        // Open the "Latest Meter Reading" modal with this batch
                                                        setSelectedMachineForBilling({ 
                                                          ...selectedMachineForBillingRecords, 
                                                          latestReading: record.readings[0]
                                                        });
                                                        setAllReadingsForBilling(record.readings);
                                                        setIsBillingModalOpen(true);
                                                        setIsBillingRecordsModalOpen(false);
                                                      }}
                                                      variant="outline"
                                                      size="sm"
                                                      className="flex items-center gap-2"
                                                    >
                                                      <FileText className="h-4 w-4" />
                                                      View
                                                    </Button>
                                                  </td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>
                                        )}
                                      </div>

                                      <div className="flex justify-end pt-4 border-t border-gray-200">
                                        <Button
                                          variant="outline"
                                          onClick={() => {
                                            setIsBillingRecordsModalOpen(false);
                                            setBillingRecordsData([]);
                                            setSelectedMachineForBillingRecords(null);
                                          }}
                                        >
                                          Close
                                        </Button>
                                      </div>
                                    </DialogContent>
                                  </Dialog>

                                  {/* Billing History Modal (for SI tab) */}
                                  <Dialog open={isBillingHistoryModalOpen} onOpenChange={setIsBillingHistoryModalOpen}>
                                    <DialogContent className="max-w-4xl max-h-[90vh]">
                                      <DialogHeader>
                                        <DialogTitle>Billing History - {selectedMachineForBillingHistory?.model}</DialogTitle>
                                        <DialogDescription>
                                          View billing statements for machine S/N: {selectedMachineForBillingHistory?.serialNumber}
                                        </DialogDescription>
                                      </DialogHeader>

                                      <div className="overflow-y-auto max-h-[70vh]">
                                        {billingHistoryData.length === 0 ? (
                                          <div className="text-center py-8 text-gray-500 dark:text-gray-300">
                                            <FileText className="h-12 w-12 mx-auto mb-3 text-gray-400" />
                                            <p>No billing history available for this machine</p>
                                          </div>
                                        ) : (
                                          <table className="w-full">
                                            <thead className="bg-gray-50 sticky top-0">
                                              <tr>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">BS NUMBER</th>
                                                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">DATE EXPORTED</th>
                                                <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">ACTIONS</th>
                                              </tr>
                                            </thead>
                                            <tbody className="bg-white divide-y divide-gray-200">
                                              {billingHistoryData.map((record, index) => (
                                                <tr key={index} className="hover:bg-gray-50 dark:hover:bg-black">
                                                  <td className="px-4 py-4 text-sm font-semibold text-gray-900 dark:text-white">
                                                    {record.bsNumber}
                                                  </td>
                                                  <td className="px-4 py-4 text-sm text-gray-600 dark:text-gray-200">
                                                    {record.exportDate ? new Date(record.exportDate).toLocaleDateString() : 'N/A'}
                                                  </td>
                                                  <td className="px-4 py-4 text-sm text-center">
                                                    <Button
                                                      onClick={async () => {
                                                        try {
                                                          // Fetch meter readings for this BS Number
                                                          const response = await axiosInstance.get(`/billing-exports/${record.bsNumber}/meter-readings`, {
                                                            params: { machine_id: selectedMachineForBillingHistory.id }
                                                          });
                                                          
                                                          // Find the department from the departments list
                                                          const dept = departments.find(d => 
                                                            d.machines?.some(m => m.id === selectedMachineForBillingHistory.id)
                                                          );
                                                          
                                                          const siData = {
                                                            exportRecord: record,
                                                            readings: response?.data || [],
                                                            machine: selectedMachineForBillingHistory,
                                                            department: dept || { 
                                                              id: '', 
                                                              name: selectedMachineForBillingHistory.departmentName || 'Unknown' 
                                                            }
                                                          };
                                                          
                                                          setSelectedSIData(siData);
                                                          setIsSIPreviewOpen(true);
                                                          setIsBillingHistoryModalOpen(false);
                                                        } catch (error) {
                                                          console.error('Error fetching meter readings:', error);
                                                          toast.error('Failed to load meter readings: ' + (error?.message || 'Unknown error'));
                                                        }
                                                      }}
                                                      variant="outline"
                                                      size="sm"
                                                      className="flex items-center gap-2"
                                                    >
                                                      <FileText className="h-4 w-4" />
                                                      View
                                                    </Button>
                                                  </td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>
                                        )}
                                      </div>

                                      <div className="flex justify-end pt-4 border-t border-gray-200">
                                        <Button
                                          variant="outline"
                                          onClick={() => {
                                            setIsBillingHistoryModalOpen(false);
                                            setBillingHistoryData([]);
                                            setSelectedMachineForBillingHistory(null);
                                          }}
                                        >
                                          Close
                                        </Button>
                                      </div>
                                    </DialogContent>
                                  </Dialog>

                                  {/* Collection History Preview Modal - With Watermark */}
                                  <Dialog open={isCollectionHistoryPreviewOpen} onOpenChange={setIsCollectionHistoryPreviewOpen}>
                                    <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
                                      <DialogHeader>
                                        <DialogTitle>Collection Record - {selectedCollectionRecord?.siNumber}</DialogTitle>
                                      </DialogHeader>

                                      {selectedCollectionRecord && (
                                        <div className="space-y-4">
                                          {/* Collection Record Details */}
                                          <div className="bg-gray-50 p-4 rounded-lg">
                                            <div className="grid grid-cols-2 gap-4 text-sm">
                                              <div><span className="font-semibold">SI Number:</span> {selectedCollectionRecord.siNumber}</div>
                                              <div><span className="font-semibold">BS Number:</span> {selectedCollectionRecord.bsNumber}</div>
                                              <div><span className="font-semibold">Department:</span> {selectedCollectionRecord.departmentName}</div>
                                              <div><span className="font-semibold">Machine:</span> {selectedCollectionRecord.machineModel}</div>
                                              <div><span className="font-semibold">Serial Number:</span> {selectedCollectionRecord.machineSerial}</div>
                                              <div><span className="font-semibold">Collection Date:</span> {selectedCollectionRecord.collectionDate ? new Date(selectedCollectionRecord.collectionDate).toLocaleDateString() : 'N/A'}</div>
                                              <div className="col-span-2"><span className="font-semibold">Total Amount:</span> <span className="text-green-600 font-bold">&#8369;{(selectedCollectionRecord.totalAmount || 0).toFixed(2)}</span></div>
                                              <div className="col-span-2">
                                                <span className="font-semibold">Status:</span> 
                                                <span className={`ml-2 px-3 py-1 rounded-full text-xs font-bold ${
                                                  selectedCollectionRecord.status === 'paid' 
                                                    ? 'bg-green-100 text-green-800' 
                                                    : 'bg-yellow-100 text-yellow-800'
                                                }`}>
                                                  {selectedCollectionRecord.status.toUpperCase()}
                                                </span>
                                              </div>
                                            </div>
                                          </div>

                                          {/* PDF Preview with Watermark */}
                                          {selectedCollectionRecord.pdfUrl && (
                                            <div className="border rounded-lg overflow-hidden relative">
                                              <div className="bg-gray-100 p-2 text-sm font-semibold">Sales Invoice PDF</div>
                                              <div className="h-[400px] relative">
                                                <iframe
                                                  src={selectedCollectionRecord.pdfUrl.replace('/view', '/preview')}
                                                  className="w-full h-full"
                                                  title="Sales Invoice PDF"
                                                />
                                                {/* Watermark Overlay */}
                                                <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                                                  <div 
                                                    className={`text-9xl font-bold opacity-20 transform rotate-[-45deg] ${
                                                      selectedCollectionRecord.status === 'paid' 
                                                        ? 'text-green-600' 
                                                        : 'text-yellow-600'
                                                    }`}
                                                    style={{
                                                      textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                                                      letterSpacing: '0.1em'
                                                    }}
                                                  >
                                                    {selectedCollectionRecord.status.toUpperCase()}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )}

                                          {/* Action Buttons */}
                                          <div className="flex justify-end gap-2">
                                            {!isEditingCollectionStatus ? (
                                              <>
                                                <Button
                                                  variant="outline"
                                                  onClick={() => {
                                                    setIsCollectionHistoryPreviewOpen(false);
                                                    setSelectedCollectionRecord(null);
                                                    setIsEditingCollectionStatus(false);
                                                  }}
                                                >
                                                  Close
                                                </Button>
                                                <Button
                                                  onClick={() => {
                                                    setIsEditingCollectionStatus(true);
                                                    setEditedCollectionStatus(selectedCollectionRecord.status);
                                                  }}
                                                  className="bg-blue-600 hover:bg-blue-700"
                                                >
                                                  Update Status
                                                </Button>
                                              </>
                                            ) : (
                                              <>
                                                <Button
                                                  variant="outline"
                                                  onClick={() => {
                                                    setIsEditingCollectionStatus(false);
                                                    setEditedCollectionStatus('');
                                                  }}
                                                >
                                                  Cancel
                                                </Button>
                                                <div className="flex items-center gap-2">
                                                  <select
                                                    value={editedCollectionStatus}
                                                    onChange={(e) => setEditedCollectionStatus(e.target.value)}
                                                    className="px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                  >
                                                    <option value="pending">Pending</option>
                                                    <option value="paid">Paid</option>
                                                  </select>
                                                  <Button
                                                    onClick={async () => {
                                                      try {
                                                        toast.info('Updating status...');
                                                        await axiosInstance.put(
                                                          `/collections/${selectedCollectionRecord.id}/status?status=${editedCollectionStatus}`
                                                        );
                                                        
                                                        // Update local state
                                                        setSelectedCollectionRecord({
                                                          ...selectedCollectionRecord,
                                                          status: editedCollectionStatus
                                                        });
                                                        
                                                        // Refresh collections list
                                                        await fetchCollections(selectedProject.id);
                                                        
                                                        toast.success('Status updated successfully!');
                                                        setIsEditingCollectionStatus(false);
                                                        setEditedCollectionStatus('');
                                                      } catch (error) {
                                                        console.error('Error updating status:', error);
                                                        toast.error('Failed to update status');
                                                      }
                                                    }}
                                                    className="bg-green-600 hover:bg-green-700"
                                                  >
                                                    Save
                                                  </Button>
                                                </div>
                                              </>
                                            )}
                                          </div>
                                        </div>
                                      )}
                                    </DialogContent>
                                  </Dialog>

                                  {/* Departments List Modal */}
                                  <Dialog open={isDepartmentsModalOpen} onOpenChange={setIsDepartmentsModalOpen}>
                                    <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
                                      <DialogHeader>
                                        <DialogTitle>Departments in {selectedProject?.title || 'Project'}</DialogTitle>
                                      </DialogHeader>
                                      <div className="space-y-2">
                                        {departments && departments.length > 0 ? (
                                          departments.map((dept) => (
                                            <div key={dept.id} className="p-4 bg-blue-50 border border-blue-200 rounded-lg hover:bg-blue-100 transition-colors">
                                              <div className="flex items-center justify-between">
                                                <div className="flex items-center gap-3">
                                                  <Building2 className="h-5 w-5 text-blue-600" />
                                                  <div>
                                                    <h3 className="font-semibold text-gray-900 dark:text-white">{dept.name}</h3>
                                                    <p className="text-sm text-gray-600 dark:text-gray-200">{dept.machines?.length || 0} machine(s)</p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ))
                                        ) : (
                                          <p className="text-center text-gray-500 dark:text-gray-300 py-8">No departments found</p>
                                        )}
                                      </div>
                                    </DialogContent>
                                  </Dialog>

                                  {/* Machines List Modal */}
                                  <Dialog open={isMachinesModalOpen} onOpenChange={setIsMachinesModalOpen}>
                                    <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto">
                                      <DialogHeader>
                                        <DialogTitle>Machines in {selectedProject?.title || 'Project'}</DialogTitle>
                                      </DialogHeader>
                                      <div className="space-y-4">
                                        {departments && departments.length > 0 ? (
                                          departments.map((dept) => (
                                            <div key={dept.id} className="border rounded-lg p-4">
                                              <h3 className="font-semibold text-gray-900 dark:text-white mb-3 flex items-center gap-2">
                                                <Building2 className="h-4 w-4 text-purple-600" />
                                                {dept.name}
                                              </h3>
                                              {dept.machines && dept.machines.length > 0 ? (
                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                                                  {dept.machines.map((machine) => (
                                                    <div key={machine.id} className="p-3 bg-purple-50 border border-purple-200 rounded hover:bg-purple-100 transition-colors">
                                                      <div className="flex items-center gap-2">
                                                        <Printer className="h-4 w-4 text-purple-600" />
                                                        <div>
                                                          <p className="font-medium text-gray-900 dark:text-white text-sm">{machine.model}</p>
                                                          <p className="text-xs text-gray-600 dark:text-gray-200">S/N: {machine.serialNumber}</p>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  ))}
                                                </div>
                                              ) : (
                                                <p className="text-sm text-gray-500 dark:text-gray-300">No machines in this department</p>
                                              )}
                                            </div>
                                          ))
                                        ) : (
                                          <p className="text-center text-gray-500 dark:text-gray-300 py-8">No machines found</p>
                                        )}
                                      </div>
                                    </DialogContent>
                                  </Dialog>

                                  {/* Earnings Breakdown Modal */}
                                  <Dialog open={isEarningsModalOpen} onOpenChange={setIsEarningsModalOpen}>
                                    <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto">
                                      <DialogHeader>
                                        <DialogTitle>Earnings Breakdown - {selectedProject?.title || 'Project'}</DialogTitle>
                                      </DialogHeader>
                                      <div className="space-y-6">
                                        {/* Summary Cards */}
                                        <div className="grid grid-cols-2 gap-4">
                                          <div className="bg-green-50 border-2 border-green-200 rounded-lg p-4">
                                            <div className="flex items-center gap-2 mb-2">
                                              <CheckCircle className="h-5 w-5 text-green-600" />
                                              <h3 className="font-semibold text-green-900">Paid</h3>
                                            </div>
                                            <p className="text-2xl font-bold text-green-900">
                                              &#8369;{collections?.filter(c => c.status === 'paid').reduce((sum, c) => sum + (c.totalAmount || 0), 0).toFixed(2) || '0.00'}
                                            </p>
                                            <p className="text-sm text-green-700 mt-1">
                                              {collections?.filter(c => c.status === 'paid').length || 0} collection(s)
                                            </p>
                                          </div>

                                          <div className="bg-yellow-50 border-2 border-yellow-200 rounded-lg p-4">
                                            <div className="flex items-center gap-2 mb-2">
                                              <Clock className="h-5 w-5 text-yellow-600" />
                                              <h3 className="font-semibold text-yellow-900">Pending</h3>
                                            </div>
                                            <p className="text-2xl font-bold text-yellow-900">
                                              &#8369;{collections?.filter(c => c.status === 'pending').reduce((sum, c) => sum + (c.totalAmount || 0), 0).toFixed(2) || '0.00'}
                                            </p>
                                            <p className="text-sm text-yellow-700 mt-1">
                                              {collections?.filter(c => c.status === 'pending').length || 0} collection(s)
                                            </p>
                                          </div>
                                        </div>

                                        {/* Paid Collections */}
                                        <div>
                                          <h3 className="font-semibold text-gray-900 dark:text-white mb-3 flex items-center gap-2">
                                            <CheckCircle className="h-5 w-5 text-green-600" />
                                            Paid Collections
                                          </h3>
                                          {collections?.filter(c => c.status === 'paid').length > 0 ? (
                                            <div className="space-y-2">
                                              {collections.filter(c => c.status === 'paid').map((collection) => (
                                                <div key={collection.id} className="p-3 bg-green-50 border border-green-200 rounded-lg">
                                                  <div className="flex items-center justify-between">
                                                    <div>
                                                      <p className="font-medium text-gray-900 dark:text-white">{collection.siNumber}</p>
                                                      <p className="text-sm text-gray-600 dark:text-gray-200">{collection.departmentName} - {collection.machineModel}</p>
                                                      <p className="text-xs text-gray-500 dark:text-gray-300">{new Date(collection.collectionDate).toLocaleDateString()}</p>
                                                    </div>
                                                    <p className="font-bold text-green-700">&#8369;{(collection.totalAmount || 0).toFixed(2)}</p>
                                                  </div>
                                                </div>
                                              ))}
                                            </div>
                                          ) : (
                                            <p className="text-sm text-gray-500 dark:text-gray-300 text-center py-4">No paid collections</p>
                                          )}
                                        </div>

                                        {/* Pending Collections */}
                                        <div>
                                          <h3 className="font-semibold text-gray-900 dark:text-white mb-3 flex items-center gap-2">
                                            <Clock className="h-5 w-5 text-yellow-600" />
                                            Pending Collections
                                          </h3>
                                          {collections?.filter(c => c.status === 'pending').length > 0 ? (
                                            <div className="space-y-2">
                                              {collections.filter(c => c.status === 'pending').map((collection) => (
                                                <div key={collection.id} className="p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                                                  <div className="flex items-center justify-between">
                                                    <div>
                                                      <p className="font-medium text-gray-900 dark:text-white">{collection.siNumber}</p>
                                                      <p className="text-sm text-gray-600 dark:text-gray-200">{collection.departmentName} - {collection.machineModel}</p>
                                                      <p className="text-xs text-gray-500 dark:text-gray-300">{new Date(collection.collectionDate).toLocaleDateString()}</p>
                                                    </div>
                                                    <p className="font-bold text-yellow-700">&#8369;{(collection.totalAmount || 0).toFixed(2)}</p>
                                                  </div>
                                                </div>
                                              ))}
                                            </div>
                                          ) : (
                                            <p className="text-sm text-gray-500 dark:text-gray-300 text-center py-4">No pending collections</p>
                                          )}
                                        </div>
                                      </div>
                                    </DialogContent>
                                  </Dialog>

                                  {/* Product Selection Modal */}
                                  <Dialog open={isProductSelectionModalOpen} onOpenChange={setIsProductSelectionModalOpen}>
                                    <DialogContent className="sm:max-w-[600px]">
                                      <DialogHeader>
                                        <DialogTitle>Select Focus Product</DialogTitle>
                                        <div className="pt-4">
                                          <Input
                                            placeholder="Filter by brand, model, or category..."
                                            value={focusProductSelectionFilter}
                                            onChange={(e) => setFocusProductSelectionFilter(e.target.value)}
                                            className="w-full"
                                          />
                                        </div>
                                      </DialogHeader>
                                      <div className="max-h-[60vh] overflow-y-auto">
                                        <div className="grid gap-2">
                                            <Button
                                                variant="outline"
                                                className="justify-start text-left h-auto py-3 font-medium text-blue-600 border-blue-200 hover:bg-blue-50 dark:hover:bg-black"
                                                onClick={() => {
                                                    if (editingTransactionIndex !== null) {
                                                        setManualInputIndices(prev => {
                                                            const next = new Set(prev);
                                                            next.add(editingTransactionIndex);
                                                            return next;
                                                        });
                                                        handleTransactionChange(editingTransactionIndex, 'item_description', '');
                                                        setIsProductSelectionModalOpen(false);
                                                    }
                                                }}
                                            >
                                                Others (Manual Input)
                                            </Button>
                                            {focusProducts
                                                .filter(p => {
                                                    if (!focusProductSelectionFilter) return true;
                                                    const search = focusProductSelectionFilter.toLowerCase();
                                                    return (
                                                        (p.brand && p.brand.toLowerCase().includes(search)) ||
                                                        (p.model && p.model.toLowerCase().includes(search)) ||
                                                        (p.category && p.category.toLowerCase().includes(search))
                                                    );
                                                })
                                                .map((product, idx) => (
                                                    <Button
                                                        key={idx}
                                                        variant="ghost"
                                                        className="justify-start text-left h-auto py-3"
                                                        onClick={() => {
                                                            if (editingTransactionIndex !== null) {
                                                                setManualInputIndices(prev => {
                                                                    const next = new Set(prev);
                                                                    next.delete(editingTransactionIndex);
                                                                    return next;
                                                                });
                                                                const description = `${product.brand} ${product.model} ${product.category}`;
                                                                handleTransactionChange(editingTransactionIndex, 'item_description', description);
                                                                setIsProductSelectionModalOpen(false);
                                                            }
                                                        }}
                                                    >
                                                        <div className="flex flex-col">
                                                            <span className="font-medium">{product.brand} {product.model}</span>
                                                            <span className="text-xs text-muted-foreground">{product.category}</span>
                                                        </div>
                                                    </Button>
                                                ))
                                            }
                                        </div>
                                      </div>
                                    </DialogContent>
                                  </Dialog>

                                  {/* Save Confirmation Dialog */}
                                  <Dialog open={isSaveConfirmationOpen} onOpenChange={setIsSaveConfirmationOpen}>
                                    <DialogContent className="sm:max-w-[425px]">
                                      <DialogHeader>
                                        <DialogTitle>Success</DialogTitle>
                                        <DialogDescription>
                                          The data has been saved successfully.
                                        </DialogDescription>
                                      </DialogHeader>
                                      <DialogFooter className="sm:justify-center">
                                        <Button type="button" onClick={() => setIsSaveConfirmationOpen(false)}>
                                          OK
                                        </Button>
                                      </DialogFooter>
                                    </DialogContent>
                                  </Dialog>

                                  </>
                                );
                              };

                              export default AdminDashboard;
